'use strict';

angular.module('directives.topicSummary', []);
'use strict';

angular.lowercase = text => text ? text.toLowerCase() : text;

angular.module('attensaApp', ['ngMaterial', 'angular-locker', 'ui.bootstrap', 'mgcrea.ngStrap.popover', 'mgcrea.ngStrap.datepicker',
    'mgcrea.ngStrap.timepicker', 'angular-growl', 'angularMoment', 'textAngular', 'ngMessages', 'permission',
    'ngFileUpload', 'ngOnload', 'ngSanitize', 'infinite-scroll', 'rzModule',
    'ui.router', 'routeAuthorization', 'uuid4', 'ImgFallback', 'xeditable', 'ng-sortable',
    'ngTable', 'ui.select', 'ui.tree', 'uiSwitch', 'chart.js', 'ngAnimate', 'ui.bootstrap.pagination',
    'controllers.browse', 'controllers.sourceCreation', 'controllers.sourceFinder', 'controllers.topics',
    'controllers.topicsSearch', 'controllers.topicsOwnedStreams', 'controllers.topicBuilder', 'directives.categoryCard',
    'directives.spinner', 'directives.sourceCard', 'directives.streamCard', 'directives.topicSummary',
    'ui.bootstrap.datepicker'])
    .factory('_', ['$window',
        function($window) {
            // place underscore / lodash include before angular
            return $window._;
        }
    ])
    .factory('Papa', ['$window',
        function($window) {
            return $window.Papa;
        }
    ])
    .factory('Promise', ['$window',
        function($window) {
            return $window.Promise; // Bluebird promises for great good
        }
    ])
    .provider('x2js',
    [function () {
        this.$get = [function(){
            /* global X2JS: false */
            return new X2JS(); 
        }];
    }])
    .run(['$rootScope', 'Promise', function ($rootScope, Promise) {
        Promise.setScheduler(function (cb) {
            $rootScope.$evalAsync(cb);
        });
    }])
    .config(['growlProvider', function(growlProvider){
        growlProvider.globalPosition('top-right');
        growlProvider.globalTimeToLive({success: 5000, error: -1, warning: 6000, info: 5000 });
        growlProvider.globalReversedOrder(true);
        growlProvider.globalDisableCountDown(true);
    }])
    .config(['$locationProvider', function($locationProvider){
        $locationProvider.html5Mode(true);
    }])
    .config(['$qProvider', function($qProvider) {
        $qProvider.errorOnUnhandledRejections(false);
    }])
    .config(['ChartJsProvider', function (ChartJsProvider) {
        ChartJsProvider.setOptions({
              showTooltips: false,
              responsive: true
        });
        ChartJsProvider.setOptions('Line', {
              bezierCurve: false
        });
    }])
    .config(['$httpProvider', function($httpProvider){
        //initialize get if not there
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }
        //disable IE ajax request caching
        $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';

        $httpProvider.interceptors.push('HttpErrorsInterceptor');
        $httpProvider.interceptors.push('AttensaVersionInterceptor');
        $httpProvider.interceptors.push('UserAuthenticatedInterceptor');
    }])
    .config(['$urlRouterProvider', function($urlRouterProvider){
        $urlRouterProvider.when('/topics/:streamId/edit', '/topics/:streamId/edit/articles');
        $urlRouterProvider.when('/mytopics', '/mytopics/recent');
        $urlRouterProvider.when('/briefings', '/briefings/index');
        $urlRouterProvider.when('/briefings/:briefingId/details', '/briefings/:briefingId/details/');
        $urlRouterProvider.otherwise('/welcome');
    }])
    .config(['lockerProvider', function config(lockerProvider) {
        lockerProvider.defaults({
            driver: 'local',
            namespace: 'attensaApp'
        });
    }])
    .config(['$stateProvider', function($stateProvider) {
        var getUncachedUser = ['UserService', function(userService) {
            return userService.getCurrentUser(true);
        }];

        var getTenant = ['TenantService', function(tenantService) {
            return tenantService.getCurrentTenant();
        }];

        var getGroups = ['groupsService', function(groupsService) {
            return groupsService.fetchGroups({params: {page: 0, rows: 40}});
        }];

        var getPeople = ['UserService', function(userService) {
            return userService.getUsers();
        }];

        var getTenantCatalogMap = ['TenantService', function(tenantService){
            return tenantService.getCatalogMap();
        }];

        var getStream = ['StreamService', '$stateParams', function(streamService, $stateParams){
            return streamService.getStream($stateParams.streamId);
        }];

        var getBriefing = ['BriefingService', '$stateParams', function(briefingService, $stateParams){
            return briefingService.getBriefing($stateParams.briefingId);
        }];

        var getAllTemplates = ['TemplateService', 'UtilService', function(templateService, utilService){
            return utilService.unwrap(templateService.getAll());
        }];

        var getBriefingSchedule = ['BriefingService', '$stateParams', function(briefingService, $stateParams){
            return briefingService.getBriefingSchedule($stateParams.briefingId);
        }];

        var isTenantAdmin = ['_', 'UserService', function(_, userService){
            return userService.getCurrentUser()
            .then(function(userResponse){
                if(userResponse.data.user){
                    return _.find(userResponse.data.user.tenantRoles, { roleType: 'TENANT_ADMIN' }) ? true : false;
                }
            });
        }];

        var verifyIsNotTenancy = ['$state', 'TenantService', function($state, tenantService){
            return tenantService.getUnauthTenantInfo()
                   .then(function(){
                       $state.go('welcome');
                   })
                   .catch(function(){
                        return true;
                   });
        }];

        var verifyHasApiAccess = ['$state', 'TenantService', function($state, tenantService){
            return tenantService.getUnauthTenantInfo()
            .then(function(results) {
                if (results.data.settings.apiAccessEnabled !== 'true') {
                    $state.go('welcome');
                }
                return false;
            })
            .catch(() =>  false);
        }];

        var verifyTenantAdmin = ['_', '$q', 'UserService', function(_, $q, userService){
            var deferred = $q.defer();

            userService.getCurrentUser()
            .then(function(userResponse){
                if(_.find(userResponse.data.user.tenantRoles, { roleType: 'TENANT_ADMIN' })){
                    deferred.resolve();
                } else {
                    deferred.reject('Unauthorized');
                }
            });

            return deferred.promise;
        }];

        /*
         * verifyAuthentication
         * TODO: extract this into a seperate service.
         *
         * Returns a promise that resolves if the user has a valid session with the server, otherwise
         * the promise rejects.
         *
         * Intended to be used with ui.router states.  This function should be part of the resolve map for
         * states that need authentication.  If it rejects, then ui.router will broadcast a $stateChangeError
         * event where we can take action to re-route the user for authentication.
         */
        var verifyAuthentication = ['$q', 'UserService', function($q, userService) {
            var deferred = $q.defer();

            // TODO: need to move to side effect free check instead of checkUser() that writes data to
            // $rootScope, but for the moment the initial/avatar logic in header needs it.
            userService.checkUser()
            .then(function(user) {
                if (user && user.id) {
                    deferred.resolve();
                } else {
                    deferred.reject('Unauthenticated');
                }
            })
            .catch(function() {
                deferred.reject('Unauthenticated');
            });

            return deferred.promise;
        }];

        var myTopicsEditRedirector = ['permissionService', 'StreamService', '$q', '$state', '$stateParams', function(permissionService, StreamService, $q, $state, $stateParams){
            var stream;
            var streamGetter = $stateParams.catalogId ?
                StreamService.getStreamFromCatalog($stateParams.catalogId, $stateParams.streamId) : StreamService.getStream($stateParams.streamId);

            return streamGetter
                .then(function(streamRes) {
                    stream = streamRes.data;
                    return $q.all([
                        permissionService.currentUserHasPermission({ action: 'MANAGE_CATALOG' }), // Can manage catalog streams?
                        permissionService.currentUserHasPermission({ action: 'MANAGE_STREAM', streamOwnerId: stream.ownerId }), // Is owner editing own topic?
                        permissionService.currentUserHasPermission({ action: 'MANAGE_STREAM', streamId: stream.id }) // has stream level permission to manage stream
                    ]);
                })
                .then(function(responses) {
                    var allowedToEditCatalogStream = responses[0];
                    var isStreamOwner = responses[1];
                    var isStreamManagerForStream = responses[2];
                    var isTenantStream = stream.tenantId;
                    if ((isTenantStream && (isStreamOwner || isStreamManagerForStream)) || (!isTenantStream && allowedToEditCatalogStream)) {
                        $state.go('mytopics.editTopic.articles', {streamId: stream.id, itemId: $state.params.itemId, source: $state.params.source }, {location: 'replace'});
                    }
                });
        }];

        $stateProvider
            .state('welcome', {
                url: '/welcome',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/readingRouter.html',
                        controller: 'WelcomeCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    tenantResponse: getTenant,
                    user: getUncachedUser
                },
                data: {
                    noNav: true
                }
            })
            .state('reading', {
                url: '/reading?itemId&tag&tags&userTag&c&s&source&query',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/readingRouter.html',
                        controller: 'ReadingRouterCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    user: getUncachedUser
                }
            })
            .state('articles', {
                url: '/articles?itemId&tag&userTag&c&s&source&query',
                reloadOnSearch: false,
                staticHelpLink: 'https://attensa.desk.com/customer/portal/articles/1824652-end-user-overview-of-my-content-section',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/reading.html',
                        controller: 'ReadingCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    user: getUncachedUser
                }
            })
            .state('briefingCenter', {
                url: '/briefingCenter',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: { template: '<briefing-center-screen></briefing-center-screen>' }
                },
                resolve: {
                    auth: verifyAuthentication,
                    user: getUncachedUser
                }
            })
            .state('briefings', {
                abstract: true,
                url: '/briefings',
                views: {
                    header: {
                        templateUrl: '/templates/header.html'
                    },
                    body: {
                        templateUrl: '/templates/briefings/base.html'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('briefings.list', {
                url: '/index?searchTerm&filter&publishedOnly',
                views: {
                    briefingHeader: {
                        templateUrl: '/templates/briefings/search.html',
                        controller: 'BriefingsSearchCtrl as briefingsSearch'
                    },
                    briefingBody: {
                        templateUrl: '/templates/briefings/itemList.html',
                        controller: 'BriefingsItemListCtrl as briefingsItemList'
                    }
                },
                resolve: {
                    isTenantAdmin: isTenantAdmin
                }
            })
            .state('briefingInvite', {
                url: '/invitation/briefings/:briefingId?userId',
                views: {
                    header: {
                        templateUrl: '/templates/header.html'
                    },
                    body: {
                        templateUrl: '/templates/invitations/briefingInvitation.html',
                        controller: 'BriefingInvitationCtrl as $ctrl'
                    }
                },
                unAuthenticated: true,
                data: {
                    noNav: true
                }
            })
            .state('briefingCreate', {
                url: '/briefings/create',
                views: {
                    header: {
                        templateUrl: '/templates/header.html'
                    },
                    body: {
                        templateUrl: '/templates/briefings/create.html',
                        controller: 'BriefingCreateCtrl as $ctrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    authorization: verifyTenantAdmin,
                    userResponse: getUncachedUser,
                    tenantResponse: getTenant
                }
            })
            .state('briefingItem', {
                abstract: true,
                url: '/briefings/:briefingId',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/briefings/itemBody.html',
                        controller: 'BriefingHeaderCtrl as $ctrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    authorization: verifyTenantAdmin,
                    briefing: getBriefing,
                    templates: getAllTemplates,
                    tenantResponse: getTenant
                }
            })
            .state('briefingItem.details', {
                url: '/details/:page?duration&timeUnitDays',
                views: {
                    details: {
                        templateUrl: '/templates/briefings/details.html',
                        controller: 'BriefingItemDetailsCtrl as briefingDetails'
                    }
                }
            })
            .state('briefingItem.schedule', {
                url: '/schedule',
                views: {
                    schedule: {
                        templateUrl: '/templates/briefings/schedule.html',
                        controller: 'BriefingItemScheduleCtrl as briefingSchedule'
                    }
                },
                resolve: {
                    briefing: getBriefing,
                    briefingSchedule: getBriefingSchedule,
                    tenant: getTenant,
                    user: getUncachedUser
                }
            })
            .state('briefingItem.people', {
                url: '/people?page&sort&sortDirection&term&filter',
                views: {
                    people: {
                        templateUrl: '/templates/briefings/people.html',
                        controller: 'BriefingPeopleCtrl as briefingPeople'
                    }
                },
                resolve: {
                    briefing: getBriefing
                }
            })
            .state('briefingItem.groups', {
                url: '/groups?page&sort&sortDirection&term&filter',
                views: {
                    groups: {
                        templateUrl: '/templates/briefings/groups.html',
                        controller: 'BriefingGroupsCtrl as briefingGroups'
                    }
                },
                resolve: {
                    briefing: getBriefing
                }
            })
            .state('briefingItem.contents', {
                url: '/contents',
                views: {
                    contents: {
                        templateUrl: '/templates/briefings/contents.html',
                        controller: 'BriefingContentsCtrl as contentCtrl'
                    }
                }
            })
            .state('preferences', {
                url: '/preferences?briefing&register&briefingId&invitationCode&token&forgotPassword&unsubscribe&userId',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/preferences/preferencesBase.html'
                    }
                },
                unAuthenticated: true,
                params: { invitationMessage: null },
                data: {
                    noNav: true
                }
            })
            .state('manageApiCreds', {
                url: '/manageApiAccess',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: { template: '<api-access-manager-screen></api-access-manager-screen>' }
                },
                resolve: {
                    auth: verifyAuthentication,
                    authorization: verifyTenantAdmin,
                    hasApiAccess: verifyHasApiAccess
                }
            })
            .state('startCreateSite', {
                url: '/createSite',
                views: {
                    body: {
                        template: '<start-create-site></start-create-site>'
                    }
                },
                resolve: {
                    isNotTenancy: verifyIsNotTenancy
                },
                params: { message: null },
                unAuthenticated: true,
                data: {
                    noNav: true
                }
            })
            .state('startCreateSiteEmbedded', {
                url: '/createSiteEmbedded',
                views: {
                    body: {
                        template: '<start-create-site></start-create-site>'
                    }
                },
                resolve: {
                    isNotTenancy: verifyIsNotTenancy
                },
                params: { message: null },
                unAuthenticated: true,
                data: {
                    noNav: true,
                    hideBar: true
                }
            })
            .state('completeCreateSite', {
                url: '/createSite/complete/:token',
                views: {
                    body: {
                        template: '<complete-create-site></complete-create-site>'
                    }
                },
                resolve: {
                    isNotTenancy: verifyIsNotTenancy
                },
                unAuthenticated: true,
                data: {
                    noNav: true
                }
            })
            .state('mytopics', {
                abstract: true,
                url: '/mytopics',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/myTopics/base.html'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    user: getUncachedUser
                }
            })
            .state('mytopics.recent', {
                url: '/recent?searchTerm&itemId',
                views: {
                    search: {
                        templateUrl: '/templates/myTopics/search.html'
                    },
                    summary: {
                        templateUrl: '/templates/myTopics/recentUpdatesSummary.html',
                        controller: 'RecentItemSummaryCtrl as summary'
                    },
                    itemList: {
                        templateUrl: '/templates/myTopics/itemList.html',
                        controller: 'RecentItemListCtrl as topicItemList'
                    },
                    noResults: {
                        templateUrl: '/templates/myTopics/noResults.html',
                        controller: 'TopicResultsCtrl as results'
                    }
                },
                data: {
                    noResultsBaseMessage: 'No recent updates found.',
                    noResultsSearchMessage: 'No matching recent updates found.'
                }
            })
            .state('mytopics.explore', {
                url: '/explore?searchTerm&tags&siteOnly&followedOnly',
                views: {
                    search: {
                        templateUrl: '/templates/myTopics/search.html'
                    },
                    summary: {
                        templateUrl: '/templates/myTopics/exploreSummary.html',
                        controller: 'ExploreSummaryCtrl as exploreSummary'
                    },
                    itemList: {
                        templateUrl: '/templates/myTopics/itemList.html',
                        controller: 'ExploreListCtrl as topicItemList'
                    },
                    noResults: {
                        templateUrl: '/templates/myTopics/noResults.html',
                        controller: 'TopicResultsCtrl as results'
                    }
                },
                data: {
                    additionalPadding: 310,
                    noResultsBaseMessage: 'Explore content by searching above!',
                    noResultsSearchMessage: 'No matching items found.'
                }
            })
            .state('mytopics.saved', {
                url: '/saved?searchTerm',
                views: {
                    summary: {
                        templateUrl: '/templates/myTopics/savedItemsSummary.html'
                    },
                    itemList: {
                        templateUrl: '/templates/myTopics/itemList.html',
                        controller: 'SavedItemListCtrl as topicItemList'
                    },
                    noResults: {
                        templateUrl: '/templates/myTopics/noResults.html',
                        controller: 'TopicResultsCtrl as results'
                    }
                },
                data: {
                    noResultsBaseMessage: 'No saved items found.',
                    noResultsSearchMessage: 'No matching saved items found.'
                }
            })
            .state('mytopics.recommended', {
                url: '/recommended?searchTerm',
                views: {
                    summary: {
                        templateUrl: '/templates/myTopics/recommendedItemsSummary.html'
                    },
                    itemList: {
                        templateUrl: '/templates/myTopics/itemList.html',
                        controller: 'RecommendedItemListCtrl as topicItemList'
                    },
                    noResults: {
                        templateUrl: '/templates/myTopics/noResults.html',
                        controller: 'TopicResultsCtrl as results'
                    }
                },
                data: {
                    noResultsBaseMessage: 'No recommended items found.',
                    noResultsSearchMessage: 'No matching recommended items found.'
                }
            })
            .state('mytopics.waypopular', {
                url: '/popular?searchTerm',
                views: {
                    summary: {
                        templateUrl: '/templates/myTopics/popularItemsSummary.html'
                    },
                    itemList: {
                        templateUrl: '/templates/myTopics/itemList.html',
                        controller: 'MostPopularItemListCtrl as topicItemList'
                    },
                    noResults: {
                        templateUrl: '/templates/myTopics/noResults.html',
                        controller: 'TopicResultsCtrl as results'
                    }
                },
                data: {
                    noResultsBaseMessage: 'No popular items found.',
                    noResultsSearchMessage: 'No matching popular items found.'
                }
            })
            .state('mytopics.topic', {
                url: '/{streamId}?searchTerm?itemId?source',
                views: {
                    summary: {
                        templateUrl: '/templates/myTopics/topicSummary.html',
                        controller: 'MyTopicsSummaryCtrl as topic'
                    },
                    controlbar: {
                        templateUrl: '/templates/myTopics/controlbar.html',
                        controller: 'MyTopicsSummaryCtrl as topic'
                    },
                    itemList: {
                        templateUrl: '/templates/myTopics/itemList.html',
                        controller: 'MyTopicsItemListCtrl as topicItemList'
                    },
                    noResults: {
                        templateUrl: '/templates/myTopics/noResults.html',
                        controller: 'TopicResultsCtrl as results'
                    }
                },
                resolve: {
                    currentStream: getStream,
                    myTopicsEditRedirector: myTopicsEditRedirector
                },
                data: {
                    noResultsBaseMessage: 'No items found.',
                    noResultsSearchMessage: 'No matching items found.',
                    noResultsDateFilterMessage: 'No matching items found for the selected dates.'
                }
            })
            .state('mytopics.editTopic', {
                abstract: true,
                params: { editTitle: null },
                url: '/:streamId/edit?catalogId?source',
                views: {
                    summary: {
                        templateUrl: '/templates/myTopics/topicSummary.html',
                        controller: 'MyTopicsSummaryCtrl as topic'
                    },
                    controlbar: {
                        templateUrl: '/templates/myTopics/controlbar.html',
                        controller: 'MyTopicsSummaryCtrl as topic'
                    },
                    itemList: {
                        templateUrl: '/templates/topicBuilder/topicBuilderTabs.html',
                    },
                },
                resolve: {
                    auth: verifyAuthentication,
                    currentStream: getStream
                },
                data: {
                    additionalPadding: 400,
                    hideControlbar: true,
                    hideEditLink: true,
                    defaultShowAll: true
                }
            })
            .state('mytopics.editTopic.activity', {
                url: '/activity',
                views: {
                    activity: {
                        templateUrl: '/templates/topicBuilder/topicBuilderActivity.html'
                    }
                }
            })
            .state('mytopics.editTopic.aggregation', {
                url: '/aggregation',
                views: {
                    aggregation: {
                        templateUrl: '/templates/topicBuilder/topicBuilderAggregation.html'
                    }
                }
            })
            .state('mytopics.editTopic.articles', {
                url: '/articles?itemId',
                params: {
                    filterTerms: null
                },
                views: {
                    articles: {
                        templateUrl: '/templates/topicBuilder/topicBuilderArticles.html',
                    },
                    noResults: {
                        templateUrl: '/templates/myTopics/noResults.html',
                        controller: 'TopicResultsCtrl as results'
                    }
                },
                resolve: {
                    currentStream: getStream
                },
                data: {
                    paneScroll: true
                }
            })
            .state('mytopics.editTopic.filters', {
                url: '/filters',
                params: {
                    filterTerms: null
                },
                views: {
                    filters: {
                        templateUrl: '/templates/topicBuilder/topicBuilderFilters.html'
                    }
                }
            })
            .state('mytopics.editTopic.sources', {
                url: '/sources',
                views: {
                    sources: {
                        template: '<topic-builder-sources></topic-builder-sources>'
                    }
                }
            })
            .state('mytopics.editTopic.people', {
                url: '/people',
                views: {
                    people: {
                        templateUrl: '/templates/topicBuilder/topicBuilderPeople.html'
                    }
                }
            })
            .state('mytopics.editTopic.topics', {
                url: '/topics',
                views: {
                    topics: {
                        templateUrl: '/templates/topicBuilder/topicBuilderTopics.html'
                    }
                }
            })
            .state('mytopics.editTopic.settings', {
                url: '/settings',
                views: {
                    settings: {
                        templateUrl: '/templates/topicBuilder/topicBuilderSettings.html'
                    }
                }
            })
            .state('mytopics.editTopic.syndication', {
                url: '/syndication',
                views: {
                    syndication: {
                        templateUrl: '/templates/topicBuilder/topicBuilderSyndication.html'
                    }
                }
            })
            .state('mytopics.editTopic.usage', {
                url: '/usage',
                views: {
                    usage: {
                        templateUrl: '/templates/topicBuilder/topicBuilderUsage.html'
                    }
                }
            })
            .state('briefing', {
                url: '/briefing?id&briefingHistoryId',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/briefingView.html',
                        controller: 'BriefingViewCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('streams', {
                url: '/streams?id&tab&category&filter&filterType&filterLabel&searchTerm&catalog&categoryName&sort&sortDirection',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/streams/streams.html',
                        controller: 'StreamsCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    userResponse: getUncachedUser,
                    tenant: getTenant,
                    tenantCatalogMap: getTenantCatalogMap
                }
            })
            .state('streamCreate', {
                url: '/streamCreate?catalog&category&categoryName',
                staticHelpLink: 'http://guide.attensa.com/getting-started/aggregate-information#CYOS',
                data: {
                    permissions: {
                        only: ['MANAGE_STREAM'],
                        redirectTo: 'reading'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/createContentSection.html',
                        controller: 'StreamCreateCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('personalDigest', {
                url: '/personalDigest',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/personalDigest/personalDigest.html'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('launchpad', {
                url: '/launchpad',
                data: {
                    permissions: {
                        only: ['CREATE_STREAM'],
                        redirectTo: 'browse.catalog'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        template: '<launchpad></launchpad>'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('seedTopic', {
                url: '/topics/seed?searchTerm',
                data: {
                    permissions: {
                        only: ['CREATE_STREAM'],
                        redirectTo: 'browse.catalog'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        template: '<topic-seed-start></topic-seed-start>'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('editTopic', {
                abstract: true,
                params: { editTitle: null },
                url: '/topics/:streamId/edit?catalogId',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/topicBuilder/topicBuilder.html',
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                },
                data:{
                    defaultShowAll: true
                }
            })
            .state('editTopic.activity', {
                url: '/activity',
                views: {
                    activity: {
                        templateUrl: '/templates/topicBuilder/topicBuilderActivity.html'
                    }
                }
            })
            .state('editTopic.aggregation', {
                url: '/aggregation',
                views: {
                    aggregation: {
                        templateUrl: '/templates/topicBuilder/topicBuilderAggregation.html'
                    }
                }
            })
            .state('editTopic.articles', {
                url: '/articles',
                params: {
                    filterTerms: null
                },
                views: {
                    articles: {
                            templateUrl: '/templates/topicBuilder/topicBuilderArticles.html',
                        controller: 'TopicBuilderArticlesCtrl as topic'
                    }
                },
                resolve: {
                    currentStream: getStream
                }
            })
            .state('editTopic.filters', {
                url: '/filters',
                params: {
                    filterTerms: null
                },
                views: {
                    filters: {
                        templateUrl: '/templates/topicBuilder/topicBuilderFilters.html'
                    }
                }
            })
            .state('editTopic.sources', {
                url: '/sources',
                views: {
                    sources: {
                        template: '<topic-builder-sources></topic-builder-sources>'
                    }
                }
            })
            .state('editTopic.people', {
                url: '/people',
                views: {
                    people: {
                        templateUrl: '/templates/topicBuilder/topicBuilderPeople.html'
                    }
                }
            })
            .state('editTopic.topics', {
                url: '/topics',
                views: {
                    topics: {
                        templateUrl: '/templates/topicBuilder/topicBuilderTopics.html'
                    }
                }
            })
            .state('editTopic.settings', {
                url: '/settings',
                views: {
                    settings: {
                        templateUrl: '/templates/topicBuilder/topicBuilderSettings.html'
                    }
                }
            })
            .state('editTopic.syndication', {
                url: '/syndication',
                views: {
                    syndication: {
                        templateUrl: '/templates/topicBuilder/topicBuilderSyndication.html'
                    }
                }
            })
            .state('editTopic.usage', {
                url: '/usage',
                views: {
                    usage: {
                        templateUrl: '/templates/topicBuilder/topicBuilderUsage.html'
                    }
                }
            })
            .state('topic', {
                url: '/topics/:streamId?endDate&startDate&indexVisible&subscribe',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/topic/topic.html',
                        controller: 'TopicStateCtrl as topic'
                    }
                },
                resolve: {
                    auth: verifyAuthentication,
                    stream: getStream
                }
            })
            .state('browse', {
                abstract: true,
                url: '/browse',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/topics/browse.html'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('browse.catalog',  {
                url: '/catalog?categoryId',
                data: { tenantTaxonomy: true },
                params: { taxonomy: null },
                views: {
                    catalog: { templateUrl: '/templates/topics/topics.html' }
                }
            })
            .state('browse.marketplace',  {
                url: '/marketplace/{catalogId}?categoryId',
                data: { tenantTaxonomy: false },
                params: { taxonomy: null },
                views: {
                    marketplace: { templateUrl: '/templates/topics/topics.html' }
                }
            })
            .state('browse.ownedStreams',  {
                url: '/ownedTopics',
                views: {
                    ownedStreams: { templateUrl: '/templates/topics/ownedStreams.html' }
                }
            })
            .state('browse.search',  {
                url: '/search?searchTerm',
                views: {
                    searchResults: { templateUrl: '/templates/topics/searchResults.html' }
                }
            })
            .state('browse.stream',  {
                url: '/topic/{streamId}',
                params: { stream: null },
                views: {
                    stream: {
                        templateUrl: '/templates/topic/topic.html',
                        controller: 'TopicStateCtrl as topic'
                    }
                },
                resolve: {
                    stream: getStream
                }
            })
            .state('login', {
                url: '/login?token&RelayState',
                unAuthenticated: true,
                views: {
                    body: { templateUrl: '/templates/login.html' }
                }
            })
            .state('forgotPassword', {
                url: '/login/forgot_password',
                unAuthenticated: true,
                views: {
                    body: { templateUrl: '/templates/forgotPassword.html' }
                }
            })
            .state('resetPassword', {
                url: '/login/reset_password?token',
                unAuthenticated: true,
                views: {
                    body: { templateUrl: '/templates/resetPassword.html' }
                }
            })
            .state('logout', {
                url: '/logout',
                onEnter: ['UserService', 'TenantService', function(userService, tenantService) {
                    tenantService.getCurrentTenant().then(function(tenant) {
                        userService.logout(tenant.data.settings);
                    });
                }]
            })
            .state('signup', {
                url: '/signup',
                unAuthenticated: true,
                views: {
                    body: {
                        templateUrl: '/templates/signup.html',
                        controller: 'SignupCtrl',
                        controllerAs: 'signup'
                    }
                }
            })
            .state('manageSubscriptions', {
                url: '/subscriptions',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/subscriptions/manageSubscriptions.html'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('register', {
                url: '/register?invitationCode&RelayState',
                unAuthenticated: true,
                onEnter: ['UserService', function(userService) {
                    userService.destroySession();
                }],
                views: {
                    header: { templateUrl: '/templates/bareHeader.html' },
                    body: { templateUrl: '/templates/register.html' }
                }
            })
            .state('editProfile', {
                url: '/profile/editor',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/profile.html',
                        controller: 'ProfileCtrl'
                    }
                },
                resolve: {
                    tenant: getTenant,
                    user: getUncachedUser,
                    auth: verifyAuthentication
                }
            })
            .state('managePeople', {
                url: '/manage/people',
                data: {
                    permissions: {
                        only: ['MANAGE_PEOPLE'],
                        redirectTo: 'reading'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/managePeopleTable.html',
                        controller: 'ManagePeopleCtrl as $ctrl'
                    }
                },
                resolve: {
                    tenant: getTenant,
                    people: getPeople,
                    auth: verifyAuthentication
                }
            })
            .state('manageCategories', {
                url: '/manage/categories',
                data: {
                    permissions: {
                        only: ['MANAGE_TENANT'],
                        redirectTo: 'reading'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/manageCategories.html',
                        controller: 'ManageCategoriesCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('manageCatalog', {
                url: '/manage/catalogs/:catalogId',
                data: {
                    permissions: {
                        only: ['MANAGE_CATALOG'],
                        redirectTo: 'browse.catalog'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/manageCategories.html',
                        controller: 'ManageCategoriesCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('manageAccount', {
                url: '/manage/account',
                data: {
                    permissions: {
                        only: ['MANAGE_TENANT'],
                        redirectTo: 'reading'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: { template: '<manage-account></manage-account>' }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('manageGroups', {
                url: '/manage/groups',
                data: {
                    permissions: {
                        only: ['MANAGE_GROUPS'],
                        redirectTo: 'reading'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/manageGroupsTable.html',
                        controller: 'ManageGroupsCtrl'
                    }
                },
                resolve: {
                    tenant: getTenant,
                    groups: getGroups,
                    auth: verifyAuthentication
                }
            })
            .state('manageTemplates', {
                url: '/manage/templates',
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/manageTemplates.html',
                        controller: 'ManageTemplateCtrl'
                    }
                },
                resolve: {
                    templates: ['TemplateService', function(templateService) {
                        return templateService.getAll();
                    }],
                    briefing: function() {
                        return null;
                    },
                    s3Bucket: ['InfoService', function(infoService) {
                        return infoService.getS3Bucket();
                    }]
                }
            })
            .state('opml', {
                url: '/stream/opml?category',
                data: {
                    permissions: {
                        only: ['MANAGE_STREAM'],
                        redirectTo: 'reading'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/opmlImport.html',
                        controller: 'OpmlImportCtrl'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            })
            .state('tenantAnalytics', {
                url: '/dashboard',
                data: {
                    permissions: {
                        only: ['MANAGE_TENANT'],
                        redirectTo: 'reading'
                    }
                },
                views: {
                    header: { templateUrl: '/templates/header.html' },
                    body: {
                        templateUrl: '/templates/tenantAnalytics.html'
                    }
                },
                resolve: {
                    auth: verifyAuthentication
                }
            });
    }])
    .run(['_', '$window', 'TenantService', function(_, $window, tenantService){
        var addFavicon = function(type, href, sizes) {
            let favicon = $window.document.createElement('link');
            favicon.setAttribute('rel', 'icon');
            favicon.setAttribute('type', type);
            if(sizes){
                favicon.setAttribute('sizes', sizes);
            }
            favicon.setAttribute('href', href);
            $window.document.querySelector('head').appendChild(favicon);
        };
        
        tenantService.getUnauthTenantInfo()
        .then(function(tenantRes){
            if (tenantRes.data && tenantRes.data.settings && !_.isEmpty(tenantRes.data.settings.faviconUrl)) {
                addFavicon('image/png', tenantRes.data.settings.faviconUrl);
            } else {
                addFavicon('image/png', 'images/favicon-16x16.png', '16x16');
                addFavicon('image/png', 'images/favicon-32x32.png', '32x32');
                addFavicon('image/png', 'images/favicon-96x96.png', '96x96');    
            }
            
            $window.document.title = tenantRes.data && tenantRes.data.settings && !_.isEmpty(tenantRes.data.settings.title) ? 
                tenantRes.data.settings.title : 
                'Attensa';
        });
    }])
    /*
     * When we can't change states due to not being authenticated:
     * 1. Check if they are an SSO tenant
     *     a.  If yes, redirect them out to IDP login url and provide relay state to they can come back
     *         with their deep link
     *     b.  If no, then send them to local login
     *
     */
    .run(['$window', '$rootScope', 'AuthService',
        function ($window, $rootScope, authService) {
            $rootScope.$on('$stateChangeError', function (e, to, toParams, from, fromParams, error) {
                if (error === 'Unauthenticated') {
                    e.preventDefault();
                    authService.goToLogin();
                }else if (error === 'Unauthorized'){
                    e.preventDefault();
                    $window.history.back();
                }
            });
        }])
    .run(['$rootScope', 'AuthService', '$stateParams',
        function($rootScope, authService, $stateParams) {
            $rootScope.$on('app.authenticationFailure', function (e) {
                e.preventDefault();
                // Check if user is trying to register with bad invitation code
                if(!$stateParams.invitationCode) {
                    authService.goToLogin();
                }
            });
        }
    ])
    .run(['$rootScope', '$state', '$uibModalStack', function($rootScope, $state, $uibModalStack) {
        $rootScope.uiState = $state;

        $rootScope.$on('$stateChangeSuccess', function(event, toState){
            $uibModalStack.dismissAll();
            var pageBody = $('html, body');
            if(pageBody) {
                if(typeof pageBody.animate !== 'undefined') {
                    pageBody.animate({ scrollTop: 0 }, 'fast');
                }
            }
        });
    }])
    .run(['InfoService', 'editableOptions', 'editableThemes',
        function(infoService, editableOptions, editableThemes) {
            editableThemes.bs3.inputClass = 'input-xs';
            editableThemes.bs3.buttonsClass = 'btn-xs';
            editableOptions.theme = 'bs3';
        }]);

'use strict';

angular.module('attensaApp')
.constant('EMAIL_ACTIVITIES', {
    'briefing_email_bounced': { displayText: 'Bounced', type: 'ERROR' },
    'briefing_email_clicked': { displayText: 'Opened and clicked', type: 'SUCCESS' },
    'briefing_email_deferred': { displayText: 'Deferred', type: 'WARN' },
    'briefing_email_delivered': { displayText: 'Delivered', type: 'INFO' },
    'briefing_email_dropped': { displayText: 'Dropped', type: 'ERROR' },
    'briefing_email_opened': { displayText: 'Opened', type: 'SUCCESS' },
    'briefing_email_spammed': { displayText: 'Marked as spam', type: 'WARN'}
} );

'use strict';

angular.module('attensaApp').config(['$provide', function($provide) {

    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {
        taRegisterTool('backgroundColor', {
            display: '<div class="color-picker-container">Highlight:' +
                '<div ng-repeat="o in options" ng-click="setColor(o)" tooltip-placement="top" uib-tooltip="{{o.name}}" ng-style="getBackgroundStyle(o.hex);" class="color-picker-box"></div>' +
                '<a ng-click="setColor({hex:\'#FFFFFF\'})" tooltip-placement="top" uib-tooltip="Clear Highlight" class="btn btn-xs btn-default color-picker-clear-button"><i class="fa fa-times"></i></a>' +
                '</div>',
            options: [
                {name: 'Red', hex: '#FF0000'},
                {name: 'Yellow', hex: '#FFFF00'},
                {name: 'Green', hex: '#00FF00'},
                {name: 'Blue', hex: '#0000FF'},
                {name: 'Violet', hex: '#9F00FF'},
                {name: 'Cyan', hex: '#00FFFF'}
            ],
            getBackgroundStyle: function(hex) {
                return {
                    'background-color':hex
                };
            },
            setColor: function (color) {
                this.$editor().wrapSelection('backColor', color.hex);                
            },
            action: function (deferred) {
                deferred.resolve();
            }
        });
        taRegisterTool('foregroundColor', {
            display: '<div class="color-picker-container">Font Color:' +
                '<div ng-repeat="o in options" ng-click="setColor(o)" tooltip-placement="top" uib-tooltip="{{o.name}}" ng-style="getBackgroundStyle(o.hex);" class="color-picker-box"></div>' +
                '<a ng-click="setColor({hex:\'#555555\'})" tooltip-placement="top" uib-tooltip="Clear Text Color" class="btn btn-xs btn-default color-picker-clear-button"><i class="fa fa-times"></i></a>' +
                '</div>',
            options: [
                {name: 'Red', hex: '#FF0000'},
                {name: 'Yellow', hex: '#FFFF00'},
                {name: 'Green', hex: '#00FF00'},
                {name: 'Blue', hex: '#0000FF'},
                {name: 'Violet', hex: '#9F00FF'},
                {name: 'Cyan', hex: '#00FFFF'},
                {name: 'White', hex: '#FFFFFF'},
                {name: 'Black', hex: '#000000'}
            ],
            getBackgroundStyle: function(hex) {
                return {
                    'background-color':hex
                };
            },
            setColor: function (color) {
                this.$editor().wrapSelection('foreColor', color.hex);
            },
            action: function (deferred) {
                deferred.resolve();
            }
        });
        taRegisterTool('fontPicker', {
            display: '<div style="padding: 2px;background-color:white;border:1px solid #ccc;" uib-dropdown ng-init="initPicker()" class="dropdown" id="text-angular-font-picker"> ' +
                     '  <div class="pull-left" style="padding:6px;">Font: </div>' +
                     '  <div class="btn-group pull-right">' +
                     '      <button class="btn btn-default" ng-disabled="showHtml()" type="button" style="min-width: 120px; font-family: {{fontSelectionCss}}">{{fontSelection}}</button>' +
                     '      <button class="btn btn-default uib-dropdown-toggle" uib-dropdown-toggle type="button" id="dropdownMenu1" data-toggle="dropdown" style="font-family: {{fontSelectionCss}}" aria-expanded="true"><span class="caret"></span> </button>' +
                     '  </div>' +
                     '  <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">' +
                     '      <li ng-repeat="o in options" role="presentation"><a style="font-family: {{o.css}}" ng-click="selectFont(o)">{{o.name}}</a></li>' +
                     '  </ul>' +
                     '</div>',
            options: [
                {name: 'Arial', css: 'Arial, Helvetica, sans-serif'},
                {name: 'Times New Roman', css: '"times new roman", serif'},
                {name: 'Wide', css: '"arial black", sans-serif'},
                {name: 'Narrow', css: '"arial narrow", sans-serif'},
                {name: 'Courier New', css: '"courier new", monospace'},
                {name: 'Garamond', css: 'garamond, serif'},
                {name: 'Georgia', css: 'georgia, serif'},
                {name: 'Tahoma', css: 'tahoma, sans-serif'},
                {name: 'Trebuchet MS', css: '"trebuchet ms", sans-serif'},
                {name: 'Helvetica', css: '"Helvetica Neue", Helvetica, Arial, sans-serif'},
                {name: 'Verdana', css: 'verdana, sans-serif'}
            ],
            initPicker: function () {
                this.fontSelection = 'Arial';
                this.fontSelectionCss = 'Arial, Helvetica, sans-serif';
            },
            selectFont: function (font) {
                this.$parent.fontSelection = font.name;
                this.$parent.fontSelectionCss = font.css;
            },
            action: function (deferred) {
                this.$editor().wrapSelection('fontName', this.fontSelectionCss);
                deferred.resolve();
            }
        });
        taRegisterTool('fontSizePicker', {
            display: '<div style="padding: 2px;background-color:white;border:1px solid #ccc;" uib-dropdown ng-init="initPicker()" class="dropdown" id="text-angular-font-size-picker"> ' +
            '  <div class="pull-left" style="padding:6px;">Font Size: </div>' +
            '  <div class="btn-group pull-right">' +
            '      <button class="btn btn-default" ng-disabled="showHtml()" type="button" style="min-width: 55px; font-family: {{fontSizeCss}}">{{fontSize}}</button>' +
            '      <button class="btn btn-default dropdown-toggle" uib-dropdown-toggle type="button" id="dropdownMenu1" data-toggle="dropdown" style="font-family: {{fontSizeCss}}" aria-expanded="true"><span class="caret"></span> </button>' +
            '  </div>' +
            '  <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">' +
            '      <li ng-repeat="o in options" role="presentation"><a style="font-family: {{o.css}}" ng-click="selectSize(o)">{{o.name}}</a></li>' +
            '  </ul>' +
            '</div>',
            options: [
                {name: 'Huge', css: '6'},
                {name: 'Large', css: '4'},
                {name: 'Normal', css: '3'},
                {name: 'Small', css: '1'}
            ],
            initPicker: function () {
                this.fontSize = 'Normal';
                this.fontSizeCss = '3';
            },
            selectSize: function (size) {
                this.$parent.fontSize = size.name;
                this.$parent.fontSizeCss = size.css;
            },
            action: function (deferred) {
                this.$editor().wrapSelection('fontSize', this.fontSizeCss);
                deferred.resolve();
            }
        });
        taOptions.toolbar[1].push('backgroundColor');
        taOptions.toolbar[1].push('foregroundColor');
        taOptions.toolbar[1].push('fontPicker');
        taOptions.toolbar[1].push('fontSizePicker');
        taOptions.disableSanitizer = true;
        return taOptions;
    }]);

}]);
'use strict';

angular.module('attensaApp')
.constant('TOPIC_TAGS', [
    {tagText: 'Business_Finance', displayText: 'Business & Finance' },
    {tagText: 'Disaster_Accident', displayText: 'Disasters & Accidents' },
    {tagText: 'Education', displayText: 'Education' },
    {tagText: 'Entertainment_Culture', displayText: 'Entertainment & Culture' },
    {tagText: 'Environment', displayText: 'Environment' },
    {tagText: 'Health_Medical_Pharma', displayText: 'Health, Medical & Pharma' },
    {tagText: 'Hospitality_Recreation', displayText: 'Hospitality & Recreation' },
    {tagText: 'Human Interest', displayText: 'Human Interest' },
    {tagText: 'Labor', displayText: 'Labor' },
    {tagText: 'Law_Crime', displayText: 'Law & Crime' },
    {tagText: 'Politics', displayText: 'Politics' },
    {tagText: 'Religion_Belief', displayText: 'Religion' },
    {tagText: 'Social Issues', displayText: 'Social Issues' },
    {tagText: 'Sports', displayText: 'Sports' },
    {tagText: 'Technology_Internet', displayText: 'Technology & Internet' },
    {tagText: 'War_Conflict', displayText: 'War & Conflict' },
    {tagText: 'Weather', displayText: 'Weather' },
    {tagText: 'Other', displayText: 'Other' }
]);
'use strict';

angular.module('attensaApp')
.constant('TAG_TYPES', ['entities', 'socialTag', 'topics'])
.constant('WATSON_TAG_TYPES', ['entities', 'keywords', 'concepts']);

'use strict';

angular.module('attensaApp')
.component('apiAccessManagerScreen', {
    template: `
        <div layout="row" flex>
            <div flex-offset="20" flex="60">
                <div layout="column">
                    <div flex="100" layout="row" layout-align="center center">
                    <h2>API Access Credentials</h2>
                    </div>
                    <spinner ng-if="$ctrl.noTouching"></spinner>
                    <div flex="100" ng-if="!$ctrl.noTouching" layout="row" layout-align="end center">
                        <md-checkbox ng-model="$ctrl.showPassword"
                                     style="margin-top: 15px; padding-right: 20px;">Show Passwords</md-checkbox>
                        <md-button class="md-raised md-primary" ng-click="$ctrl.createCreds()">Add new Credentials</md-button>
                    </div>
                    <div flex="100" ng-if="!$ctrl.noTouching" layout="row">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th width="33%">Username</th>
                                    <th width="33%">Password</th>
                                    <th width="33%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-repeat="creds in $ctrl.credentials">
                                    <td width="33%">{{creds.username}}</td>
                                    <td width="33%"><span ng-if="creds.password">{{$ctrl.renderPassword(creds.password)}}</span></td>
                                    <td width="33%"><md-button style="float: right;" ng-if="creds.password" ng-click="$ctrl.deleteCreds(creds)">Delete</md-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>        
    `,
    controller: ['$mdDialog', 'TenantService', function($mdDialog, tenantService){

        this.deleteCreds = creds => 
            $mdDialog.show($mdDialog.confirm()
                .title(`Would you like to delete ${creds.username}?`)
                .textContent('Once deleted the credentials cannot be restored.')
                .ariaLabel('Confirm')
                .ok('Delete')
                .cancel('Cancel'))
            .then(() => tenantService.deleteApiCredentials(creds.username))
            .then(() => this.loadCreds());

        this.createCreds = () => tenantService.createApiCredentials().then(() => this.loadCreds());

        this.renderPassword = password => this.showPassword ? password : '*'.repeat(password.length);

        this.loadCreds = () => {
            this.noTouching = true;            
            tenantService.getApiCredentials()
            .then(response => {
                this.noTouching = false;
                this.credentials = response.data;
            });
        };

        this.$onInit = () => this.loadCreds();
    }]
});

'use strict';

angular.module('attensaApp')
    .component('editItem', {
        bindings: {
            item: '<',
            stream: '<'
        },
        transclude: true,
        template: [
            '<li',
                'show-with-permission ',
                'action="DELETE_ITEMS"',
                'stream-id="$ctrl.item.streamId"',
                'stream-owner-id="{{$ctrl.relatedStreams.source.ownerId}}">',
                    '<a ng-click="$ctrl.editItem($ctrl.item)">',
                        '<ng-transclude></ng-transclude>',
                    '</a>',
            '</li>'

        ].join('\n'),
        controller: ['_', '$rootScope', '$uibModalStack', 'ItemService','UserService',
            function(_, $rootScope, $uibModalStack, itemService, userService) {
            var self = this;

            var itemUpdated = function(item, operation){
                return function() {
                    $rootScope.$broadcast('item-updated', item, self.stream, operation);
                };
            };

            this.editItem = function(item){
                $uibModalStack.dismissAll();
                if(_.contains(['COPY', 'EMAIL', 'MANUAL', 'SEARCH'], self.item.type) && self.stream){
                    itemService.openEditItemModal(self.item.id, self.stream, itemUpdated(item, 'edit'));
                } else {
                    userService.getCurrentUser().then(function(userResponse){
                        var name = userResponse.data.user.firstName + ' ' + userResponse.data.user.lastName;
                        itemService.openPostItemModal([self.stream], self.item.id, name, itemUpdated(item, 'edit'));
                    });
                }
            };
        }]
    });
'use strict';

angular.module('attensaApp')
    .component('emptyStateHelp', {
        bindings: {
            title: '@',
            subTitle: '@',
            targetSref: '@',
            linkText: '@'
        },
        template: `
        <div class="col-sm-offset-4 col-sm-4" style="background-color: #f5f5f5;">
            <div layout="column" layout-align="center center" style="background-color: #ffffff; margin-top:20px; margin-bottom: 20px; padding-bottom: 20px;">
                <h3 >{{$ctrl.title}}</h3>
                <h3>{{$ctrl.subTitle}}</h3>
                <button ui-sref="{{$ctrl.targetSref}}" class="btn btn-primary" style="margin-top: 40px"><span class="fa fa-plus"></span> {{$ctrl.linkText}}</button>
            </div>
            <div layout="row" style="padding-bottom: 15px;">
                <div flex="40" flex-offset="30" layout="column" layout-align="center center">
                    <img alt="Attensa" logo="" src="/images/logo.svg">
                </div>
                <div flex layout="column" layout-align="center end">
                    <a target="_blank" href="https://intercom.help/attensa-help" style="padding-top:12px;">Help & Answers</a>
                </div>
            </div>
        </div>
        `,
    });

'use strict';

angular.module('attensaApp')
.component('existingSourceList', {
    bindings: {
        parentStreamId: '@?',
        searchTerm: '<',
        sources: '=',
        includedSources: '=?',
        toggleAddToTopic: '&?',
        noPreview: '<',
        hideLinks: '@?'
    },
    template: [
        '<ul class="sources-list">',
            '<li class="source-list animated-list" ng-repeat="source in $ctrl.sortedSources()">',
                '<h5><stream-type-indicator stream="source"></stream-type-indicator> {{::source.title || $ctrl.genTitle(source)}}</h5>',
                '<div class="action-links pull-right" ng-if="$ctrl.parentStreamId" ng-hide="$ctrl.hideLinks">',
                    '<span><a ng-click="$ctrl.removeSource(source.id)")>Remove</a> / </span>',
                    '<span ng-if="source.tenantId"><a ui-sref="editTopic.articles({ streamId: source.id })">Edit</a> / </span>',
                    '<span ng-if="!$ctrl.noPreview"><a ng-click="$ctrl.previewSource(source.id)")>Preview</a> / </span>',
                    '<a ui-sref="topic({ streamId: source.id })">Read</a>',
                '</div>',
                '<div class="action-links pull-right" ng-if="!$ctrl.parentStreamId" ng-hide="$ctrl.hideLinks">',
                    '<span><a ng-click="$ctrl.previewSource(source.id)")>Preview</a> / </span>',
                    '<span><a ng-click="$ctrl.toggleAddToTopic({ source: source })">{{ $ctrl.isIncludedSource(source.id) ? \'Remove\' : \'Add\'}}</a></span>',
                '</div>',
                '<item-preview-list uib-collapse="$ctrl.previewIsHidden(source.id)" items="$ctrl.previewItems[source.id]" stream="source" readable="true"></item-preview-list>',
                '<div uib-collapse="$ctrl.previewIsHidden(source.id)" ng-if="!$ctrl.previewIsHidden(source.id) && $ctrl.previewItems[source.id].length === 0">',
                    '<source-list-no-results></source-list-no-results>',
                '</div>',
                '<spinner ng-if="$ctrl.fetchingForStream && $ctrl.fetchingForStream === source.id"></spinner>',
            '</li>',
        '</ul>'
    ].join('\n'),
    controller: ['_', '$rootScope', '$uibModal', 'ItemService', 'PreviewService', 'StreamService', function(_, $rootScope, $uibModal, ItemService, PreviewService, StreamService) {
        var self = this;

        this.$onChanges = function(){
            this.previewItems = { };
        };

        this.sortedSources = function(){
          return _.sortBy(self.sources, function(source){
              return self.genTitle(source).toLowerCase();
          });
        };

        this.removeSource = function(sourceId) {

            var modalScope = $rootScope.$new();

            modalScope.modalTitle = ' Remove source?';
            modalScope.message = 'This will remove this source from the current topic.';
            modalScope.confirmLabel = 'Continue';

            $uibModal.open({
                templateUrl: '/templates/ConfirmModal.html',
                size: 'md',
                keyboard: true,
                scope: modalScope
            }).result
            .then(function() {
                _.remove(self.sources, { id: sourceId });
                StreamService.deleteStreamSubscription(self.parentStreamId, sourceId);
            });
        };

        this.previewSource = function(streamId) {
            if(!self.previewIsHidden(streamId)) {
                self.previewedStreamId = null;
            } else {
                self.fetchingForStream = streamId;
                return ItemService.searchItems({ streamId: streamId, rows: 10, search: self.searchTerm })
                .then(function(searchRes) {
                    self.previewItems[streamId] = searchRes.content;
                    self.previewedStreamId = streamId;
                    self.fetchingForStream = undefined;
                });
            }
        };

        this.previewIsHidden = function(streamId) {
            return streamId !== self.previewedStreamId;
        };

        this.isIncludedSource = function(streamId) {
            return _.some(self.includedSources, { id: streamId });
        };

        this.genTitle = PreviewService.generateTitle;
    }]
});

'use strict';

angular.module('attensaApp')
.component('rssPublish', {
    bindings: {
        stream: '=',
        onChange: '&'
    },
    controller: ['$location', function($location){
        var self = this;

        this.streamRssUrl = function() {
            return $location.protocol() + '://' + $location.host() + '/rss/' + self.stream.id;
        };

        this.togglePublish = function(){
            self.stream.rssEnabled = !self.stream.rssEnabled;
            self.onChange();
        };
    }],
    template: [
        '<button tooltip-placement="top" ',
                'tooltip-popup-delay="500" ',
                'tooltip-append-to-body="true" ',
                'uib-tooltip="{{$ctrl.stream.rssEnabled ? \'Disable RSS\' : \'Enable RSS\'}}" ',
                'ng-click="$ctrl.togglePublish()" ',
                'class="btn btn-default" ',
                'ng-class="{\'active\': $ctrl.stream.emailPostingEnabled}" ',
                'blur-me>',
            '{{$ctrl.stream.rssEnabled ? \'On\' : \'Off\'}}',
        '</button>',
        '<div style="display: inline-block; padding-left: 10px;"><a ng-if="$ctrl.stream.rssEnabled" target="_blank" href="{{::$ctrl.streamRssUrl()}}" style="vertical-align: top;">{{::$ctrl.streamRssUrl()}}</a></div>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
    .component('digestLink', {
        controller: ['TenantService',
            function(tenantService) {
                var self = this;

                this.$onInit = function(){
                  tenantService.getCurrentTenant()
                  .then(function(tenantResponse){
                      self.followLabel = tenantResponse.data.settings.noFollowing ? 'My Briefing' : 'Personal Digest';
                  });
                };
            }],
        template: [
            '<li><a click-event eventname="edit_personal_digest_selected" ui-sref="personalDigest"><i class="glyphicon glyphicon-none nav-menu-icon"></i>{{$ctrl.followLabel}}</a></li>'
        ].join('\n'),
    });

'use strict';

angular.module('attensaApp')
.component('readPermissionWarning', {
    bindings: {
        topic: '<'
    },
    template: `
        <div ng-if="!$ctrl.userCanRead()" class="reading-item-magazine">
            <span class="fa fa-exclamation-triangle" style="color: red; font-size: 6vh"></span><h3 style="margin-top:0px;padding-left: 25px; display: inline-block;">Permission Required</h3>
            <br>You do not have permission to read the content of this topic, below is a preview. Please contact your site administrator.
        </div>
    `,
    controller: ['permissionService', 'UserService', function(permissionService, userService) {
        
        this.$onInit = () => userService.getCurrentUser().then(response => this.currentUser = response.data.user);

        this.userCanRead = () => permissionService.userCanReadStream(this.currentUser, this.topic, true);
    }]
});

'use strict';

angular.module('attensaApp')
.component('shareMenu', {
    bindings: {
        item: '<',
        topicStreamId: '<',
        viewItemSessionUuid: '<',
        appendToBody: '<'
    },
    transclude: true,
    template: `
        <div ng-if="$ctrl.appendToBody" tooltip-placement="top" uib-tooltip="Share" uib-dropdown dropdown-append-to-body>
            <a class="dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle><i class="fa fa-share"></i><ng-transclude></ng-transclude></a>
            <ul uib-dropdown-menu>
                <li class="dropdown-header">Share to:</li>
                <li ng-if="!$ctrl.prodRelated">
                    <a ng-click="$ctrl.openCopyToStreamModal($ctrl.topicStreamId, $ctrl.item.id, false)">
                    <i class="fa fa-files-o"></i> &nbsp; Topic</a></li>
                <li ng-if="!$ctrl.prodRelated">
                    <a ng-click="$ctrl.openCopyToStreamModal($ctrl.topicStreamId, $ctrl.item.id, true)">
                    <i class="fa fa-files-o"></i> &nbsp; Topic with edits</a></li>
                <li>
                    <a ng-click="$ctrl.share($ctrl.item)" target="_blank">
                    <i class="fa fa-envelope"></i> &nbsp; Email</a>
                </li>
            </ul>
        </div>
        <div ng-if="!$ctrl.appendToBody" tooltip-placement="top" uib-tooltip="Share" uib-dropdown>
            <a class="dropdown-toggle fa fa-share" data-toggle="dropdown" uib-dropdown-toggle><ng-transclude></ng-transclude></a>
            <ul uib-dropdown-menu>
                <li class="dropdown-header">Share to:</li>
                <li ng-if="!$ctrl.prodRelated">
                    <a ng-click="$ctrl.openCopyToStreamModal($ctrl.item.streamId, $ctrl.item.id, false)">
                    <i class="fa fa-files-o"></i> &nbsp; Topic</a></li>
                <li ng-if="!$ctrl.prodRelated">
                    <a ng-click="$ctrl.openCopyToStreamModal($ctrl.item.streamId, $ctrl.item.id, true)">
                    <i class="fa fa-files-o"></i> &nbsp; Topic with edits</a></li>
                <li>
                    <a ng-click="$ctrl.share($ctrl.item)" target="_blank">
                    <i class="fa fa-envelope"></i> &nbsp; Email</a>
                </li>
            </ul>
        </div>
    `,
    controller: ['$rootScope', '$window', '$uibModal', '_', 'uuid4', 'eventService', 'ItemService', 'StreamService',
        function($rootScope, $window, $uibModal, _, uuid4, eventService, itemService, streamService) {

        var buildItemEvent = (base, item, stream, uuid) =>  _.assign({},
            base,
            eventService.formatItem(item),
            eventService.formatStream(stream),
            { viewItemSession: uuid }
        );

        var doPost = (eventName, eventData, relatedStreams) => {
            var event = buildItemEvent(eventData || {}, this.item, this.relatedStreams.source, this.sessionUUID);
            eventService.postEvent(eventName, event);
        };

        this.$onInit = () => {
            if(this.item.tenantId && this.item.tenantId !== $rootScope.user.tenantId) {
                this.prodRelated = true;
            }

            this.sessionUUID = this.viewItemSessionUUID || uuid4.generate();
        };

        this.postSourceEvent = (eventName, eventData) => {
            if(this.relatedStreams){
                doPost(eventName, eventData);
            }else{
                itemService.getStreamsRelatedToItem(this.item, this.streamContext)
                .then(relatedStreams => {
                    this.relatedStreams = relatedStreams;
                    doPost(eventName, eventData);
                });
            }
        };

        this.openCopyToStreamModal = (currentStreamId, itemId, doCurate) => {
            this.postSourceEvent('item_copy_to_stream_clicked');
            $uibModal.open({
                templateUrl: '/templates/copyToStreamModal.html',
                controller: 'CopyToStreamModalCtrl',
                size: 'md',
                resolve: {
                    itemId: () => itemId,
                    currentStreamId: () => this.topicStreamId,
                    doCurate: () => doCurate
                }
            }).result
            .then(results => {
                var stream = _.find(results.selectedStreams, {id: this.topicStreamId});
                if(stream){
                    $rootScope.$broadcast('item-updated', results.item, stream, 'edit');
                }
            });
        };

        this.share = item => {
            itemService.patchItem(item.streamId, item.id, { sharedBy: $rootScope.user.id })
            .then(itemResponse => $window.location.href = itemService.emailShareLink(itemResponse.data));
            this.postSourceEvent('item_share_email_clicked');
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingCenterScreen', {
    template: `
        <div layout="row" flex>
            <div flex-offset="20" flex="60">
                <div layout="column">
                    <h2>Go to <a target="_blank" href="/client/browse">Briefing Center</a></h2>
                    <h2>Briefing Commentary</h2>
                    <div flex layout="row" style="padding-top: 20px;">
                        <p>Inserts allow content to be dynamically inserted into Briefing Center emails.</p>
                        <div ng-if="!$ctrl.editing" style="padding-left: 10px;" show-with-permission action="MANAGE_TENANT"><a ng-click="$ctrl.startEditing()">Edit</a></div>                    
                    </div>
                    <div flex="100" ng-if="!$ctrl.editing" layout="row">
                        <div ng-bind-html="$ctrl.digestCommentary.content"></div>
                    </div>
                    <div ng-if="$ctrl.editing" layout="row" style="padding-top: 20px">
                        <div text-angular
                            ta-text-editor-class="edit-annotation-text form-control" 
                            ta-html-editor-class="edit-annotation-text form-control"
                            ta-keep-styles="true"
                            ta-toolbar="[['p','h1','h2','h3'],['bold','italics','underline'],['ul','ol'],['justifyLeft','justifyCenter','justifyRight'],['indent','outdent'],['html','insertImage','insertLink'], ['backgroundColor'], ['foregroundColor'],['fontPicker'], ['fontSizePicker']]"
                            ng-model="$ctrl.editContent">
                        </div>
                    </div>
                    <div ng-if="$ctrl.editing" layout="row">
                        <md-button class="md-raised md-primary" ng-click="$ctrl.save()" ng-disabled="$ctrl.unchanged()">Save</md-button>
                        <md-button ng-click="$ctrl.editing = false">Cancel</md-button>
                    </div>
                    <h2 ng-style="$ctrl.previewHeaderStyle()">Briefing Preview</h2>
                    <div style="max-width: 830px;">
                        <spinner ng-if="$ctrl.iframeNoTouching"></spinner>
                        <div ng-show="!$ctrl.iframeNoTouching">
                            <iframe iframe-onload="$ctrl.iframeLoaded()" width="830" height="500" seamless="seamless" ng-src="{{$ctrl.previewUrl}}" frameBorder="0"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    `,
    controller: ['$sce', '$q', 'digestService', 'TenantService', 'UserService', function($sce, $q, digestService, tenantService, userService){
        
        this.unchanged = () => this.editContent === this.digestCommentary.content;

        this.startEditing = () => {
            this.editContent = this.digestCommentary.content || '';
            this.editing = true;
        };

        this.save = () => {
            this.noTouching = true;
            this.digestCommentary.content = this.editContent;
            this.iframeNoTouching = true;
            tenantService.saveDigestCommentaries(this.tenant.digestCommentaries)
            .then(() => {
                this.previewUrl = $sce.trustAsResourceUrl(digestService.previewUrl(this.digestConfiguration.id, this.user.id, '?cachebreaker=' + new Date().getTime()));
                this.noTouching = false;
                this.editing = false;
            });
        };

        this.iframeLoaded = () => this.iframeNoTouching = false;            

        this.previewHeaderStyle = () => this.iframeNoTouching ? {'margin-bottom': '-50px'} : {};

        this.$onInit = () => tenantService.getCurrentTenant().then(response => {
            this.iframeNoTouching = true;
            this.tenant = response.data;
            if(!this.tenant.digestCommentaries){
                this.tenant.digestCommentaries = [{}];
            }
            this.digestCommentary = this.tenant.digestCommentaries[0];
            $q.all([
                userService.getCurrentUser(),
                digestService.resolveCurrentUserDigestConfiguration()
            ])
            .then(results => {
                this.user = results[0].data.user;
                this.digestConfiguration = results[1];
                this.previewUrl = $sce.trustAsResourceUrl(digestService.previewUrl(this.digestConfiguration.id, this.user.id));
            });
        });
    }]
});

'use strict';

angular.module('attensaApp')
    .component('breadCrumb', {
        bindings: {
            isCurrent: '<',
            select: '&'
        },
        transclude: 'true',
        template: [
            '<md-button ng-click="$ctrl.select()" class="breadcrumb" ng-class="{\'bold-font-weight\': $ctrl.isCurrent}"><ng-transclude></ng-transclude></md-button>'
        ].join('\n'),
        controller: [function(){
            var self = this;

            this.$onInit = function(){
                self.focusFirst = true;
            };
        }]
    });

'use strict';

angular.module('attensaApp')
.component('companyDetails', {
    bindings: {
        tenant: '=',
        showErrors: '<',
        invalidate: '&',
        next: '&'
    },
    template: `
        <form name="$ctrl.form" ng-submit="$ctrl.next()">
        <md-card layout-padding flex>
            <md-card-header>Step 2 of 3</md-card-header>
            <md-card-title>
                <div>
                    <h2>What do you want to name your Workspace?</h2>
                    <h5>Your Workspace is a private news and information hub for you and your team.</h5>
                </div>
            </md-card-title>
            <md-card-content>
                <div flex layout="row">
                    <md-input-container class="md-block" flex>
                        <label>Workspace Name</label>
                        <input name="companyName" 
                               focus-me="$ctrl.focusFirst" 
                               placeholder="Ex. Acme or Acme Sales - We'll use this to name your Attensa Workspace, which you can always change later"
                               ng-change="$ctrl.changed($ctrl.form.$valid)" 
                               ng-model="$ctrl.tenant.name"
                               ng-pattern="$ctrl.regex" 
                               required>
                        <div class="has-error" ng-messages="$ctrl.form.companyName.$error">
                            <div class="validation-warning" ng-message="required">Workspace Name is required</div>
                            <div class="validation-warning" ng-message="pattern">Workspace Name can be letters, numbers and dashes only</div>
                        </div>
                    </md-input-container>
                </div>
            </md-card-content>

            <md-card-actions layout="row" layout-align="center center">
                <md-button type="submit" class="md-raised md-primary" ng-disabled="$ctrl.form.$invalid">Next</md-button>
            </md-card-actions>
        </md-card>
        </form>
    `,
    controller: ['_', '$timeout', function(_, $timeout){
        var self = this;
        this.regex = '^[a-zA-Z0-9àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ/\'/ /&/.,()_-]+$';

        this.changed = function(valid){
            if(!valid){
                self.invalidate();
            }
        };

        this.$onChanges = function(){
            if(self.showErrors) {
                $timeout(function(){
                    if (self.form.$invalid) {
                        _.forEach(self.form.$error, function (field) {
                            _.forEach(field, function (errorField) {
                                errorField.$setTouched();
                            });
                        });
                    }
                });
            }
        };

        this.$onInit = function(){
            self.focusFirst = true;
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('completeCreateSite', {
    template: [
        '<div>',
            '<div layout="column" flex>',
                '<div layout="row" flex>',
                    '<spinner flex-offset="45" ng-if="$ctrl.noTouching"></spinner>',
                    '<div ng-if="!$ctrl.noTouching && $ctrl.currentTab === \'LOGIN_INFO\'" flex-offset="10" flex="80">',
                        '<user-details user="$ctrl.user" invalidate="$ctrl.invalidate(\'LOGIN_INFO\')" show-errors="$ctrl.showErrors" next="$ctrl.showTab(\'COMPANY_NAME\', \'LOGIN_INFO\')" flex></user-details>',
                    '</div>',
                    '<div ng-if="!$ctrl.noTouching && $ctrl.currentTab === \'COMPANY_NAME\'" flex-offset="10" flex="80">',
                        '<company-details tenant="$ctrl.tenant" invalidate="$ctrl.invalidate(\'COMPANY_NAME\')" show-errors="$ctrl.showErrors" next="$ctrl.showTab(\'SITE_DOMAIN\', \'COMPANY_NAME\')"></company-details>',
                    '</div>',
                    '<div ng-if="!$ctrl.noTouching && $ctrl.currentTab === \'SITE_DOMAIN\'" flex-offset="10" flex="80">',
                        '<tenancy-details tenant="$ctrl.tenant" invalidate="$ctrl.invalidate(\'SITE_DOMAIN\')" next="$ctrl.complete()"></tenancy-details>',
                    '</div>',
                    '<div ng-if="!$ctrl.noTouching && $ctrl.currentTab === \'LOGIN\'" flex-offset="10" flex="80">',
                        '<md-card layout-padding ng-form="form" flex>',
                            '<md-card-title layout-align="center center"><h2>Congratulations, you’ve created your Attensa Workspace.</h2></md-card-title>',
                            '<md-card-content>',
                                '<div>You can sign-in to it at <a href="https://{{$ctrl.tenant.hostName}}/client/login" target="_blank">https://{{$ctrl.tenant.hostName}}</a></div>',
                                '<div>If you forget, you can always go to https://attensa.com and choose Sign In To Your Workspace</div>',
                                '<div flex layout="row" layout-align="center center">',
                                    '<md-button class="md-primary" href="https://{{$ctrl.tenant.hostName}}/client/login">Go to your site</md-button>',
                                '</div>',
                            '</md-card-content>',
                        '</md-card>',
                    '</div>',
                '</div>',
            '</div>',
        '</div>',
    ].join('\n'),
    controller: ['_', '$state', '$mdToast', 'TenantService', 'UtilService',
        function(_, $state, $mdToast, tenantService, utilService) {
        var self = this;
        var validTabs = [];

        var toast = function(message){
            $mdToast.show($mdToast.simple().textContent(message).position('top right'));
        };

        this.invalidate = function(key){
            _.pull(validTabs, key);
        };

        this.showTab = function(tabName, validTab){
            self.currentTab = tabName;
            validTabs.push(validTab);
        };

        this.complete = function(){
            var errorTab;
            errorTab = validTabs.indexOf('COMPANY_NAME') === -1 ? 'COMPANY_NAME' : errorTab;
            errorTab = validTabs.indexOf('LOGIN_INFO') === -1 ? 'LOGIN_INFO' : errorTab;

            if(errorTab){
                toast('Please complete the items below.');
                self.currentTab = errorTab;
                self.showErrors = true;
                return;
            }

            self.noTouching = true;

            utilService.showModal([
                '<md-dialog flex="33">',
                    '<md-toolbar>',
                        '<div class="md-toolbar-tools">',
                            '<h2>Attensa Terms of Service</h2>',
                        '</div>',
                    '</md-toolbar>',
                    '<md-dialog-content layout-padding>',
                        '<p>',
                            'By clicking "I Agree", you understand and agree to the terms of service as ',
                            'decribed in our <a href="http://attensa.com/agreements/terms-conditions" target="_blank">Customer Terms of Service</a>.',
                        '</p>',
                    '</md-dialog-content>',
                    '<md-dialog-actions>',
                        '<md-button class="md-primary md-raised" ng-click="$ctrl.done()">I Agree</md-button>',
                        '<md-button ng-click="$ctrl.cancel()">Cancel</md-button>',
                    '</md-dialog-actions>',
                '</md-dialog>'
            ].join('\n'), { })
            .then(function(){
                self.tenant.hostName = self.tenant.subdomain + utilService.rootDomain;
                tenantService.createNewTenant($state.params.token, self.user, self.tenant)
                .then(function(){
                    self.noTouching = false;
                    self.currentTab = 'LOGIN';
                })
                .catch(function(){
                    self.noTouching = false;
                    toast('There was an error creating your site, please contact an administrator for help.');
                });
            })
            .catch(function(){
                self.noTouching = false;
            });
        };

        this.$onInit = function(){
            self.user = {};
            self.tenant = {};
            self.noTouching = true;

            if(!$state.params.token){
                $state.go('startCreateSite', { message: 'You must have a valid invitation to create a site.'});
                return;
            }

            tenantService.fetchToken($state.params.token)
            .then(function(token){
                self.user.emailAddress = token.data.emailAddress;
                self.noTouching = undefined;
                self.currentTab = 'LOGIN_INFO';
            })
            .catch(function(){
                $state.go('startCreateSite', { message: 'You must have a valid invitation to create a site.'});
            });
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('startCreateSite', {
    bindings: {
    },
    template: [
    '<div>',
        '<md-toolbar ng-if="!$ctrl.hideBar">',
            '<div class="md-toolbar-tools">',
                '<div flex="50">',
                    '<h4 flex>Create your new Attensa Site</h4>',
                '</div>',
            '</div>',
        '</md-toolbar>',
        '<div layout="column" flex>',
            '<div layout="row" flex>',
                '<spinner flex-offset="45" ng-if="$ctrl.noTouching"></spinner>',
               '<div ng-if="!$ctrl.noTouching && $ctrl.showConfirmation" flex-offset="10" flex="80">',
                    '<md-card layout-padding layout-align="center center">',
                        '<h4>We sent an email to {{$ctrl.emailAddress}} which will have a link to finish creating your site.</h4>',
                        '<h5>(if you don\'t see the message in a few minutes, check your spam folder)</h5>',
                    '</md-card>',
                '</div>',
                '<div ng-if="!$ctrl.noTouching && !$ctrl.showConfirmation" flex-offset="10" flex="80">',
                    '<form name="form" ng-submit="$ctrl.createAccount()" flex>',
                        '<md-card class="md-input-has-value" layout-padding flex>',
                            '<div layout="column" ng-form="form">',
                                '<md-input-container>',
                                '<label>Email Address</label>',
                                '<input type="email" name="emailAddress" placeholder="Email Address" ng-model="$ctrl.emailAddress" required>',
                                '<div ng-messages="form.emailAddress.$error">',
                                    '<small class="help-block" ng-message="required">Email Address is required and cannot be empty</small>',
                                '<small class="help-block" ng-message="email">Please enter a correct email address</small>',
                                '</div>',
                                '</md-input-container>',
                            '</div>',

                            '<md-card-actions layout="row" layout-align="center center">',
                                '<md-button type="submit" class="md-raised md-primary">Create Account</md-button>',
                            '</md-card-actions>',
                        '</md-card>',
                    '</form>',
                '</div>',
            '</div>',
        '</div>',
    '</div>',
    ].join('\n'),
    controller: ['$mdToast', '$state', 'TenantService', function($mdToast, $state, tenantService) {
        var self = this;

        var toast = function(message){
            $mdToast.show($mdToast.simple().textContent(message).position('top right'));
        };

        this.createAccount = function(){
            self.noTouching = true;
            tenantService.createTenantCreationRequest(self.emailAddress)
            .then(function(){
                self.noTouching = false;
                self.showConfirmation = true;
            })
            .catch(function(){
                self.noTouching = false;
                toast('Unable to change create your site request, please contact us.');
            });
        };

        this.$onInit = function(){
            if ($state.params.message) {
                toast($state.params.message);
            }
            self.hideBar = $state.current.data.hideBar;
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('tenancyDetails', {
    bindings: {
        tenant: '=',
        invalidate: '&',
        next: '&'
    },
    template: `
        <form name="form" ng-submit="$ctrl.next()">
            <md-card layout-padding flex>
                <md-card-header>Step 3 of 3</md-card-header>
                <md-card-title>
                    <div>
                        <h2>The web address for your Workspace</h2>
                        <h5>We used your Workspace name if it was available. If it isn't, there are suggestions below you can select or type in the name you choose.</h5>
                    </div>
                </md-card-title>
                <md-card-content>
                    <div flex="90" layout="row">
                        <md-input-container class="md-block md-icon-float md-icon-right" style="padding-right:90px;" flex>
                            <label>Workspace name</label>
                            <input name="subdomain" 
                                   ng-model="$ctrl.tenant.subdomain"
                                   ng-model-options="{ allowInvalid: true }"
                                   placeholder="letters, numbers, and dashes only"
                                   focus-me="$ctrl.focusFirst" 
                                   ng-change="$ctrl.changed(form.$valid)" 
                                   unique-tenant-host ng-pattern="$ctrl.regex" 
                                   required>
                            <md-icon style="width: 80px; font-weight: bold;">{{$ctrl.rootDomain}}</md-icon>
                            <div class="has-error" ng-messages="form.subdomain.$error">
                                <div class="validation-warning" ng-message="required">Workspace web address is required</div>
                                <div class="validation-warning" ng-message="pattern">Workspace web address can be letters, numbers and dashes only</div>
                                <div class="validation-warning" ng-message="uniqueHost">
                                    That Workspace name is already taken. You can log in to {{$ctrl.tenant.subdomain}}{{$ctrl.rootDomain}} <a ng-href="{{'https://' + $ctrl.tenant.subdomain$ctrl.rootDomain + '/client/login'}}">here</a>
                                </div>
                            </div>
                        </md-input-container>
                    </div>
                    <div>
                        <p ng-if="!$ctrl.showOriginal">
                        {{$ctrl.baseName}} is already taken, how about: <a ng-click="$ctrl.setHost($ctrl.alt1Name)">{{$ctrl.alt1Name}}</a>
                        or <a ng-click="$ctrl.setHost($ctrl.alt2Name)">{{$ctrl.alt2Name}}</a>.
                        Or you can log in to {{$ctrl.originalName}}{{$ctrl.rootDomain}} <a ng-href="http://{{$ctrl.originalName}}{{$ctrl.rootDomain}}/client/login">here</a>
                        </p>
                    </div>
                </md-card-content>

                <md-card-actions layout="row" layout-align="center center">
                    <md-button type="submit" class="md-raised md-primary" ng-disabled="form.$invalid">Next</md-button>
                </md-card-actions>
            </md-card>
        </form>
    `,
    controller: ['TenantService', 'UtilService', function(tenantService, utilService){
        var self = this;
        this.regex = '^[a-zA-Z0-9-]+$';
        this.rootDomain = '.attensa.net';//utilService.rootDomain;

        this.changed = function(valid){
            if(!valid){
                self.invalidate();
            }
        };

        this.setHost = function(host){
            console.log('setting host');
            self.tenant.subdomain = host;
        };

        this.$onInit = function(){
            self.focusFirst = true;
            var name = self.tenant && self.tenant.name ? self.tenant.name.replace(/\W/g, '') : '';

            self.baseName = (name + '').toLowerCase();
            self.alt1Name = (name + 'space').toLowerCase();
            self.alt2Name = (name + '-space').toLowerCase();

            self.originalName = self.baseName;
            tenantService.tenantHostExists((self.baseName + self.rootDomain).toLowerCase())
            .then(function(tenantName){
                self.showOriginal = !tenantName.exists;
                if(self.showOriginal){
                    self.tenant.subdomain = self.tenant.subdomain || self.baseName;
                }else {
                    self.tenant.subdomain = self.tenant.subdomain || self.alt1Name;
                }
            });
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('userDetails', {
    bindings: {
        user: '=',
        showErrors: '<',
        invalidate: '&',
        next: '&'
    },
    template: `
        <form name="$ctrl.form" ng-submit="$ctrl.next()" flex>
        <md-card layout-padding flex>
            <md-card-header>Step 1 of 3</md-card-header>
            <md-card-title><h2>Create your account</h2></md-card-title>
            <md-card-content>
                <div flex layout="row">
                    <md-input-container class="md-block" flex="50">
                        <label>First Name</label>
                        <input name="firstName" focus-me="$ctrl.focusFirst" ng-model="$ctrl.user.firstName" md-autofocus required ng-change="$ctrl.changed($ctrl.form.$valid)">
                        <div class="has-error" ng-messages="$ctrl.form.firstName.$error">
                            <div class="validation-warning" ng-message="required">First Name is required</div>
                        </div>
                    </md-input-container>

                    <md-input-container class="md-block" flex="50">
                        <label>Last Name</label>
                        <input name="lastName" ng-model="$ctrl.user.lastName" required ng-change="$ctrl.changed($ctrl.form.$valid)">
                        <div class="has-error" ng-messages="$ctrl.form.lastName.$error">
                            <div class="validation-warning" ng-message="required">Last Name is required</div>
                        </div>
                    </md-input-container>
                </div>
                <div flex layout="row">
                    <md-input-container class="md-block" flex="50">
                        <label>Password</label>
                        <input type="password" 
                               autocomplete="new-password" 
                               id="newPassword" 
                               name="newPassword" 
                               minlength="8" 
                               ng-model="$ctrl.user.password"
                               placeholder="At least eight characters, one capital and one number."
                               validate-password="$ctrl.user.confirmPassword" required ng-change="$ctrl.passwordChanged($ctrl.form.$valid)">
                        <div class="has-error" ng-messages="$ctrl.form.newPassword.$error">
                            <div class="validation-warning" ng-message="required">Password is required</div>
                            <div class="validation-warning" ng-message="minlength">Your password must be longer than 8 characters</div>
                            <div class="validation-warning" ng-message="passwordCharacters">Your password must have at least one number, one uppercase, and one lowercase letter</div>
                        </div>
                    </md-input-container>

                    <md-input-container class="md-block" flex="50">
                        <label hide-xs>Confirm Password</label>
                        <label hide-gt-xs>Confirm</label>
                        <input type="password" 
                               autocomplete="off" 
                               id="confirmPassword" 
                               name="confirmPassword" 
                               ng-model="$ctrl.user.confirmPassword" 
                               match-to-validator required ng-change="$ctrl.changed($ctrl.form.$valid)">
                        <div class="has-error" ng-messages="$ctrl.form.confirmPassword.$error">
                            <div class="validation-warning" ng-message="required">Please fill both passwords</div>
                            <div class="validation-warning" ng-message="match">The passwords do not match</div>
                        </div>
                    </md-input-container>
                </div>

            </md-card-content>

            <md-card-actions layout="row" layout-align="center center">
                <md-button type="submit" class="md-raised md-primary" ng-disabled="$ctrl.form.$invalid">Next</md-button>
            </md-card-actions>
        </md-card>
        </form>
    `,
    controller: ['_', '$timeout', function(_, $timeout){

        this.passwordChanged = (valid) => {
            this.form.confirmPassword.$setTouched();          
            this.changed(valid);
        };

        this.changed = (valid) => {
            if(!valid){
                this.invalidate();
            }
        };

        this.$onChanges = () => {
            if(this.showErrors) {
                $timeout(() => {
                    if (this.form.$invalid) {
                        _.forEach(this.form.$error, (field) => _.forEach(field, (errorField) => errorField.$setTouched()));
                    }
                });
            }
        };

        this.$onInit = () => this.focusFirst = true;
    }]
});

'use strict';

angular.module('attensaApp')
    .component('groupStreamFollowers', {
        bindings: {
            stream: '<'
        },
        template: `
            <a ng-click="$ctrl.openFollowersModal($ctrl.stream)">
                <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Followers">
                    <span id="followersCount-{{::stream.id}}">{{$ctrl.stream.followersCount}}</span>
                </span>
            </a>
        `,
        controller: ['StreamService', function(streamService) {  
            this.openFollowersModal = streamService.openFollowersModal;                
        }]
    });
'use strict';

angular.module('attensaApp')
    .component('streamName', {
        bindings: {
            stream: '<'
        },
        template: `
        <div>
            <h4 class="media-heading">
                <div class="ellipsis-color">
                    <a class="overflow-ellipsis" ng-click="$ctrl.viewStreamDetails($ctrl.stream)">
                        <span class="stream-title overflow-ellipsis">
                            <span title="{{$ctrl.stream.title}}">{{$ctrl.stream.title}}</span>
                        </span>
                    </a>
                </div>
            </h4>
            <p title="{{::$ctrl.stream.description}}" class="catalog-tile-description" style="height: 17px;">{{::$ctrl.stream.description}}</p>
        </div>
        `,
        controller: ['ItemService','StreamService',
            function(itemService, streamService) {
                this.viewStreamDetails = stream => streamService.openStreamDetailModal(stream).result
                .then(item => {
                    if(item){
                        itemService.openNewModal({
                            itemId: item.id,
                            hasPrevious: false,
                            hasNext: false,
                            streamContext: stream.id
                        });
                    } 
                });
        }]
    });
'use strict';

angular.module('attensaApp')
.component('launchpad', {
    template: `
    <div layout="column" layout-align="center center">
        <div layout="row">
            <h2>Launch Pad</h2>
        </div>
        <div layout="row" layout-fill layout-align="center">
            <div layout="column" flex="15">
                <button class="btn btn-lg btn-primary" style="margin: 25px 0; height: 70px;" ui-sref="seedTopic">Create Topic</button>
            </div>
        </div>
        <div layout="row" layout-fill>
            <div layout="column" flex="15" flex-offset="30">
                <div layout="row" layout-align="center center">
                    <h2>Do</h2>
                </div>
                <button class="btn btn-lg btn-primary" style="margin: 25px 0; height: 70px;" ui-sref="streamCreate">Add Sources</button>
                <button class="btn btn-lg btn-primary" style="margin: 25px 0; height: 70px;" ui-sref="briefings.list">Set up a briefing</button>
                <button class="btn btn-lg btn-primary" style="margin: 25px 0; height: 70px;" ui-sref="managePeople">Add or invite people</button>
                <button class="btn btn-lg btn-primary" style="margin: 25px 0; height: 70px;" ui-sref="opml">Import an OPML file</button>
                <button class="btn btn-lg btn-primary" style="margin: 25px 0; height: 70px;" ui-sref="manageCategories">Manage categories</button>
            </div>
            <div layout="column" flex="15" flex-offset="10">
                <div layout="row" layout-align="center center">
                    <h2>Learn</h2>
                </div>
                <iframe flex seamless="seamless" frameborder="0" src="//attensa.com/default-panel/" scrolling="no"></iframe>
            </div>
        </div>
    </div>
    `,
});

'use strict';

angular.module('attensaApp')
.component('tagCloud', {
    bindings: {
        header: '@',
        tags: '<',  // A bluebird promise that resolves to an aggregations tag array
        onTagClick: '&'
    },
    controller: ['_', 'Promise', function(_, Promise) {
        var self = this;

        this.tagFontSize = function(tag) {
            return (tag.doc_count / self.tagCountBasis * 2 + 0.75) + 'em';
        };

        this.$onChanges = function(){
            Promise.resolve(self.tags)
            .then(function(tags) {
                self.topicsTags = _.chain(tags)
                .flatten()
                .uniq('key')
                .sortBy(function(tag) { return _.capitalize(tag.key); })
                .value();

                self.tagCountBasis = _.max(self.topicsTags, 'doc_count').doc_count;
            });
        };
    }],
    template: [
        '<h4>{{$ctrl.header}}: <i ng-if="$ctrl.tags.isPending()"><i  class="fa fa-spin fa-spinner"></i></i></h4>',
        '<ul style="padding-left: 0px;">',
            '<li ng-repeat="tag in $ctrl.topicsTags" style="display: inline">',
                '<a ng-click="$ctrl.onTagClick({ tag: tag})" ng-style="{\'font-size\': $ctrl.tagFontSize(tag)}">{{::tag.key}}</a>',
                '<small class="text-muted">({{tag.doc_count}})</small>',
            '</li>',
        '</ul>'
    ].join('\n'),
});

'use strict';

angular.module('attensaApp')
    .component('publishToggle', {
        bindings: {
            stream: '=',
            hasManageStreamPermission: '<'
        },
        controller: ['StreamService', function(streamService) {
            this.togglePublish = () => { streamService.updateStream(this.stream); };
        }],
        template: `
            <span ng-if="!$ctrl.hasManageStreamPermission && $ctrl.stream.published" class="fa fa-check catalog-stream-published" title="Published"></span>
            <switch ng-if="$ctrl.hasManageStreamPermission"
                    tooltip-placement="top" 
                    tooltip-popup-delay="500" 
                    tooltip-append-to-body="true" 
                    uib-tooltip="{{ $ctrl.stream.published ? 'Click to Unpublish' : 'Click to Publish' }}" 
                    ng-model="$ctrl.stream.published"
                    ng-change="$ctrl.togglePublish()"
                    class="small"
                    on="On" off="Off"></switch>
        `
    });

'use strict';

angular.module('attensaApp')
    .component('manageAccount', {
        template: `
        <div class="container">
            <div class="page-header" style="margin-top: 15px;">
                <h3 style="color:#777777;margin: 0 0 5px;">Account Settings</h3>
            </div>
            <spinner ng-if="$ctrl.noTouching"></spinner>
            <form name="$ctrl.form" ng-submit="$ctrl.saveSettings()" ng-if="!$ctrl.noTouching">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label for="tenantName">Account Name</label>
                            <input class="form-control" placeholder="Account Name" type="text" ng-model="$ctrl.tenant.name" readonly>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label for="tenantHostname">Host Name</label>
                            <input class="form-control" placeholder="Host Name" type="text" ng-model="$ctrl.tenant.hostName" readonly>
                        </div>
                    </div>
                </div>
                <div>
                    <h4 style="color:#777777">Settings</h3>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Briefings From Address</label>
                            <input  class="form-control" 
                                    name="briefingsFromAddress"
                                    placeholder="Briefings From Address" 
                                    type="email" 
                                    ng-model="$ctrl.tenant.settings.briefingsFromAddress" 
                                    required>
                            <div class="has-error" ng-messages="$ctrl.form.briefingsFromAddress.$error">
                                <small class="help-block" ng-message="required">Briefings From Address is required and cannot be empty</small>
                                <small class="help-block" ng-message="email">Please enter a correct email address</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Briefings Reply To Address</label>
                            <input  class="form-control" 
                                    name="briefingsReplyToAddress"
                                    placeholder="Briefings Reply To Address" 
                                    type="email" 
                                    ng-model="$ctrl.tenant.settings.briefingsReplyToAddress"
                                    required>
                            <div class="has-error" ng-messages="$ctrl.form.briefingsReplyToAddress.$error">
                                <small class="help-block" ng-message="required">Briefings Reply To Address is required and cannot be empty</small>
                                <small class="help-block" ng-message="email">Please enter a correct email address</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row" ng-if="$ctrl.showFeedbackLink">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Feedback Link Title</label>
                            <input  class="form-control" 
                                    name="feedbackLinkTitle"
                                    placeholder="Feedback Link Title" 
                                    type="text" 
                                    ng-model="$ctrl.tenant.settings.feedbackLinkTitle"
                                    ng-required="$ctrl.tenant.settings.feedbackLinkUrl.length">
                            <div class="has-error" ng-messages="$ctrl.form.feedbackLinkTitle.$error">
                                <small class="help-block" ng-message="required">Feedback Link Title is required if you have a Feedback Link Url</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row" ng-if="$ctrl.showFeedbackLink">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Feedback Link Url</label>
                            <input  class="form-control" 
                                    name="feedbackLinkUrl"
                                    placeholder="Feedback Link Url" 
                                    type="url" 
                                    ng-model="$ctrl.tenant.settings.feedbackLinkUrl">
                            <div class="has-error" ng-messages="$ctrl.form.feedbackLinkUrl.$error">
                                <small class="help-block" ng-message="url">Feedback Link Url must be a valid URL (i.e. http://www.attensa.com)</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Logo Url</label>
                            <input  class="form-control" 
                                    name="logoUrl"
                                    placeholder="Logo Url" 
                                    type="url" 
                                    ng-model="$ctrl.tenant.settings.logoUrl">
                            <div class="has-error" ng-messages="$ctrl.form.logoUrl.$error">
                                <small class="help-block" ng-message="url">Logo Url must be a valid URL (i.e. http://www.attensa.com/logo.jpg)</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Favicon Url</label>
                            <input  class="form-control" 
                                    name="faviconUrl"
                                    placeholder="Favicon Url" 
                                    type="url" 
                                    ng-model="$ctrl.tenant.settings.faviconUrl">
                            <div class="has-error" ng-messages="$ctrl.form.faviconUrl.$error">
                                <small class="help-block" ng-message="url">Favicon Url must be a valid URL (i.e. http://www.attensa.com/logo.jpg)</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>Application Title</label>
                            <input  class="form-control" 
                                    name="title"
                                    placeholder="Application Title" 
                                    type="text" 
                                    ng-model="$ctrl.tenant.settings.title">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>New User Added Notification Address</label>
                            <input class="form-control"
                                   name="newUserNotification"
                                   placeholder="New Users Notification email address"                                    
                                   type="email"
                                   ng-model="$ctrl.tenant.settings.newUserNotification">
                            <div class="has-error" ng-messages="$ctrl.form.newUserNotification.$error">
                                <small class="help-block" ng-message="email">Please enter a correct email address</small>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            
            <div class="row" ng-if="!$ctrl.noTouching">
                <div class="col-lg-12">
                    <button type="submit" 
                            id="save-account-settings" 
                            data-loading-text="Saving..."
                            class="btn btn-primary" 
                            ng-click="$ctrl.saveSettings()" 
                            ng-disabled="$ctrl.form.$invalid || $ctrl.form.$pristine">Save
                    </button>
                </div>
            </div>
        </div>
        `,
        controller: ['_', 'TenantService', function(_, tenantService) {
            var self = this;

            this.isEmpty = _.isEmpty;

            this.saveSettings = function(){
                self.noTouching = true;
                tenantService.saveSettings(self.tenant.settings)
                .then(function(tenant){
                    self.showFeedbackLink = self.tenant &&
                                            self.tenant.settings &&
                                            self.tenant.settings.feedbackLinkUrl &&
                                            self.tenant.settings.feedbackLinkUrl.length;
                    self.noTouching = false;
                    self.tenant = tenant;
                });
            };

            this.$onInit = function(){
                self.noTouching = true;
                tenantService.getCurrentTenant()
                .then(function(tenant){
                    self.noTouching = false;
                    self.tenant = tenant.data;
                });
            };
        }]
    });

'use strict';

angular.module('attensaApp')
    .component('createTopicFromSearchButton', {
        bindings: {
            term: '<',
            tags: '<',
            spin: '&'
        },
        controller: ['$rootScope', '$scope', '$uibModal', '$state', '$q', 'growl', '_', 'FilterService', 'StreamService', 'UtilService',
            function($rootScope, $scope, $uibModal, $state, $q, growl, _, FilterService, StreamService, UtilService) {
                
                $scope.$on('mytopics-stream-ids-fetched', (evt, streamIds) => {
                    this.fetching = false;

                    var modalScope = $scope.$new();
                    modalScope.title = UtilService.cleanQuotes(this.term);

                    this.spin({shouldSpin: true});
                    $uibModal.open({
                        templateUrl: '/templates/topicNameModal.html',
                        size: 'md',
                        keyboard: true,
                        scope: modalScope
                    }).result
                    .then(name => StreamService.saveStream({
                            title: name,
                            type: 'COLLECTION',
                            openForReading: true,
                            published: false,
                            subStreams: streamIds.map(streamId => ({ targetStreamId: streamId, ownerStreamId: null}))
                        })
                        .then(resp => resp.data)
                        .catch(() => {
                            this.spin({shouldSpin: false});
                            growl.error('Unable to create topic.');
                        })
                    )
                    .then(stream => {
                        const filter = {
                            isBasic: true,
                            filterTerm: UtilService.cleanQuotes(this.term),
                            basicFilterText: UtilService.cleanQuotes(this.term)
                        };
                        
                        _.map(this.tags.entities.concat(this.tags.socialTag).concat(this.tags.topics).concat(this.tags.keywords).concat(this.tags.concepts), tag => {
                            tag.key = tag.tagText;
                            return tag;
                        })
                        .forEach(tag => StreamService.addTagFilter(filter, tag));

                        filter.filterTerm = FilterService.filterTermFromBasicStructure(UtilService.cleanQuotes(this.term), filter.basicFilterStructures || []);
                        
                        return $q.all([
                            stream,
                            StreamService.postFilter(stream.id, filter)
                        ]);
                    })
                    .then(results => {
                        this.spin({shouldSpin: false});
                        this.noTouching = false;
                        return $state.go('editTopic.filters', { streamId: results[0].id });
                    });
                });

                this.startCreate = () => {
                    this.fetching = true;
                    $rootScope.$broadcast('mytopics-stream-ids-fetch');
                };

                const hasTags = tagCollection => this.tags && this.tags[tagCollection] && this.tags[tagCollection].length;

                this.isEnabled = () => !_.isEmpty(this.term) || hasTags('entities') || hasTags('socialTag') || hasTags('topics') || hasTags('keywords')  || hasTags('concepts');
            }],
        template: `
            <spinner-button ng-if="$ctrl.isEnabled()" ng-click="$ctrl.startCreate()" spin-on="$ctrl.fetching" text="Create Topic From Search" type="button"></spinner-button>
        `
    });

'use strict';

angular.module('attensaApp')
.component('briefingPreview', {
    bindings: {
        briefingId: '<'
    },
    template: [
        '<div flex layout="column">',
            '<div flex ng-if="$ctrl.previewLoading">',
                '<spinner flex-offset="45" ></spinner>',
            '</div>',
            '<div flex ng-show="!$ctrl.previewLoading">',
                '<iframe ng-onload="$ctrl.loaded()" width="100%" height="500" seamless="seamless" ng-src="{{$ctrl.briefingPreviewUrl}}" frameBorder="0"></iframe>',
            '</div>',
        '</div>',
    ].join('\n'),
    controller: ['$rootScope', '$sce', function($rootScope, $sce){
        var self = this;

        this.loaded = function(){
            self.previewLoading = undefined;
            $rootScope.$apply(); //ng-onload you got me close but not quite there
        };

        this.$onChanges = function(){
            self.previewLoading = true;
            self.briefingPreviewUrl = $sce.trustAsResourceUrl('/ws/ua/briefings/' + self.briefingId + '/preview');
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingsSection', {
    bindings: {
        user: '<',
        subscribeToBriefing: '<',
        briefingSubscribed: '&'
    },
    template: [
    '<md-card flex ng-form="form" layout="column" layout-padding ng-if="!$ctrl.noTouching && ($ctrl.user || $ctrl.publicBriefings)">',
        '<md-card-header layout="row" ng-if="$ctrl.user && $ctrl.briefings.length > 1">',
            '<div flex="50">{{$ctrl.subscribedOnly ? \'Subscribed\' : \'All\'}} Briefings</div>',
            '<div flex="50" layout="row" layout-align="end center">',
                '<a ng-if="$ctrl.subscribedOnly" ng-click="$ctrl.toggleView()">All</a>',
                '<span ng-if="!$ctrl.subscribedOnly">All</span>',
                '<span>&nbsp;/&nbsp;</span>',
                '<a ng-if="!$ctrl.subscribedOnly" ng-click="$ctrl.toggleView()">Subscribed</a>',
                '<span ng-if="$ctrl.subscribedOnly">Subscribed</span>',
            '</div>',
        '</md-card-header>',
        '<md-card-contents>',
            '<md-list>',
                '<md-divider ng-if="$ctrl.briefings.length > 0 && $ctrl.user"></md-divider>',
                '<md-list-item ng-if="$ctrl.briefings.length === 0"><h4 flex flex-offset="40">No Briefings Available</h4></md-list-item>',
                '<md-list-item ng-click="" class="noright" ng-repeat-start="briefing in $ctrl.briefings | filter:$ctrl.filterBriefings">',
                    '<div flex layout="column">',
                        '<a ng-click="$ctrl.togglePreview(briefing.id)">',
                        '<h4>{{ briefing.briefingTitle | limitTo : 100}}</h4>',
                        '<p>{{ briefing.description | limitTo : 500}}</p>',
                        '</a>',
                    '</div>',
                    '<md-button class="md-raised" ng-if="$ctrl.user" ui-sref="briefingInvite({ briefingId: briefing.id })"><span style="text-transform: none;">Share</span></md-button>',
                    '<md-briefing-subscribe-button briefing="briefing" user="$ctrl.user" subscribed="$ctrl.subscribedBriefings[briefing.id]" subscription-changed="$ctrl.subscriptionsChanged()"></md-briefing-subscribe-button>',
                '</md-list-item>',
                '<md-list-item ng-if="$ctrl.previewId === briefing.id">',
                    '<briefing-preview flex briefing-id="briefing.id"></briefing-preview>',
                '</md-list-item>',
                '<md-divider ng-repeat-end></md-divider>',
            '</md-list>',
        '</md-card-contents>',
    '</md-card>'
    ].join('\n'),
    controller: ['_', '$q', '$mdToast', 'BriefingService', 'TemplateService', 'TenantService', 'UserService',
        function(_, $q, $mdToast, briefingService, templateService, tenantService, userService) {
            var self = this;

            this.toggleView = function(){
              self.subscribedOnly = !self.subscribedOnly;
            };

            this.togglePreview = function(briefingId){
                self.previewId = self.previewId === briefingId ? undefined : briefingId;
            };

            this.filterBriefings = function(briefing){
                if(self.subscribedOnly) {
                    return _.reduce(self.user.subscriptions, function(summary, subscription){
                        return summary || subscription.briefingId === briefing.id;
                    }, false);
                }else{
                    return true;
                }
            };

            this.subscriptionsChanged = function(){
                briefingService.getCurrentUserBriefings()
                .then(function(briefingsResponse){
                    self.subscribedBriefings = _.indexBy(briefingsResponse.content, 'id');
                });
            };

            var fetchCurrentUserBriefings = function(){
                return briefingService.getCurrentUserBriefings()
                .then(function(userBriefingsResponse){
                    self.subscribedBriefings = _.indexBy(userBriefingsResponse.content, 'id');
                });
            };

            this.$onChanges = function() {
                var briefing = _.find(self.briefings, {id: self.subscribeToBriefing});
                if(self.user && self.subscribeToBriefing && briefing &&
                    self.subscribeToBriefing !== self.subscribeToBriefingProcessed){

                    userService.subscribeToBriefing(self.user, briefing.id, briefing.streamId)
                    .then(fetchCurrentUserBriefings)
                    .then(self.briefingSubscribed)
                    .finally(function () {
                        self.subscribeToBriefingProcessed = self.subscribeToBriefing;
                    })
                    .catch(function () {
                        $mdToast.show($mdToast.simple().textContent('Saved').position('top right'));
                    });
                } else if(self.user && !self.subscribedBriefings){
                    fetchCurrentUserBriefings();
                }
            };

            this.$onInit = function(){
                return $q.all([
                    briefingService.getUnauthBriefings({ published: true, rows: 1000 }),
                    templateService.getAllUnauth(),
                    tenantService.getUnauthTenantInfo()
                ])
                .then(function(responses){
                    self.briefings = responses[0].content;
                    self.templateMap = _.indexBy(responses[1], 'id');
                    self.publicBriefings = responses[2].data.settings.publicBriefings === 'true';
                    if(self.briefings && self.briefings.length === 1){
                        self.togglePreview(self.briefings[0].id);
                    }
                    self.$onChanges();
                });
            };
        }]
});

'use strict';

angular.module('attensaApp')
.component('changePassword', {
    bindings: {
        title: '<',
        cancel: '&',
        done: '&'
    },
    template: [
        '<md-toolbar>',
            '<div class="md-toolbar-tools">',
                '<h2>{{$ctrl.title}}</h2>',
            '</div>',
        '</md-toolbar>',
        '<div class="page">',
            '<form name="form">',
            '<md-dialog-content layout-padding>',
                '<div flex layout="row">',
                    '<md-input-container flex="50">',
                        '<label hide-xs>Change Password</label>',
                        '<label hide-gt-xs>Password</label>',
                        '<input md-auto-focus ',
                        '       type="password" ',
                        '       autocomplete="off" ',
                        '       id="password" ',
                        '       name="password" ',
                        '       minlength="8" ',
                        '       placeholder="New Password" ',
                        '       ng-model="$ctrl.password" ',
                        '       validate-password="$ctrl.confirmPassword"',
                        '       ng-keyup="$event.keyCode == 13 && form.$valid && $ctrl.done({result: $ctrl.password})">',
                        '<div class="has-error" ng-messages="form.password.$error">',
                            '<div class="validation-warning" ng-message="minlength">Your password must be longer than 8 characters</div>',
                            '<div class="validation-warning" ng-message="passwordCharacters">Your password must have at least one number, one uppercase, and one lowercase letter</div>',
                        '</div>',
                    '</md-input-container>',

                    '<md-input-container flex="50">',
                        '<label hide-xs>Confirm Password</label>',
                        '<label hide-gt-xs>Confirm</label>',
                        '<input type="password" ',
                        '       autocomplete="off" ',
                        '       id="confirmPassword" ',
                        '       name="confirmPassword" ',
                        '       placeholder="Confirm Password" ',
                        '       ng-model="$ctrl.confirmPassword" ',
                        '       match-to-validator',
                        '       ng-keyup="$event.keyCode == 13 && form.$valid && $ctrl.done({result: $ctrl.password})">',
                        '<div class="has-error" ng-messages="form.confirmPassword.$error">',
                            '<div class="validation-warning" ng-message="requiring">Please fill both passwords</div>',
                            '<div class="validation-warning" ng-message="match">The passwords do not match</div>',
                        '</div>',
                    '</md-input-container>',
                '</div>',
                '</md-dialog-content>',
            '</form>',
        '</div>',
        '<md-dialog-actions>',
            '<md-button class="md-primary" ng-disabled="form.$invalid" ng-click="$ctrl.done({result: $ctrl.password})">Save</md-button>',
            '<md-button ng-click="$ctrl.cancel()">Cancel</md-button>',
        '</md-dialog-actions>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('completeSignup', {
    bindings: {
        user: '=',
        cancel: '&',
        done: '&'
    },
    template: [
        '<md-toolbar>',
            '<div class="md-toolbar-tools">',
                '<h2>Create Account</h2>',
            '</div>',
        '</md-toolbar>',
        '<div class="page">',
            '<form name="form">',
                '<md-dialog-content layout-padding>',
                    '<div flex layout="column">',

                        '<div flex layout="row">',
                            '<md-input-container flex="50">',
                                '<label>Email Address</label>',
                                '<input ng-readonly="true" id="emailAddress" name="emailAddress" placeholder="Email Address" ng-model="$ctrl.user.emailAddress">',
                            '</md-input-container>',
                        '</div>',

                        '<div flex layout="row">',
                            '<md-input-container flex="50">',
                                '<label>First Name</label>',
                                '<input md-auto-focus id="firstName" name="firstName" placeholder="First Name" ng-model="$ctrl.user.firstName" required>',
                                '<div class="has-error" ng-messages="form.firstName.$error">',
                                    '<div class="validation-warning" ng-message="required">First Name is required for signup</div>',
                                '</div>',
                            '</md-input-container>',

                            '<md-input-container flex="50">',
                                '<label>Last Name</label>',
                                '<input id="lastName" name="lastName" placeholder="Last Name" ng-model="$ctrl.user.lastName" required>',
                                '<div class="has-error" ng-messages="form.lastName.$error">',
                                    '<div class="validation-warning" ng-message="required">Last Name is required for signup</div>',
                                '</div>',
                            '</md-input-container>',

                        '</div>',

                    '<div flex layout="row">',
                        '<md-input-container flex="50">',
                            '<label>Password</label>',
                            '<input type="password" autocomplete="off" id="password" name="password" minlength="8" placeholder="New Password" ng-model="$ctrl.user.password" validate-password="$ctrl.user.confirmPassword">',
                            '<div class="has-error" ng-messages="form.password.$error">',
                                '<div class="validation-warning" ng-message="minlength">Your password must be longer than 8 characters</div>',
                                '<div class="validation-warning" ng-message="passwordCharacters">Your password must have at least one number, one uppercase, and one lowercase letter</div>',
                            '</div>',
                        '</md-input-container>',

                        '<md-input-container flex="50">',
                            '<label hide-xs>Confirm Password</label>',
                            '<label hide-gt-xs>Confirm</label>',
                            '<input type="password" ',
                            '       autocomplete="off" ',
                            '       id="confirmPassword" ',
                            '       name="confirmPassword" ',
                            '       placeholder="Confirm Password" ',
                            '       ng-model="$ctrl.user.confirmPassword" ',
                            '       match-to-validator',
                            '       ng-keyup="$event.keyCode == 13 && form.$valid && $ctrl.activateUser()">',
                            '<div class="has-error" ng-messages="form.confirmPassword.$error">',
                                '<div class="validation-warning" ng-message="requiring">Please fill both passwords</div>',
                                '<div class="validation-warning" ng-message="match">The passwords do not match</div>',
                            '</div>',
                        '</md-input-container>',
                    '</div>',

                    '</div>',
                '</md-dialog-content>',
            '</form>',
        '</div>',
        '<md-dialog-actions>',
            '<md-button class="md-primary" ng-disabled="form.$invalid" ng-click="$ctrl.activateUser()">Save</md-button>',
            '<md-button ng-click="$ctrl.cancel()">Cancel</md-button>',
        '</md-dialog-actions>'
    ].join('\n'),
    controller: ['$mdToast', 'UserService', function($mdToast, userService){
        var self = this;

        this.activateUser = function(){
            return userService.activateUser(self.user)
            .then(function(user) {
                self.done({result: user});
            })
            .catch(function() {
                $mdToast.show($mdToast.simple().textContent('An error occurred activating your account.  Please contact your system administrator.').position('top right'));
            });
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('forgotPassword', {
    bindings: {
        cancel: '&',
        done: '&'
    },
    template: [
        '<md-toolbar>',
            '<div class="md-toolbar-tools">',
                '<h2>Forgot Password</h2>',
            '</div>',
        '</md-toolbar>',
        '<div class="page">',
            '<form name="form">',
                '<md-dialog-content layout-padding>',
                    '<div flex layout="column">',
                        '<md-input-container flex="50">',
                            '<label>Email Address</label>',
                            '<input md-auto-focus ',
                            '       ng-change="$ctrl.clearBadEmailMessage()" ',
                            '       autocomplete="off" ',
                            '       id="emailAddress" ',
                            '       name="emailAddress" ',
                            '       placeholder="Email Address" ',
                            '       ng-model="$ctrl.emailAddress" ',
                            '       required',
                            '       ng-keyup="$event.keyCode == 13 && form.$valid && $ctrl.resetPassword()">',
                            '<div class="has-error" ng-messages="form.emailAddress.$error">',
                                '<div class="validation-warning" ng-message="required">Email Address is required</div>',
                            '</div>',
                            '<div class="md-input-messages md-input-messages-animation ng-active">',
                                '<div ng-show="$ctrl.badEmailMessage">{{$ctrl.badEmailMessage}}</div>',
                            '</div>',
                        '</md-input-container>',
                    '</div>',
                '</md-dialog-content>',
            '</form>',
        '</div>',
        '<md-dialog-actions>',
            '<md-button class="md-primary" ng-disabled="form.$invalid" ng-click="$ctrl.resetPassword()">Reset Password</md-button>',
            '<md-button ng-click="$ctrl.cancel()">Cancel</md-button>',
        '</md-dialog-actions>'
    ].join('\n'),
    controller: ['$mdToast', 'UserService', function($mdToast, userService){
        var self = this;

        var messageForError = function(err){
            if (err.status === 404) {
                return 'Email address does not exist';
            } else if (err.status === 403) {
                return 'Your account is not yet active.  Please contact your administrator.';
            } else {
                return 'An unexpected error occurred.';
            }
        };

        this.clearBadEmailMessage = function(){
            self.badEmailMessage = null;
            console.log(self.badEmailMessage);
        };

        this.resetPassword = function(){
            self.badEmailMessage = undefined;
            userService.forgotPassword({email: self.emailAddress, returnPath: 'preferences'})
            .then(function() {
                $mdToast.show($mdToast.simple().textContent('Reset password email has been sent successfully.').position('top right'));
                self.done();
            })
            .catch(function(err) {
                self.badEmailMessage = messageForError(err);
            });
        };
    }]
});

'use strict';

angular.module('attensaApp')
    .component('loginControl', {
        bindings: {
            cancel: '&',
            done: '&'
        },
        template: [
            '<md-toolbar>',
            '<div class="md-toolbar-tools">',
                '<h2>Log In</h2>',
                '</div>',
            '</md-toolbar>',
            '<div class="page">',
                '<form name="form">',
                    '<md-dialog-content layout-padding>',
                        '<div flex layout="column">',
                            '<md-input-container ng-if="$ctrl.invalidLogin"',
                                                'class="ng-invalid ng-invalid-required md-input-invalid">',
                                '<div class="md-input-messages md-input-messages-animation ng-active">',
                                    '<div>Invalid username / password pair</div>',
                                '</div>',
                            '</md-input-container>',
                            '<md-input-container flex="50">',
                                '<label>Email Address</label>',
                                '<input md-auto-focus autocomplete="off" id="emailAddress" name="emailAddress" placeholder="Email Address" ng-model="$ctrl.user.username" required>',
                                '<div class="has-error" ng-messages="form.emailAddress.$error">',
                                    '<div class="validation-warning" ng-message="required">Email Address is required</div>',
                                '</div>',
                            '</md-input-container>',

                            '<md-input-container flex="50">',
                                '<label>Password</label>',
                                '<input type="password" ',
                                '       autocomplete="off" ',
                                '       id="password" ',
                                '       name="password" ',
                                '       placeholder="Password" ',
                                '       ng-model="$ctrl.user.password" ',
                                '       required',
                                '       ng-keyup="$event.keyCode == 13 && form.$valid && $ctrl.logIn()">',
                                '<div class="has-error" ng-messages="form.password.$error">',
                                    '<div class="validation-warning" ng-message="required">Password is required</div>',
                                '</div>',
                            '</md-input-container>',
                        '</div>',
                    '</md-dialog-content>',
                '</form>',
            '</div>',
            '<md-dialog-actions>',
                '<a ng-click="$ctrl.forgotPassword()">Forgot Password</a>',
                '<span flex></span>',
                '<md-button class="md-primary" ng-disabled="form.$invalid" ng-click="$ctrl.logIn()">Log In</md-button>',
                '<md-button ng-click="$ctrl.cancel()">Cancel</md-button>',
            '</md-dialog-actions>'
        ].join('\n'),
        controller: ['UserService', function(userService){
            var self = this;

            this.forgotPassword = function(){
                self.done({result: 'forgot-password'});
            };

            this.logIn = function(){
                self.invalidLogin = false;
                userService.signIn(self.user)
                .then(function(response){
                    self.done({result: response.data.user});
                })
                .catch(function(err){
                    self.invalidLogin = err.status === 401 || err.status === 404;
                });
            };

            this.$onInit = function(){
                self.user = {};
            };
        }]
    });

'use strict';

angular.module('attensaApp')
.component('requestSignupCode', {
    bindings: {
        cancel: '&',
        done: '&'
    },
    template: [
        '<md-toolbar>',
            '<div class="md-toolbar-tools">',
                '<h2>Sign Up</h2>',
            '</div>',
        '</md-toolbar>',
        '<div class="page">',
            '<form name="form">',
                '<md-dialog-content layout-padding>',
                    '<div flex layout="column">',
                        '<h5>Sign-up with your <strong>email address</strong>. We will send you a link to create your account.</h5>',


                        '<md-input-container flex="50">',
                            '<label>Email Address</label>',
                            '<input md-auto-focus ',
                            '       autocomplete="off" ',
                            '       id="emailAddress" ',
                            '       name="emailAddress" ',
                            '       placeholder="Email Address" ',
                            '       ng-model="$ctrl.emailAddress" ',
                            '       required',
                            '       ng-keyup="$event.keyCode == 13 && form.$valid && $ctrl.sendRequest()">',
                            '<div class="has-error" ng-messages="form.emailAddress.$error">',
                                '<div class="validation-warning" ng-message="required">Email Address is required to signup</div>',
                            '</div>',
                        '</md-input-container>',

                    '</div>',
                '</md-dialog-content>',
            '</form>',
        '</div>',
        '<md-dialog-actions>',
            '<md-button class="md-primary" ng-disabled="form.$invalid" ng-click="$ctrl.sendRequest()">Send</md-button>',
            '<md-button ng-click="$ctrl.cancel()">Cancel</md-button>',
        '</md-dialog-actions>'
    ].join('\n'),
    controller: ['$mdToast', 'UserService', function($mdToast, userService){
        var self = this;

        this.sendRequest = function(){
            userService.startSignup(self.emailAddress, 'preferences')
            .then(function(){
                $mdToast.show($mdToast.simple().textContent('We have sent a link to complete the process to your email address. If you don\'t see it there make sure to check your spam folder.').position('top right'));
                self.done();
            })
            .catch(function(){
                $mdToast.show($mdToast.simple().textContent('Unable to process invitation, please contact your site administrator').position('top right'));
            });
        };
    }]
});

'use strict';

angular.module('attensaApp')
    .component('topicSeedStart', {
        template: `
            <div layout-margin>
                <div layout="row">
                    <div flex="55" layout="row" layout-align="end center">
                        <h2>Create a topic</h2>
                    </div>
                </div>
                <div layout="row">
                    <div flex="30" flex-offset="35" layout="row" layout-align="center center">
                        <h5>Topics are collections of content focused around an audience like customers, teams, partners, etc. Topics are most effective when narrowly focussed.</h5>
                    </div>
                </div>
                
                <div layout="row">
                    <div flex="30" flex-offset="35" layout="row" layout-align="center center">
                        <h5>Get started by adding a few terms and phrases that define your audience's area of interest. Terms and phrases can be keywords, concepts, companies, trends, etc. See Examples</h5>
                    </div>
                </div>
            
                <spinner ng-if="$ctrl.noTouching"></spinner>
                
                <div ng-if="!$ctrl.noTouching" layout="row" style="padding-top:15px;">
                    <div layout="column" flex layout-align="end center">
                        <div flex layout="row" layout-fill ng-repeat="term in $ctrl.searchTerms track by $index">
                            <div flex-offset="35" style="width:20px"><span ng-if="$index !== 0">or </span></div>
                            <md-input-container flex="25" style="margin-top: 0px; margin-bottom: 0px;">
                                <input ng-model="term.value"
                                       aria-label="keyword"
                                       ng-keyup="$event.keyCode == 13 && $ctrl.addTerm()">
                            </md-input-container>
                            <button class="btn btn-primary" style="margin-left: 20px; height: 30px;" ng-if="!$last" ng-click="$ctrl.removeTerm($index)">
                                <i class="fa fa-minus"></i>
                            </button>
                            <button class="btn btn-primary" style="margin-left: 20px; height: 30px;" ng-if="$last"ng-click="$ctrl.addTerm()">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div ng-if="!$ctrl.noTouching" style="padding-top:15px; min-height: 50px;" layout="row" layout-align="center center">
                    <button class="btn btn-primary" ng-click="$ctrl.createStream()" ng-disabled="$ctrl.isEmptySearch()">GO</button>
                </div>
                <div ng-if="!$ctrl.noTouching" layout="row" style="padding-top:15px;">
                    <div flex="55" layout="row" layout-align="end center">
                        <div>Skip this step and <a ng-click="$ctrl.createEmptyTopic()">manually select sources</a></div>
                    </div>
                </div>
            </div>
        `,
        controller: ['$state', '$q', '_', '$uibModal', 'growl', 'ItemService', 'StreamService', 'UtilService',
        function($state, $q, _, $uibModal, growl, itemService, streamService, utilService) {

            this.$onInit = () => this.searchTerms =
                $state.params.searchTerm ? [{value: $state.params.searchTerm}] : [{ value: ''}];

            this.removeTerm = index => this.searchTerms.splice(index, 1);

            this.addTerm = () => this.searchTerms.push({value: ''});

            this.isEmptySearch = () => !this.searchTerms.reduce((cur, term) => !!term.value || cur, false);

            this.createStream = () => {
                this.noTouching = true;
                const term = this.searchTerms
                .filter(term => term && term.value && term.value.trim().length)
                .map(term => Object.assign({}, term))
                .map(term => Object.assign(term, {value: term.value.replace(/"/g, '')}))
                .map(term => `"${utilService.cleanQuotes(term.value)}"`)
                .join(' ');
                const itemSearchParams = {
                    search: term,
                    includeMarketplaceStreams: $state.params.siteOnly !== 'true',
                    page: 0,
                    includeReadItems: true
                };

                $q.all([
                    itemService.searchItemsWithSettings(itemSearchParams, itemSearchParams),
                    $uibModal.open({
                        templateUrl: '/templates/topicNameModal.html',
                        size: 'md',
                        keyboard: true
                    }).result
                ])
                .then(results => streamService.createTopicWithSubstreams(results[1],
                    _.chain(results[0].content).map('streamId').uniq().value()))
                .catch(() => {
                    this.noTouching = false;
                    growl.error('Unable to create topic.');
                })
                .then(stream => {
                    this.streamId = stream.id;
                    return streamService.postFilter(this.streamId, {
                        isBasic: true,
                        filterTerm: term,
                        basicFilterText: term
                    });
                })
                .then(() => $state.go('editTopic.filters', { streamId: this.streamId }));
            };

            this.createEmptyTopic = () => $uibModal.open({
                templateUrl: '/templates/topicNameModal.html',
                size: 'md',
                keyboard: true
            }).result
            .then(name => streamService.saveStream({
                title: name,
                type: 'COLLECTION',
                openForReading: true,
                published: false
            }))
            .then(streamResponse => $state.go('editTopic.sources', {streamId: streamResponse.data.id}));
        }]
    });

'use strict';

angular.module('attensaApp')
    .component('collapsibleTagList', {
        bindings: {
            label: '@',
            tags: '=',
            tagMultiSelect: '=',
            selectedTags: '=',
            tagClicked: '&'
        },
        controller: ['_',
        function(_) {
            this.limitLength = 3;

            this.$onInit = () => {
                this.limit = 3;
            };

            this.tagSelected = tag => _.indexOf(this.selectedTags, tag) !== -1;

            this.toggleTag = tag => this.tagSelected(tag) ? _.remove(this.selectedTags, selTag => selTag.tagText === tag.tagText): this.selectedTags.push(tag);

            this.toggleLimit = () => this.limit = this.limit ? undefined : this.limitLength;
        }],
        template:`
            <strong>{{$ctrl.label}}: </strong>
            <span ng-repeat="tag in $ctrl.tags | limitTo: $ctrl.limit">
                <button ng-if="$ctrl.tagMultiSelect" ng-class="{active: $ctrl.tagSelected(tag) }" class="btn btn-xs btn-default tag-item" ng-click="$ctrl.toggleTag(tag)" blur-me>{{tag.displayText ? tag.displayText : tag.tagText}}</button>
                <button ng-if="!$ctrl.tagMultiSelect" class="btn btn-xs btn-default tag-item" ng-click="$ctrl.tagClicked({$tag: tag})">{{tag.displayText ? tag.displayText : tag.tagText}}</button>
            </span>
            <a ng-if="$ctrl.tags.length > $ctrl.limitLength" ng-click="$ctrl.toggleLimit()"><span style="font-size: large; padding-left: 5px;" class="fa" ng-class="{ 'fa-angle-double-right': $ctrl.limit, 'fa-angle-double-left': !$ctrl.limit }"></span></a>
        `,
    });


'use strict';

angular.module('attensaApp')
    .component('topicControlBar', {
        bindings: {
            topic: '=',
            curate: '<',
            indexControls: '<',
            indexVisible: '='
        },
        template: [
            '<div class="topic-controls col-md-12">',
                '<div>',
                    '<div class="row">',
                        '<div class="col-md-4 margin-column">',
                            '<span ng-show="$ctrl.indexControls && $ctrl.topic.type === \'COLLECTION\'">',
                                '<a ng-click="$ctrl.indexVisible = !$ctrl.indexVisible"><span ng-hide="$ctrl.indexVisible">Show</span><span ng-show="$ctrl.indexVisible">Hide</span> Index</a>',
                            '</span>',
                            '<topic-sorter class="pull-right" style="padding-left: 8px;"></topic-sorter>',
                            '<div ng-if="$ctrl.curate && $ctrl.topic.type === \'COLLECTION\'" ',
                                 'show-with-permission',
                                 'action="MANAGE_STREAM"',
                                 'stream-id="::$ctrl.topic.id"',
                                 'stream-owner-id="{{::$ctrl.topic.ownerId}}"',
                            '     class="pull-right" ',
                            '     style="display: inline-block; padding-right:15px; padding-bottom:10px;">',
                                '<item-curation-filter filter-did-change="$ctrl.filterChanged({filter: filter})" selected-filter="$ctrl.selectedFilter" initial-filter="\'All\'"></item-curation-filter>',
                            '</div>',
                        '</div>',
                        '<div class="col-md-4">',
                            '<div class="slider-holder" ng-if="!$ctrl.displayProvidedRange">',
                                '<rzslider   rz-slider-model="$ctrl.rangeSlider.minValue"',
                                            'rz-slider-high="$ctrl.rangeSlider.maxValue"',
                                            'rz-slider-options="$ctrl.rangeSlider.options">',
                                '</rzslider>',
                            '</div>',
                            '<h5 class="muted-text date-range" ng-if="$ctrl.displayProvidedRange">',
                                '<span ng-show="$ctrl.initialStartDate && $ctrl.initialEndDate">{{ $ctrl.initialStartDate | date : \'longDate\' }} - {{ $ctrl.initialEndDate | date : \'longDate\' }}</span>',
                                '<span ng-show="$ctrl.initialStartDate && !$ctrl.initialEndDate">from {{ $ctrl.initialStartDate | date : \'longDate\' }}</span>',
                                '<span ng-show="!$ctrl.initialStartDate && $ctrl.initialEndDate">before {{ $ctrl.initialEndDate | date : \'longDate\' }}</span>',
                                '&nbsp;<a ng-click="$ctrl.resetExploreDates()" class="muted-text" style="text-decoration: underline">Clear</a>',
                            '</h5>',
                        '</div>',
                        '<div class="col-md-offset-2 col-md-2">',
                            '<h5 class="pull-right">{{$ctrl.totalItems}} Items</h5>',
                        '</div>',
                    '</div>',
                '</div>',
            '</div>'
        ].join('\n'),
        controller: ['_', 'moment', '$rootScope', '$timeout', '$state', '$stateParams', function(_, moment, $rootScope, $timeout, $state, $stateParams) {
            var self = this;

            this.initialStartDate = $stateParams.startDate;
            this.initialEndDate = $stateParams.endDate;

            this.startDate = this.initialStartDate;
            this.endDate = this.initialEndDate;

            this.displayProvidedRange = this.initialStartDate || this.initialEndDate;

            var rangeMax = 33;
            var rangeMin = -1;
            var hourMin = rangeMax - 12; // 1 - 12 hours
            var dayMin = hourMin - 10; // 1 - 10 days

            var buildLabel = function(baseLabel, bounds, value, adjustment){
                var val = bounds - value + (adjustment ? adjustment : 0);
                return val + ' ' + (val > 1 ? baseLabel + 's' : baseLabel) + ' ago';
            };

            var buildDate = function(opLabel, bounds, value, adjustment){
                return moment().subtract(bounds - value + (adjustment ? adjustment : 0), opLabel).toDate();
            };

            (function() {
                $timeout(function() {
                    $rootScope.$broadcast('rzSliderForceRender');
                });
            })();

            this.resetExploreDates = function(){
                self.rangeSlider.minValue = rangeMin;
                self.rangeSlider.maxValue = rangeMax;
                self.displayProvidedRange = false;
                $state.go($state.$current.self.name, _.omit($stateParams, 'startDate', 'endDate'), { notify: false, inherit: false });
                self.broadcastDates();
            };

            this.broadcastDates = function(){
                self.startDate = indexToDate(self.rangeSlider.minValue);
                self.endDate = indexToDate(self.rangeSlider.maxValue);
                $rootScope.$broadcast('topics-date-range-change', self.startDate, self.endDate);
            };

            this.filterChanged = function(filterChoice){
                $rootScope.$broadcast('topics-item-visibility-filter-changed', filterChoice.filter);
            };

            var indexToDate = function(value){
                if (value === rangeMax) {
                    return moment().toDate();
                } else if(value === rangeMin){
                    return null;
                } else if(value > hourMin){
                    return buildDate('hours', rangeMax, value);
                }else if(value > dayMin){
                    return buildDate('days', hourMin, value, 1);
                }else {
                    return buildDate('months', dayMin, value, 1);
                }

            };

            //TODO force this up to bindings
            $rootScope.$on('topic-date-range-clear', self.resetExploreDates);

            //TODO force this up to bindings
            $rootScope.$on('topic-item-page-fetched', function(event, page){
                self.totalItems = page.totalElements;
            });

            this.rangeSlider = {
                minValue: -1,
                maxValue: 33,

                options: {
                    floor: rangeMin,
                    ceil: rangeMax,
                    step: 1,
                    draggableRange: true,
                    hideLimitLabels: true,
                    onEnd: self.broadcastDates,
                    translate: function(value) {
                        if (value === rangeMax) {
                            return 'Now';
                        } else if(value === rangeMin){return '1 Year +';
                        } else if(value > hourMin){
                            return buildLabel('hour', rangeMax, value);
                        }else if(value > dayMin){
                            return buildLabel('day', hourMin, value, 1);
                        }else {
                            return buildLabel('month', dayMin, value, 1);
                        }
                    }
                }
            };
        }]
    });

'use strict';

angular.module('attensaApp')
.component('topicSorter', {
    bindings: {
        topic: '=',
        curate: '<',
        indexControls: '<',
        indexVisible: '='
    },
    template: [
        '<ul class="pull-right" style="padding-left: 8px;">',
            '<li class="dropdown checked-dropdown" uib-dropdown>',
                '<a uib-dropdown-toggle>',
                '<span class="dropdown-label">{{$ctrl.sort.label}}</span><span class="caret"></span>',
                '</a>',
                '<ul class="dropdown-menu">',
                    '<li ng-repeat="sort in $ctrl.sorts">',
                        '<span ng-if="$ctrl.sort.key === sort.key"><i class="fa fa-check"></i> {{sort.label}}</span>',
                        '<a ng-if="$ctrl.sort.key !== sort.key" ng-click="$ctrl.toggleSort(sort)">{{sort.label}}</a>',
                    '</li>',
                '</ul>',
            '</li>',
        '</ul>'
    ].join('\n'),
    controller: ['$rootScope', '_', function($rootScope, _) {
        var self = this;

        this.sorts = [
            { key: 'publishedDate', label: 'Most Recent'},
            { key: 'attentionRank', label: 'Most Relevant'},
            { key: 'created', label: 'Most Recently Added'}
        ];

        this.sort = this.sorts[0];

        this.toggleSort = function(sort){
            $rootScope.$broadcast('topic-set-sort', sort.key);
        };

        $rootScope.$on('topic-sort-changed', function(event, sortField){
            self.sort = _.find(self.sorts, {key: sortField});
        });
    }]
});

'use strict';

angular.module('attensaApp')
.component('topicItemListContents', {
    bindings: {
        currentTopicId: '=',
        items: '=',
        itemSearchParams: '=',
        searching: '=',
        topic: '=',
        toggleItemVisibility: '&',
        fetchPage: '&'
    },
    template: `
        <read-permission-warning topic="$ctrl.currentContext()"></read-permission-warning>
        <div class="reading-item-magazine" ng-repeat="item in $ctrl.items" ng-hide="$ctrl.searching && $ctrl.itemSearchParams.page === 0" ng-style="{'opacity' : !item.visible && $ctrl.topic.type === 'COLLECTION' ? 0.5 : .99}">
            <div class="media-left">
                <div class="rank rank-large" attention-rank-for="item"></div>
            </div>
            <div class="media-body">
                <div class="pad-left-right">
                    <h4 class="media-heading">
                        <a class="mc-reading-item-link" ng-click="$ctrl.openReadingModal(item)" title="{{::item.title}}">
                            <span ng-if="::item.attachments.length">
                                <i class="glyphicon glyphicon-paperclip"></i> ',
                            </span>
                            <strong ng-if="!item.readByUser">{{item.title || 'No title'}}</strong>
                            <span class="reading-lighweight-item-title" ng-if="item.readByUser">{{item.title || 'No title'}}</span>
                        </a>
                    </h4>
                    <p class="reading-magazine-item-description">{{::item.shortDescription}}</p>
                    <ul class="reading-magazine-bylinelist">
                        <li ng-if="::item.streamOriginTitle && $ctrl.userCanRead()">
                            <a class="view-stream-detail" stream-details-for="item.streamOriginId">{{::item.streamOriginTitle}}</a>
                        </li>
                        <li ng-if="::item.author">{{::item.author}}</li>
                        <li ng-if="::item.link !== '#' && $ctrl.userCanRead()">
                            <a click-through-item="item" context="directLink" topic-stream-id="{{$ctrl.currentTopicId}}" class="direct-link"><span class="glyphicon glyphicon-link"></span> Direct Link</a>
                        </li>
                        <li ng-if="$ctrl.userCanRead()">
                            <a toggle-bookmark item="item" items="$ctrl.items">
                                <span class="fa" ng-class="item.savedByUser ? 'fa-bookmark text-danger' : 'fa-bookmark-o'"></span> {{ item.savedByUser ? 'Saved' : 'Save'}}
                            </a>
                        </li>
                        <li style="color:#337ab7" ng-if="$ctrl.userCanRead()">
                            <share-menu item="item" topic-stream-id="$ctrl.currentTopicId" append-to-body="true"><span style="padding-left: 4px;">Share</span></share-menu>
                        </li>
                        <edit-item ng-if="$ctrl.currentTopicId && $ctrl.topic.type === 'COLLECTION' && item.type !== 'FACTIVA' && !(item.tenantId && item.tenantId !== $ctrl.currentUser.tenantId)" class="menu-item" item="item" stream="$ctrl.topic">
                            <i class="fa fa-edit"></i>&nbsp;Edit
                        </edit-item>
                        <li>
                            Added
                            <span am-time-ago="::item.created" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{::item.created | date : 'medium'}}"></span>
                        </li>
                        <li show-with-permission action="MANAGE_STREAM" stream-id="::$ctrl.topic.id" stream-owner-id="{{::$ctrl.topic.ownerId}}" ng-if="::$ctrl.topic.tenantId">
                            <a ng-if="::$ctrl.topic.type === 'COLLECTION'" ng-click="$ctrl.toggleItemVisibility({item: item})" class="eye-of-sauron" uib-tooltip="{{item.visible ? 'Hide item' : 'Expose item'}}" tooltip-append-to-body="true"><i class="fa fa-eye-slash fa-lg"></i>&nbsp;</a>
                        </li>
                        <li class="pull-right"><span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{::item.publishedDate | date : 'medium'}}">Published: {{::item.publishedDate | date:'MM/dd/yyyy' }}</span></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="reading-item-magazine" ng-show="$ctrl.searching">
            <spinner></spinner>
        </div>
    `,
    controller: ['_', '$scope', 'ItemService', 'permissionService', 'UserService', function(_, $scope, itemService, permissionService, userService) {
        
        const openAdjacentItem = (itemId, offset) => this.openReadingModal(this.items[_.findIndex(this.items, {id: itemId}) + offset]);

        $scope.$on('show-previous-item', (evt, itemId) => openAdjacentItem(itemId, -1));

        $scope.$on('show-next-item', (evt, itemId) => openAdjacentItem(itemId, 1));

        this.$onInit = () => userService.getCurrentUser().then(response => this.currentUser = response.data.user);

        this.userCanRead = () => permissionService.userCanReadStream(this.currentUser, this.currentContext(), true);

        this.currentContext = () => {
            if(this.topic && this.topic.currentStream && this.topic.currentStream.id){
                return this.topic.currentStream;
            }else if(this.topic && this.topic.id){
                return this.topic;
            }
        };

        this.openReadingModal = item => {
            const isLastItem = (this.items.indexOf(item) + 1) === this.items.length;

            if(isLastItem && !this.isLastPage){
                this.fetchPage();
            }

            item.readByUser = true;

            itemService.openNewModal({
                itemId: item.id,
                hasPrevious: this.items.indexOf(item) > 0,
                hasNext: !isLastItem,
                streamContext: this.currentContext() ? this.currentContext().id : undefined
            });
        };
    }]
});

'use strict';

angular.module('attensaApp')
    .component('topicSummarySection', {
        bindings: {
            topic: '=',
            user: '=',
            hideEditLink: '<'
        },
        template: `
            <span class="topic-summary row">
                <div class="col-md-8">
                    <div class="flex">
                        <topic-summary class="full-width" 
                                       stream="$ctrl.topic" 
                                       taxonomy="$ctrl.taxonomy"
                                       on-change="$ctrl.saveStream($ctrl.topic)"></topic-summary>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="clearfix">
                        <div class="pull-right">
                            <follow-button stream="$ctrl.topic" user="$ctrl.user" type="stream" follow-style="primary"></follow-button>
                            <subscribe-button ng-if="$ctrl.topic.briefingEnabled" stream="$ctrl.topic" user="$ctrl.user" type="stream" subscribe-style="primary"></subscribe-button>
                            <div class="manage-container">
                                <div show-with-permission action="MANAGE_STREAM"
                                     stream-id="::$ctrl.topic.id"
                                     stream-owner-id="{{::$ctrl.topic.ownerId}}"
                                     ng-if="::$ctrl.topic.tenantId">
                                    <a ng-if="!$ctrl.hideEditLink" type="button" id="edit-{{::$ctrl.topic.id}}" ui-sref="editTopic.articles({ streamId: $ctrl.topic.id})" uib-tooltip="Edit" tooltip-append-to-body="true"><span class="fa fa-cog fa-xl"></span></a>
                                </div>
                                <div show-with-permission action="MANAGE_CATALOG" ng-if="::!$ctrl.topic.tenantId">
                                    <a type="button" ui-sref="editTopic.articles({ streamId: $ctrl.topic.id})"><span class="fa fa-cog fa-xl"></span></a>
                                </div>
                            </div>
                            <a style="height: 30px; width: 30px; display: inline-block;" ng-if="$ctrl.topicInviteEnabled" type="button" ng-click="$ctrl.invite($ctrl.topic.id, $ctrl.topic.title)" uib-tooltip="Invite Others" tooltip-append-to-body="true">&nbsp;<i class="fa fa-user-plus fa-xl"></i></a>
                        </div>
                    </div>
                    <div class="pull-right">
                        <div ng-if="$ctrl.topic.type === \'COLLECTION\' && $ctrl.topic.tenantId && ($ctrl.topic.tenantId === $ctrl.user.tenantId)"
                                show-with-permission
                                action="POST_TO_STREAM"
                                stream-id="::$ctrl.topic.id"
                                stream-owner-id="{{::$ctrl.topic.ownerId}}"
                                class="pull-left">
                            <a style="padding-top:5px;" class="pull-right" ng-click="$ctrl.postToTopic($ctrl.topic)"><strong>Post to Topic</strong></a>
                        </div>
                        <div ng-if="$ctrl.topic.type === \'COLLECTION\' && !$ctrl.topic.tenantId || ($ctrl.topic.tenantId && ($ctrl.topic.tenantId !== $ctrl.user.tenantId))"
                                show-with-permission
                                action="MANAGE_CATALOG"
                                class="pull-left">
                            <a style="padding-top:5px;" class="pull-right" ng-click="$ctrl.postToTopic($ctrl.topic)"><strong>Post to Topic</strong></a>
                        </div>
                        <div ng-if="$ctrl.topic.tenantId && $ctrl.topic.tenantId === $ctrl.user.tenantId" show-with-permission="" action="MANAGE_STREAM" stream-id="$ctrl.topic.id" stream-owner-id="{{$ctrl.topic.ownerId}}" class="pull-left" style="clear:both;">
                            <delete-stream stream="$ctrl.topic"></delete-stream>
                        </div>
                        <div ng-if="!$ctrl.topic.tenantId || ($ctrl.topic.tenantId && ($ctrl.topic.tenantId !== $ctrl.user.tenantId))" show-with-permission="" action="MANAGE_CATALOG" class="pull-left" style="clear:both;">
                            <delete-stream stream="$ctrl.topic"></delete-stream>
                        </div>
                    </div>
                </div>
            </span>
        `,
        controller: ['$rootScope', '$uibModal', 'growl', 'ItemService', 'StreamService', 'TaxonomyService', 'TenantService', 'UserService',
            function($rootScope, $uibModal, growl, itemService, streamService, taxonomyService, tenantService, userService) {
            
            this.openFollowersModal = streamService.openFollowersModal;

            this.postToTopic = (currentStream) => itemService.openPostItemModal([currentStream], null,  this.user.firstName + ' ' + this.user.lastName, function(){
                    $rootScope.$broadcast('topic-fetch-items');
                });

            this.saveStream = () => streamService.updateStream(this.topic).then(() => $rootScope.$broadcast('stream-changed', this.topic));

            this.categoryTitle = streamService.categoryTitle;

            this.invite = (topicId, topicTitle) => $uibModal.open({
                    templateUrl: '/templates/emailPicker.html',
                    controller: 'EmailPickerModalCtrl',
                    controllerAs: 'emailPicker',
                    size: 'lg'
                }).result
                .then(emails => userService.sendTopicInvitation(topicId, topicTitle, emails))
                .then(() => growl.success('Invitations sent'))
                .catch(err => {
                    if(!err.cancelled) {
                        if(err.status === 409){
                            growl.error('This user has been deleted and we are unable to invite them, please contact your site administrator for further information.');
                        }else {
                            growl.error('There was a problem sending the invitation, please contact your site administrator.');
                        }
                    }
                });

            this.$onInit = () => {
                taxonomyService.getTenantTaxonomy().then(res => this.taxonomy = res.data);
                tenantService.getUnauthTenantInfo().then(res => this.topicInviteEnabled = res.data.settings.topicInviteEnabled);
            };
        }]
    });

'use strict';

angular.module('attensaApp')
.component('sourceFinder', {
    bindings: {
        streamId: '=',
        existingSources: '=',
        cancel: '&',
        done: '&'
    },
    controller: ['_', '$q', 'StreamService', 'TaxonomyService',
        function(_, $q, streamService, taxonomyService) {

            this.catalogCategorySelected = (catalogId, categoryId) => {
                if(this.params.catalogId !== catalogId || this.params.categoryId !== categoryId){
                    this.selectAll = false;
                    this.params.catalogId = catalogId;
                    this.params.categoryId = categoryId;
                    this.search();
                }
            };

            this.save = () => this.done({ results: { streamIds: this.selectedStreamIds() } });

            this.sort = (key, direction) => {
                this.params.sort = key;
                this.params.sortDirection = direction;
                this.search();
            };

            this.page = () => {
                this.params.page = this.params.pagerPage -1;
                this.selectAll = false;
                this.fetch();
            };

            this.search = () => {
                this.params.page = 0;
                this.params.pagerPage = 1;
                this.fetch();
            };

            this.setTag = (tag, noSearch) => {
                this.params.tagIds = tag;
                if(!noSearch){
                    this.search();
                }
            };

            this.onSearchTypeChange = type => {
                this.searchType = type;
                if(this.searchType === 'default' || this.searchType === 'recommend'){
                    this.params.tagIds = undefined;
                }else if(this.searchType === 'tags'){
                    this.params.term = null;
                }
                this.search();
            };

            this.fetch = () => {
                this.noTouching = true;
                this.ongoingRequest = $q.defer();
                if(_.isEmpty(this.params.tagIds)){
                    this.params.tagIds = undefined;
                }

                this.params.includeCatalogs = this.params.catalogId === 'all' ? true : undefined;

                //consistency, hobgoblins, you get the idea
                this.params.type = this.searchType === 'recommend' ? 'item_search' : undefined;
                this.params.search = this.searchType === 'recommend' ? this.params.term : undefined;
                this.params.term = this.searchType === 'tags' ? undefined : this.params.term;

                if(this.searchType === 'recommend' && !this.params.search){
                    this.noTouching = false;
                    this.streams = [];
                    this.params.totalItems = 0;
                }

                let searcher;
                if(this.searchType === 'recommend'){
                    searcher = streamService.getRecommendedStreams(this.params, this.ongoingRequest.promise);
                } else if((!this.params.catalogId || this.params.catalogId === 'all') && !this.params.categoryId) {
                    searcher = streamService.getTenantStreams(this.params, this.ongoingRequest.promise);
                } else if(this.params.categoryId && !this.params.catalogId){
                    searcher = taxonomyService.getStreams({params: this.params, timeout: this.ongoingRequest.promise});
                } else if(!this.params.categoryId && this.params.catalogId){
                    searcher = streamService.getCatalogStreams(this.params.catalogId, this.params, this.ongoingRequest.promise);
                } else{
                    searcher = taxonomyService.getCatalogCategoryStreams(this.params.catalogId, {params: this.params, timeout: this.ongoingRequest.promise});
                }

                searcher.then(results => {
                    this.noTouching = false;
                    this.streams = results.data.content;
                    this.params.totalItems = results.data.totalElements;
                });
            };

            this.streamSelected = () => this.selectAll = false;

            this.toggleSelectAll = () => {
                this.streams.forEach(stream => {
                    if(!this.existingSourceIds.includes(stream.id) && stream.id !== this.streamId) {
                        this.selectedStreams[stream.id] = this.selectAll;
                    }
                });
            };

            this.selectedStreamIds = () => _.chain(this.selectedStreams)
                                            .map((isSelected, streamId) => isSelected ? streamId : null)
                                            .filter(val => val)
                                            .value();

            this.$onInit = () => {
                this.existingSourceIds = _.map(this.existingSources, 'id');
                this.selectedStreams = {};
                this.params = {
                    page: 0,
                    pagerPage: 1,
                    rows: 40,
                    filterEmpty: true,
                    includeCatalogs: true,
                    catalogId: 'all',
                    selectAll: false,
                    selectedCount: 0
                };
                this.searchType = 'default';
                this.search();
            };
        }],
    template: `
        <section class="modal-header">
            <button class="btn btn-primary pull-right" ng-click="$ctrl.cancel()">Cancel</button>
            <button class="btn btn-primary pull-right" 
                    ng-disabled="!$ctrl.selectedStreamIds().length"
                    ng-click="$ctrl.save()" 
                    style="margin-right: 15px;">Save and Add ({{$ctrl.selectedStreamIds().length}})</button>
            <h4 class="modal-title">Add existing topics and sources</h4>
        </section>
        <div class="modal-body">
            <section>
                <source-finder-search-bar term="$ctrl.params.term"
                                          tag-ids="$ctrl.params.tagIds"
                                          catalog-id="$ctrl.params.catalogId"
                                          category-id="$ctrl.params.categoryId"
                                          search-type="$ctrl.searchType"
                                          on-search-type-change="$ctrl.onSearchTypeChange(type)"
                                          on-search="$ctrl.search()"
                                          on-set-tag="$ctrl.setTag(tag)"
                                          title-desc-tags="$ctrl.titleDescTags"
                                          restrict-to-domain="$ctrl.restrictToDomain">
                </source-finder-search-bar>
            </section>
            <section>
                <div class="row">
                    <div class="col-sm-3 taxonomy-sidebar-column">
                        <taxonomy-sidebar node-selected="$ctrl.catalogCategorySelected(catalogId, categoryId)"
                                          clear-tags="$ctrl.setTag(null, true)"></taxonomy-sidebar>
                    </div>
                    <div class="col-sm-9">
                        <spinner ng-if="$ctrl.noTouching"></spinner>
                        <source-finder-streams-table-header ng-if="!$ctrl.noTouching"
                                                            select-all="$ctrl.selectAll"
                                                            toggle-select-all="$ctrl.toggleSelectAll()"
                                                            sort="$ctrl.params.sort"
                                                            sort-direction="$ctrl.params.sortDirection"
                                                            on-sort="$ctrl.sort($sort, $sortDirection)">        
                        </source-finder-streams-table-header>
                        <source-finder-stream-table ng-if="!$ctrl.noTouching"
                                                    existing-source-ids="$ctrl.existingSourceIds"
                                                    stream-id="$ctrl.streamId"
                                                    selected-streams="$ctrl.selectedStreams"
                                                    streams="$ctrl.streams"
                                                    stream-selected="$ctrl.streamSelected()"></source-finder-stream-table>
                        <uib-pagination ng-if="!$ctrl.noTouching && $ctrl.searchType !== 'recommend' && $ctrl.params.totalItems > $ctrl.params.rows"
                                        style="padding-top: 10px;"
                                        total-items="$ctrl.params.totalItems"
                                        items-per-page="$ctrl.params.rows"
                                        ng-change="$ctrl.page()"
                                        ng-model="$ctrl.params.pagerPage"
                                        max-size="5"
                                        boundary-link-numbers="true"
                                        previous-text="&lsaquo;"
                                        next-text="&rsaquo;">
                        </uib-pagination>
                    </div>
                </div>
            </section>
        </div>
    `,
});

'use strict';

angular.module('attensaApp')
.component('sourceFinderStreamTable', {
    bindings: {
        existingSourceIds: '<',
        streams: '=',
        streamId: '<',
        selectedStreams: '=',
        streamSelected: '&'
    },
    controller: ['_', 'StreamService', function(_, streamService) {
        this.isExisting = id => _.includes(this.existingSourceIds, id);
        this.viewStreamDetails = streamService.openStreamDetailModal;
    }],
    template: `
        <div class="position-relative clearfix stream-table">
            <div ng-if="stream.id !== $ctrl.streamId" ng-repeat="stream in $ctrl.streams track by stream.id" class="clearfix">
                <div class="row streams-table-row">
                    <div class="col-md-1 no-padd-right">
                        <span>
                            <input ng-if="!$ctrl.isExisting(stream.id)" 
                                   class="select-stream-checkbox no-margin-right" 
                                   type="checkbox" 
                                   ng-model="$ctrl.selectedStreams[stream.id]" 
                                   ng-true-value="true" 
                                   ng-false-value="false" 
                                   ng-click="$ctrl.streamSelected({stream: stream})">
                            <input ng-if="$ctrl.isExisting(stream.id)" 
                                   class="select-stream-checkbox no-margin-right" 
                                   type="checkbox" 
                                   disabled="true" 
                                   checked="true" 
                                   title="Source already exists in Topic">
                        </span>
                        <div ng-if="thumbnailImageAttachmentId || stream.thumbnailImage.uri" class="pull-right">
                            <ng-include src="'/templates/streamImageThumbnail.html'"></ng-include>
                        </div>
                    </div>
                    <div class="col-md-4 col-xs-4">
                        <h4 class="media-heading">
                            <div class="ellipsis-color">
                                <a class="overflow-ellipsis" ng-click="$ctrl.viewStreamDetails(stream)">
                                    <span class="stream-title overflow-ellipsis">
                                        <span title="{{::stream.title}}">{{::stream.title}}</span>
                                    </span>
                                </a>
                            </div>
                        </h4>
                        <p title="{{::stream.description}}" class="catalog-tile-description">{{::stream.description}}</p>
                    </div>
                    <div class="hidden-sm hidden-xs col-md-2">
                        <span ng-if="::stream.tenantId"><stream-type-indicator stream="::stream"></stream-type-indicator></span>
                    </div>
                    <div class="col-md-1 col-xs-1" ng-hide="noFollowing">
                        <a ng-click="openFollowersModal(stream, false, params.catalogId)">
                            <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Followers">
                                <span id="followersCount-{{::stream.id}}">{{stream.followersCount}}</span>
                            </span>
                        </a>
                    </div>
                    <div class="col-md-1 col-xs-1">
                        <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Articles">
                            <span id="itemsCount">{{::stream.itemsCount}}</span>
                        </span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <a ng-if="!$ctrl.selectedStreams[stream.id] && !$ctrl.isExisting(stream.id)" ng-click="$ctrl.selectedStreams[stream.id] = true">Add</a>
                        <a ng-if="$ctrl.selectedStreams[stream.id] && !$ctrl.isExisting(stream.id)" ng-click="$ctrl.selectedStreams[stream.id] = false">Remove</a>
                    </div>
                </div>
            </div>
        </div>
`
});

'use strict';

angular.module('attensaApp')
.component('sourceFinderSearchBar', {
    bindings: {
        term: '=',
        tagIds: '<',
        catalogId: '=',
        categoryId: '=',
        searchType: '=',
        titleDescTags: '=',
        restrictToDomain: '=',
        onSetTag: '&',
        onSearch: '&',
        onSearchTypeChange: '&'
    },
    controller: ['_', 'TaxonomyService', 'TenantService', function(_, taxonomyService, tenantService){
        this.checkTag = () => {
            if(_.isEmpty(this.newTag)){
                this.onSetTag();
            }
        };

        this.selectTag = $item => {
            this.newTagLabel = $item.label;
            this.onSetTag({tag: $item.id});
        };

        this.tagSet = () => {
            if (this.catalogId && this.catalogId !== 'all' && !this.categoryId) {
                return this.streamTagMap[this.catalogId];

            } else if (this.catalogId && this.catalogId !== 'all' && this.categoryId) {
                return this.streamTagMap[this.categoryId];
            } else {
                return this.streamTagMap['default'];
            }
        };

         this.articleContentBlocked = () => this.tenant && this.tenant.parentTenantId && this.tenant.settings.limitProductSources === 'true';

        this.$onChanges = () => this.newTag = this.tagIds ? _.find(this.tagSet(), {id: this.tagIds }) : this.tagIds;

        this.$onInit = () => {
            this.streamTagMap = {};
            tenantService.getCatalogMap().then(catMap => this.tenantCatalogMap = catMap);

            tenantService.getUnauthTenantInfo().then(res => this.tenant = res.data);

            tenantService.getStreamTags()
                .then(tenantStreamTags => {
                    this.streamTagMap['default'] = tenantStreamTags;
                });

            _.forEach(this.tenantCatalogMap, catalog => {
                taxonomyService.getCatalogTags(catalog.catalogId)
                    .then(catalogTags => this.streamTagMap[catalog.catalogId] = catalogTags);
            });
        };
    }],
    template: `
        <div class="row" style="padding-top:10px; padding-bottom:15px;">
            <div class="col-sm-8">
                <form ng-submit="$ctrl.onSearch()">
                    <div ng-if="$ctrl.searchType !== 'tags'" class="input-group input-group-lg">
                        <input type="text" class="form-control" placeholder="Enter your search term" ng-model="$ctrl.term" on-delayed-change="$ctrl.onSearch()">
                        
                        <span class="input-group-btn">
                            <button class="btn btn-secondary" type="submit">
                                <span class="fa fa-search"></span>
                            </button>
                        </span>
                    </div>
                    <div ng-if="$ctrl.searchType === 'tags'" class="input-group input-group-lg">
                        <input type="text"
                               class="form-control add-tag"
                               id="tag"
                               uib-typeahead="tag.label for tag in $ctrl.tagSet() | filter: {label:$viewValue}"
                               typeahead-on-select="$ctrl.selectTag($item, $model, $label)"
                               ng-change="$ctrl.checkTag()"
                               placeholder="Tags"
                               maxlength="50"
                               ng-model="$ctrl.newTag">
                           
                        <span class="input-group-btn">
                            <button class="btn btn-secondary" type="submit">
                                <span class="fa fa-search"></span>
                            </button>
                        </span>
                    </div>
                </form>
            </div>
            <div class="col-sm-4 form-group form-group-md">
                <select class="form-control" name="searchType" ng-model="$ctrl.searchType" ng-change="$ctrl.onSearchTypeChange({type: $ctrl.searchType})">
                    <option value="default">Title & Descriptions</option>
                    <option ng-if="!$ctrl.articleContentBlocked()" value="recommend">Article Content</option>
                    <option value="tags">Tags</option>
                </select>
            </div>
        </div>
    `,
});

'use strict';

angular.module('attensaApp')
.component('sourceFinderStreamsTableHeader', {
    bindings: {
        sort: '=',
        sortDirection: '=',
        selectAll: '=',
        toggleSelectAll: '&',
        onSort: '&'
    },
    template: `
        <div class="row">
            <div class="col-sm-1">
                <input type="checkbox" ng-model="$ctrl.selectAll" ng-click="$ctrl.toggleSelectAll()">
            </div>
            <div class="col-sm-4">
                <sort-link label="Title"
                           key="titleLower"
                           sort="$ctrl.sort"
                           sort-direction="$ctrl.sortDirection"
                           on-sort="$ctrl.onSort({$sort: $sort, $sortDirection: $sortDirection})">
                </sort-link>
            </div>
            <div class="col-sm-2">Type</div>
            <div class="col-sm-1">
                <sort-link key="followersCount"
                           sort="$ctrl.sort"
                           sort-direction="$ctrl.sortDirection"
                           on-sort="$ctrl.onSort({$sort: $sort, $sortDirection: $sortDirection})">
                           <span class="glyphicon glyphicon-user">
                </sort-link>
            </div>
            <div class="col-sm-1">
                <sort-link key="itemsCount"
                           sort="$ctrl.sort"
                           sort-direction="$ctrl.sortDirection"
                           on-sort="$ctrl.onSort({$sort: $sort, $sortDirection: $sortDirection})">
                           <span class="fa fa-copy"></span>
                </sort-link>
            </div>
        </div>
    `
});

'use strict';

angular.module('attensaApp')
    .component('catalogCategories', {
        bindings: {
            selectedCategoryId: '=',
            categories: '=',
            selectCategory: '&'
        },
        template: `
            <ul class="streams-sidebar-section">
                <li ng-repeat="category in $ctrl.categories"
                    ng-class="{'active': category.id === $ctrl.selectedCategoryId, 'last':$last, 'before-active':$ctrl.isBeforeSelected($index)}"
                    class="category-row cursor-pointer">
                    <div class="row category-detail-row">
                        <div class="col-md-1" style="margin-top: 9px;">
                            <a ng-show="category.subcategories.length" ng-click="category.expanded = !category.expanded" class="category-toggle"><span class="glyphicon" ng-class="{ 'glyphicon-triangle-right': !category.expanded, 'glyphicon-triangle-bottom': category.expanded}"></span></a>
                        </div>
                        <div class="col-md-10" ng-click="$ctrl.selectCategory({category: category})">
                            <h5 class="overflow-ellipsis text-primary" title="{{::category.title}}">{{::category.title}}</h5>
                        </div>
                    </div>
                    <div ng-show="category.expanded" class="subcategory row" ng-repeat="subcategory in category.subcategories"
                         ng-class="{'active': subcategory.id === $ctrl.selectedCategoryId }">
                        <div class="col-md-offset-2 col-md-10" ng-click="$ctrl.selectCategory({category: subcategory})">
                            <h5>{{subcategory.title}}</h5>
                        </div>
                    </div>
                </li>
            </ul>
        `,
    });

'use strict';

angular.module('attensaApp')
    .component('taxonomyCategories', {
        bindings: {
            selectedCategoryId: '=',
            selectCategory: '&'
        },
        controller: ['_', 'TaxonomyService', function(_, taxonomyService) {
                this.isBeforeSelected = $index => ($index + 1) === _.findIndex(this.taxonomy, cat => this.selectedCategoryId === cat.id);

            this.$onInit = () => {
                taxonomyService.getTenantTaxonomy(true).then(results => this.taxonomy = results.data);
            };
        }],
        template: `
            <ul class="streams-sidebar-section" style="padding-left: 0px;">
                <li ng-repeat="category in $ctrl.taxonomy" class="category-row cursor-pointer"
                    ng-class="{'active': category.id === $ctrl.selectedCategoryId, 'last':$last, 'before-active':$ctrl.isBeforeSelected($index)}">
                    <div class="row category-detail-row">
                        <div class="col-md-1" style="margin-top: 9px;">
                            <a ng-show="category.subcategories.length" ng-click="category.expanded = !category.expanded" class="category-toggle"><span class="glyphicon" ng-class="{ 'glyphicon-triangle-right': !category.expanded, 'glyphicon-triangle-bottom': category.expanded}"></span></a>
                        </div>
                        <div class="taxonomy-category-select-link col-md-10" ng-click="$ctrl.selectCategory({category: category})">
                            <h5 class="overflow-ellipsis text-primary" title="{{category.title}}">{{category.title}}</h5>
                        </div>
                    </div>
                    <div ng-if="category.expanded" 
                         class="subcategory row" 
                         ng-repeat="subcategory in category.subcategories"
                         ng-class="{'active': subcategory.id === $ctrl.selectedCategoryId }">
                        <div class="col-md-offset-2 col-md-10" ng-click="$ctrl.selectCategory({category: subcategory})">
                            <h5>{{subcategory.title}}</h5>
                        </div>

                    </div>
                </li>
            </ul>
    `,
    });

'use strict';

angular.module('attensaApp')
    .component('taxonomySidebar', {
        bindings: {
            nodeSelected: '&',
            clearTags: '&'
        },
        controller: ['LabelService', 'TaxonomyService', 'TenantService',
        function(labelService, taxonomyService, tenantService) {
            this.selectNode = (catalog, category) => {
                let newCatalogId = null;
                if(catalog && catalog.catalogId){
                    newCatalogId = catalog.catalogId;
                }else if(catalog){
                    newCatalogId = catalog;
                }

                if(this.catalogId !== newCatalogId){
                    this.clearTags();
                }

                this.catalogId = newCatalogId;

                this.categoryId = category ? category.id : null;

                this.nodeSelected({ catalogId: this.catalogId, categoryId: this.categoryId });

                if(catalog && catalog.catalogId && !this.catalogTaxonomy[catalog.catalogId]) {
                    taxonomyService.getCatalogTaxonomy(catalog.catalogId)
                    .then(categories => this.catalogTaxonomy[catalog.catalogId] = categories);
                }
            };

            this.$onInit = () => {
                this.catalogTaxonomy = {};
                tenantService.getCatalogMap().then(catMap => this.tenantCatalogMap = catMap);
                labelService.setLabel(this, 'catalogNavigationLabel', 'catalog_navigation_label', 'Catalog');
                this.taxonomyOpenMap = { all: true };
                this.catalogId = 'all';
            };
        }],
        template: `
            <uib-accordion>
                
                <uib-accordion-group is-open="$ctrl.taxonomyOpenMap.all" is-disabled="$ctrl.taxonomyOpenMap.all">
                    <uib-accordion-heading>
                        <div class="row" ng-class="{'active': !$ctrl.categoryId && $ctrl.catalogId === 'all', 'before-active': category.id === $ctrl.categoryId}">
                            <div class="col-xs-9">
                                <a id="streams-select-all-taxonomy-button" ng-click="$ctrl.selectNode('all')"><h4 class="text-primary">Everywhere</h4></a>
                            </div>
                        </div>
                    </uib-accordion-heading>
                </uib-accordion-group>
                
                <uib-accordion-group is-open="$ctrl.taxonomyOpenMap.tenant" is-disabled="$ctrl.taxonomyOpenMap.tenant">
                    <uib-accordion-heading>
                        <div class="row" ng-class="{'active': !$ctrl.categoryId && !$ctrl.catalogId, 'before-active': category.id === $ctrl.categoryId}">
                            <div class="col-xs-9">
                                <a id="streams-select-all-taxonomy-button" ng-click="$ctrl.selectNode()"><h4 class="text-primary"> {{$ctrl.catalogNavigationLabel}}</h4></a>
                            </div>
                        </div>
                    </uib-accordion-heading>
                    <taxonomy-categories selected-category-id="$ctrl.categoryId"
                                         select-category="$ctrl.selectNode(null, category)">
                    </taxonomy-categories>
                </uib-accordion-group>
                
                <uib-accordion-group ng-repeat="catalog in $ctrl.tenantCatalogMap" is-open="$ctrl.taxonomyOpenMap[catalog.catalogId]" is-disabled="$ctrl.taxonomyOpenMap[catalog.catalogId]">
                    <uib-accordion-heading>
                        <div class="row" ng-class="{'active': !$ctrl.categoryId && $ctrl.catalogId === catalog.catalogId, 'before-active': category.id === $ctrl.categoryId}" ng-click="$ctrl.selectNode(catalog)">
                            <div class="col-xs-12">
                                <a><h4 class="text-primary"> {{catalog.label}}</h4></a>
                            </div>
                        </div>
                    </uib-accordion-heading>
                    <catalog-categories selected-category-id="$ctrl.categoryId" 
                                        categories="$ctrl.catalogTaxonomy[catalog.catalogId]"
                                        select-category="$ctrl.selectNode(catalog, category)"></catalog-categories>
                </uib-accordion-group>
            </uib-accordion>
        `,
    });

'use strict';

angular.module('attensaApp')
.component('topicBuilderSources', {
    controller: ['_', '$q', '$rootScope', '$state', '$uibModal', 'StreamService',
    function(_, $q, $rootScope, $state, $uibModal, StreamService) {
        var self = this;

        this.$onInit = function() {
            self.hideSources = true;

            $q.all([
                StreamService.getStream($state.params.streamId),
                StreamService.getSubstreams($state.params.streamId, { rows: 1000 })
            ])
            .then(results => {
                self.stream = results[0].data;
                var sourceIds;
                var indexedSources;

                if(self.stream.manuallySorted) {
                    sourceIds = _.map(self.stream.subStreams, 'targetStreamId');
                    indexedSources = _.indexBy(results[1].data.content, 'id');
                    self.sources = _.map(sourceIds, id => indexedSources[id]);
                } else {
                    self.sources = _.sortBy(results[1].data.content, stream => stream.title.toUpperCase());
                }
            });
        };

        this.removeSource = function(sourceId) {
            const modalScope = $rootScope.$new();

            modalScope.modalTitle = ' Remove source?';
            modalScope.message = 'This will remove this source from the current topic.';
            modalScope.confirmLabel = 'Continue';

            $uibModal.open({
                templateUrl: '/templates/ConfirmModal.html',
                size: 'md',
                keyboard: true,
                scope: modalScope
            }).result
            .then(() => {
                _.remove(self.sources, { id: sourceId });
                StreamService.deleteStreamSubscription($state.params.streamId, sourceId);
            });
        };

        this.sourcesReordered = sources => {
            const sourceIds = _.map(self.sources, 'id');

            const indexedSources = _.indexBy(self.stream.subStreams, 'targetStreamId');
            self.stream.subStreams = _.map(sourceIds, id => indexedSources[id]);

            const indexedSubstreamConfigurations = _.indexBy(self.stream.streamConfiguration.subStreamConfigurations, 'streamId');
            self.stream.streamConfiguration.subStreamConfigurations = _.map(sourceIds, id => indexedSubstreamConfigurations[id]);

            self.stream.manuallySorted = true;

            $rootScope.$broadcast('sourcesChanged', self.stream);
        };

        this.startAddSources = () => {
            const scope = $rootScope.$new();
            scope.streamId = $state.params.streamId;
            scope.existingSources = this.sources;
            $uibModal.open({
                template: '<source-finder stream-id="streamId" existing-sources="existingSources" cancel="$dismiss()" done="$close(results)"></source-finder>',
                keyboard: true,
                backdrop: 'static',
                windowClass: 'modal-xl',
                scope: scope,
            }).result
            .then((results) => {
                this.noTouching = true;
                return $q.all(_.map(results.streamIds, streamId => StreamService.postStreamSubscription(self.stream.id, streamId)))
                .finally(() => $state.go('.', {}, { reload: true }));
            });
        };
    }],
    template: `
        <section>
            <spinner ng-if="$ctrl.noTouching"></spinner>
            <section ng-if="!$ctrl.noTouching" class="row" style="padding-top: 10px;">
                <div class="col-md-12">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h3 class="panel-title" style="display: inline-block">Existing sources for this topic</h3>
                            <a class="pull-right" ng-click="$ctrl.startAddSources()">
                                <i class="fa fa-plus"></i> Add new sources
                            </a>
                        </div>
                        <div class="panel-body">
                            <briefing-source-list sources="$ctrl.sources"
                                                  hide-preview="true"
                                                  remove-source="$ctrl.removeSource(sourceId)"
                                                  sources-reordered="$ctrl.sourcesReordered($sources)">
                            </briefing-source-list>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    `,
});

'use strict';

angular.module('attensaApp')
.component('digestEditor', {
    bindings: {
        user: '<',
        previewEnabled: '<',
        externalSave: '<',
        saveAt: '<',
        digestSaved: '&'
    },
    template: `
        <spinner ng-if="!$ctrl.digestConfiguration"></spinner>
        <div class="col-md-7 col-md-offset-3" ng-if="$ctrl.digestConfiguration">
            <div class="page-header" style="margin-bottom: 10px;">
                <h4>
                    <span class="fa fa-envelope-o"></span>&nbsp;&nbsp;{{$ctrl.briefingTitle}}
                    <switch name="active"
                            ng-model="$ctrl.digestConfiguration.schedule.enabled"
                            class="small"
                            on="On"
                            off="Off"
                            style="margin-bottom: -6px; margin-left: 6px">
                    </switch>
                </h4>
            </div>
            <div class="row" ng-if="$ctrl.digestConfiguration.unsubscribed">
                <div class="col-lg-12">
                    <label style="color: red;">* Unsubscribed</label>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <form>
                        <div class="form-group">
                            <label for="title">Email Subject</label>
                            <input type="text" name="title" ng-model="$ctrl.digestConfiguration.title"
                                class="form-control"
                                id="digests-title" required placeholder="Subject line of email">
                        </div>
                        <div class="form-group">
                            <label for="digest-repeat-mode">Repeats</label>
                            <select ng-model="$ctrl.digestConfiguration.schedule.freq" class="form-control"
                                    ng-model="$ctrl.digestConfiguration.freq" id="digest-repeat-mode">
                                <option value="DAILY">Daily</option>
                                <option value="WEEKLY">Weekly</option>
                            </select>
                            <div ng-show="$ctrl.digestConfiguration.schedule.freq === 'WEEKLY'" class="btn-group"
                                style="margin-top: 5px">
                                <label class="btn btn-default" ng-model="$ctrl.sendDay"
                                    uib-btn-radio="'SU'">S</label>
                                <label class="btn btn-default" ng-model="$ctrl.sendDay"
                                    uib-btn-radio="'MO'">M</label>
                                <label class="btn btn-default" ng-model="$ctrl.sendDay"
                                    uib-btn-radio="'TU'">T</label>
                                <label class="btn btn-default" ng-model="$ctrl.sendDay"
                                    uib-btn-radio="'WE'">W</label>
                                <label class="btn btn-default" ng-model="$ctrl.sendDay"
                                    uib-btn-radio="'TH'">T</label>
                                <label class="btn btn-default" ng-model="$ctrl.sendDay"
                                    uib-btn-radio="'FR'">F</label>
                                <label class="btn btn-default" ng-model="$ctrl.sendDay"
                                    uib-btn-radio="'SA'">S</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="digest-description">Send Time</label>
                            <uib-timepicker ng-model="$ctrl.sendTime"></uib-timepicker>
                        </div>
                        <div class="form-group" style="padding-bottom: 15px;">
                            <briefing-timezone-selector briefing-schedule="$ctrl.digestConfiguration.schedule"></briefing-timezone-selector>
                        </div>
                        <button ng-if="$ctrl.previewEnabled" type="submit" class="btn btn-default" ng-click="$ctrl.preview($ctrl.digestConfiguration, $ctrl.sendDay, $ctrl.sendTime, $ctrl.streams)" ng-disabled="$ctrl.saveInProgress">
                            Save & Preview
                        </button>
                        <button ng-if="!$ctrl.externalSave" type="submit" class="btn btn-primary" ng-click="$ctrl.save($ctrl.digestConfiguration, $ctrl.sendDay, $ctrl.sendTime, $ctrl.streams)" ng-disabled="$ctrl.saveInProgress">
                            Save
                        </button>
                    </form>
                </div>
            </div>
        </div>
    `,
    controller: ['$q', 'growl', '_', 'digestService', 'StreamService', 'subscriptionService', 'TenantService', 
        function($q, growl, _, digestService, streamService, subscriptionService, tenantService) {

        const streamFetcher = noFollowing => {
            return noFollowing ? 
            streamService.getTenantStreams({ page: 0, rows: 1000, includeCatalogs: false, published: true }) : 
            subscriptionService.getSubscribedStreams();
        };

        this.preview = (digestConfiguration, sendDay, sendTime, streams) => 
            this.save(digestConfiguration, sendDay, sendTime, streams)
            .then(() => digestService.openDigestPreview(digestConfiguration.id, this.user.id));

        this.save = (digestConfiguration, sendDay, sendTime, streams) => {
            this.saveInProgress = true;
            const digestConfigurationToSave = digestService.compose(digestConfiguration, sendDay, sendTime, _.filter(streams, 'selected'));
            return digestService.putDigestConfiguration(digestConfigurationToSave, this.user.id, digestConfigurationToSave.id)
            .then(() => {
                this.saveInProgress = false;
                this.digestSaved();
            })
            .catch(() => growl.error('An error ocurred saving your personal digest'));
        };
    
        this.setSelected = (streams, val) => _.forEach(streams, stream => stream.selected = val);

        this.$onChanges = () => {
            if(this.user && !this.tenant){
                tenantService.getCurrentTenant()
                .then(tenant => {
                    const noFollowing = tenant.data.settings.noFollowing;
                    this.briefingTitle = noFollowing ? 'My Briefing' : 'Personal Email Digest';
                    this.tenant = tenant.data;
        
                    return $q.all([
                        streamFetcher(noFollowing),
                        digestService.resolveUserDigestConfiguration(this.user, true)
                    ])
                    .then(responses => {
                        const rawStreams = noFollowing ? responses[0].data.content : subscriptionService.flatten(responses[0]);
                        this.digestConfiguration = responses[1];
        
                        this.saveInProgress = false;
                        this.sendDay = digestService.getSendDay(this.digestConfiguration);
                        this.sendTime = new Date(1900, 1, 1, this.digestConfiguration.schedule.sendHour, this.digestConfiguration.schedule.sendMinute);
                        this.streams = _.map(rawStreams, stream => {
                            stream.selected = _.includes(this.digestConfiguration.content.streamIds, stream.id) ? true : false;
                            return stream;
                        });    
                    });
                });
            } 
            if(this.saveAt && (!this.savedAt || this.saveAt > this.savedAt)) {
                this.savedAt = this.saveAt;
                this.save(this.digestConfiguration, this.sendDay, this.sendTime, this.streams);
            }
        };
    }]
});

'use strict';

angular.module('attensaApp')
    .component('emailControl', {
        bindings: {
            user: '<',
            onChange: '&'
        },
        template: [
            '<md-input-container class="md-input-has-value" ng-form="form" flex>',
                '<label>Email Address</label>',
                '<input ng-blur="$ctrl.setFocused()" ng-focus="$ctrl.setFocused(true)" type="email" name="emailAddress" placeholder="Email Address" ng-model="$ctrl.editVal" validate-unique-email current-email="{{$ctrl.user.emailAddress}}" required ng-change="$ctrl.changed(form.emailAddress.$valid)">',
                '<div class="has-error" ng-messages="form.emailAddress.$error">',
                    '<small class="help-block" ng-message="required">Email Address is required and cannot be empty</small>',
                    '<small class="help-block" ng-message="email">Please enter a correct email address</small>',
                    '<small class="help-block" ng-message="uniqueEmail">The email address you have entered already exists, please enter another email address</small>',
                '</div>',
            '</md-input-container>'
        ].join('\n'),
        controller: ['_',
            function(_) {
                var self = this;

                this.setFocused = function(isFocused){
                    self.focused = isFocused;
                };

                this.$onChanges = function(){
                    if(!self.focused && self.user){
                        self.editVal = self.user.emailAddress;
                    }
                };

                this.changed = _.debounce(function(isValid){
                    if(isValid){
                        self.onChange({ $value: self.editVal });
                    }
                }, 1000);
            }]
    });

'use strict';

angular.module('attensaApp')
.component('groupPicker', {
    bindings: {
        selectedGroups: '='
    },
    template: `
        <md-list style="max-height: 150px; overflow-y: auto;">
            <md-list-item ng-repeat="group in $ctrl.groups">
                <p>{{group.name}}</p>
                <md-checkbox class="md-secondary" ng-model="$ctrl.selectedGroups[group.id]"></md-checkbox>
            </md-list-item>
        </md-list>
    `,
    controller: ['groupsService', function(groupsService) {
        this.$onInit = () => groupsService.fetchGroups().then(groupResponse => this.groups = groupResponse.data.content);
    }]
});

'use strict';

angular.module('attensaApp')
    .component('nameControl', {
        bindings: {
            label: '@',
            attribute: '@',
            user: '<',
            onChange: '&'
        },
        template: [
        '<md-input-container class="md-input-has-value" flex ng-form="form">',
            '<label>{{$ctrl.label}}</label>',
            '<input name="control" ng-blur="$ctrl.setFocused()" ng-focus="$ctrl.setFocused(true)" ng-model="$ctrl.editVal" required ng-change="$ctrl.changed(form.control.$valid)">',
            '<div ng-messages="form.control.$error">',
                '<div class="validation-warning" ng-message="required">{{$ctrl.label}} is required</div>',
            '</div>',
        '</md-input-container>'
        ].join('\n'),
        controller: ['_',
            function(_) {
                var self = this;

                this.setFocused = function(isFocused){
                    self.focused = isFocused;
                };

                this.$onChanges = function(){
                    if(!self.focused && self.user && self.attribute){
                        self.editVal = self.user[self.attribute];
                    }
                };

                this.changed = _.debounce(function(isValid){
                    if(isValid){
                        self.onChange({ $value: self.editVal });
                    }
                }, 1000);
            }]
    });

'use strict';

angular.module('attensaApp')
.controller('AddPeopleCtrl', ['$q', '$uibModalInstance', '_', 'eventService', 'growl', 'digestService', 'UserService', 'groupsService', 'TenantService', 'tenantTimeZone',
function($q, $uibModalInstance, _, eventService, growl, digestService, userService, groupsService, tenantService, tenantTimeZone) {

    this.initialize = () => tenantService.getCurrentTenant().then(result => {
        this.selectedGroups = {};
        this.tenant = result.data;
        this.totalUsers = [{
            activateDigest: this.tenant.settings.noInitialDigest !== 'true'
        }];
    });

    this.cancel = $uibModalInstance.dismiss;

    this.addUsers = (users, status) => {
        const groupIds = _.reduce(this.selectedGroups, (acc, val, key) => val ? _.union(acc, [key]) : acc, []);
        this.adding = true;
        eventService.postEvent(status === 'INACTIVE' ? 'user_added' : 'user_invited', this._formatInvitedUserDataForEvent(users));

        const usersToSave = _.map(users, user  => _.assign(user, { status: status, timeZone: tenantTimeZone || 'US/Pacific' }));
        return userService.addNewUsers(usersToSave)
        .then(results => {
            let groupChain;
            const promises = _.map(results.data, (user, index) => {
                _.forEach(groupIds, groupId => {
                    groupChain = groupChain ? groupChain.then(groupsService.addUser(groupId, user.id)) : groupsService.addUser(groupId, user.id);
                });
                return digestService.resolveUserDigestConfiguration(user, !usersToSave[index].activateDigest);
            });
            promises.push(groupChain);
            return $q.all(promises);
        })
        .then(() => $uibModalInstance.close(usersToSave))
        .catch(err => {
            $uibModalInstance.dismiss();
            growl.error(err && err.status && err.status === 409 ? 
                'The provided email is already in use by an archived user and cannot be reused.' : 
                'An error occurred. Not all users may have been saved. Please refresh your browser.');
        });
    };

    this._formatInvitedUserDataForEvent = users => ({
        invited_users_emails: _.pluck(users, 'emailAddress'),
        invited_users_firstName: _.pluck(users, 'firstName'),
        invited_users_lastName: _.pluck(users, 'lastName'),
        invited_users_message: _.pluck(users, 'inviteMessage')
    });

    this.addAnotherRow = form => form.$valid ? this.totalUsers.push({ activateDigest: this.tenant.settings.noInitialDigest !== 'true' }) : null;

    this.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingViewCtrl', ['$scope', '$sce', '$stateParams', function($scope, $sce, $stateParams) {
    $scope.initialize = function () {
        $scope.briefingUrl = $sce.trustAsResourceUrl('/ws/briefing/render?id=' + $stateParams.id + '&briefingHistoryId=' + $stateParams.briefingHistoryId);
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
    .controller('BriefingInvitationCtrl', ['$state', '$mdToast', '$mdConstant', '_', 'BriefingService', 'UserService', 'UtilService',
        function($state, $mdToast, $mdConstant, _, briefingService, userService, utilService){

            var self = this;
            var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

            this.noTouching = true;

            this.customKeys = [
                $mdConstant.KEY_CODE.ENTER,
                $mdConstant.KEY_CODE.SPACE,
                $mdConstant.KEY_CODE.COMMA,
                $mdConstant.KEY_CODE.SEMICOLON
            ];

            this.init = function(){
                self.invitation = { emails: [] };

                if ($state.params.briefingId) {
                    userService.getCurrentUser(true)
                    .then(function(userResult) {
                        self.loadBriefing(userResult.data.user);

                        if(!self.user && $state.params.userId){
                            userService.canActivate($state.params.userId)
                            .then(function(results){
                                if(results.canActivate){
                                    self.startActivation(results.user);
                                }else {
                                    self.logIn();
                                }
                            });
                        }else if(!self.user){
                            self.logIn();
                        }
                    });
                } else {
                    $state.go('preferences', {invitationMessage: 'No briefing to invite to.'});
                }
            };

            this.startActivation = function(user){
                self.noTouching = true;
                return utilService.showModal([
                    '<md-dialog flex="50">',
                        '<change-password cancel="$ctrl.cancel()" done="$ctrl.done(result)" title="$ctrl.title"></change-password>',
                    '</md-dialog>'
                ].join('\n'), { title: 'Set your password'})
                .then(function(password){
                    user.password = password;
                    return userService.activateUser(user);
                })
                .then(self.loadBriefing)
                .finally(function(){
                    self.noTouching = false;
                });
            };

            this.logIn = function(){
                userService.login().then(self.loadBriefing)
                .catch(function(){
                    self.noTouching = false;
                });
            };

            this.logOut = function(){
                userService.destroySession()
                .then(function(){
                    $state.go('preferences');
                });
            };

            this.loadBriefing = function(user){
                if(user) {
                    self.user = user;
                    briefingService.getBriefing($state.params.briefingId)
                    .then(function (briefing) {
                        self.briefing = briefing;
                        self.invitation.briefingTitle = briefing.briefingTitle;
                        self.noTouching = false;
                    })
                    .catch(function () {
                        $state.go('preferences', {invitationMessage: 'Cannot invite to a non-existent briefing.'});
                    });
                }
            };

            this.validateEmails = function(){
                var invalidEmails = _(self.invitation.emails)
                    .map(function(email){
                        return reg.test(email.toLowerCase()) ? undefined : email;
                    })
                    .omitBy(_.isUndefined)
                    .values()
                    .value();

                if(invalidEmails.length && invalidEmails.length < 2){
                    self.badEmailMessage = 'The email address (' + invalidEmails.join() + ') is invalid.';
                }else if(invalidEmails.length){
                    self.badEmailMessage = 'These email addresses ( '+ invalidEmails.join(', ') + ' ) are invalid.';
                }else{
                    self.badEmailMessage = undefined;
                }
            };

            this.sendInvitation = function(){
                self.noTouching = true;
                self.invitation.emails = _.map(self.invitation.emails, email => email.toLowerCase());
                briefingService.inviteToBriefing(self.briefing.id, self.invitation)
                .then(function(){
                    var message = self.invitation.emails.length === 1 ? 'Invitation' : 'Invitations';
                    message += ' sent to ' + self.invitation.emails.join(', ');
                    $state.go('preferences', {
                        invitationMessage: message
                    });
                })
                .catch(function(){
                    self.noTouching = false;
                    $mdToast.show($mdToast.simple()
                            .textContent('Errors occurred, please try again or contact your site administrator.')
                            .position('top right'));
                });
            };

            this.init();
        }]);

'use strict';

angular.module('attensaApp')
.controller('CatalogCategorySelectionModalCtrl',
    ['_', '$scope', '$rootScope', '$uibModalInstance', 'TaxonomyService', 'taxonomy', 'stream', 'growl', 'catalogId', 'selectedCategories', 'StreamService',
        function(_, $scope, $rootScope, $uibModalInstance, taxonomyService, taxonomy, stream, growl, catalogId, selectedCategories, StreamService) {

            $scope.init = function() {
                $scope.taxonomy = taxonomy;
                $scope.searchText = '';
            };

            var loadTaxonomy = function() {
                taxonomyService.getCatalogTaxonomy(catalogId, { filterEmpty: false })
                .then(function(taxonomy) {
                    taxonomyService.setCatalogTaxonomyDataOnScope(taxonomy, $scope);
                });
            };

            $scope.saveNewCategory = function(title, parent) {
                if(title.toLowerCase().indexOf('uncategorized') > -1) {
                    growl.error('Naming a category as "uncategorized" is invalid.');
                    return false;
                }

                if(!parent) {
                    $scope.taxonomy.unshift({
                        title: title,
                        removable: true
                    });
                } else {
                    if (!parent.subcategories) {
                        parent.subcategories = [];
                    }
                    parent.subcategories.push({
                        title: title,
                        subcategories: [],
                        removable: true
                    });
                }

                $scope.newCategory = { title: '' };
                return $scope.saveCatalogTaxonomy(catalogId, title, $scope, growl, loadTaxonomy);
            };

            $scope.saveCatalogTaxonomy = function(title) {
                taxonomyService.saveCatalogTaxonomy(catalogId, title, $scope, growl, loadTaxonomy)
                .then(function() {
                    $rootScope.$broadcast('taxonomyUpdated', { taxonomy: $scope.taxonomy } );
                });
            };

            $scope.toggleSelection = function(category) {
                if(!category.selected) {
                    StreamService.removeStreamFromCatalogCategory(stream.id, catalogId, category.id);
                    _.remove(selectedCategories, function(selectedCategory){
                        return selectedCategory.categoryId === category.id;
                    });
                } else {
                    StreamService.categorizeStreamInCatalog(stream.id, catalogId, category.id);
                    selectedCategories.push({ categoryId: category.id, categoryName: category.title });
                }
            };

            $scope.close = function() {
                $uibModalInstance.close(selectedCategories);
            };

            $scope.init();
        }]);

'use strict';

angular.module('attensaApp')
.controller('ConfirmInviteCtrl', ['$scope', '$uibModalInstance', 'items', function($scope, $uibModalInstance, items) {

    $scope.initialize = function() {
        if(items) {
            if(items[0].status === 'INACTIVE') {
                $scope.titleText = 'Added!';
                $scope.action = 'added';
            } else {
                $scope.titleText = 'Invited!';
                $scope.action = 'invited';
            }
            $scope.inviteCount = items.length;
        } else {
            $scope.inviteCount = 0;
        }
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('CopyToStreamModalCtrl', ['_', '$q', '$scope', '$uibModalInstance', 'itemId', 'currentStreamId', 'StreamService', 'ItemService', 'UserService', 'doCurate',
    function(_, $q, $scope, $uibModalInstance, itemId, currentStreamId, streamService, itemService, userService, doCurate) {

    $scope.initialize = function() {
        $scope.doCurate = doCurate;
        $scope.streams = [];
        $scope.selectedStreams = [];
        userService.getCurrentUser().then(function(user){
            $scope.user = user.data.user;
            $scope.userFullName = user.data.user.firstName + ' ' + user.data.user.lastName;
        });
    };

    $scope.copyToStream = function(selectedStreams, doCurate) {
        if(doCurate) {
            itemService.openPostItemModal(selectedStreams, itemId, $scope.userFullName, $uibModalInstance.close);
        } else {
            _.each(selectedStreams, function(selectedStream) {
                streamService.copyToStream(itemId, selectedStream.id);
            });
            $uibModalInstance.close();
        }
    };

    $scope.selectStream = function($item) {
        $scope.selectedStreams.push($item);
    };

    $scope.removeStream = function($item) {
        $scope.selectedStreams = _.reject($scope.selectedStreams, { id: $item.id });
    };

    $scope.checkStream = function(searchTerm) {
        $scope.loadingStreams = true;
        return $scope.getCopyableStreamsForTerm(searchTerm)
        .then(function(streams) {
            $scope.loadingStreams = false;
            if(streams.length === 0) {
                $scope.streamWarningText = 'No eligible streams found';
            } else {
                $scope.streamWarningText = false;
            }
            $scope.streams = streams;
            return streams;
        });
    };

    $scope.getCopyableStreamsForTerm = function(searchTerm) {
        return $q.all([
            streamService.getTenantStreams({ type: 'COLLECTION', rows: 40, term: searchTerm, allowedAction: 'COPY_TO_STREAM' }),
            streamService.getTenantStreams({ type: 'COLLECTION', rows: 40, term: searchTerm, ownerId: $scope.user.id })
        ])
        .then(function(results) {
            return _.chain(_.uniq(_.union(results[0].data.content, results[1].data.content), 'id'))
            .reject(function(stream) {
                return stream.id === currentStreamId || _.findWhere($scope.selectedStreams, { id: stream.id });
            })
            .sortBy(function(stream) {
                return stream.title.toLowerCase();
            })
            .value();
        });
    };

}]);

'use strict';

angular.module('attensaApp').controller('DigestPreviewCtrl',
['$scope', '$sce', 'digestService', 'previewUrl',
function($scope, $sce, digestService, previewUrl) {
    $scope.digestPreviewUrl = $sce.trustAsResourceUrl(previewUrl);
}]);

'use strict';

angular.module('attensaApp')
.controller('EditGroupBriefingsCtrl', ['_', '$q', '$scope', '$rootScope', 'BriefingService', 'groupsService', 'UtilService', 'ItemService', 'StreamService', 'growl',
function(_, $q, $scope, $rootScope, briefingService, groupsService, utilService, itemService, streamService, growl) {

    const fetchGroupBriefing = () => {
        groupsService.getBriefingSubscriptions({ params: this.params })
        .then(streamResponse => {
            this.briefings = _.union(this.briefings, streamResponse.data.content);
            this.params.sort = streamResponse.data.sort[0].property;
            this.params.sortDirection = streamResponse.data.sort[0].direction;
            this.last = streamResponse.data.last;
            $scope.briefingCount.val = streamResponse.data.totalElements;
            this.gettingBriefings = false;
            this.noSubscribedBriefings = this.briefings.length !== 0 ? false : true;
        });
    };

    const fetchPublishedBriefings = () => {
        $q.all([
            groupsService.fetchGroup($scope.group.id),
            briefingService.getBriefings({params: this.params})
        ])
        .then(results => {
            const group = results[0].data;
            const response = results[1];
            const subscribedMap = _.map(group.subscriptions, sub => sub.subscribeToBriefing ? sub.briefingId : undefined);
            this.briefings = _.union(this.briefings, response.content);
            _.forEach(this.briefings, briefing => {
                briefing.groupIsSubscribed = !!subscribedMap.includes(briefing.id); 
            });
            this.last = response.last;
            this.gettingBriefings = false;
        });
    };

    const getFreshBriefings = () => {
        this.params.page = 0;
        this.briefings = [];
        if(this.fetchAll) {
            fetchPublishedBriefings();
        } else {
            fetchGroupBriefing();
        }
    };

    this.init = () => {
        this.params = {
            groupId: $scope.group.id,
            page: -1, //Prime for initial infinite scroll event
            rows: 20,
        };

        this.briefings = [];
    };

    this.filteredFrequencies = utilService.filteredFrequencies;

    this.nextPage = () => {
        if(!this.gettingBriefings) {
            this.gettingBriefings = true;
            this.params.page++;
            if(this.fetchAll) {
                fetchPublishedBriefings();
            } else {
                fetchGroupBriefing();
            }
        }
    };

    this.briefingFetcherChanged = () => getFreshBriefings();

    this.toggleSort = sortOptions => {
        // Disable sort toggling if there's only one or no stream
        if(this.briefings.length === 0 || this.briefings.length === 1) {
            return;
        }
        this.params.sortDirection = sortOptions.sortDirection;
        this.params.sort = sortOptions.sort;
        getFreshBriefings();
    };


    this.toggleBriefingSubscription = briefing => {
        if(briefing.groupIsSubscribed){
            groupsService.unsubscribeFromBriefing($scope.group, briefing.id)
            .then(() => {
                briefing.groupIsSubscribed = false;
                $rootScope.$broadcast('group.briefingCountChanged');
            })
            .catch(() => growl.error('An error editing briefing occurred. Please refresh your browser.'));    
        } else {
            groupsService.subscribeToBriefing($scope.group, briefing.id, briefing.streamId)
            .then(() => {
                briefing.groupIsSubscribed = true;
                $rootScope.$broadcast('group.briefingCountChanged');
            })
            .catch(() => growl.error('An error editing briefing occurred. Please refresh your browser.'));
        }
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('EditGroupStreamsCtrl', ['_', '$q', '$scope', '$rootScope', 'groupsService', 'StreamService',
function(_, $q, $scope, $rootScope, groupsService, streamService) {

    const initialSortMap = {
        titleLower: 'ASC',
        followersCount: 'DESC',
        itemsCount: 'DESC'
    };

    const getFreshStreams = () => {
        this.params.page = 0;
        this.streams = [];
        if(this.fetchAll) {
            fetchPublishedStreams();
        } else {
            fetchGroupStreams();
        }
    };

    const fetchGroupStreams = () => groupsService.getStreams({ params: this.params })
    .then(streamResponse => {
        this.streams = _.union(this.streams, streamResponse.data.content);
        this.params.sort = streamResponse.data.sort[0].property;
        this.params.sortDirection = streamResponse.data.sort[0].direction;
        this.last = streamResponse.data.last;
        $scope.streamCount.val = streamResponse.data.totalElements;            
        this.gettingStreams = false;
        this.notFollowingStreams = this.streams.length !== 0 ? false : true;
    });

    const fetchPublishedStreams = () =>
        $q.all([
            groupsService.fetchGroup($scope.group.id),
            streamService.getTenantStreams({
                includeCatalogs: true, 
                published: true, 
                page: this.params.page, 
                rows: this.params.rows, 
                term: this.params.term
            })
        ])
        .then(response => {
            const group = response[0].data;
            const streamResponse = response[1];
            const subscribedMap = _.map(group.subscriptions, sub => sub.follow ? sub.streamId : undefined);
            _.forEach(streamResponse.data.content, stream => {
                stream.groupIsFollowing = !!subscribedMap.includes(stream.id); 
            });
            this.streams = _.union(this.streams, streamResponse.data.content);
            this.params.sort = streamResponse.data.sort[0].property;
            this.params.sortDirection = streamResponse.data.sort[0].direction;
            this.last = streamResponse.data.last;
            this.gettingStreams = false;
            this.notFollowingStreams = this.streams.length !== 0 ? false : true;
        });

    this.init = () => {
        $scope.$watch('addStreamsView', val => val === false ? getFreshStreams() : undefined);

        this.params = {
            groupId: $scope.group.id,
            page: -1, //Prime for initial infinite scroll event
            rows: 40,
        };
        this.streams = [];
    };

    this.streamFetcherChanged = () => getFreshStreams();

    this.isSort = (sort, sortDirection) =>  this.params.sort === sort && this.params.sortDirection === sortDirection;

    this.toggleSort = sort =>  {
        // Disable sort toggling if there's only one or no stream
        if(this.streams.length === 0 || this.streams.length === 1) {
            return;
        }

        if (this.params.sort === sort) {
            this.params.sortDirection =  this.params.sortDirection === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.params.sort = sort;
            this.params.sortDirection = initialSortMap[sort] || 'DESC';
        }
        getFreshStreams();
    };

    this.searchStreams = () => getFreshStreams();

    this.clearSearch = () => {
        this.params.term = null;
        getFreshStreams();
    };

    this.nextPage = () => {
        if(!this.gettingStreams) {
            this.gettingStreams = true;
            this.params.page++;
            if(this.fetchAll) {
                fetchPublishedStreams();
            } else {
                fetchGroupStreams();
            }            
        }
    };

    this.followGroup = stream => {
        const options = {
            groupId: $scope.group.id,
            streamId: stream.id,
            briefingId: stream.briefingId,
            follow: !stream.groupIsFollowing,
            subscribeToBriefing: !stream.groupIsFollowing ? stream.groupIsSubscribed : false
        };

        if (options.follow) {
            groupsService.addToStream(options)
            .then(() => {
                stream.groupIsFollowing = options.follow;
                stream.groupIsSubscribed = options.subscribeToBriefing;
                stream.followersCount = stream.followersCount + $scope.group.membersCount;
                $rootScope.$broadcast('group.streamCountChanged');
            });
        } else {
            groupsService.deleteFromStream(options)
            .then(() => {
                stream.groupIsFollowing = options.follow;
                stream.groupIsSubscribed = options.subscribeToBriefing;
                stream.followersCount = stream.followersCount - $scope.group.membersCount;
                $rootScope.$broadcast('group.streamCountChanged');
            });
        }
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
    .controller('EditUserModalCtrl', ['_', '$scope', '$uibModalInstance', 'eventService', 'growl', 'imageService', 'UtilService', 'UserService', 'user', 'tenantRoles', 'currentUser', 'tenant', 'StreamService', 'digestService',
    function(_, $scope, $uibModalInstance, eventService, growl, imageService, utilService, userService, user, tenantRoles, currentUser, tenant, StreamService, digestService) {

        $scope.initialize = function() {
            $scope.user = user;
            $scope.currentUser = currentUser;
            $scope.tenant = tenant;
            $scope.noFollowing = tenant.settings.noFollowing;
            $scope.allowStreamCreator = _.find(tenant.settings.allowRoleTypes, function(role){ return role === 'STREAM_CREATOR'; });
            $scope.tenantRoles = tenantRoles;
            $scope.isModal = true;
            $scope.config = {
                target: 'profile'
            };
            $scope.wasAdmin = user.admin;
            $scope.wasStreamCreator = user.streamCreator;
            if($scope.user.largeImageUri) {
                $scope.backgroundImage = $scope.user.largeImageUri ?
                {'background-image': 'url(' + $scope.user.largeImageUri + ')'} : {'background-image' : 'none'};
            }
            $scope.profilePic = {};
            $scope.displayTimezones = utilService.displayTimezones;
            userService.getUserStreams({ params: { targetUserId: user.id } })
            .then(function(streamResponse) {
                $scope.streamCount = { val: streamResponse.data.totalElements };
            });
            userService.getUserBriefings({ params: { targetUserId: user.id } })
            .then(function(streamResponse) {
                $scope.briefingCount = { val: streamResponse.data.totalElements };
            });
            userService.getUserGroups({ params: { targetUserId: user.id } })
            .then(function(groupReponse) {
                $scope.groupCount = { val: groupReponse.data.totalElements };
            });
            StreamService.getTenantStreams({ includeCatalogs: false, ownerId: $scope.user.id })
            .then(function(ownedStreamsResponse) {
                $scope.ownedStreamCount = { val: ownedStreamsResponse.data.totalElements };
            });
            digestService.resolveUserDigestConfiguration(user, true)
            .then(digestConfiguration => $scope.digestConfiguration = digestConfiguration);
        };

        $scope.saveDigest = () => $scope.saveAt = Date.now();

        $scope.digestSaved = () => $uibModalInstance.dismiss();

        $scope.save = function(){
            $scope.saving = true;
            eventService.postEvent('user_edited', eventService.formatUser($scope.user, 'edited'))
            .then(function() {
                var saveUserPromise = ($scope.currentUser) ? userService.persistCurrentUser($scope.user) : userService.persistUser($scope.user);
                return saveUserPromise;
            })
            .then(function() {
                if(user.admin !== $scope.wasAdmin) {
                    var adminUpdater = user.admin ? userService.addTenantRole : userService.removeTenantRole;
                    return adminUpdater(user.id, $scope.tenant.id, 'TENANT_ADMIN')
                    .then(function(updatedUser) {
                        $scope.user.tenantRoles = updatedUser.tenantRoles;
                    });
                }
            })
            .then(function() {
                if(user.streamCreator !== $scope.wasStreamCreator) {
                    var streamCreatorUpdater = user.streamCreator ? userService.addTenantRole : userService.removeTenantRole;
                    return streamCreatorUpdater(user.id, $scope.tenant.id, 'STREAM_CREATOR')
                    .then(function(updatedUser) {
                        $scope.user.tenantRoles = updatedUser.tenantRoles;
                    });
                }
            })
            .then(function(result){
                if($scope.profilePic.value && $scope.profilePic.value.length !== 0) {
                    return userService.savePicture($scope.user.id, $scope.profilePic.value[0])
                    .then(function(saveImageResult) {
                        $scope.user.largeImageUri = saveImageResult.data.largeImage.uri;
                        $uibModalInstance.close($scope.user);
                    });
                }else{
                    $uibModalInstance.close($scope.user);
                }
            })
            .catch(function() {
                growl.error('An error occurred. Changes to the user may not have been saved. Please refresh your browser.');
                $uibModalInstance.dismiss();
            });
        };

        $scope.generateThumb = function(file) {
            imageService.pickImage(file)
            .then(function(localImageUrl) {
                file.dataUrl = localImageUrl;
                $scope.user.hasNewPic = true; // For triggering unsaved warning
                $scope.previewBackgroundImage = { 'background-image': 'url(' + localImageUrl + ')' };
            });
        };

        $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('EditUserBriefingsModalCtrl', ['_', '$scope', 'UserService', 'UtilService', 'BriefingSubscriptionService', 'ItemService', 'StreamService', 'growl',
function(_, $scope, userService, utilService, briefingSubscriptionService, itemService, streamService, growl) {
    $scope.init = function() {
        $scope.params = {
            onlyBriefingSubscriptions: true,
            targetUserId: $scope.user.id,
            page: -1, //Prime for initial infinite scroll event
            rows: 20,
        };

        $scope.briefings = [];
    };

    $scope.$on('stream-changed', function(evt, stream) {
        getFreshBriefings();
        userService.getUserStreams({ params: { targetUserId: $scope.user.id } })
        .then(function(streamResponse) {
            $scope.streamCount.val = streamResponse.data.totalElements;
        });
    });

    $scope.filteredFrequencies = utilService.filteredFrequencies;

    $scope.tooltipManager = function(stream, isBriefing) {
        return utilService.tooltipManager(stream, isBriefing);
    };

    $scope.nextPage = function() {
        if(!$scope.gettingBriefings) {
            $scope.gettingBriefings = true;
            $scope.params.page++;
            fetchUserBriefing();
        }
    };

    $scope.toggleSort = function(sortOptions) {
        // Disable sort toggling if there's only one or no stream
        if($scope.briefings.length === 0 || $scope.briefings.length === 1) {
            return;
        }
        $scope.params.sortDirection = sortOptions.sortDirection;
        $scope.params.sort = sortOptions.sort;
        getFreshBriefings();
    };

    $scope.$on('follow-change', function(evt, evtData) {
        $scope.briefingCount.val += evtData.stream.userIsSubscribedToBriefing ? 1 : -1;
    });

    $scope.viewStreamDetails = function(stream) {
        streamService.openStreamDetailModal(stream).result
        .then(function(item) {
            if(item){
                itemService.openNewModal({
                    itemId: item.id,
                    hasPrevious: false,
                    hasNext: false,
                    streamContext: stream.id
                });
            }
        });
    };

    var getFreshBriefings = function() {
        $scope.params.page = 0;
        $scope.briefings = [];
        fetchUserBriefing();
    };

    var fetchUserBriefing = function() {
        userService.getUserBriefings({ params: $scope.params })
        .then(function(response) {
            $scope.briefings = _.union($scope.briefings, response.data.content);
            $scope.params.sort = response.data.sort[0].property;
            $scope.params.sortDirection = response.data.sort[0].direction;
            $scope.last = response.data.last;
            $scope.briefingCount.val = response.data.totalElements;
            $scope.gettingBriefings = false;
            $scope.noSubscribedBriefings = $scope.briefings.length !== 0 ? false : true;
        });
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('EditUserGroupsModalCtrl', ['_', '$scope', 'UserService', 'groupsService', 'growl', 'TenantService',
function(_, $scope, userService, groupsService, growl, tenantService) {
    $scope.init = () => {
        $scope.params = {
            targetUserId: $scope.user.id,
            page: -1, //Prime for initial infinite scroll event
            rows: 20,
        };

        $scope.groups = [];
    };

    $scope.nextPage = ()  => {
        if(!$scope.gettingGroups) {
            $scope.gettingGroups = true;
            $scope.params.page++;
            fetchUserGroups();
        }
    };

    $scope.toggleSort = sortOptions =>  {
        // Disable sort toggling if there's only one or no stream
        if($scope.groups.length === 0 || $scope.groups.length === 1) {
            return;
        }
        $scope.params.sortDirection = sortOptions.sortDirection;
        $scope.params.sort = sortOptions.sort;
        getFreshGroups();
    };

    $scope.editGroup = group => groupsService.editGroupModal(group, tenantService.getCurrentTenant());

    $scope.userInGroup = function(userId, groupMembers) {
        return _.includes(groupMembers, userId);
    };

    const addToGroup = (group, userId) => {
        group.members.push(userId);
        return groupsService.addUser(group.id, userId);
    };

    const removeFromGroup = (group, userId) => {
        _.pull(group.members, userId);
        return groupsService.removeUser(group.id, userId);
    };

    $scope.toggleGroupSubscription = function(user, group) {
        if(!$scope.toggleGroupPromise) {
            $scope.toggleGroupPromise = 
            ($scope.userInGroup(user.id, group.members) ? 
                removeFromGroup(group, user.id) : 
                addToGroup(group, user.id))
            .finally(() => $scope.toggleGroupPromise = null)
            .catch(() => growl.error('An error editing group occurred. Please refresh your browser.'));
        }
    };

    const fetchUserGroups = () => {
        userService.getUserGroups({ params: $scope.params })
        .then(groupReponse => {
            $scope.groups = _.union($scope.groups, groupReponse.data.content);
            $scope.params.sort = groupReponse.data.sort[0].property;
            $scope.params.sortDirection = groupReponse.data.sort[0].direction;
            $scope.last = groupReponse.data.last;
            $scope.groupCount.val = groupReponse.data.totalElements;
            $scope.gettingGroups = false;
            $scope.notInGroups = $scope.groups.length !== 0 ? false : true;
        });
    };

    const getFreshGroups = () => {
        $scope.params.page = 0;
        $scope.groups = [];
        fetchUserGroups();
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('EditUserStreamsModalCtrl', ['_', '$scope', 'categoryService', 'ItemService', 'StreamService',
'BriefingSubscriptionService', 'TaxonomyService', 'UserService', 'UtilService',
function(_, $scope, categoryService, itemService, streamService,
briefingSubscriptionService, taxonomyService, userService, utilService) {
    $scope.init = function() {
        $scope.params = {
            targetUserId: $scope.user.id,
            page: -1, //Prime for initial infinite scroll event
            rows: 40,
        };
        $scope.streams = [];
        taxonomyService.getTenantTaxonomy()
        .then(function(results) {
            $scope.taxonomy = results.data;
        });
    };

    $scope.$on('stream-changed', function(evt, stream) {
        getFreshStreams();
        userService.getUserStreams({ params: { targetUserId: $scope.user.id, onlyBriefingSubscriptions: true } })
        .then(function(streamResponse) {
            $scope.briefingCount.val = streamResponse.data.totalElements;
        });
    });

    var initialSortMap = {
        titleLower: 'ASC',
        followersCount: 'DESC',
        itemsCount: 'DESC'
    };

    $scope.isSort = function(sort, sortDirection) {
        return $scope.params.sort === sort && $scope.params.sortDirection === sortDirection;
    };

    $scope.toggleSort = function(sort) {
        // Disable sort toggling if there's only one or no stream
        if($scope.streams.length === 0 || $scope.streams.length === 1) {
            return;
        }

        if ($scope.params.sort === sort) {
            $scope.params.sortDirection =  $scope.params.sortDirection === 'ASC' ? 'DESC' : 'ASC';
        } else {
            $scope.params.sort = sort;
            $scope.params.sortDirection = initialSortMap[sort] || 'DESC';
        }
        getFreshStreams();
    };

    $scope.searchStreams = function() {
        getFreshStreams();
    };

    $scope.clearSearch = function() {
        $scope.params.term = null;
        getFreshStreams();
    };

    $scope.nextPage = function() {
        if(!$scope.gettingStreams) {
            $scope.gettingStreams = true;
            $scope.params.page++;
            fetchUserStreams();
        }
    };

    var getFreshStreams = function() {
        $scope.params.page = 0;
        $scope.streams = [];
        fetchUserStreams();
    };

    var fetchUserStreams = function() {
        userService.getUserStreams({ params: $scope.params })
        .then(function(streamResponse) {
            $scope.streams = _.union($scope.streams, streamResponse.data.content);
            $scope.params.sort = streamResponse.data.sort[0].property;
            $scope.params.sortDirection = streamResponse.data.sort[0].direction;
            $scope.last = streamResponse.data.last;
            $scope.streamCount.val = streamResponse.data.totalElements;
            $scope.gettingStreams = false;
            $scope.notFollowingStreams = $scope.streams.length !== 0 ? false : true;
        });
    };

    $scope.viewStreamDetails = function(stream) {
        streamService.openStreamDetailModal(stream).result
        .then(function(item) {
            if(item){
                itemService.openNewModal({
                    itemId: item.id,
                    hasPrevious: false,
                    hasNext: false,
                    streamContext: stream.id
                });
            }
        });
    };

    $scope.openFollowersModal = streamService.openFollowersModal;

    $scope.tooltipManager = function(stream, isBriefing) {
        return utilService.tooltipManager(stream, isBriefing);
    };

    $scope.$on('follow-change', function(evt, evtData) {
        $scope.streamCount.val += evtData.stream.userIsFollowing ? 1 : -1;
        categoryService.updatePersonalCategory(evtData.stream, evtData.stream.userIsFollowing, $scope.taxonomy, $scope.user, $scope.selectedCategory)
        .then(function(updatedUser) {
            $scope.user = updatedUser;
        });
    });

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('EditUserOwnedStreamsModalCtrl', ['_', '$scope', 'categoryService', 'ItemService', 'StreamService',
    'BriefingSubscriptionService', 'TaxonomyService', 'UserService', 'UtilService',
    function(_, $scope, categoryService, itemService, streamService,
             briefingSubscriptionService, taxonomyService, userService, utilService) {
        $scope.init = function() {
            $scope.params = {
                page: -1, //Prime for initial infinite scroll event
                rows: 40
            };
            $scope.streams = [];
        };

        var initialSortMap = {
            titleLower: 'ASC',
            followersCount: 'DESC',
            itemsCount: 'DESC'
        };

        $scope.isSort = function(sort, sortDirection) {
            return $scope.params.sort === sort && $scope.params.sortDirection === sortDirection;
        };

        $scope.toggleSort = function(sort) {
            // Disable sort toggling if there's only one or no stream
            if($scope.streams.length === 0 || $scope.streams.length === 1) {
                return;
            }

            if ($scope.params.sort === sort) {
                $scope.params.sortDirection =  $scope.params.sortDirection === 'ASC' ? 'DESC' : 'ASC';
            } else {
                $scope.params.sort = sort;
                $scope.params.sortDirection = initialSortMap[sort] || 'DESC';
            }
            getFreshStreams();
        };

        $scope.searchStreams = function() {
            getFreshStreams();
        };

        $scope.clearSearch = function() {
            $scope.params.term = null;
            getFreshStreams();
        };

        $scope.nextPage = function() {
            if(!$scope.gettingStreams) {
                $scope.gettingStreams = true;
                $scope.params.page++;
                fetchUserStreams();
            }
        };

        var getFreshStreams = function() {
            $scope.params.page = 0;
            $scope.streams = [];
            fetchUserStreams();
        };

        var fetchUserStreams = function() {
            streamService.getTenantStreams(_.assign({
                includeCatalogs: false,
                ownerId: $scope.user.id
            }, $scope.params))
            .then(function(streamResponse) {
                $scope.streams = _.union($scope.streams, streamResponse.data.content);
                $scope.params.sort = streamResponse.data.sort[0].property;
                $scope.params.sortDirection = streamResponse.data.sort[0].direction;
                $scope.last = streamResponse.data.last;
                $scope.ownedStreamCount.val = streamResponse.data.totalElements;
                $scope.gettingStreams = false;
                $scope.notFollowingStreams = $scope.streams.length !== 0 ? false : true;
            });
        };

        $scope.viewStreamDetails = function(stream) {
            streamService.openStreamDetailModal(stream).result
            .then(function(item) {
                if(item){
                    itemService.openNewModal({
                        itemId: item.id,
                        hasPrevious: false,
                        hasNext: false,
                        streamContext: stream.id
                    });
                }
            });
        };

        $scope.openFollowersModal = streamService.openFollowersModal;

        $scope.tooltipManager = function(stream, isBriefing) {
            return utilService.tooltipManager(stream, isBriefing);
        };

        $scope.init();
    }]);

'use strict';
/*
controllerAs : emailPicker
 */
angular.module('attensaApp')
.controller('EmailPickerModalCtrl', [ '_', 'TenantService',
function(_, tenantService) {

    var self = this;

    this.init = function() {
        tenantService.getUnauthTenantInfo()
        .then(function (tenantRes) {
            self.tenantDomain = tenantRes.data.settings.tenantDomain;
        });
    };

    this.emailAddresses = [];

    this.addAddress = function(address){
        this.emailAddresses.push(address);
        this.emailAddress = undefined;
    };

    this.addAddressFromPrefix = function(prefix, domain){
        this.emailAddresses.push(_.trim(prefix) + '@' + domain);
        this.emailPrefix = undefined;
    };

    this.removeEmail = function(emailAddress) {
        this.emailAddresses = _.without(this.emailAddresses, emailAddress);
    };

    this.init();
}]);
'use strict';

angular.module('attensaApp')
.controller('EventDetailModalCtrl',
['_', '$scope', '$rootScope', '$uibModalInstance', 'collectionName', 'eventService', 'moment', 'stream', 'fromDate', 'toDate',
function(_, $scope, $rootScope, $uibModalInstance, collectionName, eventService, moment, stream, fromDate, toDate) {
    var TZOFFSET = 1000 * 60 * 60 * 8;

    $scope.init = function() {
        var SIXTY_DAYS_AGO = moment().subtract(60, 'days');

        $scope.eventDisplayNameMap = {
            item_viewed: 'Articles read',
            item_link_clicked: 'Click throughs to source URL'
        };
        $scope.events = [];
        $scope.streamTitle = stream.title;
        $scope.collectionName = collectionName;
        $scope.fetching = true;

        return eventService.getStreamEventExtraction(stream.id, {
            collectionName: collectionName,
            fromDate: moment(new Date(fromDate)).isBefore(SIXTY_DAYS_AGO) ? SIXTY_DAYS_AGO.format('YYYY-MM-DD') : fromDate,
            toDate: toDate
        })
        .then(function(events) {
            $scope.fetching = false;
            $scope.events = events;
            $scope.tableParams = $scope.generateTableParams($scope.filterEventsForDisplay(events));
        });
    };

    $scope.eventsFormatter = eventService.formatEventsForCSV;

    $scope.generateTableParams = function(data) {
        return eventService.generateTableParams(data);
    };

    $scope.filterEventsForDisplay = function(events) {
        return _.map(events, function(event) {
            return {
                time: moment(new Date(event.properties.time * 1000 + TZOFFSET)).format('YYYY-MM-DD HH:mm:ss'),
                name: event.properties.user_lastName + ', ' + event.properties.user_firstName,
                title: event.properties.item_title
            };
        });
    };

    $scope.close = function() {
        $uibModalInstance.close();
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('GroupModalCtrl', ['_', '$scope', '$q', '$uibModal', '$uibModalInstance', 'group', 'groupsService', 'tenant', 'UserService', 'UtilService',
    function(_, $scope, $q, $uibModal, $uibModalInstance, group, groupsService, tenant, userService, utilService) {

    const processGroupResponse = groupsResponse => {
        $scope.group = groupsResponse.data;
        $scope.isUnchanged = utilService.isUnchanged($scope.group);
        $scope.config.target = 'members';
        if($scope.addMembersView) {
            $scope.addMembersView = false;
        }
    };

    const saveNewGroup = () => groupsService.saveGroup({
        name: $scope.group.name,
        description: $scope.group.description,
        creatorId: $scope.user.id,
        members: $scope.group.members
    })
    .then(processGroupResponse)
    .then(() => $scope.editing = true)
    .catch(() => $scope.$broadcast('group-detail-alerts', { type: 'danger', msg:'Error creating group, please try again.' }));

    const saveExistingGroup = group => groupsService.editGroup(group)
    .then(processGroupResponse)
    .catch(() => $scope.$broadcast('group-detail-alerts', { type: 'danger', msg:'Error editing group, please try again.' }));

    const doSort = (isNew, sortOptions) => {
        $scope.pager = isNew ? 0 : $scope.pager;
        $scope.searching = true;

        const options = utilService.sortPeopleOptions(sortOptions, $scope);
        options.params.groupId = $scope.group.id;
        options.params.page = $scope.pager;
        options.params.rows = $scope.rows;
        $scope.sort = options.params.sort;

        return ($scope.addMembersView ?  userService.getUsers(options) : groupsService.getUsers(options))
        .then(results => {
            $scope.populate(results, isNew);
            $scope.lastPage = results.data.last;
            $scope.sortDirection = options.params.sortDirection;
        });
    };

    const groupWarning = () => $scope.isUnchanged() ? 
        $q.when(true) : 
        $uibModal.open({ templateUrl: '/templates/stateChangeWithChangesWarningModal.html'}).result;
        

    $scope.calculateStreams = () => groupsService.getStreams({ params: { groupId: $scope.group.id } })
        .then(streamResponse => $scope.streamCount = { val: streamResponse.data.totalElements });

    $scope.calculateBriefings = () => groupsService.getBriefingSubscriptions({ params: { groupId: $scope.group.id } })
        .then(streamResponse => $scope.briefingCount = { val: streamResponse.data.totalElements });

    $scope.init = () => {
        $scope.users = [];
        $scope.allUsers = [];
        $scope.pager = -1;
        $scope.rows = 40;
        $scope.sortDirection = 'ASC';
        $scope.tenant = tenant.data;
        $scope.search = {};
        $scope.config = { target: 'basics' };

        if (group) {
            $scope.group = group;
            $scope.editing = true;
            $scope.calculateStreams();
            $scope.calculateBriefings();
        } else {
            $scope.group = {};
        }

        $scope.original = { name: $scope.group.name, description: $scope.group.description };

        $scope.isUnchanged = () => $scope.group.name === $scope.original.name && $scope.group.description === $scope.original.description;
    };

    $scope.refreshGroup = () => {
        groupsService.fetchGroup($scope.group.id)
        .then(response => {
            response.data.name = $scope.group.name;
            response.data.description = $scope.group.description;
            $scope.group = response.data;
        });
    };

    $scope.$on('group.streamCountChanged', () => {
        $scope.refreshGroup();
        $scope.calculateStreams();
    });
    
    $scope.$on('group.briefingCountChanged', () => {
        $scope.refreshGroup();        
        $scope.calculateBriefings();
    });

    $scope.hideMembersView = () => $scope.addMembersView = false;

    $scope.done = () => groupWarning().then(() => group ? $uibModalInstance.dismiss() : $uibModalInstance.close($scope.group));

    $scope.userInGroup = (userId, groupMembers) =>  _.includes(groupMembers, userId);

    $scope.addUserSubscription = (user, group) => {
        $scope.disabledButton = {
            user: user,
            group: group
        };
        return groupsService.addUser(group.id, user.id)
        .then(() => {
            group.members = group.members || [];
            group.members.push(user.id);
            $scope.users.push(user);
            $scope.disabledButton = undefined;
        });
    };

    $scope.removeUserSubscription = (user, group) => {
        $scope.disabledButton = {
            user: user,
            group: group
        };
        return groupsService.removeUser(group.id, user.id)
        .then(() => {
            _.pull(group.members, user.id);
            _.remove($scope.users, { id: user.id });
            $scope.disabledButton = undefined;            
        });
    };

    $scope.searchUser = () => {
        delete $scope.lastPage;
        doSort(true);
    };

    $scope.clearSearch = () => {
        $scope.search.searchTerm = '';
        delete $scope.lastPage;
        doSort(true);
    };

    // In order to get the infinite scroll to work on a modal we needed to add infinite-scroll-container as well as the
    // overflow-y: scroll and height: 480px styles
    $scope.nextPage = (sortOptions) => {
        if(!$scope.lastPage && !$scope.searching) {
            $scope.pager++;
            const isNew = $scope.pager === 0;
            doSort(isNew, sortOptions);
        }
    };

    $scope.sortByOthers = (sortOptions, isNew) => {
        delete $scope.lastPage;
        doSort(isNew, sortOptions);
    };

    $scope.addMembersTable = () => {
        delete $scope.lastPage;
        $scope.pager = -1;
        $scope.addMembersView = true;
        $scope.editing = true;
        $scope.nextPage();
    };

    $scope.cancelAddMembersTable = () => {
       groupsService.fetchGroup($scope.group.id)
       .then((group) => {
           $scope.group = group.data;
           $scope.pager = -1;
           delete $scope.lastPage;
           $scope.addMembersView = false;
           $scope.nextPage();
           $scope.editing = false;
       });
    };

    $scope.populate = (results, isNew) => {
        if(isNew && !$scope.addMembersView) {
            $scope.users = results.data.content;
        }
        if(!isNew && !$scope.addMembersView) {
            $scope.users.push.apply($scope.users, results.data.content);
        }
        if(isNew && $scope.addMembersView) {
            $scope.allUsers = results.data.content;
        }
        if(!isNew && $scope.addMembersView) {
            $scope.allUsers.push.apply($scope.allUsers, results.data.content);
        }

        _.forEach($scope.users, user  => {
            const tenantRole = user.tenantRoles[0] ? user.tenantRoles[0] : null;
            user.role = tenantRole ? _.find($scope.tenant.tenantRoles, roles => roles.type === tenantRole.roleType) : null;
            user.currentRole = tenantRole ? tenantRole.roleType : null;
        });
        $scope.searching = false;
    };

    $scope.save = group => ($scope.editing ? saveExistingGroup(group) : saveNewGroup()).then(() => $scope.search = {});

    $scope.saveAndClose = group => $scope.save(group).then(() => $scope.done());

    $scope.cancel = () => groupWarning().then(() => $uibModalInstance.dismiss());

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')

.controller('HeaderCtrl', ['_', '$window', '$rootScope', '$state', '$timeout', 'digestService', 'TenantService',
function(_, $window, $rootScope, $state, $timeout, digestService, tenantService) {
    var self = this;

    var setNoNav = function(){
        self.noNav = $window.location.search.indexOf('noNav=true') !== -1 ||
                     ($state.current && $state.current.data && $state.current.data.noNav === true);

        if(!self.noNav && !self.navConfiguration){
            tenantService.getCurrentTenant()
                .then(function(tenantResponse){
                    self.navConfiguration = tenantResponse.data.settings.navConfiguration;
                });

            tenantService.getCatalogMap()
                .then(function(catalogs) {
                    self.catalogs = catalogs;
                });
        }
    };

    this.init = function() {
        setNoNav();
    };

    $rootScope.$on('$stateChangeSuccess', setNoNav);

    this.generateUrl = function(navConfig){
        return $state.get(navConfig.state) ? $state.href(navConfig.state) : navConfig.state;
    };

    this.goToState = function($event, navConfig) {
        if(!$event.ctrlKey && !$event.metaKey) {
            if ($state.current.name === navConfig.state && navConfig.clearEvent) {
                $rootScope.$broadcast(navConfig.clearEvent);
            } else {
                $state.go(navConfig.state);
                $timeout(function () {
                    $state.go(navConfig.state, {}, {}, {location: true});
                });
            }
        }
    };

    this.isState = function(navState){
        return _.startsWith($state.current.name, navState);
    };

    this.openManageStreamTagsModal = tenantService.openManageStreamTagsModal;
    this.openPersonalDigestModal = digestService.openPersonalDigestModal;

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('ImageSelectorCtrl',['$scope', '$uibModalInstance', 'Upload', 'uploadTarget', function($scope, $uibModalInstance, $upload, uploadTarget) {

    $scope.cancel = function(){
        $uibModalInstance.dismiss();
    };

    $scope.save = function(){
        $uibModalInstance.close($scope.uploadedFile);
    };

    $scope.onFileSelect = function($files){
        var file = $files[0];
        $upload.upload({
            url: '/ws/' + uploadTarget + '/upload/image',
            method: 'POST',
            data: { myObj: $scope.myModelObj },
            headers: { 'Content-Type': 'multipart/form-data' },
            file: file
        }).success(function(data, status, headers, config) {
            $scope.uploadedFile = data;
        });
        //TODO some failure handling would be nice
    };
}]);

'use strict';

angular.module('attensaApp')
.controller('LoginCtrl', ['$q', '$window', '$cacheFactory', '$state', '$stateParams', 'growl', 'AuthService', 'UserService', 'TenantService',
    function($q, $window, $cacheFactory, $state, $stateParams, growl, authService, userService, TenantService) {

    var self = this;

    this.initialize = function(){
        this.hostname = $window.location.hostname;
        this.name = $window.location.hostname.split('.')[0];
        this.user = {};
        this.email = {};
        this.buttonText = 'Reset Password';
        this.token = $stateParams.token;

       $q.all([userService.getCurrentUser(), TenantService.getUnauthTenantInfo()])
        .then(function(responses) {
            if(responses[0].data.user && responses[0].data.user.id) {
                authService.goToDefaultState(responses[0].data.user);
            } else if(responses[1].data.settings.samlEntryPoint) {
                $window.location.href = '/';  // Get sso tenants off of the local login page
            }
            self.selfSignupConfiguration = responses[1].data.settings.selfSignupConfiguration;
        });
    };

    this.signIn = function(){
        userService.signIn(self.user).then(
            function(result) {
                if (result.data.success) {
                    $cacheFactory.get('$http').removeAll();
                    if($stateParams.RelayState) {
                        // TODO: We should parse RelayState and translate so we can do a
                        // $state.go and not force a reload, but non-trivial for now.
                        $window.location.href = $stateParams.RelayState;
                    } else {
                        authService.goToDefaultState(result.data.user);
                    }
                }
            },
            function(err) {
                if (err.status === 401 || err.status === 404) {
                    growl.error('Invalid username / password pair', {referenceId: 'login'});
                }
                //TODO something for if there is an unexpected error
            }
        );
    };

    this.forgotPassword = function(){
        userService.forgotPassword(self.email)
        .then(function() {
            growl.success('Reset password email has been sent successfully.', {referenceId: 'forgotPassword'});
            self.email = {};
        })
        .catch(function(err) {
            if (err.status === 404) {
                growl.error('Email address does not exist', {referenceId: 'forgotPassword'});
            } else if (err.status === 403) {
                growl.error('Your account is not yet active.  Please contact your administrator.', {referenceId: 'forgotPassword'});
            } else {
                growl.error('An unexpected error occurred.', {referenceId: 'forgotPassword'});
            }
        });
    };

    this.resetPassword = function(){
        self.saveText = 'Resetting Password...';
        var resetInfo = {
            token: self.token,
            newPassword: self.user.password
        };
        userService.resetPassword(resetInfo).then(
            function(result) {
                self.buttonText = 'Reset Password';
                $cacheFactory.get('$http').removeAll();
                $state.go('reading');
            }
        );
    };

    this.resetDisabled = function(){
        return self.form.$invalid || self.buttonText === 'Resetting Password...';
    };

    this.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('ManageGroupsCtrl', ['$scope', '$uibModal', '_', 'groups', 'groupsService', 'UtilService', 'tenant',
function($scope, $uibModal, _, groups, groupsService, utilService, tenant) {

    var doSort = function(isNew, sortOptions) {
        if (isNew) {
            $scope.page = 0;
        }
        $scope.searching = true;

        var options = utilService.sortPeopleOptions(sortOptions, $scope);
        options.params.page = $scope.page;
        options.params.rows = $scope.rows;

        groupsService.fetchGroups(options)
        .then(function(results) {
            $scope.populate(results, isNew);
            $scope.sortDirection = options.params.sortDirection;
        });
    };

    $scope.initialize = function() {
        $scope.groups = groups.data.content;
        $scope.groupCount = groups.data.totalElements;
        $scope.page = 0;
        $scope.rows = 40;
        $scope.tenant = tenant.data;
        $scope.navbarCollapsed = true;
    };


    $scope.nextPage = function() {
        if (!$scope.lastPage) {
            $scope.page++;
            var groupOptions = {
                params: {
                    page: $scope.page,
                    rows: 40
                }
            };

            groupsService.fetchGroups(groupOptions)
            .then(function(results) {
                $scope.lastPage = results.data.last;
                $scope.groups = $scope.groups.concat(results.data.content);
            });
        }
    };

    $scope.addGroup = function() {
        groupsService.editGroupModal(null, tenant)
        .then(function(group) {
            $scope.groupCount++;
            $scope.groups.unshift(group);
        });
    };

    $scope.deleteGroup = function(groupId) {
        var modalScope = $scope.$new(true);
        modalScope.modalTitle = 'Continue deleting group?';
        modalScope.message = 'Warning! This will <b>permanently</b> remove this group from the system.<br/>By clicking the Delete button below, you are confirming that you are removing this group and that it cannot be restored.';
        modalScope.confirmLabel = 'Delete';
        $uibModal.open({
            templateUrl: '/templates/ConfirmModal.html',
            size: 'lg',
            scope: modalScope
        }).result
        .then(function(){
            $scope.groupCount--;
            groupsService.deleteGroup(groupId)
            .then(function() {
                _.remove($scope.groups, { id: groupId });
            });
        });
    };

    $scope.editGroup = function(group) {
        groupsService.editGroupModal(group, tenant)
        .catch(function() {
            groupsService.fetchGroup(group.id)
            .then(function(groupResponse) {
                group = _.merge(group, groupResponse.data, function(a, b) {
                    if(a && !b) {
                        return null;
                    } else {
                        return b;
                    }
                });
            });
        });
    };

    $scope.sortByOthers = function(sortOptions, isNew) {
        doSort(isNew, sortOptions);
    };

    $scope.populate = function(results, isNew) {
        if(isNew) {
            $scope.groups = results.data.content;
        } else {
            $scope.groups.push.apply($scope.groups, results.data.content);
        }

        $scope.searching = false;
    };

    $scope.searchGroups = function() {
        doSort(true);
    };

    $scope.clearSearch = function() {
        $scope.searchTerm = '';
        doSort(true);
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('ManagePeopleCtrl', ['$scope', '$uibModal', '$http', '$q', 'eventService', 'UtilService', 'UserService', 'digestService', '_', 'tenant', 'people', 'growl',
function($scope, $uibModal, $http, $q, eventService, utilService, userService, digestService, _, tenant, people, growl) {
    
    const doSort = (isNew, sortOptions) => {
        this.searching = true;
        this.selectAll = false;
        this.selectDisabled = true;
        this.noTouching = isNew;

        const options = utilService.sortPeopleOptions(sortOptions, this);

        userService.getUsers(options)
        .then(results => {
            this.populate(results, isNew);
            this.sortDirection = options.params.sortDirection;
            this.peopleCount = results.data.totalElements;
            this.noTouching = false;
            this.noTouchingPaging = false;
        });
    };

    const confirmInviteModal = selectedUserIds => $uibModal.open({
        templateUrl: '/templates/peopleConfirmInviteModal.html',
        controller: 'ConfirmInviteCtrl',
        size: 'sm',
        resolve: { items: () => selectedUserIds }
    }).result;

    const confirmArchiveModal = multiple => {
        const modalScope = $scope.$new(true);
        modalScope.modalTitle =  `Continue deleting user${multiple ? 's' : ''}?`;
        modalScope.message = multiple ? 'Warning! This will <b>permanently</b> remove these users from the system.<br/>By clicking the Delete button below, you are confirming that you are removing these users.' :
                                        'Warning! This will <b>permanently</b> remove this user from the system.<br/>By clicking the Delete button below, you are confirming that you are removing this user.';
        modalScope.confirmLabel = 'Delete';
        return $uibModal.open({
            templateUrl: '/templates/ConfirmModal.html',
            size: 'lg',
            scope: modalScope
        }).result;
    };

    const inviteUsers = (userIds) => userService.sendUsersInvitation(userIds)
    .then(() => {
        confirmInviteModal(userIds);
        doSort(true);
    });

    const addUserModal = () => $uibModal.open({
        templateUrl: '/templates/peopleAddModal.html',
        controller: 'AddPeopleCtrl',
        controllerAs: '$ctrl',
        size: 'lg',
        resolve: { tenantTimeZone: () =>  this.tenant.timeZone }
    }).result;


    this.initialize = () => {
        this.selectDisabled = true;
        this.tenant = tenant.data;
        this.people = people;
        this.sortDirection = 'ASC';
        this.peopleCount = people.data.totalElements;
        this.populate(people, true);
        this.currentUser = $scope.user;
        this.pageLimit = 40;
        this.navbarCollapsed = true;
        this.selectAll = false;
        this.allowTopicCreators = _.contains(this.tenant.settings.allowRoleTypes, 'STREAM_CREATOR');
    };

    this.archiveUser = user =>  {
        confirmArchiveModal(false)
        .then(() => {
            this.noTouching = true;
            return userService.archiveUser(user);
        })
        .then(() => {
            this.peopleCount--;
            doSort(true);
        })
        .catch(() => {
            growl.error(`User ${user.emailAddress} couldn't be deleted because he or she owns streams or groups.`);
            this.noTouching = false;    
        });
    };

    this.archiveUsers = () => {
        const selectedUsers = _.filter(this.users, 'selected');
        confirmArchiveModal(selectedUsers.length === 1 ? false : true)
        .then(() => {
            this.noTouching = true;
            const deletePromises = [];
            const undeletableUsers = [];
            if (this.selectDisabled === false) {
                _.each(selectedUsers, (user) => deletePromises.push(userService.archiveUser(user).catch(() => undeletableUsers.push(user.emailAddress))));
            }
            $q.all(deletePromises).then(() => {
                // When data-service has better error codes we can axe this
                if(!_.isEmpty(undeletableUsers)) {
                    if(undeletableUsers.length > 1) {
                        const listUsers = _.map(undeletableUsers, users => `<li>${users}</li>`);
                        growl.error(`The following users couldn't be deleted because they own streams or groups: <br/><ul>${listUsers.join('')}</ul>`);
                        this.peopleCount = this.peopleCount - selectedUsers.length + undeletableUsers.length;
                        doSort(true);
                    } else {
                        growl.error(`User ${undeletableUsers.join(' ')} couldn't be deleted because he or she owns streams or groups.`);
                        this.peopleCount = this.peopleCount - selectedUsers.length + undeletableUsers.length;
                        doSort(true);
                    }
                } else {
                    this.peopleCount = this.peopleCount - selectedUsers.length;
                    doSort(true);
                }
            });
        });
    };

    this.nextPage = () => {
        if(!this.searching && !this.pager.lastPage) {
            this.pager.currentPage++;
            this.noTouchingPaging = true;
            doSort(false, { page: this.pager.currentPage - 1 });
        }
    };

    this.addPeople = () => {
        addUserModal().then(newUsers => {
            if(newUsers) {
                this.peopleCount = this.peopleCount + newUsers.length;
                doSort(true);
                confirmInviteModal(newUsers);
            }
        });
    };

    this.toggleRole = (user, roleType) => _.find(user.tenantRoles, { roleType: roleType }) ?
            this.removeTenantRole(user, roleType) : 
            this.addTenantRole(user, roleType);

    this.removeTenantRole = (user, roleType) => {
        this.searching = true;
        userService.removeTenantRole(user.id, this.tenant.id, roleType)
        .then(updatedUser => {
            user.tenantRoles = updatedUser.tenantRoles;
            user.admin = _.find(user.tenantRoles, { roleType: 'TENANT_ADMIN' }) ? true : false;
            user.streamCreator = _.find(user.tenantRoles, { roleType: 'STREAM_CREATOR' }) ? true : false;
            this.searching = false;
        });
    };

    this.addTenantRole = (user, roleType) => {
        this.searching = true;

        userService.addTenantRole(user.id, this.tenant.id, roleType)
        .then(updatedUser => {
            user.tenantRoles = updatedUser.tenantRoles;
            user.admin = _.find(user.tenantRoles, { roleType: 'TENANT_ADMIN' }) ? true : false;
            user.streamCreator = _.find(user.tenantRoles, { roleType: 'STREAM_CREATOR' }) ? true : false;
            this.searching = false;
        });

        eventService.postEvent('user_role_updated', _.assign({}, eventService.formatUser(user, 'edited_user'), { to_role: roleType } ));
    };

    this.usersGroupAction = (action, option) => {
        if(this.selectDisabled === false && !this.searching) {
            _.forEach(this.users, (user) => {
                if(user.selected) {
                    action(user, option);
                }
            });
        }
    };

    this.change = () => this.selectDisabled = utilService.isAllDisabled(this.users);

    this.changeStatus = user => {
        eventService.postEvent('user_status_updated', eventService.formatUser(user, 'edited_user'));
        userService.persistUser(user);
        if (user.status === 'ACTIVE' && this.tenant.settings.noInitialDigest !== 'true') {
            this.activateDigest(user);
        }
    };

    this.searchUser = () => doSort(true);

    this.activateDigest = (user) => {
        return digestService.resolveUserDigestConfiguration(user)
        .then(digest => {
            if(!digest.schedule.enabled){
                digest.schedule.enabled = true;
                return digestService.putDigestConfiguration(digest, user.id, digest.id);
            }else{
                return digest;
            }
        });
    };

    this.activateDigests = () => {
        return $q.all(_.chain(this.users).filter({selected: true}).map(user => this.activateDigest(user)).value());
    };

    this.setStatuses = (status) => {
        const selectedUserIds = [];
        if(this.selectDisabled === false) {
            angular.forEach(this.users, user => {
                if(user.selected && status !== 'INVITED') {
                    user.status = status;
                    this.changeStatus(user);
                } else {
                    if(user.selected) {
                        selectedUserIds.push(user.id);
                    }
                }
            });
        }

        if(selectedUserIds.length !== 0) {
            inviteUsers(selectedUserIds);
        }
    };

    this.clearSearch = () => {
        this.searchTerm = '';
        doSort(true);
    };

    this.selectAllToggle = () => {
        _.forEach(this.users, (user, key) => {
            if(this.selectAll && !this.isCurrentUser(user)) {
                user.selected = true;
            } else {
                user.selected = false;
            }
        });
        this.change();
    };

    this.isCurrentUser = (user) =>  $scope.user.id === user.id;

    this.editUser = user => {
        eventService.postEvent('user_edit_clicked', eventService.formatUser(user, 'edited_user'));
        $uibModal.open({
            templateUrl: '/templates/editUserModal.html',
            controller: 'EditUserModalCtrl',
            size: 'lg',
            resolve: {
                user: () => _.clone(user),
                tenantRoles: () => _.clone(this.tenant.tenantRoles),
                currentUser: () => this.isCurrentUser(user),
                tenant: () => this.tenant
            }
        }).result
        .then(editedUser => this.users[_.findIndex(this.users, {id: editedUser.id})] = editedUser);
    };

    this.sortByOthers = (sortOptions, isNew) => doSort(isNew, sortOptions);

    this.filterByRole = (tenantRole, isNew) => {
        this.filterByTenantRole = tenantRole;
        doSort(true, { tenantRole: tenantRole.type });
    };

    this.removeFilter = () => {
        this.filterByTenantRole = null;
        doSort(true);
    };

    this.populate = (results, isNew) => {
        this.pager = utilService.createPager(results.data);

        if(isNew) {
            this.users = results.data.content;
        } else {
            this.users.push.apply(this.users, results.data.content);
        }

        _.forEach(this.users, (user) => {
            user.admin = _.find(user.tenantRoles, { roleType: 'TENANT_ADMIN' }) ? true : false;
            user.streamCreator = _.find(user.tenantRoles, { roleType: 'STREAM_CREATOR' }) ? true : false;
        });
        this.searching = false;
    };

    this.fetchForCSV = () => {
        this.fetchingForCSV =  true;
        return userService.getUsers({ params: { rows: this.peopleCount } })
        .then(usersRes => userService.formatForExport(usersRes.data.content))
        .then(results => {
            this.fetchingForCSV =  false;
            eventService.postEvent('people_list_downloaded', { peopleCount: this.peopleCount } );
            return results;
        });
    };

    this.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('ManageStreamTagsCtrl', ['_', 'NgTableParams', '$uibModal', '$rootScope', '$scope', 'growl', 'streamTags', 'TenantService',
function(_, NgTableParams, $uibModal, $rootScope, $scope, growl, streamTags, tenantService) {
    $scope.initialize = function() {
        $scope.tableParams = new NgTableParams({
            count: 15,
            sorting: { label: 'asc' }
        }, {
            total: streamTags.length,
            counts: [],
            dataset: streamTags
        });
    };

    $scope.validateTagLabel = function(label) {
        return !_.isEmpty(label);
    };


    $scope.updateTag = function(tag) {
        return tenantService.updateStreamTag(tag)
        .then(function() {
            $scope.broadcastTags($scope.tableParams.settings().dataset);
        })
        .catch(function(err) {
            growl.error('An error occurred saving the tag.');
        });
    };

    $scope.deleteTag = function(tag) {
        return confirmTagDeleteModal()
        .then(function() {
            return tenantService.deleteStreamTag(tag)
            .then(function() {
                _.remove($scope.tableParams.settings().dataset, { id: tag.id });
                $scope.broadcastTags($scope.tableParams.settings().dataset);
                return $scope.tableParams.reload();
            })
            .then(function(streamTags) {
                  if (streamTags.length === 0 && $scope.tableParams.total() > 0) {
                    $scope.tableParams.page($scope.tableParams.page() - 1);
                    $scope.tableParams.reload();
                  }
            })
            .catch(function(err) {
                growl.error('An error occurred deleting the tag.');
            });
        });
    };

    $scope.createTag = function() {
        return tenantService.saveStreamTag({ label: $scope.tableParams.filter().label })
        .then(function(streamTag) {
            $scope.tableParams.settings().dataset.push(streamTag);
            $scope.broadcastTags($scope.tableParams.settings().dataset);
            return $scope.tableParams.reload();
        })
        .catch(function(err) {
            growl.error('An error occurred creating the tag.');
        });
    };

    $scope.broadcastTags = function(tags) {
        $rootScope.$broadcast('stream-tags-changed', tags);
    };

    $scope.canCreate = function() {
        return $scope.tableParams.filter().label &&
            !_.some($scope.tableParams.settings().dataset, { label: $scope.tableParams.filter().label });
    };

    var confirmTagDeleteModal = function() {
        var modalScope = $scope.$new(true);
        modalScope.modalTitle = 'Continue Deleting Tag?';
        modalScope.message = 'Deleting this tag will remove this tag from all streams currently tagged by it.';
        modalScope.confirmLabel = 'Delete';
        return $uibModal.open({
            templateUrl: '/templates/ConfirmModal.html',
            size: 'lg',
            scope: modalScope
        }).result;
    };

    $scope.initialize();
 }]);

'use strict';

angular.module('attensaApp')
.controller('ManageTemplateCtrl',['$scope', '$rootScope', '$uibModal', '$http', '$window', '_', 'templates', 's3Bucket', 'TemplateService',
function($scope, $rootScope, $uibModal, $http, $window, _, templates, s3Bucket, templateService) {

    $scope.initialize = function () {
        $scope.templates = $scope.sortTemplates(templates.data);
        $scope.s3Bucket = s3Bucket.data;
        $scope.manage = true;
        $scope.templateCount = $scope.templates.length;
    };

    $scope.sortTemplates = function(templates) {
        return _.sortBy(templates, function(template) {
            return template.title.toLowerCase();
        });
    };

    $scope.$on('refreshTemplates', function(event) {
        templateService.getAll()
        .then(function(results){
            $scope.templates = $scope.sortTemplates(results.data);
            $scope.templateCount = $scope.templates.length;
        });
    });

    $scope.saveTemplateTitle = function(template, title) {
        templateService.saveTemplate(template, {title: title})
        .then(function(response) {
            template = response;
            $scope.$broadcast('template-alerts', {type: 'success', msg: 'Template title saved.'});
        })
        .catch(function() {
            $scope.$broadcast('template-alerts', {type: 'danger', msg: 'Template save failed.'});
        });
    };

    $scope.deleteTemplate = function(template){
        if(template.inUse) {
            $scope.$broadcast('template-alerts', {type: 'danger', msg: 'Unable to delete: Template in use.'});
            return;
        }
        $http.delete('/ws/template/'+template.id)
        .then(function(){
            var existingTemplate = _.findWhere($scope.templates, {id: template.id});
            $scope.templates.splice(_.indexOf($scope.templates, existingTemplate), 1);
            $scope.$broadcast('template-alerts', {type: 'success', msg: 'Template Deleted'});
        })
        .catch(function() {
            $scope.$broadcast('briefing-alerts', {type: 'danger', msg: 'Delete Failed.'});
        });
    };

    $scope.placeTemplate = function(template, oldTemplateId) {
        if(oldTemplateId) {
            var existingTemplate = _.findWhere($scope.templates, {id: oldTemplateId});
            $scope.templates[_.indexOf($scope.templates, existingTemplate)] = template;
        } else {
            $scope.templates.push(template);
        }
        $scope.templates = $scope.sortTemplates($scope.templates);
    };

    $scope.uploadTemplate = function(uploadTarget){
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/templateSelectModal.html',
            controller: 'TemplateSelectorCtrl',
            size: 'sm',
            resolve: {
                uploadTarget: function() { return uploadTarget; },
                template: function() { return null; },
                templatePlacer: function() { return $scope.placeTemplate; }
            }
        });
        return modalInstance.result;
    };

    $scope.uploadReplacement = function(template) {
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/templateSelectModal.html',
            controller: 'TemplateSelectorCtrl',
            size: 'sm',
            resolve: {
                uploadTarget: function() { return null; },
                template: function() { return template; },
                templatePlacer: function() { return $scope.placeTemplate; }
            }
        });
        return modalInstance.result;
    };

    $scope.viewTemplateUse = function(template){
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/templateDetailModal.html',
            controller: 'TemplateDetailModalCtrl',
            size: 'lg',
            resolve: {
                template: function() {
                    return template;
                },
                s3Bucket: ['InfoService', function(infoService) {
                    return infoService.getS3Bucket();
                }]
            }
        });
        return modalInstance.result;
    };

    $scope.setAsDefault = function(template) {
        templateService.saveTemplate(template, {defaultTemplate: true})
        .then(function() {
            $scope.$broadcast('refreshTemplates');
        })
        .catch(function() {
                $scope.$broadcast('template-alerts', {type: 'danger', msg: 'Template save failed.'});
        });
    };

    $scope.initialize();

}]);
'use strict';

angular.module('attensaApp')
.controller('OpmlImportCtrl',
    ['_', '$scope', '$state', '$stateParams', '$window', '$uibModal', 'opmlService', 'opmlTaxonomicService', 'TaxonomyService',
    function(_, $scope, $state, $stateParams, $window, $uibModal, opmlService, opmlTaxonomicService, taxonomyService) {

    $scope.init = function() {
        taxonomyService.getTenantTaxonomy(false)
        .then(function(results) {
            $scope.taxonomy = results.data;
            $scope.taxonomyVersion = results.headers('X-Object-Version');
        });
    };

    $scope.$on('taxonomyUpdated', function(evt, results){
        $scope.taxonomy = results.taxonomy;
        $scope.taxonomyVersion = results.taxonomyVersion;
    });

    $scope.importOpml = function(opmlFile) {
        $scope.uploading = true;
        var reader = new $window.FileReader();
        reader.onloadend = function(evt) {
            try {

                opmlTaxonomicService.importOpml(evt.target.result, $scope.taxonomy, $scope.taxonomyVersion, $scope.selectedCategories)
                .then(function() {
                    $scope.fileImported = true;
                })
                .catch(function() {
                    $scope.uploading = false;
                    $scope.$broadcast('opml-alerts', {type: 'danger', msg:'Your OPML file could not be parsed.  Please make sure that it is a valid OPML file.'});
                });
            } catch (err) {

            }
        };
        reader.readAsText(opmlFile);
    };

    $scope.editCategories = function() {
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'SimpleCategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: function() {
                    return $scope.taxonomy;
                },
                taxonomyVersion: function() {
                    return $scope.taxonomyVersion;
                }
            }
        }).result
        .then(function(selectedCategories) {
            $scope.selectedCategories = selectedCategories;
            taxonomyService.markSelectedCategories($scope.taxonomy, selectedCategories);
        });
    };

    $scope.fileSelected = function() {
        if ($scope.opmlFiles[0]) {
            $scope.filePresent = true;
            $scope.fileName = $scope.opmlFiles[0].name;
        }
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('PreferenceCenterCtrl', ['$rootScope', '$state', '$mdToast', 'TenantService', 'UserService', 'UtilService',
    function($rootScope, $state, $mdToast, tenantService, userService, utilService) {

        var self = this;
        this.noTouching = true;

        var processUserResult = function(user){
            self.noTouching = user && !!self.subscribeToBriefing;
            self.user = user;
        };

        this.initialize = function() {
            self.subscribeToBriefing = $state.params.briefing || $state.params.briefingId;

            tenantService.getUnauthTenantInfo()
            .then(function (tenantRes) {
                self.selfSignupConfiguration = tenantRes.data.settings.selfSignupConfiguration;
            });

            userService.getCurrentUser(true)
            .then(function(userResult) {
                self.user = userResult.data.user;
                self.noTouching = false;

                if ($state.params.invitationMessage) {
                    $mdToast.show($mdToast.simple({hideDelay: 15000}).textContent($state.params.invitationMessage).position('top right'));
                } else if($state.params.userId && $state.params.briefingId && $state.params.unsubscribe){
                    self.noTouching = true;
                    userService.uaUnsubscribeFromBriefing($state.params.userId, $state.params.briefingId)
                    .then(function(){
                        self.briefingId = $state.params.briefingId;
                        self.userId = $state.params.userId;
                        $rootScope.$broadcast('subscribe-change'); // This is almost certainly paranoia
                        self.unSubscribed = true;
                        self.noTouching = false;
                    });
                } else if(!self.user && $state.params.invitationCode){
                    userService.canActivate(null, $state.params.invitationCode)
                    .then(function(results){
                        if(results.canActivate){
                            self.startActivation(results.user);
                        }else {
                            self.createAccount();
                        }
                    });
                }else if(!self.user && ($state.params.briefing || $state.params.briefingId)){
                    self.logIn();
                }else if(!self.user && $state.params.token){
                    self.resetPassword();
                }else if(!self.user && $state.params.forgotPassword){
                    self.startPasswordReset();
                } else if(!self.user && $state.params.register){
                    self.requestCode();
                }
            });
        };

        this.initialBriefingSubscribed = function(){
            $state.go('preferences', {}, {inherit: false});
        };

        this.changePassword = function(){
            return utilService.showModal([
                '<md-dialog flex="50">',
                    '<change-password cancel="$ctrl.cancel()" done="$ctrl.done(result)" title="$ctrl.title"></change-password>',
                '</md-dialog>'
            ].join('\n'), { title: 'Change Password'})
            .then(function(password){
                self.saveUser('password', password);
            });
        };

        this.logOut = function(){
            userService.destroySession()
            .then(function(){
                self.user = undefined;
            });
        };

        this.logIn = function(){
            userService.login().then(processUserResult);
        };

        this.startPasswordReset = userService.startPasswordReset;

        this.startActivation = function(user){
            self.noTouching = true;
            return utilService.showModal([
                '<md-dialog flex="50">',
                    '<change-password cancel="$ctrl.cancel()" done="$ctrl.done(result)" title="$ctrl.title"></change-password>',
                '</md-dialog>'
            ].join('\n'), { title: 'Set your password'})
            .then(function(password){
                user.password = password;
                return userService.activateUser(user).then(processUserResult);
            }).finally(function(){
                self.noTouching = false;
            });
        };

        this.resetPassword = function(){
            return utilService.showModal([
                '<md-dialog flex="50">',
                    '<change-password cancel="$ctrl.cancel()" done="$ctrl.done(result)" title="$ctrl.title"></change-password>',
                '</md-dialog>'
            ].join('\n'), { title: 'Reset Password'})
            .then(function(password){
                userService.resetPassword({ token: $state.params.token, newPassword: password })
                .then(function(result) {
                    self.user = result.data;
                    userService.updateCurrentUser(result.data);
                    $state.go('preferences', {invitationMessage: 'Your password has been reset.'}, {inherit: false});
                })
                .catch(function(error){
                    if(error.status === 401){
                        $mdToast.show($mdToast.simple().textContent('Your reset token has expired, please request a new one.').position('top right'));
                        self.startPasswordReset();
                    } else {
                        $mdToast.show($mdToast.simple().textContent('Unable to change your password, please contact your site administrator.').position('top right'));
                    }
                });
            });
        };

        this.createAccount = function(){
            if($state.params.invitationCode && self.invalidCode !== $state.params.invitationCode) {
                userService.getUserByInvitationCode($state.params.invitationCode)
                .then(self.registerUser)
                .catch(function(){
                    $mdToast.show($mdToast.simple().textContent('Unrecognized invitation, please contact your site administrator').position('top right'));
                    self.invalidCode = $state.params.invitationCode;
                });
            }else {
                self.requestCode();
            }
        };

        this.requestCode = function(){
            return utilService.showModal([
                '<md-dialog flex="50">',
                    '<request-signup-code cancel="$ctrl.cancel()" done="$ctrl.done(result)"></request-signup-code>',
                '</md-dialog>'
            ].join('\n'));
        };

        this.registerUser = function(user){
            return utilService.showModal([
                '<md-dialog flex="50">',
                    '<complete-signup user="$ctrl.user" cancel="$ctrl.cancel()" done="$ctrl.done(result)"></complete-signup>',
                '</md-dialog>'
            ].join('\n'), { user: user })
            .then(processUserResult);
        };

        this.saveUser = function(attr, value){
            self.user[attr] = value ? value.trim() : value;
            userService.persistCurrentUser(self.user)
            .then(function(updatedUser){
              self.user = updatedUser;
              userService.updateCurrentUser(self.user);
              $mdToast.show($mdToast.simple().textContent('Saved').position('top right'));
            });
        };

        this.initialize();
    }]);

'use strict';

angular.module('attensaApp')
.controller('ProfileCtrl', ['$scope', '$rootScope', 'imageService', 'UtilService', 'UserService', 'tenant', 'user',
    function($scope, $rootScope, imageService, utilService, userService, tenant, user) {

    $scope.displayTimezones = utilService.displayTimezones;

    $scope.initialize = function() {
        $scope.saveText = 'Save';
        $scope.user = user.data.user;
        if($scope.user.largeImageUri) {
            $scope.backgroundImage = $scope.user.largeImageUri ?
                {'background-image': 'url(' + $scope.user.largeImageUri + ')'} : {'background-image' : 'none'};
        }
        $scope.tenant = tenant.data;
        $scope.profilePic = {};
        if(tenant.data.settings.samlEntryPoint) {
            $scope.disableEmailChange = true;
        }
        utilService.confirmUnsavedChangeNav($scope, [$scope.user, $scope.profilePic]);
    };

    $scope.saveUser = function() {
        if($scope.form.$valid) {
            $scope.saveText = 'Saving...';

            userService.persistCurrentUser($scope.user)
            .then(function(savedUser) {
                $scope.user = savedUser;
                if($scope.profilePic.value && $scope.profilePic.value.length !== 0) {
                    return userService.savePicture($scope.user.id, $scope.profilePic.value[0])
                    .then(function(saveImageResult) {
                        var imageData = saveImageResult.data;
                        $scope.user.thumbnailImageAttachmentId = imageData.thumbnailImage.id;
                        $scope.user.thumbnailImageUri          = imageData.thumbnailImage.uri;
                        $scope.user.largeImageAttachmentId     = imageData.largeImage.id;
                        $scope.user.largeImageUri              = imageData.largeImage.uri;
                    });
                }
            })
            .then(function() {
                userService.updateCurrentUser($scope.user);
                $scope.isUnchanged = utilService.isUnchanged([$scope.user, $scope.profilePic]);
                $scope.ignoreChanges = true;
                $rootScope.$broadcast('profile-alerts', { type: 'success', msg: 'Profile saved' });
            })
            .catch(function() {
                $rootScope.$broadcast('profile-alerts',
                    { type: 'danger', msg: 'There was a problem saving your profile data' });
            })
            .finally(function() {
                $scope.saveText = 'Save';
            });
        }
    };

    $scope.generateThumb = function(file) {
        imageService.pickImage(file)
        .then(function(localImageUrl) {
            file.dataUrl = localImageUrl;
            $scope.user.hasNewPic = true; // For triggering unsaved warning
            $scope.previewBackgroundImage = { 'background-image': 'url(' + localImageUrl + ')' };
        });
    };

    $scope.initialize();
 }]);

'use strict';

angular.module('attensaApp')
.controller('ReadingCtrl', ['$scope', '$rootScope', '$state', '$location', '$http', '$uibModal', '$stateParams',
'$timeout', '$q', '$window', '_', 'moment', 'BriefingSubscriptionService', 'eventService', 'InfoService', 'ItemService',
'locker', 'StreamService', 'user', 'categoryService', 'TaxonomyService', 'StreamBuilderService', 'LabelService', 'UserService', 'permissionService', 
function($scope, $rootScope, $state, $location, $http, $uibModal, $stateParams,
$timeout, $q, $window, _, moment, briefingSubscriptionService, eventService, infoService, itemService,
locker, streamService, user, categoryService, taxonomyService, streamBuilderService, labelService, userService, permissionService) {

    var fetchUnsubscribedStream = function(){
        $q.all([
            taxonomyService.getTenantTaxonomy(),
            streamService.getStream($scope.streamIdParam)
        ])
        .then(function(results){
            var taxonomy = results[0].data;
            $scope.selectedStream = results[1].data;
            if(!$scope.selectedStream.userIsFollowing && $scope.page === 0 && !$scope.promptedForSubscribe && $scope.userCanRead()) {
                $scope.promptedForSubscribe = true;
                var popScope = $scope.$new(true);
                popScope.stream = $scope.selectedStream;
                $uibModal.open({
                    templateUrl: '/templates/subscribeToStreamModal.html',
                    size: 'lg',
                    scope: popScope
                }).result
                .then(function(stream) {
                    userService.setFollowing(stream.id, $scope.user.id, { follow: true, subscribe: false })
                    .then(function(){
                        $scope.streamIdParams = stream.id;
                        return categoryService.updatePersonalCategory(stream, true, taxonomy, $scope.user);
                    })
                    .then(function(updatedUser) {
                        $scope.user = updatedUser;
                        var categorizedStream = _.findWhere($scope.user.categorizedStreams, { streamId: stream.id });
                        if(categorizedStream) {
                            $scope.readingExpandedCategoryIds = _.union($scope.readingExpandedCategoryIds, [categorizedStream.categoryId]);
                        } else {
                            $scope.readingExpandedCategoryIds = _.union($scope.readingExpandedCategoryIds, ['Uncategorized']);
                        }
                        $scope.fetchSubscriptions();
                    });
                });
            } else {
                $scope.fetchSubscriptions();
            }
        });
    };

    $scope.filterPrefs = {
        all: {
            displayText: 'All results',
            includeReadItems: true
        },
        unread: {
            displayText: 'Unread',
            includeReadItems: false
        },
        last24Hours: {
            displayText: 'Last 24 hours',
            includeReadItems: true,
            restrictItemsToLast24Hours: true
        },
        commentsLast24Hours: {
            displayText: 'Recent comments',
            includeReadItems: true,
            restrictCommentsToLast24Hours: true
        }
    };

    $scope.initialize = function(){
        //WARNING since we use $location to alter the search, $stateParams are not to be trusted after initialize is complete
        $scope.fetching = true;

        locker.bind($scope, 'readingView', 'tile');
        locker.bind($scope, 'readingExpandedCategoryIds', []);
        locker.bind($scope, 'selectedFilter', $scope.filterPrefs.all);

        $scope.selectedTag = $stateParams.tag;
        $scope.selectedUserTag = $stateParams.userTag;
        $scope.selectedCategory = $stateParams.c;
        $scope.streamIdParam = $stateParams.s;
        $scope.selectedQuery = $stateParams.query;

        $scope.page = -1; //Prime for initial infinite scroll
        $scope.items = [];
        $scope.search = {};

        if($scope.selectedTag){
            $scope.search.tags = $scope.selectedTag;
            $scope.search.searching = true;
        }

        $scope.userFullName = user.data.user.firstName + ' ' + user.data.user.lastName;

        // We know the item to read and the stream context, go ahead and open reading modal with that info
        if($stateParams.itemId && $stateParams.s){
            itemService.openNewModal({
                itemId: $stateParams.itemId,
                hasPrevious: false,
                hasNext: false,
                source: $stateParams.source,
                streamContext: $stateParams.s
            });
        }

        labelService.setLabel($scope, 'readingMenuLabel', 'reading_menu_label', 'My Articles');

        $scope.fetchSubscriptions()
        .then(function() {
            // If we  know the item id but not the stream, we now have all of the user's subscriptions and can
            // open reading modal with them as possibilities
            if($stateParams.itemId && !$stateParams.s) {
                itemService.openNewModal({
                    itemId: $stateParams.itemId,
                    hasPrevious: false,
                    hasNext: false,
                    source: $stateParams.source,
                    streamContext: $scope.allSubscribedStreamIds
                });
            }
        });
    };

    $scope.userCanRead = () => permissionService.userCanReadStream($scope.user, $scope.selectedStream, true);

    $scope.startBasic = streamBuilderService.basic;

    $scope.$on('item-deleted', () => $scope.performSearch());

    $scope.$on('stream-changed', function(evt, stream) {
        var changedStream = _.chain($scope.personalCategories)
            .pluck('streams')
            .flatten()
            .findWhere({ id: stream.id })
            .value();

        if(!changedStream) {
            changedStream = {};
        }

        changedStream.title = stream.title;
        changedStream.description = stream.description;
        changedStream.briefingEnabled = stream.briefingEnabled;
        changedStream.rssEnabled = stream.rssEnabled;
        changedStream.published = stream.published;
        changedStream.followersCount = stream.followersCount;
        changedStream.itemsCount = stream.itemsCount;
        changedStream.userIsFollowing = stream.userIsFollowing;
        changedStream.userIsSubscribedToBriefing = stream.userIsSubscribedToBriefing;
        changedStream.userSubscriptionId = stream.userSubscriptionId ? stream.userSubscriptionId : null;
        if(stream.thumbnailImage) {
            changedStream.thumbnailImage = _.assign({}, changedStream.thumbnailImage, { uri: stream.thumbnailImage.uri });
        }

        $scope.fetchSubscriptions();
        var currentCategory = _.find($scope.personalCategories, { id: $scope.selectedCategory });
        var isInCurrentCategory = currentCategory && _.find(currentCategory.streams, {id: stream.id});
        if ($scope.streamIdParam && $scope.streamIdParam === stream.id) {
            $scope.selectAll();
        }else if(!$scope.selectedCategory || isInCurrentCategory) {
            $scope.performSearch();
        }
    });

    $scope.$on('show-previous-item', function(evt, itemId) {
        $scope.openReadingModal($scope.items[_.findIndex($scope.items, {id: itemId}) - 1]);
    });

    $scope.$on('show-next-item', function(evt, itemId) {
        $scope.openReadingModal($scope.items[_.findIndex($scope.items, {id: itemId}) + 1]);
    });

    $scope.$on('item-opened', function(evt, itemId) {
        var currentSearch = $location.search();
        currentSearch.itemId = itemId;
        $location.search(currentSearch);
    });

    $scope.$on('item-updated', function(){
        $scope.performSearch();
    });

    $scope.$on('item-closed', function(evt, itemId) {
        var currentSearch = $location.search();
        delete currentSearch.itemId;
        delete currentSearch.source;
        $location.search(currentSearch);
    });

    $scope.$on('item-bookmark-toggle', function(evt, itemId, bookmarked) {
       _.find($scope.items, { id: itemId }).savedByUser = bookmarked;
    });

    $scope.fetchSubscriptions = function() {
        return $http.get('/ws/subscription/streams')
        .then(function(results){
            $scope.personalCategories = results.data;
            locker.bind($scope, 'personalCategories');

            // If refresh on selected stream
            if($scope.streamIdParam) {
                $scope.selectedStream = _.findWhere(_.flatten(_.pluck($scope.personalCategories, 'streams')), {id: $scope.streamIdParam}) || $scope.selectedStream;
            }

            $scope.allSubscribedStreamIds = $scope.getAllSubscribedStreamIds($scope.personalCategories);
        })
        .catch(function(err) {
            $rootScope.$broadcast('reading-alerts', { type: 'danger', msg: 'Error fetching streams, please try again.' });
        });
    };

    $scope.getAllSubscribedStreamIds = function(personalCategories) {
        return _.chain(personalCategories)
        .pluck('streams')
        .flatten()
        .pluck('id')
        .uniq()
        .value();
    };

    $scope.fetchPage = function(append) {
        if(!$scope.isLastPage) {
            // Checks and wait for personal categories to appear in local storage
            if (!$scope.personalCategories && !locker.get('personalCategories') && $scope.selectedCategory) {
                return $timeout(function () {
                    $scope.fetchPage();
                }, 50);
            } else if ($scope.selectedCategory) {
                if (!$scope.personalCategories) {
                    $scope.personalCategories = locker.get('personalCategories');
                }
                $scope.fetchPageWithCategories(append);
            } else {
                $scope.fetchPageWithCategories(append);
            }
        }
    };

    $scope.fetchPageWithCategories = function(append) {
        if($scope.gettingPage) {
            return;
        } else {
            $scope.page++;
            $scope.gettingPage = true;
            return $scope.fetchItems(false, append)
            .finally(function() {
                $scope.gettingPage = false;
            });
        }
    };

    $scope.$on('tag-selected', function(evt, tagInfo) {
        $scope.clearSearch();
        delete $scope.selectedStream;
        delete $scope.streamIdParam;
        if(tagInfo.userTag) {
            $scope.selectedUserTag = tagInfo.userTag;
        } else if(tagInfo.tag) {
            $scope.selectedTag = tagInfo.tag;
        }
        $scope.pushState();
        $scope.search.tags = $scope.selectedTag;
        $scope.search.searching = true;
        $scope.performSearch();
    });

    $scope.openReadingModal = function(item) {
        var hasPrev = $scope.items.indexOf(item) > 0;
        var hasNext = ($scope.items.indexOf(item) + 1) < $scope.items.length;

        if(!hasNext && !$scope.isLastPage){ //If we have reached the end of our current pages
            hasNext = true;                 //force hasNext to true
            $scope.fetchPage();             //fetch another page
        }

        var streamContext = $scope.selectedStream ?
            $scope.selectedStream.id : $scope.allSubscribedStreamIds;

        item.readByUser = true;
        itemService.openNewModal({
            itemId: item.id,
            hasPrevious: hasPrev,
            hasNext: hasNext,
            streamContext: streamContext
        });
    };

    $scope.openPostItemModal = function() {
        itemService.openPostItemModal([$scope.selectedStream], null, $scope.userFullName, $scope.performSearch);
    };

    $scope.openFollowersModal = function(stream) {
        return streamService.openFollowersModal(stream);
    };

    $scope.toggleCategoryExpansion = function(personalCategory) {
        return $scope.isMenuExpanded(personalCategory) ?
            _.pull($scope.readingExpandedCategoryIds, personalCategory.id) :
            $scope.readingExpandedCategoryIds.push(personalCategory.id);
    };

    $scope.orderLabel = function(personalCategory) {
        if(personalCategory && personalCategory.title !== 'Uncategorized') {
            //return the lowercase title so we can sort by it
            return personalCategory.title.toLowerCase();
        }
        //otherwise the result will be undefined which will come last
    };

    $scope.pushState = function(){
        if ($scope.selectedStream && $scope.selectedStream.id) {
            $location.search({'s': $scope.selectedStream.id});
        } else if ($scope.selectedCategory) {
            $location.search({'c': $scope.selectedCategory});
        } else if($scope.selectedUserTag) {
            $location.search({'userTag': $scope.selectedUserTag });
        } else if($scope.selectedTag) {
            $location.search({'tag': $scope.selectedTag });
        } else if($scope.selectedQuery) {
            $location.search({ query: $scope.selectedQuery });
        } else {
            $location.search({});
        }
    };

    $scope.resetResults = function(){
        $scope.page = 0;
        $scope.items = [];
        delete $scope.numberOfResults;
    };

    $scope.performSearch = function(sort) {
        if(!_.isEmpty($scope.search.text)){
            $scope.search.searching = true;
            if($scope.search.segmentation) {
                $scope.postSearchEvent($scope.search.text, $scope.search.segmentation.segment);
            }
        }
        $scope.resetResults();
        $scope.search.sortField = sort || 'relevance';
        if((!$scope.search.text || !$scope.search.text.trim()) && $scope.search.sortField === 'relevance'){
            $scope.search.sortField = 'publishedDate';
        }

        $scope.fetchItems(true);
    };

    $scope.selectAll = function(){
        $scope.clearSearch();
        $scope.pushState();
        delete $scope.selectedStream;
        delete $scope.streamIdParam;
        $scope.fetchItems(true);
    };

    $scope.$on('reading-clear', function(){
        $scope.resetSearch();
        $scope.selectAll();
    });

    $scope.clearSearch = function(){
        delete $scope.selectedTag;
        delete $scope.selectedUserTag;
        delete $scope.selectedStream;
        delete $scope.selectedCategory;
        delete $scope.search.text;
        delete $scope.search.sortField;
        delete $scope.selectedQuery;
        delete $scope.bookmarksSelected;
        if($scope.ongoingRequest) {
            $scope.ongoingRequest.resolve('canceled');
        }
        $scope.resetResults();
    };

    $scope.resetSearch = function() {
        delete $scope.search.text;
        delete $scope.search.sortField;
        $scope.search.searching = false;
        $rootScope.$broadcast('reading-reset-search');
        $scope.resetResults();
        $scope.fetchItems(true);
    };

    $scope.selectCategory = function(category) {
        $scope.clearSearch();
        $scope.selectedCategory = category.id;
        delete $scope.selectedStream;
        delete $scope.streamIdParam;
        $scope.pushState();
        $scope.fetchItems(true);
    };

    $scope.selectQuery = function(sort) {
        $scope.clearSearch();
        $scope.selectedQuery = sort;
        delete $scope.streamIdParam;
        $scope.pushState();
        $scope.fetchItems(true);
    };

    $scope.selectBookmarks = function() {
        $scope.clearSearch();
        $scope.bookmarksSelected = true;
        delete $scope.streamIdParam;
        $scope.pushState();
        $scope.fetchItems(true);
    };

    $scope.selectStream = function(stream){
        $scope.clearSearch();
        $scope.selectedStream = stream;
        $scope.streamIdParam = stream.id;
        $scope.pushState();
        $scope.fetchItems(true);
    };

    $scope.viewStreamDetailsForId = function(streamId){
        streamService.getStream(streamId)
        .then(function(streamResponse){
            $scope.viewStreamDetails(streamResponse.data);
        });
    };

    $scope.viewStreamDetails = function(stream){
        streamService.openStreamDetailModal(stream).result
        .then(function(item){
            if(item){
                itemService.openNewModal({
                    itemId: item.id,
                    hasPrevious: false,
                    hasNext: false,
                    streamContext: stream.id
                });
            }
        });
    };

    $scope.addToCategory = function(stream){
        $uibModal.open({
            templateUrl: '/templates/streamCategoryModal.html',
            controller: 'StreamCategoryModalCtrl',
            size: 'lg',
            resolve: {
                stream: function() { return stream; }
            }
        }).result
        .then(function(results){
            var match;
            _.forEach($scope.personalCategories, function(personalCategory){
                if(personalCategory.id === results.subscriptionCategory.id){
                    personalCategory.streams.push(stream);
                    match = true;
                    $scope.selectCategory(personalCategory);
                }
                if(personalCategory.id === 'Uncategorized'){
                    personalCategory.streams = _.without(personalCategory.streams, stream);
                }
            });

            var newCategory = {
                id: results.subscriptionCategory.id,
                title: results.subscriptionCategory.title,
                streams: [stream]
            };

            if(!match){
                $scope.personalCategories.push(newCategory);
                $scope.selectCategory(newCategory);
            }
            if(!$scope.isMenuExpanded(newCategory)) {
                $scope.toggleCategoryExpansion(newCategory);
            }
        });
    };

    $scope.removeFromCategory = function(stream, $index, personalCategory) {
        categoryService.deleteStreamFromCategory(stream.id, personalCategory.id, $scope.user.id)
        .then(function(results){
            var realIndex;
            var emptyCategoryIndex;
            angular.forEach(personalCategory.streams, function(colStream, index){
                if(colStream.id === stream.id){
                    realIndex = index;
                }
            });
            personalCategory.streams.splice(realIndex, 1);

            angular.forEach($scope.personalCategories, function(personalCategory, catIndex){
                if(personalCategory.id === 'Uncategorized'){
                    personalCategory.streams.push(stream);
                }else if(personalCategory.streams.length === 0){
                    emptyCategoryIndex = catIndex;
                }
            });
            if(emptyCategoryIndex){
                $scope.personalCategories.splice(emptyCategoryIndex, 1);
                if($scope.selectedCategory === personalCategory.id) {
                    $scope.selectAll();
                }
            }
        }, function(err){
            $rootScope.$broadcast('reading-alerts', {type: 'danger', msg:'Error removing stream from category, please try again.'});
        });
    };

    $scope.unsubscribe = function(stream, $index, personalCategory){
        var currentCategory = _.find($scope.personalCategories, { id: $scope.selectedCategory });
        var isInCurrentCategory = currentCategory && _.find(currentCategory.streams, {id: stream.id});
        var isInCategorizedStreams = _.findWhere($scope.user.categorizedStreams, { streamId: stream.id });

        if(isInCategorizedStreams && personalCategory.id !== 'Uncategorized') {
            $scope.removeFromCategory(stream, $index, personalCategory);
        }

        userService.setFollowing(stream.id, user.data.user.id, { follow: false, subscribe: false })
        .then(function(results){
            $scope.fetchSubscriptions();
            if ($scope.streamIdParam && $scope.streamIdParam === stream.id) {
                $scope.selectAll();
            }else if(!$scope.selectedCategory || isInCurrentCategory) {
                $scope.performSearch();
            }
        }, function(err){
            $rootScope.$broadcast('reading-alerts', {type: 'danger', msg:'Error unsubscribing from stream, please try again.'});
        });
    };

    var generateParams = function(){
        var params = {
            includeReadItems: $scope.selectedFilter.includeReadItems,
            createdAfterDateTime: $scope.selectedFilter.restrictItemsToLast24Hours ?
            moment().subtract(1, 'days').toDate() : undefined,
            commentedAfterDateTime: $scope.selectedFilter.restrictCommentsToLast24Hours ?
            moment().subtract(1, 'days').toDate() : undefined,
            sortField: $scope.search.sortField || $scope.selectedQuery,
            page: $scope.page,
            search: $scope.search.text,
            categoryId: _.isString($scope.selectedCategory) ? $scope.selectedCategory.toLowerCase() : $scope.selectedCategory,
            streamId: $scope.streamIdParam ? $scope.streamIdParam : ($scope.selectedStream ? $scope.selectedStream.id : null),
            tag: $scope.selectedTag,
            tagText: $scope.selectedUserTag
        };

        if($scope.search.segmentation){

            if($scope.search.tags) {
                params.tag = $scope.search.tags;
            }

            if(isSegment('taxonomy')){
                params.includeMarketplaceStreams = false;
            }
            if(isSegment('catalog')){
                params.catalogId = $scope.search.segmentation.id;
            }
            if(isSegment('catalogCategory')){
                params.catalogId = $scope.search.segmentation.catalogId;
                params.id = $scope.search.segmentation.id;
            }
            if(isSegment('stream')){
                params.streamId = $scope.search.segmentation.id;
            }else{
                params.streamId = null;
            }
            if(isSegment('personalCategory') || isSegment('taxonomyCategory')){
                params.categoryId = $scope.search.segmentation.id;
            }
            if(isSegment('mostRelevant')){
                params.sortField = 'attentionRank';
            }
            if(isSegment('mostPopular')){
                params.sortField = 'popularity';
            }

            params.selectedCategory = null;
            params.streamIds = null;
            params.tagText = null;
        }

        return params;
    };

    var isSegment = function(segment){
        return $scope.search.segmentation && $scope.search.segmentation.segment === segment;
    };

    $scope._selectSearchFunction = function(){
        if(!$scope.search.segmentation && $scope.selectedCategory) {
            return userService.searchUserCategoryItems;
        } else if((!$scope.search.segmentation && $scope.selectedQuery) || isSegment('taxonomy') || isSegment('all') || isSegment('mostRelevant') || isSegment('mostPopular')) {
            return itemService.searchTenantItems;
        } else if((!$scope.search.segmentation && $scope.bookmarksSelected) || isSegment('saved')) {
            return userService.getBookmarkedItems;
        } else if(isSegment('catalog')) {
            return taxonomyService.searchCatalogItems;
        } else if(isSegment('catalogCategory')) {
            return taxonomyService.searchCatalogCategoryItems;
        } else if(isSegment('taxonomyCategory') || isSegment('catalogCategory')) {
            return itemService.searchTaxonomyItems;
        } else if(isSegment('personalCategories')){
            return userService.searchUserItems;
        } else if(isSegment('personalCategory') && $scope.search.segmentation.id && $scope.search.segmentation.id !== 'Uncategorized'){
            return userService.searchUserCategoryItems;
        } else {
            return itemService.searchItems;
        }
    };

    $scope.fetchItems = function(spin, append) {
        if (spin) {
            $scope.fetching = true;
        }

        var params = generateParams();

        if($scope.selectedStream || (!$scope.selectedStream && $scope.streamIdParam)) {
            fetchUnsubscribedStream();
        }

        var searchFn = $scope._selectSearchFunction();

        $scope.ongoingRequest = $q.defer();
        $scope.ongoingRequest.page = $scope.page;
        return searchFn(params, $scope.ongoingRequest.promise)
        .then(function(results) {
            if(!append) {
                $scope.items = [];
            }

            $scope.numberOfResults = results.totalElements;
            $scope.isLastPage = results.last;
            $scope.items.push.apply($scope.items, results.content);

            // If we came in to read a specific itemId, mark it as read, yo.  It's possible this is happening before
            // the getItem call has happened on the reading modal that actually marks it as read
            var linkedItem = _.find($scope.items, { id: $stateParams.itemId });
            if(linkedItem) {
                linkedItem.readByUser = true;
            }
        })
        .then(function(){
            $scope.fetching = false;
        })
        .catch(function(err){
            if(!(err && err.config && err.config.timeout && err.config.timeout.$$state && err.config.timeout.$$state.value === 'canceled')){
                $rootScope.$broadcast('reading-alerts', {type: 'danger', msg:'Error fetching streams, please try again.'});
            }
        });
    };

    $scope.isAllStreams = function(){
        return !$scope.selectedCategory && !$scope.selectedStream;
    };

    $scope.isMenuExpanded = function(personalCategory) {
        return _.contains($scope.readingExpandedCategoryIds, personalCategory.id);
    };

    $scope.attentionRankClass = itemService.attentionRankClass;

    $scope.setViewMode = function(viewMode){
        $scope.readingView = viewMode;
    };

    $scope.toggleEdit = function(personalCategory) {
        personalCategory.editing = !personalCategory.editing;
        personalCategory.startEditingCategory = !personalCategory.startEditingCategory;
        personalCategory.title = personalCategory.title;
        personalCategory.newTitle = personalCategory.title;
        personalCategory.hasError = false;
    };

    $scope.checkUniquePersonalCategories = function(personalCategory) {
        // Prevent duplicate, directivefy?
        if(_.filter($scope.personalCategories, {title: personalCategory.newTitle}).length >= 2) {
            personalCategory.hasError = true;
        } else {
            personalCategory.hasError = false;
        }
    };

    $scope.editCategory = function(personalCategory) {
        if(personalCategory.hasError) {
            return;
        }

        personalCategory.title = personalCategory.newTitle;

        $http.put('/ws/user/personalCategory/' + personalCategory.id, { title : personalCategory.title })
        .then(function(results) {
            _.assign(personalCategory, results.data);
            personalCategory.editing = false;
            if($scope.selectedCategory) {
                $scope.selectedCategory = personalCategory.id;
                $scope.pushState();
            }
        })
        .catch(function(err) {
            $rootScope.$broadcast('reading-alerts', { type: 'danger', msg: 'Error editing category, please try again.' });
        });
    };

    $scope.deleteCategory = function(personalCategory) {
        var modalScope = $scope.$new(true);
        modalScope.modalTitle = 'Continue Deleting Category?';
        modalScope.message = 'Warning! This will <b>permanently</b> remove this category from the system.<br/>By clicking the Delete button below, you are confirming that you are removing this category and that all streams in the category will be moved to <b>Uncategorized</b>.';
        modalScope.confirmLabel = 'Delete';

        $uibModal.open({
            templateUrl: '/templates/ConfirmModal.html',
            size: 'lg',
            scope: modalScope
        }).result
        .then(function() {
            $http.delete('/ws/user/personalCategory/' + personalCategory.id)
            .then(function(results) {
                $scope.selectedCategory = null;
                $scope.fetchSubscriptions()
                .then(function() {
                    $scope.fetchPage();
                });
            })
            .catch(function(err) {
                $rootScope.$broadcast('reading-alerts', { type: 'danger', msg: 'Error deleting category, please try again.' });
            });
        });
    };

    $scope.postSearchEvent = function(searchTerm, searchSegment) {
        eventService.postEvent('user_searched', _.assign({
            context: 'items',
            search_text: searchTerm,
            search_segment: searchSegment
        }, eventService.formatStream($scope.selectedStream)));
    };

    $scope.changeFilter = function(filter) {
        $scope.resetResults();
        $scope.selectedFilter = $scope.filterPrefs[filter];
        $scope.fetchItems(true);
        eventService.postEvent('article_list_filtered', _.assign({
            selected_filter: filter,
        }, eventService.formatStream($scope.selectedStream)));
    };

    $scope.$on('$destroy', function(){
        $scope.shortPage = false;
    });

    $scope.toggleBookmark = function(item) {
        return userService.toggleBookmark(item, $scope.items);
    };

    $scope.clickThroughItem = function(item) {
        $window.open(item.link, '_blank');
        itemService.getStreamsRelatedToItem(item, $scope.streamIdParam || $scope.allSubscribedStreamIds)
        .then(function(relatedStreams) {
            var clickThroughEvents = _.union(
                _.map(relatedStreams.topics, function(topic) { return { name: 'item_link_clicked', stream: topic }; }),
                _.map(relatedStreams.topics, function(topic) { return { name: 'item_topic_link_clicked', stream: topic }; }),
                [ { name: 'item_source_link_clicked', stream: relatedStreams.source }]
            );
            _.each(clickThroughEvents, function(event) {
                eventService.postEvent(event.name,
                    _.assign({ context: 'readingView' }, eventService.formatItem(item), eventService.formatStream(event.stream))
                );
            });
        });
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('ReadingRouterCtrl', ['_', '$state', '$window', '$q', 'DefaultToMyTopicsProvider', 'DefaultToClientProvider',
function(_, $state, $window, $q, defaultToMyTopicsProvider, defaultToClientProvider){

    this.init = function(){
        $q.all([
            defaultToMyTopicsProvider,
            defaultToClientProvider
        ])
        .then(function(results){
            var myTopicsDefault = results[0];
            var clientDefault = results[1];
            if(myTopicsDefault || clientDefault) {
                if ($state.params.s && clientDefault) {
                    $window.location.href = '/client/digest/categories/' + ($state.params.c ? $state.params.c : 'uncategorized') + '/topics/' + $state.params.s + ($state.params.itemId ? '/items/' + $state.params.itemId : '');
                } else if ($state.params.s) {
                    $state.go('mytopics.topic', _.assign({
                        streamId: $state.params.s,
                        searchTerm: $state.params.query,
                        source: $state.params.source
                    }, $state.params), {location: 'replace'});
                } else if ($state.params.tag) {
                    $state.go('mytopics.explore', _.assign({
                        streamId: $state.params.s,
                        searchTerm: $state.params.query,
                        tags: $state.params.tag,
                        source: $state.params.source
                    }, $state.params), {location: 'replace'});
                } else if(clientDefault){
                    $window.location.href = '/client/digest/recent';
                } else {
                    $state.go('mytopics.recent', _.assign({searchTerm: $state.params.query}, $state.params), {location: 'replace'});
                }
            }else{
                $state.go('articles', _.assign({searchTerm: $state.params.query}, $state.params), {location: 'replace'});
            }
        });
    };

    this.init();
}]);
'use strict';

angular.module('attensaApp')
.controller('ReadingSearchCtrl', ['$scope', '$q', '_', 'LabelService', 'TaxonomyService', 'TenantService',
function($scope, $q, _, labelService, taxonomyService, tenantService) {

    var initializeSegmentation = function(){
        if(!$scope.selectedCategory && !($scope.selectedStream && $scope.selectedStream.id) && !$scope.selectedQuery && !$scope.bookmarksSelected){
            $scope.search.segmentKey = 'personalCategories';
            $scope.search.segmentation = {segment: 'personalCategories'};
        }else if($scope.selectedCategory){
            var id = $scope.selectedCategory ? $scope.selectedCategory : undefined;
            $scope.search.segmentKey = 'personalCategory-' + (id ? id : '');
            $scope.search.segmentation = {segment: 'personalCategory', id: id };
            $scope.searchMenuState.personalCategoriesExpanded = true;
        }else if($scope.selectedStream){
            $scope.search.segmentKey = 'stream-' + $scope.selectedStream.id;
            $scope.search.segmentation = {segment: 'stream', id: $scope.selectedStream.id};
            $scope.searchMenuState.personalCategoriesExpanded = true;
            var cat = _.find($scope.personalCategories, function(category){
                return _.find(category.streams, {id: $scope.selectedStream.id });
            });
            $scope.searchMenuState.personalCategoryExpandedMap[cat ? cat.id : undefined] = true;
        }else if($scope.bookmarksSelected){
            $scope.search.segmentKey = 'saved';
            $scope.search.segmentation = {segment: 'saved'};
        }else if($scope.selectedQuery === 'attentionRank'){
            $scope.search.segmentKey = 'mostRelevant';
            $scope.search.segmentation = {segment: 'mostRelevant', query: 'attentionRank'};
        }else if($scope.selectedQuery === 'popularity'){
            $scope.search.segmentKey = 'mostPopular';
            $scope.search.segmentation = {segment: 'mostPopular', query: 'popularity'};
        }else{
            $scope.search.segmentKey = 'all';
            $scope.search.segmentation = {segment: 'all'};
        }
    };

    $scope.initialize = function(){
        $scope.searchMenuState = {
            categoryExpandedMap: {},
            catalogExpandedMap: {},
            catalogCategoryExpandedMap: {},
            personalCategoryExpandedMap: {}
        };
        $scope.catalogTaxonomy = {};

        labelService.setLabel($scope, 'tenantCategoriesName', 'catalog_navigation_label', 'Catalog');

        var all = [];
        all.push(taxonomyService.getTenantTaxonomy(true, true)
        .then(function(results) {
            $scope.taxonomy = results.data;
        }));

        all.push(tenantService.getCatalogMap().then(function(catalogMap){
            $scope.catalogMap = catalogMap;

            _.forEach(catalogMap, function(catalog){
                $scope.searchMenuState.catalogCategoryExpandedMap[catalog.catalogId] = {};
                taxonomyService.getCatalogTaxonomy(catalog.catalogId)
                .then(function (categories) {
                    $scope.catalogTaxonomy[catalog.catalogId] = categories;
                    return categories;
                });
            });
        }));
        initializeSegmentation();
        $q.all(all)
        .then(function(){
            $scope.inited = true;
            $scope.performSearch('relevance');
        });
    };

    $scope.$watch('search.segmentation', function(newVal, oldVal) {
        // We don't want this to fire on controller initialization
        if(newVal !== oldVal) {
            $scope.performSearch('relevance');
        }
    });

    $scope.$watch('search.text', function(newVal, oldVal) {
        // We don't want this to fire on controller initialization
        if(newVal !== oldVal) {
            $scope.performSearch('relevance');
        }
    });

    $scope.segmentationLabel = function(){
        if($scope.search.segmentation){
            if($scope.search.segmentation.segment === 'all'){
                return 'All Catalogs';
            }else if($scope.search.segmentation.segment === 'personalCategories'){
                return $scope.readingMenuLabel;
            }else if($scope.search.segmentation.segment === 'personalCategory') {
                if (!$scope.search.segmentation.id) {
                    return 'Uncategorized';
                }
                return _.find($scope.personalCategories, function (category) {
                    return category && (category.id === $scope.search.segmentation.id);
                }).title;
            }else if($scope.search.segmentation.segment === 'stream'){
                var stream;
                _.forEach($scope.personalCategories, function(category){
                   stream = stream || _.find(category.streams, {id: $scope.search.segmentation.id});
                });
                return stream ? stream.title : '';
            }else if($scope.search.segmentation.segment === 'taxonomy'){
                return $scope.tenantCategoriesName;
            }else if($scope.search.segmentation.segment === 'taxonomyCategory'){
                var result = taxonomyService.getCategory($scope.taxonomy, $scope.search.segmentation.id);
                return result ? result.title : '';
            }else if($scope.search.segmentation.segment === 'catalog'){
                return _.find($scope.catalogMap, {catalogId: $scope.search.segmentation.id}).label;
            }else if($scope.search.segmentation.segment === 'catalogCategory'){
                var res = taxonomyService.getCategory($scope.catalogTaxonomy[$scope.search.segmentation.catalogId], $scope.search.segmentation.id);
                return res ? res.title : '';
            }else if($scope.search.segmentation.segment === 'mostPopular'){
                return 'Most Popular';
            }else if($scope.search.segmentation.segment === 'mostRelevant'){
                return 'Recommended';
            }else if($scope.search.segmentation.segment === 'saved'){
                return 'Saved';
            }
        }else{
            return '';
        }
    };

    $scope.$on('reading-reset-search', function(){
        $scope.search.segmentation = null;
        $scope.search.tags = null;
    });

    $scope.start = function(isOpen){
        if($scope.inited && !isOpen && !$scope.search.segmentation){
            initializeSegmentation();
        }
    };

    $scope.selectSegment = function(value){
        $scope.search.segmentation = value;
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('ReadingModalCtrl', ['$q', '$scope', '$rootScope', '$state', '$uibModal', '$uibModalInstance', '$sce', '$window',
    'FeatureService', 'eventService', 'growl', 'InfoService', 'ItemService', 'StreamService', 'TenantService', 'itemId', '_', 'hasPrev', 'hasNext',
    'streamContext', 'source','uuid4', 'UserService', 'TOPIC_TAGS', 'DefaultToMyTopicsProvider', 'ExtractService', 'externalLinkifyFilter', 'permissionService',
    function($q, $scope, $rootScope, $state, $uibModal, $uibModalInstance, $sce, $window,
        featureService, eventService, growl, infoService, itemService, streamService, tenantService, itemId, _, hasPrev, hasNext,
        streamContext, source, uuid4, userService, TOPIC_TAGS, defaultToMyTopicsProvider, ExtractService, externalLinkifyFilter, permissionService) {

    this.initialize = () => {
        this.streamContext = streamContext;
        this.hasPrev = hasPrev;
        this.hasNext = hasNext;
        this.loading = true;
        this.newCommentSaveText = 'Post Comment';
        this.editCommentSaveText = 'Save Comment';
        this.newAnnotationSaveText = 'Save';
        this.editAnnotationSaveText = 'Save';
        this.startEditingComment = false;
        this.startEditingAnnotation = false;
        this.commentLimit = 4;
        this.viewItemSessionUUID = uuid4.generate();
        this.selectedFiles = [];
        this.user = $rootScope.user;
        featureService.setDisabled(this, 'disableComments', 'comments');

        if(!$rootScope.user.itemTags) {
            $rootScope.user.itemTags = [];
        }

        $rootScope.$broadcast('item-opened', itemId);

        itemService.getItemMoreLikeThis(itemId).then(moreLikeThis => this.moreLikeThis = moreLikeThis);

        const userHasReadPermsFor = (id) => permissionService.userHasReadPermission(this.user, id);

        const sourceReadable = () => this.item.sourceStreamOpenForReading || userHasReadPermsFor(this.item.streamId);

        const contextReadable = (topic) => this.userCanRead = topic.openForReading || userHasReadPermsFor(topic.id);

        tenantService.getCurrentTenant()
        .then(tenantRes => {
            this.tenant = tenantRes.data;
            return itemService.getItem(itemId);
        })
        .then(currentItemResult => {
            this.item = currentItemResult.item;

            if(this.item.tenantId && this.item.tenantId !== this.user.tenantId && this.tenant.settings.limitProductSources === 'true') {
                this.prodRelated = true;
                streamService.getProductSource(this.item.streamId)
                .then(prodSourceResponse => {
                    this.prodSource = prodSourceResponse.data;                    
                    this.userCanRead = this.prodSource.userIsFollowing;
                    this.contextStream = this.prodSource;
                    this.relatedStreams = { source: this.prodSource };
                    this.loading = false;
                    if (this.userCanRead) {
                        this.eventEmitted = 'item_viewed_source';
                        this.postSourceEvent('item_viewed_source', { source: this.prodSource || 'web' });
                    } else {
                        this.eventEmitted = 'attempted_to_view_item';                        
                        this.postSourceEvent('attempted_to_view_item', { source: this.prodSource || 'web' });
                    }
                });
            } else if(this.streamContext && this.streamContext.id){
                this.userCanRead = contextReadable(this.streamContext) && sourceReadable();
                this.loading = false;
            } else if(this.streamContext){
                streamService.getStream(Array.isArray(this.streamContext) ? this.streamContext[0] : this.streamContext).then(result => {
                    this.userCanRead = contextReadable(result.data) && sourceReadable();
                    this.loading = false;
                });
            }else{
                this.userCanRead = sourceReadable();
                this.loading = false;
            }

            this.isTweet = this.item.type === 'TWEET';

            if(this.isTweet){
                itemService.getItemOembed(this.item.link).then(oembed => this.oembed = $sce.trustAsHtml(oembed.data.html))
                .catch(()=> this.isTweet = false);
            }

            //Since we are sanitizing on the server, we can trust the default description explicitly
            this.trustedDescription = $sce.trustAsHtml(externalLinkifyFilter(this.item.defaultDescription));
            this.readingModalFocus = true;
            this.s3Url = currentItemResult.s3Url;
            this.item.encodedLink = encodeURIComponent(this.item.link);
            this.topicTags = _.filter(this.item.tags, { type: this.tenant.settings.defaultTagger === 'Watson' ? 'concepts' :'topics' });
            defaultToMyTopicsProvider.then(shouldDefault => this.tagMultiSelect = shouldDefault);
            this.selectedTags = [];
            this.topicTags.forEach(tag => tag.displayText = (_.find(TOPIC_TAGS, { tagText: tag.tagText }) || tag).displayText);
            this.socialTags = _.filter(this.item.tags, { type: this.tenant.settings.defaultTagger === 'Watson' ? 'keywords' : 'socialTag' });
            this.entityTags = _.filter(this.item.tags, { type: 'entities' });
            return this.prodRelated ? {} : itemService.getStreamsRelatedToItem(this.item, streamContext);
        })
        .then(relatedStreams => {
            this.contextStream = this.contextStream || relatedStreams && relatedStreams.topics && _.find(relatedStreams.topics, {id: streamContext});
            this.relatedStreams = this.relatedStreams || relatedStreams;
            this.postTopicEvents('item_viewed_topic', { source: source || 'web' });
            this.postTopicEvents('item_viewed', { source: source || 'web' });
            this.postSourceEvent('item_viewed_source', { source: source || 'web' });
            if (!this.prodRelated) {
                if (!this.userCanRead) {
                    this.postSourceEvent('attempted_to_view_item', { source: source || 'web' });
                }
            }
        });
    };

    this.socialTagLabel = () => this.tenant.settings.defaultTagger === 'Watson' ? 'Keywords' :'Subjects';

    this.topicTagLabel = () => this.tenant.settings.defaultTagger === 'Watson' ? 'Concepts' : 'Classifications';

    this.tagSearch = selectedTags => {
        const tagVals = selectedTags.map(tag => tag.tagText + '__' + tag.type);

        $state.go('mytopics.explore', {tags: tagVals.join()}, { inherit: $state.is('mytopics.explore') })
        // Trailer trash for squirrely state
        .catch(err => $state.go('mytopics.explore', {tags: tagVals.join()}, { inherit: $state.is('mytopics.explore') }));
    };

    this.clickThroughTitle = link => {
        if(link !== '#') {
            this.postTopicEvents('item_topic_link_clicked',  { context: 'itemPreviewTitle' });
            this.postTopicEvents('item_link_clicked',  { context: 'itemPreviewTitle' });
            this.postSourceEvent('item_source_link_clicked', { context: 'itemPreviewTitle' });
            $window.open(link, '_blank');
        }
    };

    $scope.$on('fileUploaded', (evt, file) => itemService.addAttachment(this.item.id, file).catch(() => growl.error('There was an error attaching the uploaded file to this article')));

    $scope.$on('fileCancelled', (evt, file) => this.deleteAttachment(file));

    $scope.$on('follow-change', (evt, details) => {
        if(this.prodSource && this.prodSource.id === details.stream.id){
            this.prodSource = details.stream;
            this.userCanRead = this.prodSource.userIsFollowing;
            
            if (this.prodSource.userIsFollowing && this.eventEmitted && this.eventEmitted !== 'item_viewed_source') {
                this.postSourceEvent('item_viewed_source', { source: this.prodSource || 'web' });
                this.eventEmitted = undefined;
            }
        }
    });

    this.deleteAttachment = attachment => {
        if(!attachment.deleting) {
            attachment.deleting = true;
            itemService.deleteAttachment(this.item, attachment).then(response => this.item = response.data);
        }
    };

    this.keypressCloseModal = event => {
        if (event.keyCode === 27 && !this.newAnnotation && !this.addingComment) {
            this.closeReadingModal();
        }
    };

    this.closeReadingModal = () => {
        $rootScope.$broadcast('item-closed', itemId);
    	$uibModalInstance.dismiss('cancel');
    };

    this.deleteItem = item => {
        const modalScope = $scope.$new(true);
        modalScope.modalTitle = 'Continue deleting item from '+item.streamOriginTitle+'?';
        modalScope.message = 'Warning! This will <b>permanently</b> remove this item from the system.<br/>By clicking the Delete button below, you are confirming that you are removing this item and that it cannot be restored.';
        modalScope.confirmLabel = 'Delete';
        $uibModal.open({
            templateUrl: '/templates/ConfirmModal.html',
            size: 'lg',
            scope: modalScope
        }).result
        .then(() => 
            itemService.deleteItem(item.streamId, item.id).then(() => {
                $rootScope.$broadcast('item-deleted', item, {title: item.streamOriginTitle});
                $rootScope.$broadcast('reading-alerts', { type: 'success', msg: 'Item deleted' });
                this.closeReadingModal();
            })
            .catch(() => {
                $rootScope.$broadcast('reading-alerts', { type: 'danger', msg: 'Failed to delete item. Please try again.' });
                this.closeReadingModal();
            })
        );
    };

    this.addComment = context => {
        this.postSourceEvent('item_comments_clicked', context);
        this.addingComment = true;
        this.startAddingComment = true;
        this.newComment = '';
    };

    this.cancelAddComment = () => {
        this.postSourceEvent('comment_cancelled');
        this.addingComment = false;
    };

    this.postComment = () => {
        this.newCommentSaveText = 'Saving...';
        itemService.postComment(this.item.id, { body: this.newComment, userId: $rootScope.user.id })
        .then(comment => {
            this.newCommentSaveText = 'Post Comment';
            this.addingComment = false;
            comment.thumbnail = {
                userId: $rootScope.user.id,
                fullName: $rootScope.user.firstName + ' ' + $rootScope.user.lastName,
                thumbnailImageAttachmentId: $rootScope.user.thumbnailImageAttachmentId
            };
            this.item.comments.splice(0, 0, comment);
            if(this.item.comments.length > this.commentLimit) {
                this.commentLimit++;
            }
        });
        this.postSourceEvent('comment_created', { comment_text: this.newComment });
    };

    this.deleteComment = (itemId, commentId) => itemService.deleteComment(itemId, commentId).then(() => _.remove(this.item.comments, { id: commentId }));

    this.editComment = (itemId, comment) => {
        comment.body = comment.editedBody;
        this.editCommentSaveText = 'Saving...';
        itemService.putComment(itemId, comment).then(result =>{
            this.editCommentSaveText = 'Save Comment';
            comment.editing = false;
        });
    };

    this.postAnnotation = () => {
        this.newAnnotationSaveText = 'Saving...';
        itemService.postAnnotation(this.item.id, { type: 'User', location: this.annotation.location, annotationText: this.annotation.annotationText })
        .then(annotation => {
            this.newAnnotationSaveText = 'Save';
            this.newAnnotation = false;
            this.item.annotations.push(annotation);
            this.annotation.annotationText = '';
            this.annotation.location = 'Above';
        });
        this.postSourceEvent('annotation_created', { annotation_location: this.annotation.location, annotation_text: this.annotation.annotationText});
    };

    this.deleteAnnotation = annotationId => itemService.deleteAnnotation(this.item.id, annotationId).then(() => this.item.annotations = _.reject(this.item.annotations, { id: annotationId }));

    this.editAnnotation = annotation => {
        annotation.annotationText = annotation.editedAnnotationText;
        this.editAnnotationSaveText = 'Saving...';
        itemService.putAnnotation(this.item.id, annotation)
        .then(() => {
            this.editAnnotationSaveText = 'Save';
            annotation.editing = false;
        });
    };

    this.cancelAddAnnotation =  () => {
        this.newAnnotation = false;
        this.postSourceEvent('item_annotation_cancelled');
    };

    this.gotoNewItem = item => {
        this.closeReadingModal();
        itemService.openNewModal({ itemId: item.id, hasPrevious: false, hasNext: false });
        this.postSourceEvent('item_morelikethis_clicked', eventService.formatItem(item, 'target_'));
    };

    const processTag = tagData => {
        //The differential processing is required
        //due to the fact that the reading state
        //no longer reloads on state change
        //therefore we need to issue the message
        //if we are already in the reading state
        if($state.is('articles')) {
            $rootScope.$broadcast('tag-selected', tagData);
        }else{
            defaultToMyTopicsProvider
            .then(shouldDefault => {
                if(shouldDefault){
                    $state.go('mytopics.explore', {tags: tagData.tag}, { inherit: false })    
                    .catch(() => $state.go('mytopics.explore', {tags: tagData.tag}, { inherit: false })); // Trailer trash for squirrely state
                }else{
                    $state.go('articles', tagData).catch(() => $state.go('articles', tagData));// Trailer trash for squirrely state    
                }
            });
        }
        $rootScope.$broadcast('item-closed', itemId);
        $uibModalInstance.close();
    };

    const buildItemEvent = (base, item, stream, uuid) => _.assign({}, base, eventService.formatItem(item), eventService.formatStream(stream), { viewItemSession: uuid });
    
    this.postSourceEvent = (eventName, eventData) => eventService.postEvent(eventName, buildItemEvent(eventData || {}, this.item, this.relatedStreams.source, this.viewItemSessionUUID));

    this.postTopicEvents = (eventName, eventData) => _.each(this.relatedStreams.topics, topic => eventService.postEvent(eventName, buildItemEvent(eventData || {}, this.item, topic, this.viewItemSessionUUID)));

    this.calaisTagClicked = (tagText) => {
        this.postSourceEvent('item_tag_clicked', { tag_text: tagText });
        processTag({ tag : tagText });
    };

    this.userTagClicked = (tagText) => {
        this.postSourceEvent('item_usertag_clicked', { tag_text: tagText });
        processTag({ userTag : tagText });
    };

    const goToItem = (eventLabel, broadcastEvent) => {
        this.postSourceEvent(eventLabel);
        $rootScope.$broadcast(broadcastEvent, this.item.id);
        $uibModalInstance.close();
    };

    this.prevItem = () => goToItem('item_previous_clicked', 'show-previous-item');

    this.nextItem = () => goToItem('item_next_clicked', 'show-next-item');

    this.articleClick = event => {
        const clickedLink = angular.element(event.target).prop('tagName') === 'A' || _.some(angular.element(event.target).parents(), (elm) => angular.element(elm).prop('tagName') === 'A');

        if(clickedLink) {
            this.postTopicEvents('item_topic_link_clicked',  { context: 'itemPreviewBody' });
            this.postSourceEvent('item_link_clicked', { context: 'itemPreviewBody' });
            this.postSourceEvent('item_source_link_clicked', { context: 'itemPreviewBody' });
        }
    };

    this.openAttachment = (context, link) => {
        this.postSourceEvent('item_attachment_clicked', { context: context });
        $window.open(link, '_blank');
    };

    this.additionalOptionsClick = () => this.postSourceEvent('item_additional_options_clicked');

    this.showAddAnnotation = () => {
        this.postSourceEvent('item_add_annotation_clicked');
        this.newAnnotation = true;
    };

    this.print = itemId => { 
        this.postSourceEvent('item_print_clicked');
        $window.open('/viewItem/' + itemId + '?print=true', '_blank');
    };

    this.fullTextLinkShouldShow = ()  => !_.isEmpty(this.item.link) && _.isEmpty(this.item.linkResolverLink) && this.item.link !== '#' && this.item.type !== 'TWEET' && !this.fullTextError;

    this.toggleFullArticleText = (item) => {
        if(this.displayFullText) {
            this.displayFullText = false;
        } else {
            this.postSourceEvent('item_full_article_text_displayed');
            this.fetchingFullText = true;
            return ExtractService.getUrlDetails(item.linkResolverLink || item.link)
            .then(results => {
                if(_.isArray(results.objects) && !_.isEmpty(results.objects[0].html)) {
                    this.displayFullText = true;
                    this.fullTextDescription = $sce.trustAsHtml(externalLinkifyFilter(results.objects[0].html));
                } else {
                    return $q.reject(new Error('Error fetching full text'));
                }
            })
            .catch(err =>  this.fullTextError = err.status || 500)
            .finally(() => this.fetchingFullText = false);
        }
    };

    this.linkResolverLinkClicked = () => {
        this.postTopicEvents('item_topic_link_clicked',  { context: 'itemLinkResolverLink' });
        this.postTopicEvents('item_link_clicked',  { context: 'itemLinkResolverLink' });
        this.postSourceEvent('item_source_link_clicked', { context: 'itemLinkResolverLink' });
    };

    this.helpClick = () => this.postSourceEvent('item_help_clicked');

    this.toggleBookmark = item => {
        const bookmarkPromise =  item.savedByUser ? userService.removeBookmark(item.id) : userService.bookmarkItems([item.id]);
        this.item.savedByUser = !item.savedByUser;

        return bookmarkPromise
        .then(() => $rootScope.$broadcast('item-bookmark-toggle', item.id, item.savedByUser))
        .catch(() => growl.error('An error ocurred updating save status'));
    };

    this.initials = userService.initials;

    this.viewStreamDetails = (streamId) => streamService.getStream(streamId).then(streamRes => streamService.openStreamDetailModal(streamRes.data));

    this.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('PostItemModalCtrl',
    ['$scope', '$uibModalInstance', '$q', '_', 'eventService', 'StreamService', 'ItemService',
    'tenant', 'streams', 'author', 'copyItem', 'editItem', 'growl', 'moment', 'ExtractService',
    function($scope, $uibModalInstance, $q, _, eventService, streamService, itemService,
    tenant, streams, author, copyItem, editItem, growl, moment, ExtractService) {

    var postItemEditingEvent = function(eventName, description, link, title, stream, created) {
        eventService.postEvent(eventName, _.assign({},
            eventService.formatItem({
                created: created || new Date().toISOString(),
                cleanDescription: description,
                link: link,
                publishedDate: new Date().toISOString(),
                title: title
            }),
            eventService.formatStream(stream)
        ));
    };

    $scope.initialize = function() {
        $scope.title = 'Post Item';
        $scope.action = 'Post';
        $scope.defaultDescription = '';
        $scope.itemTitle = '';
        $scope.sourceUrl = '';
        $scope.author = author;
        $scope.postedFiles = [];
        $scope.existingAttachments = _.has(copyItem, 'item.attachments') ? copyItem.item.attachments : [];
        $scope.uploadStatus = { inProgress: false };
        $scope.annotations = [];
        $scope.operation = editItem ? 'edit' : 'create';

        if(copyItem && copyItem.item) {
            $scope.item     = copyItem.item;
            $scope.action = 'Save';
            $scope.itemType = 'COPY';

            if (tenant.data.settings.annotationSettings) {
                _.each(tenant.data.settings.annotationSettings, function (annotation) {
                    $scope.annotations.push({
                        'title': annotation.title,
                        'type': 'User',
                        'location': 'Above',
                        'annotationText': '',
                        'userFullname': author
                    });
                });
            }
        } else if(editItem) {
            $scope.item = editItem.item;
            $scope.title = 'Edit Item';
            $scope.action = 'Save';
            streamService.getStream($scope.item.streamId)
            .then(function(streamResults){
                $scope.sourceStream = streamResults.data;
            });
        }

        if($scope.item){
            $scope.itemTitle          = $scope.item.title;
            $scope.defaultDescription = $scope.item.defaultDescription;
            $scope.author             = $scope.item.author;
            if ($scope.item.link !== '#') {
                $scope.sourceUrl = $scope.item.link;
            }
            var now = new Date();
            $scope.publishedDateTime = {
                date: now,
                time: now
            };
        }
    };

    $scope.$on('fileUploaded', function(evt, file) {
        $scope.postedFiles.push(file);
    });

    $scope.$on('fileCancelled', function(evt, file) {
        _.remove($scope.postedFiles, { id: file.id });
    });

    $scope.updateItem = function(){
        $scope.posting = true;
        var publishedDateTime;
        if($scope.publishedDateTime) {
            var publishedHour = moment($scope.publishedDateTime.time).format('HH');
            var publishedMinute = moment($scope.publishedDateTime.time).format('mm');
            publishedDateTime = moment($scope.publishedDateTime.date).hours(publishedHour).minutes(publishedMinute);
        }
        var options = {
            defaultDescription: $scope.defaultDescription,
            title: $scope.itemTitle,
            author: $scope.author,
            publishedDate: publishedDateTime,
            attachments: $scope.postedFiles,
            link: $scope.sourceUrl
        };

        itemService.patchItem($scope.item.streamId, $scope.item.id, options)
        .then(function(){
            postItemEditingEvent('item_edited', $scope.defaultDescription, $scope.sourceUrl, $scope.itemTitle, $scope.sourceStream, $scope.item.created);
            $uibModalInstance.close($scope.item);
        })
        .catch(function () {
            $uibModalInstance.dismiss('cancel');
            growl.error('Error updating item to stream, please try again.');
        });
    };

    $scope.postItem = function() {
        $scope.posting = true;
        $scope.title = 'Posting Item';
        var publishedDateTime;
        if($scope.publishedDateTime) {
            var publishedHour = moment($scope.publishedDateTime.time).format('HH');
            var publishedMinute = moment($scope.publishedDateTime.time).format('mm');
            publishedDateTime = moment($scope.publishedDateTime.date).hours(publishedHour).minutes(publishedMinute);
        }

        var newItem = {
                title: $scope.itemTitle,
                link: $scope.sourceUrl,
                author: $scope.author,
                type: $scope.itemType || 'MANUAL',
                attachments: _.union($scope.postedFiles, $scope.existingAttachments),
                annotations:$scope.annotations,
                publishedDate: publishedDateTime,
                copiedFromStreamId: $scope.item ? $scope.item.streamId : streams[0].id,
                uri: $scope.item ? $scope.item.uri : undefined,
                defaultDescription: $scope.defaultDescription
        };

        $q.all(_.map(streams, function(stream) {
            return itemService.saveItem(stream.id, newItem)
            .then(function () {
                postItemEditingEvent('item_posted', $scope.defaultDescription, $scope.sourceUrl, $scope.itemTitle, stream);
            });
        }))
        .then(function(){
            $uibModalInstance.close(newItem);
        })
        .catch(function () {
            $uibModalInstance.dismiss('cancel');
            growl.error('Error posting item to stream, please try again.');
        })
        .finally(function () {
            $scope.posting = false;
            $scope.title = 'Post Item';
        });
    };

    $scope.cleanPaste = function($html){
        return $html ? String($html).replace(/<br[^>]+>/gm, ' ') : '';
    };

    $scope.cancel = function() {
        eventService.postEvent('item_post_cancelled', {});
        $uibModalInstance.dismiss();
    };

    $scope.importArticle = function(url) {
        $scope.importingArticle = true;
        return ExtractService.getUrlDetails(url)
        .then(function(results) {
            var articleDetail = results.objects[0];
            $scope.itemTitle = articleDetail.title;
            $scope.defaultDescription = articleDetail.html;
            $scope.author = articleDetail.author || $scope.author;

            var streamsImportedFor = _.isEmpty(streams) ? [$scope.sourceStream] : streams;
            _.map(streamsImportedFor, function(stream) {
                postItemEditingEvent('item_full_article_imported', $scope.defaultDescription, url, $scope.itemTitle, stream);
            });
        })
        .finally(function() {
            $scope.importingArticle = false;
        });
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('RegisterCtrl', ['_', '$stateParams', '$window', '$q', 'eventService', 'growl', 'AuthService', 'digestService', 'TenantService', 'UserService',
function(_, $stateParams, $window, $q, eventService, growl, authService, digestService, tenantService, userService) {
    this.savingText = 'Saving...';

    this.initialize = () => {
        this.saveText = 'Save';
        this.invitationCode = $stateParams.invitationCode;

        tenantService.getUnauthTenantInfo().then(tenantRes => {
            this.enableDigest = tenantRes.data.settings.noInitialDigest !== 'true';
            this.tenantTimeZone = tenantRes.data.timeZone;
        });        

        if(this.invitationCode) {
            userService.getUserByInvitationCode(this.invitationCode)
            .then(user => this.user = user)
            .catch(err => this.invalidCode = true);
        }
    };

    this.generalMessageForErrors = (errors) => {
        if(errors && errors.required) {
            var errorNames = _.compact(_.uniq(_.map(errors.required, function (error) {
                if (error.$name.toLowerCase().indexOf('password') !== -1) {
                    return 'password';
                } else if (error.$name.toLowerCase().indexOf('name') !== -1) {
                    return 'name';
                }
            })));

            return 'Please enter your ' + errorNames.join(' and ') + ' below.';
        }
    };

    this.saveUser = () => {
        this.saveText = this.savingText;
        this.user.invitationCode = this.invitationCode;

        return userService.activateUser(this.user)
        .then(user => $q.all([
            $q.when(user),
            digestService.resolveUserDigestConfiguration(user, this.enableDigest)
        ]))
        .then(results => {
            const user = results[0];
            if($stateParams.RelayState) {
                $window.location.href = $stateParams.RelayState;
            } else {
                eventService.postEvent('user_registered', eventService.formatUser(user, 'user'));
                authService.goToDefaultState(user);
            }
        })
        .catch(() => 
            growl.error('An error occurred activating your account.  Please contact your system administrator.'));
    };

    this.initialize();
 }]);

'use strict';

angular.module('attensaApp')
.controller('SignupCtrl',
    ['$state', 'growl', '$window', 'TenantService', 'UserService',
    function($state, growl, $window, tenantService, userService) {
        var self = this;

        this.init = function() {
            this.hostname = $window.location.hostname;
            tenantService.getUnauthTenantInfo()
            .then(function(tenantInfoResponse){
                if(!tenantInfoResponse.data.settings.selfSignupConfiguration){
                    $state.go('login');
                }else {

                    self.show = true;
                }
            });
        };

        this.startSignup = function(email){
            userService.startSignup(email)
            .then(function(){
                self.signupSent = true;
            })
            .catch(function(){
                growl.error('Unable to process invitation, please contact your site administrator');
            });
        };

        this.init();
    }]);


'use strict';

angular.module('attensaApp')
    .controller('WelcomeCtrl', ['AuthService', 'user',
        function(authService, userResponse){
            this.init = function(){
                authService.goToDefaultState(userResponse.data.user);
            };

            this.init();
        }]);

'use strict';

angular.module('attensaApp')
   .controller('SimpleCategorySelectionModalCtrl',
   ['_', '$scope', '$rootScope', 'growl', '$uibModalInstance', 'TaxonomyService', 'taxonomy', 'taxonomyVersion',
   function(_, $scope, $rootScope, growl, $uibModalInstance, taxonomyService, taxonomy, taxonomyVersion) {

       var loadTaxonomy = function() {
           taxonomyService.getTenantTaxonomy()
           .then(function(tenantTaxonomyResponse) {
               taxonomyService._setTaxonomyDataOnScope(tenantTaxonomyResponse, $scope);
           });
       };

       $scope.init = function() {
           $scope.taxonomy = taxonomy;
           $scope.taxonomyVersion = taxonomyVersion;
           $scope.searchText = '';
       };

       $scope.close = function() {
           var addSelected = function(categories, selections){
               _.forEach(categories, function(cat){
                   if(cat.selected){
                       selections.push(cat);
                   }
                   addSelected(cat.subcategories, selections);
               });
               return selections;
           };

           $uibModalInstance.close(addSelected($scope.taxonomy, []));
       };

       $scope.saveNewCategory = function(title, parent) {
           if(title.toLowerCase().indexOf('uncategorized') > -1) {
               growl.error('Naming a category as "uncategorized" is invalid.');
               return false;
           }

           if(!parent) {
               $scope.taxonomy.unshift({
                   title:title,
                   removable:true
               });
           } else {
               if (!parent.subcategories) {
                   parent.subcategories = [];
               }
               parent.subcategories.push({
                   title: title,
                   subcategories: [],
                   removable: true
               });
           }

           $scope.newCategory = { title: '' };
           return $scope.saveTenantTaxonomy();
       };

       $scope.saveTenantTaxonomy = function(title) {
          var selectedCategoryIds = _.pluck(_.filter($scope.taxonomy, { selected: true }), 'id');
          var selectedSubCategoryIds = _.chain($scope.taxonomy).pluck('subcategories').flatten().filter({ selected: true }).pluck('id').value();
          taxonomyService.saveTenantTaxonomy(title, $scope, growl, loadTaxonomy)
          .then(function() {
            if(!_.isEmpty(selectedCategoryIds) || !_.isEmpty(selectedSubCategoryIds)) {
              _.each(selectedCategoryIds, function(id) {
                _.findWhere($scope.taxonomy, { id: id }).selected = true;
              });
              _.each(selectedSubCategoryIds, function(id) {
                _.findWhere(_.flatten(_.pluck($scope.taxonomy, 'subcategories')), { id: id }).selected = true;
              });
            }
            $rootScope.$broadcast('taxonomyUpdated', { taxonomy: $scope.taxonomy, taxonomyVersion: $scope.taxonomyVersion } );
          });
       };

       $scope.init();

   }]);

'use strict';

angular.module('attensaApp')
.controller('BriefingContentsCtrl',
['_', '$rootScope', '$state', 'BriefingService', 'StreamService', 'briefing',
function(_, $rootScope, $state, briefingService, streamService, briefing) {

    var self = this;

    var updateBriefing = function(){
        briefingService.saveBriefing(self.briefing)
        .then(function(briefing){
            $rootScope.$broadcast('briefing-updated', briefing);
        });
    };

    $rootScope.$on('briefing-updated', function(evt, briefing){
        self.briefing = briefing;
        briefingService.setStreamsAndBriefingStreamIds(self, self.briefing.streamIds);
    });

    this.init = function(){
        self.briefing = briefing;
        briefingService.setStreamsAndBriefingStreamIds(self, self.briefing.streamIds);
    };

    this.addSources = function(sourceIds){
        if(briefingService.sortedStreamIds(self.streams).isEqual(self.briefing.streamIds).value()){
            briefingService.setStreamsAndBriefingStreamIds(self, _.union(sourceIds, self.briefing.streamIds), true)
            .then(updateBriefing);
        }else{
            streamService.fetchStreams(sourceIds)
            .then(function(streams){
                return briefingService.setStreamsAndBriefingStreamIds(self, _.union(briefingService.sortedStreamIds(streams).value(), self.briefing.streamIds));
            })
            .then(updateBriefing);
        }
    };

    this.removeSource = function(sourceId) {
        return briefingService.setStreamsAndBriefingStreamIds(self, _.pull(self.briefing.streamIds, sourceId)).then(updateBriefing);
    };

    this.sourcesReordered = function(sources){
        self.briefing.streamIds = _.pluck(sources, 'id');
        updateBriefing();
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingCreateCtrl',
['$scope', '$state', '$q', '_', 'growl', 'moment', 'userResponse', 'tenantResponse', 'BriefingService', 'StreamService',
function($scope, $state, $q, _, growl, moment, userResponse, tenantResponse, briefingService, streamService) {
    var self = this;

    var localDateify = function(inDate, timeZone){
        var isoString = moment.utc(inDate).tz(timeZone).format('YYYY-MM-DDTHH:mm:ss.SSS');
        isoString = isoString + moment().format('Z');
        return new Date(isoString);
    };

    $scope.$on('templateSelected', function(evt, selectedTemplate){
        self.briefing.templateId = selectedTemplate.id;
    });

    this.init = function() {
        var timezone = userResponse.data.timeZone || tenantResponse.data.timeZone || 'US/Pacific';

        self.focusTitle = true;
        self.briefing = {
            enabled: true,
            streamIds: [],
            commentary: {},
            schedule: {
                scheduleMode: 'MANUAL',
                timeZone: timezone,
                freq: 'DAILY',
                interval: 1,
                untilDate:localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), timezone),
                startDate:localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), timezone),
                sendTimeObj:moment().hour(0).minute(0).toDate(),
                endMode:'NEVER_ENDS'
            }
        };
    };

    this.cancel = function(){
        $state.go('briefings.list');
    };

    this.addSources = function(sourceIds){
        if(briefingService.sortedStreamIds(self.streams).isEqual(self.briefing.streamIds).value()){
            briefingService.setStreamsAndBriefingStreamIds(self, _.union(sourceIds, self.briefing.streamIds), true);
        }else{
            streamService.fetchStreams(sourceIds)
            .then(function(streams){
                briefingService.setStreamsAndBriefingStreamIds(self, _.union(briefingService.sortedStreamIds(streams).value(), self.briefing.streamIds));
            });
        }
    };

    this.removeSource = function(sourceId) {
        briefingService.setStreamsAndBriefingStreamIds(self, _.pull(self.briefing.streamIds, sourceId));
    };

    this.sourcesReordered = function(sources){
        self.briefing.streamIds = _.pluck(sources, 'id');
        self.streams = _.clone(self.streams);
    };

    this.frequencyChanged = function(){
        self.selectedDays = {};
        self.briefing.schedule.interval = self.briefing.schedule.freq === 'BIWEEKLY' ? 2 : 1;
    };

    var configureForWeeks = function(freqLabel){
        self.briefing.schedule.byday = [];
        _.forEach(self.selectedDays, function (selected, day) {
            if (selected) {
                self.briefing.schedule.byday.push(day);
            }
        });

        if (self.briefing.schedule.byday.length === 0) {
            growl.error('At least one day must be selected for a briefing scheduled with a ' + freqLabel + ' frequency.', {referenceId: 'streamBuilderMessages'});
            return;
        }
    };

    this.create = function(){
        self.briefing.schedule.sendMinute = moment(self.briefing.schedule.sendTimeObj).format('mm');
        self.briefing.schedule.sendHour = moment(self.briefing.schedule.sendTimeObj).format('HH');
        self.briefing.schedule.start = moment(self.briefing.schedule.startDate).hour(0).minute(0).utc().toISOString();

        if(!moment(self.briefing.schedule.untilDate).isValid()) {
            self.briefing.schedule.untilDate = localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles');
        }

        self.briefing.schedule.until = moment(self.briefing.schedule.untilDate).hour(0).minute(0).utc().toISOString();

        if(self.briefing.schedule.freq === 'WEEKLY') {
            configureForWeeks('weekly');
        } else if(self.briefing.schedule.freq === 'BIWEEKLY'){
            configureForWeeks('bi-weekly');
        } else if(self.briefing.schedule.freq === 'EVERY_WEEKDAY') {
            self.briefing.schedule.byday = ['MO','TU','WE','TH','FR'];
        } else if(self.briefing.schedule.freq === 'EVERY_MON_WED_FRI') {
            self.briefing.schedule.byday = ['MO','WE','FR'];
        } else if(self.briefing.schedule.freq === 'EVERY_TUE_THUR') {
            self.briefing.schedule.byday = ['TU','TH'];
        }

        if(self.briefing.schedule.freq === 'BIWEEKLY'){
            self.briefing.schedule.freq = 'WEEKLY';
            self.briefing.schedule.interval = 2;
        }

        briefingService.createBriefing(self.briefing)
        .then(function(briefing){
            $state.go('briefingItem.details', { briefingId: briefing.id });
        });
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingGroupsCtrl',
['_', '$rootScope', '$q', '$state', 'briefing', 'BriefingService', 'groupsService',
    function(_, $rootScope, $q, $state, briefing, briefingService, groupService) {

        var self = this;
        var targetState = 'briefingItem.groups';

        this.fetchPage = function(){
            $state.go(targetState, {page: self.paging.pagerPage - 1});
        };

        this.doSort = function(sort, sortDirection){
            $state.go(targetState, {sort: sort, sortDirection: sortDirection, page: 0});
        };

        this.doFilter = function(filter){
            $state.go(targetState, {filter: filter, page: 0});
        };

        this.doSearch = function(searchTerm){
            $state.go(targetState, { term: searchTerm , page: 0});
        };

        this.itemsSelected = function(){
            return !!_.find(self.groups, {selected: true });
        };

        this.subscriptionChanged = function(){
            briefingService.getBriefing($state.params.briefingId)
                .then(function(briefing){
                    self.briefing = briefing;
                    $rootScope.$broadcast('briefing-updated', briefing);
                });

        };

        this.subscribe = function(){
            return $q.all(_.map(_.filter(self.groups, {selected: true}), function(group){
                if(!_.find(group.subscriptions, { briefingId: $state.params.briefingId } )){
                    return groupService.subscribeToBriefing(group, self.briefing.id, self.briefing.streamId );
                }
            }))
            .then(self.subscriptionChanged);
        };

        this.unsubscribe = function(){
            return $q.all(_.map(_.filter(self.groups, {selected: true}), function(group){
                if(_.find(group.subscriptions, { briefingId: $state.params.briefingId } )){
                    return groupService.unsubscribeFromBriefing(group, $state.params.briefingId);
                }
            }))
            .then(self.subscriptionChanged);
        };

        this.init = function(){
            self.briefing = briefing;

            var page = isNaN($state.params.page) ? 0 : parseInt($state.params.page);

            self.paging = {
                rows: 50,
                page: page,
                pagerPage: page + 1,
                sort: $state.params.sort,
                sortDirection: $state.params.sortDirection
            };

            self.briefingId = $state.params.briefingId;

            self.searchTerm = $state.params.term;

            self.filter = $state.params.filter;

            var fetcher;
            if($state.params.filter !== 'subscribers'){
                fetcher = groupService.fetchGroups({params: {
                    rows: 50,
                    page: self.paging.page,
                    sort: $state.params.sort,
                    sortDirection: $state.params.sortDirection,
                    searchTerm: $state.params.term
                }});
            }else{
                fetcher = briefingService.fetchGroupSubscribers($state.params.briefingId, 50, self.paging.page, $state.params.sort, $state.params.sortDirection, $state.params.term);
            }
            fetcher
            .then(function(response){
                self.groups = response.data ? response.data.content : response.content;
                self.paging.totalElements = response.data ? response.data.totalElements : response.totalElements;
            });
        };

        this.init();
    }]);

'use strict';

angular.module('attensaApp')
.controller('BriefingItemDetailsCtrl',
['_', '$q', 'moment', '$state', 'BriefingService', 'eventService', 'briefing',
    function(_, $q, moment, $state, briefingService, eventService, briefing) {

    var self = this;

    this.state = $state;

    var labelMap = {
        briefing_email_delivered: 'deliveredBriefings',
        briefing_email_opened: 'openedBriefings',
        briefing_email_clicked: 'clickedBriefings',
        briefing_email_dropped: 'droppedBriefings',
        briefing_email_spammed: 'spammedBriefings'
    };

    var renderAnalytics = function(daysAgo, graphSelection) {
        self.fetchingData = true;
        var params = briefing.streamId ? { streamId: briefing.streamId } : { briefingId: briefing.id };
        return $q.all([
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_delivered', eventService.totalsFormatter, params ),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_opened', eventService.totalsFormatter, params ),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_clicked', eventService.totalsFormatter, params ),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_dropped', eventService.totalsFormatter, params ),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_spammed', eventService.totalsFormatter, params )
        ])
        .then(function (queryResults) {
            self.deliveredBriefings = queryResults[0];
            self.openedBriefings = queryResults[1];
            self.clickedBriefings = queryResults[2];
            self.droppedBriefings = queryResults[3];
            self.spammedBriefings = queryResults[4];

            self.setGraphSelection(graphSelection);
        })
        .finally(function(){
            self.fetchingData = false;
        });
    };

    this.getUserStatuses = function(briefingHistories) {
        return _.map(briefingHistories, function(history) {
            return briefingService.getLatestEmailActivityPerUser(history.activities);
        });
    };

    this.init = function(){
        self.fetchingData = true;
        self.historyIndex = 0;
        self.currentPage = $state.params.page || 1;
        briefingService.getHistory($state.params.briefingId, { page: self.currentPage - 1, rows: 50 })
        .then(function(response){
            self.firstPage = response.first;
            self.lastPage = response.last;
            self.briefingHistories = _.map(response.content, function(briefingHistory) {
                return _.assign(briefingHistory, { created: moment.utc(briefingHistory.created).local().toDate() });
            });
            self.historyCount = response.totalPages;
            self.userStatuses = self.getUserStatuses(self.briefingHistories);
        });

        self.durations = _.range(1, 7);
        self.timeUnits = [
            { days: 30, text: 'months'},
            { days: 7,  text: 'weeks'},
            { days: 1,  text: 'days'}
        ];
        self.selectedDuration = ($state.params.duration|| 1) * 1;
        self.selectedTimeUnitDays = ($state.params.timeUnitDays || 7) * 1;
        self.graphSelection = 'briefing_email_delivered';

        renderAnalytics(self.selectedTimeUnitDays * self.selectedDuration, self.graphSelection);
    };

    self.setGraphSelection = function(selection) {
        self.graphSelection = selection;
        self.graphData = self[labelMap[selection]].graph;
    };

    self.toggleCurrentHistory = function(history, historyFilter){
        var sameSame = history === self.currentHistory && historyFilter === self.currentHistoryFilter;
        self.currentHistory = sameSame ? undefined : history;
        self.currentHistoryFilter = sameSame ? undefined: historyFilter;
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingItemScheduleCtrl',
['$rootScope', '_', 'growl', 'moment', '$uibModal', 'BriefingService', 'UtilService', 'briefing', 'briefingSchedule', 'tenant', 'user',
    function($rootScope, _, growl, moment, $uibModal, briefingService, utilService, briefing, briefingSchedule, tenant, user) {

        var self = this;

        var UNSUPPORTED_INTERVAL_MODES = ['EVERY_WEEKDAY', 'EVERY_MON_WED_FRI', 'EVERY_TUE_THUR'];

        this.intervals = _.range(1, 32);

        this.repeatModes = utilService.repeatModes;

        var localDateify = function(inDate, timeZone){
            var isoString = moment.utc(inDate).tz(timeZone).format('YYYY-MM-DDTHH:mm:ss.SSS');
            isoString = isoString + moment().format('Z');
            return new Date(isoString);
        };

        var prepareBriefing = function(briefingSchedule) {
            if (!briefingSchedule) {
                return {
                    scheduleMode: 'MANUAL',
                    freq: 'DAILY',
                    interval: 1,
                    timeZone: 'US/Pacific',
                    untilDate:localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles'),
                    startDate:localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles'),
                    sendTimeObj:moment().hour(0).minute(0).toDate(),
                    endMode:'NEVER_ENDS'
                };
            } else {
                briefingSchedule.timeZone = briefingSchedule.timeZone || user.timeZone || tenant.timeZone || 'US/Pacific';
                briefingSchedule.endMode = briefingSchedule.endMode || 'NEVER_ENDS';
                briefingSchedule.freq = briefingSchedule.freq || self.repeatModes[1].key;
                briefingSchedule.interval = briefingSchedule.interval || self.intervals[0];

                briefingSchedule.sendTimeObj = moment().hour(briefingSchedule.sendHour).minute(briefingSchedule.sendMinute).toDate();

                briefingSchedule.startDate = localDateify(briefingSchedule.start, briefingSchedule.timeZone);
                briefingSchedule.untilDate = localDateify(briefingSchedule.until, briefingSchedule.timeZone);
                self.selectedDays = {};
                _.forEach(briefingSchedule.byday, function(key){
                    self.selectedDays[key] = true;
                });
                if(briefingSchedule.freq === 'WEEKLY' && briefingSchedule.interval === 2){
                    briefingSchedule.freq = 'BIWEEKLY';
                }
            }
            
            return briefingSchedule;
        };

        var sendBriefingPreview = function(){
            setProcessing(true);
            briefingService.sendBriefingPreview(self.briefing.id)
            .then(function(){ growl.success('Briefing Sent'); })
            .finally(setProcessing);
        };

        var openViewBriefingPreview = function() {
            var modalInstance = $uibModal.open({
                templateUrl: '/templates/briefingPreviewModal.html',
                controller: 'BriefingPreviewCtrl',
                size: 'lg',
                keyboard: false,
                resolve: {
                    briefingId: function() {
                        return self.briefing.id;
                    }
                }
            });
            return modalInstance.result;
        };

        var confirmAnd = function(title, message, action){
            if(!self.isUnchanged()) {
                var modalScope = $rootScope.$new(true);
                modalScope.modalTitle = title;
                modalScope.message = message;
                modalScope.confirmLabel = 'Yes';
                return $uibModal.open({
                    templateUrl: '/templates/ConfirmModal.html',
                    size: 'lg',
                    scope: modalScope
                }).result
                .then(action);
            }else{
                action();
            }
        };

        this.frequencyChanged = function(){
            self.selectedDays = {};
            self.briefingSchedule.interval = self.briefingSchedule.freq === 'BIWEEKLY' ? 2 : 1;
        };

        this.endModeChanged = function() {
            this.briefingSchedule.untilDate = localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles');
        };

        var setProcessing = function (isProcessing){
            self.processing = isProcessing;
        };

        this.sendBriefingNow = function(){
            setProcessing(true);
            briefingService.sendBriefingNow(self.briefing.id)
            .then(function(){ growl.success('Briefing Sent'); })
            .finally(setProcessing);
        };

        this.sendBriefingPreviewNow = function(){
            confirmAnd('Send preview without saving briefing?',
                       'You have not saved the changes on this briefing, would you like to send the preview as it was before the changes?',
                        sendBriefingPreview);
        };

        this.viewBriefingPreview = function() {
            confirmAnd('View preview without saving briefing?',
                       'You have not saved the changes on this briefing, would you like to view the preview as it was before the changes?',
                       openViewBriefingPreview);
        };

        this.init = function(){
            this.briefing = briefing;
            this.briefingSchedule = prepareBriefing(briefingSchedule);
            this.isUnchanged = utilService.isUnchanged(this.briefingSchedule);
        };

        var configureForWeeks = function(freqLabel){
            self.briefingSchedule.byday = [];
            _.forEach(self.selectedDays, function (selected, day) {
                if (selected) {
                    self.briefingSchedule.byday.push(day);
                }
            });

            if (self.briefingSchedule.byday.length === 0) {
                growl.error('At least one day must be selected for a briefing scheduled with a ' + freqLabel + ' frequency.', {referenceId: 'streamBuilderMessages'});
                return;
            }
        };

        this.saveBriefingSchedule = function(){

            self.briefingSchedule.sendHour = moment(self.briefingSchedule.sendTimeObj).format('HH');
            self.briefingSchedule.sendMinute = moment(self.briefingSchedule.sendTimeObj).format('mm');

            this.briefingSchedule.start = moment(self.briefingSchedule.startDate).hour(0).minute(0).utc().toISOString();

            if(!moment(self.briefingSchedule.untilDate).isValid()) {
                self.briefingSchedule.untilDate = localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles');
            }

            self.briefingSchedule.until = moment(self.briefingSchedule.untilDate).hour(0).minute(0).utc().toISOString();

            if(self.briefingSchedule.freq === 'WEEKLY') {
                configureForWeeks('weekly');
            } else if(self.briefingSchedule.freq === 'BIWEEKLY'){
                configureForWeeks('bi-weekly');
            } else if(self.briefingSchedule.freq === 'EVERY_WEEKDAY') {
                self.briefingSchedule.byday = ['MO','TU','WE','TH','FR'];
            } else if(self.briefingSchedule.freq === 'EVERY_MON_WED_FRI') {
                self.briefingSchedule.byday = ['MO','WE','FR'];
            } else if(self.briefingSchedule.freq === 'EVERY_TUE_THUR') {
                self.briefingSchedule.byday = ['TU','TH'];
            }

            self.briefingSchedule.interval = _.includes(UNSUPPORTED_INTERVAL_MODES, self.briefingSchedule.freq) ? 1 : self.briefingSchedule.interval;


            if(self.briefingSchedule.freq === 'BIWEEKLY'){
                self.briefingSchedule.freq = 'WEEKLY';
                self.briefingSchedule.interval = 2;
            }

            if(self.briefingSchedule.scheduleMode !== 'MANUAL') {
                var startDateUnix = moment(self.briefingSchedule.startDate).millisecond(0).second(0).minute(0).hour(0).unix();
                var endDateUnix   = moment(self.briefingSchedule.untilDate).millisecond(0).second(0).minute(0).hour(0).unix();

                if (self.briefingSchedule.endMode === 'END' && startDateUnix >= endDateUnix) {
                    growl.error('End date must be after start date.');
                    return;
                }
            }

            setProcessing(true);

            briefingService.saveSchedule(self.briefing.id, self.briefingSchedule)
            .then(function(scheduleResults){
                self.briefingSchedule = prepareBriefing(scheduleResults);
                self.isUnchanged = utilService.isUnchanged(self.briefingSchedule);
                growl.success('Briefing Saved');
            })
            .catch(function() {
                growl.error('Failed to Save Schedule');
            })
            .finally(setProcessing);
        };

        this.init();
    }]);

'use strict';

angular.module('attensaApp')
.controller('BriefingHeaderCtrl',
['_', '$scope', '$rootScope', '$state', '$uibModal', 'growl', 'briefing', 'templates', 'tenantResponse', 'BriefingService',
function(_, $scope, $rootScope, $state, $uibModal, growl, briefing, templates, tenantResponse, briefingService) {
    this.state = $state;
    this.briefing = briefing;
    this.activeStates = {};

    $scope.$on('templateSelected', (evt, selectedTemplate) => {
        this.briefing.templateId = selectedTemplate.id;
        this.saveBriefing(this.briefing);
    });

    $scope.$on('briefing-updated', (evt, briefing) => this.briefing = briefing);

    this.saveBriefing = briefing => briefingService.saveBriefing(briefing).then(() => $rootScope.$broadcast('briefing-updated', briefing));

    this.deleteBriefing = briefing => $uibModal.open({
            templateUrl: '/templates/deleteBriefingWarningModal.html',
            size: 'lg'
        }).result
        .then( () => briefingService.deleteBriefing(briefing.id))
        .then(() => $state.go('briefings.list'))
        .catch(() => growl.error('An error occurred deleting the briefing and it may not have been deleted. Please refresh your browser.'));

    this.openSubscribers = () => $state.go('^.people', {filter: 'subscribers'});

    this.init = () => {
        this.briefingCustomConfigurationLabel = tenantResponse.data.settings.briefingCustomConfigurationLabel;
        this.showBriefingCustomConfiguration = tenantResponse.data.settings.showBriefingCustomConfiguration === 'true';
        _.forEach(['details', 'contents', 'people', 'groups', 'schedule'], 
        tab => this.activeStates[tab] = $state.current.name === 'briefingItem.' + tab);
        this.templateMap = _.indexBy(templates, 'id');
        this.show = true;
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingPeopleCtrl',
['_', '$rootScope', '$q', '$state', 'briefing', 'BriefingService', 'UserService',
function(_, $rootScope, $q, $state, briefing, briefingService, userService) {

    var self = this;
    var targetState = 'briefingItem.people';

    this.fetchPage = function(){
        $state.go(targetState, {page: self.paging.pagerPage - 1});
    };

    this.doSort = function(sort, sortDirection){
        $state.go(targetState, {sort: sort, sortDirection: sortDirection, page: 0});
    };

    this.doFilter = function(filter){
        $state.go(targetState, {filter: filter, page: 0});
    };

    this.doSearch = function(searchTerm){
        $state.go(targetState, { term: searchTerm , page: 0});
    };

    this.itemsSelected = function(){
        return !!_.find(self.users, {selected: true });
    };

    this.subscriptionChanged = function(){
        briefingService.getBriefing($state.params.briefingId)
        .then(function(briefing){
            self.briefing = briefing;
            $rootScope.$broadcast('briefing-updated', briefing);
        });

    };

    this.selectAllChanged = function(isChecked){
        _.forEach(self.users, function(user){ user.selected = isChecked; });
    };

    this.subscribe = function(){
        return $q.all(_.map(_.filter(self.users, {selected: true}), function(user){
            if(!_.find(user.subscriptions, { briefingId: self.briefing.id } )){
                return userService.subscribeToBriefing(user, self.briefing.id, self.briefing.streamId);
            }
        }))
        .then(self.subscriptionChanged);
    };

    this.unsubscribe = function(){
        return $q.all(_.map(_.filter(self.users, {selected: true}), function(user){
            if(_.find(user.subscriptions, { briefingId: $state.params.briefingId } )){
                return userService.unsubscribeFromBriefing(user, $state.params.briefingId);
            }
        }))
        .then(self.subscriptionChanged);
    };

    this.init = function(){
        self.fetching = true;
        self.briefing = briefing;

        var page = isNaN($state.params.page) ? 0 : parseInt($state.params.page);

        self.paging = {
            rows: 50,
            page: page,
            pagerPage: page + 1,
            sort: $state.params.sort,
            sortDirection: $state.params.sortDirection
        };

        self.briefingId = $state.params.briefingId;

        self.searchTerm = $state.params.term;

        self.filter = $state.params.filter;

        var fetcher;
        if($state.params.filter !== 'subscribers'){
            fetcher = userService.fetchUsers(50, self.paging.page, $state.params.sort, $state.params.sortDirection, $state.params.term);
        }else{
            fetcher = briefingService.fetchSubscribers($state.params.briefingId, 50, self.paging.page, $state.params.sort, $state.params.sortDirection, $state.params.term);
        }
        fetcher
        .then(function(response){
            self.fetching = false;
            self.users = response.content;
            self.paging.totalElements = response.totalElements;
            self.paging.first = response.first;
            self.paging.last = response.last;
        });
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingsSearchCtrl',
['_', '$state', 'BriefingService',
function(_, $state, briefingService) {

    this.init = function(){
        this.filters = _.union(briefingService.frequencyFilters, briefingService.scheduleModeFilters);
        this.state = $state;
        this.searchTerm = $state.params.searchTerm;
        this.filter = $state.params.filter;
    };

    this.setFilter = function(filter){
        
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingsItemListCtrl',
['_', '$state', 'BriefingService', 'TemplateService', 'UserService',
function(_, $state, briefingService, templateService, userService) {

    var self = this;

    var fetchItems = function(){
        self.ongoingRequest = true;
        self.searching = true;
        briefingService.getBriefings(self.itemSearchParams)
        .then(function (results) {
            self.ongoingRequest = false;
            self.searching = false;
            self.totalElements = results.totalElements;
            self.isLastPage = results.last;
            self.items.push.apply(self.items, _.filter(results.content, briefing => briefing.type !== 'SLACK'));
        });
    };

    this.init = function(){
        templateService.getAll()
        .then(function(results){
            self.templateMap = _.indexBy(results.data, 'id');
        });

        self.togglePublished = function(){
            $state.go($state.current.name, { publishedOnly: $state.params.publishedOnly ? undefined : true });
        };

        self.itemSearchParams = {
            page: 0,
            rows: 1000,
            published:true,
            hasBriefingEnabled: true,
            term: $state.params.searchTerm
        };

        if(_.includes(briefingService.frequencyFilters, $state.params.filter)){
            self.itemSearchParams.scheduleMode = 'RECURRING';
            self.itemSearchParams.freq = $state.params.filter.toUpperCase();
        }else if(_.includes(briefingService.scheduleModeFilters, $state.params.filter)){
            self.itemSearchParams.scheduleMode = $state.params.filter.toUpperCase();
        }

        self.items = [];

        userService.getCurrentUser()
        .then(function(userResponse){
            if(userResponse.data.user && userService.isAdmin(userResponse.data.user)){
                self.itemSearchParams.published = $state.params.publishedOnly ? true : undefined;
                self.publishedFilterVisible = true;
            }else{
                self.itemSearchParams.published = true;
            }
            fetchItems();
        });
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('StreamsCtrl',
['_', '$scope', '$http', '$q', '$uibModal', '$state', 'locker', 'growl', 'eventService', 'StreamService', 'StreamBuilderService', 'TaxonomyService', 'TenantService', 'LabelService',
'BriefingSubscriptionService', 'categoryService', 'permissionService', 'UserService', 'userResponse', 'UtilService', 'TemplateService', 'tenant', 'tenantCatalogMap',
function(_, $scope, $http, $q, $uibModal, $state, locker, growl, eventService, streamService, streamBuilderService, taxonomyService, tenantService, labelService,
briefingSubscriptionService, categoryService, permissionService, userService, userResponse, utilService, templateService, tenant, tenantCatalogMap) {

    //TODO sort needs to reset the page
    var clearSelectAll = function() {
        $scope.params.selectAll = false;
        $scope.params.streamCount = 0;
    };

    var populateCatalogTaxonomy = function(catalog) {
        return permissionService.currentUserHasPermission({ action: 'MANAGE_CATALOG' })
        .then(function(isCatalogManager) {
            return isCatalogManager ?
                taxonomyService.getCatalogTaxonomyTenantlessView(catalog.catalogId) : taxonomyService.getCatalogTaxonomy(catalog.catalogId);
        })
        .then(function (categories) {
            $scope.catalogTaxonomy[catalog.catalogId] = categories;
            return categories;
        });
    };

    var configureView = function(targetView){
        $scope.streamCount = null;
        $scope.params.streamCount = 0;
        $scope.view = targetView;
        $scope.params.hasBriefingEnabled = (targetView === 'briefing-table' || $scope.streamFilter && $scope.streamFilter.type === 'hasBriefingEnabled') ? true : null;
    };

    var mapTaxonomy = function(data){
        var expandedCatIds = _.pluck(_.filter($scope.taxonomy, { expanded: true }), 'id');
        return _.map(data, function(category) {
            if(_.indexOf(expandedCatIds, category.id) !== -1) {
                category.expanded = true;
            }
            return category;
        });
    };

    var allCategoryIds = function(){
        return _.chain($scope.taxonomy)
            .pluck('subcategories')
            .union($scope.taxonomy)
            .flatten()
            .pluck('id')
            .value();
    };

    $scope.selectViewTab = function(targetView) {
        // Dont go anywhere if its the same state or still fetching for data
        if(targetView === $scope.view || $scope.ongoingOtherRequest || $scope.ongoingRequest) {
            return;
        }
        $scope.params = _.assign({},
            { catalogId: $scope.params.catalogId },
            {
                page: 0,
                pagerPage: 1,
                rows: 40,
                type: null,
                selectAll: null,
                term: null,
                sort: null,
                sortDirection: null
            }
        );
        configureView(targetView);
        if($scope.streamFilter && targetView !== 'briefing-table' && targetView !== 'aggregation-table'){
            $scope.params[$scope.streamFilter.type] = $scope.streamFilter.params;
        }
        getFreshStreams();
    };

    $scope.filteredFrequencies = utilService.filteredFrequencies;

    $scope.openTemplateBrowser = function(stream) {
        templateService.openTemplateBrowser(stream.briefing)
        .then(function(newTemplate) {
            $http.put('/ws/briefing/' + stream.briefing.id, stream.briefing)
                .then(function(briefingRes) {
                    stream.briefingTemplateTitle = newTemplate.title;
                });
        });
    };

    $scope.setView = function(view){
        configureView(view);
        getFreshStreams();
    };

    $scope.$on('stream-tags-changed', function(evt, streamTags) {
        $scope.tenantStreamTags = streamTags;
    });

    $scope.$on('updateCatalog', function(event, updatedCategory) {
        taxonomyService.getTenantTaxonomy($scope.params.filterEmpty, $scope.params.published)
        .then(function(results) {
            $scope.taxonomy = mapTaxonomy(results.data);

            // If current category is irrelevant go back to All or Parent
            if($state.params.category && _.indexOf(allCategoryIds(), $state.params.category) === -1) {
                // Unless category has parent aka is not batman
                if(updatedCategory.parentTitle && updatedCategory.id === $state.params.category) {
                    $scope.selectCategory(_.find($scope.taxonomy, { title: updatedCategory.parentTitle }));
                } else {
                    $scope.selectTenantCatalog();
                }
            } else {
                getFreshStreams();
            }
        });
    });

    var updatePersonalCategory = function(evtData){
        taxonomyService.getTenantTaxonomy()
        .then(function(taxonomyResponse){
            return categoryService.updatePersonalCategory(evtData.stream, evtData.stream.userIsFollowing, taxonomyResponse.data, $scope.user, $scope.selectedCategory);
        })
        .then(function(updatedUser) {
            $scope.user = updatedUser;
        });
    };

    $scope.$on('update-personal-category', function(evt, evtData) {
        updatePersonalCategory(evtData);
    });

    $scope.init = function() {
        permissionService.currentUserHasPermission({ action: 'MANAGE_STREAM' })
        .then(function(hasManageStreamPermission) {
            $scope.hasManageStreamPermission = hasManageStreamPermission;
            locker.bind($scope, 'view', hasManageStreamPermission ? 'stream-table' : 'stream-tile');
            if(_.contains(['briefing-table', 'aggregation-table'], $scope.view) && !hasManageStreamPermission) {
                $scope.view = 'stream-table';
            }

            $scope.tenant = tenant.data;

            $scope.noFollowing = tenant.data.settings.noFollowing;

            $scope.params = {
                page: 0,
                pagerPage: 1,
                rows: 40,
                filterEmpty: true,
                published: true,
                selectAll: false,
                selectedCount: 0,
                catalogId: $state.params.catalog,
                categoryId: $state.params.category,
                term: $state.params.searchTerm,
                segmentation: $state.params.searchTerm ? {} : null,
                searching: $state.params.searchTerm ? true : null,
                sort: $state.params.sort,
                sortDirection: $state.params.sortDirection,
                type: $state.params.filter
            };


            $scope.feedbackLinkUrl = tenant.data.settings.feedbackLinkUrl;
            $scope.feedbackLinkTitle = tenant.data.settings.feedbackLinkTitle;

            labelService.setLabel($scope, 'catalogNavigationLabel', 'catalog_navigation_label', 'Catalog');

            $scope.catalogTaxonomy = {};
            $scope.currentTaxonomy = 'tenant';
            $scope.taxonomyOpenMap = {};
            if($scope.params.catalogId) {
                $scope.taxonomyOpenMap[$scope.params.catalogId] = true;
                var catalog = _.find(tenantCatalogMap, {catalogId: $scope.params.catalogId});

                if($scope.params.categoryId){
                    populateCatalogTaxonomy(catalog)
                    .then(function(categories){
                        var category = _.find(categories, {id: $scope.params.categoryId});
                        $scope.selectCatalogCategory(catalog, category);
                    });
                }else{
                    $scope.selectCatalog(catalog);
                }

            } else {
                $scope.taxonomyOpenMap.tenant = true;
            }
            $scope.user = userResponse.data.user;
            $scope.streams = [];
            $scope.params.hasBriefingEnabled = ($scope.view === 'briefing-table' || $scope.streamFilter && $scope.streamFilter.type === 'hasBriefingEnabled') ? true : null;
            $scope.params.published = userService.isAdmin($scope.user) ? undefined : true;
            $scope.tenantCatalogMap = tenantCatalogMap;
            $scope.catalogCount = _.size(tenantCatalogMap);

            $scope.filterOptions = streamService.streamFilterOptions;
            $scope.typeFilters = _.filter($scope.filterOptions, {type: 'type'});
            $scope.nonTypeFilters = _.reject($scope.filterOptions, {type: 'type'});

            if($state.params.filterType && $state.params.filter) {
                $scope.params.type = undefined;
                $scope.params[$state.params.filterType] = $state.params.filter;
                $scope.streamFilter = {type: $state.params.filterType, params: $state.params.filter, label: $state.params.filterLabel};
            }
            else if($state.params.filter) {
                $scope.streamFilter = _.findWhere($scope.typeFilters, {params: $state.params.filter});
            }

            fetchTaxonomy(true);
            $scope.fetchPage();

            tenantService.getStreamTags()
            .then(function(tenantStreamTags){
                $scope.tenantStreamTags = tenantStreamTags;
            });

            $scope.sortOptions = [
                { sort: 'titleLower', sortDirection: 'ASC', label: 'Title' },
                { sort: 'followersCount', sortDirection: 'DESC', label: 'Followers' },
                { sort: 'itemsCount', sortDirection: 'DESC', label: 'Items' }
            ];

            $scope.selectedSort = _.find($scope.sortOptions, { sort: $state.params.sort });
        });        
    };

    var fetchTaxonomy = function(preExpand) {
        taxonomyService.getTenantTaxonomy($scope.params.filterEmpty, $scope.params.published)
        .then(function(results) {
            $scope.taxonomy = results.data;
            if(preExpand){
                _.forEach($scope.taxonomy, function(category){
                    if(_.findIndex(category.subcategories, {id: $scope.params.categoryId }) !== -1){
                        category.expanded = true;
                    }
                });
            }
        });
    };

    $scope.fetchForCSV = () => {
        this.fetchingForCSV =  true;
        const params = { rows: 200000 };
        
        if($scope.view === 'aggregation-table') {
            params.excludeTypes = 'COLLECTION, PRODUCT_SOURCE';
        }
        
        return streamService.getTenantStreams(params)
        .then(streamRes => streamService.formatForExport(streamRes.data.content))
        .then(results => {
            this.fetchingForCSV =  false;
            eventService.postEvent('streams_list_downloaded', { streamsCount: results.length, view: $scope.view } );
            return results;
        });   
    };

    $scope.fetchPage = function() {
        if(!$scope.gettingStreams && !$scope.ongoingRequest) {
            $scope.showSpinner = true;
            $scope.params.page = $scope.params.pagerPage - 1;
            $scope.getStreams();
        }
    };

    $scope.toggleSelectAll = function(toggle) {
        _.forEach($scope.streams, function(stream) {
            stream.selected = stream.tenantId ? toggle : false;
        });

        $scope.params.selectedCount = toggle ?
            _.sum($scope.streams, function(stream) { return stream.selected ? 1 : 0; }) : 0;
    };

    $scope.isSort = function(sort, sortDirection){
        return $scope.params.sort === sort && $scope.params.sortDirection === sortDirection;
    };

    var initialSortMap = {
        titleLower: 'ASC',
        followersCount: 'DESC',
        itemsCount: 'DESC'
    };

    $scope.selectTag = function(tag){
        $scope.filterStreams({type: 'tagIds', params: tag.id, label: tag.label});
    };

    $scope.toggleSort = function(sort){
        clearSelectAll();
        if ($scope.params.sort === sort) {
            $scope.params.sortDirection =  $scope.params.sortDirection === 'ASC' ? 'DESC' : 'ASC';
        } else {
            $scope.params.sort = sort;
            $scope.params.sortDirection = initialSortMap[sort] || 'DESC';
        }
        getFreshStreams();
        $state.go($state.current.name, { sort: $scope.params.sort,  sortDirection: $scope.params.sortDirection }, { reload: false, notify: false });
    };

    $scope.changeSort = function(sortOption) {
        $scope.selectedSort = sortOption;
        $scope.params.sort = sortOption.sort;
        $scope.params.sortDirection = sortOption.sortDirection;
        $state.go($state.current.name, { sort: $scope.params.sort,  sortDirection: $scope.params.sortDirection }, { reload: false, notify: false });
        getFreshStreams();
    };

    var getIds = function(){
        if($scope.params.segmentation){
            return streamService.idsFromSearchSpec($scope.params.segmentation);
        }else{
            return {
                categoryId:  $scope.params.categoryId,
                catalogId: $scope.params.catalogId
            };
        }
    };

    var generateParams = function(ids){
        var paramCopy;
        var segmentation = $scope.params.segmentation;

        if(segmentation){
            paramCopy = {
                page: $scope.params.page,
                rows: $scope.params.rows,
                sort: $scope.params.sort,
                sortDirection: $scope.params.sortDirection,
                published: userService.isAdmin($scope.user) ? undefined : segmentation.published || true,
                hasBriefingEnabled: $scope.view === 'briefing-table' ? true : false,
                term: $scope.params.term,
                catalogId: ids.catalogId,
                includeCatalogs: segmentation.segment === 'all',
                tagIds: segmentation.tagIds,
                categoryId: ids.categoryId
            };

            _.forEach([segmentation.streamTypeFilter, segmentation.streamStateFilter], function(filter){
                if(filter) {
                    paramCopy[filter.type] = filter.params;
                }
            });
        }else{
            paramCopy = _.clone($scope.params);
        }

        if($scope.view === 'briefing-table') {
            paramCopy.type = null;
            paramCopy.published = null;
        }

        if($scope.view === 'aggregation-table') {
            paramCopy.excludeTypes = 'COLLECTION, PRODUCT_SOURCE';
        }

        if($scope.params.segmentation && $scope.params.segmentation.segment === 'recommended') {
            paramCopy.type   = 'item_search';
            paramCopy.search = paramCopy.term;
        }

        return paramCopy;
    };

    var _doSearch = function(ids, paramCopy){
        if($scope.params.segmentation && $scope.params.segmentation.segment === 'recommended') {
            return streamService.getRecommendedStreams(paramCopy, $scope.ongoingRequest.promise);
        }else if(!ids.categoryId && !ids.catalogId) {
            return streamService.getTenantStreams(paramCopy, $scope.ongoingRequest.promise);
        } else if(ids.categoryId && !ids.catalogId){
            return taxonomyService.getStreams({params: paramCopy, timeout: $scope.ongoingRequest.promise});
        } else if(!ids.categoryId && ids.catalogId){
            return streamService.getCatalogStreams(ids.catalogId, paramCopy, $scope.ongoingRequest.promise);
        } else{
            return taxonomyService.getCatalogCategoryStreams(ids.catalogId, {params: paramCopy, timeout: $scope.ongoingRequest.promise});
        }
    };

    $scope.getStreams = function() {
        // Cancels previous pending requests
        if($scope.ongoingRequest) {
            $scope.ongoingRequest.resolve('canceled');
        }
        $scope.ongoingRequest = $q.defer();

        var ids = getIds();

        return _doSearch(ids, generateParams(ids))
        .then(function(results) {
            $scope.showSpinner = false;
            $scope.streams = [];
            renderStreams(results);
        });
    };

    $scope.searchStreams = function() {
        $scope.emptyStreams = false;
        clearSelectAll();
        $scope.streamFilter = null;
        $scope.params.type = null;
        $scope.params.tagIds = null;
        getFreshStreams();
        $scope.params.searching = true;
        $state.go($state.current.name, { searchTerm: $scope.params.term }, {reload: false, notify: false});
        $scope.postSearchEvent($scope.params.term);
    };

    $scope.clearSearch = function() {
        clearSelectAll();
        $scope.emptyStreams = false;
        $scope.params.term = null;
        $scope.params.searching = null;
        $scope.params.segmentation = null;
        getFreshStreams();
        $state.go($state.current.name, { searchTerm: null }, {reload: false, notify: false});
    };

    var getFreshStreams = function(){
        $scope.showSpinner = true;
        $scope.params.page = 0;
        $scope.params.pagerPage = 1;
        $scope.streams = [];
        return $scope.getStreams();
    };

    $scope.postSearchEvent = function(searchTerm) {
        eventService.postEvent('user_searched', _.assign({
            context: 'streams',
            search_restrict_to_published: $scope.params.published,
            search_text: searchTerm,
            search_category: $scope.currentCategoryTitle()
        }));
    };

    $scope.selectCategory = function(category) {
        clearSelectAll();
        $scope.params.catalogId = undefined;
        $scope.selectedCategory = category;
        $scope.params.categoryId = category ? category.id : undefined;
        $state.go($state.current.name, { category: category ? category.id : undefined }, { reload: false, notify: false });

        getFreshStreams();
    };

    $scope.viewStreamDetails = streamService.openStreamDetailModal;

    $scope.isBeforeSelected = function($index) {
        var selectedIndex = _.findIndex($scope.taxonomy, function(cat) {
            return $scope.params.categoryId === cat.id;
        });
        return ($index + 1) === selectedIndex;
    };

    $scope.openFollowersModal = streamService.openFollowersModal;

    $scope.deleteStream = function(stream) {
        $uibModal.open({
            templateUrl: '/templates/deleteStreamWarningModal.html',
            controller: 'ContinueWarningCtrl',
            size: 'lg',
            resolve: {
                streamsCount: function() {
                    return 1;
                }
            }
        }).result
        .then(function() {
            var streamDeleter = $scope.params.catalogId ?
                streamService.deleteStreamFromCatalog($scope.params.catalogId, stream.id) : streamService.deleteStream(stream.id);

            streamDeleter
            .then(function() {
                $scope.streams = _.reject($scope.streams, { id: stream.id });
                $scope.streamCount--;
                if ($scope.streamCount === 0) {
                    fetchTaxonomy();
                    $scope.selectCategory();
                }
            })
            .catch(function() {
                growl.error('An error occurred deleting the stream and it may not have been deleted. Please refresh your browser.');
            });
        });
    };

    $scope.deleteStreams = function(streams) {
        if (streams.length) {
            $uibModal.open({
                templateUrl: '/templates/deleteStreamWarningModal.html',
                controller: 'ContinueWarningCtrl',
                size: 'lg',
                resolve: {
                    streamsCount: function() {
                        return streams.length;
                    }
                }
            }).result
            .then(function(confirmedDelete) {
                if(confirmedDelete) {
                    var streamIds = _.pluck(streams, 'id');
                    streamService.deleteStreams(streamIds)
                    .then(function() {
                        var deleteCount = $scope.streams.length;
                        $scope.streams = _.reject($scope.streams, function(stream) {
                            return stream.selected === true;
                        });
                        //This is so that we do not have to refetch all of the streams and the count again
                        deleteCount = deleteCount - $scope.streams.length;
                        $scope.streamCount = $scope.streamCount - deleteCount;
                        if ($scope.streamCount === 0) {
                            fetchTaxonomy();
                            $scope.selectCategory();
                        }
                    },
                    function() {
                        growl.error('An error occurred deleting the streams. Not all streams may have been deleted. Please refresh your browser.');
                    });
                }
            });
        }
    };

    $scope.addTagsToStreams = function(streams) {
        var streamTagPromise = tenantService.getStreamTags();
        $uibModal.open({
            templateUrl: '/templates/TagSelectionModal.html',
            controller: 'TagSelectionModalCtrl',
            size: 'md',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                streamTags: function(){
                    return streamTagPromise;
                }
            }
        }).result
        .then(function(tagIds){
            var streamUpdatePromises = [];
            _.forEach(streams, function(stream){
                stream.tags = _.union(stream.tags, tagIds);
                streamUpdatePromises.push(streamService.updateStream(stream));
            });
            return $q.all(streamUpdatePromises);
        })
        .catch(function(err) {
            growl.error('An error occurred while adding tags to the streams. Not all streams may have been tagged. Please refresh your browser.');
        })
        .finally(function() {
            $scope.params.selectAll = false;
            getFreshStreams();
        });
    };

    $scope.addCategoriesToStreams = function(streams) {
        // We have to resolve a freshly gotten taxonomy because the one on the scope is filtered
        var taxonomyPromise = taxonomyService.getTenantTaxonomy();
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'CategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: function() {
                    return taxonomyPromise
                    .then(function(taxonomyRes) {
                        return taxonomyRes.data;
                    });
                },
                stream: function() {
                    return { taxonomicMemberships: [] };
                },
                taxonomyVersion: function() {
                    return taxonomyPromise
                    .then(function(taxonomyRes) {
                        return taxonomyRes.headers('X-Object-Version');
                    });
                }
            }
        })
        .result.then(function(categoryIds) {
            var streamUpdatePromises = [];
            _.forEach(streams, function(stream) {
                stream.taxonomicMemberships = _.union(stream.taxonomicMemberships, categoryIds);
                streamUpdatePromises.push(streamService.updateStream(stream));
            });

            $q.all(streamUpdatePromises)
            .catch(function(err) {
                growl.error('An error occurred while adding streams to categories. Not all streams may have been categorized. Please refresh your browser.');
            })
            .finally(function() {
                taxonomyService.getTenantTaxonomy($scope.params.filterEmpty, $scope.params.published)
                .then(function(results) {
                    var existingExpandedCategoryIds = _.pluck(_.filter($scope.taxonomy, { expanded: true }), 'id');
                    var parentCategoryIdsToExpand = _.compact(_.map(categoryIds, function(categoryId) {
                        return taxonomyService.getParentCategoryId(categoryId, results.data);
                    }));
                    $scope.taxonomy = _.map(results.data, function(category) {
                        return _.contains(_.union(existingExpandedCategoryIds, parentCategoryIdsToExpand), category.id) ?
                            _.assign(category, { expanded: true }) : category;
                    });
                });
                getFreshStreams();
            });
        });
    };

    $scope.setStreamPublish = function(streams, published) {
        streams.forEach(function(stream) {
            stream.streamId = stream.id;
            stream.published = published;
        });
        streamService.patchStreams(streams)
        .finally(function(){
            getFreshStreams();
        })
        .catch(function(err) {
            growl.error('An error occurred publishing the streams. Not all streams may have been published. Please refresh your browser.');
        });
    };

    $scope.setDisableAggregation = function(streams, disabled) {
        var streamUpdatePromises = _.map(streams, function(stream) {
            stream.settings.aggregationDisabled = disabled;
            stream.settings.aggregationEnabled = !disabled;
            return streamService.updateStream(stream);
        });

        $q.all(streamUpdatePromises)
        .catch(function(err) {
            growl.error('An error occurred setting aggregation status.  Please refresh your browser.');
        });
    };

    $scope.bulkAction = function(action, options) {
        action(_.filter($scope.streams, {selected: true}), options);
    };

    var categoryFor = function(id) {
        return _.findWhere($scope.taxonomy, { id: id });
    };

    $scope.currentCategoryTitle = function() {
        return $scope.params.categoryId && categoryFor($scope.params.categoryId) ? categoryFor($scope.params.categoryId).title : 'All';
    };

    $scope.$on('follow-change', function(evt, evtData) {
        if(evtData.followStatusChanged) {
            updatePersonalCategory(evtData);
        }
    });

    $scope.$on('streams-clear', $scope.clearSearch);

    $scope.filterStreams = function(filter) {
        clearSelectAll();
        $scope.streamFilter = filter;
        $scope.params[filter.type] = filter.params;
        // Only carry over type filters
        if(filter.type === 'type') {
            $state.go($state.current.name, {filter: filter.params, filterType: undefined, filterLabel: undefined}, {reload: false, notify: false});
        } else if(filter.type === 'tagIds') {
            $state.go($state.current.name, {filter: filter.params, filterType: filter.type, filterLabel: filter.label}, {reload: false, notify: false});
        } else {
            $state.go($state.current.name, { filter: undefined, filterType: undefined, filterLabel: undefined }, { reload: false, notify: false });
        }
        getFreshStreams();
    };

    $scope.removeFilter = function() {
        $scope.streamFilter = null;
        $scope.params.type = null;
        $scope.params.tagIds = null;
        $scope.params.published = userService.isAdmin($scope.user) ? undefined : true;
        $scope.params.hasBriefingEnabled = $scope.view === 'briefing-table' ? true : false;
        $state.go($state.current.name, { filter: undefined, filterType: undefined, filterLabel: undefined }, { reload: false, notify: false });
        getFreshStreams();
    };

    $scope.removeFilterAndSearch = function() {
        clearSelectAll();
        $scope.params.term = null;
        $scope.streamFilter = null;
        $scope.params.type = null;
        $scope.params.tagIds = null;
        $scope.params.published = userService.isAdmin($scope.user) ? undefined : true;
        $scope.params.hasBriefingEnabled = $scope.briefingView ? true : false;
        getFreshStreams();
        $state.go($state.current.name, { searchTerm: null, filter: undefined, filterType: undefined, filterLabel: undefined }, {reload: false, notify: false});
    };

    var renderStreams = function(results) {
        $scope.streams = _.union($scope.streams, _.map(results.data.content, function(stream) {
            stream.settings.aggregationEnabled = !stream.settings.aggregationDisabled;
            return stream;
        }));
        $scope.totalPages = results.data.totalPages;
        $scope.last = results.data.last;
        $scope.streamCount = results.data.totalElements;
        $scope.emptyStreams = $scope.streams.length === 0 ? true : false;
        $scope.gettingStreams = false;
        $scope.ongoingRequest = null;
    };

    $scope.selectAllCheck = function(select) {
        if(!$scope.params.selectedCount){
            $scope.params.selectedCount = 0;
        }
        if (select === false) {
            --$scope.params.selectedCount;
            $scope.params.selectAll = false;
        } else {
            ++$scope.params.selectedCount;
        }
    };

    $scope.selectTenantCatalog = function(){
        $scope.currentTaxonomy = 'tenant';
        $scope.selectCategory();
    };

    $scope.selectCatalog = function(catalog){
        $scope.currentCatalog = catalog;
        $scope.params.catalogId = catalog.catalogId;
        $scope.streamFilter = null;
        $scope.params.hasBriefingEnabled = false;
        $scope.params.type = null;
        $scope.params.tagIds = null;
        $state.go($state.current.name, { filter: undefined, filterType: undefined, filterLabel: undefined }, { reload: false, notify: false });
        $scope.selectCatalogCategory(catalog);

        // De-select briefings or aggregation tab on catalog if not a catalog manager
        permissionService.currentUserHasPermission({ action: 'MANAGE_CATALOG' })
        .then(function(isCatalogManager) {
            if($scope.view === 'briefing-table' || ($scope.view === 'aggregation-table' && !isCatalogManager)) {
                $scope.view = 'stream-table';
            }
        });
        $scope.currentTaxonomy = catalog.catalogId;

        if(!$scope.catalogTaxonomy[catalog.catalogId]) {
            populateCatalogTaxonomy(catalog);
        }
    };

    $scope.$on('populate-catalog-taxonomy', function(evt, catalog){
        if(!$scope.catalogTaxonomy[catalog.catalogId]) {
            populateCatalogTaxonomy(catalog);
        }
    });

    $scope.$on('taxonomyUpdated', function(){
        taxonomyService.getTenantTaxonomy($scope.params.filterEmpty, $scope.params.published)
            .then(function(results) {
                $scope.taxonomy = mapTaxonomy(results.data);

                // If current category is irrelevant go back to All or Parent
                if($state.params.category && _.indexOf(allCategoryIds(), $state.params.category) === -1) {
                    $scope.selectTenantCatalog();
                } else {
                    getFreshStreams();
                }
            });
    });

    $scope.selectCatalogCategory = function(catalog, category) {
        clearSelectAll();
        $scope.selectedCategory = category;
        $scope.params.catalogId = catalog.catalogId;
        $scope.params.categoryId = category ? category.id : undefined;
        getFreshStreams();
    };

    $scope.saveAggregationStatus = function(stream) {
        stream.settings.aggregationDisabled = !stream.settings.aggregationEnabled;
        streamService.updateStream(stream)
        .catch(function() {
            growl.error('An error occurred updating the aggregation status');
        });
    };

    $scope.createEmptyCatalogTopic = function() {
        var streamId;
        $uibModal.open({
            templateUrl: '/templates/topicNameModal.html',
            size: 'sm',
            keyboard: true
        })
        .result.then(function(streamTitle) {
            return streamService.saveStream({
                title: streamTitle,
                type: 'COLLECTION',
                openForReading: true,
                published: true
            }, { isCatalogStream: true })
            .catch(function() {
                growl.error('Unable to create topic.');
                return $q.reject('cancelled');
            });
        })
        .then(function(streamResponse) {
            streamId = streamResponse.data.id;
            return streamService.categorizeStreamInCatalog(streamId, $scope.params.catalogId, $scope.params.categoryId);
        })
        .then(function() {
            $state.go('editTopic.sources', {
                streamId: streamId,
                catalogId: $scope.params.catalogId
            });
        });
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('StreamsSearchCtrl',
    ['_', '$scope', '$rootScope', 'TaxonomyService', 'TenantService',
    function(_, $scope, $rootScope, taxonomyService, tenantService) {

    var expandForSubcategory = function(categoryId, categories, markMap){
        _.forEach(categories, function(category){
            if(category.id !== categoryId && category.subcategories.length){
                _.forEach(category.subcategories, function(subcategory){
                    if(subcategory.id === categoryId){
                        markMap[category.id] = true;
                    }
                });
            }
        });
    };

    var initializeSegmentation = function(){
        var catalogId = $scope.params.catalogId;
        var categoryId = $scope.params.categoryId;
        if(!catalogId && !categoryId){
            $scope.params.segmentation = {segment: 'taxonomy'};
            $scope.params.segmentKey = 'taxonomy';
        } else if(!catalogId && categoryId){
            $scope.params.segmentation = {segment: 'taxonomyCategory', id: categoryId };
            $scope.searchMenuState.categoriesExpanded = true;
            expandForSubcategory(categoryId, $scope.taxonomy, $scope.searchMenuState.categoryExpandedMap);
            $scope.params.segmentKey = 'taxonomyCategory-' + categoryId;
        } else if(catalogId && !categoryId){
            $scope.params.segmentation = {segment: 'catalog', id: $scope.params.catalogId };
            $scope.params.segmentKey = 'catalog-' + catalogId;
        } else {
            $scope.params.segmentation = {segment: 'catalogCategory', catalogId: $scope.params.catalogId, id: categoryId };
            $scope.searchMenuState.catalogExpandedMap[catalogId] = true;
            expandForSubcategory(categoryId, $scope.catalogTaxonomy[catalogId], $scope.searchMenuState.catalogCategoryExpandedMap[catalogId]);
            $scope.params.segmentKey = 'catalogCategory-' + catalogId + '-' + categoryId;
       }
    };

    $scope.search = function(){
        $scope.termRequired = $scope.params.segmentation.segment === 'recommended' && !$scope.params.term;
        if(!$scope.termRequired){
            $scope.searchStreams();
        }
    };

    $scope.$watchCollection('params.segmentation', function(newParams, oldParams) {
        if(!_.isEqual(newParams, oldParams)) {
            return $scope.search(newParams);
        }
    });

    $scope.segmentationLabel = function(){
        if($scope.params.segmentation) {
            if ($scope.params.segmentation.segment === 'all') {
                return 'All Catalogs';
            } else if($scope.params.segmentation.segment === 'recommended') {
                return 'Recommended';
            } else if ($scope.params.segmentation.segment === 'taxonomy') {
                return $scope.catalogNavigationLabel;
            } else if ($scope.params.segmentation.segment === 'taxonomyCategory') {
                var result = taxonomyService.getCategory($scope.taxonomy, $scope.params.segmentation.id);
                return result ? result.title : '';
            } else if ($scope.params.segmentation.segment === 'catalog') {
                return _.find($scope.tenantCatalogMap, {catalogId: $scope.params.segmentation.id}).label;
            } else if ($scope.params.segmentation.segment === 'catalogCategory') {
                var res = taxonomyService.getCategory($scope.catalogTaxonomy[$scope.params.segmentation.catalogId], $scope.params.segmentation.id);
                return res ? res.title : '';
            }
        }
    };

    $scope.isTaxonomySegment = taxonomyService.isTaxonomySegment;

    $scope.selectTag = function($item){
        $scope.newTagLabel = $item.label;
        $scope.params.segmentation.tagIds = $item.id;
        $scope.search();
    };

    $scope.$watch('newTag', function(newVal){
        if($scope.newTagLabel && $scope.newTagLabel !== newVal){
            $scope.params.segmentation.tagIds = [];
        }
    });

    $scope.selectSegment = function(segmentation){
        if (segmentation.segment !== 'recommended') {
            segmentation.tagIds = $scope.params.segmentation.tagIds;
        } else {
            segmentation.tagIds = [];
            $scope.newTag = '';
            $scope.newTagLabel = '';
        }
        $scope.params.segmentation = segmentation;
    };

    $scope.init = function(){
        $scope.streamTagMap = {};

        tenantService.getStreamTags()
        .then(function(tenantStreamTags){
            $scope.streamTagMap['default'] = tenantStreamTags;
        });

        $scope.searchMenuState = {
            categoryExpandedMap: {},
            catalogExpandedMap: {},
            catalogCategoryExpandedMap: {},
            personalCategoryExpandedMap: {}
        };

        _.forEach($scope.tenantCatalogMap, function(catalog){
            $scope.searchMenuState.catalogCategoryExpandedMap[catalog.catalogId] = {};
            if(!$scope.catalogTaxonomy[catalog.catalogId]){
                $rootScope.$broadcast('populate-catalog-taxonomy', catalog);
            }
            taxonomyService.getCatalogTags(catalog.catalogId)
            .then(function(catalogTags){
                $scope.streamTagMap[catalog.catalogId] = catalogTags;
            });
        });

        initializeSegmentation();
    };

    $scope.tagSet = function(){
        if ($scope.params.segmentation.segment === 'catalog') {
            return $scope.streamTagMap[$scope.params.segmentation.id];
        } else if ($scope.params.segmentation.segment === 'catalogCategory') {
            return $scope.streamTagMap[$scope.params.segmentation.catalogId];
        } else{
            return $scope.streamTagMap['default'];
        }
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('StreamCategoryModalCtrl',
    ['_', '$scope', '$rootScope', '$http', '$uibModalInstance', '$q', 'stream', 'categoryService', 'growl', 'UserService',
    function(_, $scope, $rootScope, $http, $uibModalInstance, $q, stream, categoryService, growl, userService) {

    $scope.initialize = function () {
        $scope.duplicateCategoryEntered = false;
        $http.get('/ws/category/byType/Personal')
        .then(function(response){
            $scope.categories = response.data;
        });
    };

    $scope.selectCategory = function(){
        $scope.duplicateCategoryEntered = false;
        $scope.newCategoryName = null;
    };

    $scope.newCategoryNameChange = function(){
        $scope.selectedCategory = null;
        $scope.duplicateCategoryEntered = _.some($scope.categories, {'title': $scope.newCategoryName});
    };

    $scope.isInvalid = function() {
        return !$scope.newCategoryName && !$scope.selectedCategory || $scope.duplicateCategoryEntered;
    };

    $scope.save = function() {
        $scope.saving = true;
        var deferred = $q.defer();
        deferred.promise
        .then(function(){
            if($scope.newCategoryName){
                return $http.post('/ws/category', {
                    title: $scope.newCategoryName,
                    type: 'Personal'
                });
            }else{
                return null;
            }
        })
        .then(function(result){
            if(result){
                return result.data;
            }else{
                return $scope.selectedCategory;
            }
        })
        .then(function(category){
            $scope.subscriptionCategory = category;
            return userService.getCurrentUser().then(function(res) { return res.data.user; });
        })
        .then(function(currentUser) {
            return categoryService.addSubscriptionToCategory(stream, $scope.subscriptionCategory, currentUser.id);
        })
        .then(function(result){
            $uibModalInstance.close({
                result: result.data,
                subscriptionCategory: $scope.subscriptionCategory
            });
        })
        .catch(function(err){
            $scope.$broadcast('stream-category-alerts', {type: 'danger', msg:'Error categorizing stream, please try again.'});
        });

        deferred.resolve();
    };

    $scope.cancel = function() {
      $uibModalInstance.dismiss();
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp').controller('StreamCreateCtrl',
['_', '$scope', '$state', '$stateParams', 'StreamBuilderService', 'TenantService',
    function(_, $scope, $state, $stateParams, streamBuilderService, tenantService) {
        $scope.categoryId = $stateParams.category === 'uncategorized' ? undefined : $stateParams.category;
        $scope.createStream = streamBuilderService.open;

        this.onInit = () => {
            tenantService.getCurrentTenant()
            .then(response => {
                const tenant = response.data;
                $scope.allSources = !(tenant.settings.allowedSources && tenant.settings.allowedSources.length);
                $scope.allowedSources = tenant.settings.allowedSources;
            });
        };

        $scope.sourceAllowed = source => {
            return $scope.allSources || _.includes($scope.allowedSources, source);
        };

        this.onInit();
    }
]);

'use strict';

angular.module('attensaApp')
.controller('StreamDetailCtrl',
    ['$scope', '$rootScope', '$timeout', '$uibModalInstance', '$http', '$state', 'StreamService', 'stream',
    'BriefingSubscriptionService', 'UtilService', 'categoryDetail', 'UserService', 'DefaultToMyTopicsProvider', 'TenantService',
    function($scope, $rootScope, $timeout, $uibModalInstance, $http, $state, streamService, stream,
    briefingSubscriptionService, utilService, categoryDetail, userService, defaultToMyTopicsProvider, tenantService) {

    $scope.initialize = function(){
        $scope.stream = stream;
        $scope.wasFollowing = $scope.stream.userIsFollowing;

        $scope.tooltipManager = function(isBriefing) {
            return utilService.tooltipManager($scope.stream, isBriefing);
        };

        $http.get('/ws/streams/' + stream.id + '/items', { params: { page: 0, rows: 6} })
        .then(function(result){
            if (result.status !== 200) {
                $rootScope.$broadcast('catalog-alerts', {type: 'danger', msg:'Error loading stream details, please close and try again.'});
            } else {
                $scope.items = result.data.content;
            }
        });

        tenantService.getCurrentTenant()
        .then(function(tenantResp){
            $scope.noFollowing = tenantResp.data.settings.noFollowing;
        });

        userService.getCurrentUser()
        .then(function(res) {
            $scope.userId = res.data.user.id;
        });
    };

    $scope.viewItem = function(item, stream) {
        $uibModalInstance.close(item);
        defaultToMyTopicsProvider
        .then(function(shouldDefault){
            if(shouldDefault){
                $state.go('mytopics.topic', {itemId: item.id, streamId: stream.id });
                $timeout(function(){
                    $state.go('mytopics.topic', {itemId: item.id, streamId: stream.id });
                });
            } else{
                $state.go('reading', {itemId: item.id, s: stream.id });
                $timeout(function(){
                    $state.go('reading', {itemId: item.id, s: stream.id });
                });
            }
        });

    };

    $scope.$on('follow-change', function(evt, evtData) {
        $scope.wasFollowing = evtData.followStatusChanged ? !evtData.stream.userIsFollowing : evtData.stream.userIsFollowing;
        $rootScope.$broadcast('stream-change', $scope.wasFollowing, evtData.stream, categoryDetail, true);
        $rootScope.$broadcast('stream-changed', evtData.stream);
        if(evtData.followStatusChanged) {
            $rootScope.$broadcast('update-personal-category', evtData);
        }
    });

    $scope.openFollowersModal = function(stream) {
        return streamService.openFollowersModal(stream);
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
    .controller('TagSelectionModalCtrl',
    ['_', '$scope', '$rootScope', 'streamTags', 'TenantService',
    function(_, $scope, $rootScope, streamTags, tenantService) {

        $scope.init = function() {
            $scope.tenantStreamTags = streamTags;
            $scope.tags = [];
        };

        $scope.selectTag = function(tag){
            if(!_.contains($scope.tags, tag.id)) {
                $scope.tags.push(tag.id);
                $scope.newTag = '';
            }
        };

        $scope.addTag = function(newTag) {
            if(!_.find($scope.tenantStreamTags, {label: newTag}) && !_.isEmpty(newTag)){
                tenantService.saveStreamTag({ label: newTag })
                .then(function(streamTag) {
                    $scope.tenantStreamTags.push(streamTag);
                    $scope.selectTag(streamTag);
                });
            }
        };

        $scope.tagLabel = function(id){
            return _.find($scope.tenantStreamTags, {id: id}).label;
        };

        $scope.deleteTag = function(tag){
            $scope.tags = _.without($scope.tags, tag);
        };

        $scope.init();

    }]);

'use strict';

angular.module('attensaApp')
.controller('TemplateSelectorCtrl',['$scope', '$rootScope', '$uibModalInstance', 'Upload', '$window', '$interval', 'template', 'templatePlacer',
    function($scope, $rootScope, $uibModalInstance, $upload, $window, $interval, template, templatePlacer) {

    $scope.initialize = function () {
        $scope.template = (template ? template : { title: '', type: 'Email' });
        $scope.uploadButtonText = 'Upload';
        $scope.uploadInProgress = false;
    };

    $scope.close = $uibModalInstance.dismiss;

    $scope.uploadTemplate = function(file) {

        $scope.uploadButtonText = 'Uploading...';
        $scope.uploadInProgress = true;

        var uploadUrl = '/ws/template/upload';
        var data = { title: $scope.template.title, type: $scope.template.type };

        if($scope.template.id) {
            uploadUrl = '/ws/template/'+$scope.template.id+'/file';
            data = {};
        }

        $upload.upload({
            url: uploadUrl,
            method: 'POST',
            data: data,
            headers: { 'Content-Type': 'multipart/form-data' },
            file: file
        })
        .then(function(response, status, headers, config) {
            $scope.template = response.data;
            $uibModalInstance.dismiss();
            templatePlacer($scope.template, template ? template.id : null);
        }).catch(function() {
            $scope.uploadButtonText = 'Upload';
            $scope.uploadInProgress = false;
            $scope.$broadcast('template-select-alerts', {type: 'danger', msg: 'Upload failed. Bad template file.'});
        });

    };

    $scope.initialize();

}]);
'use strict';

angular.module('attensaApp')
.controller('TemplateDetailModalCtrl',['$scope', '$rootScope', '$http', '$window', '_', 'template', 's3Bucket',
function($scope, $rootScope, $http, $window, _, template, s3Bucket) {

    $scope.initialize = function () {
        $scope.currentPage = -1;
        $scope.pageLimit = 20;
        $scope.template = template;
        $scope.s3Bucket = s3Bucket.data;
        $scope.templateBriefings = [];
        $scope.fetchingInProgress = false;
    };

    $scope.refreshTemplateBriefings = function() {
        $http.get('/ws/briefing?templateId='+template.id+'&page='+$scope.currentPage+'&rows='+$scope.pageLimit)
        .then(function(response){
            $scope.currentPage = response.data.number;
            $scope.lastPage = response.data.last;
            $scope.templateBriefings.push.apply($scope.templateBriefings, response.data.content);
            $scope.fetchingInProgress = false;
        })
        .catch(function() {
            $scope.fetchingInProgress = false;
            $scope.$broadcast('template-detail-alerts', {type: 'danger', msg: 'Failed to refresh template briefings.'});
        });
    };

    $scope.dissociateFromBriefing = function(briefing) {
        if($scope.templateBriefings.length <= $scope.pageLimit) {
            $scope.fetchNextPage();
        }
        $http.post('/ws/briefing/'+briefing.id+'/template/default')
        .then(function(response){
            $scope.templateBriefings = _.reject($scope.templateBriefings, function(templateBriefing){
                return templateBriefing.id === briefing.id;
            });
            $rootScope.$broadcast('refreshTemplates');
        })
        .catch(function() {
            $scope.$broadcast('template-detail-alerts', {type: 'danger', msg: 'Failed to dissociate template from briefing.'});
        });
    };

    $scope.fetchNextPage = function() {
        if(!$scope.lastPage && !$scope.fetchingInProgress) {
            $scope.fetchingInProgress = true;
            $scope.currentPage++;
            $scope.refreshTemplateBriefings();
        }
    };

    $scope.initialize();

}]);
'use strict';

angular.module('attensaApp')
.controller('TemplateBrowserCtrl',['$scope', '$rootScope', '$state', '$http', '$uibModal', '$uibModalInstance', '$window', '$timeout', '_', 'templates', 'briefing', 's3Bucket', 'TemplateService',
function($scope, $rootScope, $state, $http, $uibModal, $uibModalInstance, $window, $timeout, _, templates, briefing, s3Bucket, templateService) {

    $scope.initialize = function () {
        $scope.templates = $scope.sortTemplates(templates.data);
        $scope.s3Bucket = s3Bucket.data;
        $scope.briefing = briefing;
        $scope.selectedTemplate = _.findWhere($scope.templates, {id: $scope.briefing.templateId});
        $scope.manage = false;
    };

    $scope.manageTemplates = function(){
        $state.go('manageTemplates', {}, {location: true});
        $timeout(function(){
            $state.go('manageTemplates', {}, {location: true});
        });
    };

    $scope.sortTemplates = function(templates) {
        var selectedTemplate = _.findWhere(templates, {id:briefing.templateId});
        if(selectedTemplate) {
            selectedTemplate.isSelected = true;
        }
        return _(templates).chain()
            .sortBy('title')
            .sortBy('isSelected')
            .value();
    };

    $scope.$on('refreshTemplates', function(event) {
        templateService.getAll()
        .then(function(results){
            $scope.templates = $scope.sortTemplates(results.data);
        });
    });

    $scope.placeTemplate = function(template) {
        $scope.templates.push(template);
        $scope.templates = $scope.sortTemplates($scope.templates);
    };

    $scope.selectTemplate = function(template) {
        $scope.selectedTemplate = template;
    };

    $scope.saveSelection = function() {
        briefing.templateId = $scope.selectedTemplate.id;
        $rootScope.$broadcast('templateSelected', $scope.selectedTemplate);
        $uibModalInstance.close($scope.selectedTemplate);
    };

    $scope.placeTemplate = function(template, oldTemplateId) {
        $scope.templates.push(template);
    };

    $scope.uploadTemplate = function(uploadTarget){
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/templateSelectModal.html',
            controller: 'TemplateSelectorCtrl',
            size: 'sm',
            resolve: {
                uploadTarget: function() { return uploadTarget; },
                template:function() { return null; },
                templatePlacer: function() { return $scope.placeTemplate; }
            }
        });
        return modalInstance.result;
    };

    $scope.initialize();

}]);
'use strict';

angular.module('attensaApp')
.controller('TenantAnalyticsCtrl', ['_', '$q', 'eventService', 'ItemService', 'StreamService', 'UtilService',
function(_, $q, eventService, itemService, streamService, utilService) {
    this.init = function() {
        this.fetchingData = true;
        this.durations = _.range(1, 7);
        this.timeUnits = [
            { days: 30, text: 'months'},
            { days: 7,  text: 'weeks'},
            { days: 1,  text: 'days'}
        ];
        this.selectedDuration = 1;
        this.selectedTimeUnitDays = 7;
        this.graphSelection = 'item_viewed';
        this.renderAnalytics(this.selectedTimeUnitDays * this.selectedDuration, this.graphSelection);
    };

    this.renderAnalytics = function(daysAgo, graphSelection) {
        var self = this;
        this.fetchingData = true;
        return $q.all([
            self.getSegmentationData(daysAgo, 'item_viewed', eventService.totalsFormatter),
            self.getSegmentationData(daysAgo, 'item_link_clicked', eventService.totalsFormatter),
            self.getSegmentationData(daysAgo, 'item_viewed', eventService.uniquesMetricFormatter, {
                segmentationProp: 'item_id'
            }),
            self.getSegmentationData(daysAgo, 'item_viewed', eventService.uniquesMetricFormatter, {
                segmentationProp: 'stream_id'
            }),
            self.getSegmentationData(daysAgo, 'item_viewed', eventService.topItemsFormatter, {
                segmentationProp: 'item_id'
            }),
            self.getSegmentationData(daysAgo, 'item_viewed', eventService.topItemsFormatter, {
                segmentationProp: 'stream_id'
            })
        ])
        .then(function(queryResults) {
            self.totalViewsData = queryResults[0];
            self.clickThroughData = queryResults[1];
            self.uniqueViewsData = queryResults[2];
            self.uniqueStreamsData = queryResults[3];
            itemService.getItems(_.map(queryResults[4], function(idCountPair) { return idCountPair[0]; }))
            .then(function(items) {
                self.topItems = eventService.buildItemListDetails(queryResults[4], items);
            });
            var streamPromises = _.map(queryResults[5], function(idCountPair) {
                return utilService.unwrap(streamService.getStream(idCountPair[0]))
                .catch(function() {
                    return null;  // If we can't find teh stream, i.e. it has been deleted
                });
            });
            $q.all(streamPromises)
            .then(function(streams) {
                self.topStreams = _.chain(queryResults[5])
                .map(function(idCountPair) {
                    return _.assign(_.find(streams, {id: idCountPair[0] }), { count: idCountPair[1] });
                })
                .reject(_.isUndefined)
                .value();
            });
            self.setGraphSelection(graphSelection);
        })
        .finally(function() {
            self.fetchingData = false;
        });
    };

    this.getSegmentationData = function(daysAgo, event, formatter, opts) {
        return eventService.getSegmentationData(daysAgo, event, opts)
        .then(function(results) {
            return formatter(results, event);
        });
    };

    this.setGraphSelection = function(selection) {
        this.graphSelection = selection;
        this.graphData = selection === 'item_viewed' ? this.totalViewsData.graph : this.clickThroughData.graph;
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('TenantThemeCtrl', ['$scope', 'TenantService',
function($scope, tenantService) {

    $scope.init = function(){
        tenantService.getUnauthTenantInfo()
        .then(function(tenantResponse) {
            if(tenantResponse.data.settings.customCss){
                $scope.tenantCss = tenantResponse.data.settings.customCss;
            }
        });
    };

    $scope.init();
}]);
'use strict';

angular.module('attensaApp')
.controller('BriefingHistoryCtrl',
['_', '$scope', '$http', 'moment', 'briefingHistories', 'BriefingService', 'EMAIL_ACTIVITIES',
    function(_, $scope, $http, moment, briefingHistories, BriefingService, EMAIL_ACTIVITIES) {
        $scope.initialize = function () {
            $scope.briefingHistories = briefingHistories.content;
            $scope.historyCount = briefingHistories.totalPages;
            $scope.userStatuses = $scope.getUserStatuses($scope.briefingHistories);
            $scope.currentPage = 1;
        };

        $scope.fetchHistory = function() {
            return BriefingService.getHistory($scope.briefingHistories[0].briefingId, { page: $scope.currentPage - 1 })
            .then(function(historyResponse) {
                $scope.briefingHistories = _.map(historyResponse.content, function(briefingHistory) {
                    return _.assign(briefingHistory, { created: moment.utc(briefingHistory.created).local().toDate() });
                });
                $scope.historyCount = historyResponse.totalPages;
                $scope.userStatuses = $scope.getUserStatuses($scope.briefingHistories);
            });
        };

        $scope.getUserStatuses = function(briefingHistories) {
            return _.map(briefingHistories, function(history) {
                return BriefingService.getLatestEmailActivityPerUser(history.activities);
            });
        };
        
        $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('BriefingPreviewCtrl',
['$scope', '$sce', 'briefingId',
    function($scope, $sce, briefingId) {

        $scope.initialize = function () {
            $scope.briefingPreviewUrl = $sce.trustAsResourceUrl('/ws/ua/briefings/' + briefingId + '/preview?briefingId');
        };

        $scope.initialize();

    }]);

'use strict';

angular.module('attensaApp')
.controller('BriefingSubscribersModalCtrl', ['briefing', function(briefing) {
    var self = this;

    this.initialize = function () {
        self.briefing = briefing;
    };

    this.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('StreamFollowersModalCtrl', ['$scope', '$window', '_', 'StreamService', 'UtilService', 'stream', 'catalogId', 'showSubscribers', 'UserService', 'eventService',
function($scope, $window, _, streamService, utilService, stream, catalogId, showSubscribers, UserService, eventService) {

    $scope.initialize = function() {
        $scope.currentPage = -1; //Prime for initial infinite scroll
        $scope.pageLimit = 40;
        $scope.followers = [];
        $scope.showSubscribers = showSubscribers;

        $scope.loading = true;
        $scope.stream = stream;
        $scope.streamId = stream.id;
        $scope.nextPageLoading = false;
    };

    $scope.fetchNextPage = function() {
        if(!$scope.lastPage && !$scope.nextPageLoading) {
            $scope.nextPageLoading = true;
            $scope.currentPage++;
            $scope.fetchFollowers();
        }
    };

    $scope._followersGetter = function(sortOptions) {
        var options = utilService.sortPeopleOptions(sortOptions, $scope);
        if ($scope.showSubscribers) {
            return streamService.getStreamSubscribers($scope.streamId, options);
        } else if (!stream.tenantId && catalogId) {
            return streamService.getCatalogStreamFollowers($scope.streamId, catalogId, options);
        } else {
            return streamService.getStreamFollowers($scope.streamId, options);
        }
    };

    $scope.fetchFollowers = function(sortOptions) {
        $scope._followersGetter(sortOptions)
        .then(function (results) {
            $scope.currentPage = results.data.number;
            $scope.lastPage = results.data.last;
            $scope.sortDirection = results.data.sort[0] ? results.data.sort[0].direction : $scope.sortDirection;
            $scope.loading = false;
            $scope.followers.push.apply($scope.followers, results.data.content);
            $scope.nextPageLoading = false;
            $scope.totalFollowers = results.data.totalElements;
        });
    };

    $scope._getAllFollowers = function () {
        return $scope._followersGetter({rows: $scope.totalFollowers});
    };

    $scope.fetchForCSV = function() {
        return $scope._getAllFollowers()
        .then(function(followersRes) {
            eventService.postEvent('followers_list_downloaded', { followersCount: followersRes.totalFollowers, streamId: $scope.streamId } );
            return UserService.formatForExport(followersRes.data.content);
        });
    };

    $scope.emailAllFollowers = function() {
        $scope._getAllFollowers()
        .then(function(followersRes) {
            var followers = _.pluck(followersRes.data.content, 'emailAddress').join(',');
            $window.location.href = 'mailto:' + followers + '?subject=' + stream.title;
        });
    };

    var resetFollowers = function(sortOptions) {
        $scope.currentPage = 0;
        $scope.followers = [];
        $scope.fetchFollowers(sortOptions);
    };

    $scope.sortByUserProperty = function(sortOptions) {
        resetFollowers(sortOptions);
    };

    $scope.searchPeople = function() {
        resetFollowers();
    };

    $scope.clearSearch = function() {
        $scope.searchTerm = '';
        resetFollowers();
    };

    $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
    .controller('CategorySelectionModalCtrl',
    ['_', '$scope', '$rootScope', '$uibModalInstance', 'TaxonomyService', 'taxonomy', 'stream', 'taxonomyVersion', 'growl',
    function(_, $scope, $rootScope, $uibModalInstance, taxonomyService, taxonomy, stream, taxonomyVersion, growl) {

        $scope.init = function() {
            $scope.taxonomy = taxonomy;
            $scope.taxonomyVersion = taxonomyVersion;
            $scope.searchText = '';
        };

        var loadTaxonomy = function() {
            taxonomyService.getTenantTaxonomy()
            .then(function(tenantTaxonomyResponse) {
                taxonomyService._setTaxonomyDataOnScope(tenantTaxonomyResponse, $scope);
            });
        };

        $scope.saveNewCategory = function(title, parent) {
            if(title.toLowerCase().indexOf('uncategorized') > -1) {
                growl.error('Naming a category as "uncategorized" is invalid.');
                return false;
            }

            if(!parent) {
                $scope.taxonomy.unshift({
                    title: title,
                    removable: true
                });
            } else {
                if (!parent.subcategories) {
                    parent.subcategories = [];
                }
                parent.subcategories.push({
                    title: title,
                    subcategories: [],
                    removable: true
                });
            }

            $scope.newCategory = { title: '' };
            return $scope.saveTenantTaxonomy(title);
        };

        $scope.saveTenantTaxonomy = function(title) {
            taxonomyService.saveTenantTaxonomy(title, $scope, growl, loadTaxonomy).then(function() {
                $rootScope.$broadcast('taxonomyUpdated', { taxonomy: $scope.taxonomy, taxonomyVersion: $scope.taxonomyVersion } );
            });
        };

        $scope.toggleSelection = function(category) {
            if(!category.selected) {
                stream.taxonomicMemberships = _.reject(stream.taxonomicMemberships, function(taxonomicMembership){
                    return taxonomicMembership === category.id;
                });
                $rootScope.$broadcast('taxonomicMembershipChange', stream.taxonomicMemberships, category, stream);
            } else {
                stream.taxonomicMemberships.push(category.id);
                $rootScope.$broadcast('taxonomicMembershipChange', stream.taxonomicMemberships, category, stream);
            }
        };

        $scope.close = function() {
            $uibModalInstance.close(stream.taxonomicMemberships);
        };

        $scope.init();

    }]);

'use strict';

angular.module('attensaApp').controller('ManageCategoriesCtrl', [
    '$scope',
    '$uibModal',
    '$q',
    '_',
    'TaxonomyService',
    'growl',
    '$stateParams',
    'TenantService',
    function ManageCategoriesCtrl(
        $scope,
        $uibModal,
        $q,
        _,
        taxonomyService,
        growl,
        $stateParams,
        TenantService
    ) {

        $scope.initialize = function () {
            $scope.taxonomyVersion = '';
            $scope.searchText = '';
            $scope.categoryCount = 0;
            $scope.categoryCollapsedMap = {};
            loadTaxonomy();
            if($stateParams.catalogId) {
                TenantService.getCatalogMap()
                .then(function(catalogs) {
                    $scope.catalog = _.find(catalogs, { catalogId: $stateParams.catalogId });
                });
            }
        };

        var loadTaxonomy = function() {
            if($stateParams.catalogId) {
                taxonomyService.getCatalogTaxonomyTenantlessView($stateParams.catalogId)
                .then(function(taxonomy) {
                    taxonomyService.setCatalogTaxonomyDataOnScope(taxonomy, $scope);
                });
            } else {
                taxonomyService.getTenantTaxonomy()
                .then(function(tenantTaxonomyResponse) {
                    taxonomyService._setTaxonomyDataOnScope(tenantTaxonomyResponse, $scope);
                });
            }
        };

        $scope.saveNewCategory = function(title) {
            var errMsg = $scope.validateTitle(title);
            if(errMsg){
                return $q.reject(errMsg);
            }

            $scope.taxonomy.unshift({
                title:title,
                subcategories: [],
                removable:true
            });
            $scope.newCategory = { title: '' };
            return $scope.saveTenantTaxonomy();
        };

        $scope.toggleAllExpansion = function(){
            var collapse = !$scope.allCollapsed();
            _.forEach($scope.taxonomy, function(parentCat){
                $scope.categoryCollapsedMap[parentCat.id] = collapse;
            });
        };

        $scope.allCollapsed = function(){
            return _.reduce($scope.taxonomy, function(result, category){
                return result && $scope.categoryCollapsedMap[category.id];
            }, true);
        };

        $scope.saveNewSubcategory = function(title, parent) {
            var errMsg = $scope.validateTitle(title);
            if(errMsg){
                return $q.reject(errMsg);
            }

            parent.subcategories.push({
                title:title,
                subcategories: [],
                removable:true
            });
            $scope.newSubCategory = { title: '' };
            return $scope.saveTenantTaxonomy();
        };

        $scope.validateTitle = function(title){
            if(!title || _.isEmpty(title)){
                return 'Category name cannot be blank.';
            }
            if(title.toLowerCase().indexOf('uncategorized') > -1) {
                return 'Naming a category as "uncategorized" is invalid.';
            }
            if(title.length > 40) {
                return 'Category title length must be less than 40 characters.';
            }
        };

        $scope.saveTenantTaxonomy = function(title) {
            return $stateParams.catalogId ?
                taxonomyService.saveCatalogTaxonomy($stateParams.catalogId, title, $scope, growl, loadTaxonomy, true) :
                taxonomyService.saveTenantTaxonomy(title, $scope, growl, loadTaxonomy, true);
        };

        $scope.deleteCategory = function(categoryToDelete, parentCategory) {
            var modalScope = $scope.$new(true);
            modalScope.modalTitle = 'Continue deleting category?';
            modalScope.message = 'Warning! This will <b>permanently</b> remove this category from the system.<br/>By clicking the Delete button below, you are confirming that you are removing this category and that it cannot be restored.';
            modalScope.confirmLabel = 'Delete';
            $uibModal.open({
                templateUrl: '/templates/ConfirmModal.html',
                size: 'lg',
                scope: modalScope
            }).result
                .then(function(){
                    if(parentCategory){
                        parentCategory.subcategories = _.reject(parentCategory.subcategories, { id: categoryToDelete.id });
                    }else{
                        $scope.taxonomy = _.reject($scope.taxonomy, { id: categoryToDelete.id });
                    }

                    $scope.saveTenantTaxonomy();
                });
        };

        $scope.alphabetize = function() {
            var comparator = function(item) {
                return item.title.toLowerCase();
            };

            $scope.taxonomy = _.sortBy($scope.taxonomy, comparator);

            _.forEach($scope.taxonomy, function(category){
                category.subcategories = _.sortBy(category.subcategories, comparator);
            });

            $scope.saveTenantTaxonomy();
        };

        $scope.categoryCollapsed = function(category){
          return $scope.categoryCollapsedMap[category.id];
        };

        $scope.categoryEnter = function(category, $event){
            if($event.buttons !== 1) {
                category.hovered = true;
            }
        };

        $scope.categoryLeave = function(category){
            category.hovered = false;
        };

        $scope.toggleCategory = function(scope){
            $scope.categoryCollapsedMap[scope.$modelValue.id] = !$scope.categoryCollapsedMap[scope.$modelValue.id];
        };

        $scope.treeOptions = {
            accept: function(sourceNodeScope, destNodeScope, destIndex) {
                var canDrop = !destNodeScope.$parent.$modelValue || !sourceNodeScope.$modelValue.subcategories.length;
                return canDrop;
            },
            dropped: function($event){
                if($event.dest.nodesScope.$parent.$modelValue){
                    $scope.categoryCollapsedMap[$event.dest.nodesScope.$parent.$modelValue.id] = false;
                }
                $scope.saveTenantTaxonomy();
            },
            dragStart: function(event){
                $scope.draggingParent = event.source.nodeScope.$modelValue.subcategories && event.source.nodeScope.$modelValue.subcategories.length;
                $scope.dragging = true;
            },
            dragStop: function(){
                $scope.dragging = false;
            }
        };

        $scope.initialize();
    }
]);

'use strict';

angular.module('attensaApp')
.controller('BingBuilderCtrl', ['$state', '$scope', '$window', '$uibModal', '$q', '_', 'growl',
'ItemService', 'StreamService', 'TaxonomyService', '$rootScope',
function($state, $scope, $window, $uibModal, $q, _, growl,
itemService, streamService, taxonomyService, $rootScope) {
    $scope.init = function() {
        var promise = $scope.config.id ? streamService.getStream($scope.config.id) : $q.when({});
        promise
        .then(function(stream) {
            $scope.stream = stream.data;

            $scope.bing = {};

            $scope.bing.search = stream && stream.data ? stream.data.settings.search : '';
            $scope.bing.type = stream && stream.data ? stream.data.settings.type : 'NEWS';

            $scope.title = stream && stream.data ? stream.data.title : '';

            $scope.taxonomicMemberships = stream && stream.taxonomicMemberships ? stream.taxonomicMemberships : [];

            $scope.action = stream.data && stream.data.id ? 'Edit' : 'Create';
            if (stream.data && stream.data.id) {
                $scope.streamId = stream.data.id;
            }
            $scope.searchBtn = 'Search';
            $scope.addBtn = 'Save';
            $scope.config.fetching = false;
        });
    };

    $scope.search = function() {
        $scope.searchBtn = 'Searching...';

        itemService.searchBing($scope.bing.search, { type: $scope.bing.type })
        .then(function(bingItems) {
            $scope.bingPreview = true;
            if (!$scope.title) {
                $scope.title = $scope.bing.search;
            }
            $scope.description = $scope.bing.search;
            $scope.bingItems = bingItems;
            if(!$scope.streamId) {
                taxonomyService.getTenantTaxonomy()
                .then(function(response) {
                    $scope.taxonomyVersion = response.headers('X-Object-Version');
                    if($state.params.category && $state.params.category !== 'uncategorized') {
                        $scope.taxonomicMemberships = taxonomyService.createStreamCategories(response.data, [$state.params.category]);
                    }
                    $scope.taxonomy = taxonomyService.markSelectedCategories(response.data, [$state.params.category]);
                });

                $scope.showCategories = true;
            }
        })
        .catch(function(){
            growl.warning('Bing search failed', { referenceId: 'streamBuilderMessages' });
        })
        .finally(function(){
            $scope.searchBtn = 'Search';
        });
    };

    $scope.bingChanged = function()  {
        $scope.bingPreview = false;
    };

    $scope.editCategories = function() {
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'SimpleCategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: function() {
                    return $scope.taxonomy;
                },
                taxonomyVersion: function() {
                    return $scope.taxonomyVersion;
                }
            }
        }).result
        .then(function(taxonomicMemberships){
            $scope.taxonomicMemberships = taxonomicMemberships;
        });
    };

    var resetSaveLabel = function(){
        $scope.addBtn = 'Save';
    };

    $scope.save = function() {
        $scope.addBtn = 'Saving...';

        var newStream;
        if($scope.stream && $scope.stream.id) {
            newStream = $scope.stream;
        } else {
            newStream = {
                title: $scope.title,
                type: 'BING_SEARCH',
                description: $scope.description,
                openForReading: true,
                emailPostingEnabled: false,
                taxonomicMemberships: _.pluck($scope.taxonomicMemberships, 'id'),
                settings: {
                    type: $scope.bing.type
                }
            };
        }
        newStream.settings.search = $scope.bing.search;

        var warningPromise = _.isEmpty($scope.taxonomicMemberships) && !$scope.stream ?
            streamService.noCategoryWarning() : $q.when(undefined);

        warningPromise
        .then(function () {
            return saveStream(newStream);
        })
        .catch(function() {
            resetSaveLabel();
        });
    };

    $scope.categoryTitle = streamService.categoryTitle;

    var saveStream = function(newStream) {
        var persistor = $scope.stream && $scope.stream.id ? streamService.updateStream : streamService.saveStream;
        return persistor(newStream)
        .then(function(saveStreamRes) {
            $scope.config.id = saveStreamRes.data.id;
            if($scope.config.closeable) {
                $scope.$close(saveStreamRes.data);
            } else {
                $state.go('editTopic.articles', { streamId: saveStreamRes.data.id });
            }
        })
        .catch(function() {
            growl.error('An error occurred when attempting to save this stream', { referenceId: 'streamBuilderMessages' });
            resetSaveLabel();
        });
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('ClinicaltrialsBuilderCtrl', ['$state', '$scope', '$window', '$uibModal', '$q', '_', 'growl',
'ItemService', 'StreamService', 'TaxonomyService', '$rootScope',
function($state, $scope, $window, $uibModal, $q, _,
growl, itemService, streamService, taxonomyService, $rootScope) {
    $scope.init = function() {
        var promise = $scope.config.id ? streamService.getStream($scope.config.id) : $q.when({});
        promise
        .then(function(stream) {
            $scope.stream = stream.data;

            $scope.clinicaltrials = {};

            $scope.clinicaltrials.search = stream && stream.data ? stream.data.settings.search : '';

            $scope.title = stream && stream.data ? stream.data.title : '';

            $scope.taxonomicMemberships = stream && stream.taxonomicMemberships ? stream.taxonomicMemberships : [];

            $scope.action = stream.data && stream.data.id ? 'Edit' : 'Create';
            if (stream.data && stream.data.id) {
                $scope.streamId = stream.data.id;
            }
            $scope.searchBtn = 'Search';
            $scope.addBtn = 'Save';
            $scope.config.fetching = false;
        });
    };

    $scope.search = function() {
        $scope.searchBtn = 'Searching...';

        itemService.searchClinicaltrials($scope.clinicaltrials.search)
        .then(function(clinicalTrialsItems) {
            $scope.clinicaltrialsPreview = true;
            if (!$scope.title) {
                $scope.title = $scope.clinicaltrials.search;
            }
            $scope.description = $scope.clinicaltrials.search;
            $scope.clinicaltrialsItems = clinicalTrialsItems;
            if(!$scope.streamId) {
                taxonomyService.getTenantTaxonomy()
                .then(function(response) {
                    $scope.taxonomyVersion = response.headers('X-Object-Version');
                    if($state.params.category && $state.params.category !== 'uncategorized') {
                        $scope.taxonomicMemberships = taxonomyService.createStreamCategories(response.data, [$state.params.category]);
                    }
                    $scope.taxonomy = taxonomyService.markSelectedCategories(response.data, [$state.params.category]);
                });

                $scope.showCategories = true;
            }
        })
        .catch(function(){
            growl.warning('ClinicalTrials.gov search failed', { referenceId: 'streamBuilderMessages' });
        })
        .finally(function(){
            $scope.searchBtn = 'Search';
        });
    };

    $scope.clinicaltrialsChanged = function()  {
        $scope.clinicaltrialsPreview = false;
    };

    $scope.editCategories = function() {
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'SimpleCategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: function() {
                    return $scope.taxonomy;
                },
                taxonomyVersion: function() {
                    return $scope.taxonomyVersion;
                }
            }
        }).result
        .then(function(taxonomicMemberships){
            $scope.taxonomicMemberships = taxonomicMemberships;
        });
    };

    var resetSaveLabel = function(){
        $scope.addBtn = 'Save';
    };

    $scope.save = function() {
        $scope.addBtn = 'Saving...';

        var newStream;
        if($scope.stream && $scope.stream.id) {
            newStream = $scope.stream;
        } else {
            newStream = {
                title: $scope.title,
                type: 'CLINICALTRIALS_SEARCH',
                description: $scope.description,
                openForReading: true,
                emailPostingEnabled: false,
                taxonomicMemberships: _.pluck($scope.taxonomicMemberships, 'id'),
                settings: {}
            };
        }
        newStream.settings.search = $scope.clinicaltrials.search;

        var warningPromise = _.isEmpty($scope.taxonomicMemberships) && !$scope.stream ?
            streamService.noCategoryWarning() : $q.when(undefined);

        warningPromise
        .then(function () {
            return saveStream(newStream);
        })
        .catch(function() {
            resetSaveLabel();
        });
    };

    $scope.categoryTitle = streamService.categoryTitle;

    var saveStream = function(newStream) {
        var persistor = $scope.stream && $scope.stream.id ? streamService.updateStream : streamService.saveStream;
        return persistor(newStream)
        .then(function(saveStreamRes) {
            $scope.config.id = saveStreamRes.data.id;
            if($scope.config.closeable) {
                $scope.$close(saveStreamRes.data);
            } else {
                $state.go('editTopic.articles', { streamId: saveStreamRes.data.id });
            }
        })
        .catch(function() {
            growl.error('An error occurred when attempting to save this stream', { referenceId: 'streamBuilderMessages' });
            resetSaveLabel();
        });
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('FactivaBuilderCtrl', ['$state', '$scope', '$window', '$uibModal', '$q', '_', 'growl',
'ItemService', 'StreamService', 'TaxonomyService', '$rootScope',
function($state, $scope, $window, $uibModal, $q, _, growl,
    itemService, streamService, taxonomyService, $rootScope) {
    $scope.init = function() {
        var promise = $scope.config.id ? streamService.getStream($scope.config.id) : $q.when({});
        promise
        .then(function(stream) {
            $scope.stream = stream.data;

            $scope.title = stream && stream.data ? stream.data.title : '';

            $scope.taxonomicMemberships = stream && stream.taxonomicMemberships ? stream.taxonomicMemberships : [];

            $scope.action = stream.data && stream.data.id ? 'Edit' : 'Create';
            if (stream.data && stream.data.id) {
                $scope.streamId = stream.data.id;
                $scope.customerId = streamService.extractFactivaCustomerId(stream.data.settings.username);
                $scope.folderName = streamService.extractFactivaFolder(stream.data.settings.uri);
            }
            $scope.addBtn = 'Save';
            $scope.config.fetching = false;

            if(!$scope.streamId) {
                taxonomyService.getTenantTaxonomy()
                .then(function(response) {
                    $scope.taxonomyVersion = response.headers('X-Object-Version');
                    if($state.params.category && $state.params.category !== 'uncategorized') {
                        $scope.taxonomicMemberships = taxonomyService.createStreamCategories(response.data, [$state.params.category]);
                    }
                    $scope.taxonomy = taxonomyService.markSelectedCategories(response.data, [$state.params.category]);
                });

                $scope.showCategories = true;
            }
        });
    };

    $scope.editCategories = function() {
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'SimpleCategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: function() {
                    return $scope.taxonomy;
                },
                taxonomyVersion: function() {
                    return $scope.taxonomyVersion;
                }
            }
        }).result
        .then(function(taxonomicMemberships){
            $scope.taxonomicMemberships = taxonomicMemberships;
        });
    };

    var resetSaveLabel = function(){
        $scope.addBtn = 'Save';
    };

    $scope.save = function() {
        $scope.addBtn = 'Saving...';

        var newStream;
        if($scope.stream && $scope.stream.id) {
            newStream = $scope.stream;
        } else {
            newStream = {
                title: $scope.title,
                type: 'FACTIVA_SELECT_HTTP',
                taxonomicMemberships: _.pluck($scope.taxonomicMemberships, 'id'),
                settings: {
                    itemTimeToLiveInDays: 90
                }
            };
        }
        newStream.settings.uri = 'select.factiva.com/' + $scope.folderName;
        newStream.settings.username = 'select/' + $scope.customerId;
        newStream.settings.password = $scope.password;

        var warningPromise = _.isEmpty($scope.taxonomicMemberships) && !$scope.stream ?
            streamService.noCategoryWarning() : $q.when(undefined);

        warningPromise
        .then(function () {
            return saveStream(newStream);
        })
        .catch(function() {
            resetSaveLabel();
        });
    };

    $scope.categoryTitle = streamService.categoryTitle;

    function isPreExisting(stream) {
        return stream && stream.id;
    }

    var saveStream = function(newStream) {
        var persistor = isPreExisting($scope.stream) ?
            streamService.saveCredentials(newStream.id, newStream.settings) : streamService.saveStream(newStream);

        return persistor
        .then(function(saveStreamRes) {
            $scope.config.id = saveStreamRes.data.id || newStream.id;
            // TODO: get rid of the target string thing when streambuilder modal is dead
            if($scope.config.closeable) {
                $scope.$close(isPreExisting($scope.stream) ? _.assign($scope.stream, { settings: newStream.settings }) : saveStreamRes.data);
            } else {
                $state.go('editTopic.articles', { streamId: $scope.config.id });
            }
        })
        .catch(function() {
            growl.error('An error occurred when attempting to save this stream', { referenceId: 'streamBuilderMessages' });
            resetSaveLabel();
        });
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('PubmedBuilderCtrl', ['$state', '$scope', '$window', '$uibModal', '$q', '_', 'growl',
'ItemService', 'StreamService', 'TaxonomyService', '$rootScope',
function($state, $scope, $window, $uibModal, $q, _, growl,
itemService, streamService, taxonomyService, $rootScope) {
    $scope.init = function() {
        var promise = $scope.config.id ? streamService.getStream($scope.config.id) : $q.when({});
        promise
        .then(function(stream) {
            $scope.stream = stream.data;

            $scope.pubmed = {};

            $scope.pubmed.search = stream && stream.data ? stream.data.settings.search : '';

            $scope.title = stream && stream.data ? stream.data.title : '';

            $scope.taxonomicMemberships = stream && stream.taxonomicMemberships ? stream.taxonomicMemberships : [];

            $scope.action = stream.data && stream.data.id ? 'Edit' : 'Create';
            if (stream.data && stream.data.id) {
                $scope.streamId = stream.data.id;
            }
            $scope.searchBtn = 'Search';
            $scope.addBtn = 'Save';
            $scope.config.fetching = false;
        });
    };

    $scope.search = function() {
        $scope.searchBtn = 'Searching...';

        itemService.searchPubmed($scope.pubmed.search)
        .then(function(pubmedItems) {
            $scope.pubmedPreview = true;
            if (!$scope.title) {
                $scope.title = $scope.pubmed.search;
            }
            $scope.description = $scope.pubmed.search;
            $scope.pubmedItems = pubmedItems;
            if(!$scope.streamId) {
                taxonomyService.getTenantTaxonomy()
                .then(function(response) {
                    $scope.taxonomyVersion = response.headers('X-Object-Version');
                    if($state.params.category && $state.params.category !== 'uncategorized') {
                        $scope.taxonomicMemberships = taxonomyService.createStreamCategories(response.data, [$state.params.category]);
                    }
                    $scope.taxonomy = taxonomyService.markSelectedCategories(response.data, [$state.params.category]);
                });

                $scope.showCategories = true;
            }
        })
        .catch(function(){
            growl.warning('PubMed search failed', { referenceId: 'streamBuilderMessages' });
        })
        .finally(function(){
            $scope.searchBtn = 'Search';
        });
    };

    $scope.pubmedChanged = function()  {
        $scope.pubmedPreview = false;
    };

    $scope.editCategories = function() {
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'SimpleCategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: function() {
                    return $scope.taxonomy;
                },
                taxonomyVersion: function() {
                    return $scope.taxonomyVersion;
                }
            }
        }).result
        .then(function(taxonomicMemberships){
            $scope.taxonomicMemberships = taxonomicMemberships;
        });
    };

    var resetSaveLabel = function(){
        $scope.addBtn = 'Save';
    };

    $scope.save = function() {
        $scope.addBtn = 'Saving...';

        var newStream;
        if($scope.stream && $scope.stream.id) {
            newStream = $scope.stream;
        } else {
            newStream = {
                title: $scope.title,
                type: 'PUBMED_SEARCH',
                description: $scope.description,
                openForReading: true,
                emailPostingEnabled: false,
                taxonomicMemberships: _.pluck($scope.taxonomicMemberships, 'id'),
                settings: {}
            };
        }
        newStream.settings.search = $scope.pubmed.search;

        var warningPromise = _.isEmpty($scope.taxonomicMemberships) && !$scope.stream ?
            streamService.noCategoryWarning() : $q.when(undefined);

        warningPromise
        .then(function () {
            return saveStream(newStream);
        })
        .catch(function() {
            resetSaveLabel();
        });
    };

    $scope.categoryTitle = streamService.categoryTitle;

    var saveStream = function(newStream) {
        var persistor = $scope.stream && $scope.stream.id ? streamService.updateStream : streamService.saveStream;
        return persistor(newStream)
        .then(function(saveStreamRes) {
            $scope.config.id = saveStreamRes.data.id;
            if($scope.config.closeable) {
                $scope.$close(saveStreamRes.data);
            } else {
                $state.go('editTopic.articles', { streamId: saveStreamRes.data.id });
            }
        })
        .catch(function() {
            growl.error('An error occurred when attempting to save this stream', { referenceId: 'streamBuilderMessages' });
            resetSaveLabel();
        });
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('RssBuilderCtrl', ['$state', '$scope', '$http', '$uibModal', '$q', '_', 'growl', 'StreamService', 'TaxonomyService', 'TenantService', 
function($state, $scope, $http, $uibModal, $q, _, growl, streamService, taxonomyService, tenantService) {
    this.init = () => {

        this.rssPreview = { shown: false };

        const promise = $scope.config.id ? streamService.getStream($scope.config.id) : $q.when({});
        promise
        .then((stream) => {
            this.stream = stream;
            this.catalog = $state.params.catalog || $state.params.catalogId;
            this.rss = {};

            this.action = stream.data && stream.data.id ? 'Edit' : 'Create';
            if (stream.data && stream.data.id) {
                this.streamId               = stream.data.id;
                this.rss.currentCredentials = !!stream.data.settings.username;
                this.rss.username           = stream.data.settings.username;
                this.rss.password           = undefined;
                this.rss.input              = stream.data.settings.source;
                this.rss.isAuthenticated    = this.rss.currentCredentials;
            } else {
                taxonomyService.getTenantTaxonomy()
                .then(taxonomyRes => {
                    this.taxonomy           = taxonomyRes.data;
                    this.taxonomyVersion    = taxonomyRes.headers('X-Object-Version');
                    this.selectedCategories = [];
                    if ($state.params.category && $state.params.category !== 'uncategorized') {
                        this.selectedCategories = taxonomyService.createStreamCategories(this.taxonomy, [$state.params.category]);
                        this.taxonomy = taxonomyService.markSelectedCategories(this.taxonomy, [$state.params.category]);
                    }
                });
            }

            this.searchBtn = 'Search';
            this.addBtn    = 'Save';
            $scope.config.fetching = false;
        });
    };

    const prependProtocol = url => url.indexOf('http') !== 0 ? 'http://' + url : url;    

    const doSearch = () => {
        let url;
        tenantService.getCurrentTenant()
        .then(tenantRes => tenantRes.data.defaultProxyId)
        .then(proxyId => {
            url = prependProtocol(this.rss.input);
            var config = {
                    uri: url,
                    username: this.rss.isAuthenticated ? this.rss.username : undefined,
                    password: this.rss.isAuthenticated ? this.rss.password : undefined
            };
            return $http.post('/ws/stream_source/rss/preview', config, {
                bypassAuthErrorInterception: true,
                params: { proxyId: proxyId }
            });
        })
        .then(result => {
            const rssData = result.data;

            this.rssPreview.shown = true;
            this.title = rssData.title ? rssData.title : url;
            this.description = rssData.description;
            this.rssItems = rssData.items;
            this.rssLink = url;
        })
        .catch(err => {
            const errMessage = err.status === 401 ?
                'Unauthorized. Username and password may be incorrect or missing.' :
                'Unable to read RSS feed. Please ensure your url is a valid RSS feed.';
            growl.warning(errMessage, { referenceId: 'streamBuilderMessages' });
        })
        .finally(() => this.searchBtn = 'Search');
    };

    const cleanUrl = url => {
        let val = url;
        val = val.indexOf('//') !== -1 ? val.substring(val.indexOf('//') + 2) : val;
        return val.endsWith('/') ? val.substring(0, val.length -1) : val; 
    };

    this.searchRss = () => {
        this.searchBtn = 'Searching...';
        const primaryTerm = this.rss.input;
        const secondaryTerm = cleanUrl(this.rss.input);
        
        $q.all([
            streamService.getTenantStreams({includeCatalogs: true, term: primaryTerm, page: 0, rows: 40}),
            streamService.getTenantStreams({includeCatalogs: true, term: secondaryTerm, page: 0, rows: 40})
        ])
        .then(res => {
            this.matched = res[0].data.content.find(stream => cleanUrl(stream.settings.uri) === cleanUrl(primaryTerm)) || 
                           res[1].data.content.find(stream => cleanUrl(stream.settings.uri) === cleanUrl(secondaryTerm));

            if(this.matched){
                this.rssPreview.shown = false;
                this.searchBtn = 'Search';
            } else {
                doSearch();
            }
        });
    };

    this.toggleAuthenticated = () => {
        this.focusOnUsername = !$scope.focusOnUsername;
        if(this.rssPreview.shown){
            var params = {};
            if(this.stream.data && this.stream.data.id){
                params.id = this.stream.data.id;
                $scope.config.id = this.stream.data.id;
            }
            this.rssPreview.shown = false;
        }

        if(!this.rss.isAuthenticated) {
            this.rss.username = undefined;
            this.rss.password = undefined;
        }
    };

    this.saveRss = () => {
        this.addBtn = 'Saving...';

        let newRssStream;
        if(this.stream.data && this.stream.data.id) {
            newRssStream = this.stream.data;
            if (!newRssStream.settings) {
                newRssStream.settings = {
                    uri: this.rssLink,
                    username: this.rss.isAuthenticated ? this.rss.username : undefined,
                    password: this.rss.isAuthenticated ? this.rss.password : undefined
                };
            } else {
                newRssStream.settings.uri = this.rssLink;
                newRssStream.settings.username = this.rss.isAuthenticated ? this.rss.username : undefined;
                newRssStream.settings.password = this.rss.isAuthenticated ? this.rss.password : undefined;
            }
        } else {
            newRssStream = {
                title: this.title,
                description: this.description,
                settings: {
                    uri: this.rssLink,
                    username: this.rss.isAuthenticated ? this.rss.username : undefined,
                    password: this.rss.isAuthenticated ? this.rss.password : undefined
                },
                taxonomicMemberships: _.pluck(this.selectedCategories, 'id'),
                openForReading: true,
                type: 'RSS',
                emailPostingEnabled: false
            };
        }

        const warningPromise = _.isEmpty(this.selectedCategories) && !this.stream.data && !this.catalog ?
            streamService.noCategoryWarning() : $q.when(undefined);

        warningPromise
        .then(() => saveStream(newRssStream))
        .catch(() => this.addBtn = 'Save');
    };

    this.categoryTitle = streamService.categoryTitle;

    this.editCategories = () => 
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'SimpleCategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: () =>  this.taxonomy,
                taxonomyVersion: () => this.taxonomyVersion
            }
        }).result.then(selectedCategories => this.selectedCategories = selectedCategories);

    const isExisting = stream => stream.data && stream.data.id;

    const saveStream = newRssStream => {
        const persistor = isExisting(this.stream) ?
            this.catalog ? streamService.updateCatalogStream(newRssStream) :
            streamService.saveCredentials(newRssStream.id, newRssStream.settings) :
                streamService.saveStream(_.assign(newRssStream, { published: this.catalog ? true : newRssStream.published }), { isCatalogStream: this.catalog ? true : undefined });

        let savedStream;
        return persistor
        .then(saveStreamResponse => {
            $scope.config.id = saveStreamResponse.data.id || newRssStream.id;
            savedStream = saveStreamResponse.data;
            if(this.catalog && !isExisting(this.stream)) {
                return streamService.categorizeStreamInCatalog($scope.config.id, this.catalog, $state.params.category);
            }
        })
        .then(() => {
            if($scope.config.closeable) {
                $scope.$close(isExisting(this.stream) ? _.assign(this.stream.data, { settings: newRssStream.settings }) : savedStream.data);
            } else {
                $state.go('editTopic.articles', { catalogId: this.catalog, streamId: savedStream.id });
            }
        })
        .catch(() => {
            this.addBtn = 'Save';
            growl.error('An error occurred when attempting to save this stream', { referenceId: 'streamBuilderMessages' });
        });
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
    .controller('SearchBuilderCtrl', ['$state', '$stateParams', '$scope', '$window', '$uibModal', '$q', '_', 'growl', 'CatalogService',
        'ItemService', 'StreamService', 'TaxonomyService', '$rootScope',
        function($state, $stateParams, $scope, $window, $uibModal, $q, _, growl, CatalogService,
            itemService, streamService, taxonomyService, $rootScope) {
            $scope.init = function() {
                var promise = $scope.config.id ? streamService.getStream($scope.config.id) : $q.when({});
                promise
                .then(function(stream) {
                    $scope.stream = stream.data;
                    $scope.catalog = $state.params.catalog;

                    $scope.searchTerm = {};
                    $scope.searchTerm.search = stream && stream.data ? stream.data.settings.search : '';
                    $scope.topicTagSettings = $scope._tagSettings(stream, 'topics');
                    $scope.entitiesTagSettings = $scope._tagSettings(stream, 'entities');
                    $scope.socialTagsSettings = $scope._tagSettings(stream, 'socialTag');

                    $scope.title = stream && stream.data ? stream.data.title : '';

                    $scope.taxonomicMemberships = stream && stream.taxonomicMemberships ? stream.taxonomicMemberships : [];

                    $scope.action = stream.data && stream.data.id ? 'Edit' : 'Create';
                    if (stream.data && stream.data.id) {
                        $scope.streamId = stream.data.id;
                    }
                    $scope.searchBtn = 'Search';
                    $scope.addBtn = 'Save';
                    $scope.config.fetching = false;
                });
            };

            $scope._tagSettings = function(stream, tagType) {
                return _.has(stream, 'data.settings.searchConfiguration.tags') ?
                { tags: _.filter(stream.data.settings.searchConfiguration.tags, { type: tagType })} : { tags: [] };
            };

            $scope.deleteTag = function(tagSettings, index) {
                _.pullAt(tagSettings.tags, index);
            };

            $scope.previewChanged = function() {
                $scope.preview = false;
            };

            $scope.search = function() {
                $scope.searchBtn = 'Searching...';
                var searchSettings = {
                    catalogId: $scope.catalog,
                    search: $scope.searchTerm.search,
                    searchConfiguration: {
                        tags: _.union($scope.topicTagSettings.tags, $scope.socialTagsSettings.tags, $scope.entitiesTagSettings.tags)
                    }
                };
                var searchItems = $scope.catalog ?
                    CatalogService.searchItemsInCatalog($scope.catalog, searchSettings) : itemService.searchItemsWithSettings(searchSettings);

                searchItems
                .then(function(result){
                    $scope.preview = true;
                    if (!$scope.title) {
                        $scope.title = $scope.searchTerm.search;
                    }
                    $scope.description = $scope.searchTerm.search;
                    $scope.items = result.content;
                    if(!$scope.streamId) {
                        if(!$scope.taxonomy) {
                            taxonomyService.getTenantTaxonomy()
                            .then(function (response) {
                                $scope.taxonomyVersion = response.headers('X-Object-Version');
                                if ($state.params.category && $state.params.category !== 'uncategorized') {
                                    $scope.taxonomicMemberships = taxonomyService.createStreamCategories(response.data, [$state.params.category]);
                                }
                                $scope.taxonomy = taxonomyService.markSelectedCategories(response.data, [$state.params.category]);
                            });
                        }

                        $scope.showCategories = $scope.catalog ? false : true;
                    }
                })
                .catch(function(){
                    growl.warning('Search failed', { referenceId: 'streamBuilderMessages' });
                })
                .finally(function(){
                    $scope.searchBtn = 'Search';
                });
            };

            $scope.editCategories = function() {
                $uibModal.open({
                    templateUrl: '/templates/CategorySelectionModal.html',
                    controller: 'SimpleCategorySelectionModalCtrl',
                    size: 'lg',
                    keyboard: false,
                    backdrop: 'static',
                    resolve: {
                        taxonomy: function() {
                            return $scope.taxonomy;
                        },
                        taxonomyVersion: function() {
                            return $scope.taxonomyVersion;
                        }
                    }
                }).result
                .then(function(taxonomicMemberships){
                    $scope.taxonomicMemberships = taxonomicMemberships;
                });
            };

            var resetSaveLabel = function(){
                $scope.addBtn = 'Save';
            };

            $scope.categoryTitle = streamService.categoryTitle;

            $scope.save = function() {
                $scope.addBtn = 'Saving...';

                var newStream;
                if($scope.stream && $scope.stream.id) {
                    newStream = $scope.stream;
                } else {
                    newStream = {
                        title: $scope.title,
                        type: 'ATTENSA_SEARCH',
                        description: $scope.description,
                        openForReading: true,
                        emailPostingEnabled: false,
                        taxonomicMemberships: _.pluck($scope.taxonomicMemberships, 'id'),
                        settings: {}
                    };
                }

                newStream.settings.catalogId = $scope.catalog;
                newStream.settings.search = $scope.searchTerm.search;
                newStream.settings.searchConfiguration = {
                    tags: _.union($scope.topicTagSettings.tags, $scope.socialTagsSettings.tags, $scope.entitiesTagSettings.tags)
                };

                var warningPromise = _.isEmpty($scope.taxonomicMemberships) && !$scope.stream && !$scope.catalog?
                    streamService.noCategoryWarning() : $q.when(undefined);

                warningPromise
                .then(function () {
                    return saveStream(newStream);
                })
                .catch(function() {
                    resetSaveLabel();
                });
            };

            var saveStream = function(newStream) {
                var persistor = ($scope.stream && $scope.stream.id) ?
                    streamService.updateStream(newStream) : streamService.saveStream(newStream, { isCatalogStream: $scope.catalog ? true : undefined });

                var savedStream;
                return persistor
                .then(function(saveStreamRes) {
                    savedStream = saveStreamRes.data;
                    $scope.config.id = savedStream.id;

                    if($scope.catalog) {
                        return streamService.categorizeStreamInCatalog($scope.config.id, $scope.catalog, $stateParams.category);
                    }
                })
                .then(function() {
                    if($scope.config.closeable) {
                        $scope.$close(savedStream);
                    } else {
                        $state.go('editTopic.articles', {
                            catalogId: $scope.catalog,
                            streamId: $scope.config.id
                        });
                    }
                })
                .catch(function() {
                    growl.error('An error occurred when attempting to save this stream', { referenceId: 'streamBuilderMessages' });
                    resetSaveLabel();
                });
            };

            $scope.init();
        }]);

'use strict';

angular.module('attensaApp')
.controller('StreamEditorBriefingCtrl',
['$scope', '$rootScope', '$http', '$stateParams', '$uibModal', '$q', 'UtilService', 'moment', '_', 'BriefingService', 'StreamService', 'TemplateService', 'growl', 'BriefingSubscriptionService', 'TenantService',
    function($scope, $rootScope, $http, $stateParams, $uibModal, $q, utilService, moment, _, briefingService, streamService, templateService, growl, briefingSubscriptionService, tenantService) {

        var UNSUPPORTED_INTERVAL_MODES = ['EVERY_WEEKDAY', 'EVERY_MON_WED_FRI', 'EVERY_TUE_THUR'];

        $scope.intervals = _.range(1, 32);

        $scope.repeatModes = utilService.repeatModes;

        var confirmUnchanged = function(continueEventName, evt, data){
            if (!$scope.isUnchanged() && !$scope.ignoreChanges) {
                evt.preventDefault();
                if (!$scope.confirmNavigationPromise) {
                    $scope.confirmNavigationPromise = $uibModal.open({
                        templateUrl: '/templates/stateChangeWithChangesWarningModal.html',
                        controller: 'StateChangeWithChangesWarningCtrl'
                    }).result;
                    $scope.confirmNavigationPromise
                    .then(function () {
                        $scope.ignoreChanges = true;
                        $rootScope.$broadcast(continueEventName, data);
                    }, function () {
                        delete $scope.confirmNavigationPromise;
                    });
                }
            }
        };

        $scope.$on('modal.closing', function(evt){
            confirmUnchanged('stream-builder.close', evt);
        });

        $scope.$on('stream-builder.before-nav-change', function(evt, tab){
            confirmUnchanged('stream-builder.request-nav-change', evt, tab);
        });

        $scope.initialize = function () {
            var promises = [
                $http.get('/ws/briefing/byStreamId', { params: { streamId: $scope.config.id } })
                .then(function(briefing){
                    $scope.briefing = briefing.data.briefing;
                    $scope.summary = briefing.data.briefingSchedule.summary;
                    $scope.prepareBriefing(briefing.data.briefingSchedule);
                }).catch(function () { return undefined; } ),
                templateService.getAll()
                .then(function(templates){
                    $scope.templates = templates.data;
                }),
                tenantService.getCurrentTenant()
                .then(function(tenantRes) {
                    $scope.tenantTimeZone = tenantRes.data.timeZone;
                    $scope.briefingCustomConfigurationLabel = tenantRes.data.settings.briefingCustomConfigurationLabel;
                    $scope.showBriefingCustomConfiguration = tenantRes.data.settings.showBriefingCustomConfiguration === 'true';
                })
            ];

            if($scope.config.id){
                promises.push(
                    streamService.getStream($scope.config.id)
                    .then(function(streamData){
                        $scope.stream = streamData.data;
                    })
                );
            }

            $q.all(promises)
            .then(function() {
                $rootScope.$broadcast('stream-fetched', $scope.stream);
                streamService.preventMarketplaceEdit($scope.stream);
                $scope.config.fetching = false;
                $scope.streamId = $scope.config.id;
                if ($scope.streamId) {
                    $scope.selectedTemplate = _.findWhere($scope.templates, {id: $scope.briefing.templateId});
                }
                utilService.confirmUnsavedChangeNav($scope, undefined, true);
            });
        };

        $scope.$on('templateSelected', function(event, template) {
            $scope.templates.push(template);
            $scope.selectedTemplate = template;
        });

        $scope.$on('refreshTemplates', function(event) {
            templateService.getAll()
            .then(function(results){
                $scope.templates = results.data;
                $scope.selectedTemplate = _.findWhere($scope.templates, {id: $scope.briefing.templateId});
            });
        });

        var localDateify = function(inDate, timeZone){
            var isoString = moment.utc(inDate).tz(timeZone).format('YYYY-MM-DDTHH:mm:ss.SSS');
            isoString = isoString + moment().format('Z');
            return new Date(isoString);
        };

        $scope.prepareBriefing = function(briefingSchedule) {
            if (!briefingSchedule) {
                $scope.briefingSchedule = {
                    scheduleMode: 'MANUAL',
                    freq: 'DAILY',
                    interval: 1,
                    timeZone: 'US/Pacific',
                    untilDate:localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles'),
                    startDate:localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles'),
                    sendTimeObj:moment().hour(0).minute(0).toDate(),
                    endMode:'NEVER_ENDS'
                };
            } else {
                $scope.briefingSchedule = briefingSchedule;
                $scope.briefingSchedule.timeZone = $scope.briefingSchedule.timeZone || $scope.user.timeZone || $scope.tenantTimeZone || 'US/Pacific';
                $scope.briefingSchedule.endMode = $scope.briefingSchedule.endMode || 'NEVER_ENDS';
                $scope.briefingSchedule.freq = $scope.briefingSchedule.freq || $scope.repeatModes[1].key;
                $scope.briefingSchedule.interval = $scope.briefingSchedule.interval || $scope.intervals[0];

                $scope.briefingSchedule.sendTimeObj = moment().hour(briefingSchedule.sendHour).minute(briefingSchedule.sendMinute).toDate();

                $scope.briefingSchedule.startDate = localDateify(briefingSchedule.start, briefingSchedule.timeZone);
                $scope.briefingSchedule.untilDate = localDateify(briefingSchedule.until, briefingSchedule.timeZone);
                $scope.selectedDays = {};
                _.forEach(briefingSchedule.byday, function(key){
                    $scope.selectedDays[key] = true;
                });
                if($scope.briefingSchedule.freq === 'WEEKLY' && $scope.briefingSchedule.interval === 2){
                    $scope.briefingSchedule.freq = 'BIWEEKLY';
                }
            }
            $scope.generateIsUnchanged();
        };

        $scope.frequencyChanged = function() {
            $scope.selectedDays = {};
            $scope.briefingSchedule.interval = $scope.briefingSchedule.freq === 'BIWEEKLY' ? 2 : 1;
        };

        $scope.endModeChanged = function() {
            $scope.briefingSchedule.untilDate = localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles');
        };

        $scope.generateIsUnchanged = function() {
            $scope.isBriefingUnchanged = utilService.isUnchanged($scope.briefing);
            $scope.isBriefingScheduleUnchanged = utilService.isUnchanged($scope.briefingSchedule);

            $scope.isUnchanged = function() {
                return $scope.isBriefingUnchanged() && $scope.isBriefingScheduleUnchanged();
            };
        };

        $scope.toggleBriefing = function() {
            if ($scope.briefing) {
                $scope.stream.briefingEnabled = !$scope.briefing.enabled;
            }
            briefingSubscriptionService.toggleBriefing($scope.briefing, $scope.streamId)
            .then(function(response) {
                $scope.briefing = response.data;
                $scope.generateIsUnchanged();
            });
        };

        $scope.openBriefingHistoryModal = function() {
            var modalInstance = $uibModal.open({
                keyboard: true,
                templateUrl: '/templates/briefingHistory.html',
                controller: 'BriefingHistoryCtrl',
                size: 'lg',
                resolve: {
                    briefingHistories: ['BriefingService', function(BriefingService) {
                        return BriefingService.getHistory($scope.briefing.id);
                    }]
                }
            });
            return modalInstance.result;
        };

        $scope.openCalendar = function(tag, $event){
            $event.preventDefault();
            $event.stopPropagation();

            $scope[tag + 'Opened'] = true;
        };

        $scope.deleteTemplate = function(template){
            if(template.inUse) {
                growl.error('Unable to delete: Template in use.', { referenceId: 'streamBuilderMessages' });
                return;
            }
            $http.delete('/ws/template/'+template.id)
            .then(function(response){
                growl.success('Template Deleted', { referenceId: 'streamBuilderMessages' });
                $scope.$broadcast('refreshTemplates');
            })
            .catch(function() {
                growl.error('Delete Failed', { referenceId: 'streamBuilderMessages' });
            });
        };

        $scope.sendBriefingNow = function(){
            if(!$scope.processing) {
                $scope.processing = true;
                briefingService.sendBriefingNow($scope.briefing.id)
                .then(function (response) {
                    return streamService.getStream($scope.config.id);
                })
                .then(function(streamData){
                    $scope.stream = streamData.data;
                    $rootScope.$broadcast('stream-changed', $scope.stream);
                    growl.success('Briefing Sent', {referenceId: 'streamBuilderMessages'});
                })
                .finally(function () {
                    $scope.processing = undefined;
                });
            }
        };

        $scope.sendBriefingPreviewNow = function(){
            var isUnchanged = $scope.isBriefingUnchanged();
            if(!isUnchanged) {
                var modalScope = $scope.$new(true);
                modalScope.modalTitle = 'Send preview without saving briefing?';
                modalScope.message = 'You have not saved the changes on this briefing, would you like to send the preview as it was before the changes?';
                modalScope.confirmLabel = 'Yes';
                $uibModal.open({
                    templateUrl: '/templates/ConfirmModal.html',
                    size: 'lg',
                    scope: modalScope
                }).result
                    .then(function () {
                        $scope.sendBriefingPreview();
                    });
            } else {
                $scope.sendBriefingPreview();
            }
        };

        $scope.sendBriefingPreview = function(){
            if(!$scope.processing) {
                $scope.processing = true;
                briefingService.sendBriefingPreview($scope.briefing.id)
                .then(function (response) {
                    growl.success('Briefing Sent', {referenceId: 'streamBuilderMessages'});
                })
                .finally(function () {
                    $scope.processing = undefined;
                });
            }
        };

        $scope.viewBriefingPreview = function() {

            var isUnchanged = $scope.isBriefingUnchanged();

            if(!isUnchanged) {
                var modalScope = $scope.$new(true);
                modalScope.modalTitle = 'View preview without saving briefing?';
                modalScope.message = 'You have not saved the changes on this briefing, would you like to view the preview as it was before the changes?';
                modalScope.confirmLabel = 'Yes';
                $uibModal.open({
                    templateUrl: '/templates/ConfirmModal.html',
                    size: 'lg',
                    scope: modalScope
                }).result
                .then(function () {
                    $scope.openViewBriefingPreview();
                });
            } else {
                $scope.openViewBriefingPreview();
            }

        };

        $scope.openViewBriefingPreview = function() {
            var modalInstance = $uibModal.open({
                templateUrl: '/templates/briefingPreviewModal.html',
                controller: 'BriefingPreviewCtrl',
                size: 'lg',
                keyboard: false,
                resolve: {
                    briefingId: function() {
                        return $scope.briefing.id;
                    }
                }
            });
            return modalInstance.result;
        };

        var configureForWeeks = function(freqLabel){
            $scope.briefingSchedule.byday = [];
            _.forEach($scope.selectedDays, function (selected, day) {
                if (selected) {
                    $scope.briefingSchedule.byday.push(day);
                }
            });

            if ($scope.briefingSchedule.byday.length === 0) {
                growl.error('At least one day must be selected for a briefing scheduled with a ' + freqLabel + ' frequency.', {referenceId: 'streamBuilderMessages'});
                return;
            }
        };

        $scope.saveBriefingSchedule = function(){
            if(!$scope.processing) {
                $scope.briefingSchedule.sendHour = moment($scope.briefingSchedule.sendTimeObj).format('HH');
                $scope.briefingSchedule.sendMinute = moment($scope.briefingSchedule.sendTimeObj).format('mm');

                $scope.briefingSchedule.start = moment($scope.briefingSchedule.startDate).hour(0).minute(0).utc().toISOString();

                if (!moment($scope.briefingSchedule.untilDate).isValid()) {
                    $scope.briefingSchedule.untilDate = localDateify(moment(new Date()).hours(0).minutes(0).seconds(0).toDate(), 'America/Los_Angeles');
                }

                $scope.briefingSchedule.until = moment($scope.briefingSchedule.untilDate).hour(0).minute(0).utc().toISOString();

                if ($scope.briefingSchedule.freq === 'WEEKLY') {
                    configureForWeeks('weekly');
                } else if ($scope.briefingSchedule.freq === 'BIWEEKLY') {
                    configureForWeeks('bi-weekly');
                } else if ($scope.briefingSchedule.freq === 'EVERY_WEEKDAY') {
                    $scope.briefingSchedule.byday = ['MO', 'TU', 'WE', 'TH', 'FR'];
                } else if ($scope.briefingSchedule.freq === 'EVERY_MON_WED_FRI') {
                    $scope.briefingSchedule.byday = ['MO', 'WE', 'FR'];
                } else if ($scope.briefingSchedule.freq === 'EVERY_TUE_THUR') {
                    $scope.briefingSchedule.byday = ['TU', 'TH'];
                }

                $scope.briefingSchedule.interval = _.includes(UNSUPPORTED_INTERVAL_MODES, $scope.briefingSchedule.freq) ?
                    1 : $scope.briefingSchedule.interval;

                if ($scope.briefingSchedule.freq === 'BIWEEKLY') {
                    $scope.briefingSchedule.freq = 'WEEKLY';
                    $scope.briefingSchedule.interval = 2;
                }

                if ($scope.briefingSchedule.scheduleMode !== 'MANUAL') {
                    var startDateUnix = moment($scope.briefingSchedule.startDate).millisecond(0).second(0).minute(0).hour(0).unix();
                    var endDateUnix = moment($scope.briefingSchedule.untilDate).millisecond(0).second(0).minute(0).hour(0).unix();

                    if ($scope.briefingSchedule.endMode === 'END' && startDateUnix >= endDateUnix) {
                        growl.error('End date must be after start date.', {referenceId: 'streamBuilderMessages'});
                        return;
                    }
                }

                $scope.processing = true;

                $q.when($scope.isBriefingUnchanged() ? null : $http.put('/ws/briefing/' + $scope.briefing.id, $scope.briefing))
                .then(function (briefingResults) {
                    if (briefingResults) {
                        $scope.stream.briefing = briefingResults.data;
                        $scope.stream.briefingTemplateTitle = $scope.selectedTemplate.title;
                        $scope.briefing = briefingResults.data;
                    }
                    return $http.post('/ws/briefing/schedule', $scope.briefingSchedule, {params: {briefingId: $scope.briefing.id}});
                })
                .then(function (scheduleResults) {
                    $scope.stream.briefingSchedule = scheduleResults.data;
                    $rootScope.$broadcast('stream-changed', $scope.stream);
                    $scope.summary = scheduleResults.data.summary;
                    $scope.prepareBriefing(scheduleResults.data);
                    $scope.generateIsUnchanged();
                    growl.success('Briefing Saved', {referenceId: 'streamBuilderMessages'});
                })
                .catch(function (error) {
                    growl.error('Failed to Save Schedule', {referenceId: 'streamBuilderMessages'});
                })
                .finally(function () {
                    $scope.processing = undefined;
                });
            }
        };

        $scope.uploadTemplate = function(uploadTarget){
            var modalInstance = $uibModal.open({
                templateUrl: '/templates/templateSelectModal.html',
                controller: 'TemplateSelectorCtrl',
                size: 'sm',
                resolve: {
                    uploadTarget: function() { return uploadTarget; }
                }
            });
            return modalInstance.result;
        };

        $scope.initialize();
}]);

'use strict';

angular.module('attensaApp')
.controller('StreamGroupsCtrl', ['_', '$scope', '$rootScope', '$q', 'groupsService', 'StreamService', 'TenantService', 'UtilService',
    function(_, $scope, $rootScope, $q, groupsService, streamService, tenantService, utilService) {
        var setPage = function(currentPage) {
            $scope.currentPage = currentPage;
            $scope.pagerPage = currentPage + 1;
        };

        var doFetch = function(sortOptions) {
            $scope.searching = true;

            var options = utilService.sortPeopleOptions(sortOptions, $scope);

            filterOrSortGroups(options)
            .then(function(results) {
                processGroups(results.data);
            });
        };

        var filterOrSortGroups = function(options) {
            if($scope.filteredByGroupSubscription) {
                if($scope.filter === 'Follower') {
                    options.params.followers = true;
                    options.params.briefingSubscribers = false;
                } else if($scope.filter === 'Subscriber') {
                    options.params.followers = false;
                    options.params.briefingSubscribers = true;
                }
                return streamService.getStreamFollowingGroups($scope.streamId, options.params);
            } else {
                return groupsService.fetchGroups(options);
            }
        };

        var processGroups = function(groups) {
            $scope.searching = false;
            setPage(groups.number);
            $scope.totalElements = groups.totalElements;

            $scope.groups = groups.content;

            _.forEach($scope.groups, function(group) {
                var matchingStream = _.find(group.subscriptions, { streamId: $scope.streamId });
                if(matchingStream) {
                    group.subscribed = matchingStream.subscribeToBriefing;
                    group.followed = matchingStream.follow;
                }
            });
        };

        $scope.initialize = function() {
            $scope.selectDisabled = true;
            $scope.searching = true;

            var promises = [];

            if($scope.config.id){
                promises.push(
                    streamService.getStream($scope.config.id)
                    .then(function(streamData){
                        $scope.stream = streamData.data;
                    })
                );
            }

            $q.all(promises)
            .then(function(){
                $rootScope.$broadcast('stream-fetched', $scope.stream);
                $scope.groups = [];
                $scope.config.fetching = false;

                $scope.streamId = $scope.config.id;
                $scope.page = 0;
                $scope.rows = 11;
                $scope.streamGroupsSearch = true; // Focuses on search
                $scope.navbarCollapsed = true;
                $scope.searching = true;

                doFetch();
            });
        };

        $scope.updateStream = function() {
            streamService.updateStream($scope.stream);
        };

        $scope.followGroup = function(group) {
            var options = {
                groupId: group.id,
                streamId: $scope.stream.id,
                follow: !group.followed,
                subscribeToBriefing: false
            };

            if (options.follow) {
                groupsService.addToStream(options)
                .then(function(streamRes) {
                    group.followed = options.follow;
                    group.subscribed = options.subscribeToBriefing;
                    $scope.stream.followersCount = streamRes.data.followersCount;
                    $rootScope.$broadcast('stream-changed', $scope.stream);
                });
            } else {
                groupsService.deleteFromStream(options)
                .then(function(streamRes) {
                    group.followed = options.follow;
                    group.subscribed = options.subscribeToBriefing;
                    $scope.stream.followersCount = streamRes.data.followersCount;
                    $scope.stream.subscribersCount = streamRes.data.subscribersCount;
                    $rootScope.$broadcast('stream-changed', $scope.stream);
                });
            }
        };

        $scope.subscribeGroup = function(group) {
            var options = {
                groupId: group.id,
                streamId: $scope.stream.id,
                briefingId: $scope.stream.briefingId,
                follow: group.subscribed ? group.followed : true,
                subscribeToBriefing: !group.subscribed
            };

            groupsService.addToStream(options)
            .then(function(streamRes) {
                group.followed = options.follow;
                group.subscribed = options.subscribeToBriefing;
                $scope.stream.subscribersCount = streamRes.data.subscribersCount;
                $rootScope.$broadcast('stream-changed', $scope.stream);
            });
        };

        $scope.groupsGroupAction = function(action) {
            angular.forEach($scope.groups, function(group) {
                if(group.selected) {
                    if (action === 'follow' && !group.followed) {
                        $scope.followGroup(group);
                    }

                    if (action === 'unfollow' && group.followed) {
                        $scope.followGroup(group);
                    }

                    if (action === 'subscribe' && !group.subscribed) {
                        $scope.subscribeGroup(group);
                    }

                    if (action === 'unsubscribe' && group.subscribed) {
                        $scope.subscribeGroup(group);
                    }
                }
            });
        };

        $scope.fetchPage = function() {
            if(!$scope.searching) {
                setPage($scope.pagerPage - 1);
                doFetch();
            }
        };

        $scope.searchGroups = function() {
            setPage(0);
            doFetch(true);
        };

        $scope.clearSearch = function() {
            $scope.groupSearchTerm = '';
            setPage(0);
            doFetch(true);
        };

        $scope.sortByGroupProperties = function(sortOptions) {
            setPage(0);
            doFetch(sortOptions);
        };

        $scope.filterByGroupSubscription  = function(filter) {
            $scope.filteredByGroupSubscription = true;
            $scope.filter = filter;
            setPage(0);
            doFetch(true);
        };

        $scope.removeFilter = function() {
            $scope.filteredByGroupSubscription = false;
            $scope.filter = null;
            setPage(0);
            doFetch(true);
        };

        $scope.selectionChange = function() {
            $scope.selectDisabled = utilService.isAllDisabled($scope.groups);
        };

        $scope.initialize();
    }
]);

'use strict';

angular.module('attensaApp').controller('StreamPeopleCtrl',
            ['$scope', '$rootScope', '$http', '$q', 'TenantService', 'UserService', 'UtilService', 'StreamService', 'categoryService', '_',
    function($scope, $rootScope, $http, $q, tenantService, userService, utilService, streamService, categoryService, _) {

        var setPage = function(currentPage){
            $scope.currentPage = currentPage;
            $scope.pagerPage   = currentPage + 1;
        };

        $scope.initialize = function() {

            $scope.searching = true;
            $scope.search = {};
            $scope.rows = 11;

            var promises = [
                tenantService.getCurrentTenant()
                .then(function(tenant){
                    $scope.tenant = tenant.data;
                    return tenant;
                }),
                userService.getUsers({ params: { streamId: $scope.config.id, rows: $scope.rows } })
                .then(function(peopleData){
                    $scope.peopleData = peopleData;
                })
            ];

            $scope.streamId = $scope.config.id;

            if($scope.config.id){
                promises.push(
                    streamService.getStream($scope.config.id)
                    .then(function(streamData){
                        $scope.stream = streamData.data;
                    })
                );
            }

            $q.all(promises)
            .then(function() {
                $rootScope.$broadcast('stream-fetched', $scope.stream);
                streamService.preventMarketplaceEdit($scope.stream);
                processPeople($scope.peopleData.data, true);
                $scope.sort               = null;
                $scope.selectDisabled     = true;
                $scope.streamId           = $scope.config.id;
                $scope.config.fetching    = false;
                $scope.streamPeopleSearch = true; // Focuses on search
                setPage();
                $scope.navbarCollapsed    = true;
            });
        };

        $scope.updateStream = function() {
            if($scope.stream.openForPosting) {
                $scope.stream.openForReading = true;
            }

            streamService.updateStream($scope.stream);
            _.each($scope.users, function(user) {
                digestUserRoles(user);
            });
        };

        $scope.$on('follow-change', function(evt, evtData) {
            $rootScope.$broadcast('stream-changed', evtData.stream);
            if(evtData.followStatusChanged) {
                categoryService.updatePersonalCategory(evtData.stream, evtData.user.userIsFollowing, $scope.tenant.taxonomy, evtData.user);
            }
        });

        $scope.removeAllStreamRoles = function(user) {
            var promises = user.roles.map(function(role) {
                return function() {
                    return $scope.updateStreamRole(user, role.roleType, false);
                };
            });

            // Can't do async delete for some reason, so we do one after another
            promises.reduce(function(chain, fn) {
                return chain.then(fn);
            }, $q.when());
        };

        $scope.updateStreamRole = function(user, roleType, checked) {
            $scope.searching = true;

            var config = {
                params: {
                    streamId: $scope.streamId,
                    roleType: roleType
                }
            };

            if(checked) {
                return $http.post('/ws/user/' + user.id + '/streamRoles/', config)
                .then(function(response) {
                    digestUserRoles(user, response.data);
                    if (user.id === $scope.user.id) {
                        $scope.stream.userHasStreamSubscriberRole = true;
                    }
                    $scope.stream.streamSubscribersCount++;
                    $rootScope.$broadcast('stream-altered', $scope.stream);
                    $scope.searching = false;
                });
            } else {
                return $http.delete('/ws/user/' + user.id + '/streamRoles/', config)
                .then(function(response) {
                    digestUserRoles(user, response.data);
                    if (user.id === $scope.user.id) {
                        $scope.stream.userHasStreamSubscriberRole = false;
                    }
                    $scope.stream.streamSubscribersCount--;
                    $rootScope.$broadcast('stream-altered', $scope.stream);
                    $scope.searching = false;
                });
            }
        };

        // Yeah, I don't like this either
        var digestUserRoles = function(user, userResponse) {
            if(userResponse) {
                var currentStreamRoles = _.filter(userResponse.streamRoles, { streamId: $scope.streamId });
                user.roles = currentStreamRoles;
            }

            user.reader = $scope.stream.openForReading ||
                _.findWhere(user.roles, { roleType: 'STREAM_SUBSCRIBER' }) ||
                _.findWhere(user.roles, { roleType: 'STREAM_PUBLISHER' }) ||
                _.findWhere(user.roles, { roleType: 'STREAM_ADMIN' }) ? true : false;

            user.publisher = $scope.stream.openForPosting ||
                _.findWhere(user.roles, { roleType: 'STREAM_PUBLISHER' }) ||
                _.findWhere(user.roles, { roleType: 'STREAM_ADMIN' }) ? true : false;

            user.manager = _.findWhere(user.roles, { roleType: 'STREAM_ADMIN' }) ? true : false;
        };

        var processPeople = function(results) {
            $scope.isFirst = results.first;
            $scope.isLast = results.last;
            $scope.totalElements = results.totalElements;
            setPage(results.number);

            $scope.users = results.content;

            _.forEach($scope.users, function(user) {
                digestUserRoles(user, user);
                if(user.id === $scope.stream.owner.id) {
                    user.selectedOwner = true;
                }
            });
            $scope.searching = false;
        };

        var doFetch = function(options) {
            if($scope.filterByFollowers) {
                return streamService.getStreamFollowers($scope.streamId, options);
            } else if($scope.filterBySubscribers) {
                return streamService.getStreamSubscribers($scope.streamId, options);
            } else {
                return userService.getUsers(options);
            }
        };

        $scope.fetchPage = function() {
            if(!$scope.searching){
                setPage($scope.pagerPage -1);
                $scope.fetchPeople();
            }
        };

        $scope.clearSearch = function() {
            $scope.search.searchTerm = '';
            setPage(0);
            $scope.fetchPeople(true);
        };

        $scope.searchPeople = function() {
            setPage(0);
            $scope.fetchPeople(true, { searchTerm: $scope.search.searchTerm });
        };

        $scope.fetchPeople = function(isNew, sortOptions) {
            $scope.searching = true;

            var options = utilService.sortPeopleOptions(sortOptions, $scope);

            doFetch(options)
            .then(function(results) {
                processPeople(results.data, isNew);
            });
        };

        $scope.change = function() {
            $scope.selectDisabled = utilService.isAllDisabled($scope.users);
        };

        $scope.usersGroupAction = function(action, option, allChecked) {
            if($scope.selectDisabled === false && !$scope.searching && !allChecked) {
                _.forEach($scope.users, function(user) {
                    if(user.selected) {
                        action(user, option, !allChecked);
                    }
                });
            }
        };

        $scope.isOverLimit = (stream, userIsReader) =>  !userIsReader && 
            stream.type === 'PRODUCT_SOURCE' && 
            $scope.tenant.settings.limitProductSources === 'true' && 
            stream.streamSubscribersCount >= stream.maxStreamSubscribers;

        $scope.follow = function(user) {
            user.userIsFollowing = true;
            userService.setFollowing($scope.stream.id, user.id, {
                follow: true,
                subscribe: user.userIsSubscribed
            });
        };

        $scope.unfollow = function(user) {
            user.userIsFollowing = false;
            user.userIsSubscribed = false;
            userService.setFollowing($scope.stream.id, user.id, {
                follow: false,
                subscribe: false
            });
        };

        $scope.subscribe = function(user) {
            user.userIsFollowing = true;
            user.userIsSubscribed = true;
            userService.setFollowing($scope.stream.id, user.id, {
                follow: true,
                subscribe: true
            });
        };

        $scope.unsubscribe = function(user) {
            user.userIsSubscribed = false;
            userService.setFollowing($scope.stream.id, user.id, {
                follow: user.userIsFollowing,
                subscribe: false
            });
        };

        $scope.sortByUserProperty = function(sortOptions, isNew) {
            setPage(0);
            $scope.fetchPeople(isNew, sortOptions);
        };

        $scope.filterByFollowingUsers = function(sortOptions) {
            $scope.filterByFollowers = true;
            $scope.filter = 'Follower';
            setPage(0);
            $scope.fetchPeople(true, sortOptions);
        };

        $scope.filterBySubscribingUsers = function(sortOptions) {
            $scope.filterBySubscribers = true;
            $scope.filter = 'Subscriber';
            setPage(0);
            $scope.fetchPeople(true, sortOptions);
        };

        $scope.filterByRole = function(roleName) {
            if($scope.stream.openForReading && roleName === 'Reader' || $scope.stream.openForPosting && roleName === 'Publisher') {
                return;
            }
            var role = _.findWhere($scope.tenant.streamRoles, { name: roleName });

            $scope.filter = role.name;
            $scope.filterByFollowers = false;
            $scope.filterBySubscribers = false;
            $scope.sortByStreamRole = role.type;
            $scope.sort = role.type;
            setPage(0);
            $scope.fetchPeople(true, {
                streamRole: role.type,
                streamId: $scope.streamId
            });
        };

        $scope.removeFilter = function() {
            $scope.filterByFollowers = false;
            $scope.filterBySubscribers = false;
            $scope.filter = null;
            $scope.searching = false;
            setPage(0);
            $scope.sort = null;
            $scope.sortByStreamRole = null;
            $scope.fetchPeople(true);
        };

        $scope.changeStreamOwner = function(userSelected, $index) {
            $scope.userSelected = userSelected;
            _.forEach($scope.users, function(user, idx) {
                if($index !== idx) {
                    user.selectedOwner = false;
                }
            });
        };

        $scope.tooltipManager = function(stream, isBriefing) {
            return utilService.tooltipManager(stream, isBriefing, $scope.fromStream);
        };

        $scope.initialize();
    }
]);

'use strict';

angular.module('attensaApp')
.controller('TwitterBuilderCtrl', ['$state', '$scope', '$window', '$uibModal', '$q', '_', 'growl',
'ItemService', 'StreamService', 'TaxonomyService', '$rootScope', '$stateParams',
function($state, $scope, $window, $uibModal, $q, _, growl,
itemService, streamService, taxonomyService, $rootScope, $stateParams) {
    $scope.init = function() {
        var promise = $scope.config.id ? streamService.getStream($scope.config.id) : $q.when({});
        promise
        .then(function(stream) {
            $scope.stream = stream.data;
            $scope.catalog = $stateParams.catalog;

            $scope.twitter = {};

            $scope.twitter.search = stream && stream.data ? stream.data.settings.search : '';

            $scope.title = stream && stream.data ? stream.data.title : '';

            $scope.taxonomicMemberships = stream && stream.taxonomicMemberships ? stream.taxonomicMemberships : [];

            $scope.action = stream.data && stream.data.id ? 'Edit' : 'Create';
            if (stream.data && stream.data.id) {
                $scope.streamId = stream.data.id;
            }
            $scope.searchBtn = 'Search';
            $scope.addBtn = 'Save';
            $scope.config.fetching = false;
        });
    };

    $scope.search = function() {
        $scope.searchBtn = 'Searching...';

        itemService.searchTwitter($scope.twitter.search)
        .then(function(twitterItems) {
            $scope.twitterPreview = true;
            if (!$scope.title) {
                $scope.title = $scope.twitter.search;
            }
            $scope.description = $scope.twitter.search;
            $scope.twitterItems = twitterItems.statuses;
            if(!$scope.streamId) {
                taxonomyService.getTenantTaxonomy()
                .then(function(response) {
                    $scope.taxonomyVersion = response.headers('X-Object-Version');
                    if($state.params.category && $state.params.category !== 'uncategorized') {
                        $scope.taxonomicMemberships = taxonomyService.createStreamCategories(response.data, [$state.params.category]);
                    }
                    $scope.taxonomy = taxonomyService.markSelectedCategories(response.data, [$state.params.category]);
                });

                $scope.showCategories = true;
            }
        })
        .catch(function(){
            growl.warning('Twitter search failed', { referenceId: 'streamBuilderMessages' });
        })
        .finally(function(){
            $scope.searchBtn = 'Search';
        });
    };

    $scope.twitterChanged = function()  {
        $scope.twitterPreview = false;
    };

    $scope.editCategories = function() {
        $uibModal.open({
            templateUrl: '/templates/CategorySelectionModal.html',
            controller: 'SimpleCategorySelectionModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                taxonomy: function() {
                    return $scope.taxonomy;
                },
                taxonomyVersion: function() {
                    return $scope.taxonomyVersion;
                }
            }
        }).result
        .then(function(taxonomicMemberships){
            $scope.taxonomicMemberships = taxonomicMemberships;
        });
    };

    var resetSaveLabel = function(){
        $scope.addBtn = 'Save';
    };

    $scope.save = function() {
        $scope.addBtn = 'Saving...';

        var newStream;
        if($scope.stream && $scope.stream.id) {
            newStream = $scope.stream;
        } else {
            newStream = {
                title: $scope.title,
                type: 'TWITTER_SEARCH',
                description: $scope.description,
                openForReading: true,
                emailPostingEnabled: false,
                taxonomicMemberships: _.pluck($scope.taxonomicMemberships, 'id'),
                settings: {}
            };
        }
        newStream.settings.search = $scope.twitter.search;

        var warningPromise = _.isEmpty($scope.taxonomicMemberships) && !$scope.stream && !$scope.catalog ?
            streamService.noCategoryWarning() : $q.when(undefined);

        warningPromise
        .then(function () {
            return saveStream(newStream);
        })
        .catch(function() {
            resetSaveLabel();
        });
    };

    $scope.categoryTitle = streamService.categoryTitle;

    var saveStream = function(newStream) {
        var persistor = $scope.stream && $scope.stream.id ?
            streamService.updateStream(newStream) : streamService.saveStream(_.assign(newStream, { published: $scope.catalog ? true : newStream.published }), { isCatalogStream: $scope.catalog ? true : undefined });

        var savedStream;
        return persistor
        .then(function(saveStreamRes) {
            $scope.config.id = saveStreamRes.data.id;
            savedStream = saveStreamRes.data;
            if($scope.catalog) {
                return streamService.categorizeStreamInCatalog($scope.config.id, $scope.catalog, $stateParams.category);
            }
        })
        .then(function() {
            if($scope.config.closeable) {
                $scope.$close(savedStream);
            } else {
                $state.go('editTopic.articles', {
                    catalogId: $scope.catalog,
                    streamId: $scope.config.id
                });
            }
        })
        .catch(function() {
            growl.error('An error occurred when attempting to save this stream', { referenceId: 'streamBuilderMessages' });
            resetSaveLabel();
        });
    };

    $scope.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('MyTopicsItemListCtrl',
['$scope', '$rootScope', '$state', '$uibModal', '$q', '$location', '_', 'ItemService','StreamService',
    function($scope, $rootScope, $state, $uibModal, $q, $location, _, itemService, streamService) {

    var self = this;

    var fetchFresh = function(){
        self.itemSearchParams.page = 0;
        self.items = [];
        fetchItems();
    };

    var fetchItems = function(){
        self.ongoingRequest = true;
        self.searching = true;
        self.ongoingRequest = $q.defer();

        itemService.searchItemsInStream(self.itemSearchParams, self.ongoingRequest.promise)
        .then(function(results){
            self.ongoingRequest = false;
            self.searching = false;
            $rootScope.$broadcast('topic-item-page-fetched', results.data);
            $rootScope.$broadcast('topic-sort-changed', self.itemSearchParams.sortField);
            if (results.data.first) {
                self.items = [];
            }
            self.totalElements = results.data.totalElements;
            self.isLastPage = results.data.last;
            self.items.push.apply(self.items, results.data.content);
        });
    };

    var reportAndRefresh = function(title, message){
        var modalScope = $scope.$new(true);
        modalScope.modalTitle = title;
        modalScope.message = message;
        modalScope.confirmLabel = 'OK';
        modalScope.hideCancel = true;
        $uibModal.open({
            templateUrl: '/templates/ConfirmModal.html',
            size: 'lg',
            backdrop: 'static',
            scope: modalScope
        }).result
        .finally(fetchFresh);
    };

    $scope.$on('topic-fetch-items', fetchItems);
    
    $scope.$on('item-updated', function(evt, item, stream, operation){
        reportAndRefresh('Item ' + operation + 'ed', '"' + item.title + '" has been ' + operation + 'ed in topic "' + stream.title + '".');
    });

    $scope.$on('item-deleted', function(evt, item, stream){
        reportAndRefresh('Item deleted', '"' + item.title + '" has been deleted from topic "' + stream.title + '".');
    });

    $scope.$on('topic-set-sort', function(evt, key){
        self.itemSearchParams.sortField = key;
        $rootScope.$broadcast('topic-sort-changed', self.itemSearchParams.sortField);
        fetchItems();
    });

    $scope.$on('topics-date-range-change', function(event, startDate, endDate){
        self.itemSearchParams.createdAfterDateTime = startDate;
        self.itemSearchParams.createdBeforeDateTime = endDate;
        fetchFresh();
    });

    $scope.$on('topics-item-visibility-filter-changed', function(evt, filter){
        self.itemSearchParams.displayedOnly = filter.params.displayedOnly;
        self.itemSearchParams.hiddenOnly = filter.params.hiddenOnly;
        fetchFresh();
    });

    $scope.$on('item-posted', fetchItems);

    this.fetchPage = function(){
        self.itemSearchParams.page++;
        fetchItems();
    };

    this.toggleItemVisibility = function(item){
        item.visible = !item.visible;

        var patch = self.topic.curated ? {
            exposed: item.visible
        } : {
            hidden: !item.visible
        };
        itemService.patchItem($state.params.streamId, item.id, patch);
    };

    this.init = function(){
        if($state.params.searchTerm){
            $state.go('mytopics.explore', $state.params);
        }

        self.currentTopicId = $state.params.streamId;
        self.itemContext = 'myTopics';

        self.itemSearchParams = {
            includeReadItems: true,
            displayedOnly: !($state.current.data && $state.current.data.defaultShowAll),
            hiddenOnly: false,
            streamId: $state.params.streamId,
            sortField: 'publishedDate',
            search: $state.params.searchTerm
        };

        streamService.getStream($state.params.streamId)
        .then(function(streamResult){
            self.topic = streamResult.data;
        });

        fetchFresh();

        if($state.params.itemId) {
            itemService.openNewModal({
                itemId: $state.params.itemId,
                hasPrevious: false,
                hasNext: false,
                source: $state.params.source,
                streamContext: $state.params.streamId
            })
            .then(() => $location.url($location.path()))
            .catch(() => $location.url($location.path()));
        }
    };

    $scope.$on('$destroy', function( ) {
        if(self.ongoingRequest){
            self.ongoingRequest.resolve();
        }
    });

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('MyTopicsSummaryCtrl',
['$rootScope', 'currentStream', 'permissionService',
function($rootScope, currentStream, permissionService) {
    
    this.init = () => {
        this.mainStream = currentStream.data;
        this.currentStream = currentStream.data;
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('MostPopularItemListCtrl',
['$scope', '$rootScope', '$state', '$q', '_', 'ItemService',
function($scope, $rootScope, $state, $q, _, itemService) {

    var self = this;

    var fetchItems = function(){
        self.ongoingRequest = true;
        self.searching = true;
        self.ongoingRequest = $q.defer();
        itemService.searchTenantItems(self.itemSearchParams, self.ongoingRequest.promise)
        .then(function (results) {
            self.ongoingRequest = false;
            self.searching = false;
            $rootScope.$broadcast('topic-item-page-fetched', results);
            if (results.first) {
                self.items = [];
            }
            self.totalElements = results.totalElements;
            self.isLastPage = results.last;
            self.items.push.apply(self.items, results.content);
        });
    };

    this.fetchPage = function(){
        self.itemSearchParams.page++;
        fetchItems();
    };

    this.init = function(){
        if($state.params.searchTerm){
            $state.go('mytopics.explore', $state.params);
        }

        self.itemContext = 'recentItems';

        self.itemSearchParams = {
            page: 0,
            sortField: 'popularity',
            search: $state.params.searchTerm
        };

        self.items = [];
        fetchItems();
    };

    $scope.$on('$destroy', function( ) {
        if(self.ongoingRequest){
            self.ongoingRequest.resolve();
        }
    });

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('ExploreListCtrl',
['$scope', '$rootScope', '$timeout', '$state', '$q', '_', 'ItemService', 'StreamService', 'UserService', 'UtilService', 'TAG_TYPES', 'WATSON_TAG_TYPES',
function($scope, $rootScope, $timeout, $state, $q, _, itemService, streamService, userService, utilService, TAG_TYPES, WATSON_TAG_TYPES) {

    var self = this;

    var doFetch = function(params){
        self.ongoingRequest = true;
        self.searching = true;
        var fetcher;
        self.ongoingRequest = $q.defer();
        if($state.params.followedOnly === 'true'){
            fetcher = userService.searchUserItems(params, self.ongoingRequest.promise);
        }else{
            fetcher = itemService.searchItemsWithSettings(params, params, self.ongoingRequest.promise);
        }

        return fetcher
        .then(function (results) {
            self.streamIds = results.aggregations.streamIds.buckets.map(res => res.key);
            self.ongoingRequest = false;
            self.searching = false;
            return results;
        });
    };

    var fetchItems = function(){
        doFetch(self.itemSearchParams)
        .then(function(results){
            $rootScope.$broadcast('topic-item-page-fetched', results);
            if (results.first) {
                self.items = [];
            }
            self.totalElements = results.totalElements;
            self.isLastPage = results.last;
            self.items.push.apply(self.items, results.content);
        });
    };

    $scope.$on('mytopics-spin', (evt, spin) => self.searching = spin);

    $scope.$on('mytopics-stream-ids-fetch', () => $rootScope.$broadcast('mytopics-stream-ids-fetched', self.streamIds));

    $scope.$on('mytopics-site-only-changed', function(evt, restrictToTenant){
        var followedOnly = restrictToTenant ? false : $state.params.followedOnly;
        $state.go('mytopics.explore', {searchTerm: $state.params.searchTerm, tags: $state.params.tags, siteOnly: restrictToTenant, followedOnly: followedOnly },  {inherit: false});
    });

    $scope.$on('mytopics-followed-only-changed', function(evt, restrictToSubscribed){
        var restrictToTenant = restrictToSubscribed ? false : $state.params.siteOnly;
        $state.go('mytopics.explore', {searchTerm: $state.params.searchTerm, tags: $state.params.tags, siteOnly: restrictToTenant, followedOnly: restrictToSubscribed },  {inherit: false});
    });

    $scope.$on('mytopics-tags-changed', function(evt, tags){
        var tagParam = [];
        _.uniq(TAG_TYPES.concat(WATSON_TAG_TYPES)).forEach(type => tags[type].forEach(tag => tagParam.push(tag.tagText + '__' + type)));

        $state.go('mytopics.explore', {searchTerm: $state.params.searchTerm, tags: tagParam.join(), siteOnly: $state.params.siteOnly, followedOnly: $state.params.followedOnly },  {inherit: false});
    });

    $scope.$on('$destroy', function( ) {
        if(self.ongoingRequest){
            self.ongoingRequest.resolve();
        }
    });

    this.fetchPage = function(){
        if(!self.isLastPage){
            self.itemSearchParams.page++;
            fetchItems();
        }
    };

    this.init = function(){
        var searchConfig = streamService.parseSearchConfiguration($state.params.tags);
        self.itemContext = 'exploreItems';
        self.itemSearchParams = {
            search: utilService.cleanQuotes($state.params.searchTerm),
            searchConfiguration: searchConfig,
            includeMarketplaceStreams: $state.params.siteOnly !== 'true',
            includeOpenForReadingFalseStreams: true,
            page: 0,
            includeReadItems: true,
            includeAggregations: true
        };

        self.items = [];

        if($state.params.searchTerm || $state.params.tags){
            fetchItems();
        }else{
            $timeout(function(){
                $rootScope.$broadcast('topic-item-page-fetched', { totalElements: 0 });
            });
        }
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('ExploreSummaryCtrl',
['$scope', '$rootScope', '$state', '$q', '_', 'growl', 'LabelService', 'StreamService', 'TenantService', 'TOPIC_TAGS', 'TAG_TYPES', 'WATSON_TAG_TYPES',
function($scope, $rootScope, $state, $q, _, growl, labelService, StreamService, tenantService, TOPIC_TAGS, TAG_TYPES, WATSON_TAG_TYPES) {

    this.tagsChanged = _.debounce(() => $rootScope.$broadcast('mytopics-tags-changed', this.tags), 2000);

    this.restrictToSiteChanged = () => $rootScope.$broadcast('mytopics-site-only-changed', this.restrictToSite);

    this.restrictToSubscribedChanged = () => $rootScope.$broadcast('mytopics-followed-only-changed', this.restrictToSubscribed);

    this.spin = shouldSpin => $rootScope.$broadcast('mytopics-spin', shouldSpin);

    this.init = () => {
        this.searchTerm = $state.params.searchTerm;
        this.topicTags = TOPIC_TAGS;
        this.tags = {};
        TAG_TYPES.concat(WATSON_TAG_TYPES).forEach(type => this.tags[type] = []);

        tenantService.getCatalogMap().then(catalogs => this.catalogs = catalogs);

        this.restrictToSubscribed = $state.params.followedOnly === 'true';
        this.restrictToSite = $state.params.siteOnly === 'true';

        labelService.setLabel(this, 'catalogNavigationLabel', 'catalog_navigation_label', 'Site');

        const configuration = StreamService.parseSearchConfiguration($state.params.tags);
        if(configuration) {
            this.configuration = configuration;
            configuration.tags.forEach(tag => this.tags[tag.type].push(tag));
        }
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('RecentItemListCtrl',
['$scope', '$rootScope', '$state', '$q', 'locker', '_', 'ItemService', 'moment',
function($scope, $rootScope, $state, $q, locker, _, itemService, moment) {

    const fetchItems = () => {
        this.ongoingRequest = true;
        this.searching = true;
        this.ongoingRequest = $q.defer();

        itemService.searchItems(this.itemSearchParams, this.ongoingRequest.promise)
        .then(results => {
            this.ongoingRequest = false;
            this.searching = false;
            $rootScope.$broadcast('topic-item-page-fetched', results);
            if (results.first) {
                this.items = [];
            }
            this.totalElements = results.totalElements;
            this.isLastPage = results.last;
            this.items.push.apply(this.items, results.content);
        });
    };

    $rootScope.$on('locker.item.updated', (e, itemInfo) => {
        if(itemInfo.key === 'recent-item-created-after-date'){
            this.items = [];
            this.itemSearchParams.createdAfterDateTime = locker.get('recent-item-created-after-date');
            fetchItems();
        }
    });

    this.fetchPage = () => {
        this.itemSearchParams.page++;
        fetchItems();
    };

    this.dateBound = () => {
        const bound = locker.get('recent-item-created-after-date') ? moment(locker.get('recent-item-created-after-date')) : moment(null);
        const defaultBound = moment().subtract(2, 'days');
        return ((!bound.isValid() || bound.isBefore(defaultBound)) ? defaultBound : bound).toISOString();
    };

    this.init = () => {
        if($state.params.searchTerm){
            $state.go('mytopics.explore', $state.params);
        }

        this.itemContext = 'recentItems';    

        this.itemSearchParams = {
            search: $state.params.searchTerm,
            page: 0,
            sortField: 'publishedDate',
            includeReadItems: false,
            createdAfterDateTime: this.dateBound()
        };

        this.items = [];
        fetchItems();

        if($state.params.itemId) {
            itemService.openNewModal({
                itemId: $state.params.itemId,
                hasPrevious: false,
                hasNext: false,
                source: $state.params.source
            });
        }
    };

    $scope.$on('$destroy', ( ) => this.ongoingRequest ? this.ongoingRequest.resolve() : null);

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('RecentItemSummaryCtrl',
['locker',
function(locker) {
    this.markNowAsCreatedAfter = function(){
        locker.put('recent-item-created-after-date', new Date());
    };
}]);

'use strict';

angular.module('attensaApp')
.controller('RecommendedItemListCtrl',
['$scope', '$rootScope', '$state', '$q', '_', 'ItemService',
function($scope, $rootScope, $state, $q, _, itemService) {

    var self = this;

    var fetchItems = function(){
        self.ongoingRequest = true;
        self.searching = true;
        self.ongoingRequest = $q.defer();

        itemService.searchTenantItems(self.itemSearchParams, self.ongoingRequest.promise)
        .then(function (results) {
            self.ongoingRequest = false;
            self.searching = false;
            $rootScope.$broadcast('topic-item-page-fetched', results);
            if (results.first) {
                self.items = [];
            }
            self.totalElements = results.totalElements;
            self.isLastPage = results.last;
            self.items.push.apply(self.items, results.content);
        });
    };

    this.fetchPage = function(){
        self.itemSearchParams.page++;
        fetchItems();
    };

    this.init = function(){
        if($state.params.searchTerm){
            $state.go('mytopics.explore', $state.params);
        }

        self.itemContext = 'recentItems';

        self.itemSearchParams = {
            page: 0,
            sortField: 'attentionRank',
            search: $state.params.searchTerm
        };

        self.items = [];
        fetchItems();
    };

    $scope.$on('$destroy', function( ) {
        if(self.ongoingRequest){
            self.ongoingRequest.resolve();
        }
    });

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('SavedItemListCtrl',
['$scope', '$rootScope', '$stateParams', '$q', '_', 'ItemService', 'UserService',
function($scope, $rootScope, $stateParams, $q, _, itemService, userService) {

    var self = this;

    var fetchItems = function(){
        self.ongoingRequest = true;
        self.searching = true;
        self.ongoingRequest = $q.defer();

        userService.getBookmarkedItems(self.itemSearchParams, self.ongoingRequest.promise)
        .then(function (results) {
            self.ongoingRequest = false;
            self.searching = false;
            $rootScope.$broadcast('topic-item-page-fetched', results);
            if (results.first) {
                self.items = [];
            }
            self.totalElements = results.totalElements;
            self.isLastPage = results.last;
            self.items.push.apply(self.items, results.content);
        });
    };

    this.fetchPage = function(){
        self.itemSearchParams.page++;
        fetchItems();
    };

    this.init = function(){
        self.itemContext = 'recentItems';

        self.itemSearchParams = {
            page: 0,
            sortField: 'publishedDate',
            search: $stateParams.searchTerm
        };

        self.items = [];
        fetchItems();
    };

    $scope.$on('$destroy', function( ) {
        if(self.ongoingRequest){
            self.ongoingRequest.resolve();
        }
    });

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('TopicSidebarCtrl',
['$scope', '$rootScope', '$q', '$state', '_', 'locker', 'LabelService', 'StreamService', 'TaxonomyService', 'TenantService', 'UserService',
function($scope, $rootScope, $q, $state, _, locker, labelService, streamService, taxonomyService, tenantService, userService) {

    var self = this;

    $scope.$on('follow-change', function(evt, followDetails){
        if(followDetails.followStatusChanged) {
            if(followDetails.stream.userIsFollowing){
                self.streams.push(followDetails.stream);
            }else{
                _.remove(self.streams, function(stream){
                    return stream.id === followDetails.stream.id;
                });
            }
            self.mapStreams();
        }
    });

    $scope.$on('$stateChangeSuccess', function(){
        self.streamId = $state.params.streamId;
    });

    const replaceStream = (streams, stream) => {
        const index = _.findIndex(streams, {id: stream.id});
        if(index !== -1) {
            streams[index] = stream;
            console.log(streams[index]);
        }
    };

    $scope.$on('taxonomicMembershipChange', (event, taxonomicMemberships, category, stream) => {
        if(taxonomicMemberships.includes(category.id)){
            self.tenantStreamCategoryMap[category.id].push(stream.id);
        }else{
            _.pull(self.tenantStreamCategoryMap[category.id], stream.id);
        }
    });

    $scope.$on('stream-changed', (evt, stream) => {
        replaceStream(self.streams, stream);
        replaceStream(self.managedStreams, stream);
    });

    $scope.$on('stream-deleted', function(evt, streamId){
        _.remove(self.managedStreams, {id: streamId});
        _.remove(self.streams, {id: streamId});
    });

    $scope.$watchCollection(
        function() { return self.openMap; },
        function() { locker.put('topic-sidebar-openmap', self.openMap ); }
    );

    var addToCategoryMap = function(categoryId, streamId){
        if(!self.tenantStreamCategoryMap[categoryId]){
            self.tenantStreamCategoryMap[categoryId] = [];
        }
        self.tenantStreamCategoryMap[categoryId].push(streamId);
    };

    var streamFetcher = function(noFollowing, userId){
        if(noFollowing){
            return streamService.getTenantStreams({ page: 0, rows: 1000, includeCatalogs: false, published: true });
        } else {
            return userService.getUserStreams({ params: { targetUserId: userId, rows: 1000 } });
        }
    };

    this.init = function(){
        self.openMap = locker.get('topic-sidebar-openmap', {});

        if($state.includes('mytopics.topic')){
            self.openMap.following = true;
        }

        taxonomyService.getTenantTaxonomy(false, false)
        .then(function(response){
            self.taxonomy = response.data;
        });

        self.sharedStreamIds = [];
        self.uncategorizedStreamIds = [];
        self.tenantStreamCategoryMap = {};
        self.streamId = $state.params.streamId;

        tenantService.getCurrentTenant()
        .then(function(tenant) {
            self.noFollowing = tenant.data.settings.noFollowing;
            labelService.labelFor('topicsIFollow', self.noFollowing ? 'Available Topics' : 'Topics I Follow')
            .then(function(label){
                self.topicsLabel = label;
            });

            return userService.getCurrentUser();
        })
        .then(function(userResponse) {
            return $q.all([
                streamFetcher(self.noFollowing, userResponse.data.user.id),
                streamService.getTenantStreams({
                    includeCatalogs: false,
                    rows: 1000,
                    ownerId: userResponse.data.user.id,
                    type: 'COLLECTION'
                })
            ]);
        })
        .then(function(response){
            self.streams = response[0].data.content;
            self.managedStreams = response[1].data.content;
            self.mapStreams();
        });
    };

    this.mapStreams = function(){
        _.forEach(self.streams, function(stream){
            if(stream.tenantId){
                if(stream.taxonomicMemberships.length){
                    _.forEach(stream.taxonomicMemberships, function(categoryId){
                        addToCategoryMap(categoryId, stream.id);
                    });
                }else{
                    addToCategoryMap('uncategorized', stream.id);
                }
            } else {
                self.sharedStreamIds.push(stream.id);
            }
        });
    };

    this.matchingStreams = function(category){
        if(category && self.tenantStreamCategoryMap) {
            var ids = self.tenantStreamCategoryMap[category.id] || [];
            _.forEach(category.subcategories, function(subcat){
                ids = _.union(ids, self.tenantStreamCategoryMap[subcat.id]);
            });
            return _.filter(self.streams, function (stream) {
                return ids.indexOf(stream.id) !== -1;
            });
        }
    };

    this.sharedStreams = function(){
        return _.filter(self.streams, function (stream) {
            return !stream.tenantId;
        });
    };

    this.orderLabel = function(category) {
        if(category && category.title !== 'Uncategorized') {
            return category.title.toLowerCase();
        }
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('TopicSearchCtrl',
['$scope', '$rootScope', '$state', 'StreamService',
function($scope, $rootScope, $state, streamService) {

    var self = this;

    $scope.$on('$stateChangeSuccess', function(){
        self.tag = $state.params.tag;
        self.tags = $state.params.tags;
        self.streamId = $state.params.streamId;
        self.searchTerm = $state.params.searchTerm;
        self.siteOnly = $state.params.siteOnly;
        self.followedOnly = $state.params.followedOnly;
        self.configuration = streamService.parseSearchConfiguration($state.params.tags);
    });

    this.init = function(){
        self.tag = $state.params.tag;
        self.tags = $state.params.tags;
        self.streamId = $state.params.streamId;
        self.searchTerm = $state.params.searchTerm;
        self.state = $state;
        self.configuration = streamService.parseSearchConfiguration($state.params.tags);
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('PersonalDigestCtrl', ['$rootScope', function($rootScope) {
    
    this.initialize = () => this.user = $rootScope.user;

    // ctrl.preview = function(digestConfiguration, sendDay, sendTime, streams) {
    //     return ctrl.save(digestConfiguration, sendDay, sendTime, streams)
    //     .then(function() {
    //         return digestService.openDigestPreview(ctrl.digestConfiguration.id, $rootScope.user.id);
    //     });
    // };

    this.initialize();
 }]);

'use strict';

angular.module('controllers.sourceCreation', []);

angular.module('controllers.sourceCreation')
.controller('SourceCreationModalCtrl', ['_', '$rootScope', '$uibModalInstance', 'sourceTypeTitle', 'streamType', 'StreamService', 'existingSources', 'preventSearch',
    function(_, $rootScope, $uibModalInstance, sourceTypeTitle, streamType, StreamService, existingSources, preventSearch) {
        var ctrl = this;

        ctrl.selectedSources = [];
        ctrl.authSettings = {
            isAuthenticated: false
        };

        ctrl.preventSearch = preventSearch;

        ctrl.search = function() {
            ctrl.selectedSources = [];
            ctrl.recommendedStreams = [];
            StreamService.getTenantStreams({
                includeCatalogs: true,
                rows: 20,
                term: ctrl.searchTerm,
                type: streamType
            })
            .then(function(searchRes) {
                var exactMatchStream = StreamService.findMatchingStream(searchRes.data.content, ctrl.searchTerm, {
                    type: ctrl.searchType,
                    username: ctrl.authSettings.username,
                    password: ctrl.authSettings.password,
                    searchConfiguration: ctrl.tagSettings
                });
                var matchingStreamId = exactMatchStream ? exactMatchStream.id : undefined;
                $rootScope.$broadcast('preview-items', { matchingStreamId: matchingStreamId });
                if(searchRes.data.content.length > 0) {
                    ctrl.recommendedStreams = _.filter(searchRes.data.content, function(stream) {
                        return stream.id !== matchingStreamId && !_.find(existingSources, { id: stream.id });
                    });
                }
            });
        };

        ctrl.sourceSelectionsDidChange = function(isSelected, streamId) {
            ctrl.selectedSources = isSelected ? _.union(ctrl.selectedSources, [streamId]) : _.without(ctrl.selectedSources, streamId);
        };

        ctrl.addSources = function(sourceId) {
            $uibModalInstance.close(_.union(ctrl.selectedSources, [sourceId]));
        };

        ctrl.tagsDidChange = function() {
            if(!_.isEmpty(ctrl.searchTerm)) {
                ctrl.search();
            }
        };

        ctrl.sourceTypeTitle = sourceTypeTitle;
        ctrl.streamType = streamType;
        ctrl.searchType = ctrl.streamType === 'BING_SEARCH' ? 'NEWS' : undefined;
        ctrl.tagSettings = ctrl.streamType === 'ATTENSA_SEARCH' ? { tags: [] } : undefined;
    }]);

'use strict';

angular.module('controllers.sourceFinder', []);

angular.module('controllers.sourceFinder')
.controller('SourceFinderCtrl', ['$scope', 'growl', '_', '$q', '$uibModal', '$uibModalInstance', '$state', 'LabelService', 'TaxonomyService', 'TenantService', 'existingSources', 'parentStreamId', 'topicsOnly',
function($scope, growl, _, $q, $uibModal, $uibModalInstance, $state, labelService, TaxonomyService, TenantService, existingSources, parentStreamId, topicsOnly) {
    var ctrl = this;

    $scope.$on('$locationChangeStart', function(event){
        if(ctrl.selectedSources.length){
            growl.error('You have unsaved selected sources!  Please choose either Add sources or close the chooser with the X.', { referenceId: 'sourceFinderMessages' });
            event.preventDefault();
        }
    });

    ctrl.init = function() {
        labelService.setLabel(ctrl, 'catalogTabLabel', 'catalog_navigation_label', 'Catalog');
        ctrl.searchTerm = '';
        ctrl.selectedSources = [];
        ctrl.existingSources = existingSources;
        ctrl.parentStreamId = parentStreamId;
        ctrl.topicsOnly = topicsOnly;

        // Here is where we get the tenant's catalog taxonomy
        TaxonomyService.getTenantTaxonomy(true, undefined, true)
        .then(function(taxonomyRes) {
            ctrl.taxonomy = taxonomyRes.data;
        });

        // Here is where we get the catalogs and taxonomies for shared catalogs
        TenantService.getCatalogMap()
        .then(function(catalogs) {
            ctrl.catalogs = catalogs;
            return catalogs;
        })
        .then(function(catalogs) {
            return $q.all(_.map(catalogs, function(catalog) {
                return TaxonomyService.getCatalogTaxonomy(catalog.catalogId);
            }));
        })
        .then(function(catalogTaxonomies) {
            ctrl.catalogTaxonomies = catalogTaxonomies;
        });
    };

    ctrl.search = function() {
       ctrl.showSearch = true;
    };

    ctrl.sourceSelectionDidChange = function(isSelected, streamId) {
        ctrl.selectedSources = isSelected ? _.union(ctrl.selectedSources, [streamId]) : _.without(ctrl.selectedSources, streamId);
    };

    ctrl.addSources = function(selectedSources) {
        $uibModalInstance.close(_.pluck(selectedSources, 'id'));
    };

    ctrl.dismiss = function(){
        if(ctrl.selectedSources.length){
            var modalScope = $scope.$new(true);
            modalScope.modalTitle = 'Unsaved selected sources';
            modalScope.message = 'You have selected sources that have not been saved. Continue close?';
            modalScope.confirmLabel = 'Close';
            return $uibModal.open({
                templateUrl: '/templates/ConfirmModal.html',
                size: 'lg',
                scope: modalScope
            }).result
            .then($uibModalInstance.dismiss);
        } else {
            $uibModalInstance.dismiss();
        }
    };

    this.init();
}]);

'use strict';

angular.module('controllers.sourceFinder')
.controller('SourceSearchCtrl', ['_', '$scope', '$rootScope', '$state', 'StreamService',
function(_, $scope, $rootScope, $state, streamService) {
    var self = this;

    this.init = function() {
        this.fetchingRecommended = true;

        streamService.getRecommendedStreams({
            includeCatalogs: true,
            rows: 20,
            topicsOnly: $scope.sourceFinderCtrl.topicsOnly ? true : undefined,
            search: $scope.sourceFinderCtrl.searchTerm,
            type: 'item_search'
        })
        .then(function(searchRes) {
            self.recommendedStreams = searchRes.data.content;
            self.fetchingRecommended = false;
        });

        this.matchingStreamsPaging = { currentPage: 1 };

        self.fetchMatchingStreams();
    };

    this.fetchMatchingStreams = function(){
        this.fetchingMatches = true;

        streamService.getTenantStreams({
            includeCatalogs: true,
            type: $scope.sourceFinderCtrl.topicsOnly ? 'COLLECTION' : undefined,
            page: self.matchingStreamsPaging.currentPage - 1,
            rows: 20,
            term: $scope.sourceFinderCtrl.searchTerm
        })
        .then(function(searchRes) {
            self.matchingStreamsPaging.first = searchRes.data.first;
            self.matchingStreamsPaging.last = searchRes.data.last;
            self.matchingStreamsPaging.totalElements = searchRes.data.totalElements;

            self.matchingStreams = searchRes.data.content;
            self.fetchingMatches = false;
        });
    };

    this.user = $rootScope.user;

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('TopicItemListCtrl',
['$scope', '$rootScope', '$q', '$window', '$stateParams', '_', 'eventService', 'ItemService',
function($scope, $rootScope, $q, $window, $stateParams, _, eventService, itemService) {

    var self = this;

    var resetItemSearch = function(){
        self.itemSearchParams = {
            page:0,
            sortField: 'publishedDate',
            includeReadItems: true,
            streamId: $scope.topic.currentStream ? $scope.topic.currentStream.id : '',
            createdAfterDateTime: self.itemSearchParams ? self.itemSearchParams.createdAfterDateTime : null,
            createdBeforeDateTime: self.itemSearchParams ? self.itemSearchParams.createdBeforeDateTime : null
        };
        $rootScope.$broadcast('topic-sort-changed', self.itemSearchParams.sortField);
    };

    var fetchItems = function(){
        self.currentTopicId = $scope.topic.currentStream.id || $scope.topic.mainStream.id;
        self.ongoingRequest = true;
        self.searching = true;
        $rootScope.$broadcast('topic-searching');
        if($scope.topic.mainStream) {
            var targetId = $scope.topic.middleStream ? $scope.topic.middleStream.id : $scope.topic.currentStream.id;
            var params =_.cloneDeep(self.itemSearchParams);
            if($scope.topic.middleStream){
                _.assign(params, { childSubStreamId: $scope.topic.currentStream.id });
            }
            itemService.fetchTopicItems($scope.topic.mainStream.id, targetId, params)
            .then(function (results) {
                self.ongoingRequest = false;
                self.searching = false;
                $rootScope.$broadcast('topic-item-page-fetched', results);
                $rootScope.$broadcast('topic-sort-changed', self.itemSearchParams.sortField);
                if (results.first) {
                    self.items = [];
                }
                self.totalElements = results.totalElements;
                self.isLastPage = results.last;
                self.items.push.apply(self.items, results.content);
            });
        }
    };

    var initialFetch = function(){
        self.itemSearchParams.page = 0;
        fetchItems();
    };

    $scope.$on('topics-date-range-change', function(event, startDate, endDate){
        self.itemSearchParams.createdAfterDateTime = startDate;
        self.itemSearchParams.createdBeforeDateTime = endDate;
        self.itemSearchParams.page = 0;
        fetchItems();
    });

    $scope.$on('topic-set-current-stream', function(){
        resetItemSearch();
        self.items = [];
        fetchItems();
    });

    $scope.$on('topic-fetch-items', initialFetch);

    $scope.$on('topic-set-sort', function(evt, key){
        self.itemSearchParams.sortField = key;
        $rootScope.$broadcast('topic-sort-changed', self.itemSearchParams.sortField);
        fetchItems();
    });

    $scope.$on('item-deleted', initialFetch);

    this.fetchPage = function(){
        self.itemSearchParams.page++;
        fetchItems();
    };

    //Initialization
    this.itemContext = 'topicView';
    this.items = [];
    resetItemSearch();
    self.itemSearchParams.createdAfterDateTime = $stateParams.startDate ? new Date($stateParams.startDate) : null;
    self.itemSearchParams.createdBeforeDateTime = $stateParams.endDate ? new Date($stateParams.endDate) : null;
    initialFetch();
}]);

'use strict';

angular.module('attensaApp')
.controller('TopicResultsCtrl',
['$scope', '$rootScope', '$state',
function($scope, $rootScope, $state) {

    var self = this;

    $scope.$on('topic-searching', function(){
        self.searching = true;
    });

    $scope.$on('topic-item-page-fetched', function(evt, results){
        self.searching = false;
        self.totalElements = results.totalElements;
    });

    this.clearDateFilter = function(){
        $rootScope.$broadcast('topic-date-range-clear');
    };

    this.init = function(){
        self.searchTerm = $state.params.searchTerm;
        self.streamId = $state.params.streamId;
        self.parentStreamId = $state.params.parentStreamId;
        if($state.current.data){
            self.noResultsBaseMessage = $state.current.data.noResultsBaseMessage;
            self.noResultsSearchMessage = $state.current.data.noResultsSearchMessage;
            self.noResultsDateFilterMessage = $state.current.data.noResultsDateFilterMessage;
        }
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('TopicSourcesCtrl',
['$scope', '$rootScope', '$stateParams', '$q', '_', 'StreamService',
function($scope, $rootScope, $stateParams, $q, _, streamService) {
    var self = this;
    this.expandedStreams = {};

    var fetchCounts = function(){
        if(self.itemCountDeferred){
            self.itemCountDeferred.resolve('cancelled');
        }
        self.itemCountDeferred = $q.defer();
        streamService.topicItemCounts($scope.topic.mainStream.id, self.createdAfterDateTime, self.createdBeforeDateTime, self.itemCountDeferred)
        .then(function(countResponse){
            self.itemCountDeferred = undefined;
            //use sortBy to force indexBy to use the largest available count for any given stream (when there are duplicate count records)
            self.idCountMap = _.chain(countResponse.data).sortBy('count').indexBy('streamId').value();
        });
    };

    this.orderedConfigurations = function(stream){
        var sourceIds;
        var indexedConfigurations;
        var subConfigs = stream.streamConfiguration.subStreamConfigurations;

        if(stream.manuallySorted){
            sourceIds = _.map(stream.subStreams, 'targetStreamId');
            indexedConfigurations = _.indexBy(subConfigs, 'streamId');

            return _.map(sourceIds, function (id) {
                return indexedConfigurations[id];
            });
        }else{
            return self.configurationsAlpha(subConfigs);
        }
    };

    this.configurationsAlpha = function(configurations){
        return _.sortBy(configurations, function(config){
            return  config.title.toLowerCase();
        });
    };

    this.toggleExpansion = function(streamConfig){
        self.expandedStreams[streamConfig.streamId] = !self.expandedStreams[streamConfig.streamId];
    };

    this.selectStream = function(streamConfig, middleConfig){
        var middleStream = middleConfig ? { id: middleConfig.streamId } : undefined;
        streamService.getStream(streamConfig.streamId)
        .then(function(streamData){
            $rootScope.$broadcast('topic-set-current-stream', streamData.data, middleStream);
        });
    };

    $scope.$on('topics-date-range-change', function(event, startDate, endDate){
        self.createdAfterDateTime = startDate;
        self.createdBeforeDateTime = endDate;
        fetchCounts();
    });

    self.createdAfterDateTime = $stateParams.startDate ? new Date($stateParams.startDate) : null;
    self.createdBeforeDateTime = $stateParams.endDate ? new Date($stateParams.endDate) : null;
    fetchCounts();
}]);

'use strict';

angular.module('attensaApp')
.controller('TopicStateCtrl',
['$scope', '$rootScope', '$stateParams', '$q', 'categoryService', 'StreamService', 'UserService', 'TaxonomyService', 'stream',
function($scope, $rootScope, $stateParams, $q, categoryService, streamService, userService, taxonomyService, stream) {

    var self = this;

    // mainStream === the topic / top level stream
    // middleStream === if it exists it is the child of the mainStream (topic) and the parent of the currentStream
    // currentStream === the terminal stream (could be child or grandchild of the topic

    this.init = function () {
        self.loaded = true;
        self.mainStream = stream.data;
        self.currentStream = stream.data;
        self.indexVisible = stream.data.type === 'COLLECTION' ? $stateParams.indexVisible === 'true' : false;

        if($stateParams.subscribe === 'true' && !self.mainStream.userIsFollowing){
            $q.all([
                userService.getCurrentUser(),
                taxonomyService.getTenantTaxonomy()
            ])
            .then(function(responses){
                self.currentUser = responses[0].data.user;
                var taxonomy = responses[1].data;
                return categoryService.updatePersonalCategory(self.mainStream, true, taxonomy, self.currentUser);
            })
            .then(function(){
                return userService.setFollowing(self.mainStream.id, self.currentUser.id, { follow: true });
            })
            .then(function(){
                return streamService.getStream(self.mainStream.id);
            })
            .then(function(streamResponse){
                self.mainStream = streamResponse.data;
                self.currentStream = streamResponse.data;
                $rootScope.$broadcast('topic-set-current-stream', streamResponse.data);
            });
        }else{
            $rootScope.$broadcast('topic-set-current-stream', self.mainStream);
        }
    };

    var setStream = function(stream){
        self.mainStream = stream;
        if (self.currentStream.id === stream.id) {
            self.currentStream = stream;
        }
        if(self.middleStream && self.middleStream.id === stream.id){
            self.middleStream = stream;
        }
    };

    $scope.$on('topic-set-current-stream', function(event, currentStream, middleStream){
        self.currentStream = currentStream;
        self.middleStream = middleStream;
    });

    $scope.$on('stream-changed', function(evt, stream){
        if(stream.id === self.mainStream.id) {
            setStream(stream);
        }else{
            streamService.getStream($stateParams.streamId)
            .then(function(streamResult){
                setStream(streamResult.data);
            });
        }
        if(stream.id === self.currentStream.id){
            self.currentStream = stream;
        }
        if(self.middleStream && stream.id === self.middleStream.id){
            self.middleStream = stream;
        }
    });

    this.init();
}]);

'use strict';

angular.module('controllers.browse', []);

angular.module('controllers.browse')
.controller('BrowseCtrl', ['_', '$q', '$scope', '$state', '$stateParams', 'categoryService', 'LabelService', 'permissionService', 'StreamService', 'TaxonomyService', 'TenantService', 'UtilService',
function(_, $q, $scope, $state, $stateParams, categoryService, labelService, permissionService, StreamService, TaxonomyService, tenantService, UtilService) {
    var self = this;

    this.init = function() {
        labelService.setLabel(self, 'catalogTabLabel', 'catalog_navigation_label', 'Catalog');
        self.searchTerm = $stateParams.searchTerm || '';
        self.selectedStreams = [];

        permissionService.currentUserHasPermission({ action: 'CREATE_STREAM' })
        .then(function(hasCreateStreamPermission) {
            self.displayOwnedStreams = hasCreateStreamPermission;
        });

        return tenantService.getCatalogMap()
        .then(function(catalogs) {
            self.catalogs = catalogs;
        });
    };

    this.search = function(streamId) {
        self.selectedStreams = _.reject(self.selectedStreams, { id: streamId });
        $state.go('browse.catalog');
    };

    $scope.$on('$stateChangeSuccess', function(evt, toState, toParams, fromState) {
        self.searchTerm = toState.name === 'browse.search' ? self.searchTerm : '';
        if(toState.name === 'browse.stream' && !_.some(self.selectedStreams, { id: toParams.streamId })) {
            _streamGetter(toParams)
            .then(function(stream) {
                self.selectedStreams.push(stream);
            });
        }
    });

    this.state = $state;
    this.stateParams = $stateParams;

    var _streamGetter = function(params) {
        return params.stream ?
            $q.when(params.stream) : UtilService.unwrap(StreamService.getStream(params.streamId));
    };

    $scope.$on('follow-change', function(evt, evtData) {
        if(evtData.followStatusChanged) {
            TaxonomyService.getTenantTaxonomy()
            .then(function(taxonomyResponse) {
                return categoryService.updatePersonalCategory(evtData.stream, evtData.stream.userIsFollowing, taxonomyResponse.data, $scope.user);
            })
            .then(function(updatedUser) {
                $scope.user = updatedUser;
            });
        }
    });

    this.init();
}]);

'use strict';

angular.module('controllers.topics', []);

angular.module('controllers.topics')
.controller('TopicsCtrl', ['_', '$q', '$scope', '$rootScope', '$state', '$stateParams', 'categoryService', 'TaxonomyService',
function(_, $q, $scope, $rootScope, $state, $stateParams, categoryService, taxonomyService) {
    var self = this;

    this.init = function() {
        this.streams = [];

        return self._taxonomyGetter($stateParams)
        .then(function(taxonomy) {
            self.taxonomy = taxonomy;
            self.selectedCategoryStack = taxonomyService.buildBreadCrumbs(self.taxonomy, $stateParams.categoryId);
            self._selectCategory(self.taxonomy, $stateParams.categoryId);
        });
    };

    this._taxonomyGetter = function(stateParams) {
        if(stateParams.taxonomy) {
            return $q.when(stateParams.taxonomy);
        } else if($state.current.data.tenantTaxonomy) {
            return taxonomyService.getTenantTaxonomy(true, true, true)
            .then(function(taxonomyRes) {
                return taxonomyRes.data;
            });
        } else {
            return taxonomyService.getCatalogTaxonomy(stateParams.catalogId);
        }
    };

    this.clickCategory = function(category) {
        $state.go($state.current, { categoryId: category.id, taxonomy: self.taxonomy });
    };

    this._selectCategory = function(taxonomy, categoryId) {
        self.categories = taxonomyService.getCategoryList(taxonomy, categoryId);
        if(categoryId) {
            var searchParams = { params: { categoryId: categoryId, includeSubcategories: false, published: true, rows: 1000 } };
            var streamGetter = $state.current.data.tenantTaxonomy ?
                taxonomyService.getStreams(searchParams) : taxonomyService.getCatalogCategoryStreams($stateParams.catalogId, searchParams);

            self.fetchingStreams = true;
            return streamGetter
            .then(function(streamsRes) {
                self.streams = streamsRes.data.content;
                self.fetchingStreams = false;
            });
        }
    };

    $scope.$on('follow-change', function(evt, evtData) {
        if(evtData.followStatusChanged) {
            return categoryService.updatePersonalCategory(evtData.stream, evtData.stream.userIsFollowing, self.taxonomy, self.user, _.last(self.selectedCategoryStack));
        }
    });

    this.stateParams = $stateParams;

    this.user = $rootScope.user;

    this.init();
}]);

'use strict';

angular.module('controllers.topicsOwnedStreams', []);

angular.module('controllers.topicsOwnedStreams')
.controller('TopicsOwnedStreamsCtrl', ['$rootScope','StreamService',
    function($rootScope, StreamService) {
        var ctrl = this;

        ctrl.init = function() {
            ctrl.fetchingTopics = true;
            ctrl.fetchingSources = true;

            StreamService.getTenantStreams({
                includeCatalogs: false,
                rows: 1000,
                ownerId: ctrl.user.id,
                type: 'COLLECTION'
            })
            .then(function(searchRes) {
                ctrl.matchingTopics = searchRes.data.content;
            })
            .finally(function() {
                ctrl.fetchingTopics = false;
            });

            StreamService.getTenantStreams({
                includeCatalogs: false,
                rows: 1000,
                ownerId: ctrl.user.id,
                excludeTypes: 'COLLECTION, PRODUCT_SOURCE'
            })
            .then(function(searchRes) {
                ctrl.matchingSources = searchRes.data.content;
            })
            .finally(function() {
                ctrl.fetchingSources = false;
            });
        };

        this.user = $rootScope.user;

        this.init();
    }]);

'use strict';

angular.module('controllers.topicsSearch', []);

angular.module('controllers.topicsSearch')
.controller('TopicsSearchCtrl', ['_', '$scope', '$rootScope', '$state', '$stateParams', 'StreamService',
function(_, $scope, $rootScope, $state, $stateParams, streamService) {
    var self = this;

    this.init = function() {
        this.fetchingMatches = true;
        this.fetchingRecommended = true;

        streamService.getRecommendedStreams({
            includeCatalogs: true,
            rows: 20,
            search: $stateParams.searchTerm,
            type: 'item_search',
            published: true
        })
        .then(function(searchRes) {
            self.recommendedStreams = searchRes.data.content;
            self.fetchingRecommended = false;
        });

        streamService.getTenantStreams({
            includeCatalogs: true,
            rows: 20,
            term: $stateParams.searchTerm,
            published: true
        })
        .then(function(searchRes) {
            self.matchingStreams = searchRes.data.content;
            self.fetchingMatches = false;
        });
    };

    this.user = $rootScope.user;

    this.init();
}]);

'use strict';

angular.module('controllers.topicBuilder', []);

angular.module('controllers.topicBuilder')
.controller('TopicBuilderActivityCtrl', ['_', '$q', '$scope', '$stateParams', 'eventService', 'ItemService',
    function(_, $q, $scope, $stateParams, eventService, ItemService) {
    var ctrl = this;

    ctrl.initialize = function() {
        ctrl.stream = $scope.builderCtrl.stream;
        ctrl.durations = _.range(1, 7);
        ctrl.timeUnits = [
            { days: 30, text: 'months'},
            { days: 7,  text: 'weeks'},
            { days: 1,  text: 'days'}
        ];
        ctrl.selectedDuration = 1;
        ctrl.selectedTimeUnitDays = 7;
        ctrl.graphSelection = 'item_viewed';
        ctrl.renderAnalytics(ctrl.stream.id, ctrl.selectedTimeUnitDays * ctrl.selectedDuration, ctrl.graphSelection);
    };

    ctrl.renderAnalytics = function(streamId, daysAgo, graphSelection) {
        ctrl.fetchingData = true;
        return $q.all([
            eventService.getFormattedSegmentationData(daysAgo, 'item_viewed', eventService.totalsFormatter, { streamId: streamId }),
            eventService.getFormattedSegmentationData(daysAgo, 'item_link_clicked', eventService.totalsFormatter, { streamId: streamId }),
            eventService.getFormattedSegmentationData(daysAgo, 'item_viewed', eventService.uniquesMetricFormatter,
                { streamId: streamId, segmentationProp: 'item_id'}),
            eventService.getFormattedSegmentationData(daysAgo, 'item_viewed', eventService.topItemsFormatter,
                { streamId: streamId, segmentationProp: 'item_id'}),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_delivered', eventService.totalsFormatter, { streamId: streamId }),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_opened', eventService.totalsFormatter, { streamId: streamId }),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_clicked', eventService.totalsFormatter, { streamId: streamId }),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_dropped', eventService.totalsFormatter, { streamId: streamId }),
            eventService.getFormattedSegmentationData(daysAgo, 'briefing_email_spammed', eventService.totalsFormatter, { streamId: streamId })
        ])
        .then(function(queryResults) {
            ctrl.totalViewsData = queryResults[0];
            ctrl.clickThroughData = queryResults[1];
            ctrl.uniqueViewsData = queryResults[2];
            ctrl.deliveredBriefings = queryResults[4];
            ctrl.openedBriefings = queryResults[5];
            ctrl.clickedBriefings = queryResults[6];
            ctrl.droppedBriefings = queryResults[7];
            ctrl.spammedBriefings = queryResults[8];
            ItemService.getItems(_.map(queryResults[3], function(idCountPair) { return idCountPair[0]; }))
            .then(function(items) {
                ctrl.topItems = eventService.buildItemListDetails(queryResults[3], items);
            });
            ctrl.setGraphSelection(graphSelection);
            ctrl.fetchingData = false;
        });
    };

    ctrl.setGraphSelection = function(selection) {
        var graphMap = {
            item_viewed: ctrl.totalViewsData,
            item_link_clicked: ctrl.clickThroughData,
            briefing_email_delivered: ctrl.deliveredBriefings,
            briefing_email_opened: ctrl.openedBriefings,
            briefing_email_clicked: ctrl.clickedBriefings,
            briefing_email_dropped: ctrl.droppedBriefings,
            briefing_email_spammed: ctrl.spammedBriefings
        };
        ctrl.graphSelection = selection;
        ctrl.graphData = graphMap[selection].graph;
    };

    ctrl.showDetailModal = eventService.showEventDetailModal;

    ctrl.initialize();
}]);

'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderAggregationCtrl', ['$scope', function($scope) {
    var ctrl = this;

    ctrl.init = function() {
        ctrl.stream = $scope.builderCtrl.stream;
        ctrl.aggregationEnabled = !ctrl.stream.settings.aggregationDisabled;
    };

    ctrl.saveAggregationStatus = function(aggregationEnabled) {
        ctrl.stream.settings.aggregationDisabled = !aggregationEnabled;
        $scope.builderCtrl.saveStream(ctrl.stream);
    };

    ctrl.init();
}]);

'use strict';

angular.module('attensaApp')
.controller('TopicBuilderArticlesCtrl',
['currentStream',
    function(currentStream) {

        var self = this;

        this.init = function(){
            self.mainStream = currentStream.data;
            self.currentStream = currentStream.data;
        };

        this.init();
    }]);

'use strict';

angular.module('controllers.topicBuilder')
    .controller('TopicBuilderFiltersCtrl', ['_', '$q', '$scope', '$state', '$stateParams', '$timeout', 'growl', 'ItemService', 'StreamService',
        function(_, $q, $scope, $state, $stateParams, $timeout, growl, ItemService, StreamService) {
            var ctrl = this;

            ctrl.init = function() {
                ctrl.showSimpleFilter = $stateParams.simpleFilter;
                ctrl.currentPage = 1;
                ctrl.refreshItemList();
            };

            ctrl.refreshItemList = function(params) {
                var filter = $scope.selectedFilter ? $scope.selectedFilter.params : { displayedOnly: false, hiddenOnly: false };

                ItemService.searchItemsInStream(_.assign({ streamId: $stateParams.streamId }, filter, params))
                .then(function(itemsRes) {
                    ctrl.items = itemsRes.data.content;
                    ctrl.itemsMetadata = _.omit(itemsRes.data, 'content');
                });

                StreamService.getStreamItemCounts($stateParams.streamId)
                .then(function(itemCounts) {
                    ctrl.itemCounts = itemCounts;
                });
            };

            ctrl.streamFilterChanged = function() {
                ctrl.refreshItemList();
                $scope.builderCtrl.getStream();
            };

            ctrl.fetchPage = function() {
                ctrl.refreshItemList({ page: ctrl.currentPage - 1 });
            };

            ctrl.slowRefresh = function(){
              $timeout(ctrl.refreshItemList, 1000);
            };

            $scope.$on('item-posted', ctrl.slowRefresh);
            $scope.$on('item-updated', ctrl.slowRefresh);
            $scope.$on('item-deleted', ctrl.slowRefresh);

            ctrl.state = $state;
            ctrl.previousSearchTerms = $stateParams.filterTerms;

            ctrl.init();
        }]);

'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderContentCtrl', ['_', '$q', '$scope', '$rootScope', '$state', '$stateParams', '$uibModal', 'StreamService',
    function(_, $q, $scope, $rootScope, $state, $stateParams, $uibModal, StreamService) {

    var ctrl = this;

    this.init = function() {
        ctrl.hideSources = true;

        $q.all([
            StreamService.getStream($stateParams.streamId),
            StreamService.getSubstreams($stateParams.streamId, { rows: 1000 })
        ])
        .then(function(results) {
            var stream = results[0].data;
            var sourceIds;
            var indexedSources;

            if(stream.manuallySorted) {
                sourceIds = _.map(stream.subStreams, 'targetStreamId');
                indexedSources = _.indexBy(results[1].data.content, 'id');

                ctrl.sources = _.map(sourceIds, function (id) {
                    return indexedSources[id];
                });
            } else {
                ctrl.sources = _.sortBy(results[1].data.content, function(stream){ return stream.title.toUpperCase(); });
            }
        });
    };

    this.subscribeToSources = function(streamIds) {
        $q.all(_.map(streamIds, function(streamId) {
            return StreamService.postStreamSubscription($scope.builderCtrl.stream.id, streamId);
        }))
        .finally(function() {
            $state.go($state.current, {}, { reload: true });
        });
    };

    this.launchSourceFinder = function() {
        $uibModal.open({
            templateUrl: '/templates/sourceFinder/sourceFinder.html',
            controller: 'SourceFinderCtrl',
            controllerAs: 'sourceFinderCtrl',
            keyboard: true,
            backdrop: 'static',
            windowClass: 'modal-xl',
            resolve: {
                existingSources: function() { return ctrl.sources; },
                parentStreamId: function() { return $stateParams.streamId; },
                topicsOnly: function(){ return false; }
            }
        }).result.then(function(sourceIdsToSubscribe) {
            ctrl.subscribeToSources(sourceIdsToSubscribe);
        });
    };

    this.removeSource = function(sourceId) {

        var modalScope = $scope.$new();

        modalScope.modalTitle = ' Remove source?';
        modalScope.message = 'This will remove this source from the current topic.';
        modalScope.confirmLabel = 'Continue';

        $uibModal.open({
            templateUrl: '/templates/ConfirmModal.html',
            size: 'md',
            keyboard: true,
            scope: modalScope
        }).result
        .then(function() {
            _.remove(ctrl.sources, { id: sourceId });
            StreamService.deleteStreamSubscription($stateParams.streamId, sourceId);
        });
    };

    this.sourcesReordered = function(stream){
        var sourceIds = _.map(ctrl.sources, 'id');

        var indexedSources = _.indexBy(stream.subStreams, 'targetStreamId');
        stream.subStreams = _.map(sourceIds, function(id){ return indexedSources[id]; });

        var indexedSubstreamConfigurations = _.indexBy(stream.streamConfiguration.subStreamConfigurations, 'streamId');
        stream.streamConfiguration.subStreamConfigurations = _.map(sourceIds, function(id){ return indexedSubstreamConfigurations[id]; });

        stream.manuallySorted = true;

        $rootScope.$broadcast('sourcesChanged');
    };

    ctrl.init();
}]);

'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderCtrl', ['_', '$q', '$rootScope', '$scope', '$state', '$stateParams', 'growl', 'ItemService', 'permissionService', 'StreamService', 'TaxonomyService', 'TenantService',
function(_, $q, $rootScope, $scope, $state, $stateParams, growl, ItemService, permissionService, StreamService, TaxonomyService, tenantService) {
    var ctrl = this;

    var processOpen = function(){
        _.forEach(['articles', 'filters', 'sources', 'syndication', 'usage', 'topics', 'people', 'activity', 'settings', 'aggregation'], 
        tab => {
            const key = 'editTopic.' + tab;
            ctrl.activeStates[key] = ctrl.state.current.name === key; 
        });
    };

    ctrl.activeStates = {};

    ctrl.init = function() {

        tenantService.getCurrentTenant()
        .then(function(tenantRes){
            ctrl.tenant = tenantRes.data;
            ctrl.noFollowing = tenantRes.data.settings.noFollowing;
        });

        ctrl.getStream();
        processOpen();
        return $stateParams.catalogId ? ctrl.getCatalogTaxonomy() : ctrl.getTaxonomy();
    };

    $scope.$on('taxonomicMembershipChange', function (event, taxonomicMemberships) {
        ctrl.stream.taxonomicMemberships = taxonomicMemberships;
        ctrl.saveStream(ctrl.stream);
    });

    $scope.$on('stream-altered', (event, stream) => {
        ctrl.stream = stream || ctrl.stream;
    });

    $scope.$on('sourcesChanged', (event, stream) => {
        ctrl.stream = stream || ctrl.stream;
        ctrl.saveStream(ctrl.stream);
    });

    $scope.$on('follow-change', (event, details) => ctrl.stream = details.stream || ctrl.stream);

    ctrl.getStream = function() {
        var stream;
        var streamGetter = $stateParams.catalogId ?
            StreamService.getStreamFromCatalog($stateParams.catalogId, $stateParams.streamId) : StreamService.getStream($stateParams.streamId);

        streamGetter
        .then(function(streamRes) {
            stream = streamRes.data;
            return $q.all([
                permissionService.currentUserHasPermission({ action: 'MANAGE_CATALOG' }), // Can manage catalog streams?
                permissionService.currentUserHasPermission({ action: 'MANAGE_STREAM', streamOwnerId: stream.ownerId }), // Is owner editing own topic?
                permissionService.currentUserHasPermission({ action: 'MANAGE_STREAM' }), // Is a tenant stream manager
                permissionService.currentUserHasPermission({ action: 'MANAGE_OWNED_STREAM_PEOPLE', streamOwnerId: stream.ownerId }), // Can see people tab?
                permissionService.currentUserHasPermission({ action: 'MANAGE_OWNED_STREAM_BRIEFING', streamOwnerId: stream.ownerId }), // Can see syndication tab?
                permissionService.currentUserHasPermission({ action: 'MANAGE_STREAM', streamId: stream.id }) // has stream level permission to manage stream
            ]);
        })
        .then(function(responses) {
            var isCatalogManager = responses[0];
            var isStreamOwner = responses[1];
            var isTenantStreamManager = responses[2];
            ctrl.canSeePeopleTab = responses[3] || isTenantStreamManager;
            ctrl.canSeeSyndicationTab = responses[4] || isTenantStreamManager;
            var isStreamManagerForStream = responses[5];
            var isTenantStream = stream.tenantId;
            // Block edit without permission
            if((isTenantStream && (!isStreamManagerForStream && !isStreamOwner)) || (!isTenantStream && !isCatalogManager)) {
                $state.go('topic', { streamId: stream.id }, { location: 'replace' });
            } else {
                ctrl.stream =  stream;
                ctrl.saveStream = ctrl.stream.tenantId ? StreamService.updateStream : StreamService.updateCatalogStream;
            }
        })
        .catch(function() {
            growl.error('Unable to retrieve topic');
        });
    };

    ctrl.getCatalogTaxonomy = function() {
        return TaxonomyService.getCatalogTaxonomy($stateParams.catalogId, { filterEmpty: false })
        .then(function(taxonomy) {
            ctrl.taxonomy = taxonomy;
        })
        .catch(function() {
            growl.error('Unable to retrieve topic categories');
        });
    };

    ctrl.getTaxonomy = function() {
        return TaxonomyService.getTenantTaxonomy()
        .then(function (response) {
            ctrl.taxonomy = response.data;
            ctrl.taxonomyVersion = response.headers('X-Object-Version');
        })
        .catch(function() {
            growl.error('Unable to retrieve topic categories');
        });
    };

    ctrl.postToTopic = function(currentStream){
        ItemService.openPostItemModal([currentStream], null, $scope.user.firstName + ' ' + $scope.user.lastName, function() {
            $rootScope.$broadcast('item-posted');
        });
    };

    ctrl.state = $state;
    ctrl.stateParams = $stateParams;

    ctrl.init();
}]);

'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderPeopleCtrl', ['$scope', '$state', '$stateParams', 'TenantService', function($scope, $state, $stateParams, tenantService) {
    var self = this;
    $scope.config = { id: $stateParams.streamId, target: 'people' };

    $scope.$watch('config.target', function() {
        $state.go($state.current.name, {id: $scope.config.id, tab: $scope.config.target}, { notify: false });
    });

    $scope.init = function(){
        tenantService.getCurrentTenant()
        .then(function(tenantRes){
            self.tenant = tenantRes.data;
        });
    };

    $scope.init();
}]);
'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderRelatedTopicsCtrl', ['$stateParams', 'StreamService', function($stateParams, streamService) {
    var self = this;

    this.init = function(){
        self.fetching = true;
        self.paging = {};

        streamService.getStreamTopics($stateParams.streamId, { rows: 1000 })
        .then(function(response){
            self.fetching = false;
            self.topics = response.content;
            self.paging.totalElements = response.totalElements;
            self.paging.first = response.first;
            self.paging.last = response.last;
        });
    };

    this.init();
}]);

'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderSeedContentSearch', ['_', '$q', '$state', '$stateParams', 'growl', 'Promise', 'PreviewService', 'StreamService', '$scope', '$uibModal', 'UtilService',
function(_, $q, $state, $stateParams, growl, Promise, PreviewService, StreamService, $scope, $uibModal, UtilService) {
    var ctrl = this;

    ctrl.init = function() {
        ctrl.usefulSearchTerms = [];
        ctrl.recommendedSources = [];
        ctrl.includedSources = [];
        ctrl.includedNewSources = [];
        ctrl.searchTerm = $stateParams.searchTerm || '';
    };

    $scope.$watch(function() { return ctrl.searchTerm; }, function(newVal) {
        if(!_.isEmpty(newVal)) {
            ctrl.search(newVal);
        }
    });

    ctrl.search = function(searchTerm) {
        this.fetchingRecommended = true;

        StreamService.getRecommendedStreams({
            includeCatalogs: !ctrl.restrictToSite,
            rows: 20,
            search: UtilService.cleanQuotes(searchTerm),
            type: 'item_search'
        })
        .then(function(searchRes) {
            ctrl.recommendedSources = searchRes.data.content;
            ctrl.fetchingRecommended = false;
        });
    };

    ctrl.toggleAddition = function(stream) {
        if(ctrl.streamIsSelected(stream.id)) {
            _.remove(ctrl.includedSources, { id: stream.id });
        } else {
            ctrl.usefulSearchTerms = _.uniq(_.union(ctrl.usefulSearchTerms, [UtilService.cleanQuotes(ctrl.searchTerm)]));
            ctrl.includedSources.push(stream);
        }
    };

    ctrl.streamIsSelected = function(streamId) {
        return _.some(ctrl.includedSources, { id: streamId });
    };

    ctrl.toggleNewSourceAddition = function(newSource) {
        if(ctrl.newSourceIsSelected(newSource)) {
            _.remove(ctrl.includedNewSources, { type: newSource.type, term: newSource.term });
        } else {
            ctrl.usefulSearchTerms = _.uniq(_.union(ctrl.usefulSearchTerms, [UtilService.cleanQuotes(ctrl.searchTerm)]));
            ctrl.includedNewSources.push(newSource);
        }
    };

    ctrl.newSourceIsSelected = function(newSource) {
        return _.some(ctrl.includedNewSources, { type: newSource.type, term: newSource.term });
    };

    ctrl.save = function() {
        var modalScope = $scope.$new();
        ctrl.usefulSearchTerms = _.uniq(_.union(ctrl.usefulSearchTerms, [ctrl.searchTerm]));
        modalScope.title = ctrl.usefulSearchTerms && ctrl.usefulSearchTerms.join(' ');
        modalScope.sources = _.union(ctrl.includedSources, ctrl.includedNewSources);

        var topicName;
        Promise.resolve($uibModal.open({
            templateUrl: '/templates/topicNameModal.html',
            size: 'md',
            keyboard: true,
            scope: modalScope
        }).result)
        .then(function(givenName) {
            topicName = givenName;
            ctrl.creatingStreams = true;
            return ctrl.includedNewSources;
        })
        .map(function(newSource) {
            return StreamService.getTenantStreams({
                includeCatalogs: true,
                rows: 20,
                term: newSource.term,
                type: newSource.type
            })
            .then(function(searchRes) {
                var exactMatchStream = StreamService.findMatchingStream(searchRes.data.content, newSource.term, { type: newSource.type });
                return exactMatchStream || UtilService.unwrap(StreamService.saveStream({
                    title: PreviewService.generateTitle(newSource),
                    type: newSource.type,
                    openForReading: true,
                    settings: {
                        search: newSource.type === 'RSS' ? undefined : newSource.term,
                        type: newSource.type === 'BING_SEARCH' ? 'NEWS' : undefined,
                        uri: newSource.type === 'RSS' ? newSource.term : undefined
                    }
                }));
            });
        })
        .then(function(newStreams) {
            return StreamService.createTopicWithSubstreams(topicName, _.map(_.union(ctrl.includedSources, newStreams), 'id'))
            .catch(function() {
                growl.error('Unable to create topic.');
            });
        })
        .then(function(stream){
            return _.isEmpty(ctrl.includedSources) && _.isEmpty(ctrl.includedNewSources) ?
                $state.go('editTopic.sources', { streamId: stream.id }) :
                $state.go('editTopic.filters', { streamId: stream.id, filterTerms: ctrl.usefulSearchTerms });
        });
    };

    ctrl.genTitle = PreviewService.generateTitle;

    ctrl.init();
}]);

'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderSyndicationCtrl', ['$scope', '$stateParams', function($scope, $stateParams) {
    // This controller is only here to jack in $scope.config.id that the briefing controller expects to inherit
    // from the controller chain.  This can go away if we bring love to the briefing controller someday
    $scope.config = { id: $stateParams.streamId };
}]);

'use strict';

angular.module('controllers.topicBuilder')
.controller('TopicBuilderUsageCtrl', ['_', '$stateParams', 'StreamService', 'TemplateService', function(_, $stateParams, streamService, templateService) {

    var self = this;

    this.init = function(){
        templateService.getAll()
        .then(function(results){
            self.templateMap = _.indexBy(results.data, 'id');
        });

        self.ongoingRequest = true;

        streamService.getBriefingsForStream($stateParams.streamId)
        .then(function(briefingsResponse){
            self.totalElements = briefingsResponse.totalElements;
            self.briefings = briefingsResponse.content;
            self.ongoingRequest = false;
        });
    };

    this.init();
}]);

'use strict';

angular.module('attensaApp')
.config(['$compileProvider', function($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
}]);

'use strict';

angular.module('attensaApp')
.directive('alerts', ['$interval', function ($interval) {
    return {
        restrict: 'E',
        replace: true,
        template: '<div id="alerts-container">' +
                    '<uib-alert ng-repeat="alert in alerts" type="{{alert.type}}" close="closeAlert($index)">{{alert.msg}}</uib-alert>' +
                  '</div>',
        scope: true,
        link: function (scope, element, attrs) {
            var watchFor = attrs.watchFor || 'alert';

            scope.alerts = [];

            scope.closeAlert = function($index) {
                scope.alerts.splice($index, 1);
            };

            scope.$on(watchFor, function (event, alert) {
                var alertExists = function (alert) {
                    var matchFound = false;
                    angular.forEach(scope.alerts, function(currentAlert) {
                        if (alert.type === currentAlert.type && alert.msg === currentAlert.msg) {
                            matchFound = true;
                        }
                    });
                    return matchFound;
                };

                if (attrs.suppressDuplicates === undefined || !alertExists(alert)) {
                    var newLength = scope.alerts.push(alert);
                    $interval(function() {
                        scope.alerts.splice((newLength-1), 1);
                    }, 6000, 1);
                }
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.component('analyticsChart', {
    bindings: {
        data: '=',
        labels: '=',
        summary: '='
    },
    transclude: true,
    template: [
        '<div class="chart-wrapper">',
            '<canvas class="chart chart-line" data="$ctrl.data" labels="$ctrl.labels"></canvas>',
            '<div class="chart-notes"><strong>{{$ctrl.summary}}</strong></div>',
        '</div>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('analyticResult', {
    bindings: {
        label: '@',
        quantity: '=',
        isSelected: '=',
        onSelect: '&',
        wrapperClass: '@'
    },
    transclude: true,
    template: [
        '<div ng-class="$ctrl.wrapper">',
            '<div class="chart-wrapper">',
                '<div class="analytics-badge"><span class="analytics-badge-number">{{$ctrl.quantity}}</span><br>{{$ctrl.label}}</div>',
                '<div class="chart-notes">',
                    '<a ng-click="$ctrl.onSelect()">{{$ctrl.isSelected ? \'Graph displayed\' : \'Display graph\'}}</a>',
                '</div>',
            '</div>',
        '</div>'
    ].join('\n'),
    controller: [function(){
        this.$onInit = function(){
          this.wrapper = this.wrapperClass || 'col-sm-4 col-lg-3';
        };
    }]
});

'use strict';

angular.module('attensaApp')
.directive('focusMe', ['$interval', function($interval) {
    return {
        scope: { trigger: '=focusMe' },
        link: function(scope, element) {
            scope.$watch('trigger', function(value) {
                if(value === true) {
                    $interval(function() {
                        element[0].focus();
                        scope.trigger = false;
                    }, 0, 1);
                }
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
    .directive('fullHeight', ['$window', '$document', '$timeout', function ($window, $document, $timeout) {
        return {
            restrict: 'A',
            scope: {
                footerElementId: '@',
                additionalPadding: '@',
                debounceWait: '@'
            },
            link: function (scope, element, attrs) {
                if (scope.debounceWait === 0) {
                    angular.element($window).on('resize', onWindowResize);
                } else {
                    // allow debounce wait time to be passed in.
                    // if not passed in, default to a reasonable 250ms
                    angular.element($window).on('resize', debounce(onWindowResize, scope.debounceWait || 250));
                }

                onWindowResize();

                // returns a fn that will trigger 'time' amount after it stops getting called.
                function debounce(fn, time) {
                    var timeout;
                    // every time this returned fn is called, it clears and re-sets the timeout
                    return function() {
                        var context = this;
                        // set args so we can access it inside of inner function
                        var args = arguments;
                        var later = function() {
                            timeout = null;
                            fn.apply(context, args);
                        };
                        $timeout.cancel(timeout);
                        timeout = $timeout(later, time);
                    };
                }

                function onWindowResize() {
                    var footerElement = angular.element($document[0].getElementById(scope.footerElementId));
                    var footerElementHeight;

                    if (footerElement.length === 1) {
                        footerElementHeight = footerElement[0].offsetHeight +
                            getTopMarginAndBorderHeight(footerElement) + getBottomMarginAndBorderHeight(footerElement);
                    } else {
                        footerElementHeight = 0;
                    }

                    var elementBottomMarginAndBorderHeight = getBottomMarginAndBorderHeight(element);

                    var additionalPadding = scope.additionalPadding || 0;

                    var elementHeight = $window.innerHeight - elementBottomMarginAndBorderHeight -
                        footerElementHeight - additionalPadding;

                    element.css('height', elementHeight + 'px');
                }

                function getTopMarginAndBorderHeight(element) {
                    var footerTopMarginHeight = getCssNumeric(element, 'margin-top');
                    var footerTopBorderHeight = getCssNumeric(element, 'border-top-width');
                    return footerTopMarginHeight + footerTopBorderHeight;
                }

                function getBottomMarginAndBorderHeight(element) {
                    var footerBottomMarginHeight = getCssNumeric(element, 'margin-bottom');
                    var footerBottomBorderHeight = getCssNumeric(element, 'border-bottom-width');
                    return footerBottomMarginHeight + footerBottomBorderHeight;
                }

                function getCssNumeric(element, propertyName) {
                    return parseInt(element.css(propertyName), 10) || 0;
                }
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.directive('attentionRankFor', [function() {
    return {
        restrict: 'A',
        scope: {
            item: '=attentionRankFor'
        },
        link: function(scope, element) {
            element.addClass('rank-' + scope.item.attentionRank);
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('autofill', function() {
    return {
        link: function (scope, element, attrs) {
            if (('action' in attrs)) {
                element.on('submit', function(e) {
                    scope.form.$commitViewValue();
                    scope.form.$setSubmitted();
                    e.preventDefault();
                });
            }
        }
    };
});

'use strict';

angular.module('attensaApp')
.directive('blurHide', ['$interval', function($interval) {
    return {
        link: function(scope, element, attrs) {
            var useShow = !!attrs.ngShow;
            var useHide = !!attrs.ngHide;

            var count = 0;

            if(useShow || useHide) {
                element.focusin(function() {
                    count++;
                });

                element.focusout(function() {
                    $interval(function() {
                        count--;
                        if (count < 1) {
                            if (useShow) {
                                scope[attrs.ngShow] = false;
                            }
                            if (useHide) {
                                scope[attrs.ngHide] = true;
                            }
                        }
                    }, 0, 1);
                });
            }
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('blurMe', [function() {
    return {
        link: function(scope, element, attrs) {
            element.click(function(){
                element.blur();
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.component('briefingPublishButton', {
    bindings: {
        briefing: '=',
        group: '=',
        user: '=',
        subscriptionChanged: '&'
    },
    transclude: true,
    template: [
        '<span uib-tooltip="{{$ctrl.displayTooltip(stream)}}" tooltip-append-to-body="true" show-with-permission action="MANAGE_TENANT" >',
            '<button id="toggle-subscribe-{{::$ctrl.briefing.id}}" ',
                    'ng-if="$ctrl.briefing.id" ',
                    'type="button" class="btn btn-default briefing-subscribe-button" ',
                    'tabstop="0" ng-click="$ctrl.togglePublish()" ',
                    'ng-class="{active: $ctrl.briefing.published }" blur-me>',
                '<span>{{$ctrl.briefing.published ? \'Unpublish\' : \'Publish\'}}</span>',
            '</button>',
        '</span>'
    ].join('\n'),
    controller: ['_', '$rootScope', 'BriefingService', function(_, $rootScope, briefingService) {
        var self = this;

        this.togglePublish = function(){
            self.briefing.published = !self.briefing.published;
            return briefingService.saveBriefing(self.briefing)
            .then(function(){
                $rootScope.$broadcast('published-change');
                self.subscriptionChanged();
            });
        };

        this.displayTooltip = function() {
            if (!self.briefing.published) {
                return 'Publish briefing';
            } else {
                return 'Unpublish briefing';
            }
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingSubscribeButton', {
    bindings: {
        briefing: '=',
        group: '=',
        user: '=',
        forceGroupCheck: '=',
        subscriptionChanged: '&'
    },
    transclude: true,
    template: `
        <span uib-tooltip="{{$ctrl.displayTooltip(stream)}}" tooltip-append-to-body="true">
            <button id="toggle-subscribe-{{::$ctrl.briefing.id}}"
                    ng-if="$ctrl.briefing.id && !$ctrl.subscribeStyle"
                    type="button" class="btn btn-default briefing-subscribe-button"
                    tabstop="0" ng-click="$ctrl.toggleSubscribe()"
                    ng-class="{active: $ctrl.isSubscribed(), disablePointerEvents: $ctrl.toggleSubscribePromise}"
                    ng-disabled="$ctrl.toggleSubscribePromise" blur-me>
                <span>{{$ctrl.isSubscribed() ? \'Unsubscribe\' : \'Subscribe\'}}</span>
            </button>
        </span>
    `,
    controller: ['_', '$rootScope', 'groupsService', 'UserService', function(_, $rootScope, groupService, userService) {
        
        this.isSubscribed = () => this.user && (!!_.find(this.user.subscriptions, { briefingId: this.briefing.id } ));

        this.toggleSubscribe = () => {
            const service = this.user ? userService : groupService;
            const method = this.isSubscribed() ? 'unsubscribeFromBriefing' : 'subscribeToBriefing';
            const item = this.user ? this.user : this.group;
            return service[method](item, this.briefing.id, this.briefing.streamId)
            .then(() => {
                $rootScope.$broadcast('subscribe-change');
                this.subscriptionChanged();
            });
        };

        this.displayTooltip = () => !this.isSubscribed() ? 'Subscribe to briefing' : 'Unsubscribe from briefing';

        this.$onInit = () => this.isGroupBasedSubscription = this.forceGroupCheck && !_.find(this.user.subscriptions, {briefingId: this.briefing.id});
    }]
});

'use strict';

angular.module('attensaApp')
.component('groupBriefingSubscribeButton', {
    bindings: {
        briefing: '=',
        group: '=',
        subscriptionChanged: '&'
    },
    transclude: true,
    template: `
        <span uib-tooltip="{{$ctrl.displayTooltip(stream)}}" tooltip-append-to-body="true">
            <button id="toggle-subscribe-{{::$ctrl.briefing.id}}"
                    ng-if="$ctrl.briefing.id && !$ctrl.subscribeStyle"
                    type="button" class="btn btn-default briefing-subscribe-button"
                    tabstop="0" ng-click="$ctrl.toggleSubscribe()"
                    ng-class="{active: $ctrl.isSubscribed(), disablePointerEvents: $ctrl.toggleSubscribePromise}"
                    ng-disabled="$ctrl.toggleSubscribePromise" blur-me>
                <span>{{$ctrl.isSubscribed() ? \'Unsubscribe\' : \'Subscribe\'}}</span>
            </button>
        </span>
    `,
    controller: ['_', '$rootScope', 'groupsService', 'UserService', function(_, $rootScope, groupService) {
        
        this.isSubscribed = () => _.find(this.group.subscriptions, {briefingId: this.briefing.id});

        this.toggleSubscribe = () => groupService[this.isSubscribed() ? 'unsubscribeFromBriefing' : 'subscribeToBriefing'](this.group, this.briefing.id, this.briefing.streamId)
        .then(() => {
            $rootScope.$broadcast('subscribe-change');
            this.subscriptionChanged();
        });

        this.displayTooltip = () => !this.isSubscribed() ? 'Subscribe to briefing' : 'Unsubscribe from briefing';
    }]
});

'use strict';

angular.module('attensaApp')
    .component('mdBriefingSubscribeButton', {
        bindings: {
            briefing: '=',
            user: '<',
            subscribed: '<',
            subscriptionChanged: '&'
        },
        transclude: true,
        template: [
            '<md-button  ng-if="$ctrl.user" aria-label="$ctrl.displayTooltip(briefing)" id="toggle-subscribe-{{::$ctrl.briefing.id}}" ',
                        'ng-if="$ctrl.briefing.id && !$ctrl.subscribeStyle" ',
                        'type="button" class="md-raised" ',
                        'tabstop="0" ng-click="$ctrl.toggleSubscribe()" ',
                        'ng-class="{ disablePointerEvents: $ctrl.toggleSubscribePromise }" ',
                        'blur-me>',
                '<md-tooltip>{{$ctrl.displayTooltip(briefing)}}</md-tooltip>',
                '<div style="text-transform: none; min-width:80px;">{{$ctrl.isSubscribed ? \'Unsubscribe\' : \'Subscribe\'}}</div>',
            '</md-button>',
            '<span ng-if="!$ctrl.user">Log in to subscribe</span>'
        ].join('\n'),
        controller: ['_', '$rootScope', 'UserService', function(_, $rootScope, userService) {
            var self = this;

            this.$onChanges = function(){
              self.isSubscribed = !!self.subscribed;
            };

            this.toggleSubscribe = function(){
                var method = self.isSubscribed ? 'unsubscribeFromBriefing' : 'subscribeToBriefing';
                return userService[method](self.user, self.briefing.id, self.briefing.streamId)
                .then(function(){
                    $rootScope.$broadcast('subscribe-change');
                    self.isSubscribed = !self.isSubscribed;
                    self.subscriptionChanged();
                });
            };

            this.displayTooltip = function() {
                if (!self.isSubscribed) {
                    return 'Subscribe to briefing';
                } else {
                    return 'Unsubscribe from briefing';
                }
            };
        }]
    });

'use strict';

angular.module('directives.categoryCard', []);

angular.module('directives.categoryCard')
.directive('categoryCard', ['growl', 'TaxonomyService', 'permissionService',
function(growl, TaxonomyService, permissionService) {
    return {
        scope: {
            catalogId: '@',
            category: '=',
            selectCategory: '&'
        },
        template: [
            '<div class="category-card clearfix">',
                '<a ng-click="selectCategory()">',
                    '<img ng-src="{{imageUrl}}" width="250" height="125">',
                '</a>',
                '<hr>',
                '<div class="media-body">',
                    '<h4 class="media-heading">',
                        '<div class="ellipsis-color">',
                            '<a class="overflow-ellipsis" style="width: 250px" ng-click="selectCategory()"><span class="stream-tile-title" >{{::category.title}}</span></a>',
                        '</div>',
                    '</h4>',
                    '<span><strong>{{::category.streamCount}}</strong> Topics and Sources</span>',
                    '<s3-upload ng-if="::hasPermissionToChangeImage" status="imageUploadStatus" inline="true"></s3-upload>',
                '</div>',
            '</div>'
        ].join('\n'),
        link: function(scope) {
            scope.imageUrl = scope.category.imageUrl ? scope.category.imageUrl : '/images/category_placeholder_2_1.jpg';
            scope.imageUploadStatus = { inProgress: false };

            var neededPermission = scope.catalogId ? 'MANAGE_CATALOG' : 'MANAGE_TENANT';
            permissionService.currentUserHasPermission({ action: neededPermission })
            .then(function(hasPermission) {
                scope.hasPermissionToChangeImage = scope.category.removable && hasPermission;
            });

            scope.$on('fileUploaded', function(evt, file) {
                scope.imageUrl = file.location;
                var saveImagePromise = scope.catalogId ?
                    TaxonomyService.postCatalogCategoryImageUrl(scope.catalogId, scope.category.id, scope.imageUrl) :
                    TaxonomyService.postTenantCategoryImageUrl(scope.category.id, scope.imageUrl);

                saveImagePromise
                .catch(function() {
                    growl.error('An error ocurred saving the category image.');
                });
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('catalogPublish', [function() {
    return {
        scope: {
            stream: '=',
            onChange: '&'
        },
        template: [
            '<strong style="vertical-align: top">Publish: </strong>',
            '<switch tooltip-placement="top" tooltip-popup-delay="500" tooltip-append-to-body="true"',
                'uib-tooltip="{{stream.published ? \'Remove from catalog\' : \'Publish to catalog\'}}"',
                'ng-model="stream.published" ng-change="onChange()" class="small" on="On" off="Off">',
            '</switch>'
        ].join('\n')
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('clickEvent', ['eventService', function(eventService) {
    return {
        restrict: 'A',
        link: function($scope, $element, $attrs){
            $element.bind('click', function() {
                var eventArgs;
                try {
                    eventArgs = JSON.parse($attrs.eventargs);
                } catch (e) {
                    eventArgs = {};
                }
                eventService.postEvent($attrs.eventname, eventArgs);
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('clickThroughItem', ['_', '$window', 'eventService', 'ItemService', function(_, $window, eventService, ItemService) {
    return {
        restrict: 'A',
        scope: {
            item: '=clickThroughItem',
            context: '@',
            topicStreamId: '@'
        },
        link: function(scope, element) {
            var buildEvent = function(item, stream) {
                return _.assign(eventService.formatItem(item), eventService.formatStream(stream));
            };

            element.bind('click', function() {
                ItemService.getStreamsRelatedToItem(scope.item, scope.topicStreamId)
                .then(function(relatedStreams) {
                    eventService.postEvent('item_source_link_clicked', buildEvent(scope.item, relatedStreams.source));
                    _.each(relatedStreams.topics, function(topic) {
                        eventService.postEvent('item_link_clicked', buildEvent(scope.item, topic));
                        eventService.postEvent('item_topic_link_clicked', buildEvent(scope.item, topic));
                    });
                });

                $window.open(scope.item.link, '_blank');
            });
        }
    };
}]);
'use strict';

angular.module('attensaApp')
.directive('createSourceCard', ['$uibModal',
    function($uibModal) {
        return {
            scope: {
                glyphClass: '@',
                logoImage: '@',
                streamType: '@',
                title: '@',
                preventSearch: '@',
                sourcesWereSelected: '&',
                existingSources: '='
            },
            template: [
            '<div class="create-stream-tile clearfix">',
                '<div class="media">',
                    '<div class="media-left">',
                        '<div class="icon-tile">',
                            '<span ng-if="::glyphClass" class="{{::glyphClass}}"></span>',
                            '<img ng-if="::logoImage" src={{::logoImage}}>',
                        '</div>',
                    '</div>',
                    '<div class="media-body">',
                        '<h4 class="media-heading">{{::title}}</h4>',
                        '<button class="btn btn-default" ng-click="start()"',
                            'click-event eventname="add_source_selected" eventargs=\'{"type": "{{streamType}}"}\')>Start</button>',
                    '</div>',
                '</div>',
            '</div>'
            ].join('\n'),
            link: function(scope) {
                scope.start = function() {
                    $uibModal.open({
                        templateUrl: '/templates/sourceCreation/sourceCreationModal.html',
                        controller: 'SourceCreationModalCtrl',
                        controllerAs: 'modalCtrl',
                        size: 'md',
                        keyboard: true,
                        resolve: {
                            streamType: function() {
                                return scope.streamType;
                            },
                            sourceTypeTitle: function() {
                                return scope.title;
                            },
                            existingSources: function() {
                                return scope.existingSources;
                            },
                            preventSearch: function(){
                                return scope.preventSearch;
                            }
                        }
                    }).result.then(function(sourceIdsToSubscribe) {
                        scope.sourcesWereSelected({ sourceIds: sourceIdsToSubscribe });
                    });
                };
            }
        };
    }]);

'use strict';

angular.module('attensaApp')
.directive('curateItemListHeader', ['_', '$rootScope',
    function(_, $rootScope) {
        return {
            scope: {
                stream: '=',
                items: '=',
                itemsDidChange: '&',
                itemCounts: '=',
                selectedFilter: '='
            },
            template: [
                '<div class="pull-left">',
                    '<ul class="nav">',
                        '<li class="pull-left">',
                            '<h5>',
                                '<span ng-if="itemCounts.displayedItemsCount < itemCounts.itemsCount">Showing {{itemCounts.displayedItemsCount | number }} of </span>',
                                '<span>{{itemCounts.itemsCount | number }} ',
                                    '<ng-pluralize count="itemCounts.itemsCount" when="{\'1\': \'article\', \'other\': \'articles\'}"></ng-pluralize>',
                                '</span>',
                            '</h5>',
                        '</li>',
                    '</ul>',
                '</div>',
                '<div class="pull-right" ng-if="::stream.type === \'COLLECTION\'">',
                    '<ul class="nav">',
                        '<li class="pull-right">',
                            '<stream-curate-control stream="stream" curate-setting-did-change="curationChanged()"></stream-curate-control>',
                        '</li>',
                        '<li class="pull-left" style="padding-right:25px; padding-top:5px;">',
                            '<item-curation-filter filter-did-change="itemsDidChange(filter)" selected-filter="selectedFilter"></item-curation-filter>',
                        '</li>',
                    '</ul>',
                '</div>'
            ].join('\n'),
            link: function (scope) {
                scope.curationChanged = function() {
                    scope.itemsDidChange({ params: _.assign({ page: 0 }, scope.selectedFilter ? scope.selectedFilter.params : {}) });
                    $rootScope.$broadcast('stream-changed', scope.stream);
                };

                scope.filterItems = function(selectedFilter) {
                    scope.itemsDidChange({ params: _.assign({ page: 0 }, scope.selectedFilter ? scope.selectedFilter.params : {}) });
                };
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.component('deleteStream', {
    bindings: {
        stream: '='
    },
    controller: ['$uibModal', '$rootScope', '$state', 'StreamService', 'growl', function($uibModal, $rootScope, $state, streamService, growl){
        var self = this;

        this.$onInit = function(){
            self.streamLabel = self.stream.type === 'COLLECTION' ? 'topic' : 'source';
        };

        this.deleteStream = function(){
          if(this.stream){
              $uibModal.open({
                  templateUrl: '/templates/deleteTopicWarningModal.html',
                  size: 'lg'
              }).result
              .then(function() {
                  streamService.deleteStream(self.stream.id)
                  .then(function() {
                      $rootScope.$broadcast('stream-deleted', self.stream.id);
                      $state.go('mytopics.recent');
                  })
                  .catch(function() {
                      growl.error('An error occurred deleting the stream and it may not have been deleted. Please refresh your browser.');
                  });
              });
          }
        };
    }],
    template: [
        '<strong><a ng-click="$ctrl.deleteStream()">Delete this {{$ctrl.streamLabel}}</a></strong>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('readStream', {
    bindings: {
        stream: '<'
    },
    controller: [function(){
        var self = this;

        this.$onChanges = function(){
            self.streamLabel = self.stream.type === 'COLLECTION' ? 'topic' : 'source';
        };
    }],
    template: [
        '<strong><a ui-sref="topic({ streamId: $ctrl.stream.id })">Read this {{$ctrl.streamLabel}}</a></strong>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.directive('editStreamEmailAddress', ['_', 'TenantService', function(_, TenantService) {
    return {
        scope: {
            stream: '=',
            onChange: '&'
        },
        template: [
            '<form class="form-inline" editable-form name="emailPublishingForm" onbeforesave="checkEmailAddress(emailPublishingForm)" onaftersave="saveEmailChange()" id="edit-email-form">',
                '<button id="email-publishing-toggle-button" type="button" ng-click="toggleEmailEnable(emailPublishingForm);" class="btn btn-default" ng-class="{\'active\': stream.emailPostingEnabled}" blur-me>',
                    '{{stream.emailPostingEnabled ? \'On\' : \'Off\'}}',
                '</button>',
                '<div class="form-group" ng-if="stream.emailPostingEnabled" ng-hide="emailPublishingForm.$visible">',
                    '<span class="email-publishing-address" ng-hide="emailPublishingForm.$visible">',
                        '&nbsp; &nbsp; {{ stream.settings.uri }}',
                    '</span>',
                    '&nbsp;',
                    '<a id="email-publishing-edit-link" ng-click="emailPublishingForm.$show()" ng-hide="emailPublishingForm.$visible" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>',
                '</div>',
                '<div class="form-group" ng-show="emailPublishingForm.$visible">',
                    '<div ng-if="stream.emailPostingEnabled">',
                        '<div class="input-group">',
                            '<input type="text" class="form-control" id="stream-email-address" name="streamEmailAddress" placeholder="Email prefix" ng-model="email.prefix" validate-stream-email valid-email-prefix no-spaces too-long="25" current-stream-source-id="::stream.sourceId" email-domain="email.domain" required>',
                            '<span id="streamEmailDomain" class="input-group-addon">@{{email.domain}}</span>',
                        '</div>',
                    '</div>',
                '</div>',
                '<div class="editable-buttons form-group" ng-show="emailPublishingForm.$visible && stream.emailPostingEnabled">',
                    '<button id="email-publishing-form-submit" type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span></button>',
                    '<button type="button" class="btn btn-default" ng-click="emailPublishingForm.$cancel()"><span class="glyphicon glyphicon-remove"></span></button>',
                '</div>',
                '<div class="has-error form-group" ng-if="badEmailAddress && emailPublishingForm.$visible">',
                    '<small class="help-block">{{badEmailAddress.message}}</small>',
                '</div>',
            '</form>'
        ].join('\n'),
        link: function(scope) {
            var init = function () {
                return TenantService.getCurrentTenant()
                .then(function (tenant) {
                    scope.email = {
                        domain: tenant.data.settings.streamsEmailDomain,
                        prefix: _.has(scope.stream, 'settings.uri') ?
                            scope.stream.settings.uri.substr(0, scope.stream.settings.uri.indexOf('@')) : ''
                    };
                });
            };

            scope._setEmailSettingsOnStream = function () {
                if (scope.email.prefix && scope.stream.emailPostingEnabled) {
                    scope.stream.settings.uri = scope.email.prefix + '@' + scope.email.domain;
                } else {
                    delete scope.stream.settings.uri;
                }
            };

            scope._setFormVisibility = function(emailPublishingForm, emailPostingIsEnabled) {
                return emailPostingIsEnabled ? emailPublishingForm.$show() : emailPublishingForm.$hide();
            };

            scope.saveEmailChange = function() {
                scope._setEmailSettingsOnStream();
                scope.onChange();
            };

            scope.toggleEmailEnable = function(emailPublishingForm) {
                scope.stream.emailPostingEnabled = !scope.stream.emailPostingEnabled;
                scope._setEmailSettingsOnStream();
                scope._setFormVisibility(emailPublishingForm, scope.stream.emailPostingEnabled);
                scope.onChange();
            };

            scope.checkEmailAddress = function(emailPublishingForm) {
                if (emailPublishingForm.streamEmailAddress.$invalid) {
                    if (emailPublishingForm.streamEmailAddress.$error.validEmailPrefix) {
                        scope.badEmailAddress = {
                            message: 'Only type the part of the email address before the @ symbol.'
                        };
                    } else if (emailPublishingForm.streamEmailAddress.$error.uniqueStreamEmail) {
                        scope.badEmailAddress = {
                            message: 'The email address you have entered is already in use.'
                        };
                    } else if (emailPublishingForm.streamEmailAddress.$error.tooLong) {
                        scope.badEmailAddress = {
                            message: 'Email address prefix must be shorter than 25 characters.'
                        };
                    } else if (emailPublishingForm.streamEmailAddress.$error.noSpaces) {
                        scope.badEmailAddress = {
                            message: 'The email address prefix cannot contain a space.'
                        };
                    }
                } else {
                    scope.badEmailAddress = {
                        message: null
                    };
                }
                return scope.badEmailAddress.message;
            };

            init();
        }
};
}]);

'use strict';

angular.module('attensaApp')
.directive('editStreamOwner', ['$rootScope', '$uibModal', function($rootScope, $uibModal) {
    return {
        scope: {
            stream: '=',
            onChange: '&'
        },
        template: [
        '<div class="form-control-static">',
            '{{stream.owner.firstName}} {{stream.owner.lastName}} (<a href="mailto:{{stream.owner.emailAddress}}">{{stream.owner.emailAddress}}</a>)',
            '<a id="edit-owner-link" ng-click="changeStreamOwner()" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>',
        '</div>',
        ].join('\n'),
        link: function(scope) {
            scope.changeStreamOwner = function() {
                var modalScope = $rootScope.$new();
                modalScope.config = {
                    id: scope.stream.id
                };
                modalScope.stream = scope.stream;

                $uibModal.open({
                    templateUrl: '/templates/changeStreamOwnerModal.html',
                    controller: 'StreamPeopleCtrl',  //FIXME: Makes me sad as shit this is sharing a controller with the stream people tab
                    size: 'lg',
                    keyboard: false,
                    backdrop: 'static',
                    scope: modalScope
                }).result
                .then(function(userSelected) {
                    scope.stream.owner = userSelected;
                    scope.stream.ownerId = userSelected.id;
                    scope.onChange();
                });
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('editStreamDescription', [function() {
    return {
        scope: {
            stream: '=',
            onChange: '&'
        },
        template: [
            '<div class="form-control-static" id="stream-description-form">',
                '<h5 id="stream-basic-description"',
                    'class="overflow-ellipsis" onaftersave="onChange()" e-form="descForm" e-style="min-width: 30em" editable-textarea="stream.description" e-rows="3">',
                    '<a id="edit-description-link" ng-click="descForm.$show()" ng-hide="descForm.$visible" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>',
                    '{{ stream.description || \'Add a description\' }}',
                '</h5>',
            '</div>'
        ].join('\n')
    };
}]);
'use strict';

// TODO: ARRRRR mateys!  Enter at your own risk.  This directive just be here for the legacy modal streambuilder.  Once
// that be gone, this can walk the plank.
angular.module('attensaApp')
.directive('editStreamDescriptionForModal', [function() {
    return {
        scope: {
            stream: '=',
            onChange: '&'
        },
        template: [
            '<div class="form-control-static">',
                '<div id="stream-basic-description" onaftersave="onChange()" e-form="descForm" e-style="min-width: 30em" editable-textarea="stream.description" e-rows="3">',
                    '{{ stream.description || \'Add a description\' }}',
                '</div>',
                '&nbsp;',
                '<a id="edit-description-link" ng-click="descForm.$show()" ng-hide="descForm.$visible" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>',
            '</div>'
        ].join('\n')
    };
}]);
'use strict';

angular.module('attensaApp')
.directive('editStreamSource', ['_', 'StreamService', 'StreamBuilderService', 'TOPIC_TAGS', function(_, StreamService, StreamBuilderService, TOPIC_TAGS) {
    return {
        scope: {
            stream: '='
        },
        template: [
            '<div class="form-control-static source-preview">',
                '<span ng-if="::stream.settings.uri && stream.type !== \'FACTIVA_SELECT_HTTP\'">URL:',
                    '<a id="stream-link" href="{{stream.settings.uri}}" target="_blank">{{stream.settings.uri}}</a>',
                '</span>',
                '<span ng-if="::stream.settings.search">Search: {{stream.settings.search}}</span>',
                '<span ng-if="::stream.settings.username">CustomerId: {{extractFactivaCustomerId(stream.settings.username)}}</span>',
                '<span class="btn-group btn-group-xs tag-buttons tag-btn-group user-tag-button-group ng-scope" ng-repeat="tag in stream.settings.searchConfiguration.tags">',
                    '<button type="button" class="btn btn-default tag-button user-tag-button">',
                        '{{tag.type === \'topics\' ? topicTagDisplayText(tag.tagText) : tag.tagText}}',
                    '</button>',
                '</span>',
                '&nbsp;',
                '<a id="edit-uri-link" ng-if="::stream.tenantId || stream.settings.uri" ng-click="editSource(stream.type, stream.id)" style="border-bottom: none;">',
                    '<i class="fa fa-pencil-square-o"></i>',
                '</a>',
                '<br>',
                '<span ng-if="::stream.settings.uri && stream.type === \'FACTIVA_SELECT_HTTP\'">Folder: {{extractFactivaFolder(stream.settings.uri)}}</span>',
                '<span ng-if="::stream.settings.type">Type: {{stream.settings.type}}</span>',
            '</div>'
        ].join('\n'),
        link: function(scope) {
            scope.editSource = function(streamType, streamId) {
                StreamBuilderService.open(streamType, streamId, true)
                .result.then(function(updateResults) {
                    _.assign(scope.stream, updateResults);
                });
            };

            scope.topicTagDisplayText = function(tagText) {
                return _.find(TOPIC_TAGS, { tagText: tagText }).displayText;
            };

            scope.extractFactivaCustomerId = StreamService.extractFactivaCustomerId;
            scope.extractFactivaFolder = StreamService.extractFactivaFolder;
            scope.targetMap = StreamBuilderService.streamTypeToEditorTargetMap;
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('editStreamTitle', [function() {
    return {
        scope: {
            stream: '=',
            onChange: '&'
        },
        template: [
            '<form name="titleForm" shown="false" editable-form id="stream-title-form">',
                '<h3 class="overflow-ellipsis"',
                    'onaftersave="onChange()"',
                    'editable-text="stream.title"',
                    'e-name="title" e-required e-size="75">',
                    '<a id="edit-title-link" ng-click="titleForm.$show()" ng-hide="titleForm.$visible"',
                        'style="border-bottom: none;">',
                        '<i class="fa fa-pencil-square-o"></i>',
                    '</a>',
                    '{{ stream.title }}',
                '</h3>',
                '<span class="editable-buttons" ng-show="titleForm.$visible">',
                    '<button id="title-form-submit" type="submit"',
                        'class="btn btn-primary btn-xs">',
                        '<span class="glyphicon glyphicon-ok"></span>',
                    '</button>',
                    '<button type="button" class="btn btn-default btn-xs"',
                        'ng-click="titleForm.$cancel()">',
                        '<span class="glyphicon glyphicon-remove"></span>',
                    '</button>',
                '</span>',
            '</form>'
        ].join('\n')
    };
}]);
'use strict';

angular.module('attensaApp')
.directive('enterKey', function() {
    return function(scope, element, attrs) {

        element.bind('keydown keypress', function(event) {
            // If enter key is pressed
            if ((event.which || event.keyCode) === 13) {
                scope.$apply(function() {
                        // Evaluate the expression
                    scope.$eval(attrs.dlEnterKey);
                });

                event.preventDefault();
            }
        });
    };
});
'use strict';

angular.module('attensaApp').
directive('exportToCsv', ['$document', '$interval', '$q', 'Papa',
function ($document, $interval, $q, Papa) {
    return {
        restrict: 'A',
        scope: {
            filename: '@',
            formatData: '&'
    },
    link: function (scope, element, attrs) {
        var toCSV = function(objectToConvert) {
            return $q.when(objectToConvert)
            .then(function(resolvedObject) {
                return Papa.unparse(resolvedObject);
            });
        };

        var exportCSV = function() {
            return toCSV(scope.formatData())
            .then(function(csv) {
                var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                var filename = scope.filename || 'data';

                // I for one welcome our MSIE overlords
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename);
                } else {
                    var downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', window.URL.createObjectURL(blob));
                    downloadLink.attr('download', filename);
                    downloadLink.attr('target', '_blank');

                    $document.find('body').append(downloadLink);
                    $interval(function () {
                        downloadLink[0].click();
                        downloadLink.remove();
                    }, null, 1);
                }
            });

        };

        element.bind('click', function (e) {
            exportCSV();
            scope.$apply();
        });
    }};
 }]);

'use strict';

angular.module('attensaApp')
    .directive('fetchInsurance', ['$window', '$document', function($window, $document) {
        return {
            link: function(scope, element, args) {
                var referenceHeight = $window.innerHeight;
                var heightInsurance = 10; //This is used to make sure that the numbers do not end up exact

                if(args.fetchInsuranceReference && $document[0].querySelector(args.fetchInsuranceReference)){
                    referenceHeight = angular.element($document[0].querySelector(args.fetchInsuranceReference)).innerHeight() + heightInsurance ;
                }

                scope.$watchCollection(args.fetchInsurance, function(){
                    if(referenceHeight > element.innerHeight()){
                        scope.$evalAsync(args.fetchInsuranceFetchRequired);
                    }
                });
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.directive('followButton', ['_', '$rootScope', '$http', 'growl', 'eventService', 'TenantService', 'UserService', 'UtilService',
function(_, $rootScope, $http, growl, eventService, tenantService, userService, utilService) {
    return {
        restrict: 'E',
        scope: {
            stream: '=',
            user: '=',
            type: '@',
            followStyle: '@'
        },
        template: `
            <div ng-if="!noFollowing" uib-tooltip="{{displayTooltip()}}" tooltip-append-to-body="true" style="display: inline-flex">
                <button id="toggle-follow-{{::stream.id}}" 
                        ng-if="type === 'stream' && followStyle === 'primary'" 
                        type="button" 
                        class="btn btn-primary stream-subscribe-button" 
                        tabstop="0" 
                        ng-click="toggleFollow(stream, user, type)" 
                        ng-class="{active: stream.userIsFollowing, disablePointerEvents: stream.userSubscriptionIsRestricted || toggleFollowPromise }" 
                        ng-disabled="stream.userSubscriptionIsRestricted || toggleFollowPromise || followingBlocked" 
                        blur-me>
                    {{stream.userIsFollowing ? 'Unfollow' : 'Follow'}}
                </button>
                <button id="toggle-follow-{{::stream.id}}" 
                        ng-if="type === 'stream' && followStyle !== 'primary'" 
                        type="button" 
                        class="btn btn-default stream-subscribe-button" 
                        tabstop="0" 
                        ng-click="toggleFollow(stream, user, type)" 
                        ng-class="{active: stream.userIsFollowing, disablePointerEvents: stream.userSubscriptionIsRestricted || toggleFollowPromise }" 
                        ng-disabled="stream.userSubscriptionIsRestricted || toggleFollowPromise || followingBlocked" 
                        blur-me>
                    {{stream.userIsFollowing ? 'Unfollow' : 'Follow'}}
                </button>
                <button ng-if="type === 'user'" 
                        type="button" 
                        class="btn btn-default" 
                        tabstop="0" 
                        ng-click="toggleFollow(stream, user, type)" 
                        ng-class="{active: user.userIsFollowing, disablePointerEvents: user.userSubscriptionIsRestricted || toggleFollowPromise }" 
                        ng-disabled="user.userSubscriptionIsRestricted || toggleFollowPromise || followingBlocked" 
                        blur-me>
                    {{user.userIsFollowing ? 'Unfollow' : 'Follow'}}
                </button>
                <span ng-if="followingBlocked" style="padding-top: 8px; padding-left: 4px; float: right;">
                    <md-tooltip>This product has reached the maximum of {{stream.maxStreamSubscribers}} users.</md-tooltip>
                    <i style="color: red;" class="fa fa-exclamation-circle"></i>                    
                </span>
            </div>`,
        link: function($scope) {
            $scope.$watch(() => {
                $scope.followingBlocked = $scope.stream && 
                                          $scope.stream.type === 'PRODUCT_SOURCE' && 
                                          $scope.stream.streamSubscribersCount >= $scope.stream.maxStreamSubscribers && 
                                          !($scope.stream.userIsFollowing || $scope.stream.userHasStreamSubscriberRole);
            });

            tenantService.getCurrentTenant()
            .then(function(tenant){
                $scope.noFollowing = tenant.data.settings.noFollowing;
            });

            $scope.displayTooltip = function() {
                if($scope.type === 'user' && !_.isEmpty($scope.user)) {
                    return utilService.tooltipManager($scope.user);
                } else if(!_.isEmpty($scope.stream)) {
                    return utilService.tooltipManager($scope.stream);
                }
            };

            $scope.toggleFollow = function(stream, user, type) {
                var wasFollowing = type === 'user' ? user.userIsFollowing : stream.userIsFollowing;
                var wasSubscribed = type === 'user' ? user.userIsSubscribed : stream.userIsSubscribedToBriefing;

                if(!$scope.toggleFollowPromise) {
                    if(!wasFollowing){
                        eventService.postEvent('followed', { streamId: stream.id});
                    }
                    $scope.toggleFollowPromise = userService.setFollowing(stream.id, user.id, {
                        follow: !wasFollowing,
                        subscribe: false
                    })
                    .then(function() {
                        _.assign(user, getNewUserProps(user, wasFollowing, type));
                        _.assign(stream, getNewStreamProps(stream, wasFollowing, wasSubscribed, type));
                        
                        if (!wasFollowing && !stream.openForReading) {
                            $http.post('/ws/user/' + user.id + '/streamRoles/', 
                                { params: { streamId: stream.id, roleType: 'STREAM_SUBSCRIBER' } })
                            .then(response => {
                                stream.streamSubscribersCount++;
                                user.reader = true;
                                $rootScope.$broadcast('follow-change', {
                                    user: user,
                                    stream: stream,
                                    followStatusChanged: true
                                });
                            });
                        } else {
                            $rootScope.$broadcast('follow-change', {
                                user: user,
                                stream: stream,
                                followStatusChanged: true
                            });
                        } 
                    })
                    .catch(function() {
                        growl.error('An error occurred attempting to update follow status.');
                    })
                    .finally(function() {
                        $scope.toggleFollowPromise = null;
                    });
                }
            };

            var getNewUserProps = function(user, wasFollowing, type) {
                return type === 'user' ?
                    {
                        userIsFollowing: !wasFollowing,
                        userIsSubscribed: false
                    } : user;
            };

            var getNewStreamProps = function(stream, wasFollowing, wasSubscribed, type) {
                return type === 'user' ?
                    {
                        followersCount: wasFollowing ? stream.followersCount - 1 : stream.followersCount + 1,
                        subscribersCount: wasSubscribed ? stream.subscribersCount - 1 : stream.subscribersCount
                    } :
                    {
                        followersCount: wasFollowing ? stream.followersCount - 1 : stream.followersCount + 1,
                        subscribersCount: wasSubscribed ? stream.subscribersCount - 1 : stream.subscribersCount,
                        userIsFollowing: !wasFollowing,
                        userIsSubscribedToBriefing: false
                    };
            };
        }
    };
}]);

/* jshint scripturl: true, strict: false */

angular.module('attensaApp')
.directive('a', [function() {
    return {
        link: function(scope, element, attrs) {
            var href = element.attr('href');
            if(href && href === 'javascript:void(0)'){
                element.removeAttr('href');
            }
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('stateHelp', ['$rootScope', '$state', '_', 'TenantService',
    function($rootScope, $state, _, tenantService) {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            template: '<a ng-show="helpLink && !hideHelp" href="{{helpLink}}" style="padding-bottom: 5px;" title="{{helpTitle}}" target="_blank"><i style="font-size: 25px;" class="glyphicon glyphicon-question-sign"></i></a>',
            link: function (scope) {
                var helpMap;

                var setHelp = function(){
                    if (helpMap) {
                        var config = _.find(helpMap, { state: $state.href($state.current.name) }) || _.find(helpMap, { state: 'DEFAULT' });
                        scope.helpLink = config.url;
                        scope.helpTitle = config.title;
                    }
                };

                tenantService.getUnauthTenantInfo()
                .then(function(response) {
                    scope.hideHelp = response.data.settings.hideHelp === 'true'; 
                    helpMap = response.data.settings.helpConfiguration ? response.data.settings.helpConfiguration : {};
                    setHelp();
                });

                $rootScope.$on('$stateChangeSuccess', setHelp);
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.directive('iframeOnload', ['$rootScope', function($rootScope){
    return {
        scope: {
            callBack: '&iframeOnload'
        },
        link: function(scope, element, attrs){
            element.on('load', function(){
                return $rootScope.$apply(scope.callBack());
            });
        }
    };
}]);
'use strict';

angular.module('attensaApp')
.component('includingTopicsList', {
    bindings: {
        topics: '<'
    },
    template: [
        '<ul class="sources-list">',
            '<li class="source-list animated-list" ng-repeat="topic in $ctrl.topics">',
                '<h5><stream-type-indicator stream="topic"></stream-type-indicator> {{::topic.title || $ctrl.genTitle(topic)}}</h5>',
                '<div class="action-links pull-right">',
                    '<span ng-if="topic.tenantId"><a ui-sref="editTopic.sources({ streamId: topic.id })">Edit</a> / </span>',
                    '<span><a ng-click="$ctrl.previewTopic(topic.id)")>Preview</a> / </span>',
                    '<a ui-sref="topic({ streamId: topic.id })">Read</a>',
                '</div>',
                '<item-preview-list uib-collapse="$ctrl.previewIsHidden(topic.id)" items="$ctrl.previewItems[topic.id]"></item-preview-list>',
                '<div uib-collapse="$ctrl.previewIsHidden(topic.id)" ng-if="!$ctrl.previewIsHidden(topic.id) && $ctrl.previewItems[topic.id].length === 0">',
                    '<source-list-no-results></source-list-no-results>',
                '</div>',
            '</li>',
        '</ul>'
    ].join('\n'),
    controller: ['ItemService', 'PreviewService', function(itemService, previewService){
        var self = this;
        this.previewItems = {};

        this.previewTopic = function(streamId) {
            if(!self.previewIsHidden(streamId)) {
                self.previewedStreamId = null;
            } else {
                return itemService.searchItemsInStream({ streamId: streamId, rows: 10 })
                .then(function(searchRes) {
                    self.previewItems[streamId] = searchRes.data.content;
                    self.previewedStreamId = streamId;
                });
            }
        };

        this.previewIsHidden = function(streamId) {
            return streamId !== self.previewedStreamId;
        };

        this.genTitle = previewService.generateTitle;
    }]
});

'use strict';

angular.module('attensaApp')
.directive('input', [function() {
    var getControl = function(el){
        if(el.parent() && el.parent().controller('form')){
            return el.parent().controller('form')[el.attr('name')];
        }
        return null;
    };

    return {
        restrict: 'E',
        link: function(scope, el, attr, ctrl) {

            if(!scope.safeApply) {
                scope.safeApply = function (fn) {
                    var phase = this.$root.$$phase;
                    if (phase === '$apply' || phase === '$digest') {
                        if (fn && (typeof(fn) === 'function')) {
                            fn();
                        }
                    } else {
                        this.$apply(fn);
                    }
                };
            }

            //This takes care of chromes reluctance to provide the value to the model if it is invalid
            if (typeof el.prop('validity') !== 'undefined'){
                el.bind('input', function(e) {
                    var validity = el.prop('validity');
                    scope.safeApply(function() {
                        var control = getControl(el);
                        if(control) {
                            getControl(el).$setValidity('badInput', !validity.badInput);
                        }
                    });
                });
            }

            el.bind('blur', function() {
                el.removeClass('has-focus');
                el.addClass('has-visited');

                scope.safeApply(function () {
                    var control = getControl(el);
                    if(control){
                        control.$hasFocus = false;
                        control.$hasVisited = true;
                    }
                });
            });

            el.bind('focus', function() {
                scope.safeApply(function () {
                    var control = getControl(el);
                    if(control) {
                        control.$hasFocus = true;
                    }
                });
            });

            var control = getControl(el);
            if(control) {
                var originalSetPristine = getControl(el).$setPristine;
                getControl(el).$setPristine = function () {
                    el.removeClass('has-focus');
                    el.removeClass('has-visited');
                    getControl(el).$hasFocus = false;
                    getControl(el).$hasVisited = false;
                    originalSetPristine.apply(getControl(el), arguments);
                };
            }

            el.parent('form').on('submit', function () {
                el.addClass('has-visited');

                scope.safeApply(function () {
                    var control = getControl(el);
                    if(control){
                        getControl(el).$hasFocus = false;
                        getControl(el).$hasVisited = true;
                    }
                });
            });

        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('initialViewVisible', ['$rootScope', '$state', 'locker', 'UserService', function($rootScope, $state, locker, userService) {
    return {
        link: function(scope, element, attrs) {
            var check = function(){
                userService.getCurrentUser()
                .then(function(response){
                    var noSubscriptions = !response.data.user || response.data.user.subscriptions.length === 0;
                    var alreadyViewed = true;// locker.get(attrs.targetState + '-viewed') === 'true';
                    var isTargetState = $state.is(attrs.targetState);
                    var initialViewVisible = attrs.initialViewVisible && attrs.initialViewVisible.toLowerCase() === 'true';
                    // if (!alreadyViewed) {
                    //     locker.put(attrs.targetState + '-viewed', 'true');
                    // }

                    if ((noSubscriptions || !alreadyViewed) && isTargetState && !initialViewVisible) {
                        element.hide();
                    } else if(!isTargetState && initialViewVisible){
                        element.hide();
                    } else if (!(noSubscriptions || !alreadyViewed) && isTargetState && initialViewVisible) {
                        element.hide();
                    }else{
                        element.show();
                    }
                });
            };

            $rootScope.$on('$stateChangeSuccess', check);

            check();
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('itemCurationFilter', ['_',
    function(_) {
        return {
            scope: {
                initialFilter: '=',
                selectedFilter: '=',
                filterDidChange: '&'
            },
            template: [
                '<ul>',
                    '<li class="dropdown checked-dropdown" uib-dropdown>',
                        '<a uib-dropdown-toggle>',
                            '<span class="dropdown-label">{{selectedFilter.label}}</span><span class="caret"></span>',
                        '</a>',
                        '<ul class="dropdown-menu">',
                            '<li ng-repeat="filter in itemFilters track by filter.label">',
                                '<span ng-show="selectedFilter === filter"><i class="fa fa-check"></i> {{::filter.label}}</span>',
                                '<a ng-hide="selectedFilter === filter" ng-click="filterItems(filter)">{{::filter.label}}</a>',
                            '</li>',
                        '</ul>',
                    '</li>',
                '</ul>'
            ].join('\n'),
            link: function (scope) {
                var init = function() {
                    scope.itemFilters = [
                        {
                            label: 'All',
                            params: {
                                displayedOnly: false,
                                hiddenOnly: false
                            }
                        },
                        {
                            label: 'Displayed',
                            params: {
                                displayedOnly: true,
                                hiddenOnly: false
                            }
                        },
                        {
                            label: 'Hidden',
                            params: {
                                displayedOnly: false,
                                hiddenOnly: true
                            }
                        }
                    ];
                    scope.selectedFilter = scope.getFilterByLabel(scope.initialFilter || 'All');
                };

                scope.getFilterByLabel = function(label) {
                    return _.find(scope.itemFilters, { label: label });
                };

                scope.filterItems = function(selectedFilter) {
                    scope.selectedFilter = selectedFilter;
                    scope.filterDidChange({ filter: selectedFilter });
                };

                init();
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.directive('itemList', ['ItemService',
    function(ItemService) {
        return {
            scope: {
                stream: '=',
                items: '=',
                itemCounts: '='
            },
            template: [
            '<div id="reading-table" class="position-relative" ng-if="items.length">',
                '<div class="reading-item animated-list" ng-repeat="item in items track by item.id" >',
                    '<div class="rich-list-link rich-list-item-read">',
                        '<div class="rich-list-item-group" ng-style="{\'opacity\' : !item.visible && stream.type === \'COLLECTION\' ? 0.5 : .99}">',
                            '<a ng-if="::stream.type === \'COLLECTION\'" ng-click="toggleItemVisibility(item)" class="eye-of-sauron" uib-tooltip="{{item.visible ? \'Hide item\' : \'Expose item\'}}" tooltip-append-to-body="true"><i class="fa fa-eye-slash fa-lg"></i>&nbsp;</a>',
                            '<a class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{item.title}}" ng-click="openReadingModal({ itemId: item.id, streamContext: stream.id })">{{item.title}}</a>',
                            '<div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="item.publishedDate"></div>',
                        '</div>',
                    '</div>',
                '</div>',
            '</div>'
            ].join('\n'),
            link: function (scope) {
                scope.openReadingModal = ItemService.openNewModal;

                scope.toggleItemVisibility = function(item) {
                    item.visible = !item.visible;
                    scope.itemCounts.hiddenItemCounts = item.visible ? scope.itemCounts.hiddenItemCounts - 1 : scope.itemCounts.hiddenItemCounts + 1;
                    scope.itemCounts.displayedItemsCount = item.visible ? scope.itemCounts.displayedItemsCount + 1 : scope.itemCounts.displayedItemsCount - 1;

                    var patch = scope.stream.curated ? {
                        exposed: item.visible
                    } : {
                        hidden: !item.visible
                    };
                    ItemService.patchItem(scope.stream.id, item.id, patch);
                };
            }
        };
    }]);

'use strict';

angular.module('attensaApp')
.directive('itemPreviewList', [
function() {
    return {
        replace: true, //uck this prevents us from converting to a component but current css requires it
        scope: {
            items: '=',
            stream: '=',
            readable: '='
        },
        template: [
            '<div id="reading-table" class="position-relative">',
                '<div class="reading-item" ng-repeat="item in items | limitTo: 10">',
                    '<div class="rich-list-link rich-list-item-read">',
                        '<div class="rich-list-item-group">',
                            '<span class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{::item.title}}"><item-title readable="::readable" item="::item" stream="::stream"></item-title></span>',
                            '<div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="::item.publishedDate"></div>',
                        '</div>',
                    '</div>',
                '</div>',
            '</div>'
        ].join('\n')
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('itemTimeToLive', ['_', function(_) {
    return {
        scope: {
            stream: '=',
            onSetLimit: '&'
        },
        template: [
            '<div class="form-control-static">',
                '<span ng-hide="retentionForm.$visible" id="selected-ttl">{{ stream.settings.itemTimeToLiveInDays || \'Forever\' }} &nbsp;</span>',
                '<a id="edit-retention-link" ng-click="retentionForm.$show()" ng-hide="retentionForm.$visible" style="border-bottom: none;">',
                    '<i class="fa fa-pencil-square-o"></i>',
                '</a>',
                '<form editable-form name="retentionForm" onaftersave="setLimit()" ng-show="retentionForm.$visible" id="retention-form">',
                    '<div class="radio inline-radio">',
                        '<input type="radio" ng-model="limitRetention" ng-value="false" name="forever">',
                        '<label for="forever">Forever</label>',
                    '</div>',
                    '<div class="radio inline-radio">',
                        '<input type="radio" ng-model="limitRetention" ng-value="true" name="limit">',
                        '<label for="limit">Retention Days</label>',
                        '<input type="number" min="1" class="form-control input-sm" id="itemTimeToLiveInDays" name="itemTimeToLiveInDays" ng-model="selectedTTL" ng-disabled="!limitRetention" ng-required="limitRetention" />',
                        '<div ng-if="retentionForm.itemTimeToLiveInDays.$touched">',
                            '<div class="has-error" ng-messages="retentionForm.itemTimeToLiveInDays.$error">',
                                '<small class="help-block" ng-message="min">Retention Days must be a number and cannot be empty.</small>',
                                '<small class="help-block" ng-message="number">Retention Days must be a number and cannot be empty.</small>',
                                '<small class="help-block" ng-message="required">Retention Days must be a number and cannot be empty.</small>',
                            '</div>',
                        '</div>',
                    '</div>',
                    '<span class="editable-buttons" ng-show="retentionForm.$visible">',
                        '<button id="retention-form-submit" type="submit" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-ok"></span></button>',
                        '<button type="button" class="btn btn-default btn-xs" ng-click="retentionForm.$cancel();">',
                            '<span class="glyphicon glyphicon-remove"></span>',
                        '</button>',
                    '</span>',
                '</form>',
            '</div>'
        ].join('\n'),
        link: function(scope) {
            // This is just to catch the first time we bind in the stream because it may not be there when we instantiate the directive
            scope.$watch('stream.settings.itemTimeToLiveInDays', function(newTTL, oldTTL) {
                scope.limitRetention = _.isNumber(newTTL) ? true : false;
                scope.selectedTTL = newTTL || 90;
            });

            scope.setLimit = function() {
                scope.stream.settings.itemTimeToLiveInDays = scope.limitRetention ? scope.selectedTTL : undefined;
                scope.onSetLimit();
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.component('itemTitle', {
    bindings: {
        item: '<',
        stream: '<',
        readable: '<'
    },
    template: [
        '<span ng-if="!$ctrl.readable">{{::$ctrl.item.title}}</span>',
        '<a ng-if="$ctrl.readable" ng-click="$ctrl.readItem($ctrl.item)">{{::$ctrl.item.title}}</a>'
    ].join('\n'),
    controller: ['ItemService', function(itemService){
        var self = this;

        this.readItem = function(item){
            itemService.openNewModal({
                itemId: item.id,
                hasPrevious: false,
                hasNext: false,
                streamContext: self.stream ? self.stream.id : undefined
            });
        };
    }]
});
'use strict';

angular.module('attensaApp')
.component('sortLink', {
    bindings: {
        label: '@',
        sort: '=',
        sortDirection: '=',
        key: '@',
        onSort: '&'
    },
    transclude: true,
    template: `
        <a class="white-space-nowrap" 
           ng-style="sort===key ? {\'font-weight\': \'bold\'} : {\'font-weight\': \'normal\'}" 
           ng-click="$ctrl.onSort({$sort: $ctrl.key, $sortDirection: $ctrl.direction()})">
           {{$ctrl.label}}<ng-transclude></ng-transclude>
           <i ng-if="$ctrl.sort === $ctrl.key" 
              ng-class="{ \'fa fa-caret-up\': $ctrl.sortDirection === \'asc\', \'fa fa-caret-down\' : $ctrl.sortDirection === \'desc\' }">
           </i>
        </a>
    `,
    controller: [function() {

        var self = this;

        this.direction = function(){
            return self.sortDirection === 'asc' ? 'desc' : 'asc';
        };
    }]
});

'use strict';

/*
 * Directive help-link
 *
 * Displays a contextual help link that opens in a new window based on the user's UI state. This directive
 * will look up specific contextual help links in the following order:
 * 1.  A url provided to the directive (see optional href param below)
 * 2.  Help links defined by $stateParams parameter values defined in the UI.router stats in the following format:
 *         parameterHelpLinks: [{
 *             paramName: 'catalog',
 *             links: [{
 *                 paramValue: 'store',
 *                 href: 'http://foo.com'
 *             }]
 *         }]
 *     If multiple parameters are provided to a state, the link for the first parameter found will be displayed.
 *     No order guaranteed.
 * 3.  Help link defined in the ui.router state as static for that state in the following format:
 *         staticHelpLink: 'http://foo.com'
 *
 *
 * Usage <help-link href="http:/foo.com">
 *
 * Params:
 *   {string}  [href]   OPTIONAL - If supplied, the directive will link to the specified url and ignore
 *   settings on the UI.route state
 */

angular.module('attensaApp')
.directive('helpLink', ['_', '$state', '$stateParams', function(_, $state, $stateParams) {
    return {
        scope: {
            href: '@'
        },
        restrict: 'E',
        replace: true,
        template: '<a target="_blank" ng-show="hasHelpLink" class="fa fa-2x fa-question-circle muted pull-right"></a>',
        link: function(scope, element, attrs) {
            scope.hasHelpLink = false;
            var linkHref;

            if(scope.href) {
                linkHref = scope.href;
            }
            else if($state.current.parameterHelpLinks) {
                var linkSpec = _.find($state.current.parameterHelpLinks, function(parameterLinkSpec) {
                    return $stateParams[parameterLinkSpec.paramName] !== undefined;
                });
                var linkObj = _.find(linkSpec.links, { paramValue: $stateParams[linkSpec.paramName] });

                linkHref = linkObj ? linkObj.href : undefined;

            } else if ($state.current.staticHelpLink) {
                linkHref = $state.current.staticHelpLink;
            }

            if(linkHref) {
                element.children().attr('href', linkHref);
                scope.hasHelpLink = true;
            }
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('hideForSamlTenant', ['TenantService', function(tenantService) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.hide();
            tenantService.getCurrentTenant()
            .then(function(tenant) {
                if(!tenant.data.settings.samlEntryPoint) {
                    element.show();
                }
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('linkResolverLink', ['TenantService', function(tenantService) {
    return {
        restrict: 'E',
        replace: true,
        scope: { item: '=', clicked: '&' },
        template: '<a href="{{::item.linkResolverLink}}" target="_blank" tooltip-placement="top" uib-tooltip={{::tenant.linkResolutionConfiguration.linkResolverToolTip}} ng-click="clicked()">' +
                            '<img ng-if="tenant.linkResolutionConfiguration.linkResolverLogoUrl" class="item-image-link-logo" ng-src="{{::tenant.linkResolutionConfiguration.linkResolverLogoUrl}}">' +
                            '{{::linkText}}' +
                    '</a>',
        link: function(scope, element, attrs) {
            tenantService.getCurrentTenant()
            .then(function(tenant) {
                scope.tenant = tenant.data;
                if (scope.tenant.linkResolutionConfiguration) {
                    if (!scope.tenant.linkResolutionConfiguration.linkResolverToolTip && !scope.tenant.linkResolutionConfiguration.linkResolverLogoUrl) {
                        scope.linkText = 'Full Text Link';
                        scope.tenant.linkResolutionConfiguration.linkResolverToolTip = scope.linkText;
                    } else if (!scope.tenant.linkResolutionConfiguration.linkResolverLogoUrl) {
                        scope.linkText = scope.tenant.linkResolutionConfiguration.linkResolverToolTip;
                    } else if (!scope.tenant.linkResolutionConfiguration.linkResolverToolTip) {
                        scope.tenant.linkResolutionConfiguration.linkResolverToolTip = 'Full Text Link';
                    }
                }
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('logo', ['TenantService', function(tenantService) {
    return {
        link: function(scope, element) {
            var setSrc = function(){
                tenantService.getUnauthTenantInfo()
                .then(function(tenant) {
                    if(tenant.data.settings.logoUrl) {
                        element.attr('src', tenant.data.settings.logoUrl);
                    } else {
                        element.attr('src', '/images/logo.svg');
                    }
                });
            };

            scope.$on('tenant-settings-updated', function(){
                setSrc();
            });

            setSrc();
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('listCount', [function() {
    return {
        restrict: 'E',
        scope: {},
        template: '<small ng-show="totalElements" class="badge">{{totalElements | number }}</small>',
        link: function(scope) {
            scope.$on('topic-item-page-fetched', function(evt, results){
                scope.totalElements = results.totalElements;
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.component('modalHeader', {
    bindings: {
        title: '@',
        onClose: '&',
        iconClass: '@'
    },
    transclude: true,
    template: [
        '<section class="modal-header">',
            '<a ng-click="$ctrl.onClose()" class="fa fa-times pull-right modal-close-x muted-text"></a>',
            '<h4 class="modal-title"><i ng-if="$ctrl.iconClass" class="{{$ctrl.iconClass}}"></i>{{::$ctrl.title}}</h4>',
            '<ng-transclude></ng-transclude>',
        '</section>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('newSourceList', {
    bindings: {
        isFetching: '=',
        includedSources: '=',
        searchTerm: '@',
        toggleAddToTopic: '&'
    },
    template: [
        '<ul class="sources-list">',
        '<new-source-listing type=\'RSS\' on-fetch-status-change="$ctrl.onFetchStatusChange(type, value)" search-term="{{$ctrl.searchTerm}}" toggle-add-to-topic="$ctrl.toggleAddToTopic({ source: source })" included-sources="$ctrl.includedSources" title="New RSS Feed" icon-class="fa fa-rss"></new-source-listing>',
        '<new-source-listing type=\'BING_SEARCH\' on-fetch-status-change="$ctrl.onFetchStatusChange(type, value)" search-term="{{$ctrl.searchTerm}}" toggle-add-to-topic="$ctrl.toggleAddToTopic({ source: source })" included-sources="$ctrl.includedSources" title="New Bing news search" icon-class="fa fa-windows"></new-source-listing>',
        '<new-source-listing type=\'TWITTER_SEARCH\' on-fetch-status-change="$ctrl.onFetchStatusChange(type, value)" search-term="{{$ctrl.searchTerm}}" toggle-add-to-topic="$ctrl.toggleAddToTopic({ source: source })" included-sources="$ctrl.includedSources" title="New Twitter search" icon-class="fa fa-twitter"></new-source-listing>',
        '</ul>'
    ].join('\n'),
    controller: [function(){
        this.status = {};

        this.onFetchStatusChange = function(type, value){
            this.status[type] = value;
            this.isFetching = this.status.RSS || this.status.BING_SEARCH || this.status.TWITTER_SEARCH;
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('newSourceListing', {
    bindings: {
        includedSources: '=',
        searchTerm: '@',
        toggleAddToTopic: '&',
        onFetchStatusChange: '&',
        title: '@',
        iconClass: '@',
        type: '@'
    },
    template: [
        '<li class="source-list animated-list" ng-if="$ctrl.previewItems.length > 0">',
            '<h5><i class="{{::$ctrl.iconClass}}"></i> {{::$ctrl.title}}</h5>',
                '<div class="action-links pull-right">',
                    '<span><a ng-click="$ctrl.togglePreview()")>Preview</a> / </span>',
                    '<span><a ng-click="$ctrl.toggleSourceAddition($ctrl.type, $ctrl.searchTerm)">{{$ctrl.isIncludedSource($ctrl.type, $ctrl.searchTerm) ? \'Remove\' : \'Add\'}}</a></span>',
                '</div>',
                '<item-preview-list uib-collapse="$ctrl.previewIsHidden" items="$ctrl.previewItems" style="margin-left: 1em"></item-preview-list>',
        '</li>',
    ].join('\n'),
    controller: ['_', '$scope', '$rootScope', 'ItemService', 'StreamService', 'PreviewService', function(_, $scope, $rootScope, ItemService, StreamService, PreviewService) {
        var ctrl = this;
        ctrl.previewIsHidden = true;
        ctrl.previewItems = [];

        $scope.$watch('$ctrl.searchTerm', function(term) {
            if(!_.isEmpty(term)) {
                ctrl.previewIsHidden = true;
                ctrl.sourceWasAdded = false;
                ctrl.onFetchStatusChange({ type: ctrl.type, value: true});
                PreviewService.previewItems(ctrl.type, term, { type: ctrl.type === 'BING_SEARCH' ? 'NEWS' : undefined })
                .then(function(itemPreviews) {
                    if(_.isArray(itemPreviews)) {
                        ctrl.feedTitle = null;
                        ctrl.previewItems = itemPreviews;
                    } else if(_.isObject(itemPreviews)) {
                        ctrl.previewItems = itemPreviews.items;
                        ctrl.feedTitle = itemPreviews.title;
                    }
                })
                .catch(function() {
                    ctrl.previewItems = [];
                })
                .finally(function(){
                    ctrl.onFetchStatusChange({ type: ctrl.type, value: false});
                });
            }
        });

        ctrl.togglePreview = function() {
            ctrl.previewIsHidden = !ctrl.previewIsHidden;
            $rootScope.$broadcast('hide-new-source-previews', ctrl.type);
        };

        $scope.$on('hide-new-source-previews', function(evt, type) {
            ctrl.previewIsHidden = type === ctrl.type ? ctrl.previewIsHidden : true;
        });

        ctrl.isIncludedSource = function(type, term) {
            return _.some(ctrl.includedSources, { type: type, term: term });
        };

        ctrl.toggleSourceAddition = function(type, term) {
            ctrl.toggleAddToTopic({ source: { type: type, term: term, title: ctrl.feedTitle} });
            ctrl.sourceWasAdded = true;
        };
    }]
});

'use strict';

angular.module('attensaApp')
.directive('ngClick', ['$timeout', function ($timeout) {
    var delay = 500;

    return {
        restrict: 'A',
        priority: -1,
        link: function (scope, elem) {
            var disabled = false;

            var onClick = function(evt) {
                if (disabled) {
                    elem.blur();
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                } else {
                    disabled = true;
                    $timeout(function () { disabled = false; }, delay, false);
                }
            };

            scope.$on('$destroy', function () { elem.off('click', onClick); });
            elem.on('click', onClick);
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('noResults', [
    function() {
        return {
            scope: {
                message: '@'
            },
            template: [
                '<h1 class="text-center"><i class="fa fa-search"></i></h1>',
                '<p class="text-center"><strong>{{::message || \'Try again! We could not find any results for that search.\'}}</strong></p>'
            ].join('\n')
        };
    }]);

'use strict';

angular.module('attensaApp')
.directive('toggleBookmark', ['UserService', function(userService) {
    return {
        restrict: 'A',
        scope: {
            item: '=',
            items: '='
        },
        link: function(scope, element) {
            element.bind('click', function(){
                return userService.toggleBookmark(scope.item, scope.items);
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('postItemButton', ['_', 'ItemService', 'UserService',
    function(_, ItemService, UserService) {
        return {
            scope: {
                stream: '=',
                itemDidPost: '&'
            },
            template: [
                '<button show-with-permission action="POST_TO_STREAM" stream-id="stream.id" tooltip-placement="top" uib-tooltip="Post Item" ng-click="openPostItemModal()" class="btn btn-default">',
                    '<span class="glyphicon glyphicon-pencil"></span> Post',
                '</button>'
            ].join('\n'),
            link: function (scope) {
                scope.openPostItemModal = function() {
                    UserService.getCurrentUser()
                    .then(function(userRes) {
                        var user = userRes.data.user;
                        ItemService.openPostItemModal([scope.stream], null, user.firstName + ' ' + user.lastName, scope.itemDidPost);
                    });
                };
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.directive('repositionMe', ['$interval', function($interval) {
    return {
        link: function(scope, element) {
            // Todo if we are using popover templates more places calculate the css position with math..
            scope.$watch('showSave', function(value) {
                var originalTop = element.prop('offsetTop');
                if(value === false) {
                    element.css('top', originalTop+70);
                } else {
                    element.css('top', originalTop-70);
                }
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('dropdownFlipper', ['$window', function($window) {
    return {
        priority: 5,
        link: function(scope, element, args) {
            element.click(function(){
                var viewTop = $window.scrollY;
                var viewBottom = (viewTop + $window.innerHeight);
                var elementOffset = element.offset();
                var elementDistanceFromBottom = (viewBottom - elementOffset.top);
                if(elementDistanceFromBottom < parseInt(args.dropdownFlipper)) {
                    element.parent().addClass('dropup');
                } else {
                    element.parent().removeClass('dropup');
                }
            });
        }
    };
}]);
'use strict';

angular.module('attensaApp')
.directive('rssAuthentication', [function() {
    return {
        scope: {
            authSettings: '='
        },
        template: [
        '<ng-form name="authForm" class="form-group clearfix">',
            '<input type="checkbox" ng-model="authSettings.isAuthenticated">',
                '<label>&nbsp;Authenticated Feed</label>',
            '</div>',
            '<div class="form-inline" ng-if="authSettings.isAuthenticated">',
                '<div class="form-group">',
                    '<label for="rssUsername">Username:</label>',
                    '<input autocomplete="off" name="rssUsername" type="text" class="form-control" placeholder="Username" ng-model="authSettings.username" required">',
                '</div>',
                '<div class="form-group">',
                    '<label for="rssPassword">Password:</label>',
                    '<input autocomplete="off" name="rssPassword" type="password" class="form-control" placeholder="Password" ng-model="authSettings.password" required>',
                '</div>',
            '</div>',
        '</ng-form>'
        ].join('\n'),
        link: function(scope) {
            scope.authSettings = {
                isAuthenticated: false
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('s3Upload', ['_', '$q', 'growl', 'InfoService', 'Upload', 'uuid4',
function(_, $q, growl, infoService, Upload, uuid4) {
    return {
        restrict: 'E',
        scope: {
            buttonText: '@',
            status: '=',
            removeOnSuccess: '@',
            inline: '@'
        },
        templateUrl: function(element, attrs) {
            return attrs.inline ? '/templates/s3Upload-inline.html' : '/templates/s3Upload-button.html';
        },
        link: function($scope, element, attrs) {
            $scope.files = [];

            $scope.filesSelected = function(files) {
                if (files.length > 0) {
                    $scope.files = _.map(files, function(file) {
                        return {
                            fileName: file.name,
                            progress: 0
                        };
                    }).concat($scope.files);

                    if(_.isObject($scope.status)) {
                        $scope.status.inProgress = true;
                    } else {
                        $scope.status = { inProgress: true };
                    }

                    var uploadPromises = _.map(files, function(file, idx) {
                        var fileUrl;

                        return infoService.getS3Creds(file.name, file.type)
                        .then(function(s3Creds) {
                            fileUrl = s3Creds.url + '/' + s3Creds.fields.key;
                            return Upload.upload({
                                url: s3Creds.url,
                                transformRequest: function(data, headersGetter) {
                                    var headers = headersGetter();
                                    delete headers.Authorization;
                                    return data;
                                },
                                fields: s3Creds.fields,
                                method: 'POST',
                                file: file
                            })
                            .progress(function(evt) {
                                $scope.files[idx].progress = parseInt(100.0 * evt.loaded / evt.total);
                            })
                            .success(function(data, status, headers, config) {
                                _.assign($scope.files[idx], {
                                    id: uuid4.generate(),
                                    location: fileUrl,
                                    fileName: file.name,
                                    sizeInBytes: file.size,
                                    success: true,
                                    mimeType: file.type
                                });
                                $scope.$emit('fileUploaded', $scope.files[idx]);
                            })
                            .error(function() {
                                $scope.files[idx].error = true;
                                $scope.status.inProgress = false;
                            });
                        })
                        .catch(function(err) {
                            $scope.status.inProgress = false;
                            growl.error('An error ocurred while uploading files.  Please refresh your browser window');
                        });
                    });

                    $q.all(uploadPromises)
                    .then(function(files) {
                        $scope.status.inProgress = false;
                    });
                }
            };

            $scope.removeFile = function(file) {
                _.remove($scope.files, { id: file.id });
                $scope.$emit('fileCancelled', file);
            };
        }
    };
}]);

'use strict';
/**
 * Sort user by Mongo attribute or tenant/stream roles
 *
 * Usage nest inside <th>: 
 *     <sort-people-by label="'First Name'" sort="sort" sort-key="'firstName'" sort-by="sortByOthers"></sort-people-by>
 *     - "label" is the <a> tag of user attribute
 *     - "sort" is the current sorted column two-way binded to the parent controler's $scope.sort
 *     - "sort-key" is the key used for creating request parameter
 *     - "sort-by" is the method on parent controller that handles the actual sorting
 *     
 *     Note: if you provide streamRoleType or tenantRoleType, the sort & sortDirection parameters will be ignored.
 */
angular.module('attensaApp')
.directive('sortPeopleBy', [function() {
    return {
        restrict: 'E',
        scope: {
            label: '=',
            sortKey: '=',
            sortBy: '=',
            sort: '=',
            initialSort: '=',
            initialDescending: '='
        },
        replace: true,
        template: '<span>' +
                        '<a class="white-space-nowrap" ng-style="sort===sortKey ? {\'font-weight\': \'bold\'} : {\'font-weight\': \'normal\'}"" ng-click="sortFunct()">{{label}} <i ng-if="sort===sortKey" ng-class="upOrDown"></i></a>' +
                    '</span>',
        link: function(scope, element, attrs) {
            scope.ascending =  scope.initialSort ? scope.initialSort : false;

            var sortView = function() {
                if(scope.sort !== scope.sortKey && scope.initialDescending){
                    scope.ascending = false;
                }

                scope.sort = scope.sortKey;
                scope.sortDirection = scope.ascending ? 'ASC' : 'DESC';
                scope.upOrDown = scope.ascending ? 'fa fa-caret-up' : 'fa fa-caret-down';
            };

            if(scope.initialSort) {
                sortView();
            }

            scope.sortFunct = function() {
                scope.ascending = !scope.ascending;
                sortView();
                scope.sortBy({
                    sort: scope.sort,
                    sortDirection: scope.sortDirection
                }, true);
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.component('sourceListNoResults', {
    template: [
        '<div class="rich-list-link rich-list-item-read">',
            '<div class="rich-list-item-group">',
                '<span class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="the source/topic has no articles">the source/topic has no articles</span>',
            '</div>',
        '</div>'
    ].join('\n')
});

'use strict';

angular.module('directives.spinner', []);

angular.module('directives.spinner').directive('spinner', [
function() {
    return {
        template: [
            '<div class="center-block la-ball-pulse la-2x big-spinner">',
                '<div></div>',
                '<div></div>',
                '<div></div>',
            '</div>'
        ].join('\n')
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('scrollup', [function () {
    return {
        restrict: 'A',
        link: function (scope, elm, attrs) {
            elm.bind('click', function () {
                // Don't scrollup if on modal
                if(angular.element('.modal-dialog').length === 0) {
                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                }
            });
        }
    };
}]);
'use strict';

angular.module('attensaApp')
.directive('scrollHeight', ['$interval', function ($interval) {
    return {
        restrict: 'A',
        link: function (scope, elm, attrs) {
            var intervalPromise = $interval(function(){
                scope[attrs.scrollHeight] = elm.prop('scrollHeight');

                if(attrs.scrollHeight && scope[attrs.scrollHeight]) {
                    $interval.cancel(intervalPromise);
                }
            }, 500);

            elm.on('$destroy', function() {
                $interval.cancel(intervalPromise);
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
    .directive('scrolled', ['$window', '_', function ($window, _) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                angular.element($window).bind('scroll', _.throttle(function(){
                    if(angular.element($window.document).scrollTop() > (attrs.scrolled || 80)) {
                        if(!elm.hasClass('scrolled')) {
                            elm.addClass('scrolled');
                        }
                    } else {
                        if(elm.hasClass('scrolled')) {
                            elm.removeClass('scrolled');
                        }
                    }
                }, 50));
            }
        };
    }]);

'use strict';

/*
 * Hides DOM element if the user does not have permission to perform a specified action
 *
 * Usage:
 * <div show-with-permission action='FOO' stream-id='BAR' user-id='BAZ' stream-owner-id='QUX'></div>
 *     - 'FOO' is an action defined for a role (e.g. MANAGE_PEOPLE).  If the current user has the action in one
 *             of it's roles, the element will be shown.  By default, only tenant level roles are searched.
 *     - 'BAR' is a streamID that the action targets.  If supplied, the 'action' search will also be done against
 *             stream roles for the supplied streamID.
 *     - 'BAZ' is a userID to compare to the currently logged in user.  If the id matches the current user, the element
 *             will be shown
 *     - 'QUX' is the owner id (userId) of a stream for permission check against. This is used to see if a user
 *             can execute actions against a stream that they are the owner of.
 *
 *     All arguments are optional.  But at least one of 'action' or 'user-id' must be supplied.
 */

angular.module('attensaApp')
.directive('showWithPermission', ['permissionService',
    function(permissionService) {
    return {
        scope: {
            action:   '@',
            streamId: '=?',
            userId:   '=?',
            streamOwnerId: '@'
        },
        link: function(scope, element, attr) {
            // We hide the element by default so it won't show in case of failure
            element.hide();

            // TODO: It's kind of nasty to put this in a watch.  Once UI router is implemented we can use $resolve
            // to make sure all our XHR data is loaded before the route is rendered.
            scope.$watch('streamId', function(newValue, oldValue, scope) {
                permissionService.currentUserHasPermission({
                    action: scope.action || undefined,
                    streamId: scope.streamId || undefined,
                    streamOwnerId: scope.streamOwnerId || undefined,
                    userId: scope.userId || undefined
                })
                .then(function(result) {
                    if(result) {
                        element.show();
                    }
                });
            });

            scope.$watch('streamOwnerId', function(newValue, oldValue, scope) {
                permissionService.currentUserHasPermission({
                    action: scope.action || undefined,
                    streamId: scope.streamId || undefined,
                    streamOwnerId: scope.streamOwnerId || undefined,
                    userId: scope.userId || undefined
                })
                .then(function(result) {
                    if(result) {
                        element.show();
                    }
                });
            });
        }
    };
}]);

'use strict';

angular.module('directives.sourceCard', []);

angular.module('directives.sourceCard')
.directive('sourceCard', ['_',
    function(_) {
        return {
            scope: {
                existingSources: '=',
                parentStreamId: '@',
                stream: '=',
                sourceSelectionDidChange: '&'
            },
            template: [
                '<div class="source-card clearfix" ng-class="{\'source-card-disabled\': isExistingSource}" uib-tooltip="Existing source" tooltip-enable="isExistingSource"',
                    'ng-style="::backgroundImageStyle" ng-click="toggleSelection()">',
                    '<div class="media">',
                        '<div style="height: 90px">',
                            '<h4 class="media-heading">',
                                '<div class="ellipsis-color">',
                                    '<span class="overflow-ellipsis stream-tile-title" style="width: 255px" title="{{::stream.title}}">',
                                        '{{::stream.title}}',
                                    '</span>',
                                '</div>',
                            '</h4>',
                            '<h5 ng-if="::stream.settings.search" class="stream-card-setting" title="{{::stream.settings.search}}">Search term: {{::stream.settings.search}}</h5>',
                            '<h5 ng-if="::stream.settings.uri" class="stream-card-setting" title="{{::stream.settings.uri}}">Url: {{::stream.settings.uri}}</h5>',
                            '<h5 ng-if="::stream.settings.type" class="stream-card-setting" title="{{::stream.settings.type}}">Type: {{::stream.settings.type}}</h5>',
                            '<p class="stream-card-description line-clamp" title="{{::stream.description}}">{{::stream.description}}</p>',
                        '</div>',
                    '</div>',
                    '<div class="info muted-text">' +
                        '<span ng-if="::stream.settings.username" class="fa fa-lock"></span>',
                        '<span class="fa fa-file"></span>',
                        '<span>{{::stream.itemsCount}}</span>',
                    '</div>',
                    '<div ng-show="isSelected || isExistingSource" class="selection-marker">',
                        '<span class="fa fa-check fa-2x text-success"></span>',
                    '</div>',
                '</div>'
            ].join('\n'),
            link: function(scope) {
                scope.isSelected = false;
                scope.isExistingSource = _.find(scope.existingSources, { id: scope.stream.id }) || scope.parentStreamId === scope.stream.id;

                scope.toggleSelection = function() {
                    if(!scope.isExistingSource) {
                        scope.isSelected = !scope.isSelected;
                        scope.sourceSelectionDidChange({ isSelected: scope.isSelected });
                    }
                };

                var hasBackgroundImage = _.has(scope.stream, 'largeImage.uri');
                scope.backgroundImageStyle = hasBackgroundImage ?
                { background: 'linear-gradient(to bottom, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.95) 100%),' +
                'url(' + scope.stream.largeImage.uri + ') no-repeat 50% 50%',
                    'background-size': 'cover'
                } : {};
            }
        };
    }]);

'use strict';

angular.module('attensaApp')
.directive('spinnerButton', [function() {
    return {
        replace: true,
        scope: {
            spinOn: '=',
            text: '@',
            type: '@'
        },
        template: [
            '<button type="{{type}}" class="btn btn-default" ng-disabled="spinOn">',
                '{{text}} <span ng-if="spinOn" class="fa fa-spinner fa-pulse"></span>',
            '</button>'
        ].join('\n')
    };
}]);

'use strict';

angular.module('attensaApp')
.directive(
    'sourcePreview', ['_', 'PreviewService', 'StreamService',
function(_, PreviewService, StreamService) {
    return {
        scope: {
            term: '=',
            searchSettingsType: '=',
            streamType: '@',
            sourceTypeTitle: '@',
            searching: '=',
            authSettings: '=',
            tagSettings: '=',
            addNewSource: '&'
        },
        template: [
        '<div ng-if="!previewError && !searching && items !== undefined">',
            '<div class="row pad-top-bottom">',
                '<div class="col-md-12">',
                    '<button class="btn btn-primary" ng-click="addSource(matchingStreamId)">Add source</button>',
                '</div>',
            '</div>',
            '<div class="row pad-top-bottom">',
                '<div class="col-md-12">',
                    '<item-preview-list items="items"></item-preview-list>',
                '</div>',
            '</div>',
        '</div>',
        '<div class="row" ng-if="!searching && items.length === 0">',
            '<div class="col-md-12">',
                '<no-results message="We couldn\'t find any results for that {{::entryType}}.  You can still add the source, but it may not have any content."></no-results>',
            '</div>',
        '</div>',
        '<div class="row" ng-if="!searching && previewError">',
            '<div class="col-md-12">',
                '<no-results message="An error occurred getting a preview.  Please ensure you have entered a valid {{::entryType}}"></no-results>',
            '</div>',
        '</div>',
        '<spinner ng-if="searching"></spinner>'
        ].join('\n'),
        link: function(scope) {
            scope.entryType = scope.streamType === 'RSS' ? 'url' : 'search term';

            scope.$on('preview-items', function(evt, payload) {
                scope.matchingStreamId = payload.matchingStreamId;
                scope.previewError = false;
                scope.searching = true;
                scope.previewService(scope.streamType, scope.term, {
                    type: scope.searchSettingsType,
                    username: scope.authSettings.isAuthenticated ? scope.authSettings.username : undefined,
                    password: scope.authSettings.isAuthenticated ? scope.authSettings.password : undefined,
                    searchConfiguration: scope.tagSettings
                })
                .then(function(itemPreviews) {
                    if(_.isArray(itemPreviews)) {
                        scope.items = itemPreviews;
                    } else if(_.isObject(itemPreviews)) {
                        scope.items = itemPreviews.items;
                        scope.title = itemPreviews.title;
                    }
                })
                .catch(function() {
                    scope.previewError = true;
                })
                .finally(function() {
                    scope.searching = false;
                });
            });

            scope.addSource = function(matchingStreamId) {
                if(matchingStreamId) {
                    scope.addNewSource({ streamId: matchingStreamId });
                } else {
                    return StreamService.saveStream({
                        title: scope.title ? scope.title : scope.sourceTypeTitle + ': ' + scope.term,
                        type: scope.streamType,
                        openForReading: true,
                        settings: {
                            search: scope.streamType === 'RSS' ? undefined : scope.term,
                            type: scope.searchSettingsType,
                            uri: scope.streamType === 'RSS' ? scope.term : undefined,
                            username: scope.authSettings.username,
                            password: scope.authSettings.password,
                            searchConfiguration: scope.tagSettings
                        }
                    })
                    .then(function(streamResponse) {
                        scope.addNewSource({ streamId: streamResponse.data.id });
                    });

                }
            };

            scope.previewService = PreviewService.previewItems;
        }
    };
}]);

'use strict';

angular.module('directives.streamCard', []);

angular.module('directives.streamCard')
.directive('streamCard', ['_', '$state', 'permissionService', 'StreamService',
function(_, $state, permissionService, StreamService) {
    return {
        scope: {
            stream: '=',
            user: '='
        },
        template: [
            '<div class="stream-card clearfix" ng-style="::backgroundImageStyle">',
                '<div class="media">',
                    '<div class="tile-body">',
                        '<h4 class="media-heading">',
                            '<div class="ellipsis-color">',
                                '<a class="overflow-ellipsis" style="width: 270px" ng-click="$state.go(\'^.stream\', { streamId: stream.id, stream: stream, indexVisible: false })">',
                                    '<span class="stream-tile-title" title="{{::stream.title}}">{{::stream.title}}</span>',
                                '</a>',
                            '</div>',
                        '</h4>',
                        '<p class="stream-card-description line-clamp" title="{{::stream.description}}">{{::stream.description}}</p>',
                    '</div>',
                '</div>',
                '<div class="row">',
                    '<div class="col-md-7">',
                        '<div class="pad-top-bottom">',
                            '<div role="group" ng-if="userCanRead()">',
                                '<follow-button stream="stream" user="user" type="stream" follow-style="primary"></follow-button>',
                                '<subscribe-button ng-if="::stream.briefingEnabled" stream="stream" user="user" type="stream" subscribe-style="primary"></subscribe-button>',
                            '</div>',
                        '</div>',
                    '</div>',
                    '<div class="col-md-5" style="padding-left: 0;">',
                        '<div class="pad-top-bottom margin-top-bottom pull-right">',
                            '<a class="muted-text margin-left-right pull-right" title="Number of followers" ng-click="userCanRead() && openFollowersModal(stream)">',
                                '<span class="glyphicon glyphicon-user"></span>',
                                '<span>{{stream.followersCount}}</span>',
                            '</a>',
                            '<span class="muted-text margin-left-right pull-right">',
                                '<span class="fa fa-file"></span>',
                                '<span id="itemsCount">{{::stream.itemsCount}}</span>',
                            '</span>',
                        '</div>',
                    '</div>',
                '</div>',
            '</div>'
        ].join('\n'),
        link: function(scope) {
            scope.$state = $state;

            var hasBackgroundImage = _.has(scope.stream, 'largeImage.uri');
            scope.backgroundImageStyle = hasBackgroundImage ?
                { background: 'linear-gradient(to bottom, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.95) 100%),' +
                              'url(' + scope.stream.largeImage.uri + ') no-repeat 50% 50%',
                  'background-size': 'cover'
                } : {};

            scope.userCanRead = () => permissionService.userCanReadStream(scope.user, scope.stream, true);

            scope.openFollowersModal = StreamService.openFollowersModal;
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('streamCurateControl', ['_', '$rootScope', 'StreamService',
    function(_, $rootScope, StreamService) {
        return {
            scope: {
                stream: '=',
                curateSettingDidChange: '&'
            },
            template: [
                '<div>',
                    '<span class="muted">Default:</span>',
                    '<div class="btn-group btn-toggle stream-curate-toggle">',
                        '<button class="btn" ng-class="!stream.curated ? \'active btn-primary\' : \'btn-default\'" ng-click="setStreamCuration(false)" blur-me>Show</button>',
                        '<button class="btn" ng-class="stream.curated ? \'active btn-primary\' : \'btn-default\'" ng-click="setStreamCuration(true)" blur-me>Hide</button>',
                    '</div>',
                '</div>'
            ].join('\n'),
            link: function(scope) {
                scope.setStreamCuration = function(isCurated) {
                    scope.stream.curated = isCurated;
                    StreamService.updateStream(scope.stream)
                    .then(function(streamRes) {
                        scope.stream.itemsCount = streamRes.data.itemsCount;
                        scope.curateSettingDidChange();
                    });
                };
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.directive('streamDetailsFor', ['ItemService', 'StreamService', function(itemService, streamService) {
    return {
        restrict: 'A',
        scope: {
            streamId: '=streamDetailsFor'
        },
        link: function(scope, element) {
            element.bind('click', function(){
                streamService.getStream(scope.streamId)
                    .then(function(streamResponse){
                        return streamService.openStreamDetailModal(streamResponse.data).result;
                    })
                    .then(function(item){
                        if(item){
                            itemService.openNewModal({
                                itemId: item.id,
                                hasPrevious: false,
                                hasNext: false,
                                streamContext: scope.streamId
                            });
                        }
                    });
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('subscribeButton', ['_', '$rootScope', 'growl', 'UserService', 'UtilService',
function(_, $rootScope, growl, userService, utilService) {
    return {
        restrict: 'E',
        scope: {
            stream: '=',
            user: '=',
            type: '@',
            subscribeStyle: '@'
        },
        template:
            '<span uib-tooltip="{{displayTooltip(stream)}}" tooltip-append-to-body="true">' +
                '<button id="toggle-subscribe-{{::stream.id}}" ng-if="type === \'stream\' && subscribeStyle === \'primary\'" type="button" class="btn btn-primary catalog-stream-subscribe-button briefing-subscribe-button" tabstop="0" ng-click="toggleSubscribe(stream, user, type)" ng-class="{active: stream.userIsSubscribedToBriefing, disablePointerEvents: stream.userSubscriptionIsRestricted || toggleSubscribePromise}" ng-disabled="stream.userSubscriptionIsRestricted || toggleSubscribePromise" style="margin-left: 5px" blur-me>' +
                    '<span class="glyphicon glyphicon-envelope"></span>' +
                '</button>' +
                '<button id="toggle-subscribe-{{::stream.id}}" ng-if="type === \'stream\' && !subscribeStyle" type="button" class="btn btn-default briefing-subscribe-button" tabstop="0" ng-click="toggleSubscribe(stream, user, type)" ng-class="{active: stream.userIsSubscribedToBriefing, disablePointerEvents: stream.userSubscriptionIsRestricted || toggleSubscribePromise}" ng-disabled="stream.userSubscriptionIsRestricted || toggleSubscribePromise" blur-me>' +
                    '<span>{{stream.userIsSubscribedToBriefing ? \'Unsubscribe\' : \'Subscribe\'}}</span>' +
                '</button>' +
                '<button ng-if="type === \'user\'" type="button" class="btn btn-default" tabstop="0" ng-click="toggleSubscribe(stream, user, type)" ng-class="{active: user.userIsSubscribed, disablePointerEvents: user.userSubscriptionIsRestricted || toggleSubscribePromise}" ng-disabled="user.userSubscriptionIsRestricted || toggleSubscribePromise" blur-me>' +
                    '{{user.userIsSubscribed ? \'Unsubscribe\' : \'Subscribe\'}}' +
                '</button>' +
            '</span>',
        link: function($scope, element, attrs) {
            $scope.displayTooltip = function() {
                if($scope.type === 'user' && !_.isEmpty($scope.user)) {
                    return utilService.tooltipManager($scope.user, true);
                } else if(!_.isEmpty($scope.stream)) {
                    return utilService.tooltipManager($scope.stream, true);
                }
            };

            $scope.toggleSubscribe = function(stream, user, type) {
                if(!$scope.toggleSubscribePromise) {
                    var wasFollowing = type === 'user' ? user.userIsFollowing : stream.userIsFollowing;
                    var wasSubscribed = type === 'user' ? user.userIsSubscribed : stream.userIsSubscribedToBriefing;
                    var newFollow = calculateNewFollow(stream, user, type);

                    $scope.toggleSubscribePromise = userService.setFollowing(stream.id, user.id, {
                        follow: newFollow,
                        subscribe: !wasSubscribed
                    })
                    .then(function() {
                        _.assign($scope.user, getNewUserProps(user, wasSubscribed, newFollow, type));
                        _.assign($scope.stream, getNewStreamProps(stream, wasSubscribed, wasFollowing, newFollow, type));
                        $rootScope.$broadcast('follow-change', {
                            user: $scope.user,
                            stream: $scope.stream,
                            followStatusChanged: wasFollowing !== newFollow
                        });
                    })
                    .catch(function() {
                        growl.error('An error occurred attempting to update subscription status.');
                    })
                    .finally(function() {
                        $scope.toggleSubscribePromise = null;
                    });
                }
            };

            var calculateNewFollow = function(stream, user, type) {
                return type === 'user' ?
                    user.userIsSubscribed ? user.userIsFollowing : true :
                    stream.userIsSubscribedToBriefing ? stream.userIsFollowing : true;
            };

            var getNewUserProps = function(user, wasSubscribed, newFollow, type) {
                return type === 'user' ?
                    {
                        userIsFollowing: newFollow,
                        userIsSubscribed: !wasSubscribed
                    } : user;
            };

            var getNewStreamProps = function(stream, wasSubscribed, wasFollowing, newFollow, type) {
                return type === 'user' ?
                    {
                        followersCount: wasFollowing === newFollow ? stream.followersCount : newFollow === true ? stream.followersCount +1 : stream.followersCount -1,
                        subscribersCount: wasSubscribed ? stream.subscribersCount - 1 : stream.subscribersCount + 1
                    } :
                    {
                        followersCount: wasFollowing === newFollow ? stream.followersCount : newFollow === true ? stream.followersCount +1 : stream.followersCount -1,
                        subscribersCount: wasSubscribed ? stream.subscribersCount - 1 : stream.subscribersCount + 1,
                        userIsFollowing: newFollow,
                        userIsSubscribedToBriefing: !wasSubscribed
                    };
            };
        }
    };
}]);

'use strict';

angular.module('directives.topicSummary')
    .directive('topicSummary', [
        function() {
            return {
                scope: {
                    stream: '=',
                    taxonomy: '=',
                    onChange: '&',
                },
                restrict: 'E',
                template: `
                    <div>
                        <topic-image stream="stream"></topic-image>
                    </div>
                    <div style="flex:2;">
                        <h3 class="overflow-ellipsis" 
                            title="{{stream.title}}"
                            hide-with-permission action="MANAGE_STREAM"
                            stream-id="stream.id"
                            stream-owner-id="{{stream.ownerId}}">
                            {{stream.title}}
                        </h3>
                        <h3 title="{{stream.title}}" 
                            show-with-permission 
                            action="MANAGE_STREAM" 
                            stream-id="stream.id" 
                            stream-owner-id="{{stream.ownerId}}">
                            <edit-stream-title stream="stream" on-change="onChange()"></edit-stream-title>
                        </h3>
                        <h5 class="overflow-ellipsis" 
                            title="{{stream.description}}"
                            hide-with-permission action="MANAGE_STREAM"
                            stream-id="stream.id"
                            stream-owner-id="{{stream.ownerId}}">
                            {{stream.description}}
                        </h5>
                        <h5 class="overflow-ellipsis" 
                            title="{{stream.description}}"
                            show-with-permission 
                            action="MANAGE_STREAM" 
                            stream-id="stream.id" 
                            stream-owner-id="{{stream.ownerId}}">
                            <edit-stream-description stream="stream" on-change="onChange()"></edit-stream-description>
                        </h5>
                        <div style="display: inline-block">
                            <topic-followers stream="stream"></topic-followers>
                            <topic-items stream="stream"></topic-items>
                            <a ng-show="stream.tenantId" class="muted-text" style="text-decoration: underline" ng-click="showMore=!showMore">{{showMore ? \'Show less\' : \'Show more\'}}</a>
                        </div>
                        <div></div>
                        <div class="topic-summary-more">
                            <span ng-show="showMore">
                                <span hide-with-permission action="MANAGE_STREAM"
                                      stream-id="stream.id"
                                      stream-owner-id="{{stream.ownerId}}">
                                    <topic-categories stream="stream" taxonomy="taxonomy"></topic-categories>
                                    <topic-tags stream="stream"></topic-tags>
                                </span>
                                <span show-with-permission action="MANAGE_STREAM"
                                      stream-id="stream.id"
                                      stream-owner-id="{{stream.ownerId}}">
                                    <topic-categories stream="stream" taxonomy="taxonomy" allow-edit="true"></topic-categories>
                                    <topic-tags stream="stream" allow-edit="true" on-tag-change="onChange()"></topic-tags>
                                </span>
                            </span>
                        </div>
                    </div>
                `
            };
        }]);

'use strict';

angular.module('directives.topicSummary')
.directive('topicCatalogCategories', ['_', 'StreamService', 'TaxonomyService', '$uibModal',
    function(_, streamService, TaxonomyService, $uibModal) {
        return {
            scope: {
                allowEdit: '@',
                catalogId: '@',
                selectedCategories: '=',
                stream: '=',
                taxonomy: '='
            },
            template: [
                '<div>',
                    '<a class ="fa fa-pencil-square-o" title="Edit categories" ng-click="editCategories()" ng-if="allowEdit"></a>',
                    '<span class="muted-text">Categories:</span>',
                    '<span ng-hide="selectedCategories && selectedCategories.length > 0"><i class="glyphicon glyphicon-exclamation-sign text-danger"></i> Uncategorized</span>',
                    '<span class="btn-group btn-group-xs tag-buttons tag-btn-group user-tag-button-group ng-scope" ng-repeat="category in selectedCategories">',
                    '<button type="button" class="btn btn-default tag-button user-tag-button default-cursor">',
                        '{{category.categoryName}}',
                    '</button>',
                    '</span>',
                '</div>'
            ].join('\n'),
            link: function(scope) {
                scope.categoryTitle = streamService.categoryTitle;

                scope.streamCategories = function(taxonomy, stream){
                    return TaxonomyService.createStreamCategories(taxonomy, stream.taxonomicMemberships);
                };

                // Eh?  So it turns out that the category selection modal expects its parent to mark selected categories after the taxonomy
                // has been updated and bind those to the taxonomy object it was resolved.  No, it doens't really make sense to do this here
                // and once the streambuilder dies we should make it work more simpler
                // TODO: make this more sane after streambuilder dies
                scope.$on('taxonomyUpdated', function (event, updatedTaxonomy) {
                    scope.taxonomy = updatedTaxonomy.taxonomy;
                    TaxonomyService.markSelectedCategoriesForCatalog(scope.taxonomy, scope.selectedCategories);
                });

                scope.editCategories = function() {
                    $uibModal.open({
                        templateUrl: '/templates/CategorySelectionModal.html',
                        controller: 'CatalogCategorySelectionModalCtrl',
                        size: 'lg',
                        keyboard: false,
                        backdrop: 'static',
                        resolve: {
                            catalogId: function() { return scope.catalogId; },
                            stream: function() { return scope.stream; },
                            selectedCategories: function() { return scope.selectedCategories; },
                            taxonomy: function() {
                                return TaxonomyService.markSelectedCategoriesForCatalog(scope.taxonomy, scope.selectedCategories);
                            }
                        }
                    });
                };
            }
        };
    }]);

'use strict';

angular.module('directives.topicSummary')
    .directive('topicCategories', ['_', 'StreamService', 'TaxonomyService', '$uibModal',
        function(_, streamService, TaxonomyService, $uibModal) {
            return {
                scope: {
                    allowEdit: '@',
                    stream: '=',
                    taxonomy: '=',
                    taxonomyVersion: '@'
                },
                template: [
                    '<div>',
                        '<a class ="fa fa-pencil-square-o" title="Edit categories" ng-click="editCategories()" ng-if="allowEdit" id="edit-categories"></a>',
                        '<span class="muted-text">Categories:</span>',
                        '<span ng-hide="streamCategories(taxonomy, stream).length"><i class="glyphicon glyphicon-exclamation-sign text-danger"></i> Uncategorized</span>',
                        '<span class="btn-group btn-group-xs tag-buttons tag-btn-group user-tag-button-group ng-scope" ng-repeat="category in streamCategories(taxonomy, stream)">',
                            '<button type="button" class="btn btn-default tag-button user-tag-button default-cursor">',
                                '{{categoryTitle(category)}}',
                            '</button>',
                        '</span>',
                    '</div>'
                ].join('\n'),
                link: function(scope) {
                    scope.categoryTitle = streamService.categoryTitle;

                    scope.streamCategories = function(taxonomy, stream){
                        return stream ? TaxonomyService.createStreamCategories(taxonomy, stream.taxonomicMemberships) : {};
                    };

                    // Eh?  So it turns out that the category selection modal expects its parent to mark selected categories after the taxonomy
                    // has been updated and bind those to the taxonomy object it was resolved.  No, it doens't really make sense to do this here
                    // and once the streambuilder dies we should make it work more simpler
                    // TODO: make this more sane after streambuilder dies
                    scope.$on('taxonomyUpdated', function (event, updatedTaxonomy) {
                        scope.taxonomy = updatedTaxonomy.taxonomy;
                        scope.taxonomyVersion = updatedTaxonomy.taxonomyVersion;
                        TaxonomyService.markSelectedCategories(scope.taxonomy, scope.stream.taxonomicMemberships);
                    });

                    scope.editCategories = function() {
                        $uibModal.open({
                            templateUrl: '/templates/CategorySelectionModal.html',
                            controller: 'CategorySelectionModalCtrl',
                            size: 'lg',
                            keyboard: false,
                            backdrop: 'static',
                            resolve: {
                                taxonomy: function() {
                                    return TaxonomyService.markSelectedCategories(scope.taxonomy, scope.stream.taxonomicMemberships);
                                },
                                stream: function() {
                                    return scope.stream;
                                },
                                taxonomyVersion: function() {
                                    return scope.taxonomyVersion;
                                }
                            }
                        });
                    };
                }
            };
        }]);

'use strict';

angular.module('directives.topicSummary')
    .directive('topicFollowers', ['StreamService',
        function(streamService) {
            return {
                scope: {
                    stream: '='
                },
                template: [
                    '<a class="pull-left" ng-click="openFollowersModal(stream)">',
                        '<span class="text-primary margin-left-right pull-right" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Followers">',
                            '<span class="glyphicon glyphicon-user"></span>',
                            '<span id="followersCount-{{::stream.id}}">{{stream.followersCount}}</span>',
                        '</span>',
                    '</a>'
                ].join('\n'),
                link: function(scope) {
                    scope.openFollowersModal = streamService.openFollowersModal;
                }
            };
        }]);

'use strict';

angular.module('directives.topicSummary')
    .directive('topicImage', ['_', 'growl', 'imageService', 'StreamService',
        function(_, growl, imageService, StreamService) {
            return {
                scope: {
                    stream: '=',
                    usePlaceholder: '@',
                    allowEdit: '@'
                },
                template: [
                    '<div class="topic-image" style="height:130px;" ng-if="stream.thumbnailImage.uri || usePlaceholder">',
                        '<div ng-style="{ \'background-image\':\'url(\' + imageUri + \')\' }" class="stream-image-small">',
                            '<div ng-if="allowEdit" ng-show="!uploadInProgress" class="topic-image-overlay">',
                                '<span class="fa fa-pencil-square-o edit-stream-image-glyph"',
                                    'accept="image/*" ngf-change="changeImage(streamPic[0], $files)" ngf-select',
                                    'ng-model="streamPic" ngf-multiple="false">',
                                '</span>',
                            '</div>',
                        '</div>',
                    '</div>'
                ].join('\n'),
                link: function(scope) {
                    scope.$watch('stream.thumbnailImage.uri', function() {
                        scope.imageUri = _.has(scope.stream, 'thumbnailImage.uri') ?
                            scope.stream.thumbnailImage.uri : '/images/stream_placeholder_1_1.jpg';
                    });

                    scope.changeImage = function(file) {
                        return imageService.pickImage(file)
                        .then(function(localImageUrl) {
                            scope.uploadInProgress = true;
                            file.dataUrl = localImageUrl;
                            return StreamService.saveImage(scope.stream.id, file);
                        })
                        .then(function(imageSaveResults) {
                            _.assign(scope.stream, imageSaveResults.data);
                        })
                        .catch(function() {
                            growl.error('Unable to save stream image.');
                        })
                        .finally(function() {
                            scope.uploadInProgress = false;
                        });
                    };
                }
            };
        }]);

'use strict';

angular.module('directives.topicSummary')
    .directive('topicItems', [
        function() {
            return {
                scope: {
                    stream: '='
                },
                template: [
                    '<span class="muted-text margin-left-right pull-left" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Items">',
                        '<span class="fa fa-file"></span>',
                        '<span id="itemsCount">{{stream.itemsCount}}</span>',
                    '</span>'
                ].join('\n')
            };
        }]);

'use strict';

angular.module('directives.topicSummary')
    .directive('topicTags', ['_', '$rootScope', 'StreamService','TenantService',
        function(_, $rootScope, streamService, TenantService) {
            return {
                scope: {
                    allowEdit: '@',
                    onTagChange: '&',
                    stream: '='
                },
                template: [
                    '<div class="tag-container">',
                        '<div class="stream-tag-toggle" ng-if="allowEdit">',
                            '<div uib-dropdown is-open="toggleStatus.tagsOpen">',
                                '<a title="Add a tag" uib-dropdown-toggle ng-click="startAddingTag = true;">',
                                    '<i class="fa fa-pencil-square-o"></i>',
                                '</a>',
                                '<ul class="dropdown-menu" role="menu" >',
                                    '<li class="tag-menu-form">',
                                        '<div class="form-group">',
                                            '<label for="tag">Add a tag:</label>',
                                            '<input type="text"',
                                                'class="form-control add-tag"',
                                                'id="tag"',
                                                'uib-typeahead="tag.label for tag in tenantStreamTags | filter: {label:$viewValue}"',
                                                'typeahead-on-select="selectTag($item, $model, $label)"',
                                                'placeholder="New Tag"',
                                                'maxlength="50"',
                                                'ng-model="newTag"',
                                                'ui-keyup="{\'enter\':\'addTag(newTag)\'}"',
                                                'focus-me="startAddingTag">',
                                        '</div>',
                                    '</li>',
                                '</ul>',
                            '</div>',
                        '</div>',
                        '<span class="muted-text">Tags: </span>',
                        '<span ng-hide="stream.streamTags.length">none</span>',
                        '<div class="btn-group btn-group-xs tag-buttons tag-btn-group user-tag-button-group ng-scope" ng-repeat="tag in stream.streamTags">',
                            '<button type="button" class="btn btn-primary tag-button user-tag-button default-cursor" data-toggle="tooltip" data-placement="top">',
                                '{{::tag.label}}',
                            '</button>',
                            '<button type="button" class="btn btn-primary delete-tag" ng-click="deleteTag(tag)" ng-if="allowEdit">',
                                '<span class="glyphicon glyphicon-remove"></span>',
                            '</button>',
                        '</div>',
                    '</div>'
                ].join('\n'),
                link: function(scope) {
                    scope.categoryTitle = streamService.categoryTitle;

                    (function() {
                        scope.toggleStatus = {};
                        return TenantService.getStreamTags()
                        .then(function(tenantStreamTags){
                            scope.tenantStreamTags = tenantStreamTags;
                        });
                    })();

                    scope.selectTag = function(tag) {
                        if(!_.contains(scope.stream.tags, tag.id)) {
                            scope.stream.streamTags.push(tag);
                            scope.stream.tags.push(tag.id);
                            scope.newTag = '';
                            scope.toggleStatus.tagsOpen = false;
                            scope.onTagChange();
                        }
                    };

                    scope.addTag = function(newTag) {
                        if(!_.find(scope.tenantStreamTags, {label: newTag}) && !_.isEmpty(newTag)){
                            TenantService.saveStreamTag({ label: newTag })
                            .then(function(streamTag) {
                                scope.tenantStreamTags.push(streamTag);
                                scope.selectTag(streamTag);
                                // TODO: We will not need this broadcast when modal streambuilder goes away
                                $rootScope.$broadcast('stream-tags-changed', scope.tenantStreamTags);
                            });
                        }
                    };

                    scope.deleteTag = function(tag) {
                        scope.stream.streamTags = _.reject(scope.stream.streamTags, { id: tag.id });
                        scope.stream.tags = _.without(scope.stream.tags, tag.id);
                        scope.onTagChange();
                    };

                }
            };
        }]);



'use strict';

angular.module('attensaApp')
.directive('topicTagFacets', ['_', 'TOPIC_TAGS',
    function(_, TOPIC_TAGS) {
        return {
            scope: {
                tagSelectionDidChange: '&',
                tagSettings: '=',
                type: '@',
                disableChange: '='
            },
            restrict: 'E',
            template: [
                '<div ng-if="type === \'select\'">',
                    '<ui-select multiple ng-model="selectedTags.tags" theme="bootstrap">',
                        '<ui-select-match placeholder="Select one or more classifications to narrow results">{{$item.displayText}}</ui-select-match>',
                        '<ui-select-choices repeat="tag in topicTags | filter: $select.search track by tag.tagText">',
                            '<span ng-bind-html="tag.displayText | highlight: $select.search"></span>',
                        '</ui-select-choices>',
                    '</ui-select>',
                '</div>'
            ].join('\n'),
            link: function(scope) {
                scope.topicTags = _.map(TOPIC_TAGS, function(tag) {
                    return _.assign({}, tag, { selected: false });
                });

                //This one is for the multiselect dropdown mode, it has its own convention for a model
                scope.selectedTags = { tags: _.filter(scope.topicTags, function(tag) {
                    return _.find(scope.tagSettings.tags, { tagText: tag.tagText });
                })};

                scope.updateTagSettingsAndCallback = function() {
                    scope.tagSettings.tags = scope.tagSettingsFromSelectedTags(scope.topicTags);
                    scope.tagSelectionDidChange({ tagSettings: scope.tagSettings });
                };

                scope.$watchCollection('selectedTags.tags', function(newSelectedTags, oldSelectedTags) {
                    if(newSelectedTags !== oldSelectedTags) {
                        _.forEach(scope.topicTags, function(tag) {
                            tag.selected = _.find(newSelectedTags, { tagText: tag.tagText }) ? true : false;
                        });
                        scope.updateTagSettingsAndCallback();
                    }
                });

                scope.tagSettingsFromSelectedTags = function(topicTags) {
                    return _.chain(topicTags)
                    .filter(function(tag) {
                        return tag.selected;
                    })
                    .map(function(tag) {
                        return { tagText: tag.tagText, type: 'topics' };
                    })
                    .value();
                };
            }
        };
    }]);

'use strict';

/*
 * Hides DOM element if the user has permission to perform a specified action
 *
 * Usage:
 * <div hide-with-permission action='FOO' stream-id='BAR' user-id='BAZ'></div>
 *     - 'FOO' is an action defined for a role (e.g. MANAGE_PEOPLE).  If the current user has the action in one
 *             of it's roles, the element will be hidden.  By default, only tenant level roles are searched.
 *     - 'BAR' is a streamID that the action targets.  If supplied, the 'action' search will also be done against
 *             stream roles for the supplied streamID.
 *     - 'BAZ' is a userID to compare to the currently logged in user.  If the id matches the current user, the element
 *             will be shown
 *
 *     All arguments are optional.  But at least one of 'action' or 'user-id' must be supplied.
 */

angular.module('attensaApp')
.directive('hideWithPermission', ['permissionService',
    function(permissionService) {
    return {
        scope: {
            action:   '@',
            streamId: '=?',
            userId:   '=?'
        },
        link: function(scope, element, attr) {
            // We hide the element by default so it won't show in case of failure
            element.hide();

            // TODO: It's kind of nasty to put this in a watch.  Once UI router is implemented we can use $resolve
            // to make sure all our XHR data is loaded before the route is rendered.
            scope.$watch('streamId', function(newValue, oldValue, scope) {
                permissionService.currentUserHasPermission({
                    action: scope.action || undefined,
                    streamId: scope.streamId || undefined,
                    userId: scope.userId || undefined
                })
                .then(function(result) {
                    if(!result) {
                        element.show();
                    }
                });
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('streamTypeIndicator', [function() {
    var streamTypeMap = {
        COLLECTION: {
            style: 'fa-sitemap',
            description: 'Topic'
        },
        BRICK_FTP: {
            style: 'fa-code',
            description: 'Source: XML'
        },
        ATTENSA_FTP: {
            style: 'fa-code',
            description: 'Source: XML'
        },
        XML: {
            style: 'fa-code',
            description: 'Source: XML'
        },
        FACTIVA_SELECT_HTTP: {
            style: 'fa-code',
            description: 'Source: Factiva Select'
        },
        RSS: {
            style: 'fa-rss',
            description: 'Source: RSS'
        },
        TWITTER_SEARCH: {
            style: 'fa-twitter',
            description: 'Source: Twitter'
        },
        BING_SEARCH: {
            style: 'fa-windows',
            description: 'Source: Bing Search'
        },
        ATTENSA_SEARCH: {
            style: 'fa-search',
            description: 'Source: Attensa Search'
        },
        PUBMED_SEARCH: {
            style: 'fa-code',
            description: 'Source: PubMed Search'
        },
        CLINICALTRIALS_SEARCH: {
            style: 'fa-code',
            description: 'Source: ClinicalTrials.gov Search'
        }
    };
    return {
        scope: {
            stream: '='
        },
        replace: true,
        template: '<span class="fa stream-type" ng-class="style()" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{description()}}"></span>',
        link: function(scope, element, attrs) {
            scope.description = function() {
                return scope.stream && streamTypeMap[scope.stream.type] ? streamTypeMap[scope.stream.type].description : '';
            };

            scope.style = function() {
                return scope.stream && streamTypeMap[scope.stream.type] ? streamTypeMap[scope.stream.type].style : '';
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('onDelayedChange', ['$interval', function ($interval) {
    return {
        require: '^ngModel',
        restrict: 'A',
        scope: {
            'onDelayedChange': '&'
        },
        link: function ($scope, elm, attrs, ngModelCtrl) {
            var config = { searchDelayInMs: 1000 };

            ngModelCtrl.$viewChangeListeners.push(function() {
                angular.element(elm).on('keypress', function(evt) {
                    // Enter key pressed, prevent duplicate api calls
                    if (evt.keyCode === 13) {
                        $interval.cancel(config.searchTimeoutPromise);
                    }
                });

                if(config.searchTimeoutPromise) {
                    $interval.cancel(config.searchTimeoutPromise);
                }

                config.searchTimeoutPromise = $interval(function () {
                    $scope.onDelayedChange();
                    $interval.cancel(config.searchTimeoutPromise);
                    delete config.searchTimeoutPromise;
                }, config.searchDelayInMs, 1);
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('topItemsList', ['ItemService', function(itemService) {
    return {
        restrict: 'A',
        scope: {
            streamContext: '@streamId',
            title: '@',
            topListContent: '=',
        },
        templateUrl: '/templates/topList.html',
        transclude: true,
        controller: ['$scope', function($scope) {
            $scope.clickAction = function(item) {
                itemService.openNewModal({
                    hasNext: false,
                    hasPrev: false,
                    itemId: item.id,
                    streamContext: $scope.streamContext
                });
            };
        }]
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('topStreamsList', ['StreamService', function(streamService) {
    return {
        restrict: 'A',
        scope: {
            title: '@',
            topListContent: '=',
        },
        templateUrl: '/templates/topList.html',
        transclude: true,
        controller: ['$scope', function($scope) {
            $scope.clickAction = function(stream) {
                streamService.openStreamDetailModal(stream);
            };
        }]
    };
}]);

'use strict';

angular.module('ImgFallback', [])
    .directive('fallbackSrc', ['$interval', function($interval) {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                element.on('error', function() {
                    element[0].src = attr.fallbackSrc;
                    var ngSrc = attr.ngSrc;
                    var failedSrc = attr.failedSrc;
                    var retryCount = (typeof attr.retryCount === 'undefined') ? 1 : (parseInt(attr.retryCount) + 1);
                    attr.retryCount = retryCount;
                    if(retryCount < 5) {
                        $interval(function () {
                            element[0].src = ngSrc + '?' + new Date().getTime();
                        }, 3000, 1);
                    } else {
                        element[0].src = failedSrc;
                    }
                });
                element.on('load', function() {
                    var ngSrc = attr.ngSrc;
                    if(element.src === ngSrc.substring(0, ngSrc.indexOf('?'))) {
                        attr.retryCount = 0;
                    }
                });
            }
        };
    }])
    .directive('loadingSrc', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                element[0].src = attr.loadingSrc;
                var img = angular.element('<img />');
                img.src = scope.ngSrc;
                img.on('load', function() {
                    element[0].src = img.src;
                });
            }
        };
    });
'use strict';

angular.module('attensaApp')
.component('briefingCard', {
    bindings: {
        briefing: '=',
        user: '=',
        template: '='
    },
    transclude: true,
    template: [
        '<div class="briefing-card clearfix" ng-style="::$ctrl.backgroundImageStyle">',
            '<div class="media">',
                '<div class="briefing-tile-body">',
                    '<h4 class="media-heading">',
                        '<div class="ellipsis-color">',
                            '<span hide-with-permission action="MANAGE_TENANT" class="overflow-ellipsis" style="width: 270px">',
                                '<span class="stream-tile-title" title="{{::$ctrl.briefing.briefingTitle}}">{{::$ctrl.briefing.briefingTitle}}</span>',
                            '</span>',
                        '<a show-with-permission action="MANAGE_TENANT" class="overflow-ellipsis" style="width: 270px" ng-href="/briefings/{{$ctrl.briefing.id}}/details">',
                                '<span class="stream-tile-title" title="{{::$ctrl.briefing.briefingTitle}}">{{::$ctrl.briefing.briefingTitle}}</span>',
                            '</a>',
                        '</div>',
                    '</h4>',
                    '<p class="briefing-card-description line-clamp" title="Template: {{::$ctrl.briefing.briefingTemplateTitle}}">Template: {{::$ctrl.template.title}}</p>',
                '</div>',
            '</div>',
            '<briefing-summary briefing="$ctrl.briefing"></briefing-summary>',
            '<briefing-subscribe-button briefing="$ctrl.briefing" user="$ctrl.user"></briefing-subscribe-button>',
            '<briefing-publish-button briefing="$ctrl.briefing" user="$ctrl.user"></briefing-publish-button>',
        '</div>'
    ].join('\n'),
    controller: ['$state', function($state) {
        this.state = $state;
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingContentChooser', {
    bindings: {
        addSources: '&',
        initialShow: '=',
        sources: '='
    },
    transclude: true,
    template: [
        '<div class="panel panel-default">',
            '<div class="panel-heading">',
                '<h3 class="panel-title"><a ng-click="$ctrl.hideSources = !$ctrl.hideSources" click-event eventname="add_source_panel_opened">',
                    '<i class="fa fa-plus"></i> Add new sources</a>',
                '</h3>',
            '</div>',
            '<div class="panel-body" uib-collapse="$ctrl.hideSources">',
                '<div class="create-stream-tile" style="float: none">',
                    '<div class="media">',
                        '<div class="media-left">',
                            '<div class="icon-tile">',
                                '<span class="fa fa-book"></span>',
                            '</div>',
                        '</div>',
                        '<div class="media-body">',
                            '<h4 class="media-heading">Select from catalogs</h4>',
                            '<button class="btn btn-default"',
                                    'ng-click="$ctrl.launchSourceFinder()"',
                                    'click-event eventname="add_briefing-source_selected" eventargs=\'{"type": "catalogs"}\')>Start</button>',
                        '</div>',
                    '</div>',
                '</div>',
                '<div>',
                    '<hr>',
                    '<create-source-card title="RSS feed" stream-type="RSS" glyph-class="fa fa-rss"',
                                        'sources-were-selected="$ctrl.addSources({$sourceIds: sourceIds})"',
                                        'existing-sources="$ctrl.sources">',
                    '</create-source-card>',
                    '<create-source-card title="Attensa search" stream-type="ATTENSA_SEARCH"',
                                        'glyph-class="fa fa-search"',
                                        'sources-were-selected="$ctrl.addSources(sourceIds)"',
                                        'existing-sources="$ctrl.sources">',
                    '</create-source-card>',
                    '<create-source-card title="Twitter" stream-type="TWITTER_SEARCH" glyph-class="fa fa-twitter"',
                                        'sources-were-selected="$ctrl.addSources({$sourceIds: sourceIds})""',
                                        'existing-sources="$ctrl.sources">',
                    '</create-source-card>',
                    '<create-source-card title="Bing" stream-type="BING_SEARCH" glyph-class="fa fa-windows"',
                                        'sources-were-selected="$ctrl.addSources({$sourceIds: sourceIds})""',
                                        'existing-sources="$ctrl.sources">',
                    '</create-source-card>',
                    '<create-source-card title="ClinicalTrials.gov" stream-type="CLINICALTRIALS_SEARCH"',
                                        'glyph-class="fa fa-user-md"',
                                        'sources-were-selected="$ctrl.addSources({$sourceIds: sourceIds})""',
                                        'existing-sources="$ctrl.sources">',
                    '</create-source-card>',
                    '<create-source-card title="Pubmed" stream-type="PUBMED_SEARCH" logo-image="/images/pubmed.gif"',
                                        'sources-were-selected="$ctrl.addSources({$sourceIds: sourceIds})""',
                                        'existing-sources="$ctrl.sources">',
                    '</create-source-card>',
                '</div>',
            '</div>',
        '</div>'
    ].join('\n'),
    controller: ['$uibModal', function($uibModal){
        var self = this;

        this.launchSourceFinder = function(){
            $uibModal.open({
                templateUrl: '/templates/sourceFinder/sourceFinder.html',
                controller: 'SourceFinderCtrl',
                controllerAs: 'sourceFinderCtrl',
                keyboard: true,
                backdrop: 'static',
                windowClass: 'modal-xl',
                resolve: {
                    existingSources: function() { return self.sources; },
                    parentStreamId: function() { return ''; },
                    topicsOnly: function(){ return true; }
                }
            }).result
            .then(function(sources){
                self.addSources({ $sourceIds: sources });
            });
        };

        this.$onInit = function(){
            self.hideSources = !self.initialShow;
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingEditDetails', {
    bindings: {
        briefing: '=',
        briefingSchedule: '=',
        hideNonScheduleItems: '=',
        form: '=',
        endModeChanged: '&',
        frequencyChanged: '&',
        selectedDays: '=',
        selectedTemplate: '='
    },
    transclude: true,
    template: [
        '<div>',
            '<div class="row">',
                '<div ng-show="$ctrl.briefing.enabled && !$ctrl.hideNonScheduleItems" class="col-md-3">',
                    '<div class="form-group">',
                        '<label>Email Subject Line</label>',
                        '<input class="form-control" name="title" id="briefing-subject-line" ng-model="$ctrl.briefing.briefingTitle" required>',
                        '<div ng-if="$ctrl.form.title.$touched">',
                            '<div class="has-error" ng-messages="$ctrl.form.title.$error">',
                                '<small id="email-subject-line-required-message" class="help-block" ng-message="required">Email subject line is required</small>',
                            '</div>',
                        '</div>',
                    '</div>',
                '</div>',
                '<briefing-schedule-mode-selector briefing="$ctrl.briefing" briefing-schedule="$ctrl.briefingSchedule"></briefing-schedule-mode-selector>',
                '<div ng-show="$ctrl.briefing.enabled && $ctrl.briefingSchedule.summary" class="col-md-5">',
                    '<div class="form-group">',
                        '<label>Current Schedule</label>',
                        '<p ng-bind-html="$ctrl.briefingSchedule.summary"></p>',
                    '</div>',
                '</div>',
                '<div ng-show="$ctrl.briefing.enabled && !$ctrl.hideNonScheduleItems" ng-class="{ \'col-md-2\': !$ctrl.hideNonScheduleItems, \'col-md-4\': $ctrl.hideNonScheduleItems }">',
                    '<div class="form-group">',
                        '<label>Template</label><br/>',
                        '<a title="{{ $ctrl.selectedTemplate.title || \'Select\' }}" id="template-selection-link" ng-click="$ctrl.openTemplateBrowser()" style="width: 100%">{{ $ctrl.selectedTemplate.title || \'Select\' }}</a>',
                    '</div>',
                '</div>',
            '</div>',
            '<div class="row">',
                '<div ng-show="$ctrl.briefing.enabled && !$ctrl.hideNonScheduleItems" class="col-md-6">',
                    '<div class="form-group">',
                        '<label>Description</label>',
                        '<textarea id="briefing-description" ng-model="$ctrl.briefing.description" class="form-control"></textarea>',
                    '</div>',
                '</div>',
                '<div ng-show="$ctrl.briefing.enabled && !$ctrl.hideNonScheduleItems" class="col-md-6">',
                    '<div class="form-group">',
                        '<label>Briefing Title</label>',
                        '<textarea id="briefing-title" ng-model="$ctrl.briefing.templateTitle" class="form-control"></textarea>',
                    '</div>',
                '</div>',
            '</div>',
            '<div ng-show="$ctrl.briefing.enabled" class="panel panel-default">',
                '<div class="panel-heading">',
                    '<p class="pull-right text-info" ng-show="$ctrl.nextScheduledDateFormatted()"><strong>Next scheduled send date:</strong> {{$ctrl.briefingSchedule.scheduleMode !== \'MANUAL\' && !$ctrl.briefingSchedule.defaultSchedule ? $ctrl.nextScheduledDateFormatted() : \'None\'}}</p>',
                    '<h3 class="panel-title">Schedule</h3>',
                '</div>',
                '<div ng-show="$ctrl.briefingSchedule.scheduleMode === \'MANUAL\'" class="panel-body">',
                    'Manual briefings do not have a schedule. Select recurring schedule mode from above.',
                '</div>',
                '<ul class="list-group" ng-if="$ctrl.briefingSchedule.scheduleMode !== \'MANUAL\'">',
                    '<li id="briefing-send-date-section" class="list-group-item">',
                        '<div class="row">',
                            '<div class="col-md-2">',
                                '<briefing-start-date briefing-schedule="$ctrl.briefingSchedule" form="form"></briefing-start-date>',
                            '</div>',
                            '<div class="col-md-2">',
                                '<briefing-send-time briefing-schedule="$ctrl.briefingSchedule" form="form"></briefing-send-time>',
                            '</div>',
                            '<div class="col-md-4">',
                                '<briefing-timezone-selector briefing-schedule="$ctrl.briefingSchedule"></briefing-timezone-selector>',
                            '</div>',
                        '</div>',
                    '</li>',
                    '<li id="briefing-recurring-section" class="list-group-item" ng-show="$ctrl.briefingSchedule.scheduleMode === \'RECURRING\'">',
                        '<fieldset>',
                            '<div class="row">',
                                '<div class="col-md-6">',
                                    '<briefing-repeat-selector briefing-schedule="$ctrl.briefingSchedule" frequency-changed="$ctrl.frequencyChanged()"></briefing-repeat-selector>',
                                '</div>',
                                '<div class="col-md-6" id="repeats-on-days">',
                                    '<briefing-repeat-days briefing-schedule="$ctrl.briefingSchedule" selected-days="$ctrl.selectedDays"></briefing-repeat-days>',
                                '</div>',
                            '</div>',
                        '</fieldset>',
                    '</li>',
                '</ul>',
            '</div>',
        '</div>'
    ].join('\n'),
    controller: ['moment', 'TemplateService', function(moment, templateService){
        var self = this;

        var formattedGenerator = function(inDate, timeZone) {
            return inDate ? moment.utc(inDate).tz(timeZone).format('ddd, MMM Do YYYY, h:mm a') : undefined;
        };

        this.isRepeatable = function(){
            return self.briefingSchedule.freq === 'WEEKLY' || self.briefingSchedule.freq === 'BIWEEKLY';
        };

        this.nextScheduledDateFormatted = function(){
            if(this.briefingSchedule) {
                return formattedGenerator(this.briefingSchedule.nextScheduledDate, this.briefingSchedule.timeZone);
            }
        };

        this.openTemplateBrowser = function(){
            templateService.openTemplateBrowser(this.briefing);
        };

    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingEnabledSwitch', {
    bindings: {
        briefing: '=',
        toggleBriefing: '&'
    },
    transclude: true,
    template: [
    '<div class="row graphic-switch">',
        '<div class="col-md-2">',
            '<div ng-click="$ctrl.toggleBriefing()" class="switch-row well briefing-switch" style="padding: 10px 0;">',
                '<div><span class="ugly-switch graphic-switch" ng-class="{\'ugly-switch-off\': !$ctrl.briefing || !$ctrl.briefing.enabled, \'ugly-switch-on\': $ctrl.briefing && $ctrl.briefing.enabled}"></span></div>',
                '<div class="graphic-switch-label open-sans-extra-bold">{{$ctrl.briefing.enabled ? \'ON\' : \'OFF\'}}</div>',
            '</div>',
        '</div>',
        '<div ng-show="!$ctrl.briefing.enabled" class="col-md-10">',
            '<div class="container-fluid">',
                '<div class="jumbotron">',
                    '<h2>Briefing Disabled</h2>',
                    '<p>Enable this briefing by flipping the switch to the left.</p>',
                '</div>',
            '</div>',
        '</div>',
    '</div>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('briefingFrequencySelector', {
    bindings: {
        briefingSchedule: '='
    },
    transclude: true,
    template: [
    '<div class="form-group" ng-show="$ctrl.isFrequencyRepeatType()">',
        '<label>Frequency</label>',
        '<div class="form-group form-inline clearfix">',
            '<label style="color:#555555;font-weight:normal;">Repeat every</label>',
            '<select class="form-control" style="margin: 0px 10px;" name="briefing_frequency" ng-model="$ctrl.briefingSchedule.interval" ng-options="item for item in $ctrl.intervals"></select>',
            '<label style="color:#555555;font-weight:normal;"> {{$ctrl.frequencyLabelMap[$ctrl.briefingSchedule.freq]}}</label>',
        '</div>',
    '</div>'
    ].join('\n'),
    controller: ['_', function(_){
        var self = this;

        this.intervals = _.range(1, 32);

        this.isFrequencyRepeatType = function(){
            return self.briefingSchedule ? _.contains(['HOURLY', 'DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'], self.briefingSchedule.freq) : false;
        };

        this.frequencyLabelMap = {
            'HOURLY': 'hours',
            'DAILY': 'days',
            'WEEKLY': 'weeks',
            'MONTHLY': 'months'
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingHistoryActivities', {
    bindings: {
        history: '=',
        noOffset: '='
    },
    transclude: true,
    template: [
        '<div ng-if="::$ctrl.history.sent" class="row">',
            '<ng-transclude></ng-transclude>',
            '<div class="col-sm-2" ng-class="{ \'col-sm-offset-1\': !$ctrl.noOffset }">',
                '<briefing-history-activity-item history="$ctrl.history" activity="briefing_email_delivered" label="delivered"></briefing-history-activity-item>',
            '</div>',
            '<div class="col-sm-2">',
                '<briefing-history-activity-item history="$ctrl.history" activity="briefing_email_opened" label="opened"></briefing-history-activity-item>',
            '</div>',
            '<div class="col-sm-2">',
                '<briefing-history-activity-item history="$ctrl.history" activity="briefing_email_clicked" label="clicked"></briefing-history-activity-item>',
            '</div>',
            '<div class="col-sm-2">',
                '<briefing-history-activity-item history="$ctrl.history" activity="briefing_email_bounced" label="bounced"></briefing-history-activity-item>',
            '</div>',
            '<div class="col-sm-2">',
                '<briefing-history-activity-item history="$ctrl.history" activity="briefing_email_dropped" label="dropped"></briefing-history-activity-item>',
            '</div>',
        '</div>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('briefingHistoryActivityItem', {
    bindings: {
        history: '=',
        activity: '@',
        label: '@'
    },
    transclude: true,
    template: [
        '<div class="chart-wrapper">',
            '<div class="analytics-badge"><span class="analytics-badge-number">{{$ctrl.countByActivity()}}</span><br>{{::$ctrl.label}}</div>',
        '</div>'
    ].join('\n'),
    controller: ['_', function(_) {
        var self = this;

        this.countByActivity = function(){
            var activityNames = _.chain(self.activity).split(',').map(_.trim).value();

            return _.chain(self.history.activities)
            .filter(function(val){
                return _.includes(activityNames, val.activity);
            })
            .uniq('emailAddress')
            .size()
            .value();
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingHistoryItem', {
    bindings: {
        briefingHistory: '=',
        historyIndex: '=',
        userStatuses: '='
    },
    transclude: true,
    template: [
        '<div class="row">',
            '<div class="col-md-12">',
                '<table class="table table-condensed borderless">',
                    '<tr>',
                        '<td class="table-label">Subject:</td>',
                        '<td ng-show="$ctrl.briefingHistory.sent">',
                            '<a href="/briefing?id={{::$ctrl.briefingHistory.briefingId}}&briefingHistoryId={{::$ctrl.briefingHistory.id}}" target="_blank">{{::$ctrl.briefingHistory.subject}}</a>',
                        '</td>',
                        '<td ng-show="!$ctrl.briefingHistory.sent">{{::$ctrl.briefingHistory.subject}}</a>',
                        '</td>',
                    '</tr>',
                    '<tr>',
                        '<td class="table-label">Send time:</td><td>{{::$ctrl.briefingHistory.created | amDateFormat:\'MMM Do YYYY, h:mm a\'}}</td>',
                    '</tr>',
                    '<tr>',
                        '<td class="table-label">Type:</td><td>{{::$ctrl.briefingHistory.type}}</td>',
                    '</tr>',
                    '<tr>',
                        '<td class="table-label">Sent:</td>',
                        '<td>',
                            '<h4 class="spaceless">',
                                '<i class="fa" tooltip-placement="top" uib-tooltip="{{::$ctrl.briefingHistory.sent ? \'Successfully Sent\' : \'Did Not Send\'}}" ng-class="{\'fa-check text-success\': $ctrl.briefingHistory.sent, \'fa-exclamation-triangle text-danger\':!$ctrl.briefingHistory.sent}"></i>',
                            '</h4>',
                        '</td>',
                    '</tr>',
                    '<tr>',
                        '<td class="table-label">Number of items sent:</td><td>{{::$ctrl.briefingHistory.numberOfItemsSent}}</td>',
                    '</tr>',
                    '<tr>',
                        '<td class="table-label">Note:</td><td>{{::$ctrl.briefingHistory.note}}</td>',
                    '</tr>',
                    '<tr>',
                        '<td class="table-label">Recipients ({{::$ctrl.briefingHistory.recipients.length}}):</td>',
                        '<td>',
                            '<briefing-recipients briefing-history="$ctrl.briefingHistory" history-index="$ctrl.historyIndex" user-statuses="$ctrl.userStatuses"></briefing-recipients>',
                        '</td>',
                    '</tr>',
                '</table>',
            '</div>',
        '</div>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('briefingPreviewLink', {
    bindings: {
        briefing: '='
    },
    transclude: true,
    template: [
        '<div class="flex-row" style="clear: both;">',
            '<a title="Preview" ng-click="$ctrl.viewPreview()">Preview</a>',
        '</div>'
    ].join('\n'),
    controller: ['$uibModal', function($uibModal) {
        var self = this;

        this.viewPreview = function() {
            var modalInstance = $uibModal.open({
                templateUrl: '/templates/briefingPreviewModal.html',
                controller: 'BriefingPreviewCtrl',
                size: 'lg',
                keyboard: false,
                resolve: {
                    briefingId: function() {
                        return self.briefing.id;
                    }
                }
            });
            return modalInstance.result;
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingRecipients', {
    bindings: {
        briefingHistory: '=',
        historyIndex: '=',
        userStatuses: '=',
        historyFilter: '=',
    },
    transclude: true,
    template: [
        '<div class="forced-scroll-div">',
            '<ul class="list-group">',
                '<li ng-repeat="recipient in $ctrl.filteredRecipients() | orderBy:\'+\'" class="list-group-item">',
                    '<span class="pull-right label {{$ctrl.statusDisplayClass(recipient, $ctrl.briefingDetails.historyIndex)}}" ng-if="$ctrl.briefingHistory.sent">',
                        '{{$ctrl.statusDisplayText(recipient, $ctrl.historyIndex)}}',
                    '</span> {{recipient}}',
                '</li>',
            '</ul>',
        '</div>'
    ].join('\n'),
    controller: ['_', 'EMAIL_ACTIVITIES', function(_, EMAIL_ACTIVITIES) {
        var self = this;

        this.statusDisplayText = function(emailAddress, briefingHistoryIndex) {
            var status = self.userStatuses[briefingHistoryIndex] ? self.userStatuses[briefingHistoryIndex][emailAddress] : {};
            return status ? EMAIL_ACTIVITIES[status.activity].displayText : 'Queued';
        };

        this.statusDisplayClass = function(emailAddress, briefingHistoryIndex) {
            var typeClassMap = {
                INFO: 'label-default',
                WARN: 'label-warning',
                ERROR: 'label-danger',
                SUCCESS: 'label-success'
            };

            var status = this.userStatuses[briefingHistoryIndex] ? this.userStatuses[briefingHistoryIndex][emailAddress] : undefined;
            if(!status) {
                return 'label-default';
            } else {
                return typeClassMap[EMAIL_ACTIVITIES[status.activity].type] || 'label-default';
            }
        };

        this.filteredRecipients = function(){
            if(this.historyFilter){
                var filters = _.map(this.historyFilter.split(','), function(filter){ return _.trim(filter); });
                return _.chain(this.userStatuses[this.historyIndex])
                        .filter(function(status){
                            return filters.indexOf(status.activity) !== -1;
                        }).map('emailAddress').value();
            } else{
                return this.briefingHistory.recipients;
            }
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingRepeatDays', {
    bindings: {
        briefingSchedule: '=',
        selectedDays: '='
    },
    transclude: true,
    template: [
    '<div class="form-group" ng-show="$ctrl.isRepeatable()">',
        '<label class="clearfix">Repeats on</label><br/>',
        '<div class="form-group" ng-form="selectedDaysForm">',
            '<input type="hidden" ng-model="$ctrl.selectedDays" name="selectedDays">',
            '<div class="btn-group briefing-repeat-days" >',
                '<buton type="button" class="btn btn-default" ng-model="$ctrl.selectedDays[\'SU\']" uib-btn-checkbox> Su</buton>',
                '<buton type="button" class="btn btn-default" ng-model="$ctrl.selectedDays[\'MO\']" uib-btn-checkbox> Mo</buton>',
                '<buton type="button" class="btn btn-default" ng-model="$ctrl.selectedDays[\'TU\']" uib-btn-checkbox> Tu</buton>',
                '<buton type="button" class="btn btn-default" ng-model="$ctrl.selectedDays[\'WE\']" uib-btn-checkbox> We</buton>',
                '<buton type="button" class="btn btn-default" ng-model="$ctrl.selectedDays[\'TH\']" uib-btn-checkbox> Th</buton>',
                '<buton type="button" class="btn btn-default" ng-model="$ctrl.selectedDays[\'FR\']" uib-btn-checkbox> Fr</buton>',
                '<buton type="button" class="btn btn-default" ng-model="$ctrl.selectedDays[\'SA\']" uib-btn-checkbox> Sa</buton>',
            '</div>',
            '<div class="has-error" ng-messages="selectedDaysForm.selectedDays.$error">',
                '<small id="by-days-required" class="help-block" ng-message="required">Day selection is required when repeating weekly</small>',
            '</div>',
        '</div>',
    '</div>'
    ].join('\n'),
    controller: ['$scope', '_', function($scope, _){
        var self = this;
        var setValidity = function(){
            if(self.briefingSchedule){
                if(self.isRepeatable() && !_.reduce(self.selectedDays, function(accumulated, current){ return accumulated || current;})){
                    $scope.selectedDaysForm.selectedDays.$setValidity('required', false);
                }else{
                    $scope.selectedDaysForm.selectedDays.$setValidity('required', true);
                }
            }
        };

        this.$onInit = function(){
            $scope.$watchCollection(function(){ return self.selectedDays; }, setValidity);
            $scope.$watch(function(){ return self.briefingSchedule ? self.briefingSchedule.freq : self.briefingSchedule; }, setValidity);
        };

        this.isRepeatable = function(){
            return this.briefingSchedule && _.includes(['WEEKLY', 'BIWEEKLY'], this.briefingSchedule.freq);
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingRepeatSelector', {
    bindings: {
        briefingSchedule: '=',
        frequencyChanged: '&'
    },
    transclude: true,
    template: [
    '<div class="form-group">',
        '<label>Repeats</label>',
        '<select ng-change="$ctrl.frequencyChanged()" class="form-control" ng-model="$ctrl.briefingSchedule.freq" ng-options="mode.key as mode.val for mode in $ctrl.repeatModes"></select>',
    '</div>'
    ].join('\n'),
    controller: ['UtilService', function(utilService){
        this.repeatModes = utilService.repeatModes;
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingSendTime', {
    bindings: {
        briefingSchedule: '=',
        form: '='
    },
    transclude: true,
    template: [
        '<div class="form-group">',
            '<label>Send Time</label>',
            '<input class="form-control" name="sendTime" type="text" bs-timepicker data-minute-step="1" arrow-behavior="picker" length="1" ng-model="$ctrl.briefingSchedule.sendTimeObj" id="briefing-time" required>',
            '<div ng-if="$ctrl.form.sendTime.$error.date">',
                '<div class="has-error">',
                    '<small class="help-block">Invalid Time (Must be in hh:mm AM/PM format)</small>',
                '</div>',
            '</div>',
            '<div ng-if="$ctrl.form.sendTime.$touched">',
                '<div class="has-error" ng-messages="$ctrl.form.sendTime.$error">',
                    '<small class="help-block" ng-message="required">Send time is required</small>',
                '</div>',
            '</div>',
        '</div>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('briefingSendInfo', {
    bindings: {
        briefing: '='
    },
    transclude: true,
    template: [
        '<div class="flex-row" style="padding-top: 5px;">',
            '<div class="glyphicon glyphicon-send"></div>',
            '<div style="padding-left: 8px;" >',
                '<div ng-if="$ctrl.briefing.schedule.nextScheduledDate" title="Next Send: {{::$ctrl.briefing.schedule.nextScheduledDate | amDateFormat:\'MMM Do YYYY, h:mm a\' }}">Next: {{::$ctrl.briefing.schedule.nextScheduledDate | amDateFormat:\'MMM Do YYYY, h:mm a\' }}</div>',
                '<div ng-if="!$ctrl.briefing.schedule.nextScheduledDate" title="Next Send: On Demand">Next: On Demand</div>',
            '</div> ',
        '</div> '
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('briefingScheduleInfo', {
    bindings: {
        briefing: '='
    },
    transclude: true,
    template: [
        '<div class="flex-row" title="Schedule: {{::$ctrl.filteredFrequencies($ctrl.briefing.schedule)}}">',
            '<div class="glyphicon glyphicon-calendar"></div>',
            '<div style="padding-left: 8px;"> {{::$ctrl.filteredFrequencies($ctrl.briefing.schedule)}}</div>',
        '</div>'
    ].join('\n'),
    controller: ['UtilService', function(utilService) {
        this.filteredFrequencies = utilService.filteredFrequencies;
    }]
});

'use strict';

angular.module('attensaApp')
    .component('briefingSourceList', {
        bindings: {
            sources: '=',
            removeSource: '&',
            hideOutLinks: '=',
            hidePreview: '<',
            sourcesReordered: '&'
        },
        template: [
            '<div class="source-tree" ui-tree="$ctrl.treeOptions" data-empty-placeholder-enabled="false">',
                '<ul class="sources-list" ui-tree-nodes ng-model="$ctrl.sources">',
                    '<li class="source-list animated-list" ng-repeat="source in $ctrl.sources" ui-tree-node collapsed="false">',
                        '<h5 ui-tree-handle><stream-type-indicator stream="source"></stream-type-indicator> {{::source.title || genTitle(source)}}</h5>',
                        '<div class="action-links pull-right" ng-hide="hideLinks">',
                            '<span><a ng-click="$ctrl.removeSource({sourceId: source.id})")>Remove</a> / </span>',
                            '<span ng-if="source.tenantId && !$ctrl.hideOutLinks"><a ui-sref="editTopic.articles({ streamId: source.id })">Edit</a> / </span>',
                            '<span ng-if="!$ctrl.hidePreview"><a ng-click="$ctrl.previewSource(source.id)")>Preview</a> <span ng-hide="$ctrl.hideOutLinks">/</span> </span>',
                            '<a ng-hide="$ctrl.hideOutLinks" ui-sref="topic({ streamId: source.id })">Read</a>',
                        '</div>',
                        '<item-preview-list uib-collapse="$ctrl.previewIsHidden(source.id)" items="$ctrl.previewItems[source.id]"></item-preview-list>',
                        '<div uib-collapse="$ctrl.previewIsHidden(source.id)" ng-if="!$ctrl.previewIsHidden(source.id) && $ctrl.previewItems[source.id].length === 0">',
                            '<source-list-no-results></source-list-no-results>',
                        '</div>',
                    '</li>',
                '</ul>',
            '</div>'
        ].join('\n'),
        controller: ['_', 'ItemService', 'PreviewService', function(_, ItemService, PreviewService){
            var self = this;

            this.treeOptions = {
              dropped: function($evt){
                var sources = _.cloneDeep(self.sources);
                sources.splice($evt.dest.index, 0, sources.splice($evt.source.index, 1)[0]); 
                self.sourcesReordered({$sources: sources });
              }
            };

            this.previewItems = { };

            this.previewSource = function(streamId) {
                if(!self.previewIsHidden(streamId)) {
                    self.previewedStreamId = null;
                } else {
                    return ItemService.searchItemsInStream({ streamId: streamId, rows: 10 })
                    .then(function(searchRes) {
                        self.previewItems[streamId] = searchRes.data.content;
                        self.previewedStreamId = streamId;
                    });
                }
            };

            this.previewIsHidden = function(streamId) {
                return streamId !== this.previewedStreamId;
            };

            this.genTitle = PreviewService.generateTitle;
        }]
    });

'use strict';

angular.module('attensaApp')
    .component('briefingSources', {
        bindings: {
            streams: '<',
            hideOutLinks: '<',
            removeSource: '&',
            sourcesReordered: '&'
        },
        transclude: true,
        template: [
            '<div class="panel panel-default">',
                '<div class="panel-heading">',
                    '<h3 class="panel-title">Existing sources for this briefing</h3>',
                '</div>',
                '<div class="panel-body">',
                    '<briefing-source-list',
                        'ng-if="$ctrl.sources && !$ctrl.fetching"',
                        'sources="$ctrl.sources"',
                        'remove-source="$ctrl.removeSource({$sourceId: sourceId})"',
                        'hide-out-links="$ctrl.hideOutLinks" ' +
                        'sources-reordered="$ctrl.reorder($sources)">',
                    '</briefing-source-list>',
                    '<spinner ng-if="$ctrl.fetching"></spinner>',
                '</div>',
            '</div>'
        ].join('\n'),
        controller: ['BriefingService', function(briefingService){
            var self = this;

            this.$onChanges = function(){
                if(self.streams){
                    self.sources = self.streams;
                    self.fetching = false;
                }
            };

            this.reorder = function(sources){
                self.fetching = true;
                self.sourcesReordered({$sources: sources});
            };
        }]
    });

'use strict';

angular.module('attensaApp')
.component('briefingSubscribers', {
    bindings: {
        briefing: '=',
        dismiss: '&'
    },
    template: [
        '<div class="modal-body generic-modal-content">',
            '<h2>Subscribers <span>({{$ctrl.briefing.subscribersCount}})</span><a ng-click="$ctrl.dismiss()" class="fa fa-times muted pull-right modal-close-x follower-modal-close-x" aria-hidden="true"></a></h2>',
            '<h4 class="text-muted">{{$ctrl.briefing.title}}</h4>',
            '<div class="row">',
                '<div class="col-md-6">',
                    '<form role="search">',
                        '<input type="text" class="form-control" placeholder="Search People" ng-model="$ctrl.searchTerm"',
                                'ng-change="$ctrl.searchSubscribers($ctrl.searchTerm)" ng-model-options="{debounce: 1000}" maxlength="100">',
                        '<a ng-click="$ctrl.searchSubscribers()" ng-show="$ctrl.searchTerm"',
                            'class="glyphicon glyphicon-remove-sign form-control-feedback search-clear"></a>',
                    '</form>',
                '</div>',
                '<div class="col-md-6">',
                    '<button class="btn btn-default pull-right"',
                            'ng-click="$ctrl.emailAllSubscribers()"',
                            'ng-disabled="!$ctrl.paging.totalElements"',
                            'title="Email all subscribers">',
                        '<span class="fa fa-envelope-o"></span>',
                    '</button>',
                    '<button class="btn btn-default pull-right margin-left-right"',
                        'export-to-csv',
                        'format-data="$ctrl.fetchForCSV()"',
                        'filename="subscribers.csv"',
                        'ng-disabled="!$ctrl.paging.totalElements"',
                        'title="Download CSV file of all subscribers">',
                        '<span class="fa fa-download"></span>',
                    '</button>',
                '</div>',
            '</div>',
            '<table ng-hide="$ctrl.fetching" class="table table-striped scrollable-table followers-view-table">',
                '<thead>',
                    '<tr>',
                        '<th style="width:33.33%;">',
                            '<sort-link  label="First Name"',
                                        'key="firstNameLower"',
                                        'sort="$ctrl.paging.sort"',
                                        'sort-direction="$ctrl.paging.sortDirection"',
                                        'on-sort="$ctrl.doSort($sort, $sortDirection)"></sort-link>',
                        '</th>',
                        '<th style="width:33.33%;">',
                            '<sort-link  label="Last Name"',
                                        'key="lastNameLower"',
                                        'sort="$ctrl.paging.sort"',
                                        'sort-direction="$ctrl.paging.sortDirection"',
                                        'on-sort="$ctrl.doSort($sort, $sortDirection)"></sort-link>',
                        '</th>',
                        '<th style="width:33.33%;">',
                            '<sort-link  label="Email Address"',
                                'key="emailAddress"',
                                'sort="$ctrl.paging.sort"',
                                'sort-direction="$ctrl.paging.sortDirection"',
                                'on-sort="$ctrl.doSort($sort, $sortDirection)"></sort-link>',
                        '</th>',
                    '</tr>',
                '</thead>',
                '<tbody class="on-modal followers-infinite-scroll-container" infinite-scroll="$ctrl.fetchNextPage()" infinite-scroll-distance="1" infinite-scroll-container=\'".followers-infinite-scroll-container"\'>',
                    '<tr ng-repeat="subscriber in $ctrl.subscribers">',
                        '<td style="width:33.33%;">{{subscriber.firstName}}</td>',
                        '<td style="width:33.33%;">{{subscriber.lastName}}</td>',
                        '<td style="width:33.33%;">{{subscriber.emailAddress}}</td>',
                    '</tr>',
                '</tbody>',
            '</table>',
            '<spinner ng-show="$ctrl.fetching"></spinner>',
            '<div ng-if="!$ctrl.paging.totalElements && !$ctrl.fetching" class="flex-center"><h3>No matching subscribers.</h3></div>',
            '<div class="row" style="padding-top: 15px;" ng-hide="$ctrl.fetching">',
                '<div class="col-md-offset-5 col-md-6" ng-show="$ctrl.subscribers.length && !($ctrl.paging.first && $ctrl.paging.last)">',
                    '<uib-pagination ng-if="$ctrl.paging.totalElements"',
                                    'total-items="$ctrl.paging.totalElements"',
                                    'ng-model="$ctrl.paging.pagerPage"',
                                    'items-per-page="$ctrl.paging.rows"',
                                    'ng-change="$ctrl.fetchSubscribers()"',
                                    'max-size="5"',
                                    'boundary-link-numbers="true"',
                                    'previous-text="&lsaquo;"',
                                    'next-text="&rsaquo;">',
                    '</uib-pagination>',
                '</div>',
            '</div>',
        '</div>',
        '<div class="modal-footer">',
            '<button type="button" class="btn btn-primary" ng-click="$ctrl.dismiss()">Close</button>',
        '</div>'
    ].join('\n'),
    controller: ['_', '$window', 'BriefingService', 'UserService', 'eventService', function(_, $window, briefingService, userService, eventService) {
        var self = this;

        this.$onInit = function () {
            self.paging = { rows: 50, page: 0, pagerPage: 1, sort: 'lastNameLower', sortDirection: 'desc' };
            self.fetchSubscribers();
        };

        this.doSort = function(sort, sortDirection){
            _.assign(self.paging, {page: 0, pagerPage: 1, sort: sort, sortDirection: sortDirection});
            self.fetchSubscribers();
        };

        this.emailAllSubscribers = function(){
            briefingService.fetchSubscribers(self.briefing.id, self.paging.totalElements)
            .then(function(followersRes) {
                var followers = _.pluck(followersRes.content, 'emailAddress').join(',');
                $window.open('mailto:' + followers + '?subject=' + self.briefing.briefingTitle);
            });
        };

        this.fetchForCSV = function(){
            return briefingService.fetchSubscribers(self.briefing.id, self.paging.totalElements)
            .then(function(followersRes) {
                eventService.postEvent('subscribers_list_downloaded', { subscribersCount: self.paging.totalElements, briefingId: self.briefing.id } );
                return userService.formatForExport(followersRes.content);
            });
        };

        this.searchSubscribers = function(searchTerm){
            self.searchTerm = searchTerm;
            _.assign(self.paging, {page: 0, pagerPage: 1});
            self.fetchSubscribers();
        };

        this.fetchSubscribers = function(){
            self.fetching = true;
            self.paging.page = self.paging.pagerPage -1;
            briefingService.fetchSubscribers(self.briefing.id,
                                             self.paging.rows,
                                             self.paging.page,
                                             self.paging.sort,
                                             self.paging.sortDirection,
                                             self.searchTerm)
            .then(function(response){
                self.fetching = false;
                self.subscribers = response.content;
                self.paging.totalElements = response.totalElements;
                self.paging.first = response.first;
                self.paging.last = response.last;
            });
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingSummary', {
    bindings: {
        briefing: '=',
        showPublish: '<',
        showDelete: '<',
        openSubscribers: '&',
        deleteBriefing: '&'
    },
    transclude: true,
    template: [
        '<div class="row">',
            '<div class="col-md-9 no-padd-right">',
                '<briefing-schedule-info briefing="$ctrl.briefing"></briefing-schedule-info>',
                '<briefing-send-info briefing="$ctrl.briefing"></briefing-send-info>',
                '<a ng-if="!$ctrl.briefing.streamId && $ctrl.showDelete" ng-click="$ctrl.deleteBriefing()">Delete this briefing</a>',
                '<briefing-preview-link briefing="$ctrl.briefing"></briefing-preview-link>',
            '</div>',
            '<div class="col-md-3" style="padding-left: 0;">',
                '<div show-with-permission action="MANAGE_TENANT" class="pad-top margin-top-bottom pull-right">',
                    '<a class="muted-text margin-left-right pull-right" title="Number of subscribers" ng-click="$ctrl.openSubscribers($ctrl.briefing)">',
                        '<span class="glyphicon glyphicon-user"></span>',
                        '<span>{{$ctrl.briefing.subscribersCount}}</span>',
                    '</a>',
                '</div>',
                '<div style="padding-left: 25px;" ng-if="$ctrl.showPublish">',
                    '<briefing-publish-button briefing="$ctrl.briefing" user="$ctrl.user"></briefing-publish-button>',
                '</div>',
            '</div>',
        '</div>'
    ].join('\n'),
    controller: ['$uibModal', function($uibModal){
        this.openSubscribers = function(briefing){
            return $uibModal.open({
                template: '<briefing-subscribers briefing="$ctrl.briefing" dismiss="$dismiss()"></briefing-subscribers>',
                controller: 'BriefingSubscribersModalCtrl as $ctrl',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    briefing: function() {
                        return briefing;
                    }
                }
            }).result;
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingTemplate', {
    bindings: {
        briefing: '='
    },
    template: [
        '<label style="font-weight: normal;">Template:</label>',
        '<a title="{{ $ctrl.selectedTemplate().title || \'Select\' }}" ng-click="$ctrl.openTemplateBrowser()">{{ $ctrl.selectedTemplate().title || \'\' }}</a>',
    ].join('\n'),
    controller: ['_', '$rootScope', 'TemplateService', function(_, $rootScope, templateService) {
        var self = this;

        var getTemplates = function(){
            return templateService.getAll()
            .then(function(templates){
                self.templates = templates.data;
            });
        };

        var deRegister = $rootScope.$on('refreshTemplates', getTemplates);

        this.selectedTemplate = function(){
            if(self.templates && self.briefing && self.briefing.templateId) {
                return _.findWhere(this.templates, {id: self.briefing.templateId});
            }
        };

        this.openTemplateBrowser = function(){
            templateService.openTemplateBrowser(self.briefing);
        };

        this.$onInit = function(){
            getTemplates()
            .then(function(){
                if(self.briefing && !self.briefing.id){
                    $rootScope.$broadcast('templateSelected', _.find(self.templates, {defaultTemplate: true}));
                }
            });
        };

        this.$onDestroy = function(){
            deRegister();
        };
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingScheduleModeSelector', {
    bindings: {
        briefing: '=',
        briefingSchedule: '='
    },
    transclude: true,
    template: [
    '<div ng-show="$ctrl.briefing.enabled" class="col-md-2" id="scheduling-mode-section">',
        '<div class="form-group">',
            '<label>Schedule</label>',
            '<select class="form-control" name="brief_mode" ng-model="$ctrl.briefingSchedule.scheduleMode" ng-options="mode.key as mode.val for mode in $ctrl.schedulingModes">',
            '</select>',
        '</div>',
    '</div>'
    ].join('\n'),
    controller: [function(){
        this.schedulingModes = [
            { key: 'MANUAL', val: 'Manual'},
            { key: 'RECURRING', val: 'Recurring'}
        ];
    }]
});

'use strict';

angular.module('attensaApp')
.component('briefingStartDate', {
    bindings: {
        briefingSchedule: '=',
        form: '='
    },
    transclude: true,
    template: [
        '<div class="form-group">',
            '<label>Start</label>',
            '<div class="input-group date">',
                '<input name="startDate" type="text" data-placement="bottom" bs-datepicker data-date-format="MM/dd/yyyy" class="form-control" ng-model="$ctrl.briefingSchedule.startDate" id="start-date" required/>',
            '</div>',
            '<div ng-if="$ctrl.form.startDate.$error.date && !$ctrl.form.startDate.$error.min">',
                '<div class="has-error">',
                    '<small class="help-block">Invalid Date (Must be in MM/DD/YYYY format)</small>',
                '</div>',
            '</div>',
            '<div id="date-before-now" ng-if="$ctrl.form.startDate.$error.min">',
                '<div class="has-error">',
                    '<small class="help-block">Invalid Date (Date cannot be in the past)</small>',
                '</div>',
            '</div>',
            '<div ng-if="$ctrl.form.startDate.$touched">',
                '<div class="has-error" ng-messages="$ctrl.form.startDate.$error">',
                    '<small class="help-block" ng-message="required">Start date is required</small>',
                '</div>',
            '</div>',
        '</div>'
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('briefingTimezoneSelector', {
    bindings: {
        briefingSchedule: '='
    },
    transclude: true,
    template: [
    '<div class="form-group">',
        '<label>Time Zone</label>',
        '<select class="form-control" id="briefing-timezone-select" ng-model="$ctrl.briefingSchedule.timeZone" ng-options="zone.key as zone.val for zone in $ctrl.displayTimezones"></select>',
    '</div>'
    ].join('\n'),
    controller: ['UtilService', function(utilService){
        this.displayTimezones = utilService.displayTimezones;
    }]
});

'use strict';

angular.module('attensaApp')
.component('editBriefingCommentary',{
    bindings: {
        briefing: '=',
        onChange: '&'
    },
    template: [
        '<form class="form-inline editable-textarea" editable-form name="briefingCommentaryForm" onaftersave="$ctrl.onChange()">',
            '<div class="form-control-static">',
                '<span ng-if="!briefingCommentaryForm.$visible" style="font-weight: bold;">Commentary: </span>',
                '<a id="edit-description-link" ng-click="briefingCommentaryForm.$show()" ng-hide="briefingCommentaryForm.$visible" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>',
                '<span style="margin-top: 10px;" title="{{$ctrl.briefing.commentary.title}}" editable-text="$ctrl.briefing.commentary.title" e-name="title" e-style="min-width: 30em">{{ $ctrl.briefing.commentary.title || \'Add commentary title\'}}</span>',
                '<div ng-style="!briefingCommentaryForm.$visible && {\'margin-left\' :\'111px\'}">',
                    '<span  title="{{$ctrl.briefing.commentary.body}}" editable-textarea="$ctrl.briefing.commentary.body" style="max-width: 320px;" class="overflow-ellipsis" e-name="body" e-style="min-width: 30em; margin-top:12px;resize: vertical">{{ $ctrl.briefing.commentary.body || \'Add commentary\' | limitTo : 50}}</span>',
                    '<span class="editable-buttons" style="margin-top: 12px;" ng-if="briefingCommentaryForm.$visible">',
                        '<button class="btn btn-primary btn-xs" ng-click="briefingCommentaryForm.submit()">',
                            '<span class="glyphicon glyphicon-ok"></span>',
                        '</button>',
                        '<button class="btn btn-default btn-xs" ng-click="briefingCommentaryForm.$cancel()">',
                            '<span class="glyphicon glyphicon-remove"></span>',
                        '</button>',
                    '</span>',
                '</div>',
            '</div>',
        '</form>',
    ].join('\n')
});

'use strict';

angular.module('attensaApp')
.component('editBriefingTextAreaItem',{
    bindings: {
        briefing: '=',
        label: '@',
        attr: '@',
        attrDescription: '@',
        onChange: '&'
    },
    template: [
        '<div class="form-control-static" style="min-width: 0;" id="briefing-description-form">',
            '<h5 id="briefing-basic-description" class="overflow-ellipsis" onaftersave="$ctrl.onChange()" e-form="descForm" e-style="min-width: 30em" editable-textarea="$ctrl.briefing[$ctrl.attr]" e-rows="3">',
                '<label>{{$ctrl.label}}</label>',
                '<a id="edit-description-link" ng-click="descForm.$show()" ng-hide="descForm.$visible" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>',
                '{{ $ctrl.briefing[$ctrl.attr] || \'Add a \' + $ctrl.attrDescription }}',
            '</h5>',
        '</div>'
    ].join('\n')
});
'use strict';

angular.module('attensaApp')
.component('editBriefingTitle', {
    bindings: {
        briefing: '=',
        onChange: '&'
    },
    template: [
        '<form name="titleForm" shown="false" editable-form id="briefing-title-form">',
            '<h3 class="overflow-ellipsis"',
                'onaftersave="$ctrl.onChange()"',
                'editable-text="$ctrl.briefing.briefingTitle"',
                'e-name="title" e-required e-size="75">',
                '<label>Title:</label>',
                '<a id="edit-title-link" ng-click="titleForm.$show()" ng-hide="titleForm.$visible"',
                    'style="border-bottom: none;">',
                    '<i class="fa fa-pencil-square-o"></i>',
                '</a>',
                '{{ $ctrl.briefing.briefingTitle }}',
            '</h3>',
            '<span class="editable-buttons" ng-show="titleForm.$visible">',
                '<button id="title-form-submit" type="submit" class="btn btn-primary btn-xs">',
                    '<span class="glyphicon glyphicon-ok"></span>',
                '</button>',
                '<button type="button" class="btn btn-default btn-xs" ng-click="titleForm.$cancel()">',
                    '<span class="glyphicon glyphicon-remove"></span>',
                '</button>',
            '</span>',
        '</form>'
    ].join('\n')
});
'use strict';

angular.module('attensaApp')
.directive('sourceFinderCatalog', ['TaxonomyService',
    function(TaxonomyService) {
        return {
            scope: {
                taxonomy: '=',
                catalogId: '@',
                sourceSelectionDidChange: '&',
                existingSources: '=',
                parentStreamId: '@'
            },
            template: [
                '<div class="tab-content" style="padding-top: 2em">',
                    '<div class="row" style="margin-bottom: 20px;">',
                        '<div class="col-md-12">',
                            '<ol class="breadcrumb">',
                                '<li ng-repeat="category in selectedCategoryStack" ng-switch on="$last">',
                                    '<span ng-switch-when="true">{{category.title}}</span>',
                                    '<a ng-switch-default ng-click="selectCategory(taxonomy, category.id)">{{category.title}}</a>',
                                '</li>',
                            '</ol>',
                            '<div>',
                                '<category-card ng-repeat="category in categories" category="category" select-category="selectCategory(taxonomy, category.id)"></category-card>',
                            '</div>',
                        '</div>',
                    '</div>',
                '<div class="row">',
                    '<spinner ng-show="topicsView.fetchingStreams && topicsView.categories.length === 0"></spinner>',
                    '<div class="col-md-12">',
                        '<div class="well well-sm" ng-if="streams.length !== 0">',
                            '<span><strong>{{streams.length}}</strong> Topics and Sources</span>',
                        '</div>',
                        '<source-card parent-stream-id="{{::parentStreamId}}" existing-sources="::existingSources" ng-repeat="stream in streams" stream="stream" source-selection-did-change="sourceSelectionDidChange({isSelected: isSelected, source: stream})"></source-card>',
                    '</div>',
                '</div>',
                '</div>'
            ].join('\n'),
            link: function (scope) {
                scope.init = function() {
                    scope.streams = [];
                    scope.selectCategory(scope.taxonomy);
                };

                scope.selectCategory = function(taxonomy, categoryId) {
                    scope.selectedCategoryStack = TaxonomyService.buildBreadCrumbs(taxonomy, categoryId);
                    scope.categories = TaxonomyService.getCategoryList(taxonomy, categoryId);
                    if(categoryId) {
                        var searchParams = { params: { categoryId: categoryId, includeSubcategories: false, rows: 1000 } };
                        var streamGetter = scope.catalogId ?
                            TaxonomyService.getCatalogCategoryStreams(scope.catalogId, searchParams) : TaxonomyService.getStreams(searchParams);

                        scope.fetchingStreams = true;
                        return streamGetter
                        .then(function(streamsRes) {
                            scope.streams = streamsRes.data.content;
                            scope.fetchingStreams = false;
                        });
                    }
                };

                scope.init();
            }
        };
    }]);

'use strict';

angular.module('attensaApp')
.component('filterPrefill', {
    bindings: {
        filterTerms: '<'
    },
    template: [
        '<div class="alert alert-warning" uib-collapse="$ctrl.doneWithPrefillBox">',
            '<p><ng-pluralize count="$ctrl.filterTerms.length" ',
                    'when="{ \'1\': \'Would you like to apply this previous search term as a filter to this topic?\', ',
                    '\'other\': \'Would you like to apply these previous search terms as filters to this topic?\'}">',
            '</ng-pluralize></p>',
            '<ul style="list-style: inherit; margin-bottom: 10px;">',
                '<li ng-repeat="term in $ctrl.filterTerms"><strong>{{::term}}</strong></li>',
            '</ul>',
            '<button class="btn btn-default" style="margin-right: 5px" ng-click="$ctrl.fillBasicFilter($ctrl.filterTerms)">',
                '<ng-pluralize count="$ctrl.filterTerms.length" ',
                    'when="{ \'1\': \'Yes, apply this as a filter\', ',
                    '\'other\': \'Yes, apply these as filters\'}">',
                '</ng-pluralize>',
            '</button>',
            '<button class="btn btn-default" ng-click="$ctrl.doneWithPrefillBox = true;">No thanks, I\'ll build my own filter</button>',
        '</div>'
    ].join('\n'),
    controller: ['$rootScope', function($rootScope) {
        var ctrl = this;

        ctrl.fillBasicFilter = function(filterTerms) {
            ctrl.doneWithPrefillBox = true;
            $rootScope.$broadcast('set-stream-filter-terms', filterTerms);
        };
    }]
});

'use strict';

angular.module('attensaApp')
.directive('streamFilterDayRestriction', [function() {
    return {
        scope: {
            filter: '='
        },
        template: [
            '<label>',
                '<input type="checkbox" ng-model="settings.restrictByDays" ng-change="updateFilterWithDateRestriction(settings)">',
                'Only articles published in the last <input style="width: 5em; display: inline-block" type="number" min="1" ng-model="settings.publishedWithinDays" ng-disabled="!settings.restrictByDays" ng-change="updateFilterWithDateRestriction(settings)" class="form-control">',
                'days',
            '</label>'
        ].join('\n'),
        link: function(scope) {
            scope.init = function() {
                scope.settings = {
                    publishedWithinDays : scope.filter.publishedWithinDays,
                    restrictByDays : !!scope.filter.publishedWithinDays
                };
            };

            scope.updateFilterWithDateRestriction = function(newVal, oldVal) {
                scope.filter.publishedWithinDays = scope.settings.publishedWithinDays && scope.settings.restrictByDays ?
                    scope.settings.publishedWithinDays : undefined;
            };

            scope.$watch('filter.publishedWithinDays', scope.init);
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('streamFilterEditor', ['$stateParams', '$rootScope', '_', 'StreamService', function($stateParams, $rootScope, _, StreamService) {
    return {
        scope: {
            stream: '=',
            onFilterChange: '&'
        },
        template: [
            '<div class="panel panel-default" ng-if="filter">',
                '<div class="panel-heading">',
                    '<h3 class="panel-title" style="display: inline">',
                        '<span>Filter</span>',
                    '</h3>',
                    '<div class="form-group pull-right">',
                        '<input type="checkbox" ng-model="advancedMode" ng-change="switchMode(advancedMode)" ng-click="filterCollapsed = false;"> Advanced mode',
                    '</div>',
                '</div>',
                '<div class="panel-body">',
                    '<div ng-show="!advancedMode"><stream-simple-filter filter="filter" stream="stream" on-filter-change="onFilterChange()"></stream-simple-filter></div>',
                    '<div ng-show="advancedMode"><advanced-stream-filter filter="filter" stream="stream" on-filter-change="onFilterChange()"></advanced-stream-filter></div>',
                '</div>',
            '</div>'
        ].join('\n'),
        link: function(scope) {
            (function() {
                scope.advancedMode = false;
                StreamService.getFilters(scope.stream.id)
                .then(function(filter) {
                    scope.filter = filter;
                    scope.advancedMode = scope.filter.isBasic === false ? true : false;
                })
                .catch(function() {
                    scope.filter = { streamId: scope.stream.id, isBasic: true };
                });
            })();

            scope.switchMode = function(advancedMode) {
                $rootScope.$broadcast('stream-filter-mode-switch', !advancedMode);
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('advancedStreamFilter',
            ['_', 'Promise', 'StreamService', 'UtilService',
    function(_, Promise, StreamService, UtilService) {
    return {
        scope: {
            filter: '=',
            stream: '=',
            onFilterChange: '&'
        },
        template: [
            '<div class="form-group" ng-class="{ \'has-error\': invalidFilter }">',
                '<textarea class="form-control" placeholder="Enter filter criteria here." rows="4"',
                    'ng-model="filter.advancedFilterTerm">',
                '</textarea>',
                '<div style="position: relative" class="pull-right"><a data-template="/templates/filterHelpPopover.html"',
                    'data-placement="left"',
                    'data-auto-close="true"',
                    'bs-popover class="fa fa-question-circle modal-close-x"></a></div>',
                '<span class="text-danger" ng-if="invalidFilter">Sorry, we can\'t apply that filter.  They syntax may be incorrect.  Please check the syntax guide and try again.</span>',
            '</div>',
            '<stream-filter-day-restriction filter="filter" ng-if="filter"></stream-filter-day-restriction>',
            '<div class="form-group">',
                '<spinner-button text="Apply" spin-on="asyncPostFilter.isPending()" type="submit" ng-click="applyFilter()"></spinner-button>',
            '</div>'
        ].join('\n'),
        link: function(scope) {
            scope.applyFilter = function() {
                var filterTerm = scope.filter.advancedFilterTerm || undefined;
                _.assign(scope.filter, {
                    advancedFilterTerm: UtilService.cleanQuotes(filterTerm),
                    filterTerm: UtilService.cleanQuotes(filterTerm),
                    isBasic: false,
                    basicFilterStructures: _.filter(scope.filter.basicFilterStructures, function(structure) {
                        return !_.isEmpty(structure.value);
                    })
                });

                scope.asyncPostFilter = Promise.resolve(StreamService.postFilter(scope.stream.id, scope.filter))
                .then(function() {
                    scope.invalidFilter = false;
                    scope.onFilterChange();
                })
                .catch(function() {
                    scope.invalidFilter = true;
                });

                return scope.asyncPostFilter;
            };

            scope.$on('stream-filter-mode-switch', function(evt, isBasic) {
                if(!isBasic) {
                    if(_.isEmpty(scope.filter.advancedFilterTerm)) {
                        scope.filter.advancedFilterTerm = UtilService.cleanQuotes(scope.filter.filterTerm);
                    }
                    scope.applyFilter();
                }
            });
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('streamSimpleFilter', ['_', 'ItemService', 'StreamService', 'UtilService', '$timeout', 'Promise', 'FilterService', 'TagService', 'TenantService',
    function(_, ItemService, StreamService, UtilService, $timeout, Promise, FilterService, TagService, TenantService) {
    return {
        scope: {
            filter: '=',
            stream: '=',
            onFilterChange: '&'
        },
        template: `
            <div class="row">
                <form class="col-sm-12 form-horizontal" ng-submit="applyFilter()">
                    <div class="form-group">
                        <label class="col-sm-1 control-label">Text</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" ng-model="filter.basicFilterText" ng-disabled="filterCondition.type === \'TAG\'">
                        </div>
                    </div>
                    <div class="form-group" ng-repeat="filterCondition in filter.basicFilterStructures">
                        <label class="col-sm-1 control-label">{{filterCondition.type === \'TAG\' ? \'Tags\' : \'Text\' }}</label>
                        <div class="col-sm-4">
                            <select name="select" class="form-control" ng-model="filterCondition.condition">
                                <option value="CONTAINS" selected>contains</option>
                                <option value="EXCLUDES">does not contain</option>
                            </select>
                        </div>
                        <div class="col-sm-4">
                            <input type="text" class="form-control" ng-model="filterCondition.value" ng-disabled="filterCondition.type === \'TAG\'" required>
                        </div>
                        <div class="col-sm-1">
                            <a class="fa fa-trash-o" ng-click="deleteFilterCondition($index)"></a>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-11">
                            <stream-filter-day-restriction filter="filter" ng-if="filter"></stream-filter-day-restriction>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <spinner-button text="Apply" spin-on="asyncPostFilter.isPending()" type="submit"></spinner-button>
                        </div>
                    </div>
                </form>
                <div class="col-sm-12">
                    <hr ng-if="tenant.settings.defaultTagger !== 'Watson'">
                    <tag-cloud ng-if="tenant.settings.defaultTagger !== 'Watson'" tags="asyncTopicTags" header="Classifications" on-tag-click="addCondition(tag)"></tag-cloud>
                    <hr ng-if="tenant.settings.defaultTagger === 'Watson'">
                    <tag-cloud ng-if="tenant.settings.defaultTagger === 'Watson'" tags="asyncConceptTags" header="Concepts" on-tag-click="addCondition(tag)"></tag-cloud>
                    <hr>
                    <tag-cloud tags="asyncEntityTags" header="Entities" on-tag-click="addCondition(tag)"></tag-cloud>
                    <hr ng-if="tenant.settings.defaultTagger !== 'Watson'">
                    <tag-cloud ng-if="tenant.settings.defaultTagger !== 'Watson'" tags="asyncSocialTags" header="Subjects" on-tag-click="addCondition(tag)"></tag-cloud>
                    <hr ng-if="tenant.settings.defaultTagger === 'Watson'">
                    <tag-cloud ng-if="tenant.settings.defaultTagger === 'Watson'" tags="asyncKeywordTags" header="Keywords" on-tag-click="addCondition(tag)"></tag-cloud>
                </div>
            </div>
        `,
        link: function(scope) {
            scope.init = function() {
                TenantService.getCurrentTenant().then(tenantRes => scope.tenant = tenantRes.data);
                return scope.populateTagCloud();
            };

            scope.populateTagCloud = function() {
                const aggregationsPromise = Promise.resolve(ItemService.searchItemsWithSettings({search: ''}, { includeAggregations: true, streamId: scope.stream.id }));

                scope.asyncTopicTags = aggregationsPromise.then(searchResults => TagService.extractTagsFromAggregations(searchResults.aggregations, ['topics']));
                scope.asyncConceptTags = aggregationsPromise.then(searchResults => TagService.extractTagsFromAggregations(searchResults.aggregations, ['concepts']));
                scope.asyncEntityTags = aggregationsPromise.then(searchResults => TagService.extractTagsFromAggregations(searchResults.aggregations, ['entities']));
                scope.asyncSocialTags = aggregationsPromise.then(searchResults => TagService.extractTagsFromAggregations(searchResults.aggregations, ['socialTag']));
                scope.asyncKeywordTags = aggregationsPromise.then(searchResults => TagService.extractTagsFromAggregations(searchResults.aggregations, ['keywords']));
            };

            scope.deleteFilterCondition = function(index) {
                _.pullAt(scope.filter.basicFilterStructures, index);
            };

            scope.addCondition = function(tag) {
                StreamService.addTagFilter(scope.filter, tag);
            };

            scope.applyFilter = function() {
                scope.filter.basicFilterText = UtilService.cleanQuotes(scope.filter.basicFilterText);
                scope.filter.basicFilterStructures = scope.filter.basicFilterStructures || [];
                var terms = FilterService.filterTermFromBasicStructure(UtilService.cleanQuotes(scope.filter.basicFilterText), scope.filter.basicFilterStructures);

                _.assign(scope.filter, {
                    isBasic: true,
                    filterTerm: _.isEmpty(terms) ? undefined : terms
                });

                scope.asyncPostFilter = Promise.resolve(StreamService.postFilter(scope.stream.id, scope.filter))
                .then(function() {
                    scope.onFilterChange();
                    scope.populateTagCloud();
                });
                return scope.asyncPostFilter;
            };

            scope.$on('stream-filter-mode-switch', function(evt, isBasic) {
                if(isBasic) {
                    scope.applyFilter();
                }
            });

            scope.$on('set-stream-filter-terms', function(evt, filterTerms) {
                if(filterTerms && filterTerms.length === 1){
                    scope.filter.basicFilterText = UtilService.cleanQuotes(filterTerms[0]);
                }else if(filterTerms && filterTerms.length > 1){
                    scope.filter.basicFilterText = _.map(filterTerms, function(term){
                       return '(' + UtilService.cleanQuotes(term) + ')';
                    }).join(' OR ');
                }

                scope.applyFilter();
            });

            scope.init();
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('personalDigestStreamManagement', ['_', '$q', '$rootScope', 'digestService',
    function(_, $q, $rootScope, digestService) {
        return {
            bindToController: true,
            controllerAs: 'ctrl',
            template: [
                '<h4>Personal Digest</h4>',
                '<div>',
                    '<ul class="list-group">',
                        '<li class="list-group-item">',
                            '<strong>{{ctrl.digestConfiguration.title || \'My personal digest\'}}</strong>',
                            '<small><a ui-sref="personalDigest">&nbsp;Edit contents and schedule</a></small>',
                            '<switch ng-model="ctrl.digestConfiguration.schedule.enabled"',
                                'ng-change="ctrl.toggleDigestEnabled()"',
                                'class="small pull-right"',
                                'disabled="ctrl.personalDigestUpdateInFlight"',
                                'on="On"',
                                'off="Off">',
                            '</switch>',
                        '</li>',
                    '</ul>',
                '</div>'
            ].join('\n'),
            controller: function() {
                var ctrl = this;

                ctrl.init = function() {
                    digestService.resolveCurrentUserDigestConfiguration()
                    .then(function(digestConfiguration) {
                        ctrl.digestConfiguration = digestConfiguration;
                    });

                };

                ctrl.toggleDigestEnabled = function() {
                    ctrl.personalDigestUpdateInFlight = true;
                    return digestService.putDigestConfiguration(ctrl.digestConfiguration, $rootScope.user.id, ctrl.digestConfiguration.id)
                    .then(function() { ctrl.personalDigestUpdateInFlight = false; });
                };

                ctrl.init();
            }
        };
    }]);

'use strict';

angular.module('attensaApp')
.directive('briefingSubscriptionManagement', ['_', '$q', '$rootScope', 'UserService', 'UtilService',
    function(_, $q, $rootScope, UserService, UtilService) {
        return {
            bindToController: true,
            controllerAs: 'briefingCtrl',
            template: [
                '<h4>Briefings ',
                    '<small ng-if="briefingCtrl.briefingStreams && briefingCtrl.someStreamsAreRestricted(briefingCtrl.briefingStreams)"',
                        'uib-tooltip="Your account administrator has subscribed you to email briefings and restricted your access to unsubscribe.  Please contact your administrator to be removed from these briefings.">',
                        'Why can\'t I unsubscribe from some briefings?',
                    '</small>',
                '</h4>',
                '<ul class="list-group">',
                    '<li ng-repeat="stream in briefingCtrl.briefingStreams | orderBy:\'title\' track by stream.id" class="list-group-item">',
                        '<strong>{{::stream.title}}</strong>',
                        '<small class="small muted-text" style="font-size: 85%">{{briefingCtrl.frequencyDisplayText(stream.briefingSchedule.scheduleMode, stream.briefingSchedule.freq)}}</small>',
                        '<switch ng-model="briefingCtrl.subscribedToBriefings[$index]"',
                            'ng-change="!briefingCtrl.switchShouldDisable(stream, briefingCtrl.subscriptionRequestsInFlight[$index]) && briefingCtrl.modifyBriefingSubscription(stream, briefingCtrl.subscribedToBriefings[$index], $index)"',
                            'class="small pull-right"',
                            'on="On"',
                            'off="Off"',
                            'disabled="briefingCtrl.switchShouldDisable(stream, briefingCtrl.subscriptionRequestsInFlight[$index])">',
                        '</switch>',
                    '</li>',
                '</ul>'
            ].join('\n'),
            controller: function() {
                var ctrl = this;

                ctrl.init = function() {
                    UserService.getUserStreams({ params: {
                        onlyBriefingSubscriptions: true,
                        targetUserId: $rootScope.user.id,
                        rows: 2000
                    }})
                    .then(function(res) {
                        ctrl.briefingStreams = res.data.content;
                        ctrl.subscribedToBriefings = _.map(_.range(ctrl.briefingStreams.length), function() { return true; });
                        ctrl.subscriptionRequestsInFlight = _.map(_.range(ctrl.briefingStreams.length), function() { return false; });
                    });

                };

                ctrl.modifyBriefingSubscription = function(stream, shouldSubscribe, index) {
                    ctrl.subscriptionRequestsInFlight[index] = true;
                    UserService.setFollowing(stream.id, $rootScope.user.id, {
                        follow: stream.userIsFollowing,
                        subscribe: shouldSubscribe
                    })
                    .finally(function() { ctrl.subscriptionRequestsInFlight[index] = false; });
                };

                ctrl.switchShouldDisable = function(stream, requestInFlight) {
                    return stream.userSubscriptionIsRestricted || requestInFlight;
                };

                ctrl.someStreamsAreRestricted = function(streams) {
                    return _.some(streams, function(stream) {
                        return stream.userSubscriptionIsRestricted;
                    });
                };

                ctrl.frequencyDisplayText = function(mode, freq) {
                    var freqInfo = _.find(UtilService.repeatModes, { key: freq });
                    return mode === 'RECURRING' && freqInfo ? freqInfo.val : 'Manual';
                };

                ctrl.init();
            }
        };
    }]);

'use strict';

angular.module('attensaApp')
.component('reportList', {
    template: `
        <div ng-if="$ctrl.hasReports">
            <h5>Raw activity reports are available below. If there was no activity during the report period, an empty file is generated.</h5>
            <h5>Download links expire after 15 minutes.  To generate new download links, you can refresh your browser.</h5>
            <table ng-table="$ctrl.tableParams" class="table table-condensed table-bordered table-striped">
                <tr ng-repeat="report in $data">
                    <td data-title="'Report Type'" sortable="'type'">{{::report.type}}</td>
                    <td data-title="'Start Date'" sortable="'fromDate'">{{::report.fromDate}}</td>
                    <td data-title="'End Date'" sortable="'toDate'">{{::report.toDate}}</td>
                    <td data-title="'Download'" sortable="'size'"><a ng-click="$ctrl.reportDownloaded(report)" href="{{::report.url}}">{{::report.size | filesize}}</a></td>
                </tr>
            </table>
        </div>
    `,
    controller: ['$http', 'NgTableParams', 'eventService', function($http, NgTableParams, eventService) {
        var ctrl = this;

        $http.get('/ws/analytics/reports')
        .then(function(reportsRes) {
            ctrl.hasReports = reportsRes.data.length > 0;
            ctrl.tableParams = new NgTableParams({
                count: 50,
                sorting: { type: 'asc' }
            }, {
                total: reportsRes.data.length,
                counts: [],
                dataset: reportsRes.data
            });
        });

        this.reportDownloaded = report => eventService.postEvent('reportDownloaded', report);
    }]
});

'use strict';

angular.module('attensaApp')
.directive('noSpaces', [function() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$validators.noSpaces = function(emailPrefix) {
                return !!emailPrefix && emailPrefix.indexOf(' ') === -1;
            };
        }
    };
}]);
'use strict';

angular.module('attensaApp')
    .directive('tooLong', [function() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function(scope, elm, attrs, ctrl) {
                ctrl.$validators.tooLong = function(emailPrefix) {
                    return !!emailPrefix && emailPrefix.length < attrs.tooLong;
                };
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.directive('validEmailPrefix', [function() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$validators.validEmailPrefix = function(emailPrefix) {
                // No @s in our email prefix!
                return !!emailPrefix && emailPrefix.indexOf('@') === -1;
            };
        }
    };
}]);
'use strict';

angular.module('attensaApp')
.directive('validatePassword', [function() {
    var REQUIRED_PATTERNS = [
        /\d+/,    //numeric values
        /[a-z]+/, //lowercase values
        /[A-Z]+/  //uppercase values
    ];

    return {
        require : 'ngModel',
        link : function(scope, element, attrs, ctrl) {
            scope.$watch(attrs.validatePassword, function() {
                ctrl.$validators.passwordCharacters = function(value) {
                    scope.$broadcast('matchThisValue', value);
                    var status = true;
                    if(value) {
                        angular.forEach(REQUIRED_PATTERNS, function(pattern) {
                            status = status && pattern.test(value);
                        });
                    }
                    return status;
                };
            });
        }
    };
}])

.directive('matchToValidator', function() {
    var validateRequired = function(matchValue, targetValue, ctrl) {
        if(matchValue && !targetValue) {
            ctrl.$setValidity('requiring', false);
        } else {
            ctrl.$setValidity('requiring', true);
        }
    };

    var validateMatch = function(matchValue, targetValue, ctrl) {
        if(matchValue === targetValue || !targetValue) {
            ctrl.$setValidity('match', true);
        } else {
            ctrl.$setValidity('match', false);
        }
    };

    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ctrl) {
            var matchValue, targetValue;
            scope.$on('matchThisValue', function(evt, value) {
                matchValue = value;
                validateRequired(matchValue, targetValue, ctrl);
                validateMatch(matchValue, targetValue, ctrl);
            });
            ctrl.$validators.match = function(value) {
                targetValue = value;
                validateRequired(matchValue, targetValue, ctrl);
                if(value && !matchValue) {
                    return false;
                }
                return value === matchValue;
            };
        },
        restrict: 'A'
    };
});

'use strict';

angular.module('attensaApp')
.directive('validateUniqueEmail', ['$q', '_', 'UserService', function($q, _, userService) {
    var REQUIRED_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i;

    return {
        require: 'ngModel',
        restrict: 'A',
        link: function(scope, element, attr, ctrl) {
            ctrl.$validators.email = function(email) {
                var status = true;
                if(email) {
                    status = status && REQUIRED_PATTERN.test(email);
                }
                return status;
            };

            var currentEmail = function(){
                if(attr.currentEmail && attr.currentEmail.length){
                    return attr.currentEmail;
                }else{
                    return scope.user ? scope.user.emailAddress : null;
                }
            };

            ctrl.$asyncValidators.uniqueEmail = function(email) {

                if(email === currentEmail()) {
                    return $q(function(resolve) {
                        resolve(true);
                    });
                }
                if (_.some(scope.totalUsers, { emailAddress: email })) {
                    return $q.reject('exists');
                }
                return userService.getUserByEmail(email)
                .then(function resolved(result) {
                    if(result.data.emailAddress) {
                        return $q.reject('exists');
                    } else {
                        return true;
                    }
                }, function rejected() {
                    return true;
                });
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.directive('validateStreamEmail', ['$q', 'streamSourceService', function($q, streamSourceService) {
    return {
        require: 'ngModel',
        scope: {
            emailDomain: '=',
            currentStreamSourceId: '='
        },
        restrict: 'A',
        link: function(scope, element, attr, ctrl) {
            ctrl.$asyncValidators.uniqueStreamEmail = function(emailPrefix) {
                return streamSourceService.searchStreamSources('uri', emailPrefix + '@' + scope.emailDomain)
                .then(function resolved(streamSourceRes) {
                    if(streamSourceRes.data.id === scope.currentStreamSourceId) {
                        return true;  // All good, we just found the stream we are currently editing
                    } else {
                        return $q.reject('Email address is not unique');
                    }
                })
                .catch(function(err) {
                    if(err.status === 404) {
                        return true; // This is a unique email address
                    } else {
                        return $q.reject('Unable to verify email');  //Something went wrong, better safe than sorry
                    }
                });
            };
        }
    };
}]);
'use strict';

angular.module('attensaApp')
.directive('uniqueIn', function() {
    return {
        require : 'ngModel',
        link : function($scope, element, attrs, ngModel) {
            ngModel.$validators.unique = function(value) {
                var status = true;
                if($scope[attrs.uniqueIn]){
                    angular.forEach($scope[attrs.uniqueIn], function(checker){
                        var altValue = checker[ngModel.$name];
                        if(altValue && altValue === ngModel.$viewValue){
                            status = false;
                        }
                    });
                }
                return status;
            };
        }
    };
});
'use strict';

angular.module('attensaApp')
.directive('uniqueTenantHost', ['$q', 'TenantService', 'UtilService', function($q, tenantService, utilService) {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function(scope, element, attr, ctrl) {

            ctrl.$asyncValidators.uniqueHost = function(host) {
                return tenantService.tenantHostExists(host.toLowerCase() + utilService.rootDomain)
                .then(function(result){
                    if(result.exists || host.toLowerCase() === 'create'){
                        return $q.reject('exists');
                    }else{
                        return true;
                    }
                });
            };
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.filter('categoryFilter', ['_', function(_) {
    return function(input, search) {
        if(!search) {
            return input;
        }

        var regex = new RegExp(search, 'i'); // TODO make better regex
        var output = [];

        _.each(input, function(parentCat) {
            _.each(parentCat.subcategories, function(cat) {
                if(regex.test(cat.title) && !_.find(output, {id: parentCat.id})) {
                    output.push(parentCat);
                }
            });
            if(regex.test(parentCat.title) && !_.find(output, {id: parentCat.id})) {
                output.push(parentCat);
            }
        });

        return output;
    };
}]);

'use strict';

angular.module('attensaApp')
    .filter('externalLinkify', ['$sce', function($sce) {
        return function(value) {
            try {
                var content = angular.element('<div>' + $sce.trustAsHtml(value) + '</div>');//avoid 'invalid html' exception
                content.find('a').attr('target', '_blank');
                return angular.element('<div>').append(content).html();
            }
            catch(e){
                return value;
            }
        };
    }]);
'use strict';

angular.module('attensaApp')
.filter( 'filesize', function () {
    var units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB'
    ];

    return function( bytes, precision ) {
        if ( isNaN( parseFloat( bytes )) || ! isFinite( bytes ) ) {
            return '?';
        }

        var unit = 0;

        while ( bytes >= 1024 ) {
            bytes /= 1024;
            unit ++;
        }

        return bytes.toFixed( + precision ) + ' ' + units[ unit ];
    };
});
'use strict';

angular.module('attensaApp')
.filter('stripFilename', [function() {
    return function(filename) {
        return filename.replace(/[^\w]/gi, '');
    };
}]);
'use strict';

angular.module('attensaApp')
.service('AuthService',
    ['$window', '$location', '$state', '$cacheFactory', '_', 'UserService', 'TenantService',
function($window, $location, $state, $cacheFactory, _, userService, tenantService) {
    var service = {};

    var urlToState = _($state.get())
        .map(function (state) {
            var url = $state.href(state);
            url = url ? url.replace('//', '/') : url;
            return {href: url, state: state};
        })
        .indexBy('href')
        .value();

    var simpleLogin = function(){
        $cacheFactory.get('$http').removeAll();
        //do not stack the url
        if($window.location.href.indexOf('RelayState') === -1) {
            $state.transitionTo('login', { RelayState: $window.location.href.indexOf('/login/reset_password') === -1 ? $window.location.href : undefined });
        }
    };

    service.goToLogin = function(){
        tenantService.getUnauthTenantInfo()
        .then(function(tenantRes) {
            if(_.has(tenantRes, 'data.settings.samlEntryPoint')) {
                // TODO: we should do a proper url parse and build
                $window.location.href = '/';
            } else {
                simpleLogin();
            }
        })
        .catch(function(err) {
            simpleLogin();
        });
    };

    var defaultStateForUser = function(tenant, user){
        var defaults = tenant.settings.defaultPages;

        if(defaults) {
            var target = defaults[_(user.tenantRoles)
                .pluck('roleType')
                .find(function (roleName) {
                    return urlToState[defaults[roleName]];
                })];

            let state = target || defaults.DEFAULT;
            if(state && state.startsWith('/client')){
                return userService.getUserStreams({ params: { targetUserId: user.id, rows: 20 }})
                .then(res => {
                    if(res.data.content.length){
                        $window.location.href = state;
                    }else{
                        $window.location.href = '/client/browse';
                    }
                });
            } else{
                return urlToState[state];
            }
        }
    };

    service.goToDefaultState = function(user){
        tenantService.getCurrentTenant()
        .then(function(tenantRes) {
            return defaultStateForUser(tenantRes.data, user);
        })
        .then(function(target){
            if(target){
                $state.go(target.state);
            }  else {
                $state.go('reading');
            }
        });
    };


    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('BriefingService', ['_', '$http', 'eventService', 'StreamService', 'TenantService', 'UtilService',
    function(_, $http, eventService, streamService, TenantService, UtilService) {
    var service = {};

    service.deleteBriefing = function(briefingId){
        return UtilService.unwrap($http.delete('/ws/briefing/' + briefingId));
    };

    service.getBriefing = function(briefingId, params){
        return UtilService.unwrap($http.get('/ws/briefing/' + briefingId, { params: params }));
    };

    service.getBriefingSchedule = function(briefingId){
        return UtilService.unwrap($http.get('/ws/briefing/schedule', { params: {briefingId: briefingId}}));
    };

    service.getBriefings = function(params){
        return UtilService.unwrap($http.get('/ws/briefing', { params: params }));
    };

    service.getUnauthBriefings = function(params){
        return UtilService.unwrap($http.get('/ws/ua/briefings', { params: params }));
    };

    service.getCurrentUserBriefings = function(){
        return UtilService.unwrap($http.get('/ws/user/currentUser/briefings'));
    };

    service.getHistory = function(briefingId, params){
        return UtilService.unwrap($http.get('/ws/briefing/' + briefingId + '/history', { params: params }));
    };

    service.getLatestEmailActivityPerUser = function(activities) {
        return _.chain(activities)
            .groupBy(function(activity) {
                return activity.emailAddress;
            })
            .mapValues(function(userActivities) {
                var terminalClickActivity = _.find(userActivities, { activity: 'briefing_email_clicked' });
                return terminalClickActivity ?
                    terminalClickActivity : _.max(userActivities, function(userActivity) {
                        return new Date(userActivity.timestamp);
                    });
            })
            .value();
    };

    service.countByActivity = function(activities, activityName) {
        return _.chain(activities)
        .groupBy(function(activity) {
            return activity.activity;
        })
        .get(activityName, [])
        .uniq('emailAddress')
        .size()
        .value();
    };

    service.fetchBriefingStreams = function(briefingId) {
        return UtilService.unwrap($http.get('/ws/briefing/' + briefingId + '/streams'));
    };

    service.fetchSubscribers = function(briefingId, rows, page, sort, sortDirection, term) {
        return UtilService.unwrap($http.get('/ws/briefing/' + briefingId + '/subscribers', {params: { rows: rows, page: page, sort: sort, sortDirection: sortDirection, term: term }}));
    };

    service.fetchGroupSubscribers = function(briefingId, rows, page, sort, sortDirection, term){
        return UtilService.unwrap($http.get('/ws/briefing/' + briefingId + '/groups', {params: { rows: rows, page: page, sort: sort, sortDirection: sortDirection, term: term }}));
    };

    service.sendBriefingPreview = function(briefingId){
        return UtilService.unwrap($http.post('/ws/briefing/' + briefingId + '/sendTest'));
    };

    service.sendBriefingNow = function(briefingId) {
        return UtilService.unwrap($http.post('/ws/briefing/' + briefingId + '/sendNow'));
    };

    service.saveSchedule = function(briefingId, schedule){
        return UtilService.unwrap($http.post('/ws/briefing/schedule', schedule, { params: {briefingId: briefingId}}));
    };

    service.saveBriefing = function(briefing){
        return UtilService.unwrap($http.put('/ws/briefing/' + briefing.id, briefing));
    };

    service.createBriefing = function(briefing){
        return TenantService.isAutoPublishBriefingTenant()
        .then(function(isAutoPublishTopic){
            briefing.published = isAutoPublishTopic || briefing.published;
            return UtilService.unwrap($http.post('/ws/briefing/', briefing));

        })
        .then(function(response){
            eventService.postEvent('briefing_created');
            return response;
        });
    };

    service.sortedStreamIds = function(streams){
        return _.chain(streams).sortBy('titleLower').pluck('id');
    };

    service.setStreamsAndBriefingStreamIds = function(target, streamIds, doSort){
        return streamService.fetchStreams(streamIds)
        .then(function(streams){
            target.streams = doSort ? _.sortBy(streams, 'titleLower') : streams;
            target.briefing.streamIds = _.pluck(target.streams, 'id');
        });
    };

    service.frequencyFilters = ['Daily', 'Monthly', 'Weekly'];

    service.scheduleModeFilters = ['Manual'];

    service.inviteToBriefing = function(briefingId, invitation) {
        return UtilService.unwrap($http.post('/ws/briefing/' + briefingId + '/invitations', invitation));
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('CatalogService', ['$http', 'UtilService', function($http, UtilService) {
    var service = {};

    service.searchItemsInCatalog = function(catalogId, searchSettings) {
        return UtilService.unwrap($http.post('/ws/catalogs/' + catalogId + '/items/search', searchSettings));
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('categoryService', ['$http', '_', '$q', 'StreamService', 'UserService', function($http, _, $q, streamService, userService) {

    var service = {};

    service.getCategoryByType = function(type) {
        return $http.get('/ws/category/byType/' + type);
    };

    service.putCategories = function(userId, personalCategories) {
        return $http.put('/ws/user/' + userId + '/personalCategories', personalCategories)
        .then(function(res) {
            return res.data;
        });
    };

    service.addSubscriptionToCategory = function(stream, category, userId) {
        return $http.post('/ws/user/' + userId + '/personalCategories/' + category.id + '/stream', { streamId: stream.id })
        .then(function(res) {
            return res.data;
        });
    };

    service.deleteStreamFromCategory = function(streamId, categoryId, userId) {
        return $http.delete('/ws/user/' + userId + '/personalCategories/' + categoryId + '/stream/' + streamId)
        .then(function(res) {
            return res.data;
        });
    };

    service.addStreamToPersonalCategory = function(stream, categoryDetail, user) {
        // Check if personal category already exists otherwise create it before save into
        if(!_.some(user.personalCategories, { title: categoryDetail.title })) {
            user.personalCategories.push({ title: categoryDetail.title });
            return service.putCategories(user.id, user.personalCategories)
            .then(function(updatedCategories) {
                var newCategory = _.find(updatedCategories, { title: categoryDetail.title });
                user.personalCategories = updatedCategories;
                return service.addSubscriptionToCategory(stream, newCategory, user.id);
            });
        } else {
            return service.addSubscriptionToCategory(stream, _.findWhere(user.personalCategories, { title: categoryDetail.title } ), user.id);
        }
    };

    // For one who abstracts stream change into service - if thou gaze long into the abyss the abyss will gaze back into you
    service.updatePersonalCategory = function(stream, isFollowing, taxonomy, user, selectedCategory) {
        if(stream.taxonomicMemberships && !_.isEmpty(stream.taxonomicMemberships)) {
            if(isFollowing) {
                // Use selected category otherwise default to first category of the stream
                var matchingCategory = selectedCategory ||
                    _.findWhere(taxonomy, { id: stream.taxonomicMemberships[0] }) ||
                    _.findWhere(_.flatten(_.pluck(taxonomy, 'subcategories')), { id: stream.taxonomicMemberships[0] });

                return service.addStreamToPersonalCategory(stream, matchingCategory, user);
            } else {
                var matchingCategorizedStream = _.findWhere(user.categorizedStreams, { streamId: stream.id });
                if(matchingCategorizedStream){
                    return service.deleteStreamFromCategory(stream.id, matchingCategorizedStream.categoryId, user.id);
                } else {
                    return $q.when(user);
                }
            }
        // Handle marketplace stream subscriptions
        } else if (stream.catalogCategories && !_.isEmpty(stream.catalogCategories)) {
            if(isFollowing) {
                var matchingMarketplaceCategory = selectedCategory || stream.catalogCategories[0];
                if(!matchingMarketplaceCategory.title) {
                    matchingMarketplaceCategory.title = matchingMarketplaceCategory.categoryName;
                }
                return service.addStreamToPersonalCategory(stream, matchingMarketplaceCategory, user);
            } else {
                var matchingMarketplaceCategorizedStream = _.findWhere(user.categorizedStreams, { streamId: stream.id });
                if(matchingMarketplaceCategorizedStream) {
                    return service.deleteStreamFromCategory(stream.id, matchingMarketplaceCategorizedStream.categoryId, user.id);
                } else {
                    return $q.when(user);
                }
            }
        } else {
            // Fail safe for uncategorized streams
            return $q.when(user);
        }
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('digestService', ['_', '$http', '$q', '$uibModal', '$rootScope', 'TenantService', 'UtilService',
function(_, $http, $q, $uibModal, $rootScope, tenantService, utilService) {
    const service = {};
    
    service.previewUrl = (digestConfigurationId, userId, extra) => `/ws/user/${userId}/digestConfigurations/${digestConfigurationId}/preview${extra ? extra : ''}`;

    service.openDigestPreview = (digestConfigurationId, userId) => $uibModal.open({
        templateUrl: '/templates/digestPreviewModal.html',
        controller: 'DigestPreviewCtrl',
        size: 'lg',
        keyboard: false,
        resolve: { previewUrl: function() { return service.previewUrl(digestConfigurationId, userId); } }
    });

    service.postDigestConfiguration = (digestConfiguration, userId) =>  utilService.unwrap($http.post(`/ws/user/${userId}/digestConfigurations`, digestConfiguration));

    service.putDigestConfiguration = (digestConfiguration, userId, digestConfigurationId) =>  
        utilService.unwrap($http.put(`/ws/user/${userId}/digestConfigurations/${digestConfigurationId}`, digestConfiguration));

    service.getDigestConfigurations = userId =>  utilService.unwrap($http.get('/ws/user/' + userId + '/digestConfigurations'));

    service.resolveCurrentUserDigestConfiguration = () => service.resolveUserDigestConfiguration($rootScope.user);

    service.resolveUserDigestConfiguration = (user, defaultInactive) => 
        $q.all([ tenantService.getCurrentTenant(), service.getDigestConfigurations(user.id)])
        .then(results => results[1].length === 0 ? 
                         service.postDigestConfiguration(service.buildDefault(user, results[0].data, defaultInactive), user.id) :  
                         results[1][0]);

    service.buildDefault = (user, tenant, defaultInactive) => {
        let title;
        if (tenant && tenant.settings.defaultTitle && tenant.settings.defaultTitle.length) {
            title = tenant.settings.defaultTitle; 
        } else {
            title = (tenant && tenant.settings.noFollowing) ? 'My ' + tenant.name + ' Briefing' : 'My Personal Digest';
        }
        return {
            content: {},
            title: title,
            schedule: {
                scheduleMode: 'RECURRING',
                start: '1900-01-01T00:00:00.000Z',
                timeZone: user.timeZone || tenant.timeZone || 'US/Pacific',
                freq: 'DAILY',
                interval: 1,
                sendHour: new Date().getHours(),
                sendMinute: 0,
                enabled: !defaultInactive
            }
        };
    };

    service.getSendDay = digestConfiguration =>  _.isEmpty(digestConfiguration.schedule.byday) ? 'MO' : digestConfiguration.schedule.byday[0];

    service.compose = (digestConfiguration, sendDay, sendTime, streams) => {
        var newDigestConfiguration = _.cloneDeep(digestConfiguration);
        newDigestConfiguration.schedule.byday = sendDay && digestConfiguration.schedule.freq === 'WEEKLY' ?
            [sendDay] : undefined;
        newDigestConfiguration.content.streamIds = _.pluck(streams, 'id');
        newDigestConfiguration.schedule.sendHour = sendTime.getHours();
        newDigestConfiguration.schedule.sendMinute = sendTime.getMinutes();
        return newDigestConfiguration;
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.provider('DefaultToMyTopicsProvider', function(){
    this.$get = ['_', 'TenantService', function(_, tenantService){
        return tenantService.getUnauthTenantInfo()
        .then(function(response){
            return  _.find(response.data.settings.navConfiguration, {state: 'mytopics.recent'}) || _.find(response.data.settings.navConfiguration, {state: 'mytopics'});
        });
    }];
});
'use strict';

angular.module('attensaApp')
.provider('DefaultToClientProvider', function(){
    this.$get = ['_', 'TenantService', function(_, tenantService) {  
        return tenantService.getUnauthTenantInfo()
        .then(function(resp){ 
            return resp.data.settings.defaultPages && resp.data.settings.defaultPages.DEFAULT && resp.data.settings.defaultPages.DEFAULT.startsWith('/client');
        });
    }];
});
'use strict';

angular.module('attensaApp')
.service('eventService', ['_', 'NgTableParams', '$filter', '$http', '$uibModal', '$q', '$state', '$location', 'growl', 'moment', 'TenantService', 'UserService', 'UtilService',
    function(_, NgTableParams, $filter, $http, $uibModal, $q, $state, $location, growl, moment, tenantService, userService, utilService) {
    var service = {};

    service._eventsSupportedByTenant = undefined;
    service._eventWriteUrl = undefined;

    service._initialize = function() {
        return tenantService.getUnauthTenantInfo()
        .then(function(tenantResponse) {
            var tenant = tenantResponse.data;
            if(tenant.settings && tenant.settings.eventWriteUrl) {
                service._eventsSupportedByTenant = true;
                service._eventWriteUrl = tenant.settings.eventWriteUrl;
                return service._eventWriteUrl;
            } else {
                service._eventsSupportedByTenant = false;
                return $q.reject('Tenant does not support event logging');
            }
        });
    };

    service.postEvent = function(eventName, eventData) {
        if(service._eventsSupportedByTenant === true) {
            return service._addConstantDataAndPostEvent(eventName, eventData);
        } else if(service._eventsSupportedByTenant === false ) {
            return $q.when(undefined);
        } else {
            // We haven't initialized this service with the async tenant data we need
            return service._initialize()
            .then(function() {
                return service._addConstantDataAndPostEvent(eventName, eventData);
            });
        }
    };

    service._addConstantDataAndPostEvent = function(eventName, eventData) {
        return service._addTenantAndUserData(eventData)
        .then(function(extendedEvent) {
            return $http.post(service._eventWriteUrl, {
                userId: extendedEvent.user_emailAddress || 'UNKNOWN', //UNKNOWN if user is logged out and we don't know who it is
                event: eventName,
                data: extendedEvent
            });
        });
    };

    service._addTenantAndUserData = function(eventData) {
        return $q.all([tenantService.getUnauthTenantInfo(), userService.getCurrentUser()])
        .then(function(responses) {
            return _.assign({},
                {
                    tenantId: responses[0].data.id,
                    tenantName: responses[0].data.name,
                },
                {
                    url_current: $location.url(),
                    url_state: $state.current.name
                },
                service.formatUser(responses[1].data.user),
                eventData
            );
        });
    };

    service.formatItem = function(item, prefix) {
        prefix = prefix || '';
        return _.chain({})
            .assign(item)
            .assign({
                publishedDate: new Date(item.publishedDate).toISOString(),
                createdDate: item.created ? new Date(item.created).toISOString() : undefined,
                tags: item.tagText,
                userTags: _.pluck(item.userTags, 'tag')
            })
            .pick('cleanDescription', 'createdDate', 'id', 'link',
                  'publishedDate', 'streamId', 'tags', 'title', 'userTags')
            .mapKeys(function(value, key) {
                return prefix + 'item_' + key;
            })
            .value();
    };

    service.formatStream = function(stream) {
        return _.chain(stream)
            .pick('description', 'emailPostingEnabled', 'id',  'followersCount', 'itemsCount',
                  'ownerId', 'rssEnabled', 'title', 'type')
            .mapKeys(function(value, key) {
                return 'stream_' + key;
            })
            .value();
    };

    service.formatUser = function(user, prefix) {
        return _.chain(user)
            .pick('emailAddress', 'firstName', 'id', 'lastName', 'status')
            .mapKeys(function(value, key) {
                return prefix ? prefix + '_' + key : 'user_' + key;
            })
            .value();
    };

    /* Get an event extraction for a given stream, limited to most recent 5000 events
    *  @param {String} - streamId
    *  @param {Object} - queryOpts
    *                   {
    *                     collectionName: the name of the event/collection to extract
    *                     fromDate: a date to start the extraction from
    *                   }
    */
    service.getStreamEventExtraction = function(streamId, queryOpts) {
        return $http.get('/ws/analytics/extraction', { params: {
            event: JSON.stringify([queryOpts.collectionName]),
            from_date: queryOpts.fromDate,
            to_date: queryOpts.toDate,
            where: '"' + streamId + '" == properties["stream_id"]'
        }})
        .then(function(res) {
            return res.data;
        });
    };

    // Generate table parameters for an ngTable that displays event data.
    // Default sort order is by data property 'time'
    service.generateTableParams = function(data) {
        return new NgTableParams({
            page: 1,
            count: 15,
            sorting: { time : 'desc' }
        }, {
            total: data.length,
            counts: [],
            getData: function(config) {
                var orderedEvents = config.sorting() ? $filter('orderBy')(data, config.sorting()) : data;
                orderedEvents = config.filter() ? $filter('filter')(orderedEvents, config.filter()) : orderedEvents;
                config.total(orderedEvents.total);
                return $q.resolve(orderedEvents.slice((config.page() - 1) * config.count(), config.page() * config.count()));
            },
        });
    };

    // Takes an array of analytics events and prepares them to be exported to CSV by stringifying arrays
    service.formatEventsForCSV = function(events) {
        return _.map(events, function(event) {
            return _.chain(event.properties)
                .assign({ item_tags: _.isArray(event.properties.item_tags) ? event.properties.item_tags.join() : event.properties.item_tags })
                .assign({ item_userTags: _.isArray(event.properties.item_userTags) ? event.properties.item_userTags.join() : event.properties.item_userTags })
                .pick('user_emailAddress','user_lastName','user_firstName','item_title','item_id','item_userTags','item_tags','item_link','item_cleanDescription','item_publishedDate','stream_title','stream_id','stream_type','stream_description','stream_itemsCount','stream_rssEnabled','time')
                .value();
        });
    };

    service.showEventDetailModal = function(stream, collectionName, daysAgo) {
        if(daysAgo >= 2) {
            $uibModal.open({
                templateUrl: '/templates/eventDetailModal.html',
                controller: 'EventDetailModalCtrl',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    stream: function() { return stream; },
                    collectionName: function() { return collectionName; },
                    fromDate: function() { return  moment().subtract(daysAgo - 1, 'days').format('YYYY-MM-DD'); },
                    toDate: function() { return moment().format('YYYY-MM-DD'); }
                }
            });
        } else {
            growl.warning('Detailed event data is delayed approximately one day.  Please select a longer time frame.');
        }
    };

    /* Generate segmentation query params for mixpanel query against a streamId
    *  @param {Integer} - daysAgo - the number of days to go back from now for query
    *  @param {String} - event - the event collection (e.g. 'item_viewed')
    *  @param {Object} - options - optional
    *         {
    *             {String} - segmentationProp: segmentationProp - segment agains a property (e.g. 'item_id')
    *             {String} - streamId: streamId to match against
    *         }
    */
    service.generateSegmentationQuery = function(daysAgo, event, opts) {
        opts = opts || {};
        var whereClause;
        if (opts.streamId) {
            whereClause = '"' + opts.streamId + '" == properties["stream_id"]';
        } else if (opts.briefingId) {
            whereClause = '"' + opts.briefingId + '" == properties["briefing_id"]';
        }
        return {
            event: event,
            from_date: moment().subtract(daysAgo - 1, 'days').format('YYYY-MM-DD'),
            to_date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            on: opts.segmentationProp ? 'properties["' + opts.segmentationProp + '"]' : undefined,
            unit: daysAgo < 7 ? 'hour' : 'day',
            where: whereClause
        };
    };

    service.getSegmentationData = function(daysAgo, event, opts) {
        return $http.get('/ws/analytics/segmentation', {
            params: service.generateSegmentationQuery(daysAgo, event, opts)
        })
        .then(function(res) {
            return res.data;
        });
    };

    // Formats return value from mixpanel segmentation query, returning the number of segment results
    //  {
    //      metric: <result>
    //  }
    service.uniquesMetricFormatter = function(results) {
        return results && results.data ? { metric: _.size(results.data.values) } : {};
    };

    // Formats segmentation query from mixpanel for diplay as a graph and total metric of all data points
    service.totalsFormatter = function(results, event) {
        return {
            graph: {
                summaryText: service.getSummaryText(event),
                labels: results && results.data ? utilService.sparsify(results.data.series, '', 8)  : {},
                data: !results || !results.data || _.isEmpty(results.data.values[event]) ?
                    [] : [_.map(results.data.series, function(label) {
                    return results.data.values[event][label];
                })]
            },
            metric: results && results.data ? _.reduce(results.data.values[event], function(result, val, key) {
                return result + val;
            }, 0) : 0
        };
    };

    // Formats mixpanel result to return array of key-value pairs containing the property segmentated on and the count
    service.topItemsFormatter = function(results) {
        return  results && results.data ? _.chain(results.data.values)
            .mapValues(function(vals, itemId) {
                return _.reduce(vals, function(result, val, date) {
                    return result + val;
                }, 0);
            })
            .pairs()
            .sortBy(function(idCountPair) { return idCountPair[1]; })
            .filter(pair => pair[0] !== 'undefined')
            .takeRight(5)
            .reverse()
            .value() : {};
    };

    // Takes a list of id/count pairs (presumably from mixpanel) and a list of items, returning a list like the following
    // for the intersection based on id
    // [{ id, title, count }]
    service.buildItemListDetails = function(idCountPairs, items) {
        return  _.chain(idCountPairs)
            .map(function(idCountPair) {
                var item = _.find(items, {id: idCountPair[0] });
                return item ? {
                    id: idCountPair[0],
                    title: _.find(items, {id: idCountPair[0] }).title,
                    count: idCountPair[1]
                } : undefined;
            })
            .compact()
            .value();
    };

    // Returns a summary text snippet for an analytics graph based on the event collection
    service.getSummaryText = function(graphSelection) {
        var summaryMap = {
            item_viewed: 'Total articles read over time',
            item_link_clicked: 'Click-throughs to article source over time',
            briefing_email_delivered: 'Email briefings delivered',
            briefing_email_opened: 'Number of times email briefings were opened',
            briefing_email_clicked: 'Number of times email briefings had links clicked',
            briefing_email_dropped: 'Number of undelivered briefings',
            briefing_email_spammed: 'Number of briefings marked as spam'
        };
        return summaryMap[graphSelection];
    };

    service.getFormattedSegmentationData = function(daysAgo, event, formatter, opts) {
        return service.getSegmentationData(daysAgo, event, opts)
        .then(function(results) {
            return formatter(results, event);
        });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('ExtractService', ['$http', 'UtilService',
    function($http, UtilService) {
        var service = {};

        service.getUrlDetails = function(url) {
            return UtilService.unwrap($http.get('/ws/extract', {
                params: { url: url }
            }));
        };

        return service;
    }]);

'use strict';

angular.module('attensaApp')
.service('groupsService', ['_', '$http', '$uibModal', 'UtilService',
function(_, $http, $uibModal, UtilService) {
    var service = {};

    service.fetchGroups = function(options) {
        if (!options) {
            options = {params: {page: 0, rows: 40}};
        }
        return $http.get('/ws/groups/search', options);
    };

    service.fetchGroup = function(groupId) {
        return $http.get('/ws/groups/' + groupId);
    };

    service.deleteGroup = function(groupId) {
        return $http.delete('/ws/groups/' + groupId);
    };

    service.saveGroup = function(group) {
        return $http.post('/ws/groups', group);
    };

    service.editGroup = function(group) {
        return $http.put('/ws/groups', group);
    };

    service.getUsers = function(options) {
        return $http.get('/ws/groups/users', options);
    };

    service.addUser = (groupId, userId) => $http.post(`/ws/groups/${groupId}/users`, [userId]);

    service.removeUser = (groupId, userId) => $http.delete(`/ws/groups/${groupId}/users/${userId}`); 

    service.getStreams = function(options) {
        return $http.get('/ws/groups/streams', options);
    };

    service.addToStream = function(options) {
        return $http.post('/ws/groups/addToStream', options);
    };

    service.deleteFromStream = function(options) {
        var subscriptionInfo = {
            params: {
                groupId: options.groupId,
                streamId: options.streamId
            }
        };
        return $http.delete('/ws/groups/deleteFromStream', subscriptionInfo);
    };

    service.editGroupModal = function(group, tenant) {
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/groupModal.html',
            controller: 'GroupModalCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                tenant: function() { return tenant; },
                group: function() { return group; }
            }
        });
        return modalInstance.result;
    };

    service.getBriefingSubscriptions = function(options) {
        return $http.get('/ws/groups/briefings', options);
    };

    service.subscribeToBriefing = function(group, briefingId, streamId){
        return UtilService.unwrap($http.post('/ws/groups/' + group.id + '/briefings/' + briefingId, { streamId: streamId }))
        .then(function(){
            group.subscriptions.push({ groupId: group.id, briefingId: briefingId, subscribeToBriefing: true });
        });
    };

    service.unsubscribeFromBriefing = function(group, briefingId){
        return UtilService.unwrap($http.delete('/ws/groups/' + group.id + '/briefings/' + briefingId))
        .then(function(){
            _.remove(group.subscriptions, { briefingId: briefingId });
        });
    };

    return service;
}]);
'use strict';

angular.module('attensaApp')
.service('FeatureService', ['TenantService',
function(tenantService) {
    var service = {};

    service.isDisabled = function(featureName){
        return tenantService.getUnauthTenantInfo()
        .then(function(tenant){
            return tenant.data.settings['feature_' + featureName + '_disabled'];
        });
    };

    service.setDisabled = function($scope, property, featureName) {
      service.isDisabled(featureName)
      .then(function(disabled){
          $scope[property] = disabled;
      });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('FilterService', ['_', function(_) {
    var service = {};

    service.filterTermFromBasicStructure = function(basicFilterText, basicFilterStructures) {
        var filterTerm = _.chain(basicFilterStructures)
            .map(function(filterCondition) {
                var escapedValue = filterCondition.value.replace(/"/g, '');
                var condition;
                if(filterCondition.type === 'TEXT') {
                    condition = '(cleanDescription: "' + escapedValue + '" OR title: "' + escapedValue + '")';
                } else if (filterCondition.type === 'TAG') {
                    condition = 'tags.tagText.raw: "' + filterCondition.value + '"';

                }
                return filterCondition.condition === 'CONTAINS' ? condition : '-' + condition;
            })
            .join(' AND ')
            .value();

        return _.compact([basicFilterStructures.length && basicFilterText ? ('(' + basicFilterText + ')') : basicFilterText, filterTerm]).join(' AND ');
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.factory('HttpErrorsInterceptor', ['$q', '$rootScope', function HttpErrorsInterceptor($q, $rootScope) {
    var errorHandler = function(rejection){
        var config = rejection.config;

        if(!config.bypassAuthErrorInterception && rejection.status === 401){
            $rootScope.$broadcast('app.authenticationFailure', rejection);
        }

        //TODO maybe handle general error with the following?? Is there a better way to do this??
        //$rootScope.$broadcast('app.error', 'Error communicating with backend service, please try again.', rejection.data.cause);

        return $q.reject(rejection);
    };

    var interceptor = {};

    interceptor.requestError = errorHandler;
    interceptor.responseError = errorHandler;

    return interceptor;
}]);


'use strict';

angular.module('attensaApp')
.service('imageService', ['$q', '$timeout', '$window', function($q, $timeout, $window) {
    var service = {};

    service.pickImage = function(file){
        var deferred = $q.defer();

        if (file && file.type.indexOf('image') > -1) {
            $timeout(function() {
                var fileReader = new $window.FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = function(e) {
                    $timeout(function() {
                        return deferred.resolve(e.target.result);
                    });
                };
            });
        }

        return deferred.promise;
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('InfoService', ['$rootScope', '$interval', '$http', function($rootScope, $interval, $http) {
    var service = {};

    service.getS3Bucket = function() {
        return $http.get('/ws/info/s3Bucket', { cache: true });
    };

    service.getS3Creds = function(filename, filetype) {
        return $http.post('/ws/info/s3Creds', { filename: filename, type: filetype })
        .then(function(res) {
            return res.data;
        });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('ItemService', ['$http', '$uibModal', '$q', '$rootScope', '$timeout', 'Upload', '_', 'StreamService', 'TenantService', 'UtilService',
function($http, $uibModal, $q, $rootScope, $timeout, $upload, _, streamService, tenantService, UtilService) {
    var service = {};

    service.getItem = function(itemId){
        return $http.get('/ws/item/' + itemId)
        .then(function(itemResponse) {
            return itemResponse.data;
        });
    };

    service.getItems = function(itemIds) {
        return $http.get('/ws/item', { params: { ids: itemIds.join() } })
        .then(function(itemResponse) {
            return itemResponse.data;
        });
    };

    service.getItemMoreLikeThis = function(itemId){
        return $http.get('/ws/item/' + itemId + '/moreLikeThis')
        .then(function(mltResponse) {
            return mltResponse.data;
        });
    };

    service.addAttachment = function(itemId, file) {
        return $http.post('/ws/item/' + itemId + '/attachments', file);
    };

    service.deleteAttachment = function(item, attachment) {
        return $http.delete('/ws/item/' + item.id + '/attachments/'+attachment.id+'/'+encodeURIComponent(attachment.fileName));
    };

    service.saveItem = function(streamId, item) {
        return $http.post('/ws/item?streamId=' + streamId, item);
    };

    service.patchItem = function(streamId, itemId, options) {
        return $http.patch('/ws/item/' + itemId + '?streamId=' + streamId, options);
    };

    service.deleteItem = function(streamId, itemId) {
        return $http.delete('/ws/streams/' + streamId + '/items/' + itemId );
    };

    service.searchItems = function(opts, deferred) {
        return $http.get('/ws/item/search', { params: opts, timeout: deferred })
        .then(function(response){
            return response.data;
        });
    };

    service.searchItemsInStream = function(opts, timeout) {
        return $http.get('/ws/streams/'+opts.streamId+'/items', { params: opts, timeout: timeout });
    };

    service.searchTenantItems = function(opts, deferred) {
        return $http.get('/ws/item/items', { params: opts, timeout: deferred })
        .then(function(response){
            return response.data;
        });
    };

    service.searchItemsWithSettings = function(settings, params, timeout) {
        return UtilService.unwrap($http.post('/ws/item/settingsSearch', settings, { params: params, timeout: timeout }));
    };

    service.searchTaxonomyItems = function(opts, deferred) {
        return $http.get('/ws/taxonomy/items', { params: opts, timeout: deferred })
        .then(function(response){
            return response.data;
        });
    };

    service.getStreamsRelatedToItem = function(item, topicIds) {
        var getStream = function(streamId) {
            return UtilService.unwrap(streamService.getStream(streamId));
        };

        // If streamIDs is a string, we know it is a solid match, use it.
        if(_.isString(topicIds) && !_.isEmpty(topicIds)) {
            return $q.all([
                getStream(item.streamId),
                getStream(topicIds)
            ])
            .then(function(sourceAndTopic) {
                return {
                    source: sourceAndTopic[0],
                    topics: [sourceAndTopic[1]]
                };
            });
        }
        // If we don't have any candidate streams as sources, use the stream directly associated with the item
        else if(_.isEmpty(topicIds)) {
            return getStream(item.streamId)
            .then(function(source) {
                return {
                    source: source,
                    topics: [source]
                };
            });
        } else {
            return $q.all([
                getStream(item.streamId),
                UtilService.unwrap($http.get('/ws/item/' + item.id + '/readingSources', { params: { streamIds: topicIds.join(',') } }))
            ])
            .then(function(sourceAndReadingTopics) {
                return {
                    source: sourceAndReadingTopics[0],
                    topics: _.isEmpty(sourceAndReadingTopics[1]) ? [sourceAndReadingTopics[0]] : sourceAndReadingTopics[1]
                };
            });
        }
    };

    service.postComment = function(itemId, comment) {
        return $http.post('/ws/item/' + itemId + '/comments', comment)
        .then(function(commentResponse) {
            return commentResponse.data;
        });
    };

    service.putComment = function(itemId, comment) {
        return $http.put('/ws/item/' + itemId + '/comments/' + comment.id, comment)
        .then(function(commentResponse) {
            return commentResponse.data;
        });
    };

    service.deleteComment = function(itemId, commentId) {
        return $http.delete('/ws/item/' + itemId + '/comments/' + commentId)
        .then(function(deleteResponse) {
            return deleteResponse.data;
        });
    };

    service.postAnnotation = function(itemId, annotation) {
        return $http.post('/ws/item/' + itemId + '/annotations/', annotation)
        .then(function(annotationResponse) {
            return annotationResponse.data;
        });
    };

    service.putAnnotation = function(itemId, annotation) {
        return $http.put('/ws/item/' + itemId + '/annotations/' + annotation.id, annotation)
        .then(function(annotationResponse) {
            return annotationResponse.data;
        });
    };

    service.deleteAnnotation = function(itemId, annotationId) {
        return $http.delete('/ws/item/' + itemId + '/annotations/' + annotationId)
        .then(function(annotationResponse) {
            return annotationResponse.data;
        });
    };

    service.openNewModal = function(options) {
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/readingModal.html',
            controller: 'ReadingModalCtrl as readingModal',
            size: 'lg',
            keyboard: true,
            resolve: {
                itemId: function() { return options.itemId; },
                hasPrev: function() { return options.hasPrevious; },
                hasNext: function() { return options.hasNext; },
                source: function() { return options.source; },
                streamContext: function() { return options.streamContext; }
            }
        });
        return modalInstance.result;
    };

    service.openEditItemModal = function(itemId, streamId, refreshCallback){
      service.openPostItemModal([], null, null, refreshCallback, itemId);
    };

    service.openPostItemModal = function(selectedStreams, copyItemId, usersFullName, refreshCallback, editItemId) {
        var itemResolver = function(itemId){
            return function(){
                return itemId ? service.getItem(itemId) : null;
            };
        };

        var modalInstance = $uibModal.open({
            templateUrl: '/templates/postItemModal.html',
            controller: 'PostItemModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                streams: function() {
                    return selectedStreams;
                },
                author: function() {
                    return usersFullName;
                },
                tenant: function() {
                    return tenantService.getCurrentTenant();
                },
                copyItem: itemResolver(copyItemId),
                editItem: itemResolver(editItemId)
            }
        }).result.
        then(function(item){
            if(!copyItemId && !editItemId) {
                var modalScope = $rootScope.$new(true);
                modalScope.modalTitle = 'Item Received';
                modalScope.message = 'Item received and is being processed.';
                $uibModal.open({
                    templateUrl: '/templates/messageModal.html',
                    size: 'lg',
                    scope: modalScope
                }).result
                .then(function () {
                    $timeout(function () {
                        refreshCallback({selectedStreams: selectedStreams, item: item});
                    }, 1000);
                });
            } else {
                $timeout(function () {
                    refreshCallback({selectedStreams: selectedStreams, item: item});
                }, 1000);
            }
        });
        return modalInstance.result;
    };

    service.addTag = function(tag, itemId) {
        return $http.post('/ws/item/' + itemId + '/userTags', { tag: tag } )
        .then(function(res) {
            return res.data;
        });
    };

    service.deleteTag = function(tag, itemId) {
        return $http.delete('/ws/item/' + itemId + '/userTags/' + encodeURIComponent(tag))
        .then(function(res) {
            return res.data;
        });
    };

    service.searchTwitter = function(query){
        return UtilService.unwrap($http.get('/ws/twitter', { params: {search: query} }));
    };

    service.getItemOembed = function(link){
        return $http.get('/ws/twitter/tweet', { params: {url: link} });
    };

    service.searchPubmed = function(term) {
        return UtilService.unwrap($http.post('/ws/stream_source/pubmed/preview', { search: term }));
    };

    service.searchClinicaltrials = function(term) {
        return UtilService.unwrap($http.post('/ws/stream_source/clinicaltrials/preview', { search: term }));
    };

    service.searchBing = function(term, settings) {
        return UtilService.unwrap($http.post('/ws/stream_source/bing/preview', { search: term, type: settings.type }));
    };

    service.previewRss = function(uri, settings) {
        var _prependProtocol = function(url) {
            return url.indexOf('http') !== 0 ? 'http://' + url : url;
        };

        return tenantService.getCurrentTenant()
        .then(function(tenantRes) {
            return tenantRes.data.defaultProxyId;
        })
        .then(function(proxyId) {
            return $http.post('/ws/stream_source/rss/preview', {
                uri: _prependProtocol(uri),
                username: settings.username,
                password: settings.password
            }, {
                bypassAuthErrorInterception: true,
                params: { proxyId: proxyId }
            });
        })
        .then(function(result) {
            return result.data;
        });
    };

    service.emailShareLink = function(item) {
        var itemDirectLink = '  ' + (item.link === '#' ? '' : encodeURIComponent(item.link));
        var mailTo = 'mailto:?subject=Recommended: ';
        var bodyParam = '&body=';
        var coreLength = mailTo.length + item.title.length + bodyParam.length + itemDirectLink.length;
        var contents = _.trunc(item.cleanDescription.replace(/&/g, 'and'), (1000 - coreLength));
        var mailtoHref = mailTo + item.title + bodyParam + contents + itemDirectLink;
        return mailtoHref;
    };

    service.attentionRankClass = function(item){
        return 'rank-' + item.attentionRank;
    };

    service.fetchTopicItems = function(topicId, streamId, params){
        return   $http.get('/ws/topics/' + topicId + '/streams/' + streamId + '/items', { params: params})
        .then(function(res){
            return res.data;
        });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('LabelService', ['TenantService',
    function(tenantService) {
        var service = {};

        service.labelFor = function(labelKey, defaultLabel){
            return tenantService.getUnauthTenantInfo()
            .then(function(tenant){
                var labels = typeof tenant.data.settings.labels === 'string' ? JSON.parse(tenant.data.settings.labels) : tenant.data.settings.labels;
                if(labels && labels[labelKey]){
                    return  labels[labelKey];
                } else {
                    return defaultLabel;
                }
            });
        };

        service.setLabel = function($scope, property, labelKey, defaultLabel) {
            service.labelFor(labelKey, defaultLabel)
            .then(function(label){
                $scope[property] = label;
            });
        };

        return service;
    }]);

'use strict';

angular.module('attensaApp')
.service('opmlService', ['_', '$q', '$http', 'StreamService', 'x2js',
    function(_, $q, $http, streamService, x2js) {

    var service = {};

    service.parseOpml = function(opml) {
        var parsedOpml = x2js.xml2js(opml);

        if (!parsedOpml) {
            throw new Error('There was an error parsing the OPML file.');
        }
        return parsedOpml.opml.body.outline;
    };

    service.crawlOutlines = function(outline, parentCategory, importData, imgLinks) {
        if (outline.outline) {
            parentCategory = outline._text || outline._title;
            service.crawlOutlines(outline.outline, parentCategory, importData, imgLinks);
        } else if (Array.isArray(outline)) {
            outline.forEach(function(subOutline) {
                service.crawlOutlines(subOutline, parentCategory, importData, imgLinks);
            });
        } else if (outline._xmlUrl || outline._url) {
            var url = outline._xmlUrl || outline._url;
            var feed = {
                url: url,
                title: outline._title || url,
                category: parentCategory || outline._Category || outline._category
            };
            if(outline._description){
                feed.description = outline._description;
            }

            if(outline._img){
                imgLinks.push({
                    sourceUrl: url,
                    imgUrl: outline._img
                });
            }
            importData.push(feed);
        }
    };

    return service;

}]);

'use strict';

angular.module('attensaApp')
.service('opmlTaxonomicService', ['_', '$q', '$http', 'StreamService', 'TaxonomyService', 'x2js',
function(_, $q, $http, streamService, taxonomyService, x2js) {

    var service = {};

    service.parseOpml = function(opml) {
        var parsedOpml = x2js.xml2js(opml);

        if (!parsedOpml) {
            throw new Error('There was an error parsing the OPML file.');
        }
        return parsedOpml.opml.body.outline;
    };

    service.crawlOutlines = function(outline, parentCategory, importData, imgLinks) {
        if (outline.outline) {
            parentCategory = outline._text || outline._title;
            service.crawlOutlines(outline.outline, parentCategory, importData, imgLinks);
        } else if (Array.isArray(outline)) {
            outline.forEach(function(subOutline) {
                service.crawlOutlines(subOutline, parentCategory, importData, imgLinks);
            });
        } else if (outline._xmlUrl || outline._url) {
            var url = outline._xmlUrl || outline._url;
            var feed = {
                url: url,
                title: outline._title || url,
                category: parentCategory || outline._Category || outline._category
            };
            if(outline._description){
                feed.description = outline._description;
            }

            if(outline._img){
                imgLinks.push({
                    sourceUrl: url,
                    imgUrl: outline._img
                });
            }
            importData.push(feed);
        }
    };

    service.matchCategory = function(feed, taxonomy) {
        var matchingCategory;

        if (feed.category) {
            matchingCategory = _.where(taxonomy, { 'loweredTitle': feed.category.toLowerCase() })[0];
        }

        if (feed.category && !matchingCategory) {
            taxonomy.push({ 'loweredTitle': feed.category.toLowerCase(), 'title': feed.category });
        }
    };

    service.addMissingCategories = function(taxonomy, taxonomyVersion) {
        return taxonomyService.putTenantTaxonomy(taxonomy, taxonomyVersion);
    };

    service.importFeed = function(feed, taxonomy, selectedCategories) {
        var feedData = {
            settings: { uri: feed.url },
            title: feed.title,
            type: 'RSS',
            openForReading: true
        };

        if (feed.description) {
            feedData.description = feed.description;
        }

        //Associate new categories with streams to be imported
        if (selectedCategories) {
            feedData.taxonomicMemberships = [];
            selectedCategories.forEach(function(category) {
                feedData.taxonomicMemberships.push(category.id);
            });
        }
        if (feed.category && !feedData.taxonomicMemberships) {
            feedData.taxonomicMemberships = _.pluck(_.where(taxonomy, {'title': feed.category}), 'id');
        } else if (feed.category && feedData.taxonomicMemberships) {
            var selectedCategoryIds = _.pluck(_.where(taxonomy, {'title': feed.category}), 'id');
            feedData.taxonomicMemberships = feedData.taxonomicMemberships.concat(selectedCategoryIds);
        }

        return streamService.saveStream(feedData);
    };

    service.importOpml = function(opml, taxonomy, taxonomyVersion, selectedCategories) {
        var parsedOpml;
        try {
            parsedOpml = this.parseOpml(opml);
        } catch (err) {
            return $q.reject(err);
        }

        var importData = [];
        var imgLinks = [];

        this.crawlOutlines(parsedOpml, null, importData, imgLinks);
        taxonomy.forEach(function(category) {
            category.loweredTitle = category.title.toLowerCase();
        });

        //Find matching categories and add to taxonomy or missingCategories array
        var promises = [];
        importData.forEach(function(feed) {
            promises.push(service.matchCategory(feed, taxonomy));
        });

        return $q.all(promises)
        .then(function() {
            return service.addMissingCategories(taxonomy, taxonomyVersion);
        })

        //Import the feeds
        .then(function(newTaxonomy) {
            taxonomy = newTaxonomy.data;
            var promises = [];
            importData.forEach(function(feed) {
                promises.push(service.importFeed(feed, taxonomy, selectedCategories));
            });
            return $q.all(promises);
        })

        //Add the images to the streams
        .then(function(streamResponses){
            var idMap = {};
            _.forEach(streamResponses, function(response){
                var val = _.result(_.findWhere(imgLinks, { 'sourceUrl': response.data.settings.uri }), 'imgUrl');
                if(val){
                    idMap[response.data.id] = val;
                }
            });
            return streamService.addImages(idMap);
        });
    };

    return service;

}]);

'use strict';

angular.module('attensaApp')
.service('permissionService', ['_', '$q', '$window', '$state', 'UserService', 'DefaultToMyTopicsProvider', 'DefaultToClientProvider',
    function(_, $q, $window, $state, userService, defaultToMyTopicsProvider, defaultToClientProvider) {

    var service = {};

    service.rerouteStreamViewWithoutPermission = stream => {
        return service.currentUserHasPermission({ action: 'VIEW_STREAM', streamId: stream.id, streamOwnerId: stream.ownerId })
        .then(hasPerm => hasPerm ? undefined : $q.all([defaultToMyTopicsProvider, defaultToClientProvider]))
        .then(results => {
            if(results && results[1]){
                $window.location.href = '/client/digest/recent';
            } else if(results){
                $state.go('mytopics.recent');
            }
        });
    };

    /*
     * Checks if the current user has permission to perform the specified action
     *
     * Argument is an object:
     * {
     *     action:            'DELETE_COMMENTS',
     *     passNoUserThrough: true
     *     streamId:          '123',
     *     streamOwnerId:     '789
     *     userId:            '456',
     * }
     *
     * Argument option property definitions.  All properties are optional, but at least one of 'action' or 'userId' must
     * be supplied.
     * {string} [action]         String specifying the required action (e.g. DELETE_COMMENTS).  Searches tenant level
     *                           permissions by default unless streamId is supplied.
     *
     * {string} [streamId]       StreamId to check permission for.  May be omitted if the permission
     *                           check is for a tenant-level action.
     *
     * {string} [streamOwnerId]  The owner id (userId) of a stream for permission check against. This is used to see if a user
     *                           can execute actions against a stream that they are the owner of.
     *
     * {string} [userId]         UserId to compare to the current user.  If match, then the user is granted permission.
     *
     * {boolean | false} [passNoUserThrough]  If true, if there is no current user, the function will return true
     *
     * @return {Promise->boolean}  Returns promise resolving to a boolean
     *                             true  = user has permission
     *                             false = user does not have permission
     */
    service.currentUserHasPermission = options => userService.getCurrentUser()
    .then(userRes => service.userHasPermission(userRes.data.user, options));

    /*
     * Checks if the provided user has permission to perform the specified action
     *
     * Argument is an object:
     * {
     *     action:            'DELETE_COMMENTS',
     *     passNoUserThrough: true
     *     streamId:          '123',
     *     streamOwnerId:     '789
     *     userId:            '456',
     * }
     *
     * Argument option property definitions.  All properties are optional, but at least one of 'action' or 'userId' must
     * be supplied.
     * {string} [action]         String specifying the required action (e.g. DELETE_COMMENTS).  Searches tenant level
     *                           permissions by default unless streamId is supplied.
     *
     * {string} [streamId]       StreamId to check permission for.  May be omitted if the permission
     *                           check is for a tenant-level action.
     *
     * {string} [streamOwnerId]  The owner id (userId) of a stream for permission check against. This is used to see if a user
     *                           can execute actions against a stream that they are the owner of.
     *
     * {string} [userId]         UserId to compare to the current user.  If match, then the user is granted permission.
     *
     * {boolean | false} [passNoUserThrough]  If true, if there is no current user, the function will return true
     *
     * @return {boolean}  Returns boolean
     *                             true  = user has permission
     *                             false = user does not have permission
     */
    service.userHasPermission = (user, options) => {
        if(user && user.id) {
            return service._userHasPermittedTenantAction(user, options.action) ||
                service._userHasPermittedStreamAction(user, options.action, options.streamId) ||
                service._userIsStreamOwnerAndHasPermission(user, options.action, options.streamOwnerId) ||
                (user.id === options.userId && !options.streamOwnerId);
        } else {
            return options && options.passNoUserThrough ? true : false;
        }
    };

    service.userHasReadPermission = (user, streamId) => service.userHasPermission(user, { action: 'VIEW_STREAM', streamId: streamId });

    service.userCanReadStream = (user, stream, defaultVal) => !stream || !user ? defaultVal : stream.openForReading || service.userHasReadPermission(user, stream.id);

    service._userIsStreamOwnerAndHasPermission = function(user, action, streamOwnerId) {
        return user.id === streamOwnerId &&
            (
                (service._userHasPermittedTenantAction(user, 'CREATE_STREAM') && _.contains(ALLOWED_STREAM_OWNER_ACTIONS, action)) ||
                service._userHasPermittedTenantAction(user, action)
            );
    };

    service._userHasPermittedTenantAction = function(user, action) {
        if(user.tenantRoleActions) {
            return _.some(user.tenantRoleActions, function(tenantRole) {
                return _.contains(tenantRole.actions, action);
            });
        } else {
            return false;
        }
    };

    service._userHasPermittedStreamAction = function(user, action, streamId) {
        if(user.streamRoleActions) {
            return _.some(user.streamRoleActions, function(streamRole) {
                return _.contains(streamRole.actions, action) && streamRole.streamId === streamId;
            });
        } else {
            return false;
        }
    };

    // ACTIONS a stream owner is allowed on the streams they own
    var ALLOWED_STREAM_OWNER_ACTIONS = [
        'DELETE_ITEMS',
        'MANAGE_ANNOTATIONS',
        'MANAGE_STREAM',
        'EMAIL_TO_STREAM',
        'DELETE_COMMENTS',
        'POST_TO_STREAM',
        'VIEW_STREAM'
    ];

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('PreviewService', ['_', 'ItemService',
    function(_, ItemService) {
        var service = {};

        service.previewItems = function(streamType, term, settings) {
            var typeMap = {
                ATTENSA_SEARCH: function(term) {
                    return ItemService.searchItemsWithSettings({
                        search: term,
                        searchConfiguration: settings.searchConfiguration
                    })
                    .then(function(result) {
                        return result.content;
                    });
                },
                PUBMED_SEARCH: ItemService.searchPubmed,
                CLINICALTRIALS_SEARCH: ItemService.searchClinicaltrials,
                BING_SEARCH: ItemService.searchBing,
                RSS: ItemService.previewRss,
                TWITTER_SEARCH: function(term) {
                    return ItemService.searchTwitter(term)
                    .then(function(twitterItems) {
                        return _.map(twitterItems.statuses, function(tweet) {
                            return {
                                title: tweet.text,
                                publishedDate: tweet.created_at
                            };
                        });
                    });
                }
            };

            return typeMap[streamType](term, settings);
        };

        service.generateTitle = function(newSource) {
            return newSource.title || newSource.type + ': ' + newSource.term;
        };

        return service;
    }]);

'use strict';

angular.module('attensaApp')
.service('sessionTimerService', ['$injector', 'growl', function AttensaVersionInterceptor($injector, growl) {
    var service = {};

    var WARNING_LIFETIME = 60 * 1000; // 60 seconds
    var FIVE_MINUTES = 5 * 60 * 1000;
    var HALF_SECOND = 500;
    var _sessionTimer;
    var _warningTime;

    service.resetSessionCounter = function(timeToExpire) {
        clearTimeout(_sessionTimer);
        _sessionTimer = setTimeout(service._sessionWarning, timeToExpire - FIVE_MINUTES);
    };

    service._sessionWarning = function() {
        _warningTime = Date.now();
        var WARNING_TEXT = 'Your session is about to expire.  Click here to dismiss this message and stay logged in.';
        growl.warning(WARNING_TEXT, {
            disableCloseButton: true,
            disableCountDown: false,
            ttl: WARNING_LIFETIME,
            onclose: service._keepSessionAlive
        });
    };

    service._keepSessionAlive = function() {
        // This is sort of a nasty hack, but only way to tell if the growl button was ttl'ed out or clicked
        // We check within a half second since the ttl timeout is not millisecond perfect
        if(Date.now() - _warningTime <= WARNING_LIFETIME - HALF_SECOND) {
            var $http = $injector.get('$http');
            return $http.get('/ws/auth/keepalive');
        } else {
            var userService = $injector.get('UserService');
            userService.getUnCachedCurrentUser()
            .then(function(response){
                if(!response.data.user || !response.data.user.id) {
                    return userService.clearLocalSession();
                }
            });
        }
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('subscriptionService', ['_', '$http', 'UtilService',
function(_, $http, utilService) {
    var service = {};
    var unwrap = utilService.unwrap;

    service.getSubscribedStreams = function() {
        return unwrap($http.get('/ws/subscription/streams'));
    };

    service.flatten = function(personalCategoryTree) {
        return _.chain(personalCategoryTree)
            .map(function(category) {
                return category.streams;
            })
            .flatten()
            .value();
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('StreamService', ['$http', '$uibModal', '$q', '$rootScope', 'Upload', 'eventService', 'TenantService', '$state', 'UtilService', '_', 'TAG_TYPES', 'WATSON_TAG_TYPES', 'TOPIC_TAGS',
    function($http, $uibModal, $q, $rootScope, $upload, eventService, TenantService, $state, UtilService, _, TAG_TYPES, WATSON_TAG_TYPES, TOPIC_TAGS) {
    var service = {};

    service.streamFilterOptions = {
        rss: { type: 'type' , params: 'RSS', label: 'RSS', icon: 'fa-rss'},
        collection: { type: 'type' , params: 'COLLECTION', label: 'Topic', icon: 'fa-sitemap' },
        bing: { type: 'type' , params: 'BING_SEARCH', label: 'Bing', icon: 'fa-windows' },
        twitter: { type: 'type' , params: 'TWITTER_SEARCH', label: 'Twitter', icon: 'fa-twitter' },
        xml: { type: 'type' , params: 'XML', label: 'XML', icon: 'fa-code' },
        search: { type: 'type' , params: 'ATTENSA_SEARCH', label: 'Attensa Search', icon: 'fa-search' },
        published: { type: 'published', params: true, label: 'Published', icon: 'fa-book' },
        briefings: { type: 'hasBriefingEnabled' , params: true, label: 'Briefings', icon: 'fa-envelope-o' }
    };

    service.openStreamDetailModal = function(stream) {
        return $uibModal.open({
            templateUrl: '/templates/streamDetailModal.html',
            controller: 'StreamDetailCtrl',
            size: 'lg',
            resolve: {
                stream: function() { return stream; },
                // TODO fill out the details for taxonomy
                categoryDetail: function() { return stream.taxonomicMembership; }
            }
        });
    };

    service.openFollowersModal = function(stream, showSubscribers, catalogId) {
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/StreamFollowersModal.html',
            controller: 'StreamFollowersModalCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                stream: function() {
                    return stream;
                },
                showSubscribers: function() {
                    return showSubscribers;
                },
                catalogId: function(){
                    return catalogId;
                }
            }
        }).result;
        return modalInstance.result;
    };

    service.postStreamSubscription = function(streamId, targetStreamId) {
        return $http.post('/ws/streams/' + streamId + '/subscriptions', [targetStreamId])
        .then(function(res) {
            return res.data;
        });
    };

    service.deleteStreamSubscription = function(streamId, targetStreamId) {
        return $http.delete('/ws/streams/' + streamId + '/subscriptions/' + targetStreamId)
        .then(function(res) {
            return res.data;
        });
    };

    service.getRecommendedStreams = function(options, deferred){
        return $http.get('/ws/streams/recommended/search', { params: options, timeout: deferred });
    };

    service.getTenantStreams = function(options, deferred) {
        return $http.get('/ws/streams/tenant/search', { params: options, timeout: deferred });
    };

    service.getCatalogStreams = function(catalogId, options, deferred){
        return $http.get('/ws/streams/catalog/' + catalogId + '/search', { params: options, timeout: deferred });
    };

    service.getSubstreams = function(streamId, options, deferred){
        return $http.get('/ws/streams/' + streamId + '/substreams', { params: options, timeout: deferred });
    };

    service.getBriefingsForStream = function(streamId){
        return UtilService.unwrap($http.get('/ws/streams/' + streamId + '/briefings'));
    };

    service.copyToStream = function(itemId, streamId) {
        return $http.post('/ws/item/copy', {
            itemId: itemId,
            streamId: streamId
        });
    };


    service.addTagFilter = function(filter, tag){
        var value = tag ? tag.key : '';
        var type = tag ? 'TAG' : 'TEXT';
        if(!_.some(filter.basicFilterStructures, { value: value, type: type })) {
            filter.basicFilterStructures = filter.basicFilterStructures || [];
            filter.basicFilterStructures.push({
                condition: 'CONTAINS',
                value: value,
                type: type
            });
        }
    };

    service.addCategory = function(category) {
        return $http.post('/ws/category', category);
    };

    service.getFilters = function(streamId) {
        return UtilService.unwrap($http.get('/ws/streams/' + streamId + '/filter'));
    };

    service.postFilter = function(streamId, filter) {
        return $http.post('/ws/streams/' + streamId + '/filter', filter);
    };

    service.removeFilter = function(streamId, filterId) {
        return $http.delete('/ws/streams/' + streamId + '/filter/' + filterId);
    };

    service.getStreamSubscriptions = function(streamId) {
        return $http.get('/ws/streams/' + streamId + '/subscriptions')
        .then(function(res) {
            return res.data;
        });
    };

    service.getStreamTopics = function(streamId, options) {
        return UtilService.unwrap($http.get('/ws/streams/' + streamId + '/topics', { params: options }));
    };

    service.getCatalogStreamFollowers = function(streamId, catalogId, options) {
        return $http.get('/ws/streams/catalogs/' + catalogId + '/streams/' + streamId + '/followers', options);
    };

    service.getStreamFollowers = function(streamId, options) {
        return $http.get('/ws/streams/' + streamId + '/followers', options);
    };

    service.getStreamFollowingGroups = function(streamId, options) {
        return $http.get('/ws/streams/' + streamId + '/groups', { params: options });
    };

    service.getStreamSubscribers = function(streamId, options) {
        return $http.get('/ws/streams/' + streamId + '/subscribers', options);
    };

    service.getStream = function(streamId) {
      return $http.get('/ws/streams/' + streamId);
    };

    service.saveStream = function(stream, params) {
        return TenantService.isAutoPublishTopicTenant()
        .then(function(isAutoPublishTopic){
            if(isAutoPublishTopic && stream.type === 'COLLECTION'){
                stream.published = true;
                eventService.postEvent('topic_created');
            }else{
                eventService.postEvent('source_created');
            }
            if(stream.type === 'TWITTER_SEARCH' || 
               stream.type === 'BING_SEARCH' ||
               stream.type === 'ATTENSA_SEARCH') {
                stream.settings = stream.settings || {};
                stream.settings.itemTimeToLiveInDays = 30;
            }else if(stream.type !== 'COLLECTION'){
                stream.settings = stream.settings || {};                
                stream.settings.itemTimeToLiveInDays = 90;
            }
            return $http.post('/ws/streams', stream, { params: params });
        });
    };

    service.updateStream = function(stream) {
        return $http.put('/ws/streams/' + stream.id, stream);
    };

    service.updateCatalogStream = function(stream) {
        return $http.put('/ws/streams/catalogStreams/' + stream.id, stream);
    };

    service.deleteStreams = function(streamIds) {
        return $http.delete('/ws/streams/', {params: {ids: streamIds.join()}});
    };

    service.deleteStream = function(streamId) {
        return UtilService.unwrap($http.delete('/ws/streams/' + streamId));
    };

    service.deleteStreamFromCatalog = function(catalogId, streamId) {
        return UtilService.unwrap($http.delete('/ws/catalogs/' + catalogId + '/streams/' + streamId));
    };

    service.getProductSource = streamId =>  $http.get(`/ws/streams/${streamId}/productSource`); 

    service.getStreamFromCatalog = function(catalogId, streamId) {
        return $http.get('/ws/catalogs/' + catalogId + '/streams/' + streamId);
    };

    service.patchStreams = function(streams) {
        return $http.patch('/ws/streams/', streams);
    };

    service.saveCredentials= function(streamId, settings) {
        return $http.post('/ws/streams/' + streamId + '/settings/credentials', settings);
    };

    service.createTopicWithSubstreams = function(title, substreamIds) {
        var collectionStream = {
            title: title,
            type: 'COLLECTION',
            openForReading: true,
            published: false
        };

        return service.saveStream(collectionStream)
        .then(function(streamResponse) {
            collectionStream = streamResponse.data;
            var subscriptionPromises = _.map(substreamIds, function(substreamId) {
                return service.postStreamSubscription(collectionStream.id, substreamId);
            });
            return $q.all(subscriptionPromises);
        })
        .then(function() {
            return collectionStream;
        });
    };

    service.saveImage = function(streamId, image) {
        return $upload.upload({
            url: '/ws/streams/' + streamId + '/image',
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            file: image
        });
    };

    service.noCategoryWarning = function() {
        var modalInstance = $uibModal.open({
            templateUrl: '/templates/noCategoryWarningModal.html',
            controller: 'ContinueWarningCtrl',
            resolve: {
                streamsCount: function() {
                    return 1;
                }
            }
        });
        return modalInstance.result;
    };

    service.addImages = function(imageMap){
        return $http.post('/ws/streams/images', imageMap);
    };

    service.checkForCategory = function(catalogMemberships, saveStream, type) {
        var deferred = $q.defer();
        var hasTopic = this.hasCategory(catalogMemberships);

        var savingStream = function() {
            saveStream(type).then(function() {
                deferred.resolve('Save');
            });
        };

        if(hasTopic) {
            savingStream();
        } else {
            this.noCategoryWarning().then(function(result) {
                if(result) {
                    savingStream();
                }
            }, function() {
                deferred.resolve('Save');
            });
        }
        return deferred.promise;
    };

    service.streamSelector = function(category, searching, searchStreams, selectedCategory, streamsForCategories) {
        if (searching) {
            return searchStreams;
        } else if (selectedCategory) {
            return selectedCategory.streams;
        }
        return streamsForCategories[category.id];
    };

    service.processFollowersChange = function(stream) {
        stream.followersCount += stream.userIsFollowing ? 1 : -1;
    };

    service.preventMarketplaceEdit = function(stream){
        if(stream.id && !stream.tenantId){
            $rootScope.$broadcast('stream-builder.close');
        }
    };

    service.categoryTitle = function(category){
        if(category.parentTitle){
            return category.parentTitle + ' > ' + category.title;
        }else{
            return category.title;
        }
    };

    service.extractFactivaFolder = function(factivaUri) {
        var match = factivaUri.match(/select\.factiva\.com\/(.*)/);
        return match ? match[1] : '';
    };

    service.extractFactivaCustomerId = function(factivaUsername) {
        var match = factivaUsername.match(/select\/(.*)/);
        return match ? match[1] : '';
    };

    service.idsFromSearchSpec = function(searchSpec){
        var ids = {};
        var segment = searchSpec.segment;

        if(segment === 'catalog'){
            ids.catalogId = searchSpec.id;
        }

        if(segment === 'catalogCategory'){

            ids.catalogId = searchSpec.catalogId;
        }

        if(segment === 'taxonomyCategory' || segment === 'catalogCategory'){
            ids.categoryId = searchSpec.id;
        }

        return ids;
    };

    service.getStreamItemCounts = function(streamId) {
        return UtilService.unwrap($http.get('/ws/streams/' + streamId + '/items/count'));
    };

    service.itemCounts = function(streamIds, createdAfterDateTime, createdBeforeDateTime, deferred){
        return $http.get('/ws/item/counts', { params: {
            streamIds: streamIds,
            createdAfterDateTime: createdAfterDateTime,
            createdBeforeDateTime: createdBeforeDateTime
        }, timeout: deferred });
    };

    service.topicItemCounts = function(topicId, createdAfterDateTime, createdBeforeDateTime, deferred){
        return $http.get('/ws/topics/' + topicId + '/count', { params: {
            createdAfterDateTime: createdAfterDateTime,
            createdBeforeDateTime: createdBeforeDateTime
        }, timeout: deferred });
    };

    service.categorizeStreamInCatalog = function(streamId, catalogId, categoryId) {
        if (categoryId) {
            return UtilService.unwrap($http.post('/ws/catalogs/' + catalogId + '/taxonomy/' + categoryId + '/streams', [streamId]));
        } else {
            return UtilService.unwrap($http.post('/ws/catalogs/' + catalogId + '/streams', [streamId]));
        }
    };

    service.removeStreamFromCatalogCategory = function(streamId, catalogId, categoryId) {
        return UtilService.unwrap($http.delete('/ws/catalogs/' + catalogId + '/taxonomy/' + categoryId + '/streams/' + streamId));
    };

    var isTagOk = function(tagType, tagText){
        return tagType === 'topics' ? _.some(TOPIC_TAGS, {tagText: tagText}) : _.includes(TAG_TYPES.concat(WATSON_TAG_TYPES), tagType);
    };

    service.parseSearchConfiguration = function(tagVars){
        var tags = [];
        if(tagVars){
            _.forEach(tagVars.split(','), function(splitTagSet){
                var tagBits = splitTagSet.split('__');
                var tagText = tagBits[0];
                var types = _.takeRight(tagBits, tagBits.length - 1);
                _.forEach(types.length ? types : TAG_TYPES.concat(WATSON_TAG_TYPES), function(tagType){
                    if(isTagOk(tagType, tagText)){
                        tags.push({ tagText: tagText, type: tagType });
                    }
                });
            });
        }

        if(tags.length){
            return {tags: tags};
        }
    };

    service.findMatchingStream = function(candiateStreams, term, settings) {
        return _.find(candiateStreams, function(stream) {
            return !_.isEmpty(term) &&
                (
                    (stream.settings.search === term && stream.settings.type === settings.type && stream.type !== 'ATTENSA_SEARCH') ||
                    (stream.settings.search === term && _.isEqual(stream.settings.searchConfiguration, settings.searchConfiguration) && stream.type === 'ATTENSA_SEARCH' ) ||
                    (
                        (stream.settings.uri === term || stream.settings.uri === 'http://' + term || stream.settings.uri === 'https://' + term) &&
                        (stream.settings.username === settings.username)
                    )
                );
        });
    };

    service.formatForExport = streams => 
        _.map(streams, stream => ({
            id: stream.id, 
            title: stream.title,
            source: stream.settings.uri || stream.settings.search,
            retentionDays: stream.settings.itemTimeToLiveInDays,
            type: stream.type,
            created: stream.created,
            followersCount: stream.followersCount,
            itemsCount: stream.itemsCount,
            published: stream.published,
            aggregationEnabled: stream.settings.aggregationDisabled,
            inError: stream.status.inError,
            lastSuccess: stream.status.lastSuccess,
            lastError: stream.status.lastFailure,
            itemsPerDay: stream.status.averageItemsPerDay
        })
    );

    service.fetchStreams = function(streamIds){
        return $q.all(_.map(streamIds, function(streamId){
            return service.getStream(streamId).catch(function(){ return undefined; });
        }))
        .then(function(responses) {
            return _.chain(responses).reject(_.isEmpty).pluck('data').value();
        });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('StreamBuilderService', ['$rootScope', '$uibModal', '$state',
function($rootScope, $uibModal, $state) {
    var service = {};

    service.open = function(target, id, closeable) {
        var modalScope = $rootScope.$new();
        modalScope.config = {
            id: id,
            target: target,
            closeable: closeable  // TODO: We can remove this flag and make default behavior when stream builder modal is nixed
        };

        return $uibModal.open({
            templateUrl: '/templates/streamBuilder/streamModal.html',
            size: 'lg',
            backdrop: 'static',
            scope: modalScope
        });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('streamSourceService', ['$http', function($http) {
    var service = {};

    service.searchStreamSources = function(key, value){
        return $http.get('/ws/stream_source', { params: { key: key, value: value } });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('TagService', ['_',  function(_) {
    var service = {};

    service.extractTagsFromAggregations = function(aggregations, tagTypes){
        return _.chain(tagTypes)
            .map(function(tagType) {
                var typeBucket = _.find(aggregations.tagTypes.type.buckets, { key: tagType });
                return typeBucket ? typeBucket.tagText.buckets : [];
            })
            .flatten()
            .value();
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('TaxonomyService', ['$http', '_', 'growl', 'UtilService', function($http, _, growl, util) {

    var service = {};

    service.getTenantTaxonomy = function(filterEmpty, published, includeSubcategories) {
        return $http.get('/ws/taxonomy', {params: {filterEmpty: filterEmpty, published: published, includeSubcategories: includeSubcategories }});
    };

    service.putTenantTaxonomy = function(taxonomy, tenantVersion) {
        return $http.put('/ws/taxonomy', taxonomy, {
            headers: {
                'X-Object-Version': tenantVersion
            }
        });
    };

    service.putCatalogTaxonomy = function(catalogId, taxonomy) {
        return util.unwrap($http.put('/ws/taxonomy/catalog/' + catalogId + '/taxonomy', taxonomy));
    };

    service.postTenantCategoryImageUrl = function(categoryId, imageUrl) {
        return util.unwrap($http.post('/ws/taxonomy/categories/' + categoryId + '/imageUrl', { imageUrl: imageUrl }));
    };

    service.postCatalogCategoryImageUrl = function(catalogId, categoryId, imageUrl) {
        return util.unwrap($http.post('/ws/taxonomy/catalog/' + catalogId + '/categories/' + categoryId + '/imageUrl', { imageUrl: imageUrl }));
    };

    var markCategoryParent = function(category, parentTitle) {
        category.parentTitle = parentTitle;
        _.forEach(category.subcategories, function(subcat){
            markCategoryParent(subcat, category.title);
        });
    };

    // TODO:  This is awful and we should fix it
    service._setTaxonomyDataOnScope = function(tenantTaxonomyResponse, $scope) {
        $scope.taxonomyVersion = tenantTaxonomyResponse.headers('X-Object-Version');
        $scope.taxonomy = _.reject(tenantTaxonomyResponse.data, { title: 'Uncategorized' });
        _.forEach($scope.taxonomy, function(cat){
            markCategoryParent(cat);
        });
        $scope.categoryCount = service.categoryCount($scope.taxonomy);
    };

    // TODO: And lo, a child was born.  A child with horns that is named Lucifer.  Ye who inherits it's care shall curse my
    // name for all eternity.  I do this not to spite you, I do this for expediency in re-using controller code for managing
    // catalog categories.
    service.setCatalogTaxonomyDataOnScope = function(catalogTaxonomy, $scope) {
        $scope.taxonomy = _.reject(catalogTaxonomy, { title: 'Uncategorized' });
        _.forEach($scope.taxonomy, function(category) {
            markCategoryParent(category);
        });
        $scope.categoryCount = service.categoryCount($scope.taxonomy);
    };

    service.categoryCount = function(taxonomy) {
        return _.reduce(taxonomy, function(total, parentCat){
            return total + 1 + parentCat.subcategories.length;
        }, 0);
    };

    service.saveTenantTaxonomy = function(title, $scope, growl, loadCallback, removeUncategorized) {
        if(title && title.toLowerCase().indexOf('uncategorized') > -1) {
            growl.error('Naming a category as "uncategorized" is invalid.');
            loadCallback();
            return 'Naming a category as "uncategorized" is invalid.';
        }
        var taxonomyWithUncategorized;
        if(removeUncategorized) {
            taxonomyWithUncategorized = $scope.taxonomy.concat([{id: 'uncategorized', title: 'Uncategorized', removable: false}]);
        }
        return service.putTenantTaxonomy((taxonomyWithUncategorized ? taxonomyWithUncategorized : $scope.taxonomy), $scope.taxonomyVersion)
        .then(function(tenantTaxonomyResponse) {
            service._setTaxonomyDataOnScope(tenantTaxonomyResponse, $scope);
        })
        .catch(function(error) {
            if(error.status === 409) {
                growl.error('Changes have conflicted with another user. Please try again.');
                service.getTenantTaxonomy()
                .then(function(tenantTaxonomyResponse) {
                    service._setTaxonomyDataOnScope(tenantTaxonomyResponse, $scope);
                })
                .catch(function() {
                        growl.error('Taxonomy reload failed. Please try refreshing the browser.');
                });
            } else {
                growl.error('Unable to save taxonomy');
            }
        });
    };

    // TODO: This makes me feel like a terrible person.  An honest to god terrible person.  Like one of those people
    // that crowds around the boarding line at the airport before their group is called and you can't tell if
    // they are in line or not.  Then you have to push your way past them when it is your time to board.
    // They probably also have a giant carry on bag that they won't be able to find a spot for in the overhead bins.
    // I hate those people.  And now I am one of them.  I'm sorry, I'm only doing it so I can reasonably re-use controllers
    // that were built to manage tenant taxonomies.
    service.saveCatalogTaxonomy = function(catalogId, title, $scope, growl, loadCallback, removeUncategorized) {
        if(title && title.toLowerCase().indexOf('uncategorized') > -1) {
            growl.error('Naming a category as "uncategorized" is invalid.');
            loadCallback();
            return 'Naming a category as "uncategorized" is invalid.';
        }
        var taxonomyWithUncategorized;
        if(removeUncategorized) {
            taxonomyWithUncategorized = $scope.taxonomy.concat([{id: 'uncategorized', title: 'Uncategorized', removable: false}]);
        }
        return service.putCatalogTaxonomy(catalogId, taxonomyWithUncategorized ? taxonomyWithUncategorized : $scope.taxonomy)
        .then(function(taxonomy) {
            service.setCatalogTaxonomyDataOnScope(taxonomy, $scope);
        })
        .catch(function() {
             growl.error('Unable to save taxonomy');
        });
    };

    service.createStreamCategories = function(tenantTaxonomy, streamTaxonomicMemberships) {
        var streamCategories = [];
        var categoryPush = function(category){
            if(_.contains(streamTaxonomicMemberships, category.id)) {
                streamCategories.push(category);
            }
            _.each(category.subcategories, function(subcat){
                categoryPush(subcat);
            });
        };

        _.each(tenantTaxonomy, function(category){ categoryPush(category); });
        return streamCategories;
    };

    service.markSelectedCategories= function(tenantTaxonomy, streamTaxonomicMemberships) {
        var selectedTaxonomy = tenantTaxonomy.slice();
        var selectCategories = function(category){
            category.selected = _.contains(streamTaxonomicMemberships, category.id);
            _.forEach(category.subcategories, function(subcat){
                selectCategories(subcat, category.title);
            });
        };

        _.forEach(selectedTaxonomy, function(cat){
            selectCategories(cat);
            markCategoryParent(cat);
        });

        return selectedTaxonomy;
    };

    service.markSelectedCategoriesForCatalog = function(taxonomy, selectedCategories) {
        var selectedTaxonomy = taxonomy.slice();
        var selectCategories = function(category) {
            category.selected = !!_.find(selectedCategories, { categoryId: category.id });
            _.forEach(category.subcategories, function(subcategory) {
                selectCategories(subcategory);
            });
        };

        _.forEach(selectedTaxonomy, function(category) {
            selectCategories(category);
            markCategoryParent(category);
        });

        return selectedTaxonomy;
    };

    service.getStreams = function(options) {
        return $http.get('/ws/taxonomy/streams', options);
    };

    service.searchCatalogItems = function(query) {
        return $http.get('/ws/taxonomy/catalog/' + query.catalogId + '/items', { params: query })
        .then(function(results){
            return results.data;
        });
    };

    service.searchCatalogCategoryItems = function(query) {
        return $http.get('/ws/taxonomy/catalog/' + query.catalogId + '/category/' + query.id + '/items', { params: query })
        .then(function(results){
            return results.data;
        });
    };

    service.getCatalogCategoryStreams = function(catalogId, options) {
        return $http.get('/ws/taxonomy/catalog/' + catalogId + '/streams', options);
    };

    service.getCatalogTaxonomy = function(catalogId, params) {
        return $http.get('/ws/taxonomy/catalog/' + catalogId + '/taxonomy', { params: _.assign({ filterEmpty: true }, params) })
        .then(function(results){
            return results.data;
        });
    };

    service.getCatalogTaxonomyTenantlessView = function(catalogId) {
        return util.unwrap($http.get('/ws/taxonomy/catalog/' + catalogId + '/taxonomy/tenantless' ));
    };

    service.getCatalogTags = function(catalogId){
        return $http.get('/ws/taxonomy/catalog/' + catalogId + '/tags')
        .then(function(results){
            return results.data;
        });
    };

    service.getParentCategoryId = function(subcategoryId, taxonomy) {
        var parent = _.find(taxonomy, function(topLevelCategory) {
            return _.some(topLevelCategory.subcategories, { id: subcategoryId });
        });
        return parent ? parent.id : undefined;
    };

    service.getCategory = function(set, id){
        var result;
        _.forEach(set, function(category){
            if(category.id === id){
                result = category;
            }
            _.forEach(category.subcategories, function(subcategory){
                if(subcategory.id === id){
                    result = subcategory;
                }
            });
        });
        return result;
    };

    service.isTaxonomySegment = function(segmentation){
        return segmentation.segment === 'taxonomy' || segmentation.segment === 'taxonomyCategory';
    };

    // Given a taxonomy, return an array of categories that have the given parent category.
    // If the top level of categories is desired, the parent category id may be omitted.
    service.getCategoryList = function(taxonomy, parentCategoryId) {
        if(!parentCategoryId) {
            return _.map(taxonomy, function(category) {
                return _.omit(category, 'subcategories');
            });
        } else {
            var parentCategory = _.find(taxonomy, { id: parentCategoryId });
            return parentCategory ? parentCategory.subcategories : [];
        }
    };
    
    // Given a taxonomy/catalog and a categoryId, this will return an array of categories from the
    // taxonomy root to the category with categoryId.  The root is represented with undefined id and
    // title 'Categories'
    service.buildBreadCrumbs = function(taxonomy, categoryId) {
        var categoryStack = [{ id: undefined, title: 'Categories'}];  // We start at root level
        _.forEach(taxonomy, function(topLevelCategory) {
            if(topLevelCategory.id === categoryId) {
                categoryStack.push(topLevelCategory);
            } else {
                var matchingSubcategory = _.find(topLevelCategory.subcategories, { id: categoryId });
                if(matchingSubcategory) {
                    categoryStack.push(topLevelCategory, matchingSubcategory);
                }
            }
        });

        return categoryStack;
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('TenantService', ['$rootScope', '$http', '$cacheFactory', '$uibModal', 'UtilService',
    function($rootScope, $http, $cacheFactory, $uibModal, utilService) {
    var service = {};
    var unwrap = utilService.unwrap;

    service.getApiCredentials = () => $http.get('/ws/tenant/apiCredentials');

    service.createApiCredentials = () => $http.post('/ws/tenant/apiCredentials', {}); 

    service.deleteApiCredentials = credId => $http.delete(`/ws/tenant/apiCredentials/${credId}`);

    service.getCurrentTenant = function() {
        return $http.get('/ws/tenant/current', { cache: true, bypassAuthErrorInterception: true });
    };

    service.getCatalogMap = function() {
        return unwrap($http.get('/ws/tenant/catalogs'));
    };

    service.getStreamTags = function() {
        return unwrap($http.get('/ws/tenant/streamTags'));
    };

    service.saveStreamTag = function(tag) {
        return unwrap($http.post('/ws/tenant/streamTags', tag));
    };

    service.saveSettings = function(settings) {
        $cacheFactory.get('$http').removeAll();
        return unwrap($http.put('/ws/tenant/settings', settings))
        .then(function(result){
            $rootScope.$broadcast('tenant-settings-updated');
            return result;
        });
    };

    service.saveDigestCommentaries = (commentaries) => $http.put('/ws/tenant/digestCommentaries', commentaries)
    .then(result => {
        $cacheFactory.get('$http').removeAll();
        $rootScope.$broadcast('tenant-settings-updated');
        return result.data;
    });

    service.updateStreamTag = function(tag) {
        return unwrap($http.put('/ws/tenant/streamTags/' + tag.id, tag));
    };

    service.deleteStreamTag = function(tag) {
        return unwrap($http.delete('/ws/tenant/streamTags/' + tag.id, tag));
    };

    service.getUnauthTenantInfo = function() {
        return $http.get('/ws/unauthTenant/unauthTenantInfo', { cache: true, bypassAuthErrorInterception: true });
    };

    service.isAutoPublishTopicTenant = function(){
        return service.getCurrentTenant()
        .then(function(tenantResponse){
            return tenantResponse.data.settings.autoTopicPublish && tenantResponse.data.settings.autoTopicPublish === 'true';
        });
    };

    service.isAutoPublishBriefingTenant = function(){
        return service.getCurrentTenant()
        .then(function(tenantResponse){
            return tenantResponse.data.settings.autoBriefingPublish && tenantResponse.data.settings.autoBriefingPublish === 'true';
        });
    };

    service.openManageStreamTagsModal = function() {
        $uibModal.open({
            templateUrl: '/templates/manageStreamTagsModal.html',
            controller: 'ManageStreamTagsCtrl',
            size: 'md',
            resolve: {
                streamTags: service.getStreamTags
            }
        });
    };

    service.createTenantCreationRequest = function(emailAddress){
        return unwrap($http.post('/ws/ua/tenant/creationRequest', { emailAddress: emailAddress }, { bypassAuthErrorInterception: true }));
    };

    service.fetchToken = function(code){
        return unwrap($http.get('/ws/ua/tenant/code/' + code));
    };

    service.tenantHostExists = function(host){
        return unwrap($http.get('/ws/ua/tenant/', { params: { tenantHost: host }, bypassAuthErrorInterception: true }));
    };

    service.createNewTenant = function(token, user, tenant){
        return unwrap($http.post('/ws/ua/tenant',
                                 { token: token, user: user, tenant: tenant },
                                 { bypassAuthErrorInterception: true }));
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('UtilService', ['$uibModal', '$timeout', '_', '$state', '$mdDialog', '$location',
    function($uibModal, $timeout, _, $state, $mdDialog, $location) {
    var service = {};

    var domain = $location.host().split('.');
    service.rootDomain = '.' + domain[domain.length -2] + '.' + domain[domain.length -1];

    service.displayTimezones = [
        { key: 'US/Samoa', val: 'Midway Island, Samoa'},
        { key: 'US/Hawaii', val: 'Hawaii'},
        { key: 'US/Alaska', val: 'Alaska'},
        { key: 'US/Pacific', val: 'Pacific Time (US & Canada)'},
        { key: 'US/Mountain', val: 'Mountain Time (US & Canada)'},
        { key: 'US/Central', val: 'Central Time (US & Canada), Mexico City'},
        { key: 'US/Eastern', val: 'Eastern Time (US & Canada), Bogota, Lima'},
        { key: 'Canada/Atlantic', val: 'Atlantic Time (Canada), Caracas, La Paz'},
        { key: 'Canada/Newfoundland', val: 'Newfoundland'},
        { key: 'America/Argentina/Buenos_Aires', val: 'Brazil, Buenos Aires, Georgetown'},
        { key: 'Brazil/DeNoronha', val: 'Mid-Atlantic'},
        { key: 'Atlantic/Cape_Verde', val: 'Azores, Cape Verde Islands'},
        { key: 'Europe/London', val: 'Western Europe Time, London, Lisbon, Casablanca'},
        { key: 'Europe/Paris', val: 'Brussels, Copenhagen, Madrid, Paris'},
        { key: 'Europe/Kaliningrad', val: 'Kaliningrad, South Africa'},
        { key: 'Europe/Moscow', val: 'Baghdad, Riyadh, Moscow, St. Petersburg'},
        { key: 'Europe/Samara', val: 'Abu Dhabi, Muscat, Baku, Tbilisi'},
        { key: 'Asia/Kabul', val: 'Kabul'},
        { key: 'Asia/Karachi', val: 'Ekaterinburg, Islamabad, Karachi, Tashkent'},
        { key: 'Asia/Colombo', val: 'Bombay, Calcutta, Madras, New Delhi'},
        { key: 'Asia/Kathmandu', val: 'Kathmandu'},
        { key: 'Asia/Almaty', val: 'Almaty, Dhaka, Colombo'},
        { key: 'Asia/Bangkok', val: 'Bangkok, Hanoi, Jakarta'},
        { key: 'Asia/Hong_Kong', val: 'Beijing, Perth, Singapore, Hong Kong'},
        { key: 'Asia/Tokyo', val: 'Tokyo, Seoul, Osaka, Sapporo, Yakutsk'},
        { key: 'Australia/Darwin', val: 'Adelaide, Darwin'},
        { key: 'Pacific/Guam', val: 'Eastern Australia, Guam, Vladivostok'},
        { key: 'Pacific/Noumea', val: 'Magadan, Solomon Islands, New Caledonia'},
        { key: 'Pacific/Majuro', val: 'Auckland, Wellington, Fiji, Kamchatka'}
    ];

    service.repeatModes = [
        { key: 'HOURLY', val: 'Hourly'},
        { key: 'DAILY', val: 'Daily'},
        { key: 'EVERY_WEEKDAY', val: 'Every weekday (Monday to Friday)'},
        { key: 'EVERY_MON_WED_FRI', val: 'Every Monday, Wednesday and Friday'},
        { key: 'EVERY_TUE_THUR', val: 'Every Tuesday and Thursday'},
        { key: 'WEEKLY', val: 'Weekly'},
        { key: 'BIWEEKLY', val: 'Bi-weekly'},
        { key: 'MONTHLY', val: 'Monthly'}
    ];

    service.createPager = function(pagedResults) {
        var pager = {
            pageSize: pagedResults.size,
            firstPage: pagedResults.first,
            lastPage: pagedResults.last,
            prevPage: pagedResults.last,
            nextPage: pagedResults.first,
            totalItems: pagedResults.totalElements,
            totalPages: pagedResults.totalPages,
            currentPage: pagedResults.number + 1,
            pages: []
        };
        for(var x = 0; x < pager.totalPages; x++) {
            pager.pages.push(x);
        }
        return pager;
    };

    service.isUnchanged = function(target){
        var original = angular.copy(target);
        return function(){
            // Angular adds a hashkey to the object that we dont want to compare against
            var modifiedTarget = _.cloneDeep(target);
            if (modifiedTarget.$$hashKey) {
                delete modifiedTarget.$$hashKey;
            }
            return _.isEqual(original, modifiedTarget);
        };
    };

    service.confirmUnsavedChangeNav = function($scope, target, doubleGo){
        if(target && !$scope.isUnchanged){
            $scope.isUnchanged = service.isUnchanged(target);
        }

        $scope.$on('$stateChangeStart', function(event, toState, toParams) {
            if (!$scope.isUnchanged() && !$scope.ignoreChanges) {
                event.preventDefault();
                if (!$scope.confirmNavigationPromise) {
                    $scope.confirmNavigationPromise = $uibModal.open({
                        templateUrl: '/templates/stateChangeWithChangesWarningModal.html'
                    }).result;
                    $scope.confirmNavigationPromise
                    .then(function () {
                        $scope.ignoreChanges = true;
                        $state.go(toState, toParams);
                        if(doubleGo){
                            $timeout(function(){
                                $state.go(toState, toParams, {}, {location: true});
                            });
                        }
                    }, function () {
                        delete $scope.confirmNavigationPromise;
                    });
                }
            }
        });
    };

    service.isAllDisabled = function(checkboxArray) {
        var disabled = true;

        angular.forEach(checkboxArray, function(checkbox) {
            if(checkbox.selected) {
                disabled = false;
            }
        });

        return disabled;
    };

    service.sortPeopleOptions = function(sortOptions, $scope) {
        return {
            params: {
                streamId: sortOptions && sortOptions.streamId ? sortOptions.streamId : $scope.streamId,
                groupId: sortOptions && sortOptions.groupId ? sortOptions.groupId : $scope.groupId,
                searchTerm: sortOptions && sortOptions.searchTerm ? sortOptions.searchTerm : $scope.searchTerm || $scope.groupSearchTerm || ($scope.search ? $scope.search.searchTerm : ''),
                tenantRole: sortOptions && sortOptions.tenantRole ? sortOptions.tenantRole : ($scope.filterByTenantRole ? $scope.filterByTenantRole.type : undefined),
                streamRole: sortOptions && sortOptions.streamRole ? sortOptions.streamRole : $scope.sortByStreamRole,
                page: sortOptions && sortOptions.page ?  sortOptions.page : $scope.currentPage || $scope.page,
                rows: sortOptions && sortOptions.rows ? sortOptions.rows : $scope.pageLimit || $scope.rows,
                sort: sortOptions && sortOptions.sort ? sortOptions.sort : $scope.sort,
                sortDirection: sortOptions && sortOptions.sortDirection ? sortOptions.sortDirection : $scope.sortDirection
            }
        };
    };

    service.tooltipManager = function(obj, isBriefing, fromStream) {
        if (isBriefing && obj.userSubscriptionIsRestricted) {
            return 'Can\'t unsubscribe from restricted streams.';
        } else if (isBriefing && !obj.userIsSubscribedToBriefing) {
            return 'Subscribe to briefing';
        } else if (isBriefing && obj.userIsSubscribedToBriefing) {
            return 'Unsubscribe from briefing';
        } else if (!fromStream && obj.userSubscriptionIsRestricted) {
            return 'Can\'t unfollow restricted streams.';
        } else if (!fromStream && obj.userIsFollowing) {
            return 'Unfollow this stream';
        } else if (!fromStream && !obj.userIsFollowing) {
            return 'Follow this stream';
        } else if (fromStream && obj.streamIsSubscribed) {
            return 'Remove this stream';
        } else if (fromStream && !obj.streamIsSubscribed) {
            return 'Add this stream';
        }
    };

    service.filteredFrequencies = function(schedule) {
        if(!schedule) {
            // Bad schedule data
            return '';
        }

        if(schedule.scheduleMode === 'MANUAL') {
            return 'Manual';
        } else if(schedule.scheduleMode === 'RECURRING') {
            return _.findWhere(service.repeatModes, { key: schedule.freq }).val;
        }
    };

    service.unwrap = function(httpPromise){
        return httpPromise
        .then(function(response){
            return response.data;
        });
    };

    service.sparsify = function(array, fill, factor) {
        return _.map(array, function(val, idx, series) {
            if(idx === 0 || idx === series.length - 1 || (idx % parseInt(series.length / factor) === 0)) {
                return val;
            } else {
                return fill;
            }
        });
    };

    service.cleanQuotes = function(target){
        return target ? target.replace(/[\u2018\u2019]/g, '\'').replace(/[\u201C\u201D]/g, '"') : target;
    };

    service.showModal = function(template, locals){
        return $mdDialog.show({
            template: template,
            controller: ['$mdDialog', function($mdDialog){
                this.cancel = $mdDialog.cancel;
                this.done = $mdDialog.hide;
            }],
            locals: locals,
            controllerAs: '$ctrl',
            bindToController: true
        });
    };

    return service;
}]);

'use strict';

angular.module('attensaApp')
.factory('UserAuthenticatedInterceptor', ['sessionTimerService', function AttensaVersionInterceptor(sessionTimerService) {
    return {
        response: function(response) {
            if(response.headers('X-Attensa-Authenticated')) {
                sessionTimerService.resetSessionCounter(response.headers('X-Attensa-Authenticated'));
            }

            return response;
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.service('UserService', ['$cacheFactory', '$window', '$http', '$rootScope', 'Upload', '$state', '_', 'growl', 'UtilService',
    function($cacheFactory, $window, $http, $rootScope, $upload, $state, _, growl, UtilService) {
    var service = {};

    var bootIntercom = function(user){
        if(user && user.isIntercomLinked && $window.Intercom && !$window.Intercom.isBooted){
            $window.Intercom('boot', {
                app_id: $window.APP_ID,
                user_id: user.id,
                email: user.emailAddress
            });
            $window.Intercom.isBooted = true;
        }
    };

    service.initials = function(name) {
        return name.split(' ').map(function (s) { return s.charAt(0); }).join('');
    };

    service.canActivate = function(id, invitationCode){
        return UtilService.unwrap($http.get('/ws/auth/status', {params: { userId: id, invitationCode: invitationCode }}));
    };

    service.checkUser = function() {
        return service.getCurrentUser().then(function (result) {
            var currentUser = result.data.user;
            $rootScope.user = currentUser;
            return currentUser;
        });
    };

    service.clearLocalSession = function(){
        $cacheFactory.get('$http').removeAll();
        $state.go('login');
    };

    service.destroySession = function() {
        $cacheFactory.get('$http').removeAll();
        return $http.get('/ws/auth/logout');
    };

    service.logout = function(options) {
        this.destroySession()
        .then(function(logoutRes) {
            if(logoutRes.data.redirect) {
                $window.location.href = logoutRes.data.redirect;
            } else {
                $state.go('login');
            }
        })
        .catch(function() {
           $state.go('login');
        });
    };

    service.archiveUser = function(user) {
        return $http.delete('/ws/user/archive', {
            params:{
                userId:user.id
            }
        });
    };

    service.getUnCachedCurrentUser = function(){
        $cacheFactory.get('$http').remove('/ws/user');
        return service.getCurrentUser();
    };

    service.getCurrentUser = function(doNotCache) {
        return $http.get('/ws/user', { cache: !doNotCache,  bypassAuthErrorInterception: true })
        .then(function(response){
            bootIntercom(response.data.user);
            return response;
        });
    };

    service.savePicture = function(userId, image) {
        return $upload.upload({
            url: '/ws/user/' + userId + '/image',
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            file: image
        });
    };

    service.persistCurrentUser = function(user) {
        $cacheFactory.get('$http').removeAll();
        return UtilService.unwrap($http.put('/ws/user/currentUser', user));
    };

    service.persistUser = function(user) {
        return $http.put('/ws/user/' + user.id, user);
    };

    service.updateCurrentUser = function(user) {
        $rootScope.user = user;
    };

    //Deprecated
    service.getUsers = function(options) {
        return $http.get('/ws/user/search', options);
    };

    service.fetchUsers = function(rows, page, sort, sortDirection, term) {
        return UtilService.unwrap($http.get('/ws/user/search', {params: { rows: rows, page: page, sort: sort, sortDirection: sortDirection, searchTerm: term }}));
    };

    service.subscribeToBriefing = function(user, briefingId, streamId){
        return UtilService.unwrap($http.post('/ws/user/' + user.id + '/briefings/' + briefingId, { streamId: streamId }))
        .then(function(){
            user.subscriptions.push({ userId: user.id, briefingId: briefingId, subscribeToBriefing: true });
        });
    };

    service.unsubscribeFromBriefing = function(user, briefingId){
        return UtilService.unwrap($http.delete('/ws/user/' + user.id + '/briefings/' + briefingId))
        .then(function(){
            _.remove(user.subscriptions, { briefingId: briefingId });
        });
    };

    service.uaUnsubscribeFromBriefing = function(userId, briefingId){
        return UtilService.unwrap($http.delete('/ws/ua/briefings/' + briefingId + '/user/' + userId));
    };

    service.getUserByInvitationCode = function(invitationCode) {
        return $http.get('/ws/user/forInvitationCode', { params: { invitationCode: invitationCode}})
        .then(function(res) {
            return res.data;
        });
    };

    service.getUserByEmail = function(email) {
        var apiAddress = '/ws/user/getUserByEmailAddress';
        return $http.get(apiAddress, { params: { emailAddress: email }, bypassAuthErrorInterception: true });
    };

    service.getUserStreams = function(options) {
        return $http.get('/ws/user/streams', options);
    };

    service.getUserBriefings = function(options) {
        return $http.get('/ws/user/briefings', options);
    };

    service.getUserGroups = function(options) {
        return $http.get('/ws/user/groups', options);
    };

    service.activateUser = function(user) {
        return $http.post('/ws/user/activateUser', user)
        .then(function(res) {
            return res.data;
        });
    };

    service.signIn = function (credentials){
        return $http.post('/ws/auth', credentials, {bypassAuthErrorInterception: true})
        .then(function(response){
            bootIntercom(response.data.user);
            return response;
        });
    };

    service.sendUsersInvitation = function(selectedUserIds) {
        return  $http.post('/ws/user/inviteUsers', selectedUserIds);
    };

    service.sendTopicInvitation = function(topicId, topicTitle, emails) {
        return  $http.post('/ws/user/inviteToTopic', { topicId: topicId, topicTitle: topicTitle, emails: emails });
    };

    service.addNewUsers = function(newUsers) {
        return $http.post('/ws/user/addUsers', newUsers);
    };

    service.forgotPassword = function (email){
        return $http.post('/ws/user/forgotPassword', email,  {bypassAuthErrorInterception: true});
    };

    service.resetPassword = function (resetInfo){
        return $http.post('/ws/user/resetPassword', resetInfo, {bypassAuthErrorInterception: true});
    };

    service.startSignup = function(email, path) {
      return $http.post('/ws/user/selfSignup', { emailAddress: email, path: path }, {bypassAuthErrorInterception: true});
    };

    service.isAdmin = function(user) {
        return _.findWhere(user.tenantRoles, { roleType: 'TENANT_ADMIN' });
    };

    service.toggleBookmark = function(item, items){
        var bookmarkPromise =  item.savedByUser ?
            service.removeBookmark(item.id) : service.bookmarkItems([item.id]);
        _.find(items, { id: item.id }).savedByUser = !item.savedByUser;

        return bookmarkPromise
        .catch(function(err) {
            growl.error('An error ocurred updating save status');
        });
    };

    // Adds items to the currents user's saved/bookmarked list
    service.bookmarkItems = function(itemIds) {
        return $http.post('/ws/user/bookmarks/items', itemIds)
        .then(function(res) {
            return res.data;
        });
    };

    // Adds items to the currents user's saved/bookmarked list
    service.removeBookmark = function(itemId) {
        return $http.delete('/ws/user/bookmarks/items/' + itemId)
        .then(function(res) {
            return res.data;
        });
    };

    // Gets a user's bookmarked/saved items
    service.getBookmarkedItems = function(searchParams, timeout) {
        return $http.get('/ws/user/bookmarks/items', { params: searchParams, timeout: timeout })
        .then(function(res) {
            return res.data;
        });
    };

    service.searchUserItems = function(searchParams, timeout){
        return $http.get('/ws/user/items', { params: searchParams, timeout: timeout})
        .then(function(res) {
            return res.data;
        });
    };

    service.searchUserCategoryItems = function(searchParams){
        return $http.get('/ws/user/category/items', { params: searchParams })
        .then(function(res) {
            return res.data;
        });
    };

    service.setFollowing = function(streamId, userId, opts) {
        return $http.post('/ws/user/' + userId + '/streams', {
            streamId: streamId,
            follow: opts.follow,
            subscribeToBriefing: opts.subscribe,
            restricted: false
        });
    };

    service.formatForExport = function(users) {
        return _.map(users, function(user) {
            return _.assign({lastName: '', firstName: '', emailAddress: '', status: '', created: '', lastActivityDate: ''},
                _.pick(user, 'lastName', 'firstName', 'emailAddress', 'status', 'created', 'lastActivityDate'));
        });
    };

    service.addTenantRole = function(userId, tenantId, roleType) {
        return UtilService.unwrap($http.post('/ws/user/' + userId + '/tenantRoles', {
            tenantId: tenantId,
            roleType: roleType
        }));
    };

    service.removeTenantRole = function(userId, tenantId, roleType) {
        return UtilService.unwrap($http.delete('/ws/user/' + userId + '/tenantRoles', { params: {
            tenantId: tenantId,
            roleType: roleType
        } }));
    };

    service.login = function(){
        return UtilService.showModal([
            '<md-dialog flex="50">',
            '<login-control cancel="$ctrl.cancel()" done="$ctrl.done(result)"></login-control>',
            '</md-dialog>'
        ].join('\n'))
        .then(function(result){
            if(result === 'forgot-password'){
                service.startPasswordReset();
                return null;
            }else{
                bootIntercom(result);
                return result;
            }
        });
    };

    service.startPasswordReset = function(){
        return UtilService.showModal([
            '<md-dialog flex="50">',
            '<forgot-password cancel="$ctrl.cancel()" done="$ctrl.done(result)"></forgot-password>',
            '</md-dialog>'
        ].join('\n'));
    };

    $rootScope.$on('follow-change', function(){
        $cacheFactory.get('$http').remove('/ws/user');
        service.getCurrentUser();
    });

    $rootScope.$on('subscribe-change', function(){
        $cacheFactory.get('$http').remove('/ws/user');
        service.getCurrentUser();
    });

    return service;
}]);

'use strict';

angular.module('attensaApp')
.service('BriefingSubscriptionService', ['$http', function($http) {
    var service = {};

    service.toggleBriefing = function(briefing, streamId) {
        if(briefing && briefing.enabled){
            return $http.get('/ws/briefing/disable', {params: {'briefingId': briefing.id}});
        } else {
            return $http.get('/ws/briefing/enable', {params: {'streamId': streamId}});
        }
    };

    return service;

}]);
'use strict';

angular.module('attensaApp')
.service('TemplateService',
            ['$rootScope', '$http', '_', '$uibModal', 'UtilService',
    function($rootScope, $http, _, $uibModal, UtilService) {

    var service = {};

    service.getAll = function(){
        return $http.get('/ws/template/getAll');
    };

    service.getAllUnauth = function(){
        return UtilService.unwrap($http.get('/ws/ua/templates'));
    };

    service.saveTemplate = function(template, changes) {
        var templateWithChanges = _.extend(template, changes);
        return $http.post('/ws/template/'+template.id, templateWithChanges).then(function(response) {
            return response.data;
        });
    };

    service.openTemplateBrowser = function(briefing) {
        return $uibModal.open({
            templateUrl: '/templates/templateBrowserModal.html',
            controller: 'TemplateBrowserCtrl',
            size: 'lg',
            resolve: {
                templates: ['TemplateService', function(templateService) {
                    return templateService.getAll();
                }],
                briefing: function() {
                    return briefing;
                },
                s3Bucket: ['InfoService', function(infoService) {
                    return infoService.getS3Bucket();
                }]
            }
        }).result.then(function(res){
            $rootScope.$broadcast('refreshTemplates');
            return res;
        });
    };

    return service;

}]);

'use strict';

angular.module('attensaApp')
.factory('AttensaVersionInterceptor', ['growl', function AttensaVersionInterceptor(growl) {
    var _cachedVersion;

    return {
        response: function(response) {
            var version = response.headers('X-Attensa-Version');

            if(version && !_cachedVersion) {
                _cachedVersion = version;
            } else if(_cachedVersion && version && (version !== _cachedVersion) && (version !== 'unknown')) {
                growl.info('<a onclick="window.location.reload()">' +
                           'We just updated Attensa and we need to load the new version. ' +
                           'Click to reload now.</a>', {ttl: -1});
            }
            return response;
        }
    };
}]);

'use strict';

angular.module('attensaApp')
.run(['$rootScope', 'eventService', '$window', function($rootScope, eventService, $window) {
    $rootScope.$on('$stateChangeSuccess', function(event, toState, toStateParams, fromState) {
        // Current state info is automatically injected by event service for any event. So here we just provide where we came from
        eventService.postEvent('url_changed', { url_from_state: fromState.name});

        //Let intercom know that the world as we know it has changed because that is the kind of people we are
        if($window.Intercom && $window.Intercom.isBooted){
            $window.Intercom('update');
        }
    });
}]);

'use strict';

/*
 * AUTHORIZATION MODULE FOR UI-ROUTER ROUTES
 *
 * Each route authorization strategy needs a 'defineRole' here. Note that we are really defining the
 * *permitted action* and not the role, but the angular-permission API uses a function called 'defineRole'.
 * Don't let the term confuse you.
 */

angular.module('routeAuthorization', [])
    .run(['Permission', 'permissionService', '$q', function (permission, permissionService, $q) {
        var _resolvePermission = function(permissionObj) {
            var deferred = $q.defer();

            permissionService.currentUserHasPermission(permissionObj)
            .then(function(userHasPermission) {
                if(userHasPermission) {
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            })
            .catch(function() {
                deferred.reject();
            });

            return deferred.promise;
        };

        permission
        .defineRole('MANAGE_PEOPLE', function() {
            return _resolvePermission({ action: 'MANAGE_PEOPLE', passNoUserThrough: true });
        })
        .defineRole('MANAGE_GROUPS', function() {
            return _resolvePermission({ action: 'MANAGE_GROUPS', passNoUserThrough: true });
        })
        .defineRole('MANAGE_STREAM', function(stateParams) {
            return _resolvePermission({ action: 'MANAGE_STREAM', passNoUserThrough: true, streamId: stateParams.id });
        })
        .defineRole('MANAGE_TENANT', function() {
            return _resolvePermission({ action: 'MANAGE_TENANT', passNoUserThrough: true});
        })
        .defineRole('CREATE_STREAM', function() {
            return _resolvePermission({ action: 'CREATE_STREAM', passNoUserThrough: true});
        })
        .defineRole('MANAGE_CATALOG', function() {
            return _resolvePermission({ action: 'MANAGE_CATALOG', passNoUserThrough: true});
        });
    }]);

'use strict';

angular.module('attensaApp')
.controller('ContinueWarningCtrl', ['$scope', 'streamsCount', function($scope, streamsCount) {
    $scope.streamsCount = streamsCount;
}]);

angular.module('attensaApp').run(['$templateCache', function($templateCache) {$templateCache.put('/templates//CategorySelectionModal.html','<div class="modal-body">\n    <div class="row" style="margin-left:0;margin-right:0;" id="manage-categories-header">\n        <div class="col-md-12 bg-info" style="padding-bottom: 10px;">\n            <h4>\n                All Categories &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n                <a style="font-size:12px;" editable-text="newCategory.title" e-placeholder="Type in new category" onaftersave="saveNewCategory($data)"><i class="fa fa-plus"></i> Add Category</a>\n                <a ng-click="close()" class="fa fa-times pull-right" aria-hidden="true"></a>\n                <div class="pull-right has-feedback">\n                    <input type="text" class="form-control" placeholder="Search..." ng-model="searchText">\n                    <a ng-show="searchText" ng-click="searchText = \'\';" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n                </div>\n            </h4>\n        </div>\n    </div>\n    <div class="row">\n        <alerts watch-for="category-selection-alerts" suppress-duplicates></alerts>\n    </div>\n    <div class="row">\n        <div class="col-md-12" id="category-select-list-container">\n            <div class="row" ng-repeat="category in taxonomy | categoryFilter:searchText" ng-show="category.removable">\n                <div class="col-md-12" ng-class="{\'bg-lightgrey\':category.selected}">\n                    <label class="pull-left pad-left-right overflow-ellipsis" id="category-select-title" title="{{::category.title}}">\n                        <input type="checkbox" ng-model="category.selected" ng-change="toggleSelection(category); $event.stopPropagation();">\n                        {{category.title}}\n                    </label>\n                    <a class="add-sub-category" style="font-size:12px;" editable-text="newCategory.title" e-placeholder="Type in new category" onaftersave="saveNewCategory($data, category)"><i class="fa fa-plus"></i> Add Sub Category</a>\n                </div>\n                <div class="col-md-offset-1 col-md-11" ng-repeat="subcat in category.subcategories | filter:{title: searchText}" ng-class="{\'bg-lightgrey\':subcat.selected}">\n                    <label class="overflow-ellipsis" title="{{::subcat.title}}">\n                        <input type="checkbox" ng-model="subcat.selected" ng-change="toggleSelection(subcat); $event.stopPropagation();">\n                        {{subcat.title}}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button id="category-selection-modal-close-button" class="btn btn-primary pull-right" ng-click="close()">Close</button>\n</div>');
$templateCache.put('/templates//ConfirmModal.html','<modal-header title="{{modalTitle}}" icon-class="glyphicon glyphicon-exclamation-sign" on-close="$dismiss()"></modal-header>\n<div class="modal-body generic-modal-content">\n    <div class="row">\n        <div class="col-md-12" ng-bind-html="message"></div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button ng-if="!hideCancel" type="button" class="btn btn-default" ng-click="$dismiss()">{{cancelLabel || \'Cancel\'}}</button>\n    <button type="button" class="btn btn-primary" ng-click="$close()">{{confirmLabel}}</button>\n</div>\n');
$templateCache.put('/templates//StreamFollowersModal.html','<div class=\'modal-loading-indicator\' ng-show="loading">Loading...</div>\n<div class="modal-body generic-modal-content" ng-show="!loading">\n    <h2>Followers and Subscribers <span ng-show="stream.followersCount">({{showSubscribers ? stream.subscribersCount : stream.followersCount}})</span><a ng-click="$dismiss()" class="fa fa-times muted pull-right modal-close-x follower-modal-close-x" aria-hidden="true"></a></h2>\n    <h4 class="text-muted">{{stream.title}}</h4>\n    <div class="row">\n        <div class="col-md-6">\n            <form role="search">\n                <input type="text" class="form-control" placeholder="Search People" ng-model="searchTerm"\n                       ng-change="searchPeople()" ng-model-options="{debounce: 1000}" maxlength="100">\n                <a ng-click="clearSearch()" ng-show="searchTerm"\n                   class="glyphicon glyphicon-remove-sign form-control-feedback search-clear"></a>\n            </form>\n        </div>\n        <div class="col-md-6" show-with-permission action="MANAGE_STREAM" stream-id="::streamId">\n                <button class="btn btn-default pull-right"\n                        ng-click="emailAllFollowers()"\n                        ng-disabled="!totalFollowers"\n                        title="Email all followers"\n                >\n                    <span class="fa fa-envelope-o"></span>\n                </button>\n                <button class="btn btn-default pull-right margin-left-right"\n                        export-to-csv\n                        format-data="fetchForCSV()"\n                        filename="followers.csv"\n                        ng-disabled="!totalFollowers"\n                        title="Download CSV file of all followers"\n                >\n                    <span class="fa fa-download"></span>\n                </button>\n            </div>\n    </div>\n    <table class="table table-striped scrollable-table followers-view-table">\n        <thead>\n            <tr>\n                <th style="width:33.33%;">\n                    <sort-people-by label="\'First Name\'" sort="sort" sort-key="\'firstNameLower\'" sort-by="sortByUserProperty"></sort-people-by>\n                </th>\n                <th style="width:33.33%;">\n                    <sort-people-by label="\'Last Name\'" sort="sort" sort-key="\'lastNameLower\'" sort-by="sortByUserProperty"></sort-people-by>\n                </th>\n                <th style="width:33.33%;">\n                    <sort-people-by label="\'Email Address\'" sort="sort" sort-key="\'emailAddress\'" sort-by="sortByUserProperty"></sort-people-by>\n                </th>\n            </tr>\n        </thead>\n        <tbody class="on-modal followers-infinite-scroll-container" infinite-scroll="fetchNextPage()" infinite-scroll-distance="1" infinite-scroll-container=\'".followers-infinite-scroll-container"\'>\n            <tr ng-repeat="follower in followers">\n                <td style="width:33.33%;">{{follower.firstName}}</td>\n                <td style="width:33.33%;">{{follower.lastName}}</td>\n                <td style="width:33.33%;">{{follower.emailAddress}}</td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n<div class="modal-footer">\n    <button type="button" class="btn btn-primary" ng-click="$dismiss()">Close</button>\n</div>\n');
$templateCache.put('/templates//TagSelectionModal.html','<div class="modal-body tag-select-modal">\n    <div class="row" style="margin-left:0;margin-right:0;" id="manage-tags-header">\n        <div class="col-md-12 bg-info" style="padding-bottom: 10px;">\n            <h4>Tags</h4>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12">\n            <div class="form-control-static item-tags">\n                <div class="stream-tags-group">\n                    <label for="tag">Add a tag:</label>\n                    <input type="text"\n                           class="form-control add-tag"\n                           id="tag"\n                           uib-typeahead="tag.label for tag in tenantStreamTags | filter: {label:$viewValue}"\n                           typeahead-on-select="selectTag($item, $model, $label)"\n                           placeholder="New Tag"\n                           maxlength="50"\n                           ng-model="newTag"\n                           ui-keyup="{\'enter\':\'addTag(newTag)\'}"\n                           focus-me="startAddingTag">\n                    <div class="tight-right tag-list">\n                        <div class="btn-group btn-group-xs tag-buttons tag-btn-group user-tag-button-group ng-scope" ng-repeat="tag in tags">\n                            <button type="button" class="btn btn-primary tag-button user-tag-button ng-binding" tag-text="{{::tagLabel(tag)}}" data-toggle="tooltip" data-placement="top">\n                                {{::tagLabel(tag)}}\n                            </button>\n                            <button type="button" class="btn btn-primary delete-tag" ng-click="deleteTag(tag)">\n                                <span class="glyphicon glyphicon-remove" style="top: -3px;"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button id="tag-selection-modal-close-button" class="btn btn-primary pull-right" ng-click="$close(tags)">Close</button>\n</div>');
$templateCache.put('/templates//annotations.html','<h4 ng-if="annotation.title">{{annotation.title}}</h4>\n<div class="col-md-12 edit-item-annotation" ng-show="annotation.editing" style="padding: 0; margin-top: 10px;">\n    <div class="bs-example">\n        <div text-angular ta-text-editor-class="edit-annotation-text form-control" ta-keep-styles="true" ta-html-editor-class="edit-annotation-text form-control" ta-toolbar="[[\'p\',\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'underline\'],[\'ul\',\'ol\'],[\'justifyLeft\',\'justifyCenter\',\'justifyRight\'],[\'indent\',\'outdent\'],[\'html\',\'insertImage\',\'insertLink\'], [\'backgroundColor\'], [\'foregroundColor\'],[\'fontPicker\'], [\'fontSizePicker\']]" ng-model="annotation.editedAnnotationText" ng-init="annotation.editedAnnotationText = annotation.annotationText" ng-minlength="1" required></div>\n    </div>\n    <div class="highlight">\n        <div class="clearfix" style="width: 100%;padding-right: 0;">\n            <div class="btn-group btn-group-xs" uib-dropdown>\n                <button type="button" style="margin-left: 3px;" class="btn btn-default dropdown-toggle annotation-location-dropdown" data-toggle="dropdown" uib-dropdown-toggle>\n                    Location: <span class="annotation-location-label">{{annotation.location}}</span> <span class="caret"></span>\n                </button>\n                <ul class="dropdown-menu" role="menu">\n                    <li><a class="annotation-above" ng-click="annotation.location = \'Above\'">Above</a></li>\n                    <li><a class="annotation-below" ng-click="annotation.location = \'Below\'">Below</a></li>\n                </ul>\n            </div>\n            <button type="button" style="margin-left: 3px;" class="edit-save-annotation btn btn-default btn-xs pull-right" ng-click="readingModal.editAnnotation(annotation)" ng-disabled="readingModal.editAnnotationSaveText === \'Saving...\' || editTopAnnotation.$invalid">{{readingModal.editAnnotationSaveText}}</button>\n            <button type="button" style="margin-left: 3px;" class="edit-cancel-annotation btn btn-default btn-xs pull-right" ng-click="annotation.editing = false">Cancel</button>\n        </div>\n    </div>\n</div>\n<div class="annotation well annotation-well" ng-show="!annotation.editing" style="padding: 10px; position: relative;">\n    <div show-with-permission action="MANAGE_ANNOTATIONS" stream-id="readingModal.item.streamId" class="btn-group btn-group-xs" style="position: absolute; top: 0px; right: 0px;">\n        <button type="button" class="btn btn-default edit-annotation" ng-click="annotation.editing = true; readingModal.startEditingAnnotation = true;">Edit</button>\n        <button type="button" class="btn btn-default delete-annotation" ng-click="readingModal.deleteAnnotation(annotation.id)">Delete</button>\n    </div>\n    <blockquote style="padding: 0 15px; margin: 0; border-left: none;">\n        <p class="annotation-text" ng-bind-html="annotation.annotationText"></p>\n        <footer ng-bind="annotation.userFullname"></footer>\n    </blockquote>\n</div>\n');
$templateCache.put('/templates//bareHeader.html','<header class="header" ng-show="$state.current.name !== \'login\'">\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-2">\r\n                <div style="padding-left:10px; padding-top:10px; padding-bottom: 10px;">\r\n                    <a ui-sref="reading"><img style="width:250px;" alt="Attensa" logo/></a>\r\n                </div>\r\n            </div>\r\n            <div class="col-xs-3 col-xs-offset-7">\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</header>\r\n');
$templateCache.put('/templates//briefingHistory.html','<modal-header title="Briefing History" on-close="$dismiss()">\n    <p>Each page represents a briefing even if it failed to send. Use the paging control to view prior briefings.</p>\n</modal-header>\n<div class="modal-body generic-modal-content" ng-repeat="briefingHistory in briefingHistories" ng-init="historyIndex = $index">\n    <briefing-history-item briefing-history="briefingHistory" history-index="historyIndex" user-statuses="userStatuses"></briefing-history-item>\n    <briefing-history-activities history="briefingHistory"></briefing-history-activities>\n</div>\n<div class="modal-footer">\n    <uib-pagination\n                class="pull-left"\n                total-items="historyCount"\n                items-per-page="1"\n                ng-change="fetchHistory()"\n                ng-model="currentPage"\n                max-size="5"\n                boundary-link-numbers="true"\n                previous-text="&lsaquo;"\n                next-text="&rsaquo;">\n    </uib-pagination>\n    <button type="button" class="btn btn-default sub-modal-cancel" ng-click="$close()">Close</button>\n</div>');
$templateCache.put('/templates//briefingPreviewModal.html','<modal-header title="Briefing Preview" on-close="$dismiss()"></modal-header>\n<div class="modal-body generic-modal-content">\n    <iframe width="830" height="500" seamless="seamless" ng-src="{{briefingPreviewUrl}}" frameBorder="0"></iframe>\n</div>\n<div class="modal-footer">\n    <button type="button" class="btn btn-primary" ng-click="$close()">Close</button>\n</div>');
$templateCache.put('/templates//briefingView.html','<div style="position: absolute; top: 70px; bottom: 0px; width: 100%;">\n    <iframe height="100%" width="100%" seamless="seamless" ng-src="{{briefingUrl}}" frameBorder="0"></iframe>\n</div>\n');
$templateCache.put('/templates//changeStreamOwnerModal.html','<modal-header title="Edit stream owner - {{stream.title}}" on-close="$dismiss()"></modal-header>\n<div class="modal-body generic-modal-content">\n    <form role="search">\n        <div class="form-group has-feedback">\n            <input ng-model="search.searchTerm" ng-change="searchPeople()" ng-model-options="{debounce: 1000}" id="people-search-input" type="text" focus-me="streamPeopleSearch" class="form-control" size="40" placeholder="Search people">\n            <a ng-click="clearSearch()" ng-show="search.searchTerm" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n        </div>\n    </form>\n    <table class="table table-striped scrollable-table">\n        <thead>\n            <tr>\n                <th style="width:10%;">Ownership</th>\n                <th style="width:30%;">\n                    <sort-people-by label="\'First Name\'" sort="sort" sort-key="\'firstNameLower\'" sort-by="sortByUserProperty"></sort-people-by>\n                </th>\n                <th style="width:30%;">\n                    <sort-people-by label="\'Last Name\'" sort="sort" sort-key="\'lastNameLower\'" sort-by="sortByUserProperty"></sort-people-by>\n                </th>\n                <th style="width:30%;">\n                    <sort-people-by label="\'Email Address\'" sort="sort" sort-key="\'emailAddress\'" sort-by="sortByUserProperty"></sort-people-by>\n                </th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr ng-repeat="user in users">\n                <td style="width:10%;" class="text-center select-cell"><input type="radio" ng-value="true" ng-model="user.selectedOwner" ng-change="changeStreamOwner(user, $index)"></td>\n                <td class="overflow-ellipsis" style="width:30%;">{{user.firstName}}</td>\n                <td class="overflow-ellipsis" style="width:30%;">{{user.lastName}}</td>\n                <td class="overflow-ellipsis" style="width:30%;">{{user.emailAddress}}</td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n<div class="modal-footer">\n    <uib-pagination class="pull-left"\n                    total-items="totalElements"\n                    ng-model="pagerPage"\n                    items-per-page="rows"\n                    ng-change="fetchPage()"\n                    max-size="5"\n                    boundary-link-numbers="true"\n                    previous-text="&lsaquo;"\n                    next-text="&rsaquo;"></uib-pagination>\n    <button class="btn btn-default" ng-click="$dismiss()">Close</button>\n    <button type="button" class="btn btn-primary" ng-click="$close(userSelected)" ng-disabled="!userSelected">Change</button>\n</div>\n');
$templateCache.put('/templates//contentStreamsSidebar.html','<div id="stream-builder-add-content-sidebar" class="row taxonomy-sidebar" style="height:660px;">\n    <span ng-controller="ContentSidebarCtrl">\n    <uib-accordion close-others="true">\n        <uib-accordion-group is-open="taxonomyOpenMap[\'tenant\']" is-disabled="taxonomyOpenMap[\'tenant\']">\n            <uib-accordion-heading>\n                <div class="row" ng-class="{\'active\': (!selectedCategoryId && catalogId === \'tenant\'), \'before-active\':category.id === selectedCategoryId}" ng-click="selectCategory()">\n                    <div class="col-xs-9">\n                        <a><h4 class="text-primary"> {{catalogNavigationLabel}}</h4></a>\n                    </div>\n                </div>\n            </uib-accordion-heading>\n            <ul class="streams-sidebar-section" ng-style="{ \'height\': 557 - (45 * catalogCount) }">\n                <li ng-repeat="category in taxonomy"\n                    ng-class="{\'active\': category.id === selectedCategoryId, \'last\':$last, \'before-active\':isBeforeSelected($index)}"\n                    class="category-row cursor-pointer"\n                    scrollup\n                    ng-hide="catalogId !== \'tenant\' || !catalogOpen">\n\n                    <div class="row category-detail-row"\n                         click-event\n                         eventname="category_selected"\n                         eventargs=\'{"category": "{{category.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-1" style="margin-top: 9px;">\n                            <a ng-show="category.subcategories.length" ng-click="category.expanded = !category.expanded" class="category-toggle"><span class="glyphicon" ng-class="{ \'glyphicon-triangle-right\': !category.expanded, \'glyphicon-triangle-bottom\': category.expanded}"></span></a>\n                        </div>\n                        <div class="col-md-10" ng-click="selectCategory(category)">\n                            <h5 class="overflow-ellipsis text-primary" title="{{::category.title}}">{{::category.title}}</h5>\n                        </div>\n                    </div>\n                    <div ng-show="category.expanded" class="subcategory row" ng-repeat="subcategory in category.subcategories"\n                         ng-class="{\'active\': subcategory.id === selectedCategoryId }"\n                         click-event\n                         eventname="category_selected"\n                         eventargs=\'{"category": "{{subcategory.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-offset-2 col-md-10" ng-click="selectCategory(subcategory)">\n                            <h5>{{subcategory.title}}</h5>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </uib-accordion-group>\n        <uib-accordion-group ng-repeat="catalog in tenantCatalogMap" is-open="taxonomyOpenMap[catalog.catalogId]" is-disabled="taxonomyOpenMap[catalog.catalogId]">\n            <uib-accordion-heading>\n                <div class="row" ng-class="{\'active\': !selectedCategoryId && catalog.catalogId === catalogId, \'before-active\':category.id === selectedCategoryId}" ng-click="selectCatalog(catalog)">\n                    <div class="col-xs-12">\n                        <a><h4 class="text-primary"> {{catalog.label}}</h4></a>\n                    </div>\n                </div>\n            </uib-accordion-heading>\n            <ul class="streams-sidebar-section" ng-style="{ \'height\': 557 - (45 * catalogCount) }">\n                <li ng-repeat="category in catalogTaxonomy[catalog.catalogId]"\n                    ng-show="catalogId === catalog.catalogId && catalogOpen"\n                    ng-class="{\'active\': category.id === selectedCategoryId, \'last\':$last, \'before-active\':isBeforeSelected($index)}"\n                    class="category-row cursor-pointer"\n                    scrollup\n                    click-event\n                    eventname="category_selected"\n                    eventargs=\'{"category": "{{category.title}}", "admin_view": {{adminView}}}\'>\n                    <div class="row category-detail-row"\n                         click-event\n                         eventname="category_selected"\n                         eventargs=\'{"category": "{{category.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-1" style="margin-top: 9px;">\n                            <a ng-show="category.subcategories.length" ng-click="category.expanded = !category.expanded" class="category-toggle"><span class="glyphicon" ng-class="{ \'glyphicon-triangle-right\': !category.expanded, \'glyphicon-triangle-bottom\': category.expanded}"></span></a>\n                        </div>\n                        <div class="col-md-10" ng-click="selectCategory(category)">\n                            <h5 class="overflow-ellipsis text-primary" title="{{::category.title}}">{{::category.title}}</h5>\n                        </div>\n                    </div>\n                    <div ng-show="category.expanded" class="subcategory row" ng-repeat="subcategory in category.subcategories"\n                         ng-class="{\'active\': subcategory.id === selectedCategoryId }"\n                         click-event\n                         eventname="category_selected"\n                         eventargs=\'{"category": "{{subcategory.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-offset-2 col-md-10" ng-click="selectCategory(subcategory)">\n                            <h5>{{subcategory.title}}</h5>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </uib-accordion-group>\n    </uib-accordion>\n    </span>\n</div>\n');
$templateCache.put('/templates//copyToStreamModal.html','<div class="modal-content" ng-init="initialize()">\n    <modal-header title="{{::doCurate ? \'Edit item and share to topic\' : \'Share to topic\'}}" on-close="$dismiss()"></modal-header>\n    <div class="modal-body">\n        <form name="form" role="form" enctype="multipart/form-data">\n            <div class="form-group has-feedback">\n                <ui-select multiple ng-model="selectedStreams" theme="bootstrap" ng-disabled="disabled" style="min-width: 300px;" on-select="selectStream($item)" on-remove="removeStream($item)">\n                    <ui-select-match placeholder="Choose a topic">{{$item.title}}</ui-select-match>\n                    <ui-select-choices repeat="stream in streams | filter: $select.search" refresh="checkStream($select.search)" refresh-delay="0">\n                        <div class="overflow-ellipsis" title="{{::stream.title}}" ng-bind-html="stream.title | highlight: $select.search"></div>\n                    </ui-select-choices>\n                </ui-select>\n                <small class="help-block" ng-if="streamWarningText">No eligible topics found</small>\n            </div>\n        </form>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default sub-modal-cancel" ng-click="$dismiss()">Cancel</button>\n        <button type="button" class="btn btn-default sub-modal-submit" ng-click="copyToStream(selectedStreams, doCurate)" ng-disabled="(!selectedStreams || selectedStreams < 1) || streamWarningText">Share</button>\n    </div>\n</div>\n');
$templateCache.put('/templates//copyToStreamTypeahead.html','<a>\n    <img ng-if="match.model.thumbnailImage" ng-src="{{match.model.thumbnailImage.uri}}" width="16">\n    <span bind-html-unsafe="match.label | typeaheadHighlight:query"></span>\n</a>\n');
$templateCache.put('/templates//createContentSection.html','<div class="container">\r\n    <h2>Create Stream</h2>\r\n    <div class="clearfix">\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'RSS\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ng-click="createStream(\'RSS\')"><span class="fa fa-rss"></span></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ng-click="createStream(\'RSS\')">RSS Feed</a>\r\n                    </h4>\r\n                    <a ng-click="createStream(\'RSS\')" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'ATTENSA_SEARCH\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ng-click="createStream(\'ATTENSA_SEARCH\')"><span class="fa fa-search"></span></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ng-click="createStream(\'ATTENSA_SEARCH\')">Search Attensa</a>\r\n                    </h4>\r\n                    <a ng-click="createStream(\'ATTENSA_SEARCH\')" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'RSS\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ui-sref="opml({catalog: catalog, category: categoryId})"><span class="icon icon-opml"></span></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ui-sref="opml({catalog: catalog, category: categoryId})">Import OPML File</a>\r\n                    </h4>\r\n                    <a ui-sref="opml({catalog: catalog, category: categoryId})" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'TWITTER_SEARCH\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ng-click="createStream(\'TWITTER_SEARCH\')"><span class="fa fa-twitter"></span></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ng-click="createStream(\'TWITTER_SEARCH\')">Twitter Search</a>\r\n                    </h4>\r\n                    <a ng-click="createStream(\'TWITTER_SEARCH\')" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'BING_SEARCH\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ng-click="createStream(\'BING_SEARCH\')"><span class="fa fa-windows"></span></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ng-click="createStream(\'BING_SEARCH\')">Bing Search</a>\r\n                    </h4>\r\n                    <a ng-click="createStream(\'BING_SEARCH\')" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'PUBMED_SEARCH\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ng-click="createStream(\'PUBMED_SEARCH\')"><img src="/images/pubmed.gif"></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ng-click="createStream(\'PUBMED_SEARCH\')">PubMed Search</a>\r\n                    </h4>\r\n                    <a ng-click="createStream(\'PUBMED_SEARCH\')" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'CLINICALTRIALS_SEARCH\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ng-click="createStream(\'CLINICALTRIALS_SEARCH\')"><span class="fa fa-user-md"></span></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ng-click="createStream(\'CLINICALTRIALS_SEARCH\')">ClinicalTrials.gov Search</a>\r\n                    </h4>\r\n                    <a ng-click="createStream(\'CLINICALTRIALS_SEARCH\')" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="create-stream-tile clearfix" ng-if="sourceAllowed(\'FACTIVA_SELECT_HTTP\')">\r\n            <div class="media">\r\n                <div class="media-left">\r\n                    <div class="icon-tile">\r\n                        <a ng-click="createStream(\'FACTIVA_SELECT_HTTP\')"><img src="/images/factiva.png"></a>\r\n                    </div>\r\n                </div>\r\n                <div class="media-body">\r\n                    <h4 class="media-heading">\r\n                        <a ng-click="createStream(\'FACTIVA_SELECT_HTTP\')">Factiva Select</a>\r\n                    </h4>\r\n                    <a ng-click="createStream(\'FACTIVA_SELECT_HTTP\')" class="btn btn-default">Start</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <br/>\r\n    </div>\r\n</div>');
$templateCache.put('/templates//deleteBriefingWarningModal.html','<modal-header title="Deleting briefing" icon-class="glyphicon glyphicon-exclamation-sign" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <p>Warning! This will <b>permanently</b> remove this briefing from the system.\n    </p>\n    <p>By clicking the Delete button below, you are confirming that you are removing this briefing and that it cannot be restored.</p>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n    <button class="btn btn-primary" ng-click="$close()">Delete</button>\n</div>\n');
$templateCache.put('/templates//deleteStreamWarningModal.html','<modal-header title="Stream delete" icon-class="glyphicon glyphicon-exclamation-sign" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <p>Warning! This will <b>permanently</b> remove\n        <ng-pluralize count="streamsCount" when="{\'one\': \'this\', \'other\': \'these\'}"></ng-pluralize>\n        <ng-pluralize count="streamsCount" when="{\'one\': \'stream\', \'other\': \'streams\'}"></ng-pluralize>\n        from the system.\n    </p>\n    <p>By clicking the Delete button below, you are confirming that you are removing\n        <ng-pluralize count="streamsCount" when="{\'one\': \'this\', \'other\': \'these\'}"></ng-pluralize>\n        <ng-pluralize count="streamsCount" when="{\'one\': \'stream\', \'other\': \'streams\'}"></ng-pluralize>\n        and that\n        <ng-pluralize count="streamsCount" when="{\'one\': \'it\', \'other\': \'they\'}"></ng-pluralize>\n        cannot be restored.\n    </p>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n    <button class="btn btn-primary" ng-click="$close(true)">Delete</button>\n</div>\n');
$templateCache.put('/templates//deleteTopicWarningModal.html','<modal-header title="Deleting topic" icon-class="glyphicon glyphicon-exclamation-sign" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <p>Warning! This will <b>permanently</b> remove this topic from the system.\n    </p>\n    <p>By clicking the Delete button below, you are confirming that you are removing this topic and that it cannot be restored.</p>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n    <button class="btn btn-primary" ng-click="$close()">Delete</button>\n</div>\n');
$templateCache.put('/templates//digestPreviewModal.html','<modal-header title="Personal Digest preview" on-close="$dismiss()"></modal-header>\n<div class="modal-body generic-modal-content">\n    <iframe width="830" height="500" seamless="seamless" ng-src="{{digestPreviewUrl}}" frameBorder="0"></iframe>\n</div>\n<div class="modal-footer">\n    <button type="button" class="btn btn-primary" ng-click="$close()">Close</button>\n</div>\n');
$templateCache.put('/templates//editUserModal.html','<modal-header title="{{user.firstName}} {{user.lastName}}" on-close="$dismiss()"></modal-header>\n<form id="userForm" name="form" role="form" enctype="multipart/form-data">\n    <div class="modal-body pad-top-none">\n        <div class="editor user-modal">\n            <div class="row">\n                <ul class="section-subnav">\n                    <li ng-class="{active: config.target === \'profile\', disabled: config.target !== \'profile\'}"><a id="user-profile-link" ng-click="config.target = \'profile\'">Profile</a></li>\n                    <li ng-class="{active: config.target === \'streams\', disabled: config.target !== \'streams\'}" ng-hide="noFollowing"><a id="user-streams-link" ng-click="config.target = \'streams\'">Followed streams ({{!streamCount ? \'0\' : streamCount.val}})</a></li>\n                    <li ng-class="{active: config.target === \'ownedStreams\', disabled: config.target !== \'ownedStreams\'}"><a id="user-owned-streams-link" ng-click="config.target = \'ownedStreams\'">Owned streams ({{!ownedStreamCount ? \'0\' : ownedStreamCount.val}})</a></li>\n                    <li ng-class="{active: config.target === \'briefings\', disabled: config.target !== \'briefings\'}" ng-hide="noFollowing"><a id="user-briefings-link" ng-click="config.target = \'briefings\'">Briefings ({{!briefingCount ? \'0\' : briefingCount.val}})</a></li>\n                    <li ng-class="{active: config.target === \'digest\', disabled: config.target !== \'digest\'}"><a id="user-digest-link" ng-click="config.target = \'digest\'">Digest</a></li>\n                    <li ng-class="{active: config.target === \'groups\', disabled: config.target !== \'groups\'}"><a id="user-groups-link" ng-click="config.target = \'groups\'">Groups ({{!groupCount ? \'0\' : groupCount.val}})</a></li>\n                </ul>\n            </div>\n            <div class="row">\n                <div class="col-md-12" ng-style="config.target === \'profile\' && {\'padding-top\': \'20px\'}">\n                    <div class="user-panel">\n                        <div class="tab-content">\n                            <span ng-if="config.target === \'profile\'">\n                                <ng-include src="\'/templates/userForm.html\'"></ng-include>\n                            </span>\n                            <span ng-if="config.target === \'streams\'">\n                                <ng-include src="\'/templates/userStreamsTable.html\'"></ng-include>\n                            </span>\n                            <span ng-if="config.target === \'ownedStreams\'">\n                                <ng-include src="\'/templates/userOwnedStreamsTable.html\'"></ng-include>\n                            </span>\n                            <span ng-if="config.target === \'briefings\'">\n                                <ng-include src="\'/templates/userBriefingsTable.html\'"></ng-include>\n                            </span>\n                            <span ng-if="config.target === \'digest\'">\n                                <digest-editor user="user" external-save="true" save-at="saveAt" saving="savingDigest" digest-saved="digestSaved()"></digest-editor>\n                            </span>\n                            <span ng-if="config.target === \'groups\'">\n                                <ng-include src="\'/templates/userGroupsTable.html\'"></ng-include>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" ng-click="$dismiss()">Close</button>\n        <button class="btn btn-primary" ng-if="config.target === \'digest\'" ng-disabled="savingDigest" ng-click="saveDigest()">Save</button>\n        <button class="btn btn-primary" ng-if="config.target === \'profile\'" ng-disabled="form.$invalid || saving" ng-click="save()">Save</button>\n    </div>\n</form>\n');
$templateCache.put('/templates//emailPicker.html','<modal-header title="Select email addresses" on-close="$dismiss({cancelled: true})"></modal-header>\r\n<div class="modal-body">\r\n        <form id="addEmailForm" name="addEmailForm" role="form"ng-if="!emailPicker.tenantDomain">\r\n        <div class="row" style="padding-bottom:10px;">\r\n            <div class="col-md-8 col-md-offset-1">\r\n                <div class="has-feedback">\r\n                    <div ng-if="addEmailForm.email.$error.required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\r\n                </div>\r\n                <input autofocus type="email" name="email" placeholder="Email Address" class="form-control" style="width: 100%; padding-right: 40px;" ng-model="emailPicker.emailAddress">\r\n                <div ng-if="addEmailForm.email.$dirty">\r\n                    <div class="has-error" ng-messages="addEmailForm.email.$error">\r\n                        <small class="help-block" ng-message="email">Please enter a correct email address</small>\r\n                        <small class="help-block" ng-message="restrictToDomain">Email address must be within the domain {{emailPicker.tenantDomain}}</small>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class="col-md-2">\r\n                    <button class="btn btn-primary" ng-disabled="addEmailForm.$invalid || !emailPicker.emailAddress.length" ng-click="emailPicker.addAddress(emailPicker.emailAddress); addEmailForm.$setPristine()">Add Address</button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n\r\n\r\n    <form id="addEmailPrefixForm" name="addEmailPrefixForm" role="form" ng-if="emailPicker.tenantDomain">\r\n        <div class="row" style="padding-bottom:10px;">\r\n            <div class="col-md-8 col-md-offset-1">\r\n                <div class="form-group">\r\n                    <div class="input-group">\r\n                        <input type="text" class="form-control" name="emailPrefix" placeholder="Email prefix" ng-model="emailPicker.emailPrefix" required valid-email-prefix no-spaces>\r\n                        <span id="streamEmailDomain" class="input-group-addon">@{{emailPicker.tenantDomain}}</span>\r\n                    </div>\r\n                    <div ng-if="addEmailPrefixForm.emailPrefix.$dirty">\r\n                        <div class="has-error" ng-messages="addEmailPrefixForm.emailPrefix.$error">\r\n                            <small class="help-block" ng-message="required">Please enter an email prefix</small>\r\n                            <small class="help-block" ng-message="validEmailPrefix">Email prefix cannot contain an @</small>\r\n                            <small class="help-block" ng-message="noSpaces">Email prefix cannot contain spaces</small>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class="col-md-2">\r\n                <button class="btn btn-primary" ng-disabled="addEmailPrefixForm.$invalid || !emailPicker.emailPrefix.length" ng-click="emailPicker.addAddressFromPrefix(emailPicker.emailPrefix, emailPicker.tenantDomain); addEmailPrefixForm.$setPristine();">Add Address</button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n\r\n    <div class="row" ng-repeat="emailAddress in emailPicker.emailAddresses" style="padding-top: 8px; padding-bottom: 8px;">\r\n        <div class="col-md-7 col-md-offset-1">\r\n            {{emailAddress}}\r\n        </div>\r\n        <div class="col-md-1">\r\n            <a ng-click="emailPicker.removeEmail(emailAddress)" aria-hidden="true"><i class="glyphicon glyphicon-remove-sign"></i></a>\r\n        </div>\r\n    </div>\r\n\r\n    <div class="modal-footer">\r\n        <button class="btn btn-primary" ng-disabled="!emailPicker.emailAddresses.length" ng-click="$close(emailPicker.emailAddresses)">Send Invitations</button>\r\n        <a type="button" ng-click="$dismiss({cancelled: true})">Cancel</a>\r\n    </div>\r\n</div>');
$templateCache.put('/templates//eventDetailModal.html','<modal-header title="{{::eventDisplayNameMap[collectionName]}} for {{::streamTitle}}" on-close="close()"></modal-header>\n<div class="modal-body">\n    <div ng-show="fetching"><h4><span class="fa fa-spinner fa-spin"></span> Crunching data.  This may take a little while.</h4></div>\n    <table ng-show="!fetching" ng-table="tableParams" show-filter="true" class="table table-bordered table-condensed" style=\'table-layout:fixed\'>\n        <tr ng-repeat="event in $data">\n            <td data-title="\'Timestamp\'" sortable="\'time\'">\n                {{::event.time}}\n            </td>\n            <td data-title="\'Name\'" sortable="\'name\'" filter="{ \'name\': \'text\' }">\n                <span class="overflow-ellipsis">{{::event.name}}</span>\n            </td>\n            <td data-title="\'Article\'" sortable="\'title\'" filter="{ \'title\': \'text\' }">\n                <span class="overflow-ellipsis">{{::event.title}}</span>\n            </td>\n        </tr>\n    </table>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-default" export-to-csv format-data="eventsFormatter(events)"  filename="events.csv" ng-disabled="events.length === 0">Export to CSV</button>\n    <button class="btn btn-primary" ng-click="close()">Close</button>\n</div>\n');
$templateCache.put('/templates//filterHelpPopover.html','<div class="popover filter-help-popover">\n  <div class="arrow"></div>\n  <h3 class="popover-title">Help</h3>\n  <div class="popover-content">\n    <uib-accordion>\n        <uib-accordion-group>\n            <uib-accordion-heading>\n                <i class="fa fa-info-circle"><b> OR</b></i>\n            </uib-accordion-heading>\n            <p>The <i>OR</i> operator is the default conjunction operator contains either "Portland Oregon" or just "Portland"</p>\n            <p>"Portland Oregon" Portland</p>\n            <p>"Portland Oregon" <i>OR</i> Portland</p>\n        </uib-accordion-group>\n        <uib-accordion-group>\n            <uib-accordion-heading>\n                <i class="fa fa-info-circle"><b> AND</b></i>\n            </uib-accordion-heading>\n            <p>The <i>AND</i> operator contains "Portland Oregon" and "Oregon Pearl"</p>\n            <p>"Portland Oregon" <i>AND</i> "Oregon Pearl"</p>\n        </uib-accordion-group>\n        <uib-accordion-group>\n            <uib-accordion-heading>\n                <i class="fa fa-info-circle"><b> NOT</b></i>\n            </uib-accordion-heading>\n            <p>The <i>NOT</i> operator contains the phrase "Portland Oregon" but does not contain the phrase "Oregon Pearl"</p>\n            <p>"Portland Oregon" <i>NOT</i> "Oregon Pearl"</p>\n        </uib-accordion-group>\n        <uib-accordion-group>\n            <uib-accordion-heading>\n                <i class="fa fa-info-circle"><b> *</b></i>\n            </uib-accordion-heading>\n            <p>matches zero or more sequential characters</p>\n            <p>tes\\* - would match test, testing and tester</p>\n            <p>\\*est\\* - would match pest, test, testing and tester</p>\n        </uib-accordion-group>\n        <uib-accordion-group>\n            <uib-accordion-heading>\n                <i class="fa fa-info-circle"><b> ?</b></i>\n            </uib-accordion-heading>\n            <p>matches a single character</p>\n            <p>te?t \u2013 would match test, text and tent</p>\n        </uib-accordion-group>\n        <uib-accordion-group>\n            <uib-accordion-heading>\n                <i class="fa fa-info-circle"><b> Grouping searches:</b></i>\n            </uib-accordion-heading>\n            <p>Searches for either "Portland" or "Oregon" and "website" (Portland OR Oregon) <i>AND</i> website requiring that the term "website" exist, along with either term "Portland" and "Oregon."</p>\n        </uib-accordion-group>\n    </uib-accordion>\n    </div>\n</div>\n');
$templateCache.put('/templates//forgotPassword.html','<div class="container login-container" ng-controller="LoginCtrl as login">\n    <div class="row">\n        <div class="col-md-6 col-md-offset-3">\n            <div class="well">\n                <div style="margin-top:10px;text-align:center;" class="header-logo-inline">\n                    <a style="max-height: 100px;" ui-sref="login"><img style="max-height: 100px;" alt="Attensa" logo/></a>\n                </div>\n                <div>\n                    <form class="form-signin" name="form" role="form">\n                        <div class="position-relative">\n                            <input id="email-input" value="" ng-model="login.email.email" name="email" type="email" class="form-control" placeholder="Email address" required autofocus>\n                            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>\n                        </div>\n\n                        <div class="login-center-text-block">\n                            <span class="login-button-sizer"><button class="btn btn-primary btn-default btn-block" style="margin-top: 5px;" type="submit" ng-click="login.forgotPassword()">Reset Password</button></span>\n                        </div>\n\n                        <div>\n                            <a ui-sref="login">Return to login page</a>\n                        </div>\n                    </form>\n                </div>\n            </div>\n            <span growl reference="forgotPassword" inline="true"></span>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//groupModal.html','<modal-header title="{{group.name || \'New group\'}}" on-close="done()"></modal-header>\n<div class="modal-body generic-modal-content pad-top-none" ng-hide="addMembersView">\n    <div class="editor group-modal">\n        <div class="row">\n            <ul class="section-subnav">\n                <li ng-class="{active: config.target === \'basics\', disabled: config.target !== \'basics\'}"><a id="group-basics-link" ng-click="config.target = \'basics\'">Basics</a></li>\n                <li ng-if="group.id" ng-class="{active: config.target === \'members\', disabled: config.target !== \'members\'}"><a id="group-members-link" ng-click="config.target = \'members\'">Members ({{!group.members.length ? \'0\' : group.members.length}})</a></li>\n                <li ng-if="group.id" ng-class="{active: config.target === \'streams\', disabled: config.target !== \'streams\'}"><a id="group-streams-link" ng-click="config.target = \'streams\'">Streams ({{!streamCount ? \'0\' : streamCount.val}})</a></li>\n                <li ng-if="group.id" ng-class="{active: config.target === \'briefings\', disabled: config.target !== \'briefings\'}"><a id="group-briefings-link" ng-click="config.target = \'briefings\'">Briefings ({{!briefingCount ? \'0\' : briefingCount.val}})</a></li>\n            </ul>\n        </div>\n        <div class="row">\n            <div class="col-md-12">\n                <div class="group-panel">\n                    <div class="tab-content">\n                        <span ng-if="config.target === \'basics\'">\n                            <ng-include src="\'/templates/groups/basics.html\'"></ng-include>\n                        </span>\n                        <span ng-if="config.target === \'members\'">\n                            <ng-include src="\'/templates/groups/members.html\'"></ng-include>\n                        </span>\n                        <span ng-if="config.target === \'streams\'">\n                            <ng-include src="\'/templates/groups/streams.html\'"></ng-include>\n                        </span>\n                        <span ng-if="config.target === \'briefings\'">\n                            <ng-include src="\'/templates/groups/briefings.html\'"></ng-include>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div ng-if="addMembersView" class="modal-body generic-modal-content">\n    <div class="row">\n        <div class="col-md-12 table-section-content">\n            <nav class="navbar navbar-default" role="navigation">\n                <div class="container-fluid">\n                    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">\n                        <form class="navbar-form navbar-left" role="search">\n                            <div class="form-group has-feedback input-group">\n                                <input id="admin-table-search-input" type="text" class="form-control admin-table-search" placeholder="Search People" ng-model="search.searchTerm" ng-change="searchUser()" ng-model-options="{debounce: 1000}" clear-input>\n                                <a ng-click="clearSearch()" ng-show="search.searchTerm" class="glyphicon glyphicon-remove-sign form-control-feedback members-clear search-clear" aria-hidden="true"></a>\n                            </div>\n                        </form>\n                        <ul class="nav navbar-nav navbar-right">\n                            <li role="presentation" class="members-count">\n                                <label>{{(!group.members.length || group.members.length < 2) ? (group.members.length === 1 ? \'1 Member\' : \'0 Members\') : (group.members.length + \' Members\')}}</label>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </nav>\n            <div class="add-members-view-table">\n                <table class="table scrollable-table" id="people-table">\n                    <thead>\n                        <tr>\n                            <th style="width:18%;">\n                                <sort-people-by label="\'First Name\'" sort="sort" sort-key="\'firstName\'" sort-by="sortByOthers"></sort-people-by>\n                            </th>\n                            <th style="width:18%;">\n                                <sort-people-by label="\'Last Name\'" sort="sort" sort-key="\'lastName\'" sort-by="sortByOthers"></sort-people-by>\n                            </th>\n                            <th style="width:40%;">\n                                <sort-people-by label="\'Email Address\'" sort="sort" sort-key="\'emailAddress\'" sort-by="sortByOthers"></sort-people-by>\n                            </th>\n                            <th style="width:12%;">\n                                <sort-people-by label="\'Status\'" sort="sort" sort-key="\'status\'" sort-by="sortByOthers"></sort-people-by>\n                            </th>\n                            <th style="width:12%;">\n                                <span class="normal-font-weight">Member</span>\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody style="height: auto;" class="on-modal people-table-infinite-scroll-container" infinite-scroll="nextPage()" infinite-scroll-distance="1" infinite-scroll-disabled="lastPage" infinite-scroll-container=\'".add-members-view-table"\'>\n                        <tr ng-repeat="user in allUsers" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                            <td style="width:18%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.firstName}}">{{::user.firstName}}</td>\n                            <td style="width:18%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.lastName}}">{{::user.lastName}}</td>\n                            <td style="width:40%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.emailAddress}}">{{::user.emailAddress}}</td>\n                            <td style="width:12%;" class="white-space-nowrap">{{::user.status}}</td>\n                            <td style="width:12%;" class="white-space-nowrap">\n                                <button ng-disabled="disabledButton.user === user && disabledButton.group === group" \n                                        type="button" class="btn add-item-button add-member-button" \n                                        ng-class="{\'btn-default\': userInGroup(user.id, group.members), \'btn-primary\': !userInGroup(user.id, group.members)}" \n                                        ng-click="userInGroup(user.id, group.members) ? removeUserSubscription(user, group) : addUserSubscription(user, group)">\n                                            <span ng-show="disabledButton.user !== user && disabledButton.group !== group">{{userInGroup(user.id, group.members) ? \'Remove\' : \'Add\'}}</span>\n                                            <span ng-show="disabledButton.user === user && disabledButton.group === group">\n                                                <div class="center-block la-ball-pulse"><div></div><div></div><div></div></div>\n                                            </span>\n                                </button>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n<div ng-if="config.target === \'basics\'" class="modal-footer">\n    <button class="btn btn-default" ng-click="cancel()">Cancel</button>\n    <button class="btn btn-default btn-primary" ng-disabled="form.$invalid" ng-click="save(group)">Save</button>\n</div>\n<div ng-if="config.target !== \'basics\' && !addMembersView" class="modal-footer">\n    <button class="btn btn-default btn-primary" ng-click="saveAndClose(group)">Done</button>\n</div>\n<div ng-if="addMembersView" class="modal-footer">\n    <button class="btn btn-default btn-primary" ng-click="hideMembersView()">Done</button>\n</div>');
$templateCache.put('/templates//header.html','<header class="header" ng-show="$state.current.name !== \'login\'" ng-controller="HeaderCtrl as header">\r\n    <div class="container-fluid">\r\n        <div class="flex row header">\r\n            <div>\r\n                <div class="navbar navbar-brand navbar-brand-tight">\r\n                    <a ng-hide="header.noNav" click-event eventname="articles_nav_selected" ng-href="{{header.generateUrl({state: \'reading\'})}}" ng-click="header.goToState($event, {state: \'reading\', clearEvent: \'reading-clear\'})"><img class="header-image" alt="Attensa" logo/></a>\r\n                    <img ng-show="header.noNav" class="header-image" alt="Attensa" logo/>\r\n                </div>\r\n            </div>\r\n            <div class="flex-item-center hidden-xs hidden-sm" id="wide-state-selector" ng-hide="header.noNav">\r\n                <div>\r\n                    <ul class="nav nav-pills">\r\n                        <li ng-repeat="navConfig in header.navConfiguration" class="top-menu" ng-class="{ \'nav-selected\' : header.isState(navConfig.state) }">\r\n                            <a ng-if="!navConfig.restrictToRole && !navConfig.popout" ng-href="{{header.generateUrl(navConfig)}}" click-event eventname="{{navConfig.eventName}}" ng-click="header.goToState($event, navConfig)"><strong>{{navConfig.label}}</strong></a>\r\n                            <a ng-if="!navConfig.restrictToRole && navConfig.popout" target="_blank" ng-href="{{header.generateUrl(navConfig)}}" click-event eventname="{{navConfig.eventName}}" ><strong>{{navConfig.label}}</strong></a>\r\n                            <a ng-if="navConfig.restrictToRole && !navConfig.popout" show-with-permission ng-href="{{header.generateUrl(navConfig)}}"  action="{{navConfig.restrictToRole}}" click-event eventname="{{navConfig.eventName}}" ng-click="header.goToState($event, navConfig)"><strong>{{navConfig.label}}</strong></a>\r\n                            <a ng-if="navConfig.restrictToRole && navConfig.popout" target="_blank" show-with-permission ng-href="{{header.generateUrl(navConfig)}}"  action="{{navConfig.restrictToRole}}" click-event eventname="{{navConfig.eventName}}"><strong>{{navConfig.label}}</strong></a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n\r\n            </div>\r\n            <div ng-hide="header.noNav">\r\n                <ul class="nav user-menu pull-left">\r\n                    <li class="dropdown" uib-dropdown show-with-permission action="MANAGE_TENANT">\r\n                        <a class="dropdown-toggle profile-menu-link" data-toggle="dropdown" uib-dropdown-toggle>{{::user.firstName}} {{::user.lastName}} <b class="caret"></b></a>\r\n                        <ul class="dropdown-menu">\r\n                            <li role="presentation" class="dropdown-header"><i class="glyphicon glyphicon-cog nav-menu-icon"></i> Settings</li>\r\n                            <li click-event eventname="manage_account_selected" show-with-permission action="MANAGE_TENANT"><a ui-sref="manageAccount"><i class="glyphicon glyphicon-none nav-menu-icon"></i>Account</a></li>\r\n                            <li click-event eventname="tenant_analytics_selected" show-with-permission action="MANAGE_TENANT"><a ui-sref="tenantAnalytics"><i class="glyphicon glyphicon-none nav-menu-icon"></i>Analytics</a></li>\r\n                            <li click-event eventname="manage_categories_selected" show-with-permission action="MANAGE_TENANT"><a ui-sref="manageCategories"><i class="glyphicon glyphicon-none nav-menu-icon"></i>Categories</a></li>\r\n                            <li click-event eventname="manage_people_selected" show-with-permission action="MANAGE_PEOPLE"><a ui-sref="managePeople"><i class="glyphicon glyphicon-none nav-menu-icon"></i>People</a></li>\r\n                            <li click-event eventname="manage_tags_selected" show-with-permission action="MANAGE_TENANT"><a ng-click="header.openManageStreamTagsModal()"><i class="glyphicon glyphicon-none nav-menu-icon"></i>Tags</a></li>\r\n                            <li click-event eventname="manage_templates_selected" show-with-permission action="MANAGE_TENANT"><a ui-sref="manageTemplates"><i class="glyphicon glyphicon-none nav-menu-icon"></i>Templates</a></li>\r\n                            <li class="divider" show-with-permission action="MANAGE_CATALOG"></li>\r\n                            <li role="presentation" class="dropdown-header" show-with-permission action="MANAGE_CATALOG"><i class="glyphicon glyphicon-cog nav-menu-icon"></i> Catalogs</li>\r\n                            <li ng-repeat="catalog in header.catalogs"\r\n                                show-with-permission action="MANAGE_CATALOG">\r\n                                    <a ui-sref="manageCatalog({ catalogId: catalog.catalogId })"><i class="glyphicon glyphicon-none nav-menu-icon"></i>{{::catalog.label}}</a>\r\n                            </li>\r\n                            <li class="divider"></li>\r\n                            <li role="presentation" class="dropdown-header"><i class="glyphicon glyphicon-user nav-menu-icon"></i>{{::user.firstName}} {{::user.lastName}}</li>\r\n                            <li><a click-event eventname="edit_profile_selected" ui-sref="editProfile"><i class="glyphicon glyphicon-none nav-menu-icon"></i>Edit Profile</a></li>\r\n                            <digest-link class="menu-item"></digest-link>\r\n                            <li><a click-event eventname="logout" ui-sref="logout"><i class="glyphicon glyphicon-none nav-menu-icon"></i>Sign Out</a></li>\r\n                        </ul>\r\n                    </li>\r\n                    <li class="dropdown" uib-dropdown hide-with-permission action="MANAGE_TENANT">\r\n                        <a class="dropdown-toggle profile-menu-link" data-toggle="dropdown" uib-dropdown-toggle>{{::user.firstName}} {{::user.lastName}} <b class="caret"></b></a>\r\n                        <ul class="dropdown-menu">\r\n                            <li><a click-event eventname="edit_profile_selected" ui-sref="editProfile"><i class="glyphicon glyphicon-user nav-menu-icon"></i>Edit Profile</a></li>\r\n                            <digest-link class="menu-item"></digest-link>\r\n                            <li><a click-event eventname="logout" ui-sref="logout"><i class="glyphicon glyphicon-log-out nav-menu-icon"></i>Sign Out</a></li>\r\n                        </ul>\r\n                    </li>\r\n                </ul>\r\n                <div style="display: inline-block; padding-top: 26px; margin-right: 15px;"><state-help></state-help></div>\r\n            </div>\r\n        </div>\r\n        <div class="row header hidden-lg hidden-md" ng-hide="header.noNav">\r\n            <div class="col-xs-12">\r\n                <div class="col-md-7 col-md-offset-5">\r\n                    <ul class="nav nav-pills">\r\n                        <li ng-repeat="navConfig in header.navConfiguration" class="top-menu" ng-class="{ \'nav-selected\' : header.isState(navConfig.state) }">\r\n                            <a ng-if="!navConfig.restrictToRole && !navConfig.popout" ng-href="{{header.generateUrl(navConfig)}}" click-event eventname="{{navConfig.eventName}}" ng-click="header.goToState($event, navConfig)"><strong>{{navConfig.label}}</strong></a>\r\n                            <a ng-if="!navConfig.restrictToRole && navConfig.popout" target="_blank" ng-href="{{header.generateUrl(navConfig)}}" click-event eventname="{{navConfig.eventName}}"><strong>{{navConfig.label}}</strong></a>\r\n                            <a ng-if="navConfig.restrictToRole && !navConfig.popout" show-with-permission ng-href="{{header.generateUrl(navConfig)}}"  action="{{navConfig.restrictToRole}}" click-event eventname="{{navConfig.eventName}}" ng-click="header.goToState($event, navConfig)"><strong>{{navConfig.label}}</strong></a>\r\n                            <a ng-if="navConfig.restrictToRole && navConfig.popout" target="_blank" show-with-permission ng-href="{{header.generateUrl(navConfig)}}"  action="{{navConfig.restrictToRole}}" click-event eventname="{{navConfig.eventName}}"><strong>{{navConfig.label}}</strong></a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</header>\r\n');
$templateCache.put('/templates//login.html','<div class="login-container" ng-controller="LoginCtrl as login" style="background-color: #F8FBFF; height: calc(100vh - 0px);">\n    <div class="flex-row">\n        <div class="flex"></div>\n        <div class="login-form-container">\n            <span growl reference="login" inline="true"></span>\n\n            <div class="well">\n                <div class="flex-center">\n                    <h2 style="padding-bottom: 10px; color: black !important;">Sign in to {{login.name}}</h2>\n                </div>\n                <div class="flex-center padded" style="color: black;">\n                    <h5 class="no-top-margin">Enter your <strong>email address</strong> and <strong>password</strong></h5>\n                </div>\n                <form class="form-signin" name="form" role="form" ng-submit="login.signIn()" autofill>\n                    <div class="position-relative">\n                        <md-input-container style="width: 100%; margin-top: 8px; margin-bottom: 0px;">\n                            <label>Email address</label>\n                            <input id="username-input" ng-model="login.user.username" name="username" type="text" autofocus required>\n                            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>\n                        </md-input-container>\n                    </div>\n                    <div class="position-relative">\n                        <md-input-container style="width: 100%; margin-top: 0px; margin-bottom: 0px;">\n                            <label>Password</label>\n                            <input id="password-input" name="password" ng-model="login.user.password" type="password" required>\n                            <span class="glyphicon glyphicon-lock form-control-feedback"></span>\n                        </md-input-container>\n                    </div>\n\n                    <div flex="100" layout="row" layout-align="center center">\n                        <md-button flex="100" class="md-raised md-primary" type="submit" style="text-transform: none;">Sign In</md-button>\n                    </div>\n\n                    <div flex="100" layout="row" layout-align="center center">\n                            <md-checkbox ng-model="login.user.stayLoggedIn">Remember Me</md-checkbox>\n                        </div>\n                </form>\n                <div class="login-center-text-block">\n                    <span>Forgot password? <a ui-sref="forgotPassword" style="padding-left: 12px;">Reset it here</a></span>\n                </div>\n            </div>\n            <div ng-if="login.selfSignupConfiguration" class="self-signup-container">\n                <div flex="100" layout="row" class="text-center">\n                    <h5 class="self-signup-start">Don\'t have an account on {{login.name}} yet?\n                        <md-button style="width: 100%" class="md-primary" ui-sref="signup">Create an account</md-button>\n                    </h5>\n                </div>\n            </div>\n\n            <div flex="100" layout="row" layout-align="center center" style="padding-top: 20px">\n                <img alt="Attensa" width="130" src="/images/attensa-logo-130.png">\n            </div>\n        </div>\n        <div class="flex"></div>\n    </div>\n</div>\n');
$templateCache.put('/templates//manageCategories.html','<div class="container manage-categories-container" ng-class="{ \'parent-dragging\' : draggingParent }">\n    <h5 ng-if="::catalog">Catalog: {{::catalog.label}}</h5>\n    <div class="well">\n        <div class="row">\n            <div class="col-md-3">\n                    <h4 ng-show="taxonomy">{{categoryCount}} Categories</h4>\n            </div>\n            <div class="col-md-6">\n                <div class="category-manager-add-new-category">\n                    <a editable-text="newCategory.title" e-placeholder="Type in new category" onaftersave="saveNewCategory($data)"><i class="fa fa-plus"></i> Add Category</a>\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-3">\n                <a ng-click="alphabetize()" class="btn btn-default" blur-me>Alphabetize</a>\n            </div>\n            <div class="col-md-offset-5 col-md-4">\n                <div class="has-feedback category-manager-filter">\n                    <input type="text" class="form-control ng-pristine ng-valid has-visited ng-touched" placeholder="Search..." ng-model="searchText">\n                    <a ng-show="searchText" ng-click="searchText = \'\';" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear ng-hide" aria-hidden="true"></a>\n                </div>\n\n            </div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-3">\n            <a ng-show="taxonomy && allCollapsed()" ng-click="toggleAllExpansion()"><h4><i class="glyphicon glyphicon-plus"></i> Expand All</h4></a>\n            <a ng-show="taxonomy && !allCollapsed()" ng-click="toggleAllExpansion()"><h4><i class="glyphicon glyphicon-minus"></i> Collapse All</h4></a>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12" ui-tree="treeOptions" data-empty-placeholder-enabled="false">\n            <ol ui-tree-nodes id="category-manage-list" class="list-group" ng-model="taxonomy">\n                <li ui-tree-node collapsed="false" ng-repeat="category in taxonomy | categoryFilter:searchText" ng-show="category.removable">\n                    <div class="row category-item" ng-class="{\'bg-lightgrey\':category.hovered}" ng-mouseover="categoryEnter(category, $event)" ng-mouseleave="categoryLeave(category);">\n                        <div class="col-md-1 tight-right">\n                            <a ng-show="category.subcategories.length" ng-click="toggleCategory(this)" class="category-toggle"><span class="glyphicon" ng-class="{ \'glyphicon-triangle-right\': categoryCollapsed(category), \'glyphicon-triangle-bottom\': !categoryCollapsed(category)}"></span></a>\n                        </div>\n                        <div class="col-md-10 tight-left">\n                            <span id="taxonomic-category-title" editable-text="category.title" onbeforesave="validateTitle($data)" onaftersave="saveTenantTaxonomy(category.title)" e-form="categoryTitleForm">{{category.title}}</span>\n                            &nbsp; <a ng-click="categoryTitleForm.$show()" ng-hide="dragging || categoryTitleForm.$visible || !category.hovered" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>\n                            &nbsp; <a ng-click="deleteCategory(category)" ng-hide="dragging || !category.hovered"><i class="fa fa-times-circle text-danger"></i></a>\n                            &nbsp; <a ng-show="!dragging && category.hovered" editable-text="newSubCategory.title" e-placeholder="Type in new category" onaftersave="saveNewSubcategory($data, category)"><i class="fa fa-plus"></i> Add Subcategory</a>\n                        </div>\n                        <div ui-tree-handle class="col-md-1" ng-show="!dragging && category.hovered">\n                            <i style="margin-top:3px;" class="fa fa-arrows text-muted pull-right sort-handle"></i>\n                        </div>\n                    </div>\n                    <div ui-tree-nodes class="subcategories" ng-model="category.subcategories">\n                        <div ui-tree-node ng-repeat="subcat in category.subcategories | filter:{title: searchText}" ng-class="{\'bg-lightgrey\':subcat.hovered}" ng-mouseover="categoryEnter(subcat, $event)" ng-mouseleave="categoryLeave(subcat)" nodrop-enabled ng-hide="categoryCollapsed(category)">\n                            <div class="row category-item">\n                                <div class="col-md-offset-2 col-md-9">\n                                    <span editable-text="subcat.title" onbeforesave="validateTitle($data)" onaftersave="saveTenantTaxonomy(subcat.title)" e-form="subcategoryTitleForm">{{subcat.title}}</span>\n                                    &nbsp; <a ng-click="subcategoryTitleForm.$show()" ng-hide="dragging || subcategoryTitleForm.$visible || !subcat.hovered" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>\n                                    &nbsp; <a ng-click="deleteCategory(subcat, category)" ng-hide="dragging || !subcat.hovered"><i class="fa fa-times-circle text-danger"></i></a>\n                                </div>\n                                <div ui-tree-handle class="col-md-1" ng-show="!dragging && subcat.hovered">\n                                    <i style="margin-top:3px;" class="fa fa-arrows text-muted pull-right sort-handle"></i>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ol>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//manageGroupsTable.html','<div class="col-md-10 col-md-offset-1">\n    <div class="container white-container">\n        <div class="row">\n            <div class="col-md-2">\n                <h3>Manage Groups</h3>\n            </div>\n            <div class="col-md-8">\n                <div class="row">\n                    <div class="col-md-6 col-md-offset-5">\n                        <ul class="nav nav-pills pad-top-bottom">\n                            <li role="presentation" ui-sref="managePeople"><a>People</a></li>\n                            <li role="presentation" ui-sref="manageGroups" class="active"><a>Groups</a></li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-2"></div>\n        </div>\n        <div class="navbar navbar-default" role="navigation">\n            <div class="navbar-header">\n                <button type="button" class="navbar-toggle" ng-click="navbarCollapsed = !navbarCollapsed">\n                    <span class="sr-only">Toggle navigation</span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                </button>\n            </div>\n            <!-- Collect the nav links, forms, and other content for toggling -->\n            <div class="collapse navbar-collapse" uib-collapse="navbarCollapsed">\n                <div class="pull-left">\n                    <label ng-show="groupCount" class="header-counter">{{groupCount}} <ng-pluralize count="groupCount" when="{\'one\': \'Group\', \'other\': \'Groups\'}"></ng-pluralize></label>\n                </div>\n                <div class="pull-left">\n                    <div class="nav navbar-nav">\n                        <a type="button" class="btn btn-primary add-item-button header-navbar-section" ng-click="addGroup()"><span class="fa fa-plus"></span> Group</a>\n                    </div>\n                </div>\n                <div class="pull-right header-navbar-section" role="search">\n                    <div class="has-feedback">\n                        <input id="admin-table-search-input" type="text" class="form-control admin-table-search" placeholder="Search" ng-model="searchTerm" ng-change="searchGroups()" ng-model-options="{debounce: 1000}" clear-input>\n                        <a ng-click="clearSearch()" ng-show="searchTerm" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-12 table-section-content" infinite-scroll="nextPage()" infinite-scroll-disabled="lastPage" infinite-scroll-disabled="lastPage">\n                <table class="table fixed-table" id="group-table">\n                    <thead>\n                        <tr>\n                            <th style="width: 20%;">\n                                <sort-people-by label="\'Name\'" sort="sort" sort-key="\'nameLower\'" sort-by="sortByOthers"></sort-people-by>\n                            </th>\n                            <th>\n                                <span style="font-weight: normal">Description</span>\n                            </th>\n                            <th style="width: 10%;">\n                                <sort-people-by label="\'Members\'" sort="sort" sort-key="\'membersCount\'" sort-by="sortByOthers" initial-descending="true"></sort-people-by>\n                            </th>\n                            <th style="width: 18%;">\n                                <sort-people-by label="\'Created\'" sort="sort" sort-key="\'created\'" sort-by="sortByOthers" initial-sort="true"></sort-people-by>\n                            </th>\n                            <th style="width: 8%"></th>\n                        </tr>\n                    </thead>\n                    <tr ng-repeat="group in groups" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                        <td class="white-space-nowrap fixed-table-cell" title="{{group.name}}">{{group.name}}</td>\n                        <td class="white-space-nowrap fixed-table-cell" title="{{group.description}}">{{group.description}}</td>\n                        <td class="white-space-nowrap fixed-table-cell">{{group.members.length}}</td>\n                        <td class="white-space-nowrap fixed-table-cell">{{group.created | amDateFormat:\'MMM Do YYYY, h:mm a\'}}</td>\n                        <td>\n                            <div class="btn-group" uib-dropdown>\n                                <button type="button" id="edit-{{group.id}}" ng-click="editGroup(group)" class="btn btn-xs btn-default">Edit</button>\n                                <button type="button" id="dropdown-{{group.id}}" class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle>\n                                    <span class="caret"></span>\n                                </button>\n                                <ul class="dropdown-menu" role="menu">\n                                    <li>\n                                        <a id="delete-{{group.id}}" ng-click="deleteGroup(group.id)">Delete</a>\n                                    </li>\n                                </ul>\n                            </div>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//managePeopleTable.html','<div class="col-md-10 col-md-offset-1">\n    <div class="container white-container">\n        <div class="row">\n            <div class="col-md-2">\n                <h3>Manage People</h3>\n            </div>\n            <div class="col-md-8">\n                <div class="row">\n                    <div class="col-md-6 col-md-offset-5">\n                        <ul class="nav nav-pills pad-top-bottom">\n                            <li role="presentation" ui-sref="managePeople" class="active"><a>People</a></li>\n                            <li role="presentation" ui-sref="manageGroups"><a>Groups</a></li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-2"></div>\n        </div>\n        <div class="navbar navbar-default" role="navigation">\n            <div class="navbar-header">\n                <button type="button" class="navbar-toggle" ng-click="$ctrl.navbarCollapsed = !$ctrl.navbarCollapsed">\n                    <span class="sr-only">Toggle navigation</span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                </button>\n            </div>\n            <!-- Collect the nav links, forms, and other content for toggling -->\n            <div class="collapse navbar-collapse" uib-collapse="$ctrl.navbarCollapsed">\n                <div class="pull-left">\n                    <label ng-show="$ctrl.peopleCount" class="header-counter">{{$ctrl.peopleCount}} <ng-pluralize count="$ctrl.peopleCount" when="{\'one\': \'Person\', \'other\': \'People\'}"></ng-pluralize></label>\n                </div>\n                <div class="pull-left">\n                    <div class="nav navbar-nav">\n                        <a type="button" class="btn btn-primary add-item-button header-navbar-section" ng-click="$ctrl.addPeople()" click-event eventname="add_people_clicked"><span class="fa fa-plus"></span> People</a>\n                    </div>\n                    <div class="nav navbar-nav">\n                        <div class="dropdown" uib-dropdown>\n                            <button uib-dropdown-toggle ng-disabled="$ctrl.selectDisabled" id="bulk-action-dropdown" class="btn btn-default header-navbar-section" data-toggle="dropdown" uib-dropdown-toggle="" aria-haspopup="true" aria-expanded="false">Bulk Actions <span class="fa fa-caret-down"></span></button>\n                            <ul class="dropdown-menu" role="menu">\n                                <li role="presentation" class="dropdown-header">User</li>\n                                <li><a ng-click="$ctrl.setStatuses(\'ACTIVE\')">Activate</a></li>\n                                <li><a ng-click="$ctrl.setStatuses(\'INACTIVE\')">De-activate</a></li>\n                                <li><a ng-click="$ctrl.setStatuses(\'INVITED\')">Send Invitation</a></li>\n                                <li><a ng-click="$ctrl.activateDigests()">Activate Digests</a></li>\n                                <li><a ng-click="$ctrl.archiveUsers()">Delete</a></li>\n                                <li class="divider"></li>\n                                <li role="presentation" class="dropdown-header">Add Role</li>\n                                <li ng-class="{disabled: $ctrl.searching}" ng-repeat="role in $ctrl.tenant.tenantRoles | orderBy: \'name\'" ng-hide="::!$ctrl.allowTopicCreators && role.type === \'STREAM_CREATOR\'">\n                                    <a ng-click="$ctrl.usersGroupAction($ctrl.addTenantRole, role.type)">{{role.name}}</a>\n                                </li>\n                                <li class="divider"></li>\n                                <li role="presentation" class="dropdown-header">Remove Role</li>\n                                <li ng-class="{disabled: $ctrl.searching}" ng-repeat="role in $ctrl.tenant.tenantRoles | orderBy: \'name\'" ng-hide="::!$ctrl.allowTopicCreators && role.type === \'STREAM_CREATOR\'">\n                                    <a ng-click="$ctrl.usersGroupAction($ctrl.removeTenantRole, role.type)">{{role.name}}</a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class="nav navbar-nav header-navbar-section">\n                        <button class="btn btn-default"\n                                export-to-csv\n                                format-data="$ctrl.fetchForCSV()"\n                                filename="people.csv"\n                                ng-disabled="!$ctrl.peopleCount || $ctrl.fetchingForCSV"\n                                title="Download CSV file of all people"\n                        >\n                            <span class="fa fa-download"></span>\n                        </button>\n                    </div>\n                </div>\n                <div class="pull-right">\n                    <ul class="nav navbar-nav header-navbar-section">\n                        <li uib-dropdown>\n                            <button class="btn btn-default dropdown-toggle" uib-dropdown-toggle title="Filter">\n                                <span class="glyphicon glyphicon-filter"></span> {{$ctrl.filterByTenantRole ? $ctrl.filterByTenantRole.name : \'All\'}} <span class="caret"></span>\n                            </button>\n                            <ul class="dropdown-menu" role="menu">\n                                <li>\n                                    <a ng-click="$ctrl.removeFilter()">All</a>\n                                </li>\n                                <li ng-repeat="tenantRole in $ctrl.tenant.tenantRoles | orderBy: \'name\'" ng-hide="::!$ctrl.allowTopicCreators && tenantRole.type === \'STREAM_CREATOR\'">\n                                    <a ng-click="$ctrl.filterByRole(tenantRole)">{{tenantRole.name}}</a>\n                                </li>\n                            </ul>\n                        </li>\n                    </ul>\n                    <form class="nav navbar-nav header-navbar-section" role="search">\n                        <div class="has-feedback">\n                            <input id="admin-table-search-input" type="text" class="form-control admin-table-search" placeholder="Search" ng-model="$ctrl.searchTerm" ng-change="$ctrl.searchUser()" ng-model-options="{debounce: 1000}" clear-input>\n                            <a ng-click="$ctrl.clearSearch()" ng-show="$ctrl.searchTerm" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n        <div>\n            <div class="row">\n                <div ng-if="$ctrl.noTouching"><spinner></spinner></div>\n                <div ng-if="!$ctrl.noTouching" class="col-md-12 table-section-content" infinite-scroll="$ctrl.nextPage()" infinite-scroll-distance="1">\n                    <table class="table" id="people-table">\n                        <thead>\n                        <tr>\n                            <th style="text-align: center;">\n                                <input type="checkbox" ng-model="$ctrl.selectAll" ng-change="$ctrl.selectAllToggle()">\n                            </th>\n                            <th class="admin-table-header">\n                                <sort-people-by label="\'First Name\'" sort="$ctrl.sort" sort-key="\'firstNameLower\'" sort-by="$ctrl.sortByOthers"></sort-people-by>\n                            </th>\n                            <th class="admin-table-header">\n                                <sort-people-by label="\'Last Name\'" sort="$ctrl.sort" sort-key="\'lastNameLower\'" sort-by="$ctrl.sortByOthers"></sort-people-by>\n                            </th>\n                            <th>\n                                <sort-people-by label="\'Email Address\'" sort="$ctrl.sort" sort-key="\'emailAddress\'" sort-by="$ctrl.sortByOthers"></sort-people-by>\n                            </th>\n                            <th ng-if="::$ctrl.allowTopicCreators">Topic Creator</th>\n                            <th>Admin</th>\n                            <th>\n                                <sort-people-by label="\'Status\'" sort="$ctrl.sort" sort-key="\'status\'" sort-by="$ctrl.sortByOthers"></sort-people-by>\n                            </th>\n                            <th>\n                                <sort-people-by label="\'Date Added\'" sort="$ctrl.sort" sort-key="\'created\'" sort-by="$ctrl.sortByOthers"></sort-people-by>\n                            </th>\n                            <th>\n                                <sort-people-by label="\'Last Active\'" sort="$ctrl.sort" sort-key="\'lastActivityDate\'" sort-by="$ctrl.sortByOthers" initial-descending="true"></sort-people-by>\n                            </th>\n                            <th style="width: 8%"></th>\n                        </tr>\n                        </thead>\n\n                        <tr ng-repeat="user in $ctrl.users" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                            <td class="text-center select-cell"><input type="checkbox" ng-model="user.selected" ng-change="$ctrl.change()" ng-disabled="user.id === $ctrl.currentUser.id"></td>\n                            <td class="white-space-nowrap">{{user.firstName}}</td>\n                            <td class="white-space-nowrap">{{user.lastName}}</td>\n                            <td class="white-space-nowrap">{{user.emailAddress}}</td>\n                            <td class="white-space-nowrap" ng-if="::$ctrl.allowTopicCreators">\n                                <input type="checkbox" ng-model="user.streamCreator" ng-change="$ctrl.toggleRole(user, \'STREAM_CREATOR\')" ng-disabled="user.id === $ctrl.currentUser.id">\n                            </td>\n                            <td class="white-space-nowrap">\n                                <input type="checkbox" ng-model="user.admin" ng-change="$ctrl.toggleRole(user, \'TENANT_ADMIN\')" ng-disabled="user.id === $ctrl.currentUser.id">\n                            </td>\n                            <td class="white-space-nowrap">\n                                <div class="dropdown" uib-dropdown>\n                                    <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle style="min-width: 100px;" ng-disabled="user.id === $ctrl.currentUser.id">{{user.status}} <span class="caret"></span></button>\n                                    <ul class="dropdown-menu" role="menu">\n                                        <li>\n                                            <a ng-click="user.status=\'ACTIVE\'; $ctrl.changeStatus(user)">ACTIVE</a>\n                                        </li>\n                                        <li>\n                                            <a ng-click="user.status=\'INACTIVE\'; $ctrl.changeStatus(user)">INACTIVE</a>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </td>\n                            <td class="white-space-nowrap">{{user.created | amDateFormat:\'MMM Do YYYY\'}}</td>\n                            <td class="white-space-nowrap">{{user.lastActivityDate | amDateFormat:\'MMM Do YYYY\'}}<span ng-if="!user.initialized && !$ctrl.tenant.settings.samlEntryPoint" title="No initial login" style="color: red;"> *</span></td>\n                            <td>\n                                <div uib-dropdown class="btn-group manage-people-edit-dropdown" ng-style="$ctrl.isCurrentUser(user) && {\'cursor\': \'not-allowed\'}">\n                                    <button type="button" id="edit-{{::user.id}}" ng-click="$ctrl.editUser(user)" class="btn btn-default">Edit</button>\n                                    <button type="button" class="btn btn-default dropdown-toggle" ng-disabled="$ctrl.isCurrentUser(user)" uib-dropdown-toggle aria-expanded="false">\n                                        <span class="caret"></span>\n                                        <span class="sr-only">Toggle Dropdown</span>\n                                    </button>\n                                    <ul class="dropdown-menu" role="menu">\n                                        <li><a ng-click="$ctrl.archiveUser(user)">Delete</a></li>\n                                    </ul>\n                                </div>\n                            </td>\n                        </tr>\n                    </table>\n                    <div ng-if="$ctrl.noTouchingPaging"><spinner></spinner></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//manageStreamTagsModal.html','<modal-header title="Stream Tags" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <form class="form-inline">\n        <div class="form-group has-feedback has-clear">\n            <input type="text" class="form-control" style="width: 496px" placeholder="Search existing tags or create a new tag" ng-model="tableParams.filter().label">\n            <a ng-click="tableParams.filter().label = \'\'" ng-show="tableParams.filter().label" class="glyphicon glyphicon-remove-sign form-control-feedback form-control-clear search-clear-glyph"></a>\n         </div>\n         <button class="btn btn-default" ng-disabled="!canCreate()" ng-click="createTag()">Create</button>\n    </form><br>\n    <table ng-table="tableParams" class="table table-condensed table-bordered table-striped">\n        <colgroup>\n          <col width="60%" />\n          <col width="20%" />\n          <col width="10%" />\n          <col width="10%" />\n        </colgroup>\n        <tr ng-repeat="tag in $data">\n            <td data-title="\'Tag\'" sortable="\'label\'"><span editable-text="tag.label" onbeforesave="validateTagLabel($data)" onaftersave="updateTag(tag)" e-form="editTagForm">{{tag.label}}&nbsp; </span></td>\n            <td data-title="\'Created\'" sortable="\'created\'"><nobr>{{::tag.created | date: \'mediumDate\'}}</nobr></td>\n            <td data-title="\'Streams\'" sortable="\'streamCount\'">{{::tag.streamCount || 0}}</td>\n            <td>\n                <a ng-click="editTagForm.$show()" style="border-bottom: none;"><i class="fa fa-pencil-square-o"></i></a>&nbsp;<a ng-click="deleteTag(tag)"><i class="fa fa-times-circle text-danger"></i></a>&nbsp;\n            </td>\n        </tr>\n    </table>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-primary pull-right" ng-click="$close()">Close</button>\n</div>');
$templateCache.put('/templates//manageTemplates.html','<div class="container">\n    <div class="row">\n        <div class="col-md-12">\n            <button id="add-template-button" style="margin-top:10px;" class="btn btn-primary pull-right" ng-click="uploadTemplate()"><i class="fa fa-plus"></i> Template</button>\n            <h3>{{templateCount}} Briefing Templates</h3>\n            <alerts watch-for="template-alerts" suppress-duplicates></alerts>\n            <ng-include src="\'/templates/templateBrowser.html\'"></ng-include>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//messageModal.html','<div class="modal-body generic-modal-content">\n    <h2>{{modalTitle}}</h2>\n    <div class="row">\n        <div class="col-md-12">\n            {{message}}\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button type="button" class="btn btn-default" id="ok-button" ng-click="$close()">Ok</button>\n</div>');
$templateCache.put('/templates//noCategoryWarningModal.html','<modal-header title="No category selected" icon-class="glyphicon glyphicon-exclamation-sign" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <p>This will automatically save under "Uncategorized".</p>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n    <button class="btn btn-primary" ng-click="$close(true)">Save</button>\n</div>\n');
$templateCache.put('/templates//opmlImport.html','<div class="container">\r\n    <div ng-hide="fileImported" class="pad-top-bottom">\r\n        <alerts watch-for="opml-alerts" suppress-duplicates></alerts>\r\n        <h2>Import OPML File</h2>\r\n        <div class="modal-body">\r\n            <div class="container">\r\n                <div class="col-lg-10">\r\n                    <div title="select file" class="btn" ng-class="{\'btn-primary\': !filePresent, \'btn-default\': filePresent}" style="position: relative; display: inline-block;" data-multiple="false">\r\n                        Choose file\r\n                        <button title="select file" class="upload-button" ngf-change="fileSelected()" ngf-select ng-model="opmlFiles" ngf-multiple="false" />\r\n                    </div>\r\n                    <div style="display: inline-block; margin-left: 15px;"><h4>{{fileName}}</h4></div>\r\n                </div>\r\n            </div>\r\n            <div class="container pad-top-bottom" ng-show="opmlFiles">\r\n                <div class="form-group" ng-if="!streamId">\r\n                    <label>Categories</label>\r\n                    <div class="panel panel-default">\r\n                        <div class="panel-heading">\r\n                            <h4 class="panel-title">\r\n                                <button class="btn btn-sm btn-default" ng-disabled="!taxonomy" ng-click="editCategories()">Edit</button>\r\n                            </h4>\r\n                        </div>\r\n                        <ul class="list-group" ng-if="selectedCategories.length > 0">\r\n                            <li class="list-group-item">\r\n                                <h4><span ng-repeat="category in selectedCategories" class="label label-default label-tag">{{category.title}}</span></h4>\r\n                            </li>\r\n                        </ul>\r\n                        <ul class="list-group" ng-if="selectedCategories.length === 0">\r\n                            <li class="list-group-item help-block">Click edit to categorize this stream.</li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div ng-show="fileImported" class="jumbotron col-md-8 col-md-offset-2" style="margin-top: 15px;">\r\n        <h2>OPML File Imported</h2>\r\n        <p>Your OPML file is currently being processed. Streams will be added as they are processed.</p>\r\n        <a ng-show="fileImported" class="btn btn-primary pull-right" ui-sref="streams">Back to catalog</a>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button ng-hide="fileImported" ng-disabled="!filePresent || uploading" class="btn" ng-class="{\'btn-primary\': filePresent, \'btn-default\': !filePresent}" ng-click="importOpml(opmlFiles[0])">Import OPML</button>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//peopleAddModal.html','<modal-header title="Add new people" on-close="$dismiss()"></modal-header>\n<div class="modal-body generic-modal-content">\n  <div class="container white-container">\n    <div class="row">\n      <form name="addPeopleForm" class="form-inline" role="form">\n        <fieldset>\n          <div class="people-add-rows" ng-form="userForm" ng-repeat="user in $ctrl.totalUsers">\n            <div class="add-person-row clearfix" style="padding-top: 10px;">\n              <div class="add-person">\n                <div class="form-group col-sm-6" style="padding-left: 5px; padding-right: 5px;">\n                    <div class="has-feedback">\n                      <div ng-if="userForm.email.$error.required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                      <div ng-if="!userForm.email.$error.required && userForm.email.$invalid" class="form-control-feedback glyphicon glyphicon-ban-circle"></div>\n                      <div ng-if="userForm.email.$pending" class="form-control-feedback glyphicon glyphicon-refresh"></div>\n                      <div ng-if="userForm.email.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n                    </div>\n                    <input type="email" name="email" placeholder="Email Address" class="form-control" style="width: 100%; padding-right: 40px;" ng-model="user.emailAddress" validate-unique-email ng-model-options="{ updateOn: \'default blur\', debounce: {\'default\': 500, \'blur\': 0} }" required>\n                    <div ng-if="userForm.email.$touched">\n                      <div class="has-error" ng-messages="userForm.email.$error">\n                        <small class="help-block" ng-message="required">Please enter an email address</small>\n                        <small class="help-block" ng-message="email">Please enter a correct email address</small>\n                        <small class="help-block" ng-message="uniqueEmail">The email address you have entered already exists, please enter another email address</small>\n                      </div>\n                    </div>\n                </div>\n                <div class="form-group col-sm-3" style="padding-left: 5px; padding-right: 5px;">\n                  <div class="has-feedback" ng-messages="userForm.firstName.$error">\n                    <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                    <div ng-if="userForm.firstName.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n                  </div>\n                  <input type="text" name="firstName" placeholder="First Name" class="form-control" style="width: 100%; padding-right: 40px;" ng-model="user.firstName" required>\n                  <div ng-if="userForm.firstName.$touched">\n                    <div class="has-error" ng-messages="userForm.firstName.$error">\n                      <small class="help-block" ng-message="required">Please enter a first name</small>\n                    </div>\n                  </div>\n                </div>\n                <div class="form-group col-sm-3" style="padding-left: 5px; padding-right: 5px;">\n                  <div class="has-feedback" ng-messages="userForm.lastName.$error">\n                    <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                    <div ng-if="userForm.lastName.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n                  </div>\n                  <input type="text" name="lastName" placeholder="Last Name" class="form-control" style="width: 100%; padding-right: 40px;" ng-model="user.lastName" required>\n                  <div ng-if="userForm.lastName.$touched">\n                      <div class="has-error" ng-messages="userForm.lastName.$error">\n                      <small class="help-block" ng-message="required">Please enter a last name</small>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class="form-group col-sm-12" style="padding-left: 5px; padding-right: 5px; padding-bottom: 10px; margin-top: 5px;">\n                  <textarea rows="2" name="inviteMessage" placeholder="Invitation Message" class="form-control" style="width: 100%;" ng-model="user.inviteMessage"></textarea>\n                </div>\n                <div class="form-group col-sm-12" class="checkbox" style="padding-left: 7px">\n                  <label>\n                    <input type="checkbox" ng-model="user.activateDigest"> Personal Briefing Active\n                  </label>\n                </div>\n            </div>\n          </div>\n          <span class="add-another-person-button" ng-click="$ctrl.addAnotherRow(addPeopleForm)">\n            <span style="font-size: 20px;" class="fa fa-plus-circle"></span>\n            <span>Add Another</span>\n          </span>\n          <div style="padding-top: 15px;">\n                <h4>User groups</h4>\n          </div>\n          <div>\n                <group-picker selected-groups="$ctrl.selectedGroups"></group-picker>\n          </div>\n        </fieldset>\n      </form>\n      <div class="modal-footer">\n        <button class="btn btn-default" ng-click="$ctrl.cancel()">Cancel</button>\n        <button class="btn btn-primary" ng-click="$ctrl.addUsers($ctrl.totalUsers, \'INACTIVE\')" ng-disabled="addPeopleForm.$invalid || addPeopleForm.$pending || adding">Add User</button>\n        <button class="btn btn-primary" ng-click="$ctrl.addUsers($ctrl.totalUsers, \'INVITED\')" ng-disabled="addPeopleForm.$invalid || addPeopleForm.$pending || adding">Add User and Send Invite</button>\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('/templates//peopleConfirmInviteModal.html','<modal-header title="{{::titleText}}" on-close="$dismiss()"></modal-header>\n<div class="modal-body generic-modal-content">\n    <h3 style="text-align: center">\n        <ng-pluralize count="inviteCount"\n        when="{\'one\': \'1 user {{action}}!\',\n            \'other\': \'{} users {{action}}!\'}">\n        </ng-pluralize>\n    </h3>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-primary" ng-click="$dismiss()">Ok</button>\n</div>\n');
$templateCache.put('/templates//postItemModal.html','<div id="post-item-modal" style="position:relative" class="modal-body generic-modal-content">\n    <a ng-click="cancel()" class="fa fa-times muted pull-right modal-close-x" aria-hidden="true"></a>\n    <h2>{{title}}</h2>\n    <div class="row" ng-hide="posting">\n        <div class="col-md-12">\n            <form name="form" role="form" enctype="multipart/form-data" autocomplete="off" class="form">\n                <div class="form-group">\n                    <label for="sourceUrl">Source URL</label>\n                    <div class="input-group">\n                        <input name="sourceUrl" ng-model="sourceUrl" type="url"\n                                                     class="form-control" id="sourceUrl"\n                                                     placeholder="To set the destination for when the title of this item is clicked add a URL here">\n                        <span class="input-group-btn">\n                            <button class="btn btn-default" type="button" ng-click="importArticle(sourceUrl)" ng-disabled="importingArticle" style="width: 10em">\n                                <span ng-if="importingArticle"><i class="fa fa-spinner fa-spin"></i></span>\n                                <span ng-if="!importingArticle">Import article</span>\n                            </button>\n                        </span>\n                    </div>\n                    <div ng-if="form.sourceUrl.$error.url">\n                        <div class="has-error">\n                            <small class="help-block">Invalid URL</small>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label for="itemTitle">Title</label>\n                    <input name="itemTitle" ng-model="itemTitle" type="text" class="form-control" id="itemTitle" placeholder="Title" required>\n                    <div ng-if="form.itemTitle.$touched">\n                        <div class="has-error" ng-messages="form.itemTitle.$error">\n                            <small class="help-block" ng-message="required">Title is required and cannot be empty</small>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label for="author">Author</label>\n                    <input name="author" ng-model="author" type="text" class="form-control" id="author" placeholder="Author">\n                </div>\n                <div class="form-group" ng-if="item">\n                    <label for="published-date">Date</label>\n                    <div class="form-inline">\n                        <div class="input-group date row">\n                            <div class="col-sm-6 col-md-6 date-select-box">\n                                <input class="form-control" data-placement="auto" placeholder="Date (MM/DD/YYYY)" name="publishedDate" type="text" bs-datepicker data-container="#post-item-modal .date-select-box" data-date-format="MM/dd/yyyy" ng-model="publishedDateTime.date" id="published-date" required/>\n                                <div class="has-error" ng-messages="form.publishedDate.$error">\n                                    <small class="help-block" ng-message="required">Date must not be empty</small>\n                                </div>\n                            </div>\n                            <div class="col-sm-6 col-md-6 time-select-box">\n                                <input class="form-control" data-length="1" data-placement="auto" placeholder="Time (H:MM AM/PM)" name="publishedTime" type="text" bs-timepicker data-container="#post-item-modal .time-select-box" data-minute-step="1" arrow-behavior="picker" ng-model="publishedDateTime.time" id="published-time" required/>\n                                <div class="has-error" ng-messages="form.publishedTime.$error">\n                                    <small class="help-block" ng-message="required">Time must not be empty</small>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-repeat="annotation in annotations">\n                    <div class="col-md-12 item-annotation" style="padding: 0; margin-top: 10px;">\n                        <h3>{{annotation.title}}</h3>\n                        <div>\n                            <div ta-paste="cleanPaste($html)" ta-text-editor-class="edit-annotation-text form-control" ta-keep-styles="true" ta-html-editor-class="edit-annotation-text form-control" text-angular ta-toolbar="[[\'p\',\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'underline\'],[\'ul\',\'ol\'],[\'justifyLeft\',\'justifyCenter\',\'justifyRight\'],[\'indent\',\'outdent\'],[\'html\',\'insertImage\',\'insertLink\'], [\'backgroundColor\'], [\'foregroundColor\'],[\'fontPicker\'], [\'fontSizePicker\']]" ng-model="annotation.annotationText"></div>\n                        </div>\n                        <div class="highlight">\n                            <div class="clearfix" style="width: 100%; padding-right: 0;">\n                                <div class="btn-group btn-group-xs" uib-dropdown>\n                                    <button type="button" style="margin-left: 3px;" class="btn btn-default dropdown-toggle annotation-location-dropdown" data-toggle="dropdown" uib-dropdown-toggle>\n                                        Location: <span class="annotation-location-label" ng-bind="annotation.location"></span> <span class="caret"></span>\n                                    </button>\n                                    <ul class="dropdown-menu" role="menu">\n                                        <li><a class="annotation-above" ng-click="annotation.location = \'Above\'">Above</a></li>\n                                        <li><a class="annotation-below" ng-click="annotation.location = \'Below\'">Below</a></li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label for="itemTitle">Content</label>\n                    <div ng-required="true" name="defaultDescription" ng-model="defaultDescription" ta-paste="cleanPaste($html)" ta-keep-styles="true" ta-text-editor-class="form-control add-item-textarea" ta-html-editor-class="form-control" text-angular ta-toolbar="[[\'p\',\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'underline\'],[\'ul\',\'ol\'],[\'justifyLeft\',\'justifyCenter\',\'justifyRight\'],[\'indent\',\'outdent\'],[\'html\',\'insertImage\',\'insertLink\'], [\'backgroundColor\'], [\'foregroundColor\'], [\'fontPicker\'], [\'fontSizePicker\']]"></div>\n                    <div ng-if="form.defaultDescription.$touched">\n                        <div class="has-error" ng-messages="form.defaultDescription.$error">\n                            <small class="help-block" ng-message="required">Description is required and cannot be empty</small>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <p>\n                        <label for="attachments">Attachments</label>\n                    </p>\n                    <ul class="attachment-list">\n                        <li class="attachment-li mc-attachment-li" ng-repeat="attachment in existingAttachments">\n                            <a href="{{attachment.location}}" target="_blank">{{attachment.fileName}}</a>\n                        </li>\n                    </ul>\n                    <s3-upload button-text="Add Attachments" status="uploadStatus"></s3-upload>\n                </div>\n            </form>\n        </div>\n    </div>\n    <spinner ng-show="posting"></spinner>\n</div>\n<div class="modal-footer">\n    <button type="button" class="btn btn-default sub-modal-cancel" ng-click="cancel()" ng-disabled="posting">Cancel</button>\n    <span ng-show="operation === \'create\'" style="margin: 1%;" uib-tooltip="{{form.$invalid ? \'Fill in title and content to post item\' : \'\'}}" tooltip-append-to-body="true">\n        <button type="button" class="btn btn-primary" ng-disabled="form.$invalid || posting || uploadStatus.inProgress" ng-click="postItem()">{{action}}</button>\n    </span>\n    <span ng-show="operation === \'edit\'" style="margin: 1%;" uib-tooltip="{{form.$invalid ? \'Fill in title and content to update item\' : \'\'}}" tooltip-append-to-body="true">\n        <button type="button" class="btn btn-primary" ng-disabled="form.$invalid || posting" ng-click="updateItem()">Save</button>\n    </span>\n</div>\n');
$templateCache.put('/templates//profile.html','<div class="content-profile editor">\n    <div class="container">\n        <div class="profile-panel">\n            <div class="tab-content">\n                <div class="tab-pane active">\n                    <div class="page-header" style="margin-top: 15px;">\n                        <h3 style="color:#777777;margin: 0 0 5px;">Edit Profile</h3>\n                    </div>\n                    <form id="userForm" name="form" role="form" enctype="multipart/form-data">\n                        <div class="row">\n                            <alerts watch-for="profile-alerts" suppress-duplicates></alerts>\n                        </div>\n\n                        <ng-include src="\'/templates/userForm.html\'"></ng-include>\n\n                        <div class="form-group pane-controls">\n                            <div class="navbar-right">\n                                <button type="button" id="save-profile-basics" data-loading-text="Saving..."\n                                        class="btn btn-primary" ng-click="saveUser()" ng-disabled="form.$invalid" ng-bind="saveText">Save\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//reading.html','<div>\r\n    <div class="col-md-2" class="reading-menu-container">\r\n        <ng-include ng-if="!search.searching" src="\'/templates/readingSidebar.html\'"></ng-include>\r\n        <ng-include ng-if="search.searching" src="\'/templates/readingSearchSidebar.html\'"></ng-include>\r\n    </div>\r\n    <div class="col-md-10">\r\n        <nav id="reading-controls" scrolled class="container bg-lightgrey" style="margin-left: -5px;">\r\n                <div class="pull-left" style="width: 30%; padding-top: 5px;">\r\n                    <label class="reading-count">\r\n                        <span id="reading-title" ng-show="numberOfResults !== undefined && selectedQuery !== \'attentionRank\'" >{{numberOfResults | number}} articles</span>\r\n                    </label>\r\n                    <button class="btn btn-subtle-link reading-scroll-top" scrollup>\r\n                        <span class="glyphicon glyphicon-chevron-up"></span>\r\n                    </button>\r\n                    <span class="reading-view-toggle">\r\n                        <a ng-show="readingView === \'table\'" ng-click="setViewMode(\'tile\')" class="btn dropdown-toggle pull-left" id="readingViewTileLink">\r\n                            <span class="glyphicon glyphicon-th-list text-info" title="Detail View"></span>\r\n                        </a>\r\n                        <a ng-show="readingView === \'tile\'" ng-click="setViewMode(\'table\')" class="btn dropdown-toggle pull-left" id="readingViewTableLink">\r\n                            <span class="glyphicon glyphicon-list text-info" title="List View"></span>\r\n                        </a>\r\n                    </span>\r\n                </div>\r\n                <div class="pull-left">\r\n                    <div class="nav pull-left" ng-if="selectedStream && selectedStream.type === \'COLLECTION\'" stream-id="selectedStream.id" show-with-permission action="POST_TO_STREAM">\r\n                        <button title="Post to Stream" class="btn btn-default reading-post-item-button" ng-click="openPostItemModal()" blur-me><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-md hidden-sm hidden-xs">Post</span></button>\r\n                    </div>\r\n                    <ul class="nav pull-left">\r\n                        <li class="dropdown" uib-dropdown>\r\n                            <button title="Filter items" type="button" class="btn btn-default navbar-btn dropdown-toggle" uib-dropdown-toggle><span class="glyphicon glyphicon-filter"></span> <span class="hidden-md hidden-sm hidden-xs">{{selectedFilter.displayText}}</span> <span class="caret"></span></button>\r\n                            <ul class="dropdown-menu">\r\n                                <li><a ng-click="changeFilter(\'all\')">{{::filterPrefs.all.displayText}}</a></li>\r\n                                <li><a ng-click="changeFilter(\'unread\')">{{::filterPrefs.unread.displayText}}</a></li>\r\n                                <li><a ng-click="changeFilter(\'last24Hours\')">{{::filterPrefs.last24Hours.displayText}}</a></li>\r\n                                <li><a ng-click="changeFilter(\'commentsLast24Hours\')">{{::filterPrefs.commentsLast24Hours.displayText}}</a></li>\r\n                            </ul>\r\n                        </li>\r\n                    </ul>\r\n                    <ul class="nav pull-left">\r\n                        <li class="dropdown" uib-dropdown>\r\n                            <span id="tooltip-wrapper" title="Result sort order (can be changed only on searches)">\r\n                                <button id="reading-sort-order-button" type="button" class="btn btn-default navbar-btn dropdown-toggle" uib-dropdown-toggle ng-disabled="!search.searching || (!search.searching && selectedQuery) || (search.searching && search.segmentation.query)"><span class="glyphicon glyphicon-sort"></span> <span class="hidden-md hidden-sm hidden-xs">{{search.sortField === \'relevance\' ? \'Relevance\' : \'Published Date\' }}</span> <span class="caret"></span>\r\n                                </button>\r\n                            </span>\r\n                            <ul class="dropdown-menu">\r\n                                <li><a ng-click="performSearch(\'publishedDate\')">Sort by published date</a></li>\r\n                                <li><a ng-click="performSearch(\'relevance\')">Sort by relevance</a></li>\r\n                            </ul>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n                <div class="pull-right reading-search">\r\n                    <div class="has-feedback pull-right hide-sm" style="padding-top:8px;">\r\n                        <input type="text" class="reading-search-input" class="form-control" placeholder="Search" ng-model="search.text" ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }" size="40" enter-key="search.searching = true" on-delayed-change="search.searching = true">\r\n                        <a ng-click="resetSearch()" ng-show="search.text" style="margin-top: 8px" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\r\n                    </div>\r\n                </div>\r\n        </nav>\r\n        <div class="reading-inner-body" fetch-insurance="items" fetch-insurance-fetch-required="fetchPage(true)">\r\n            <read-permission-warning topic="selectedStream"></read-permission-warning>\r\n            <div class="row">\r\n                <alerts watch-for="reading-alerts"></alerts>\r\n            </div>\r\n            <spinner ng-show="fetching"></spinner>\r\n            <div ng-hide="fetching" class="position-relative" infinite-scroll="fetchPage(true)" infinite-scroll-disabled="isLastPage" infinite-scroll-immediate-check="false">\r\n                <div ng-if="readingView !== \'table\'" >\r\n                    <div class="reading-item-magazine" ng-repeat="item in items track by item.id">\r\n                        <div class="media-left">\r\n                            <div class="rank rank-large" ng-class="::attentionRankClass(item)"></div>\r\n                        </div>\r\n                        <div class="media-body">\r\n                            <div class="pad-left-right">\r\n                                <h4 class="media-heading"><a class="mc-reading-item-link" ng-click="openReadingModal(item)" title="{{::item.title}}"><span ng-if="::item.attachments.length"><i class="glyphicon glyphicon-paperclip"></i> </span><strong ng-if="!item.readByUser">{{item.title || \'No title\'}}</strong><span class="reading-lighweight-item-title" ng-if="item.readByUser">{{item.title || \'No title\'}}</span></a></h4>\r\n                                <p class="reading-magazine-item-description">{{::item.shortDescription}}</p>\r\n                                <ul class="reading-magazine-bylinelist">\r\n                                    <li ng-if="::item.streamOriginTitle && userCanRead()"><a class="view-stream-detail" ng-click="viewStreamDetailsForId(item.streamOriginId)">{{::item.streamOriginTitle}}</a></li>\r\n                                    <li am-time-ago="::item.publishedDate" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{::item.publishedDate | date : \'medium\'}}"></li>\r\n                                    <li ng-if="::item.author">{{::item.author}}</li>\r\n                                    <li ng-if="::item.link !== \'#\' && userCanRead()"><a ng-click="clickThroughItem(item)" class="direct-link"><span class="glyphicon glyphicon-link"></span> Direct Link</a></li>\r\n                                    <li ng-if="userCanRead()"><a ng-click="toggleBookmark(item)"><span class="fa" ng-class="item.savedByUser ? \'fa-bookmark text-danger\' : \'fa-bookmark-o\'"></span> {{ item.savedByUser ? \'Saved\' : \'Save\'}}</a></li>\r\n                                </ul>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div ng-if="readingView === \'table\'" >\r\n                    <div ng-repeat="item in items" class="reading-item" ng-class="{\'reading-new-item\': isItemNew(item)}">\r\n                        <div class="rich-list-item-group">\r\n                            <div class="rich-list-item-seg item-list-icon">\r\n                                <a ng-click="toggleBookmark(item)"><span class="fa" ng-class="item.savedByUser ? \'fa-bookmark text-danger\' : \'fa-bookmark-o\'"></span></a>&nbsp;\r\n                            </div>\r\n                            <div class="rich-list-item-seg rank-div">\r\n                                <span class="rank rich-list-rank" ng-class="::attentionRankClass(item)">&nbsp;</span>\r\n                            </div>\r\n                            <div class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" title="{{::item.title}}"><a class="rich-list-item-read mc-reading-item-link" ng-click="openReadingModal(item);"><span ng-if="::item.attachments.length"><i class="glyphicon glyphicon-paperclip"></i> </span><strong ng-if="!item.readByUser">{{item.title || \'No title\'}}</strong><span ng-if="item.readByUser">{{item.title || \'No title\'}}</span> - <span class="short-description">{{::item.shortDescription}}</span></a></div>\r\n                            <div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="::item.publishedDate" tooltip-placement="left" uib-tooltip="{{::item.publishedDate | date : \'medium\'}}"></div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div ng-show="isLastPage && personalCategory.streams.length > 0" class="row">\r\n                <div class="col-md-2 col-md-offset-5">\r\n                    <h3 class="text-info text-muted">No more articles.</h3>\r\n                </div>\r\n            </div>\r\n            <div ng-show="getAllSubscribedStreamIds(personalCategories).length === 0 && !fetching && items.length === 0" class="row">\r\n                <div class="col-md-offset-1 col-md-11">\r\n                    <h3 class="text-info">You are not following any streams. <a ui-sref="streams">Add some.</a>\r\n                </div>\r\n            </div>\r\n            <div ng-show="!fetching && items.length === 0 && getAllSubscribedStreamIds(personalCategories).length !== 0" class="alert alert-warning alert-dismissible" role="alert">\r\n                <div ng-if="search.text">\r\n                    No articles match your <i>{{selectedFilter.displayText}}</i> filter and search criteria.\r\n                </div>\r\n                <div ng-if="!search.text && !selectedFilter.restrictCommentsToLast24Hours">\r\n                    No articles match your <i>{{selectedFilter.displayText}}</i> filter criteria.\r\n                </div>\r\n                <div ng-if="!search.text && selectedFilter.restrictCommentsToLast24Hours">\r\n                    No articles with recent comments.\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//readingItems.html','<div class="reading-inner-body">\n    <div class="row">\n        <alerts watch-for="reading-alerts"></alerts>\n    </div>\n    <spinner ng-show="fetching"></spinner>\n    <div ng-hide="fetching" class="position-relative" infinite-scroll="fetchPage()" infinite-scroll-distance="1" infinite-scroll-disabled="isLastPage">\n        <div class="reading-item-magazine" ng-repeat="item in items">\n            <div class="row">\n                <div class="col-md-1" style="padding-right: 0;">\n                    <h9 class="muted" am-time-ago="item.publishedDate" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{item.publishedDate | date : \'medium\'}}"></h9>\n                </div>\n                <div class="col-md-8" style="padding-left: 0;">\n                    <div class="media-body">\n                        <div class="pad-left-right">\n                            <h4 class="media-heading"><a class="mc-reading-item-link" ng-click="openReadingModal(item)" title="{{item.title}}"><span ng-if="item.attachments.length"><i class="glyphicon glyphicon-paperclip"></i> </span><strong ng-if="!item.readByUser">{{item.title}}</strong><span class="reading-lighweight-item-title" ng-if="item.readByUser">{{item.title}}</span></a></h4>\n                            <p class="reading-magazine-item-description">{{item.shortDescription}}</p>\n                            <ul class="reading-magazine-bylinelist">\n                                <li ng-if="item.streamOriginTitle"><a class="view-stream-detail" ng-click="viewStreamDetailsForId(item.streamOriginId)">{{item.streamOriginTitle}}</a></li>\n                                <li ng-if="item.link !== \'#\'"> &nbsp; - &nbsp;</li>\n                                <li ng-if="item.link !== \'#\'"><a href="{{item.link}}" class="direct-link" target="_blank"><span class="glyphicon glyphicon-link"></span> Direct Link</a></li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <!-- The following two might need backend support -->\n                <div class="col-md-1">\n                    <i class="fa fa-folder-open"></i> 1000\n                </div>\n                <div class="col-md-1">\n                    <i class="fa fa-comments"></i> 808\n                </div>\n                <div class="col-md-1">\n                    <i class="fa fa-share-square-o"></i>\n                </div>\n            </div>\n            <hr>\n        </div>\n    </div>\n    <div ng-show="isLastPage && personalCategory.streams.length > 0" class="row">\n        <div class="col-md-2 col-md-offset-5">\n            <h3 class="text-info text-muted">No More Items</h3>\n        </div>\n    </div>\n    <div ng-show="personalCategories.length === 0" class="row">\n        <div class="col-md-1 col-md-11">\n            <h3 class="text-info">You Are Not Following Any Streams. <a ui-sref="streams">Go Here</a> to Get Started.</h3>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//readingModal.html','<spinner ng-if="readingModal.loading"></spinner>\n<div class="modal-body generic-modal-content" ng-if="!readingModal.loading" ng-keydown="readingModal.keypressCloseModal($event)">\n    <div class="row item">\n        <div class="col-sm-1">\n            <div class="rank rank-large rank-{{::readingModal.item.attentionRank}}"></div>\n        </div>\n        <div class="col-sm-9">\n            <div class="row">\n                <div class="col-md-12">\n                    <ul class="reader-item-info">\n                        <li class="reader-stream-name"><a\n                                ng-click="readingModal.viewStreamDetails(readingModal.item.streamOriginId)">{{::readingModal.item.streamOriginTitle}}</a>\n                        </li>\n                        <li class="reader-author" ng-if="::readingModal.item.author">By {{::readingModal.item.author}}</li>\n                        <li class="reader-date">{{::readingModal.item.publishedDate | amDateFormat:\'MMMM Do YYYY, h:mm a\'}} (<span\n                                class="reader-date" am-time-ago="::readingModal.item.publishedDate"></span>)\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <h1 class="item-title">\n                        <a ng-if="readingModal.userCanRead" ng-click="readingModal.clickThroughTitle(readingModal.item.link)">{{::readingModal.item.title || \'No title\'}}</a>\n                        <span ng-if="!readingModal.userCanRead">{{::readingModal.item.title || \'No title\'}}</span>\n                    </h1>\n                </div>\n            </div>\n        </div>\n        <div class="col-sm-2">\n            <a ng-click="readingModal.closeReadingModal()" id="top-reading-close-button"\n               class="fa fa-times muted pull-right modal-close-x" aria-hidden="true"></a>\n            <help-link ng-click="readingModal.helpClick()" tooltip-placement="bottom" uib-tooltip="Help"\n                       href="http://guide.attensa.com/topic-management#mytopics"></help-link>\n        </div>\n    </div>\n    <div class="row item" id="{{::readingModal.item.id}}">\n        <div class="col-md-1">\n            <h1 ng-show="::readingModal.hasPrev"><a id="prev-item-link" ng-click="readingModal.prevItem()"><i\n                    class="glyphicon glyphicon-chevron-left text-muted" tooltip-placement="top"\n                    tooltip-append-to-body="true" uib-tooltip="Previous Item"></i></a></h1>\n        </div>\n        <div class="col-md-10">\n            <div class="row">\n                <div class="col-md-7" ng-if="::readingModal.item.linkResolverLink || (readingModal.item.link)">\n                    <ul class="reader-item-info">\n                       <li ng-if="readingModal.userCanRead && readingModal.fullTextLinkShouldShow()">\n                            <span ng-if="readingModal.fetchingFullText"><i class="fa fa-spin fa-spinner"></i>&nbsp;</span>\n                            <a ng-click="readingModal.toggleFullArticleText(readingModal.item)">{{readingModal.displayFullText ? \'Hide\' : \'Get\'}} full\n                                article text</a>\n                        </li>\n                        </li>\n                        <li ng-if="readingModal.fullTextError && readingModal.fullTextError === 429">\n                            <a ng-click="readingModal.toggleFullArticleText(readingModal.item)">Too busy. Try full article text again.</a>\n                        </li>\n                        <li ng-if="readingModal.fullTextError && readingModal.fullTextError !== 429">\n                            <span class="text-danger">Unable to fetch article text</span>\n                        </li>\n                        <li ng-if="::readingModal.item.linkResolverLink">\n                            <link-resolver-link item="::readingModal.item" clicked="readingModal.linkResolverLinkClicked()"></link-resolver-link>\n                        </li>\n                    </ul>\n                </div>\n                <div class="col-md-5 navbar reading-modal-icon-bar" ng-if="readingModal.userCanRead">\n                    <span ng-if="readingModal.item.type !== \'TWEET\'" class="navbar-right navbar-text" ng-click="readingModal.additionalOptionsClick()" uib-dropdown\n                        tooltip-placement="right" uib-tooltip="Additional Options">\n                        <a focus-me="readingModal.readingModalFocus" class="dropdown-toggle fa fa-2x fa-bars" style="color: #777;"\n                        data-toggle="dropdown" uib-dropdown-toggle></a>\n                        <ul uib-dropdown-menu>\n                            <li show-with-permission action="MANAGE_ANNOTATIONS" stream-id="readingModal.item.streamId" stream-owner-id="{{readingModal.relatedStreams.source.ownerId}}"><a\n                                    class="add-annotation" ng-click="readingModal.showAddAnnotation()"><i class="fa fa-header"></i> &nbsp; Add Annotation</a></li>\n                            <li><a ng-click="readingModal.print(readingModal.item.id)" target="_blank"><i\n                                    class="fa fa-print"></i> &nbsp; Print</a></li>\n                            <edit-item class="menu-item" \n                                  ng-if="!readingModal.prodRelated && readingModal.streamContext && readingModal.contextStream.type === \'COLLECTION\' && readingModal.relatedStreams.source.type !== \'FACTIVA_SELECT_HTTP\'" \n                                  item="readingModal.item" \n                                  stream="readingModal.contextStream">\n                                <i class="fa fa-edit"></i> &nbsp; Edit Item\n                            </edit-item>\n                            <li ng-if="(readingModal.item.type === \'COPY\' || readingModal.item.type === \'EMAIL\' || readingModal.item.type === \'MANUAL\' || readingModal.item.type === \'SEARCH\') && readingModal.relatedStreams"\n                                show-with-permission action="DELETE_ITEMS" stream-id="readingModal.item.streamId"\n                                stream-owner-id="{{readingModal.relatedStreams.source.ownerId}}"><a ng-click="readingModal.deleteItem(readingModal.item)"><i\n                                    class="fa fa-times-circle"></i> &nbsp; Delete Item</a></li>\n                        </ul>\n                    </span>\n                    <a ng-click="readingModal.toggleBookmark(readingModal.item)" class="fa fa-2x navbar-text navbar-right"\n                        ng-class="readingModal.item.savedByUser ? \'fa-bookmark bookmarked\' : \'fa-bookmark-o\'"\n                        tooltip-placement="top"\n                        uib-tooltip="{{readingModal.item.savedByUser ? \'Remove from saved articles\' : \'Save article\'}}"></a>\n                    <span class="navbar-right navbar-text" ng-show="readingModal.item.attachments.length" uib-dropdown>\n                        <a class="fa fa-2x fa-paperclip" uib-dropdown-toggle></a>\n                        <ul uib-dropdown-menu>\n                            <li ng-repeat="attachment in readingModal.item.attachments">\n                                <a ng-click="readingModal.openAttachment(\'clip-icon\', attachment.location)">{{attachment.fileName}}</a>\n                            </li>\n                        </ul>\n                    </span>\n                    <div class="navbar-right navbar-text" style="margin-top: -5px;">\n                        <share-menu style="color: #777;" class="fa-2x" item="readingModal.item" topic-stream-id="readingModal.item.streamOriginId" view-item-session-uuid="readingModal.viewItemSessionUUID"></share-menu>\n                    </div>\n                </div>\n            </div>\n            <div class="row reading-header-bar"></div>\n            <div class="row calais-tags" ng-if="readingModal.userCanRead">\n                <h4>\n                <span ng-if="!readingModal.tagMultiSelect || !readingModal.selectedTags.length">Select tags to search</span >\n                <a ng-if="readingModal.tagMultiSelect && readingModal.selectedTags.length" ng-click="readingModal.tagSearch(readingModal.selectedTags)">Search tags</a>\n                </h4>\n            </div>                \n            <div class="row calais-tags" ng-if="readingModal.userCanRead && readingModal.topicTags.length > 0">                \n                <collapsible-tag-list\n                          label="{{readingModal.topicTagLabel()}}" \n                          tags="readingModal.topicTags"\n                          tag-clicked="readingModal.calaisTagClicked($tag.tagText)"\n                          tag-multi-select="readingModal.tagMultiSelect"\n                          selected-tags="readingModal.selectedTags"\n                          style="display: inline-block; max-width: 65%;"></collapsible-tag-list>\n            </div>\n            <div class="row calais-tags" ng-if="readingModal.userCanRead && readingModal.entityTags.length > 0">\n                <collapsible-tag-list\n                          label="Entities" \n                          tags="readingModal.entityTags"\n                          tag-clicked="readingModal.calaisTagClicked($tag.tagText)"\n                          tag-multi-select="readingModal.tagMultiSelect"\n                          selected-tags="readingModal.selectedTags"></collapsible-tag-list>\n            </div>\n            <div class="row calais-tags" ng-if="readingModal.userCanRead && readingModal.socialTags.length > 0">\n                <collapsible-tag-list\n                          label="{{readingModal.socialTagLabel()}}"   \n                          tags="readingModal.socialTags"\n                          tag-clicked="readingModal.calaisTagClicked($tag.tagText)"\n                          tag-multi-select="readingModal.tagMultiSelect"\n                          selected-tags="readingModal.selectedTags"></collapsible-tag-list>\n            </div>\n            <div class="row">\n                <div class="col-md-12 item-annotation" ng-show="readingModal.userCanRead && readingModal.newAnnotation"\n                     style="padding: 0; margin-top: 10px;">\n                    <div class="bs-example">\n                        <div ta-text-editor-class="edit-annotation-text form-control"\n                             ta-html-editor-class="edit-annotation-text form-control" text-angular\n                             ta-keep-styles="true"\n                             ta-toolbar="[[\'p\',\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'underline\'],[\'ul\',\'ol\'],[\'justifyLeft\',\'justifyCenter\',\'justifyRight\'],[\'indent\',\'outdent\'],[\'html\',\'insertImage\',\'insertLink\'], [\'backgroundColor\'], [\'foregroundColor\'],[\'fontPicker\'], [\'fontSizePicker\']]"\n                             ng-model="readingModal.annotation.annotationText"></div>\n                    </div>\n                    <div class="highlight">\n                        <div class="clearfix" style="width: 100%; padding-right: 0;">\n                            <div class="btn-group btn-group-xs" uib-dropdown>\n                                <button type="button" style="margin-left: 3px;"\n                                        class="btn btn-default dropdown-toggle annotation-location-dropdown"\n                                        data-toggle="dropdown" uib-dropdown-toggle>\n                                    Location: <span class="annotation-location-label" ng-bind="readingModal.annotation.location"\n                                                    ng-init="readingModal.annotation.location = \'Above\'"></span> <span\n                                        class="caret"></span>\n                                </button>\n                                <ul class="dropdown-menu" role="menu">\n                                    <li><a class="annotation-above"\n                                           ng-click="readingModal.annotation.location = \'Above\'">Above</a></li>\n                                    <li><a class="annotation-below"\n                                           ng-click="readingModal.annotation.location = \'Below\'">Below</a></li>\n                                </ul>\n                            </div>\n                            <button type="button" style="margin-left: 3px;"\n                                    class="save-annotation btn btn-default btn-xs pull-right"\n                                    ng-click="readingModal.postAnnotation()"\n                                    ng-disabled="readingModal.newAnnotationSaveText === \'Saving...\' || newAnnotationForm.$invalid">{{readingModal.newAnnotationSaveText}}</button>\n                            <button type="button" style="margin-left: 3px;"\n                                    class="cancel-annotation btn btn-default btn-xs pull-right"\n                                    ng-click="readingModal.cancelAddAnnotation()">Cancel\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row" id="top-edit-annotation-container">\n                <div class="col-md-12 item-annotations" ng-if="readingModal.item.annotations"\n                     ng-repeat="annotation in readingModal.item.annotations">\n                    <div ng-if="annotation.location === \'Above\'">\n                        <ng-include src="\'/templates/annotations.html\'"></ng-include>\n                    </div>\n                </div>\n            </div>\n            <div class="row" ng-if="readingModal.item.logoUrl">\n                <div class="col-md-offset-7 col-md-5">\n                    <img ng-src="{{readingModal.item.logoUrl}}" class="logo-image">\n                </div>\n            </div>\n            <div class="row" ng-if="!readingModal.userCanRead">\n                    <div class="reading-item-magazine" ng-if="!readingModal.prodSource">\n                        <span class="fa fa-exclamation-triangle" style="color: red; font-size: 6vh"></span><h3 style="margin-top:0px;padding-left: 25px; display: inline-block;">Permission Required</h3>\n                        <br>You do not have permission to read the content of this topic. Please contact your site administrator.                        \n                    </div>\n                    <div class="reading-item-magazine" ng-if="readingModal.prodSource">\n                        <span class="fa fa-exclamation-triangle" style="color: red; font-size: 6vh"></span><h3 style="margin-top:0px;padding-left: 25px; display: inline-block;">Permission Required</h3>\n                        <br><div>You must register to read {{readingModal.prodSource.title}}. <follow-button stream="readingModal.prodSource" user="readingModal.user" type="stream"></follow-button></div>                        \n                    </div>\n            </div>\n            <div class="row" ng-if="readingModal.userCanRead">\n                <div class="col-md-12 item-content" ng-bind-html="readingModal.trustedDescription"\n                     ng-if="!readingModal.isTweet && !readingModal.displayFullText" ng-click="readingModal.articleClick($event)"></div>\n                <div class="col-md-12 item-content" ng-bind-html="readingModal.fullTextDescription"\n                     ng-if="!readingModal.isTweet && readingModal.displayFullText" ng-click="readingModal.articleClick($event)"></div>\n                <div class="col-md-12" ng-bind-html="readingModal.oembed" ng-if="readingModal.isTweet" ng-click="readingModal.articleClick($event)"></div>\n            </div>\n            <div class="row">\n                <div class="col-md-12 item-annotations" ng-if="readingModal.item.annotations"\n                     ng-repeat="annotation in readingModal.item.annotations">\n                    <div ng-if="annotation.location === \'Below\'">\n                        <ng-include src="\'/templates/annotations.html\'"></ng-include>\n                    </div>\n                </div>\n            </div>\n            <div class="row" ng-if="readingModal.userCanRead">\n                <div class="col-md-12" ng-if="readingModal.moreLikeThis.length !== 0">\n                    <h4 class="mlt-header">More Like This</h4>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <table class="table">\n                                <tr ng-repeat="mltItem in readingModal.moreLikeThis">\n                                    <td class="more-like-this-cell">\n                                        <a class="more-like-this-link" ng-bind="mltItem.title"\n                                           ng-click="readingModal.gotoNewItem(mltItem)"></a>\n                                    </td>\n                                    <td class="rich-list-item-seg align-right muted reading-item-list-date"\n                                        am-time-ago="mltItem.publishedDate"></td>\n                                </tr>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-show="readingModal.userCanRead && !readingModal.disableComments" class="row">\n                <div class="col-md-12">\n                    <h4 class="comment-header"><span class="comment-count" ng-bind="readingModal.item.comments.length"></span>\n                        Comment<span ng-show="readingModal.item.comments.length > 1">s</span></h4>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="well comment-well" ng-form="commentInput">\n                                <div class="comment-placeholder" ng-click="readingModal.addComment(\'leave_comment\')"\n                                     ng-hide="readingModal.addingComment">\n                                    Leave a comment..\n                                </div>\n                                <textarea class=\'comment-textarea\' name=\'comment-input\' ng-show="readingModal.addingComment"\n                                          ng-model="readingModal.newComment" focus-me="readingModal.startAddingComment" ng-minlength="1"\n                                          required></textarea>\n                            </div>\n                            <button type="button" class="post-comment-button btn btn-default btn-sm pull-right"\n                                    ng-show="readingModal.addingComment" ng-click="readingModal.postComment()"\n                                    ng-disabled="readingModal.newCommentSaveText === \'Saving...\' || commentInput.$invalid">{{readingModal.newCommentSaveText}}</button>\n                            <button type="button" class="cancel-comment-button btn btn-default btn-sm pull-right"\n                                    ng-show="readingModal.addingComment" ng-click="readingModal.cancelAddComment()">Cancel\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-show="readingModal.userCanRead && !readingModal.disableComments" class="row comment-section">\n                <div class="col-md-12">\n                    <ul class="comment-list">\n                        <li class="comment-li" ng-repeat="comment in readingModal.item.comments | limitTo: readingModal.commentLimit">\n                            <div class="thumbnail-container">\n                                <div class="comment-thumbnail"\n                                     ng-style="if(!comment.thumbnail.thumbnailImageAttachmentId)">\n                                    <span ng-if="comment.thumbnail.thumbnailImageAttachmentId" aria-hidden="true"\n                                          class="icon comment-profile-image"\n                                          ng-style="{ \'background-image\':\'url(\' + readingModal.s3Url + comment.thumbnail.thumbnailImageAttachmentId + \')\' }"></span>\n                                    <span ng-if="!comment.thumbnail.thumbnailImageAttachmentId" aria-hidden="true"\n                                          class="icon">{{readingModal.initials(comment.userFullName)}}</span>\n                                </div>\n                            </div>\n                            <div class="comment-container">\n                                <div class="comment-namedate">\n                                    {{comment.userFullName}}\n                                    <span class="comment-date" am-time-ago="comment.created"></span>\n                                    <span show-with-permission user-id="comment.userId" class="comment-edit"\n                                          ng-click="comment.editing = true; readingModal.startEditingComment = true;">Edit</span>\n                                    <span show-with-permission action="DELETE_COMMENTS" stream-id="readingModal.item.streamId"\n                                          user-id="comment.userId" class="comment-delete"\n                                          ng-click="readingModal.deleteComment(readingModal.item.id, comment.id)">Delete</span>\n                                </div>\n                                <div class="comment-body" ng-show="!comment.editing">{{comment.body}}</div>\n                                <div class=\'well comment-well\' ng-show="comment.editing" ng-form="editCommentInput">\n                                    <textarea class=\'comment-textarea\' name=\'comment-input\'\n                                              ng-model="comment.editedBody" focus-me="readingModal.startEditingComment"\n                                              ng-init="comment.editedBody = comment.body" ng-minlength="1"\n                                              required></textarea>\n                                </div>\n                                <button type="button" ng-show="comment.editing"\n                                        ng-click="readingModal.editComment(readingModal.item.id, comment)"\n                                        ng-disabled="readingModal.editCommentSaveText === \'Saving...\' || editCommentInput.$invalid"\n                                        class="edit-comment-button btn btn-default btn-sm pull-right">{{readingModal.editCommentSaveText}}</button>\n                                <button type="button" ng-show="comment.editing" ng-click="comment.editing = false"\n                                        class="cancel-edit-comment-button btn btn-default btn-sm pull-right">Cancel\n                                </button>\n                            </div>\n                            <br style="clear:both;"/>\n                        </li>\n                    </ul>\n                    <a ng-if="readingModal.item.comments.length > readingModal.commentLimit"\n                       ng-click="readingModal.commentLimit = readingModal.item.comments.length">View All</a>\n                </div>\n            </div>\n            <div ng-if="readingModal.userCanRead" class="row attachment-section">\n                <div class="col-md-12">\n                    <h3 ng-show="readingModal.item.attachments.length">Attachments</h3>\n                    <ul class="attachment-list">\n                        <li class="attachment-li mc-attachment-li" ng-repeat="attachment in readingModal.item.attachments">\n                            <a ng-click="readingModal.openAttachment(\'article-bottom\', attachment.location)">{{attachment.fileName}}</a>\n                            <a ng-if="readingModal.item.type === \'MANUAL\' && !attachment.uploadInProgress"\n                               ng-click="readingModal.deleteAttachment(attachment)"><i\n                                    ng-class="attachment.deleting ? \'fa-spinner fa-spin\' : \'fa-times-circle\'"\n                                    class="fa text-danger"></i></a><i ng-if="attachment.uploadInProgress"\n                                                                      class="fa fa-spinner fa-spin"></i>\n                        </li>\n                    </ul>\n                    <s3-upload ng-if="readingModal.item.type === \'MANUAL\'" button-text="Add Attachments"></s3-upload>\n                </div>\n            </div>\n        </div>\n        <div class="col-md-1">\n            <h1 ng-show="readingModal.hasNext"><a id="next-item-link" ng-click="readingModal.nextItem()"><i\n                    class="glyphicon glyphicon-chevron-right text-muted" tooltip-placement="top"\n                    tooltip-append-to-body="true" uib-tooltip="Next Item"></i></a></h1>\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button type="button" class="btn btn-default sub-modal-cancel" ng-click="readingModal.closeReadingModal()">Close</button>\n</div>');
$templateCache.put('/templates//readingRouter.html','<spinner></spinner>');
$templateCache.put('/templates//readingSearchSidebar.html','<div class="reading-search" full-height>\n    <div ng-controller="ReadingSearchCtrl">\n        <div class="reading-menu-category reading-search-top row">\n            <div class="col-md-2">\n                <a class="btn" ng-click="resetSearch()">\n                    <i class="glyphicon glyphicon-chevron-left"></i>\n                </a>\n            </div>\n        </div>\n        <div class="row row-pad-top">\n            <div class="col-md-offset-1 col-md-11">\n                <label>Search In:</label>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-offset-1 col-md-11">\n                <ul class="nav">\n                    <li class="dropdown" uib-dropdown auto-close="outsideClick" is-open="isOpen">\n                        <span>\n                            <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle mouseleave-me ng-click="start(isOpen)">\n                                <div class="search-segmentation-label pull-left" title="{{segmentationLabel()}}">{{segmentationLabel()}}</div>\n                                <span class="caret"></span>\n                            </button>\n                        </span>\n                        <div class="dropdown-menu search-within-menu">\n                            <div class="row">\n                                <div class="col-md-12 search-filter-title">\n                                    Search Within:\n                                </div>\n                            </div>\n                            <!-- All  the things -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'all\'})" ng-value="\'all\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <span class="search-menu-label-unexpandable">All Catalogs</span>\n                                </div>\n                            </div>\n                            <!-- /All  the things -->\n                            <!-- Most popular -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'mostPopular\', query: \'popularity\'})" ng-value="\'mostPopular\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <span class="search-menu-label-unexpandable">Most Popular</span>\n                                </div>\n                            </div>\n                            <!-- /Most popular -->\n                            <!-- Most Relevant -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'mostRelevant\', query: \'attentionRank\'})" ng-value="\'mostRelevant\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <span class="search-menu-label-unexpandable">Recommended</span>\n                                </div>\n                            </div>\n                            <!-- /Most Relevant -->\n                            <!-- Saved -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'saved\'})" ng-value="\'saved\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <span class="search-menu-label-unexpandable">Saved</span>\n                                </div>\n                            </div>\n                            <!-- /Saved -->\n                            <!-- Personal Categories -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'personalCategories\'})" ng-value="\'personalCategories\'">\n                                </div>\n                                <div class="col-md-10">\n                                    <a ng-click="searchMenuState.personalCategoriesExpanded = !searchMenuState.personalCategoriesExpanded; $event.stopPropagation();">\n                                        <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.personalCategoriesExpanded,\n                                                                           \'glyphicon-triangle-right\': !searchMenuState.personalCategoriesExpanded}"></span>\n                                    </a>\n                                    <span class="search-menu-label">{{readingMenuLabel}}</span>\n                                </div>\n                            </div>\n                            <span ng-show="searchMenuState.personalCategoriesExpanded">\n                                <span ng-repeat="personalCategory in personalCategories | orderBy: orderLabel">\n                                    <div class="row selection-row">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'personalCategory\', id: personalCategory.id })" ng-value="\'personalCategory-\' + personalCategory.id">\n                                        </div>\n                                        <div class="col-md-offset-1 col-md-9">\n                                            <a ng-click="searchMenuState.personalCategoryExpandedMap[personalCategory.id] = !searchMenuState.personalCategoryExpandedMap[personalCategory.id]; $event.stopPropagation();">\n                                                <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.personalCategoryExpandedMap[personalCategory.id],\n                                                                                   \'glyphicon-triangle-right\': !searchMenuState.personalCategoryExpandedMap[personalCategory.id]}"></span>\n                                            </a>\n                                            {{personalCategory.title}}\n                                        </div>\n                                    </div>\n                                    <span ng-show="searchMenuState.personalCategoryExpandedMap[personalCategory.id]">\n                                        <span ng-repeat="stream in personalCategory.streams | orderBy:\'title\'">\n                                            <div class="row selection-row">\n                                                <div class="col-md-1">\n                                                    <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'stream\', id: stream.id })" ng-value="\'stream-\' + stream.id">\n                                                </div>\n                                                <div class="col-md-offset-2 col-md-8">\n                                                    {{stream.title}}\n                                                </div>\n                                            </div>\n                                        </span>\n                                    </span>\n                                </span>\n                            </span>\n                            <!-- /Personal Categories -->\n                            <!-- Tenant -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline"ng-model="search.segmentKey" ng-change="selectSegment({segment: \'taxonomy\'})" ng-value="\'taxonomy\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <a ng-click="searchMenuState.categoriesExpanded = !searchMenuState.categoriesExpanded; $event.stopPropagation();">\n                                        <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.categoriesExpanded,\n                                                                           \'glyphicon-triangle-right\': !searchMenuState.categoriesExpanded}"></span>\n                                    </a>\n                                    <span class="search-menu-label">{{tenantCategoriesName}}</span>\n                                </div>\n                            </div>\n                            <span ng-show="searchMenuState.categoriesExpanded">\n                                <span ng-repeat="category in taxonomy">\n                                    <div class="row selection-row">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline"ng-model="search.segmentKey" ng-change="selectSegment({segment: \'taxonomyCategory\', id: category.id })" ng-value="\'taxonomyCategory-\' + category.id">\n                                        </div>\n                                        <div class="col-md-offset-1 col-md-8">\n                                            <a ng-show="category.subcategories.length" ng-click="searchMenuState.categoryExpandedMap[category.id] = !searchMenuState.categoryExpandedMap[category.id]; $event.stopPropagation();">\n                                                <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.categoryExpandedMap[category.id],\n                                                                                   \'glyphicon-triangle-right\': !searchMenuState.categoryExpandedMap[category.id]}"></span>\n                                            </a>\n                                            <span ng-class="{\'search-menu-label\': category.subcategories.length, \'search-menu-label-unexpandable\': !category.subcategories.length}">{{category.title}}</span>\n                                        </div>\n                                    </div>\n                                    <div class="row selection-row" ng-repeat="subcategory in category.subcategories" ng-show="searchMenuState.categoryExpandedMap[category.id]">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline" ng-model="search.segmentKey" ng-change="selectSegment({segment: \'taxonomyCategory\', id: subcategory.id })" ng-value="\'taxonomyCategory-\' + subcategory.id">\n                                        </div>\n                                        <div class="col-md-offset-2 col-md-8">\n                                            <span class="search-menu-label">{{subcategory.title}}</span>\n                                        </div>\n                                    </div>\n                                </span>\n                            </span>\n                            <!-- /Tenant -->\n                            <!-- Catalog -->\n                            <span ng-repeat="catalog in catalogMap">\n                                <div class="row selection-row">\n                                    <div class="col-md-1">\n                                        <input type="radio" class="radio inline"ng-model="search.segmentKey" ng-change="selectSegment({segment: \'catalog\', id: catalog.catalogId })" ng-value="\'catalog-\' + catalog.catalogId">\n                                    </div>\n                                    <div class="col-md-9">\n                                        <a ng-click="searchMenuState.catalogExpandedMap[catalog.catalogId] = !searchMenuState.catalogExpandedMap[catalog.catalogId]; $event.stopPropagation();">\n                                            <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.catalogExpandedMap[catalog.catalogId],\n                                                                               \'glyphicon-triangle-right\': !searchMenuState.catalogExpandedMap[catalog.catalogId]}"></span>\n                                        </a>\n                                        <span class="search-menu-label">{{catalog.label}}</span>\n                                    </div>\n                                </div>\n                                <span ng-repeat="category in catalogTaxonomy[catalog.catalogId]" ng-show="searchMenuState.catalogExpandedMap[catalog.catalogId]">\n                                    <div class="row selection-row">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline"ng-model="search.segmentKey" ng-change="selectSegment({segment: \'catalogCategory\', catalogId: catalog.catalogId, id: category.id})" ng-value="\'catalogCategory-\' + catalog.catalogId + \'-\' + category.id">\n                                        </div>\n                                        <div class="col-md-offset-1 col-md-9">\n                                            <a ng-show="category.subcategories.length" ng-click="searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id] = !searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id]; $event.stopPropagation();">\n                                                <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id],\n                                                                                   \'glyphicon-triangle-right\': !searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id]}"></span>\n                                            </a>\n                                            <span ng-class="{\'search-menu-label\': category.subcategories.length, \'search-menu-label-unexpandable\': !category.subcategories.length}">{{category.title}}</span>\n                                        </div>\n                                    </div>\n                                    <div class="row selection-row" ng-repeat="subcategory in category.subcategories" ng-show="searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id]">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline"ng-model="search.segmentKey" ng-change="selectSegment({segment: \'catalogCategory\', catalogId: catalog.catalogId, id: subcategory.id})" ng-value="\'catalogCategory-\' + catalog.catalogId + \'-\' + subcategory.id">\n                                        </div>\n                                        <div class="col-md-offset-2 col-md-7">\n                                            <span class="search-menu-label">{{subcategory.title}}</span>\n                                        </div>\n                                    </div>\n                                </span>\n                            </span>\n                            <!-- /Catalog -->\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class="row row-pad-top">\n            <div class="col-md-offset-1 col-md-11">\n                <label>With the query:</label>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-offset-1 col-md-11">\n                <textarea class="search-control" ng-model="search.text" ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }">\n                </textarea>\n            </div>\n        </div>\n        <div class="row row-pad-top">\n            <div class="col-md-offset-1 col-md-11">\n                <label>Tagged with:</label>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-offset-1 col-md-11">\n                <input class="search-control" type="text" ng-model="search.tags" on-delayed-change="performSearch(\'relevance\')">\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//readingSidebar.html','<div title="Most Popular" class="row reading-menu reading-menu-top-level" ng-class="{\'bg-info\': selectedQuery === \'popularity\', \'reading-menu-top-level-unselected\': selectedQuery !== \'popularity\'}">\r\n    <div class="col-md-12">\r\n        <h5 class="text-primary">\r\n            <span class="fa fa-fire"></span>&nbsp;&nbsp;<a ng-click="selectQuery(\'popularity\')">Most Popular</a>\r\n        </h5>\r\n    </div>\r\n</div>\r\n<div title="Recommended" class="row reading-menu reading-menu-top-level" ng-class="{\'bg-info\': selectedQuery === \'attentionRank\', \'reading-menu-top-level-unselected\': selectedQuery !== \'attentionRank\'}">\r\n    <div class="col-md-12">\r\n        <h5 class="text-primary">\r\n            <span class="fa fa-lightbulb-o"></span>&nbsp;&nbsp;<a ng-click="selectQuery(\'attentionRank\')">Recommended</a>\r\n        </h5>\r\n    </div>\r\n</div>\r\n<div title="Saved Articles" class="row reading-menu reading-menu-top-level" ng-class="{\'bg-info\': bookmarksSelected, \'reading-menu-top-level-unselected\': !bookmarksSelected}">\r\n    <div class="col-md-12">\r\n        <h5 class="text-primary">\r\n            <span class="fa fa-bookmark"></span>&nbsp;&nbsp;<a ng-click="selectBookmarks()">Saved</a>\r\n        </h5>\r\n    </div>\r\n</div>\r\n<div class="row reading-menu reading-menu-top-level" title="All" ng-class="{\'bg-info\': !selectedCategory && !selectedStream.id && !selectedQuery && !bookmarksSelected, \'reading-menu-top-level-unselected\': selectedCategory || selectedStream.id || selectedQuery || bookmarksSelected}">\r\n    <div class="col-md-12">\r\n        <h5 class="text-primary"><a ng-click="selectAll()">{{readingMenuLabel}}</a></h5>\r\n    </div>\r\n</div>\r\n<div ui-tree data-drag-enabled="false" data-empty-placeholder-enabled="false">\r\n    <ol ui-tree-nodes="" ng-model="personalCategories">\r\n        <li ng-repeat="personalCategory in personalCategories | orderBy: orderLabel" ng-show="personalCategory.streams.length" title="{{personalCategory.title}}" class="reading-menu-category" ui-tree-node>\r\n        <div ng-show="!personalCategory.editing" class="row" ng-class="{\'bg-info\': personalCategory.id === selectedCategory}">\r\n            <div class="col-md-10 col-xs-10">\r\n                <h5 class="personal-category-item text-primary overflow-ellipsis">\r\n                    <a class="glyphicon" ng-class="isMenuExpanded(personalCategory) ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-right\'" ng-click="toggleCategoryExpansion(personalCategory)"></a>\r\n                    &nbsp; <a ng-click="selectCategory(personalCategory)">{{personalCategory.title}}</a>\r\n                </h5>\r\n            </div>\r\n            <div class="col-md-2 col-xs-2">\r\n                <span class="pull-right reading-menu-action-toggle" uib-dropdown ng-hide="personalCategory.id === \'Uncategorized\'">\r\n                    <a class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="true" uib-dropdown-toggle>\r\n                        <span class="fa fa-ellipsis-v text-primary"></span>\r\n                    </a>\r\n                    <ul class="dropdown-menu right-inherit" role="menu">\r\n                        <li>\r\n                            <a ng-click="toggleEdit(personalCategory)">Edit Category</a>\r\n                        </li>\r\n                        <li>\r\n                            <a ng-click="deleteCategory(personalCategory)">Delete Category</a>\r\n                        </li>\r\n                    </ul>\r\n                </span>\r\n            </div>\r\n        </div>\r\n        <div ng-show="personalCategory.editing" class="row">\r\n            <div class="col-md-12">\r\n                <form name="form" ng-submit="editCategory(personalCategory)">\r\n                    <div class="btn-group right-absolute-offset">\r\n                       <a class="btn btn-mini btn-success" ng-click="editCategory(personalCategory)"><i class="fa fa-check"></i></a>\r\n                       <a class="btn btn-mini btn-danger" ng-click="toggleEdit(personalCategory)"><i class="fa fa-times"></i></a>\r\n                   </div>\r\n                    <input class="edit-category" type="text" name="category title" ng-model="personalCategory.newTitle" placeholder="Category Name" focus-me="personalCategory.startEditingCategory" ng-change="checkUniquePersonalCategories(personalCategory)">\r\n                    <div class="has-error">\r\n                        <small ng-if="personalCategory.hasError" class="help-block">Category already exists.</small>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n        <ol ui-tree-nodes="" ng-model="personalCategory.streams" ng-show="isMenuExpanded(personalCategory)">\r\n            <li class="row reading-menu-stream-row"\r\n                 ng-repeat="stream in personalCategory.streams | orderBy:\'title\'"\r\n                 title="{{::stream.title}}"\r\n                 ng-class="{\'bg-info\': stream.id === selectedStream.id}"\r\n                 ui-tree-node>\r\n                <div class="col-md-11 col-md-offset-1 clearfix">\r\n                    <a scrollup ng-click="selectStream(stream)" class="sidebar-nowrap-title text-primary cursor-pointer">\r\n                        {{::stream.title}}\r\n                    </a>\r\n                    <div class="dropdown right-absolute reading-menu-action-toggle" uib-dropdown>\r\n                        <a class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="true" uib-dropdown-toggle>\r\n                            <span class="fa fa-ellipsis-v text-primary"></span>\r\n                        </a>\r\n                        <ul class="dropdown-menu" role="menu">\r\n                            <li>\r\n                                <a ng-click="viewStreamDetails(stream)">View Stream Details</a>\r\n                            </li>\r\n                            <li class="divider"></li>\r\n                            <li ng-if="personalCategory.id === \'Uncategorized\'">\r\n                                <a ng-click="addToCategory(stream)">Add to Category</a>\r\n                            </li>\r\n                            <li ng-if="personalCategory.id !== \'Uncategorized\'">\r\n                                <a ng-click="removeFromCategory(stream, $index, personalCategory)">Remove from Category</a>\r\n                            </li>\r\n                            <li>\r\n                                <a ng-hide="stream.userSubscriptionIsRestricted" ng-click="unsubscribe(stream, $index, personalCategory)">Unfollow</a>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </li>\r\n        </ol>\r\n        </li>\r\n    </ol>\r\n</div>\r\n');
$templateCache.put('/templates//readingTaxonomySidebar.html','<div class="well well-sm taxonomy">\n    <div class="row">\n        <div ng-click="selectMyStreams()" class="col-md-12 cursor-pointer">\n            <h5 class="text-primary">\n                <icon class="glyphicon glyphicon-user"></icon> &nbsp; My Streams\n            </h5>\n            <hr style="margin: 0px;">\n            <div class="row">\n                 <div ng-click="selectAll()" class="col-md-11 col-md-offset-1 cursor-pointer">\n                    <h5 class="text-primary">\n                        <icon class="glyphicon glyphicon-chevron-right"></icon> &nbsp; All\n                    </h5>\n                </div>\n            </div>\n            <hr style="margin: 0px;">\n            <!-- Placeholder -->\n            <div class="row">\n                 <div ng-click="selectTaxonomy()" class="col-md-11 col-md-offset-1 cursor-pointer">\n                    <h5 class="text-primary">\n                        <icon class="glyphicon" ng-class="{\'glyphicon-chevron-down\': isCollapsed, \'glyphicon-chevron-right\': !isCollapsed}" ng-click="isCollapsed = !isCollapsed"></icon> &nbsp; Tech Blogs\n                    </h5>\n                    <div uib-collapse="!isCollapsed" class="row">\n                        <div ng-click="selectTax()" class="col-md-10 col-md-offset-2">\n                            <h5 class="text-primary">\n                                Categories here be\n                            </h5>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row" ng-repeat="categories in taxonomy">\n                 <div ng-click="selectTaxonomy(categories)" class="col-md-11 col-md-offset-1 cursor-pointer">\n                    <h5 class="text-primary overflow-ellipsis">\n                        <icon class="glyphicon" ng-class="{\'glyphicon-chevron-down\': category.isCollapsed, \'glyphicon-chevron-right\': !category.isCollapsed}" ng-click="category.isCollapsed = !category.isCollapsed"></icon> &nbsp; {{categories.title}}\n                    </h5>\n                    <div uib-collapse="!category.isCollapsed" class="row">\n                        <!-- ng-repeat here on category streams -->\n                        <div class="col-md-10 col-md-offset-2">\n                            <h5 class="text-primary overflow-ellipsis" ng-click="selectStream(stream, category)">\n                                Uncategorized streams here\n                            </h5>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <hr style="margin: 0px;">\n        </div>\n        <div ng-click="selectAll()" class="col-md-12 cursor-pointer">\n            <h5 class="text-primary">\n                <icon class="glyphicon glyphicon-home"></icon> &nbsp; Tenant Company\n            </h5>\n        </div>\n        <hr style="margin: 0px;">\n    </div>\n</div>\n');
$templateCache.put('/templates//register.html','<div class="content-profile editor">\n    <div class="container">\n        <div class="white-container" ng-controller="RegisterCtrl as register">\n            <div ng-hide="register.invalidCode || !register.invitationCode">\n                <div class="page-header" style="margin-top: 15px;">\n                    <h2 style="margin: 0 0 5px;">Welcome to Attensa</h2>\n                </div>\n                <form id="userForm" name="form" role="form" enctype="multipart/form-data">\n                    <div id="invalidFormWarning" class="row" ng-show="form.$invalid">\n                        <div class="alert alert-warning alert-dismissible" role="alert">{{register.generalMessageForErrors(form.$error)}}</div>\n                    </div>\n                    <div class="row">\n                        <div class="col-lg-12">\n                            <div class="row">\n                                <div class="form-group col-lg-4 has-feedback" style="height: 70px;">\n                                    <label for="firstName">First Name</label>\n                                    <div class="has-feedback" ng-messages="form.firstName.$error">\n                                        <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                                        <div ng-if="form.firstName.$valid" class="form-control-feedback glyphicon glyphicon-ok" id="first-name-ok"></div>\n                                    </div>\n                                    <input type="text" class="form-control" id="firstName" name="firstName" placeholder="First Name" ng-model="register.user.firstName" style="padding-right: 40px;" required>\n                                    <div ng-if="form.firstName.$touched">\n                                        <div class="has-error" ng-messages="form.firstName.$error">\n                                            <small class="help-block" ng-message="required">First name is required and cannot be empty</small>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <div class="form-group col-lg-3" style="height: 70px;">\n                                    <label for="middleName">Middle Name</label>\n                                    <input type="text" class="form-control" id="middleName" name="middleName"placeholder="Middle Name" ng-model="register.user.middleName" style="padding-right: 40px;">\n                                </div>\n\n                                <div class="form-group col-lg-4  has-feedback" style="height: 70px;">\n                                    <label for="lastName">Last Name</label>\n                                    <div class="has-feedback" ng-messages="form.lastName.$error">\n                                        <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                                        <div ng-if="form.lastName.$valid" class="form-control-feedback glyphicon glyphicon-ok" id="last-name-ok"></div>\n                                    </div>\n                                    <input type="text" class="form-control" id="lastName" name="lastName" placeholder="Last Name" ng-model="register.user.lastName" style="padding-right: 40px;" required>\n                                    <div ng-if="form.lastName.$touched">\n                                        <div class="has-error" ng-messages="form.lastName.$error">\n                                            <small class="help-block" ng-message="required">Last name is required and cannot be empty</small>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <div class="form-group col-lg-1" style="height: 70px;">\n                                    <label for="suffix">Suffix</label>\n                                    <input type="text" class="form-control" id="suffix" name="suffix" placeholder="Suffix" ng-model="register.user.suffix">\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="form-group col-lg-6 has-feedback" style="height: 80px;">\n                                    <label for="password">Password</label>\n                                    <div class="has-feedback" ng-messages="form.password.$error">\n                                        <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk" id="pass-require-glyph"></div>\n                                        <div ng-message="minlength" class="form-control-feedback glyphicon glyphicon-ban-circle" id="pass-min-glyph"></div>\n                                        <div ng-message="passwordCharacters" class="form-control-feedback glyphicon glyphicon-ban-circle" id="pass-chars-glyph"></div>\n                                        <div ng-if="form.password.$valid" class="form-control-feedback glyphicon glyphicon-ok" id="pass-ok-glyph"></div>\n                                    </div>\n                                    <input type="password" class="form-control" id="password" autocomplete="off" name="password" minlength="8" placeholder="Password" ng-model="register.user.password" style="padding-right: 40px;" validate-password="register.user.confirmPassword" required>\n                                    <div ng-if="form.password.$touched">\n                                        <div class="has-error" ng-messages="form.password.$error">\n                                            <small class="help-block" ng-message="required">Password is required and cannot be empty</small>\n                                            <small class="help-block" ng-message="minlength">Your password must be longer than 8 characters</small>\n                                            <small class="help-block" ng-message="passwordCharacters">Your password must have at least one number, one uppercase, and one lowercase letter</small>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <div class="form-group col-lg-6 has-feedback" style="height: 70px;">\n                                    <label for="confirmPassword">Confirm Password</label>\n                                    <div class="has-feedback" ng-messages="form.confirmPassword.$error">\n                                        <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk" id="pass-confirm-require-glyph"></div>\n                                        <div ng-message="match" class="form-control-feedback glyphicon glyphicon-ban-circle" id="pass-match-glyph"></div>\n                                        <div ng-if="form.confirmPassword.$valid && form.password.$valid" class="form-control-feedback glyphicon glyphicon-ok" id="pass-confirm-ok-glyph"></div>\n                                    </div>\n                                    <input type="password" class="form-control" id="confirmPassword" autocomplete="off" name="confirmPassword" placeholder="Confirm Password" ng-model="register.user.confirmPassword" style="padding-right: 40px;" match-to-validator required>\n                                    <div ng-if="form.confirmPassword.$touched">\n                                        <div class="has-error" ng-messages="form.confirmPassword.$error">\n                                            <small class="help-block" ng-message="required">Please fill both passwords</small>\n                                            <small class="help-block" ng-message="match">The passwords do not match</small>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="form-group col-lg-12  has-feedback" style="height: 70px;">\n                                    <label for="emailAddress">Email Address</label>\n                                    <input type="email" class="form-control" id="emailAddress" name="emailAddress" placeholder="Email Address" ng-model="register.user.emailAddress" type="email" disabled="disabled" style="padding-right: 40px;" required>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class="form-group pane-controls">\n                            <div class="navbar-right">\n                                <div class="pull-right">\n                                    <button type="submit" class="btn btn-primary" ng-click="register.saveUser()" ng-disabled="form.$invalid || register.saveText === register.savingText">{{register.saveText}}</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div ng-show="register.invalidCode" style="text-align: center; font-size: 32px; color: red; padding-top: 25px;">\n                Your invitation is no longer valid. Please request a new invitation from your system administrator.\n            </div>\n            <div ng-show="!register.invitationCode" style="text-align: center; font-size: 32px; color: red; padding-top: 25px;">\n                You need an invitation code in order to register. Please contact your system administrator.\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//resetPassword.html','<div class="container" ng-controller="LoginCtrl as login">\n    <div class="row">\n        <div class="col-md-6 col-md-offset-3">\n            <div class="alert alert-danger" role="alert" ng-show="form.$error.match || form.$error.passwordCharacters || form.$error.minlength" ng-messages="form.$error">\n                <div ng-message="minlength">\n                    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>\n                    <span class="sr-only">Error:</span>\n                    Your password must be longer than 8 characters\n                </div>\n                <div ng-message="passwordCharacters">\n                    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>\n                    <span class="sr-only">Error:</span>\n                    Your password must have at least one number, one uppercase, and one lowercase letter\n                </div>\n                <div ng-message="match">\n                    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>\n                    <span class="sr-only">Error:</span>\n                    Your passwords do not match\n                </div>\n            </div>\n            <div class="well">\n                <div style="margin-top:10px;text-align:center;" class="header-logo-inline">\n                    <a ui-sref="login"><img alt="Attensa" style="max-height: 100px;" logo/></a>\n                </div>\n                <div id="login-error-box" class="" style="padding-top: 20px;"></div>\n                <form class="form-signin" name="form" role="form" enctype="multipart/form-data">\n                    <div class="input-group password-input-group">\n                        <span class="input-group-addon user-password-addon">\n                            <span class="glyphicon glyphicon-lock"></span>\n                        </span>\n                        <input type="password" autocomplete="off" class="form-control" minlength="8" placeholder="New Password" ng-model="login.user.password" ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 } }" validate-password="user.confirmPassword" required>\n                    </div>\n                    <div class="input-group password-input-group">\n                        <span class="input-group-addon user-password-addon">\n                            <span class="glyphicon glyphicon-lock"></span>\n                        </span>\n                        <input name="confirmPassword" type="password" autocomplete="off" class="form-control" minlength="8" ng-model="login.user.confirmPassword" ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 } }" placeholder="Confirm Password" match-to-validator required>\n                    </div>\n                    <button class="btn btn-lg btn-default btn-block" ng-disabled="login.resetDisabled()" ng-click="login.resetPassword()">{{login.buttonText}}</button>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//s3Upload-button.html','<div>\n    <div ng-repeat="file in files" style="margin-top: 1em">\n        <div ng-hide="removeOnSuccess && file.success || file.removed">\n            <span ng-show="file.success" class="fa fa-check text-success"></span><span ng-show="file.error" class="fa fa-exclamation-circle text-danger"></span><a ng-show="file.location" href="{{file.location}}" target="_blank"> {{file.fileName}}</a><span ng-show="!file.location"> {{file.fileName}}</span> <a class="fa fa-times-circle text-danger" ng-show="file.id" ng-click="removeFile(file)"></a>\n            <uib-progressbar value="file.progress" animate="true"><span style="color:white; white-space:nowrap; min-width: 2em">{{file.error ? \'Error uploading\' : file.progress + \'%\'}}</span></uib-progressbar>\n        </div>\n    </div>\n    <button ng-model="uploadAttachments" ngf-change="filesSelected($files, $event)" ngf-select ngf-multiple="true" class="btn btn-default"><i class="glyphicon glyphicon-paperclip"></i> {{buttonText}}</button>\n</div>');
$templateCache.put('/templates//s3Upload-inline.html','<div ng-show="!status.inProgress"\n    class="upload-link pull-right"\n    ng-model="uploadAttachments"\n    ngf-change="filesSelected($files, $event)"\n    ngf-select\n    ngf-multiple="false"\n    >\n    <a class="fa fa-picture-o"></a>\n</div>\n<div ng-show="status.inProgress"\n    class="pull-right"\n    >\n    <i class="fa fa-spinner fa-spin"></i>\n</div>\n');
$templateCache.put('/templates//signup.html','<div ng-show="signup.show" class="login-container">\r\n    <div class="flex-row">\r\n        <div ng-hide="signup.signupSent" class="login-form-container flex-center signup-block" style="width: auto;">\r\n            <form name="form" role="form" autofill>\r\n\r\n                <div class="well">\r\n\r\n                    <div class="flex-center">\r\n                        <h4 class="login-text">Sign-up for</h4>\r\n                    </div>\r\n\r\n                    <div class="flex-center">\r\n                        <h2 class="no-top-margin">{{signup.hostname}}</h2>\r\n                    </div>\r\n\r\n                    <div class="flex-center padded">\r\n                        <h5 class="login-text no-top-margin">Sign-up with your <strong>email address</strong>. We will send you a link to create your account.</h5>\r\n                    </div>\r\n\r\n                    <div class="position-relative margin-top">\r\n                        <input id="email-address" ng-model="signup.emailAddress" name="email" type="email" class="form-control" placeholder="Email address" required>\r\n                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>\r\n                    </div>\r\n\r\n                    <div class="login-center-text-block" style="margin-top: 20px;">\r\n                        <span class="login-button-sizer"><button class="btn btn-block btn-primary" ng-disabled="form.$invalid" ng-click="signup.startSignup(signup.emailAddress)">Next</button></span>\r\n                    </div>\r\n\r\n                </div>\r\n            </form>\r\n        </div>\r\n        <div ng-show="signup.signupSent" class="login-form-container signup-block">\r\n            <div class="well">\r\n                <div class="flex-center">\r\n                    <h2 class="login-text">Thanks!</h2>\r\n                </div>\r\n\r\n                <div class="flex-center padded">\r\n                    <h3 class="text-center">We have sent a link to complete the process to your email address.</h3>\r\n                </div>\r\n\r\n                <div class="flex-center padded">\r\n                    <h4 class="text-center">If you don\'t see it there make sure to check your spam folder.</h4>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="login-asset-container">\r\n            <iframe src="//attensa.com/default-panel/" class="login-asset-frame" frameborder="0" scrolling="no"></iframe>\r\n        </div>\r\n    </div>\r\n\r\n</div>');
$templateCache.put('/templates//stateChangeWithChangesWarningModal.html','<modal-header title="Unsaved changes" icon-class="glyphicon glyphicon-exclamation-sign" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <p>If you continue, your changes will be lost.</p>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n    <button class="btn btn-primary" ng-click="$close(true)">Continue</button>\n</div>\n');
$templateCache.put('/templates//streamCategoryModal.html','<div class="modal-body">\r\n        <div class="modal-header">\r\n            <h4 class="modal-title">Categorize: {{stream.title}}<a ng-click="$dismiss()" class="fa fa-times muted pull-right modal-close-x stream-category-modal-close-x" aria-hidden="true"></a></h4>\r\n        </div>\r\n        <div class="modal-body">\r\n            <alerts watch-for="stream-category-alerts"></alerts>\r\n            <form class="form-horizontal ajax-form" role="form">\r\n                <div class="form-group">\r\n                    <label class="col-sm-4 control-label">New Category:</label>\r\n                    <div class="col-sm-7">\r\n                        <input type="text" class="form-control" name="categoryName" ng-change="newCategoryNameChange()" ng-model="newCategoryName" placeholder="Category Name">\r\n                        <div ng-show="duplicateCategoryEntered" class="has-error">\r\n                            <small class="help-block">This category name already exists. Please enter another category name</small>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div>\r\n                    <h3 class="text-center">- OR -</h3>\r\n                    <br/>\r\n                </div>\r\n                <div class="form-group">\r\n                    <label class="col-sm-4 control-label">Existing Category:</label>\r\n                    <div class="col-sm-7">\r\n                        <select class="form-control" ng-change="selectCategory()" ng-model="selectedCategory" ng-options="category.title for category in categories | orderBy: \'title\'">\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n        <div class="modal-footer">\r\n            <button type="button" class="btn btn-default" ng-click="cancel()" ng-disabled="saving">Close</button>\r\n            <button type="button" class="btn btn-primary" ng-click="save()" ng-disabled="saving || isInvalid()">Save</button>\r\n        </div>\r\n</div>');
$templateCache.put('/templates//streamDetailModal.html','<div class="modal-body">\r\n    <div class="row">\r\n        <alerts watch-for="stream-detail-alerts"></alerts>\r\n    </div>\r\n    <div class="stream-detail">\r\n        <div class="stream-detail-header">\r\n            <div class="stream-detail-graphic">\r\n                <ng-include src="\'/templates/streamImageThumbnail.html\'"></ng-include>\r\n            </div>\r\n            <div class="stream-detail-info">\r\n                <div class="stream-detail-headline-text">\r\n                    <h1 style="margin-left: 0px;"><stream-type-indicator stream="::stream"></stream-type-indicator> {{::stream.title}}</h1>\r\n                </div>\r\n                <div class="stream-detail-description">\r\n                    {{::stream.description}}\r\n                </div>\r\n            </div>\r\n            <a ng-click="$close()" class="fa fa-times muted pull-right modal-close-x stream-detail-modal-close-x" aria-hidden="true"></a>\r\n            <div class="stream-detail-follow-box" ng-hide="noFollowing">\r\n                <div class="stream-detail-follow-icon">\r\n                    <span class="glyphicon glyphicon-user"></span>\r\n                </div>\r\n                <div class="stream-detail-follower-count">\r\n                    <a ng-click="openFollowersModal(stream)" class="stream-detail-follower-value">{{stream.followersCount}}</a><br/>\r\n                    <span class="stream-detail-follower-label"><ng-pluralize count="stream.followersCount" when="{\'1\': \'follower\',\r\n            \'other\': \'followers\'}">\r\n        <ng-pluralize></span>\r\n                </div>\r\n                <div role="group" data-toggle="buttons" aria-label="...">\r\n                    <follow-button stream="stream" user="user" type="stream" follow-style="primary">&nbsp;</follow-button><subscribe-button ng-if="stream.briefingEnabled" stream="stream" user="user" type="stream" subscribe-style="primary"></subscribe-button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="stream-detail-tags"></div>\r\n        <div class="stream-detail-item-preview">\r\n            <h3>Recent Activity <span class="muted" style="font-size:14px;">({{stream.itemsCount}} Total Items)</span></h3>\r\n            <div id="reading-table" class="position-relative">\r\n                <div ng-repeat="item in items" class="reading-item">\r\n                    <a class="rich-list-link rich-list-item-read" ng-click="viewItem(item, stream)">\r\n                        <div class="rich-list-item-group">\r\n                            <div class="rich-list-item-seg rank-div">\r\n                                <span class="rank rank-{{::item.attentionRank}} rich-list-rank">&nbsp;</span>\r\n                            </div>\r\n                            <div class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{::item.title}}">{{item.title || \'No title\'}} - <span style="color:#B2B2B3;">{{::item.shortDescription}}</span></div>\r\n                            <div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="::item.publishedDate"></div>\r\n                        </div>\r\n                    </a>\r\n                </div>\r\n                <p ng-hide="items">No recent activity</p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class="modal-footer">\r\n    <button class="btn btn-default btn-primary" ng-click="$close()">Close</button>\r\n</div>\r\n');
$templateCache.put('/templates//streamImageThumbnail.html','<div ng-if="!stream.thumbnailImage.uri && thumbnailImageAttachmentId"\r\n     ng-style="{ \'background-image\':\'url(\' + s3Url + thumbnailImageAttachmentId + \')\' }"\r\n     class="stream-image-small"></div>\r\n<div ng-if="stream.thumbnailImage.uri"\r\n     ng-style="{ \'background-image\':\'url(\' + stream.thumbnailImage.uri + \')\' }"\r\n     class="stream-image-small"></div>\r\n<div ng-if="!thumbnailImageAttachmentId && !stream.thumbnailImage.uri" class="stream-image-small"></div>');
$templateCache.put('/templates//subscribeToStreamModal.html','<div class="modal-content">\n    <div class="modal-body generic-modal-sub-modal-content">\n        <h4 class="modal-title subscribe-modal-title">You are not following {{stream.title}}. Would you like to follow it?</h4>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-primary sub-modal-submit" ng-click="$close(stream)">Follow</button>\n        <button type="button" class="btn btn-default sub-modal-cancel" ng-click="$dismiss()">No thanks</button>\n    </div>\n</div>');
$templateCache.put('/templates//templateBrowser.html','<div class="panel pull-left" style="margin-right:5px;width:275px;" ng-repeat="template in templates" ng-class="{\'cursor-pointer\':!manage ,\'panel-primary\' : selectedTemplate.id === template.id, \'panel-default\': selectedTemplate.id !== template.id}">\n    <div style="height:40px;" class="panel-heading text-center">\n        <h3 ng-if="!manage" style="height: 30px;" class="panel-title overflow-ellipsis" ng-click="selectTemplate(template)">{{template.title}}</h3>\n        <h3 ng-if="manage" style="height: 30px;" class="panel-title overflow-ellipsis"><a class="template-title-edit-link" editable-text="template.title" onbeforesave="saveTemplateTitle(template, $data)">{{template.title || "empty" }}</a></h3>\n    </div>\n    <div ng-show="manage" class="panel-footer">\n        <div class="row">\n            <div class="col-md-3">\n                <div class="dropdown" uib-dropdown is-open="template.dropOpen">\n                    <a class="dropdown-toggle btn btn-default" dropdown-flipper="180" data-toggle="dropdown" uib-dropdown-toggle><span class="fa fa-ellipsis-v text-primary ellipsis-v-button"></span></a>\n                    <ul class="dropdown-menu" role="menu">\n                        <li><a ng-click="uploadReplacement(template)"><i class="fa fa-retweet"></i> Replace</a></li>\n                        <li ng-if="!template.defaultTemplate"><a ng-click="setAsDefault(template)"><i class="fa fa-check"></i> Set as default</a></li>\n                        <li ng-if="!template.defaultTemplate"><a class="template-delete-link" ng-click="deleteTemplate(template)"><i class="fa fa-times-circle"></i> Delete</a></li>\n                        <li><a target="_blank" href="/s3/{{template.bucketName}}/{{template.id}}/{{template.title | stripFilename}}.html?directory=templates"><i class="fa fa-file-code-o"></i> Download</a></li>\n                    </ul>\n                </div>\n            </div>\n            <div class="col-md-5 white-space-nowrap">\n                <span ng-if="template.inUse" style="margin-top:8px;" class="badge">{{template.useCount}}</span> &nbsp;\n                <span style="margin-top:8px;">\n                    <small><a ng-click="viewTemplateUse(template)" ng-if="template.inUse">In Use</a></small>\n                </span>\n            </div>\n            <div class="col-md-4">\n                <div style="margin-top:6px;">\n                    <small id="is-default-label" ng-show="template.defaultTemplate === true && manage">Default <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></small>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//templateBrowserModal.html','<modal-header title="Choose briefing template" on-close="$dismiss()"></modal-header>\n<div class="modal-body clearfix">\n    <a ng-click="manageTemplates()">Manage Templates</a>\n    <div style="max-height: 400px;overflow-y: auto;">\n        <ng-include src="\'/templates/templateBrowser.html\'"></ng-include>\n    </div>\n</div>\n<div class="modal-footer">\n    <button style="margin-left:5px;" class="btn btn-primary pull-right" ng-click="saveSelection()">Select</button>\n    <button style="margin-left:5px;" class="btn btn-default pull-right" ng-click="$dismiss()">Cancel</button>\n    <button id="add-template-button" class="btn btn-default pull-right" ng-click="uploadTemplate()"><i class="fa fa-plus"></i> Template</button>\n</div>');
$templateCache.put('/templates//templateDetailModal.html','<modal-header title="Briefings using this template" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <div class="row">\n        <div class="col-md-4">\n            <h4>{{template.title}}</h4>\n        </div>\n        <div class="col-md-8">\n            <alerts watch-for="template-detail-alerts" suppress-duplicates></alerts>\n            <p class="text-warning" ng-if="template.defaultTemplate">This is currently the default template so you cannot remove the association of briefings from it.</p>\n            <table class="table table-striped scrollable-table">\n                <thead>\n                    <tr>\n                        <th>Associated Briefing</th>\n                        <th>Active</th>\n                    </tr>\n                </thead>\n                <tbody class="on-modal template-briefings-infinite-scroll-container" infinite-scroll="fetchNextPage()" infinite-scroll-distance="1" infinite-scroll-container=\'".template-briefings-infinite-scroll-container"\'>\n                    <tr ng-repeat="templateBriefing in templateBriefings">\n                        <td>{{templateBriefing.briefingTitle}}</td>\n                        <td> &nbsp; &nbsp;\n                            <a ng-if="!template.defaultTemplate" ng-click="dissociateFromBriefing(templateBriefing)" style="font-size:18px;"><i class="fa fa-times-circle text-danger"></i></a>\n                            <i style="font-size:18px;" ng-if="template.defaultTemplate" class="fa fa-times-circle text-muted"></i>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-primary pull-right" ng-click="$dismiss()">Ok</button>\n</div>');
$templateCache.put('/templates//templateSelectModal.html','<modal-header title="Upload template" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <alerts watch-for="template-select-alerts" suppress-duplicates></alerts>\n    <form class="image-upload-form" enctype="multipart/form-data" role="form" name="templateForm">\n        <div ng-if="!template.id" class="form-group">\n            <label for="title">Template Title</label>\n            <input type="text" class="form-control" id="templateTitle" id="title" name="title" placeholder="Template Title" ng-model="template.title" required ng-maxlength="64">\n            <div ng-if="templateForm.title.$dirty || templateForm.title.$touched">\n                <div class="has-error" ng-messages="templateForm.title.$error">\n                    <small class="help-block" ng-message="required">Title is required</small>\n                    <small class="help-block" ng-message="maxlength">Title must be less than 64 characters</small>\n                </div>\n            </div>\n        </div>\n        <button title="select file" class="btn btn-default" ngf-select="" ngf-accept="\'.html,.htm\'" ngf-multiple="false" ng-model="templateFiles">Choose file</button><h5>{{templateFiles[0].name | limitTo:30}}</h5>\n        <p class="help-block">Please <span ng-if="!template.id">input a title and</span> select a text file to use as the template.</p>\n    </form>\n</div>\n<div class="modal-footer">\n    <button class="btn btn-default btn-primary" ng-click="uploadTemplate(templateFiles[0])" ng-disabled="uploadInProgress || !templateFiles[0] || templateForm.$invalid">{{uploadButtonText}}</button>\n    <button class="btn btn-default" ng-click="close()">Close</button>\n</div>\n');
$templateCache.put('/templates//tenantAnalytics.html','<div ng-controller="TenantAnalyticsCtrl as dashboard" class="container">\n    <div class="row">\n        <div class="col-sm-4">\n            <div class="form-group form-inline">\n                <label>Last&nbsp;\n                    <select class="form-control" ng-model="dashboard.selectedDuration" ng-options="selectedDuration*1 as selectedDuration for selectedDuration in dashboard.durations">\n                    </select>\n                    <select class="form-control" ng-model="dashboard.selectedTimeUnitDays" ng-options="timeUnit.days as timeUnit.text for timeUnit in dashboard.timeUnits">\n                    </select>\n                    <button class="btn btn-primary" ng-click="dashboard.renderAnalytics(dashboard.selectedTimeUnitDays * dashboard.selectedDuration, dashboard.graphSelection)" ng-disabled="dashboard.fetchingData">\n                        <span ng-if="!dashboard.fetchingData">Go</span>\n                        <span ng-if="dashboard.fetchingData"><span class="fa fa-spinner fa-spin"></span><span>\n                    </button>\n                </label>\n            </div>\n            <div top-items-list title="Most Read Articles" top-list-content="dashboard.topItems"></div>\n            <div top-streams-list title="Most Read Streams" top-list-content="dashboard.topStreams"></div>\n        </div>\n        <div class="col-sm-8">\n            <div class="row">\n                <div class="col-sm-3">\n                    <div class="chart-wrapper">\n                        <div class="analytics-badge"><span class="analytics-badge-number">{{dashboard.totalViewsData.metric}}</span><br>total items viewed</div>\n                    </div>\n                </div>\n                <div class="col-sm-3">\n                    <div class="chart-wrapper">\n                        <div class="analytics-badge"><span class="analytics-badge-number">{{dashboard.clickThroughData.metric}}</span><br>click-throughs to source</div>\n                    </div>\n                </div>\n                <div class="col-sm-3">\n                    <div class="chart-wrapper">\n                        <div class="analytics-badge"><span class="analytics-badge-number">{{dashboard.uniqueViewsData.metric >= 10000 ? \'>10k\' : dashboard.uniqueViewsData.metric}}</span><br>unique items viewed</div>\n                    </div>\n                </div>\n                <div class="col-sm-3">\n                    <div class="chart-wrapper">\n                        <div class="analytics-badge"><span class="analytics-badge-number">{{dashboard.uniqueStreamsData.metric >= 10000 ? \'>10k\' : dashboard.uniqueStreamsData.metric}}</span><br>unique streams viewed</div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-sm-12">\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="chart-wrapper">\n                                <div class="chart-notes">\n                                    <a ng-class="{\'selected-graph\': dashboard.graphSelection === \'item_viewed\'}" ng-click="dashboard.setGraphSelection(\'item_viewed\')">Total Article Views</a> -\n                                    <a ng-class="{\'selected-graph\': dashboard.graphSelection !== \'item_viewed\'}" ng-click="dashboard.setGraphSelection(\'item_link_clicked\')">Article click-throughs to source</a>\n                                </div>\n                                <canvas class="chart chart-line" data="dashboard.graphData.data" labels="dashboard.graphData.labels"></canvas>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-lg-12">\n            <report-list></report-list>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//topList.html','<h4>{{title}}</h4>\n<ul class="list-group">\n    <li ng-repeat="item in topListContent" class="list-group-item"><span class="badge">{{item.count}}</span><a ng-click="clickAction(item)">{{item.title || \'No Title\'}}</a></li>\n</ul>\n');
$templateCache.put('/templates//topicNameModal.html','<modal-header title="Topic Name" on-close="$dismiss()"></modal-header>\n<section class="modal-body">\n    <form name="titleForm" ng-submit="$close(title)">\n        <div class="form-group">\n            <input type="text" class="form-control" placeholder="Topic name" ng-model="title" name="title" ng-required="true">\n            <span style="padding-left: 15px; font-style: italic; font-size: 12px;">You will be able to edit the name later</span>\n        </div>\n        <p ng-if="sources && sources.length === 0" class="alert alert-warning">\n            It looks like you are creating a topic with no sources.  If you create the topic you can add sources later, or click cancel to find and add some sources now.\n        </p>\n        <div class="form-group">\n            <button class="btn btn-default" type="button" ng-click="$dismiss()">Cancel</button>\n            <button class="btn btn-primary" type="submit" ng-disabled="titleForm.title.$error.required">Create topic</button>\n        </div>\n        <div class="panel panel-default" ng-if="sources && sources.length > 0">\n            <div class="panel-heading">\n                <h3 class="panel-title">Topic will be created with the following sources:</h3>\n            </div>\n            <div class="panel-body">\n                <existing-source-list sources="sources" hide-links="true"></existing-source-list>\n            </div>\n        </div>\n    </form>\n</section>\n');
$templateCache.put('/templates//twitterHelpPopover.html','<div class="popover">\n    <div class="arrow"></div>\n    <h3 class="popover-title">Help</h3>\n    <div class="popover-content">\n        <accordion>\n            <accordion-group is-open="true">\n                <accordion-heading>\n                    <i class="fa fa-info-circle"> <b>Advanced Twitter search</b></i>\n                </accordion-heading>\n                <p>You may enter any phrase supported by Twitter\'s advanced search syntax.</p>\n                <p>For example:</p>\n                <p>keyword1 keyword2 "exact phrase" -unwanted -words from:nelityson OR from:StephenAtHome</p>\n            </accordion-group>\n        </accordion>\n    </div>\n</div>\n');
$templateCache.put('/templates//userBriefingsTable.html','<div class="row" ng-controller="EditUserBriefingsModalCtrl">\n    <div class="col-md-12 table-section-content">\n        <table class="table scrollable-table" id="briefing-table">\n            <thead>\n                <tr>\n                    <th style="width: 20%;">\n                        <sort-people-by label="\'Briefing\'" sort="sort" sort-key="\'titleLower\'" sort-by="toggleSort" initial-sort="true"></sort-people-by>\n                    </th>\n                    <th style="width: 20%;">\n                        <label>Schedule</label>\n                    </th>\n                    <th style="width: 20%;">\n                        <sort-people-by label="\'Last Sent\'" sort="sort" sort-key="\'lastSentDate\'" sort-by="toggleSort"></sort-people-by>\n                    </th>\n                    <th style="width: 20%;">\n                        <sort-people-by label="\'Next Scheduled\'" sort="sort" sort-key="\'schedule.nextScheduledDate\'" sort-by="toggleSort"></sort-people-by>\n                    </th>\n                    <th class="pull-right" style="width: 20%"></th>\n                </tr>\n            </thead>\n            <tbody class="on-modal briefings-infinite-scroll-container" infinite-scroll="nextPage()" infinite-scroll-distance="1" infinite-scroll-disabled="last" infinite-scroll-container=\'".briefings-infinite-scroll-container"\' style="height: 400px">\n                <tr ng-if="noSubscribedBriefings">\n                    <th style="padding-top: 0px;">\n                        <div class="alert alert-warning alert-dismissible" role="alert">\n                            <p class="normal-font-weight">User currently not subscribed to any briefings</p>\n                        </div>\n                    </th>\n                </tr>\n                <tr ng-repeat="briefing in briefings">\n                    <!-- TODO the title should link to stream builder modal opened to briefing tab -->\n                    <td class="overflow-ellipsis" style="width: 20%;" title="{{::briefing.briefingTitle}}"><a ui-sref="briefingItem.details({briefingId: briefing.id})"><div class="briefing-title-wrapper">{{::briefing.briefingTitle}}</div></a></td>\n                    <td style="width: 20%;">{{::filteredFrequencies(briefing.schedule)}}</td>\n                    <td style="width: 20%">{{::briefing.lastSentDate | amDateFormat:\'MMM Do YYYY, h:mm a\'}}</td>\n                    <td style="width: 20%">{{::briefing.schedule.nextScheduledDate | amDateFormat:\'MMM Do YYYY, h:mm a\'}}</td>\n                    <td class="pull-right" style="width: 20%">\n                        <briefing-subscribe-button briefing="briefing" \n                                                   user="user"\n                                                   force-group-check="true">\n                        </briefing-subscribe-button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('/templates//userForm.html','<div id="invalidFormWarning" class="row" ng-show="form.$invalid">\n    <div class="alert alert-warning alert-dismissible" role="alert">\n        <button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>\n        Please correct the items below.\n    </div>\n</div>\n<div class="row">\n    <div class="col-lg-2 profile-detail-graphic">\n        <div id="profile-pic" ng-style="backgroundImage" class="profile-image" ng-show="user.largeImageUri && !profilePic.value[0].dataUrl"></div>\n        <div id="preview-pic" ng-style="previewBackgroundImage" class="profile-image" ng-show="profilePic.value[0].dataUrl"></div>\n        <div id="blank-pic" class="profile-image" ng-show="!profilePic.value[0].dataUrl && !user.largeImageUri"></div>\n        <button type="button" accept="image/*" style="margin-top: 10px; margin-bottom: 10px; width: 121px; font-size: 14px; font-weight: 500; text-shadow: none; color: #666;" ngf-change="generateThumb(profilePic.value[0], $files)" ngf-select ng-model="profilePic.value" ngf-multiple="false" ngf-reset-on-click="true" class="btn btn-default btn-sm profile-image-select">Select Image</button>\n    </div>\n    <div class="col-lg-10">\n        <div class="row" ng-if="!user.initialized && !tenant.settings.samlEntryPoint">\n                <div class="col-lg-12">\n                    <label style="color: red;">* No initial Login</label>\n                </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-lg-4 has-feedback" style="height: 70px;">\n                <label for="firstName">First Name</label>\n                <div class="has-feedback" ng-messages="form.firstName.$error">\n                    <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                    <div ng-if="form.firstName.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n                </div>\n                <input type="text" class="form-control" id="firstName" name="firstName" placeholder="First Name" ng-model="user.firstName" style="padding-right: 40px;" required>\n                <div class="has-error white-space-nowrap" ng-messages="form.firstName.$error">\n                    <small class="help-block" ng-message="required">First name is required and cannot be empty</small>\n                </div>\n            </div>\n\n            <div class="form-group col-lg-2" style="height: 70px;">\n                <label for="middleName">Middle</label>\n                <input type="text" class="form-control" id="middleName" name="middleName" placeholder="Middle" ng-model="user.middleName">\n            </div>\n\n            <div class="form-group col-lg-4  has-feedback" style="height: 70px;">\n                <label for="lastName">Last Name</label>\n                <div class="has-feedback" ng-messages="form.lastName.$error">\n                    <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                    <div ng-if="form.lastName.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n                </div>\n                <input type="text" class="form-control" id="lastName" name="lastName" placeholder="Last Name" ng-model="user.lastName" style="padding-right: 40px;" style="padding-right: 40px;" required>\n                <div class="has-error white-space-nowrap" ng-messages="form.lastName.$error">\n                    <small class="help-block" ng-message="required">Last name is required and cannot be empty</small>\n                </div>\n            </div>\n\n            <div class="form-group col-lg-2" style="height: 70px;">\n                <label for="suffix">Suffix</label>\n                <input type="text" class="form-control" id="suffix" name="suffix" placeholder="Suffix" ng-model="user.suffix" style="padding-right: 40px;">\n            </div>\n        </div>\n\n        <div class="row" ng-if="!tenant.settings.samlEntryPoint">\n            <div class="form-group col-lg-6 has-feedback" style="height: 80px;">\n                <label for="password">Change Password</label>\n                <div class="has-feedback" ng-if="form.password.$invalid">\n                    <i class="form-control-feedback glyphicon glyphicon-ban-circle"></i>\n                </div>\n                <div class="has-feedback" ng-if="form.newConfirmPassword.$valid && form.newPassword.$valid">\n                    <i class="form-control-feedback glyphicon glyphicon-ok"></i>\n                </div>\n                <input type="password" autocomplete="new-password" class="form-control" id="password" name="newPassword" minlength="8" placeholder="New Password" ng-model="user.password" style="padding-right: 40px;" validate-password="user.confirmPassword">\n                <div class="has-error" ng-messages="form.newPassword.$error">\n                    <small class="help-block" ng-message="minlength">Your password must be longer than 8 characters</small>\n                    <small class="help-block" ng-message="passwordCharacters">Your password must have at least one number, one uppercase, and one lowercase letter</small>\n                </div>\n            </div>\n\n            <div class="form-group col-lg-6 has-feedback" style="height: 70px;">\n                <label for="confirmPassword">Confirm Password</label>\n                <div class="has-feedback" ng-messages="form.newConfirmPassword.$error">\n                    <div ng-message="requiring" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                    <div ng-message="match" class="form-control-feedback glyphicon glyphicon-ban-circle"></div>\n                    <div ng-if="form.newConfirmPassword.$valid && form.newPassword.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n                </div>\n                <input type="password" autocomplete="new-password" class="form-control" id="confirmPassword" name="newConfirmPassword" placeholder="Confirm Password" ng-model="user.confirmPassword" style="padding-right: 40px;" match-to-validator>\n                <div class="has-error" ng-messages="form.newConfirmPassword.$error">\n                    <small class="help-block" ng-message="requiring">Please fill both passwords</small>\n                    <small class="help-block" ng-message="match">The passwords do not match</small>\n                </div>\n            </div>\n        </div>\n\n        <div class="row" ng-if="!disableEmailChange">\n            <div class="form-group col-lg-12  has-feedback" style="height: 70px;">\n                <label for="emailAddress">Email Address</label>\n                <div class="has-feedback">\n                    <div ng-if="form.emailAddress.$error.required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n                    <div ng-if="!form.emailAddress.$error.required && form.emailAddress.$invalid" class="form-control-feedback glyphicon glyphicon-ban-circle"></div>\n                    <div ng-if="form.emailAddress.$pending" class="form-control-feedback glyphicon glyphicon-refresh"></div>\n                    <div ng-if="form.emailAddress.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n                </div>\n                <input type="email" class="form-control" id="emailAddress" name="emailAddress" placeholder="Email Address" ng-model="user.emailAddress" style="padding-right: 40px;" validate-unique-email required>\n                <div class="has-error" ng-messages="form.emailAddress.$error">\n                    <small class="help-block" ng-message="required">Email Address is required and cannot be empty</small>\n                    <small class="help-block" ng-message="email">Please enter a correct email address</small>\n                    <small class="help-block" ng-message="uniqueEmail">The email address you have entered already exists, please enter another email address</small>\n                </div>\n            </div>\n        </div>\n\n        <div class="row" ng-if="disableEmailChange">\n            <div class="form-group col-lg-12  has-feedback" style="height: 70px;">\n                <label for="emailAddress">Email Address</label>\n                <input type="email" class="form-control" id="emailAddress" name="emailAddress" ng-model="user.emailAddress" style="padding-right: 40px;" ng-disabled="true">\n            </div>\n        </div>\n\n        <div class="row">\n            <div class="form-group col-lg-7" style="height: 70px;">\n                <label>Timezone</label>\n                <select class="form-control" ng-model="user.timeZone" ng-options="zone.key as zone.val for zone in displayTimezones">\n                    <option value="">-- Select Timezone --</option>\n                </select>\n            </div>\n            <div class="form-group col-lg-2 has-feedback" style="height: 70px;" ng-show="isModal">\n                <label for="status">Status</label>\n                <div class="dropdown" uib-dropdown>\n                    <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle style="min-width: 100px;" ng-disabled="currentUser">{{user.status}} <span class="caret"></span></button>\n                    <ul class="dropdown-menu" role="menu">\n                        <li>\n                            <a ng-click="user.status=\'ACTIVE\'; changeStatus(user)">ACTIVE</a>\n                        </li>\n                        <li>\n                            <a ng-click="user.status=\'INACTIVE\'; changeStatus(user)">INACTIVE</a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class="col-lg-3 has-feedback" ng-show="isModal">\n                <ul>\n                    <li><label><input id="edit-user-admin-checkbox" type="checkbox" ng-model="user.admin" ng-disabled="currentUser"> Administrator</label></li>\n                    <li ng-show="allowStreamCreator"><label><input id="edit-user-topic-creator-checkbox" type="checkbox" ng-model="user.streamCreator" ng-disabled="currentUser"> Topic Creator</label></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//userGroupsTable.html','<div class="row" ng-controller="EditUserGroupsModalCtrl">\n    <div class="col-md-12 table-section-content">\n        <table class="table fixed-table scrollable-table" id="group-table">\n            <thead>\n                <tr>\n                    <th style="width: 20%;">\n                        <sort-people-by label="\'Name\'" sort="sort" sort-key="\'nameLower\'" sort-by="toggleSort" initial-sort="true"></sort-people-by>\n                    </th>\n                    <th style="width: 30%">\n                        <sort-people-by label="\'Description\'" sort="sort" sort-key="\'description\'" sort-by="toggleSort"></sort-people-by>\n                    </th>\n                    <th style="width: 10%;">\n                        <sort-people-by label="\'Members\'" sort="sort" sort-key="\'membersCount\'" sort-by="toggleSort"></sort-people-by>\n                    </th>\n                    <th style="width: 25%;">\n                        <sort-people-by label="\'Created\'" sort="sort" sort-key="\'created\'" sort-by="toggleSort"></sort-people-by>\n                    </th>\n                    <th style="width: 15%"></th>\n                </tr>\n            </thead>\n            <tbody class="on-modal groups-infinite-scroll-container" infinite-scroll="nextPage()" infinite-scroll-distance="1" infinite-scroll-disabled="last" infinite-scroll-container=\'".groups-infinite-scroll-container"\' style="height: 400px">\n                <tr ng-if="notInGroups">\n                    <th style="padding-top: 0px;">  \n                        <div class="alert alert-warning alert-dismissible" role="alert">\n                            <p class="normal-font-weight">User currently not in any groups</p>\n                        </div>\n                    </th>\n                </tr>\n                <tr ng-repeat="group in groups">\n                    <td class="overflow-ellipsis" style="width: 20%;" title="{{::group.name}}"><a ng-click="editGroup(group)">{{group.name}}</a></td>\n                    <td class="overflow-ellipsis" style="width: 30%;" title="{{::group.description}}">{{group.description}}</td>\n                    <td style="width: 10%;">{{group.members.length}}</td>\n                    <td style="width: 25%">{{::group.created | amDateFormat:\'MMM Do YYYY, h:mm a\'}}</td>\n                    <td style="width: 15%">\n                        <button type="button" data-loading-text="Saving..." class="btn btn-xs btn-default catalog-stream-subscribe-button table" ng-class="{active: userInGroup(user.id, group.members)}" ng-click="toggleGroupSubscription(user, group)" blur-me>{{userInGroup(user.id, group.members) ? \'Remove\' : \'Add\'}}</button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('/templates//userOwnedStreamsTable.html','<div ng-controller="EditUserOwnedStreamsModalCtrl">\n    <div class="row hidden-sm hidden-xs user-streams-table-panel-header" scrolled>\n        <div class="col-md-4 col-md-offset-1">\n            <a ng-click="toggleSort(\'titleLower\')">\n                <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'titleLower\'), \'fa-sort-asc\': isSort(\'titleLower\', \'ASC\'), \'fa-sort-desc\': isSort(\'titleLower\', \'DESC\') }"></i> Title\n            </a>\n        </div>\n        <div class="col-md-1">\n            <strong>Type</strong>\n        </div>\n        <div class="col-md-1">\n            <i class="fa fa-book"></i>\n        </div>\n        <div class="col-md-1">\n            <a ng-click="toggleSort(\'followersCount\')" title="Followers">\n                <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'followersCount\'), \'fa-sort-asc\': isSort(\'followersCount\', \'ASC\'), \'fa-sort-desc\': isSort(\'followersCount\', \'DESC\') }"></i> <span class="glyphicon glyphicon-user"></span>\n            </a>\n        </div>\n        <div class="col-md-1">\n            <a ng-click="toggleSort(\'itemsCount\')" title="Items">\n                <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'itemsCount\'), \'fa-sort-asc\': isSort(\'itemsCount\', \'ASC\'), \'fa-sort-desc\': isSort(\'itemsCount\', \'DESC\') }"></i> <span class="fa fa-copy"></span>\n            </a>\n        </div>\n        <div class="col-md-3">\n            <input type="text" class="form-control" placeholder="Search" ng-model="params.term" size="80" enter-key="searchStreams()" on-delayed-change="searchStreams()">\n            <a ng-click="clearSearch()" ng-show="params.term" id="streams-search-clear" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n        </div>\n    </div>\n    <div class="position-relative clearfix owned-stream-table stream-table people-table-infinite-scroll-container" infinite-scroll="nextPage()" infinite-scroll-distance="1" infinite-scroll-disabled="last" infinite-scroll-container=\'".owned-stream-table"\'>\n        <div ng-show="notFollowingStreams" class="alert alert-warning alert-dismissible" role="alert">\n            This user does not own any streams\n        </div>\n        <div ng-repeat="stream in streams" class="clearfix">\n            <div class="row streams-table-row">\n                <div class="col-md-1 hidden-sm hidden-xs">\n                    <div ng-if="::thumbnailImageAttachmentId || stream.thumbnailImage.uri" class="stream-table-image pull-left">\n                        <ng-include src="\'/templates/streamImageThumbnail.html\'"></ng-include>\n                    </div>\n                </div>\n                <div class="col-md-4 col-xs-5">\n                    <h4 class="media-heading">\n                        <div class="ellipsis-color">\n                            <a class="overflow-ellipsis" ng-click="viewStreamDetails(stream)">\n                            <span class="stream-title overflow-ellipsis">\n                                <span title="{{stream.title}}">{{stream.title}}</span>\n                            </span>\n                            </a>\n                        </div>\n                    </h4>\n                    <p title="{{::stream.description}}" class="catalog-tile-description">{{::stream.description}}</p>\n                </div>\n                <div class="hidden-sm hidden-xs col-md-1">\n                    <stream-type-indicator stream="::stream"></stream-type-indicator>\n                </div>\n                <div class="hidden-sm hidden-xs col-md-1">\n                    <span ng-show="stream.published" class="fa fa-check catalog-stream-published" title="Published"></span>\n                </div>\n                <div class="hidden-lg hidden-md col-md-1">\n                    <stream-type-indicator stream="::stream"></stream-type-indicator>\n                    <span ng-show="stream.published" class="fa fa-check catalog-stream-published" title="Published"></span>\n                </div>\n                <div class="col-md-1 col-xs-1">\n                    <a ng-click="openFollowersModal(stream)">\n                    <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Followers">\n                        <span id="followersCount-{{::stream.id}}">{{stream.followersCount}}</span>\n                    </span>\n                    </a>\n                </div>\n                <div class="col-md-1 col-xs-1">\n                <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Articles">\n                    <span id="itemsCount">{{::stream.itemsCount}}</span>\n                </span>\n                </div>\n                <div class="col-md-1">\n                    <a ng-show="stream.rssEnabled" target="_blank" href="/rss/{{stream.id}}" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="RSS Feed">\n                        <i class="fa fa-rss"></i>\n                    </a>\n                    <span ng-show="!stream.rssEnabled" class="gluphicon glyphicon-none"></span>\n                    <span ng-show="stream.briefingEnabled" class="fa fa-envelope-o" title="Briefings"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//userStreamsTable.html','<div ng-controller="EditUserStreamsModalCtrl">\n    <div class="row hidden-sm hidden-xs user-streams-table-panel-header" scrolled>\n        <div class="col-md-4 col-md-offset-1">\n            <a ng-click="toggleSort(\'titleLower\')">\n                <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'titleLower\'), \'fa-sort-asc\': isSort(\'titleLower\', \'ASC\'), \'fa-sort-desc\': isSort(\'titleLower\', \'DESC\') }"></i> Title\n            </a>\n        </div>\n        <div class="col-md-1">\n            <strong>Type</strong>\n        </div>\n        <div class="col-md-1">\n            <i class="fa fa-book"></i>\n        </div>\n        <div class="col-md-1">\n            <a ng-click="toggleSort(\'followersCount\')" title="Followers">\n                <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'followersCount\'), \'fa-sort-asc\': isSort(\'followersCount\', \'ASC\'), \'fa-sort-desc\': isSort(\'followersCount\', \'DESC\') }"></i> <span class="glyphicon glyphicon-user"></span>\n            </a>\n        </div>\n        <div class="col-md-1">\n            <a ng-click="toggleSort(\'itemsCount\')" title="Items">\n                <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'itemsCount\'), \'fa-sort-asc\': isSort(\'itemsCount\', \'ASC\'), \'fa-sort-desc\': isSort(\'itemsCount\', \'DESC\') }"></i> <span class="fa fa-copy"></span>\n            </a>\n        </div>\n        <div class="col-md-3">\n            <input type="text" class="form-control" placeholder="Search" ng-model="params.term" size="80" enter-key="searchStreams()" on-delayed-change="searchStreams()">\n            <a ng-click="clearSearch()" ng-show="params.term" id="streams-search-clear" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n        </div>\n    </div>\n    <div class="position-relative clearfix stream-table people-table-infinite-scroll-container" infinite-scroll="nextPage()" infinite-scroll-distance="1" infinite-scroll-disabled="last" infinite-scroll-container=\'".stream-table"\'>\n        <div ng-show="notFollowingStreams" class="alert alert-warning alert-dismissible" role="alert">\n            User currently not following any streams\n        </div>\n        <div ng-repeat="stream in streams" class="clearfix">\n            <div class="row streams-table-row">\n                <div class="col-md-1 hidden-sm hidden-xs">\n                    <div ng-if="::thumbnailImageAttachmentId || stream.thumbnailImage.uri" class="stream-table-image pull-left">\n                        <ng-include src="\'/templates/streamImageThumbnail.html\'"></ng-include>\n                    </div>\n                </div>\n                <div class="col-md-4 col-xs-5">\n                    <h4 class="media-heading">\n                        <div class="ellipsis-color">\n                            <a class="overflow-ellipsis" ng-click="viewStreamDetails(stream)">\n                            <span class="stream-title overflow-ellipsis">\n                                <span title="{{stream.title}}">{{stream.title}}</span>\n                            </span>\n                            </a>\n                        </div>\n                    </h4>\n                    <p title="{{::stream.description}}" class="catalog-tile-description">{{::stream.description}}</p>\n                </div>\n                <div class="hidden-sm hidden-xs col-md-1">\n                    <stream-type-indicator stream="::stream"></stream-type-indicator>\n                </div>\n                <div class="hidden-sm hidden-xs col-md-1">\n                    <span ng-show="stream.published" class="fa fa-check catalog-stream-published" title="Published"></span>\n                </div>\n                <div class="hidden-lg hidden-md col-md-1">\n                    <stream-type-indicator stream="::stream"></stream-type-indicator>\n                    <span ng-show="stream.published" class="fa fa-check catalog-stream-published" title="Published"></span>\n                </div>\n                <div class="col-md-1 col-xs-1">\n                    <a ng-click="openFollowersModal(stream)">\n                    <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Followers">\n                        <span id="followersCount-{{::stream.id}}">{{stream.followersCount}}</span>\n                    </span>\n                    </a>\n                </div>\n                <div class="col-md-1 col-xs-1">\n                <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Articles">\n                    <span id="itemsCount">{{::stream.itemsCount}}</span>\n                </span>\n                </div>\n                <div class="col-md-1">\n                    <a ng-show="stream.rssEnabled" target="_blank" href="/rss/{{stream.id}}" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="RSS Feed">\n                        <i class="fa fa-rss"></i>\n                    </a>\n                    <span ng-show="!stream.rssEnabled" class="gluphicon glyphicon-none"></span>\n                    <span ng-show="stream.briefingEnabled" class="fa fa-envelope-o" title="Briefings"></span>\n                </div>\n                <div class="col-md-2">\n                    <ul class="list-inline pull-right">\n                        <li>\n                            <follow-button stream="stream" user="user" type="stream"></follow-button>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//briefings/base.html','<div class="briefings-state">\n    <ui-view name="briefingHeader"></ui-view>\n    <ui-view name="briefingBody"></ui-view>\n</div>');
$templateCache.put('/templates//briefings/contents.html','<section ng-if="contentCtrl.briefing && contentCtrl.briefing.streamId">\r\n        <div class="flex-center">\r\n            <div>\r\n                <h3>Topic briefings\' sources are managed in the Topic interface</h3>\r\n                <a ui-sref="editTopic.sources({streamId: contentCtrl.briefing.streamId})" class="flex-center"><h4>manage topic sources for {{contentCtrl.briefing.briefingTitle}}</h4></a>\r\n            </div>\r\n        </div>\r\n</section>\r\n<section ng-if="contentCtrl.briefing && !contentCtrl.briefing.streamId">\r\n    <section class="row browse-section">\r\n        <div class="col-md-12">\r\n            <briefing-content-chooser sources="contentCtrl.sources" add-sources="contentCtrl.addSources($sourceIds)"></briefing-content-chooser>\r\n        </div>\r\n    </section>\r\n    <section class="row">\r\n        <div class="col-md-12">\r\n            <briefing-sources streams="contentCtrl.streams" remove-source="contentCtrl.removeSource($sourceId)" sources-reordered="contentCtrl.sourcesReordered($sources)"></briefing-sources>\r\n        </div>\r\n    </section>\r\n</section>');
$templateCache.put('/templates//briefings/create.html','<div class="row">\r\n    <div class="col-md-9 col-md-offset-2">\r\n        <section>\r\n            <form name="form" novalidate>\r\n                <h2>Create a new briefing</h2>\r\n                <section>\r\n                    <div class="form-group">\r\n                        <input type="text" class="form-control" placeholder="Title" ng-model="$ctrl.briefing.briefingTitle" name="briefingTitle" required="true" focus-me="$ctrl.focusTitle">\r\n                        <div>\r\n                            <div class="has-error" ng-messages="form.briefingTitle.$error">\r\n                                <small class="help-block" ng-message="required">Please enter a briefing title</small>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <input type="text" class="form-control" placeholder="Subject line" ng-model="$ctrl.briefing.subjectLine" name="subjectLine">\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <input type="text" class="form-control" placeholder="Briefing title" ng-model="$ctrl.briefing.templateTitle" name="templateTitle">\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <input type="text" class="form-control" placeholder="Description" ng-model="$ctrl.briefing.description" name="description">\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <input type="text" class="form-control" placeholder="Commentary Title" ng-model="$ctrl.briefing.commentary.title" name="commentaryTitle">\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <input type="text" class="form-control" placeholder="Commentary" ng-model="$ctrl.briefing.commentary.body" name="commentaryBody">\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <briefing-template briefing="$ctrl.briefing"></briefing-template>\r\n                    </div>\r\n                </section>\r\n\r\n                <section>\r\n                    <briefing-edit-details\r\n                            briefing="$ctrl.briefing"\r\n                            briefing-schedule="$ctrl.briefing.schedule"\r\n                            hide-non-schedule-items="true"\r\n                            form="form"\r\n                            end-mode-changed="$ctrl.endModeChanged()"\r\n                            frequency-changed="$ctrl.frequencyChanged()"\r\n                            selected-days="$ctrl.selectedDays"\r\n                            selected-template="$ctrl.selectedTemplate()">\r\n                    </briefing-edit-details>\r\n                </section>\r\n\r\n                <section>\r\n                    <section class="row browse-section">\r\n                        <div class="col-md-12">\r\n                            <briefing-content-chooser initial-show="true" sources="[]" add-sources="$ctrl.addSources($sourceIds)"></briefing-content-chooser>\r\n                        </div>\r\n                </section>\r\n\r\n                <section class="row" ng-show="$ctrl.briefing.streamIds.length">\r\n                    <div class="col-md-12">\r\n                        <briefing-sources streams="$ctrl.streams"\r\n                                          remove-source="$ctrl.removeSource($sourceId)"\r\n                                          sources-reordered="$ctrl.sourcesReordered($sources)"\r\n                                          hide-out-links="true"></briefing-sources>\r\n                    </div>\r\n                </section>\r\n\r\n\r\n                <div class="form-group">\r\n                    <button class="btn btn-default" type="button" ng-click="$ctrl.cancel()">Cancel</button>\r\n                    <button class="btn btn-primary" type="button" ng-disabled="form.$invalid || !$ctrl.briefing.templateId" ng-click="$ctrl.create()">Create briefing</button>\r\n                </div>\r\n\r\n            </form>\r\n        </section>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//briefings/details.html','<div class="row">\n    <div class="col-sm-offset-2 col-sm-9">\n        <div class="row" style="padding-top: 30px;">\n            <div class="col-sm-offset-2 col-sm-6">\n                <div class="form-group form-inline">\n                    <label>Last&nbsp;\n                        <select class="form-control" ng-model="briefingDetails.selectedDuration" ng-options="selectedDuration*1 as selectedDuration for selectedDuration in briefingDetails.durations">\n                        </select>\n                        <select class="form-control" ng-model="briefingDetails.selectedTimeUnitDays" ng-options="timeUnit.days as timeUnit.text for timeUnit in briefingDetails.timeUnits">\n                        </select>\n                        <button class="btn btn-primary" ui-sref="briefingItem.details({duration: briefingDetails.selectedDuration, timeUnitDays: briefingDetails.selectedTimeUnitDays})" ng-disabled="briefingDetails.fetchingData">Go</button>\n                    </label>\n                </div>\n            </div>\n        </div>\n        <div class="row" style="padding-bottom: 30px;">\n            <div class="col-sm-offset-2 col-sm-6">\n                <analytics-chart data="briefingDetails.graphData.data" labels="briefingDetails.graphData.labels" summary="briefingDetails.graphData.summaryText"></analytics-chart>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-sm-12">\n            <analytic-result wrapper-class="col-sm-3 col-lg-2"\n                             label="briefings delivered"\n                             quantity="briefingDetails.deliveredBriefings.metric"\n                             is-selected="briefingDetails.graphSelection === \'briefing_email_delivered\'"\n                             on-select="briefingDetails.setGraphSelection(\'briefing_email_delivered\')"></analytic-result>\n            <analytic-result wrapper-class="col-sm-3 col-lg-2"\n                             label="briefing opens"\n                             quantity="briefingDetails.openedBriefings.metric"\n                             is-selected="briefingDetails.graphSelection === \'briefing_email_opened\'"\n                             on-select="briefingDetails.setGraphSelection(\'briefing_email_opened\')"></analytic-result>\n            <analytic-result wrapper-class="col-sm-3 col-lg-2"\n                             label="briefing clicks"\n                             quantity="briefingDetails.clickedBriefings.metric"\n                             is-selected="briefingDetails.graphSelection === \'briefing_email_clicked\'"\n                             on-select="briefingDetails.setGraphSelection(\'briefing_email_clicked\')"></analytic-result>\n            <analytic-result wrapper-class="col-sm-3 col-lg-2"\n                             label="briefings dropped"\n                             quantity="briefingDetails.droppedBriefings.metric"\n                             is-selected="briefingDetails.graphSelection === \'briefing_email_dropped\'"\n                             on-select="briefingDetails.setGraphSelection(\'briefing_email_dropped\')"></analytic-result>\n            <analytic-result wrapper-class="col-sm-3 col-lg-2"\n                             label="briefings spammed"\n                             quantity="briefingDetails.spammedBriefings.metric"\n                             is-selected="briefingDetails.graphSelection === \'briefing_email_spammed\'"\n                             on-select="briefingDetails.setGraphSelection(\'briefing_email_spammed\')"></analytic-result>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div ng-show="briefingDetails.briefingHistories.length" class="table-section-content" style="padding: 30px 0px 0px 0px;">\n\n    <ol class="breadcrumb">\n        <li><h2>Send History</h2></li>\n    </ol>\n\n    <table class="table">\n        <thead>\n            <td>Subject</td>\n            <td>Sent</td>\n            <td>Type</td>\n            <td>Items Sent</td>\n            <td>Note</td>\n            <td>Recipients</td>\n        </thead>\n        <tbody>\n            <tr ng-repeat-start="history in briefingDetails.briefingHistories" ng-class-even="\'even\'" ng-class-odd="\'odd\'" class="briefing-history-info">\n                <td>\n                    <span ng-if="!history.sent">{{history.subject}}</span>\n                    <a ng-if="history.sent" href="/briefing?id={{history.briefingId}}&briefingHistoryId={{history.id}}">{{history.subject}}</a>\n                </td>\n                <td>{{history.created | date: \'medium\' }}</td>\n                <td>{{history.type}}</td>\n                <td>{{history.numberOfItemsSent}}</td>\n                <td>{{history.note}}</td>\n                <td>\n                    <a ng-click="briefingDetails.toggleCurrentHistory(history)">\n                        <div class="info-wrapper">\n                            <div class="chart-wrapper">\n                                <div class="analytics-badge"><span class="analytics-badge-number">{{history.recipients.length}}</span><br>Recipients</div>\n                            </div>\n                        </div>\n                    </a>\n                    <a ng-click="briefingDetails.toggleCurrentHistory(history, \'briefing_email_delivered, briefing_email_opened, briefing_email_clicked\')">\n                        <div class="info-wrapper">\n                            <briefing-history-activity-item history="history" activity="briefing_email_delivered, briefing_email_opened, briefing_email_clicked" label="delivered"></briefing-history-activity-item>\n                        </div>\n                    </a>\n                    <a ng-click="briefingDetails.toggleCurrentHistory(history, \'briefing_email_opened, briefing_email_clicked\')">\n                        <div class="info-wrapper">\n                            <briefing-history-activity-item history="history" activity="briefing_email_opened, briefing_email_clicked" label="opened"></briefing-history-activity-item>\n                        </div>\n                    </a>\n                    <a ng-click="briefingDetails.toggleCurrentHistory(history, \'briefing_email_clicked\')">\n                        <div class="info-wrapper">\n                            <briefing-history-activity-item history="history" activity="briefing_email_clicked" label="clicked"></briefing-history-activity-item>\n                        </div>\n                    </a>\n                    <a ng-click="briefingDetails.toggleCurrentHistory(history, \'briefing_email_bounced\')">\n                        <div class="info-wrapper">\n                            <briefing-history-activity-item history="history" activity="briefing_email_bounced" label="bounced"></briefing-history-activity-item>\n                        </div>\n                    </a>\n                    <a ng-click="briefingDetails.toggleCurrentHistory(history, \'briefing_email_dropped\')">\n                        <div class="info-wrapper">\n                            <briefing-history-activity-item history="history" activity="briefing_email_dropped" label="dropped"></briefing-history-activity-item>\n                        </div>\n                    </a>\n                </td>\n            </tr>\n            <tr ng-repeat-end ng-if="briefingDetails.currentHistory === history" class="briefing-history-info">\n                <td colspan="5"></td>\n                <td>\n                    <briefing-recipients briefing-history="history" history-index="$index" user-statuses="briefingDetails.userStatuses" history-filter="briefingDetails.currentHistoryFilter"></briefing-recipients>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n\n    <div class="flex" style="justify-content: center;" ng-hide="briefingDetails.firstPage && briefingDetails.lastPage">\n        <uib-pagination ng-if="briefingDetails.historyCount"\n                        class="pull-left"\n                        total-items="briefingDetails.historyCount"\n                        items-per-page="1"\n                        ng-change="briefingDetails.state.go(briefingDetails.state.current.name, { page: briefingDetails.currentPage })"\n                        ng-model="briefingDetails.currentPage"\n                        max-size="5"\n                        boundary-link-numbers="true"\n                        previous-text="&lsaquo;"\n                        next-text="&rsaquo;">\n        </uib-pagination>\n    </div>\n</div>\n<spinner ng-show="briefingDetails.fetchingData"></spinner>');
$templateCache.put('/templates//briefings/groups.html','<div class="tab-pane">\n    <div class="row">\n        <div class="col-md-12">\n            <nav class="navbar navbar-default" role="navigation">\n                <ul class="nav navbar-nav">\n                    <li uib-dropdown>\n                        <a data-toggle="dropdown" uib-dropdown-toggle><i class="fa fa-ellipsis-v"></i></a>\n                        <ul class="dropdown-menu" role="menu">\n                            <li ng-class="{disabled: !briefingGroups.itemsSelected()}"><a ng-click="briefingGroups.subscribe()">Subscribe</a></li>\n                            <li ng-class="{disabled: !briefingGroups.itemsSelected()}"><a ng-click="briefingGroups.unsubscribe()">Unsubscribe</a></li>\n                        </ul>\n                    </li>\n                </ul>\n                <form class="navbar-form navbar-left" role="search">\n                    <div class="form-group has-feedback">\n                        <input ng-model="briefingGroups.searchTerm" ng-change="briefingGroups.doSearch(briefingGroups.searchTerm)"\n                               ng-model-options="{debounce: 1000}" id="group-search-input" type="text"\n                               focus-me="streamGroupsSearch" class="form-control admin-table-search"\n                               placeholder="Search Groups">\n                        <a ng-click="briefingGroups.doSearch()" ng-show="briefingGroups.searchTerm"\n                           class="glyphicon glyphicon-remove-sign form-control-feedback search-clear"\n                           aria-hidden="true"></a>\n                    </div>\n                </form>\n                <ul class="nav navbar-nav">\n                    <li ng-if="!briefingGroups.filter" uib-dropdown>\n                        <a class="dropdown-toggle" tooltip-placement="top" uib-tooltip="Filter" uib-dropdown-toggle>\n                            <i class="fa fa-filter"></i>\n                        </a>\n                        <ul class="dropdown-menu" role="menu">\n                            <li>\n                                <a ng-click="briefingGroups.doFilter(\'subscribers\')">Subscriber</a>\n                            </li>\n                        </ul>\n                    </li>\n                    <li ng-if="briefingGroups.filter">\n                        <a type="button" class="btn" tooltip-placement="top" uib-tooltip="Remove filter"\n                           ng-click="briefingGroups.doFilter()">\n                            Filtered by: {{briefingGroups.filter}} <i class="fa fa-times"></i>\n                        </a>\n                    </li>\n                </ul>\n            </nav>\n            <div style="margin-top:8px;" class="row">\n                <div class="col-md-12">\n                    <div class="row">\n                        <div class="col-md-12 table-section-content">\n                            <table class="table scrollable-table fixed-table" id="group-table">\n                                <thead>\n                                <tr>\n                                    <th style="width: 10%;">Select</th>\n                                    <th style="width: 20%;" class="admin-table-header">\n                                        <sort-link label="Group"\n                                                   key="nameLower"\n                                                   sort="briefingGroups.paging.sort"\n                                                   sort-direction="briefingGroups.paging.sortDirection"\n                                                   on-sort="briefingGroups.doSort($sort, $sortDirection)"></sort-link>\n                                    </th>\n                                    <th style="width: 45%;" class="admin-table-header">\n                                        <span style="font-weight: normal">Description</span>\n                                    </th>\n                                    <th style="width: 10%;">\n                                        <sort-link label="Members"\n                                                   key="membersCount"\n                                                   sort="briefingGroups.paging.sort"\n                                                   sort-direction="briefingGroups.paging.sortDirection"\n                                                   on-sort="briefingGroups.doSort($sort, $sortDirection)"></sort-link>\n                                    </th>\n                                    <th style="width: 15%;">Subscribed</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat="group in briefingGroups.groups" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                                    <td style="width: 10%;" class="text-center select-cell"><input type="checkbox" ng-model="group.selected"></td>\n                                    <td style="width: 20%;" class="overflow-ellipsis white-space-nowrap" title="{{group.name}}">{{group.name}}</td>\n                                    <td style="width: 45%;" class="overflow-ellipsis white-space-nowrap" title="{{group.description}}">{{group.description}}</td>\n                                    <td style="width: 10%;" class="overflow-ellipsis white-space-nowrap">{{group.membersCount}}</td>\n                                    <td style="width: 15%;" class="overflow-ellipsis white-space-nowrap">\n                                        <group-briefing-subscribe-button briefing="briefingGroups.briefing" group="group" subscription-changed="briefingGroups.subscriptionChanged()"></group-briefing-subscribe-button>\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        <spinner ng-if="!briefingGroups.paging.totalElements"></spinner>\n                    </div>\n                    <div class="row" style="padding-top: 15px;">\n                        <div class="col-md-6" ng-show="groups.length">\n                            <uib-pagination ng-if="briefingGroups.paging.totalElements"\n                                            total-items="briefingGroups.pagingtotalElements"\n                                            ng-model="briefingGroups.paging.pagerPage"\n                                            items-per-page="briefingGroups.paging.rows"\n                                            ng-change="briefingGroups.paging.fetchPage()"\n                                            max-size="5"\n                                            boundary-link-numbers="true"\n                                            previous-text="&lsaquo;"\n                                            next-text="&rsaquo;">\n                            </uib-pagination>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//briefings/itemBody.html','<div class="row" ng-show="$ctrl.show">\n    <div class="col-md-10 col-md-offset-1">\n        <div class="topic-summary row">\n            <div class="col-md-12 flex">\n                <div style="flex:3; min-width: 0; margin-right: 30px;">\n                    <edit-briefing-title title="{{$ctrl.briefing.briefingTitle}}" briefing="$ctrl.briefing" on-change="$ctrl.saveBriefing($ctrl.briefing)"></edit-briefing-title>\n                    <edit-briefing-text-area-item title="{{$ctrl.briefing.subjectLine}}" label="Subject line:" briefing="$ctrl.briefing" attr="subjectLine" attr-description="email subject line" on-change="$ctrl.saveBriefing($ctrl.briefing)"></edit-briefing-text-area-item>\n                    <edit-briefing-text-area-item title="{{$ctrl.briefing.templateTitle}}" label="Briefing title:" briefing="$ctrl.briefing" attr="templateTitle" attr-description="briefing title" on-change="$ctrl.saveBriefing($ctrl.briefing)"></edit-briefing-text-area-item>\n                    <edit-briefing-text-area-item title="{{$ctrl.briefing.description}}" label="Description:" briefing="$ctrl.briefing" attr="description" attr-description="description" on-change="$ctrl.saveBriefing($ctrl.briefing)"></edit-briefing-text-area-item>\n                    <edit-briefing-commentary briefing="$ctrl.briefing" on-change="$ctrl.saveBriefing($ctrl.briefing)"></edit-briefing-commentary>\n                    <edit-briefing-text-area-item ng-if="$ctrl.showBriefingCustomConfiguration" label="{{$ctrl.briefingCustomConfigurationLabel}}:" briefing="$ctrl.briefing" attr="customConfiguration" attr-description="template custom configuration" on-change="$ctrl.saveBriefing($ctrl.briefing)"></edit-briefing-text-area-item>\n                    <div style="padding-top: 5px; padding-bottom: 20px;">\n                        <briefing-template briefing="$ctrl.briefing"></briefing-template>\n                    </div>\n                </div>\n                <div style="flex:1;">\n                    <briefing-summary briefing="$ctrl.briefing" show-publish="true" show-delete="true" open-subscribers="$ctrl.openSubscribers()" delete-briefing="$ctrl.deleteBriefing($ctrl.briefing)"></briefing-summary>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="col-md-10 col-md-offset-1">\n    <uib-tabset>\n        <uib-tab heading="History" ui-sref=".details" active="$ctrl.activeStates[\'details\']">\n            <div ui-view="details"></div>\n        </uib-tab>\n        <uib-tab heading="Sources" ui-sref=".contents" active="$ctrl.activeStates[\'contents\']">\n            <div ui-view="contents"></div>\n        </uib-tab>\n        <uib-tab heading="People" ui-sref=".people({filter: \'subscribers\'})" active="$ctrl.activeStates[\'people\']">\n            <div ui-view="people"></div>\n        </uib-tab>\n        <uib-tab heading="Groups" ui-sref=".groups" active="$ctrl.activeStates[\'groups\']">\n            <div ui-view="groups"></div>\n        </uib-tab>\n        <uib-tab heading="Schedule" ui-sref=".schedule" active="$ctrl.activeStates[\'schedule\']">\n            <div ui-view="schedule"></div>\n        </uib-tab>\n    </uib-tabset>\n</div>\n');
$templateCache.put('/templates//briefings/itemHeader.html','<ui-view name="itemHeader"></ui-view>');
$templateCache.put('/templates//briefings/itemList.html','<div class="tab-content" style="padding-top: 2em">\n    <div class="row">\n        <div class="col-md-12">\n            <div class="well well-sm" ng-if="!briefingsItemList.ongoingRequest">\n                <span><strong>{{briefingsItemList.totalElements}}</strong> Briefings</span>\n                <span style="padding-left:20px;" ng-if="briefingsItemList.publishedFilterVisible">\n                    <input type="checkbox" ng-model="briefingsItemList.itemSearchParams.published" ng-change="briefingsItemList.togglePublished()"> Published\n                </span>\n            </div>\n            <div>\n                <briefing-card ng-repeat="briefing in briefingsItemList.items track by briefing.id" briefing="briefing" user="user" template="briefingsItemList.templateMap[briefing.templateId]"></briefing-card>\n            </div>\n            <div ng-if="!briefingsItemList.ongoingRequest && briefingsItemList.items.length === 0" style="padding-top:40px;">\n                <empty-state-help title="Create a briefing"\n                                  sub-title="your audience will love"\n                                  target-sref="briefingCreate"\n                                  link-text="Briefing"></empty-state-help>\n            </div>\n        </div>\n        <spinner ng-show="briefingsItemList.ongoingRequest && briefingsItemList.items.length === 0"></spinner>\n    </div>\n</div>\n');
$templateCache.put('/templates//briefings/people.html','<div class="tab-pane" style="padding-top: 20px;">\n    <div class="row">\n        <div class="col-md-12">\n            <nav class="navbar navbar-default" role="navigation">\n                <ul class="nav navbar-nav">\n                    <li uib-dropdown>\n                        <a data-toggle="dropdown" uib-dropdown-toggle><i class="fa fa-ellipsis-v"></i>\n                        </a>\n                        <ul class="dropdown-menu" role="menu" id="action-dropdown">\n                            <li ng-class="{disabled: !briefingPeople.itemsSelected()}"><a ng-click="briefingPeople.subscribe()">Subscribe</a></li>\n                            <li ng-class="{disabled: !briefingPeople.itemsSelected()}"><a ng-click="briefingPeople.unsubscribe()">Unsubscribe</a></li>\n                        </ul>\n                    </li>\n                </ul>\n                <form class="navbar-form navbar-left" role="search">\n                    <div class="form-group has-feedback">\n                        <input ng-model="briefingPeople.searchTerm" ng-change="briefingPeople.doSearch(briefingPeople.searchTerm)" ng-model-options="{debounce: 1000}" id="people-search-input" type="text" focus-me="briefingPeopleSearch" class="form-control" placeholder="Search People">\n                        <a ng-click="briefingPeople.doSearch()" ng-show="search.searchTerm" id="clear-search" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n                    </div>\n                </form>\n                <ul class="nav navbar-nav">\n                    <li ng-if="!briefingPeople.filter" uib-dropdown>\n                        <a class="dropdown-toggle" tooltip-placement="top" uib-tooltip="Filter" uib-dropdown-toggle>\n                            <i class="fa fa-filter"></i>\n                        </a>\n                        <ul class="dropdown-menu" role="menu">\n                            <li><a ng-click="briefingPeople.doFilter(\'subscribers\')">Subscriber</a></li>\n                        </ul>\n                    </li>\n                    <li ng-if="briefingPeople.filter">\n                        <a type="button" class="btn" tooltip-placement="top" uib-tooltip="Remove filter" ng-click="briefingPeople.doFilter()">\n                            Filtered by: {{briefingPeople.filter}} <i class="fa fa-times"></i>\n                        </a>\n                    </li>\n                </ul>\n            </nav>\n            <div style="margin-top:8px;" class="row">\n                <div class="col-md-12">\n                    <div class="row">\n                        <div class="col-md-12 table-section-content">\n                            <table class="table scrollable-table" id="people-table">\n                                <thead>\n                                <tr>\n                                    <th style="width:10%; text-align: center;">\n                                        <input type="checkbox"\n                                               ng-model="briefingPeople.selectAll"\n                                               ng-change="briefingPeople.selectAllChanged(briefingPeople.selectAll)">\n                                    </th>\n                                    <th style="width:25%;" class="admin-table-header">\n                                        <sort-link label="First Name"\n                                                   key="firstNameLower"\n                                                   sort="briefingPeople.paging.sort"\n                                                   sort-direction="briefingPeople.paging.sortDirection"\n                                                   on-sort="briefingPeople.doSort($sort, $sortDirection)"></sort-link>\n                                    </th>\n                                    <th style="width:25%;" class="admin-table-header">\n                                        <sort-link label="Last Name"\n                                                   key="lastNameLower"\n                                                   sort="briefingPeople.paging.sort"\n                                                   sort-direction="briefingPeople.paging.sortDirection"\n                                                   on-sort="briefingPeople.doSort($sort, $sortDirection)"></sort-link>\n                                    </th>\n                                    <th style="width:20%;">\n                                        <sort-link label="Email Address"\n                                                   key="emailAddress"\n                                                   sort="briefingPeople.paging.sort"\n                                                   sort-direction="briefingPeople.paging.sortDirection"\n                                                   on-sort="briefingPeople.doSort($sort, $sortDirection)"></sort-link>\n                                    </th>\n                                    <th style="width:20%;">Subscribed</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat="user in briefingPeople.users" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                                    <td style="width:10%;" class="text-center select-cell"><input type="checkbox" ng-model="user.selected" ng-change="briefingPeople.selectAll = false"></td>\n                                    <td style="width:25%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.firstName}}">{{::user.firstName}}</td>\n                                    <td style="width:25%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.lastName}}">{{::user.lastName}}</td>\n                                    <td style="width:20%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.emailAddress}}">{{::user.emailAddress}}</td>\n                                    <td style="width:20%;" class="white-space-nowrap">\n                                        <briefing-subscribe-button briefing="briefingPeople.briefing" user="user" subscription-changed="briefingPeople.subscriptionChanged()"></briefing-subscribe-button>\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        <spinner ng-if="briefingPeople.fetching"></spinner>\n                    </div>\n                        <div ng-if="!briefingPeople.paging.totalElements && !briefingPeople.fetching" class="flex-center"><h3>No matching users.</h3></div>\n                    <div class="row" style="padding-top: 15px;">\n                        <div class="col-md-offset-5 col-md-6" ng-show="briefingPeople.users.length && !(briefingPeople.paging.first && briefingPeople.paging.last)">\n                            <uib-pagination ng-if="briefingPeople.paging.totalElements"\n                                            total-items="briefingPeople.paging.totalElements"\n                                            ng-model="briefingPeople.paging.pagerPage"\n                                            items-per-page="briefingPeople.paging.rows"\n                                            ng-change="briefingPeople.fetchPage()"\n                                            max-size="5"\n                                            boundary-link-numbers="true"\n                                            previous-text="&lsaquo;"\n                                            next-text="&rsaquo;">\n                            </uib-pagination>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//briefings/schedule.html','<div style="padding-top: 20px">\n    <form name="form" role="form" autocomplete="off" class="form">\n        <briefing-edit-details\n                briefing="briefingSchedule.briefing"\n                briefing-schedule="briefingSchedule.briefingSchedule"\n                hide-non-schedule-items="true"\n                form="form"\n                end-mode-changed="briefingSchedule.endModeChanged()"\n                frequency-changed="briefingSchedule.frequencyChanged()"\n                selected-days="briefingSchedule.selectedDays"\n                selected-template="briefingSchedule.selectedTemplate()">\n        </briefing-edit-details>\n        <div class="row">\n            <div class="col-md-12">\n                <div class="pull-right">\n                    <button class="btn btn-default" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Send briefing to all subscribers." ng-disabled="!briefingSchedule.briefing.id || briefingSchedule.processing || briefingSchedule.briefingSchedule.defaultSchedule" ng-click="briefingSchedule.sendBriefingNow()">Send Now</button>\n                    <button class="btn btn-default" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Send briefing to just you." ng-disabled="!briefingSchedule.briefing.id || briefingSchedule.processing" ng-click="briefingSchedule.sendBriefingPreviewNow()">Send Preview</button>\n                    <button class="btn btn-default" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="View preview" ng-disabled="!briefingSchedule.briefing.id || briefingSchedule.processing" ng-click="briefingSchedule.viewBriefingPreview()">View Preview</button>\n                    <button class="btn btn-primary" ng-disabled="briefingSchedule.processing || form.$invalid" ng-click="briefingSchedule.saveBriefingSchedule()">Save</button>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>');
$templateCache.put('/templates//briefings/search.html','<div class="row" style="padding-top:10px;">\n    <div class="col-sm-8 col-sm-offset-2">\n        <form ng-submit="briefingsSearch.state.go(briefingsSearch.state.current.name, { searchTerm: briefingsSearch.searchTerm, filter: briefingsSearch.filter })">\n            <a show-with-permission action="MANAGE_TENANT" class="btn btn-primary pull-left" style="margin-right: 30px; display: block;" type="button" ui-sref="briefingCreate"><span class="fa fa-plus"></span> Briefing</a>\n            <div class="input-group input-group-lg">\n                <input type="text" class="form-control"\n                       placeholder="Enter keyword"\n                       ng-model="briefingsSearch.searchTerm"\n                       ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }"\n                       on-delayed-change="briefingsSearch.state.go(briefingsSearch.state.current.name, { searchTerm: briefingsSearch.searchTerm, filter: briefingSearch.filter })">\n                <div class="input-group-btn" uib-dropdown>\n                    <button type="button" class="btn btn-default" uib-dropdown-toggle>\n                        <span>{{briefingsSearch.filter || \'Filter\'}}</span> <span class="caret"></span>\n                    </button>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ng-repeat="filter in briefingsSearch.filters">\n                            <a ng-click="briefingsSearch.state.go(briefingsSearch.state.current.name, { searchTerm: briefingsSearch.searchTerm, filter: filter })">{{filter}}</a>\n                        </li>\n                        <li ng-show="briefingsSearch.filter">\n                            <a ng-click="briefingsSearch.state.go(briefingsSearch.state.current.name, { searchTerm: briefingsSearch.searchTerm, filter: undefined })">Clear <i class="fa fa-close"></i></a>\n                        </li>\n                    </ul>\n                    <button class="btn btn-primary" ng-click="contentSearchCtrl.save()" type="submit">\n                        <span class="fa fa-search"></span>\n                    </button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('/templates//directives/categoryCard.html','');
$templateCache.put('/templates//invitations/briefingInvitation.html','<md-toolbar>\r\n    <div class="md-toolbar-tools">\r\n        <div flex="50">\r\n            <h4 flex>Share Briefing</h4>\r\n        </div>\r\n        <div flex="auto" layout="row" layout-align="end center">\r\n            {{$ctrl.badEmailMessage}}\r\n            <md-button ng-if="!$ctrl.user" ng-click="$ctrl.logIn()">Log In</md-button>\r\n            <md-button ng-if="$ctrl.user" ng-click="$ctrl.logOut()">Logout</md-button>\r\n        </div>\r\n    </div>\r\n</md-toolbar>\r\n<div layout="column" flex="grow" ng-form="form">\r\n    <spinner ng-if="$ctrl.noTouching"></spinner>\r\n    <div layout="row" flex ng-if="!$ctrl.noTouching">\r\n        <div ng-if="!$ctrl.user" flex layout-padding layout="column" layout-align="center center">\r\n            <h3 flex>You must log in to share a briefing.</h3>\r\n        </div>\r\n        <div flex-offset="20" flex="60" layout="column" ng-if="$ctrl.user">\r\n            <div layout="column" flex >\r\n                <h3>Share Briefing: {{$ctrl.briefing.briefingTitle}} with others</h3>\r\n            </div>\r\n            <div layout="column" layout-padding>\r\n                <md-chips name="addresses"\r\n                          ng-model="$ctrl.invitation.emails"\r\n                          placeholder="Email address"\r\n                          md-add-on-blur="true"\r\n                          md-on-add="$ctrl.validateEmails()"\r\n                          md-on-remove="$ctrl.validateEmails()"\r\n                          md-separator-keys="$ctrl.customKeys"\r\n                          md-auto-focus\r\n                          required>\r\n                </md-chips>\r\n\r\n                <md-input-container ng-if="$ctrl.badEmailMessage"\r\n                                    class="ng-invalid ng-invalid-required md-input-invalid">\r\n                    <div class="md-input-messages md-input-messages-animation ng-active">\r\n                        <div>{{$ctrl.badEmailMessage}}</div>\r\n                    </div>\r\n                </md-input-container>\r\n            </div>\r\n            <div layout="row" layout-padding>\r\n                <md-input-container flex="grow">\r\n                    <label style="font-weight: normal; padding-left: 11px; font-size: 16px;">Message (Optional)</label>\r\n                    <textarea md-no-resize="false" ng-model="$ctrl.invitation.message"></textarea>\r\n                </md-input-container>\r\n            </div>\r\n            <div layout="row" flex>\r\n                <md-button class="md-primary md-raised"\r\n                           ng-disabled="$ctrl.badEmailMessage || !$ctrl.invitation.emails.length"\r\n                           ng-click="$ctrl.sendInvitation()">\r\n                    Send\r\n                </md-button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//groups/basics.html','<form name="form" role="form" enctype="multipart/form-data" autocomplete="off">\n    <div class="row">\n        <alerts watch-for="group-detail-alerts"></alerts>\n    </div>\n    <div class="form-group has-feedback">\n        <label for="group-name">Group Name</label>\n        <div class="has-feedback" ng-messages="form.name.$error">\n            <div ng-message="required" class="form-control-feedback glyphicon glyphicon-asterisk"></div>\n            <div ng-if="form.name.$valid" class="form-control-feedback glyphicon glyphicon-ok"></div>\n        </div>\n        <input type="text" class="form-control" id="group-name" name="name" placeholder="Group Name" ng-model="group.name" required>\n        <div ng-if="form.name.$touched">\n            <div class="has-error" ng-messages="form.name.$error">\n                <small class="help-block" ng-message="required">Group Name is required and cannot be empty</small>\n            </div>\n        </div>\n    </div>\n    <div class="form-group">\n        <label for="group-description">Group Description</label>\n        <textarea name="description" id="group-description" class="description-textarea form-control" placeholder="Group Description" ng-model="group.description"></textarea>\n    </div>\n</form>\n');
$templateCache.put('/templates//groups/briefings.html','<div class="row" ng-controller="EditGroupBriefingsCtrl as $ctrl">\n    <div class="row hidden-sm hidden-xs" scrolled>\n        <div class="col-md-2 col-md-offset-10">\n            <label><input type="checkbox" ng-model="$ctrl.fetchAll" ng-change="$ctrl.briefingFetcherChanged()"> Show All</label>\n        </div>\n    </div>\n    <div class="col-md-12 table-section-content">\n        <table class="table scrollable-table" id="briefing-table">\n            <thead>\n                <tr>\n                    <th style="width: 20%;">\n                        <sort-people-by label="\'Stream\'" sort="$ctrl.sort" sort-key="\'titleLower\'" sort-by="$ctrl.toggleSort" initial-sort="true"></sort-people-by>\n                    </th>\n                    <th style="width: 20%;">\n                        <label>Schedule</label>\n                    </th>\n                    <th style="width: 20%;">\n                        <sort-people-by label="\'Last Sent\'" sort="$ctrl.sort" sort-key="\'briefingLastSentDate\'" sort-by="$ctrl.toggleSort"></sort-people-by>\n                    </th>\n                    <th style="width: 20%;">\n                        <sort-people-by label="\'Next Scheduled\'" sort="$ctrl.sort" sort-key="\'briefingSchedule.nextScheduledDate\'" sort-by="$ctrl.toggleSort"></sort-people-by>\n                    </th>\n                    <th class="pull-right" style="width: 20%"></th>\n                </tr>\n            </thead>\n            <tbody class="on-modal briefings-infinite-scroll-container" infinite-scroll="$ctrl.nextPage()" infinite-scroll-distance="1" infinite-scroll-disabled="$ctrl.last" infinite-scroll-container=\'".briefings-infinite-scroll-container"\' style="height: 400px">\n                <tr ng-if="$ctrl.noSubscribedBriefings && !$ctrl.fetchAll">\n                    <th style="padding-top: 0px;">\n                        <div class="alert alert-warning alert-dismissible" role="alert">\n                            <p class="normal-font-weight">Group currently not subscribed to any briefings</p>\n                        </div>\n                    </th>\n                </tr>\n                <tr ng-repeat="briefing in $ctrl.briefings">\n                    <!-- TODO the title should link to stream builder modal opened to briefing tab -->\n                    <td class="overflow-ellipsis" style="width: 20%;" title="{{::briefing.briefingTitle}}">\n                        <a ui-sref="briefingItem.details({briefingId: briefing.id})"\n                           style="display: inline-block; max-width: 600px; overflow-x: hidden; text-overflow: ellipsis;">{{::briefing.briefingTitle}}</a>\n                    </td>\n                    <td style="width: 20%;">{{::$ctrl.filteredFrequencies(briefing.schedule)}}</td>\n                    <td style="width: 20%">{{::briefing.lastSentDate | amDateFormat:\'MMM Do YYYY, h:mm a\'}}</td>\n                    <td style="width: 20%">{{::briefing.schedule.nextScheduledDate | amDateFormat:\'MMM Do YYYY, h:mm a\'}}</td>\n                    <td class="pull-right" style="width: 20%">\n                        <span id="tooltip-wrapper" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{briefing.groupIsSubscribed ? \'Unsubscribe to briefing\' : \'Subscribe to briefing\'}}">\n                            <button type="button" data-loading-text="Saving..." class="btn btn-xs btn-default catalog-stream-subscribe-button table" ng-class="{active: briefing.groupIsSubscribed}" ng-click="$ctrl.toggleBriefingSubscription(briefing)" blur-me>{{briefing.groupIsSubscribed ? \'Unsubscribe\' : \'Subscribe\'}}</button>\n                        </span>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('/templates//groups/members.html','<div class="row">\n    <div class="col-md-12 table-section-content">\n        <nav class="navbar navbar-default" role="navigation">\n            <div class="container-fluid">\n                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">\n                    <form class="navbar-form navbar-left" role="search">\n                        <div class="form-group has-feedback input-group">\n                            <input id="admin-table-search-input" type="text" class="form-control admin-table-search" placeholder="Search People" ng-model="search.searchTerm" ng-change="searchUser()" ng-model-options="{debounce: 1000}" clear-input>\n                            <a ng-click="clearSearch()" ng-show="search.searchTerm" class="glyphicon glyphicon-remove-sign form-control-feedback members-clear search-clear" aria-hidden="true"></a>\n                        </div>\n                    </form>\n                    <button class="btn btn-primary pull-right edit-members" ng-click="addMembersTable()">Edit Members</button>\n                    <ul class="nav navbar-nav navbar-right">\n                        <li role="presentation" class="members-count">\n                            <label>{{(!group.members.length || group.members.length < 2) ? (group.members.length === 1 ? \'1 Member\' : \'0 Members\') : (group.members.length + \' Members\')}}</label>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </nav>\n        <table class="table scrollable-table" id="people-table">\n            <thead>\n                <tr>\n                    <th style="width:18%;">\n                        <sort-people-by label="\'First Name\'" sort="sort" sort-key="\'firstNameLower\'" sort-by="sortByOthers"></sort-people-by>\n                    </th>\n                    <th style="width:18%;">\n                        <sort-people-by label="\'Last Name\'" sort="sort" sort-key="\'lastNameLower\'" sort-by="sortByOthers"></sort-people-by>\n                    </th>\n                    <th style="width:50%;">\n                        <sort-people-by label="\'Email Address\'" sort="sort" sort-key="\'emailAddress\'" sort-by="sortByOthers"></sort-people-by>\n                    </th>\n                    <th style="width:14%;">\n                        <sort-people-by label="\'Status\'" sort="sort" sort-key="\'status\'" sort-by="sortByOthers"></sort-people-by>\n                    </th>\n                </tr>\n            </thead>\n            <tbody class="on-modal people-table-infinite-scroll-container" infinite-scroll="nextPage()" infinite-scroll-distance="1" infinite-scroll-container=\'".people-table-infinite-scroll-container"\'>\n                <tr ng-repeat="user in users" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                    <td style="width:18%;" class="overflow-ellipsis white-space-nowrap" title="{{user.firstName}}">{{user.firstName}}</td>\n                    <td style="width:18%;" class="overflow-ellipsis white-space-nowrap" title="{{user.lastName}}">{{user.lastName}}</td>\n                    <td style="width:50%;" class="overflow-ellipsis white-space-nowrap" title="{{user.emailAddress}}">{{user.emailAddress}}</td>\n                    <td style="width:14%;" class="white-space-nowrap">{{user.status}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('/templates//groups/streams.html','<div ng-controller="EditGroupStreamsCtrl as $ctrl">\n    <div class="row hidden-sm hidden-xs user-streams-table-panel-header" scrolled>\n        <div class="col-md-2 col-md-offset-10">\n            <label><input type="checkbox" ng-model="$ctrl.fetchAll" ng-change="$ctrl.streamFetcherChanged()"> Show All</label>\n        </div>\n    </div>\n    <div class="row hidden-sm hidden-xs user-streams-table-panel-header" scrolled>\n        <div class="col-md-4 col-md-offset-1">\n            <a ng-click="$ctrl.toggleSort(\'titleLower\')">\n                <i class="fa" ng-class="{\'fa-sort\': ($ctrl.params.sort !== \'titleLower\'), \'fa-sort-asc\': $ctrl.isSort(\'titleLower\', \'ASC\'), \'fa-sort-desc\': $ctrl.isSort(\'titleLower\', \'DESC\') }"></i> Title\n            </a>\n        </div>\n        <div class="col-md-1">\n            <strong>Type</strong>\n        </div>\n        <div class="col-md-1">\n            <i class="fa fa-book"></i>\n        </div>\n        <div class="col-md-1">\n            <a ng-click="$ctrl.toggleSort(\'followersCount\')" title="Followers">\n                <i class="fa" ng-class="{\'fa-sort\': ($ctrl.params.sort !== \'followersCount\'), \'fa-sort-asc\': $ctrl.isSort(\'followersCount\', \'ASC\'), \'fa-sort-desc\': $ctrl.isSort(\'followersCount\', \'DESC\') }"></i> <span class="glyphicon glyphicon-user"></span>\n            </a>\n        </div>\n        <div class="col-md-1">\n            <a ng-click="$ctrl.toggleSort(\'itemsCount\')" title="Items">\n                <i class="fa" ng-class="{\'fa-sort\': ($ctrl.params.sort !== \'itemsCount\'), \'fa-sort-asc\': $ctrl.isSort(\'itemsCount\', \'ASC\'), \'fa-sort-desc\': $ctrl.isSort(\'itemsCount\', \'DESC\') }"></i> <span class="fa fa-copy"></span>\n            </a>\n        </div>\n        <div class="col-md-3">\n            <input type="text" class="form-control" placeholder="Search" ng-model="$ctrl.params.term" size="80" enter-key="$ctrl.searchStreams()" on-delayed-change="$ctrl.searchStreams()">\n            <a ng-click="$ctrl.clearSearch()" ng-show="$ctrl.params.term" id="streams-search-clear" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n        </div>\n    </div>\n    <div class="position-relative clearfix stream-table people-table-infinite-scroll-container" infinite-scroll="$ctrl.nextPage()" infinite-scroll-distance="1" infinite-scroll-disabled="$ctrl.last" infinite-scroll-container=\'".stream-table"\'>\n        <div ng-show="$ctrl.notFollowingStreams" class="alert alert-warning alert-dismissible" role="alert">\n            Group currently not following any streams\n        </div>\n        <div ng-repeat="stream in $ctrl.streams">\n            <div class="row streams-table-row">\n                <div class="col-md-1 hidden-sm hidden-xs">\n                    <div ng-if="::thumbnailImageAttachmentId || stream.thumbnailImage.uri" class="stream-table-image pull-left">\n                        <ng-include src="\'/templates/streamImageThumbnail.html\'"></ng-include>\n                    </div>\n                </div>\n                <div class="col-md-4 col-xs-5">\n                    <stream-name stream="stream"></stream-name>\n                </div>\n                <div class="hidden-sm hidden-xs col-md-1">\n                    <stream-type-indicator stream="::stream"></stream-type-indicator>\n                </div>\n                <div class="hidden-sm hidden-xs col-md-1">\n                    <span ng-show="stream.published" class="fa fa-check catalog-stream-published" title="Published"></span>\n                </div>\n                <div class="hidden-lg hidden-md col-md-1">\n                    <stream-type-indicator stream="::stream"></stream-type-indicator>\n                    <span ng-show="stream.published" class="fa fa-check catalog-stream-published" title="Published"></span>\n                </div>\n                <div class="col-md-1 col-xs-1">\n                    <group-stream-followers stream="stream"></group-stream-followers>\n                </div>\n                <div class="col-md-1 col-xs-1">\n                <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Articles">\n                    <span id="itemsCount">{{::stream.itemsCount}}</span>\n                </span>\n                </div>\n                <div class="col-md-1">\n                    <a ng-show="stream.rssEnabled" target="_blank" href="/rss/{{stream.id}}" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="RSS Feed">\n                        <i class="fa fa-rss"></i>\n                    </a>\n                    <span ng-show="!stream.rssEnabled" class="gluphicon glyphicon-none"></span>\n                    <span ng-show="stream.briefingEnabled" class="fa fa-envelope-o" title="Briefings"></span>\n                </div>\n                <div class="col-md-2">\n                    <ul class="list-inline pull-right">\n                        <li>\n                        <span id="tooltip-wrapper" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{stream.groupIsFollowing ? \'Unfollow this stream\' : \'Follow this stream\'}}">\n                            <button type="button" data-loading-text="Saving..." class="btn btn-xs btn-default catalog-stream-subscribe-button table" ng-class="{active: stream.groupIsFollowing}" ng-click="$ctrl.followGroup(stream)" blur-me>\n                                {{stream.groupIsFollowing ? \'Unfollow\' : \'Follow\'}}\n                            </button>\n                        </span>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//myTopics/base.html','<div class="topic-state">\r\n    <ng-include ng-controller="TopicSidebarCtrl as topicSidebar" src="\'/templates/myTopics/topicSidebar.html\'"></ng-include>\r\n    <div class="col-sm-8 col-md-9" initial-view-visible="false" target-state="mytopics.recent">\r\n        <ng-include ng-controller="TopicSearchCtrl as topicSearch" src="\'/templates/myTopics/search.html\'"></ng-include>\r\n        <ui-view name="summary"></ui-view>\r\n        <ui-view name="controlbar" ng-if="!uiState.current.data.hideControlbar"></ui-view>\r\n        <div ng-if="!uiState.includes(\'mytopics.editTopic\')" class="row mytopic-scroll-container" full-height style="overflow-y: auto;" additional-padding="{{ uiState.current.data.additionalPadding || 220 }}">\r\n            <div class="col-md-12 topic-item-list">\r\n                <ui-view name="itemList"></ui-view>\r\n                <ui-view name="noResults"></ui-view>\r\n            </div>\r\n        </div>\r\n        <div ng-if="uiState.includes(\'mytopics.editTopic\')" class="row" style="padding-top:20px;">\r\n            <div class="col-md-12 topic-item-list">\r\n                <ui-view name="itemList"></ui-view>\r\n                <ui-view name="noResults"></ui-view>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="col-sm-8 col-md-9" initial-view-visible="true" target-state="mytopics.recent">\r\n        <p class="text-center" style="padding-top:60px;">\r\n            <strong>Looks like you have not created any sources or topics yet. </strong> \r\n        </p>\r\n        <p class="text-center" style="padding-top:20px;">\r\n            <a ui-sref="streams">Create one now</a>\r\n        </p>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//myTopics/controlbar.html','<div class="row">\r\n        <topic-control-bar topic="topic.mainStream" curate="true"></topic-control-bar>\r\n</div>\r\n');
$templateCache.put('/templates//myTopics/exploreSummary.html','<div class="row">\r\n    <div class="col-sm-8 col-sm-offset-2">\r\n        <h4 style="display: inline-block">\r\n            <ul class="list-inline">\r\n                <li>Search Only:</li>\r\n                <li>\r\n                    <input type="checkbox" ng-model="exploreSummary.restrictToSubscribed" ng-change="exploreSummary.restrictToSubscribedChanged()" clss="form-control" style="margin-right: 0.5em">Topics I Follow\r\n                </li>\r\n                <li ng-if="exploreSummary.catalogs.length">\r\n                    <input type="checkbox" ng-model="exploreSummary.restrictToSite" ng-change="exploreSummary.restrictToSiteChanged()" clss="form-control" style="margin-right: 0.5em">Site\r\n                </li>\r\n            </ul>\r\n        </h4>\r\n        <span class="pull-right" style="padding-top:8px;" show-with-permission action="CREATE_STREAM">\r\n            <create-topic-from-search-button term="exploreSummary.searchTerm" tags="exploreSummary.tags" items="exploreSummary.items" spin="exploreSummary.spin(shouldSpin)"></create-topic-from-search-button>\r\n        </span>\r\n    </div>\r\n</div>\r\n<div class="topic-summary row">\r\n    <div class="col-md-4">\r\n        <div class="custom-item-list">\r\n            <div class="icon-wrapper">\r\n                <h4><i class="glyphicon glyphicon-search"></i></h4>\r\n            </div>\r\n            <div classs="label-wrapper">\r\n                <h4><span>Explore</span> <list-count></list-count></h4>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div style="padding-top:10px;" class="row">\r\n    <div class="col-md-4 form-group" ng-if="exploreSummary.tags.concepts.length">\r\n        <label>Concepts:</label>\r\n        <ui-select multiple ng-model="exploreSummary.tags.concepts" theme="bootstrap" on-remove="exploreSummary.tagsChanged()" on-select="exploreSummary.tagsChanged()">\r\n            <ui-select-match placeholder="Select one or more tags to narrow results">{{$item.tagText}}</ui-select-match>\r\n            <ui-select-choices repeat="tag in exploreSummary.concepts | filter: $select.search track by tag.tagText">\r\n                <span ng-bind-html="tag.tagText | highlight: $select.search"></span>\r\n            </ui-select-choices>\r\n        </ui-select>\r\n    </div>\r\n    <div class="col-md-4 form-group" ng-if="exploreSummary.tags.topics.length">\r\n        <label>Types:</label>\r\n        <ui-select multiple ng-model="exploreSummary.tags.topics" theme="bootstrap" on-remove="exploreSummary.tagsChanged()" on-select="exploreSummary.tagsChanged()">\r\n            <ui-select-match placeholder="Select one or more tags to narrow results">{{$item.displayText}}</ui-select-match>\r\n            <ui-select-choices repeat="tag in exploreSummary.topicTags | filter: $select.search track by tag.tagText">\r\n                <span ng-bind-html="tag.displayText | highlight: $select.search"></span>\r\n            </ui-select-choices>\r\n        </ui-select>\r\n    </div>\r\n    <div class="col-md-4 form-group" ng-if="exploreSummary.tags.entities.length">\r\n        <label>Entities:</label>\r\n        <ui-select multiple ng-model="exploreSummary.tags.entities" theme="bootstrap" on-remove="exploreSummary.tagsChanged()" on-select="exploreSummary.tagsChanged()">\r\n            <ui-select-match placeholder="Select one or more tags to narrow results">{{$item.tagText}}</ui-select-match>\r\n            <ui-select-choices repeat="tag in exploreSummary.entities | filter: $select.search track by tag.tagText">\r\n                <span ng-bind-html="tag.displayText | highlight: $select.search"></span>\r\n            </ui-select-choices>\r\n        </ui-select>\r\n    </div>\r\n    <div class="col-md-4 form-group" ng-if="exploreSummary.tags.keywords.length">\r\n        <label>Keywords:</label>\r\n        <ui-select multiple ng-model="exploreSummary.tags.keywords" theme="bootstrap" on-remove="exploreSummary.tagsChanged()" on-select="exploreSummary.tagsChanged()">\r\n            <ui-select-match placeholder="Select one or more tags to narrow results">{{$item.tagText}}</ui-select-match>\r\n            <ui-select-choices repeat="tag in exploreSummary.socialTag | filter: $select.search track by tag.tagText">\r\n                <span ng-bind-html="tag.displayText | highlight: $select.search"></span>\r\n            </ui-select-choices>\r\n        </ui-select>\r\n    </div>\r\n    <div class="col-md-4 form-group" ng-if="exploreSummary.tags.socialTag.length">\r\n        <label>Subjects:</label>\r\n        <ui-select multiple ng-model="exploreSummary.tags.socialTag" theme="bootstrap" on-remove="exploreSummary.tagsChanged()" on-select="exploreSummary.tagsChanged()">\r\n            <ui-select-match placeholder="Select one or more tags to narrow results">{{$item.tagText}}</ui-select-match>\r\n            <ui-select-choices repeat="tag in exploreSummary.socialTag | filter: $select.search track by tag.tagText">\r\n                <span ng-bind-html="tag.displayText | highlight: $select.search"></span>\r\n            </ui-select-choices>\r\n        </ui-select>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//myTopics/itemList.html','<div class="position-relative" infinite-scroll="topicItemList.fetchPage()" infinite-scroll-disabled="topicItemList.isLastPage || topicItemList.ongoingRequest" infinite-scroll-immediate-check="false" infinite-scroll-container="\'.mytopic-scroll-container\'">\r\n    <topic-item-list-contents\r\n            current-topic-id="topicItemList.currentTopicId"\r\n            items="topicItemList.items"\r\n            item-search-params="topicItemList.itemSearchParams"\r\n            searching="topicItemList.searching"\r\n            topic="topicItemList.topic"\r\n            toggle-item-visibility="topicItemList.toggleItemVisibility(item)"\r\n            fetch-page="topicItemList.fetchPage()">\r\n    </topic-item-list-contents>\r\n</div>\r\n');
$templateCache.put('/templates//myTopics/noResults.html','<no-results ng-show="!results.searching && results.totalElements === 0" message="{{results.noResultsBaseMessage}}"></no-results>\r\n');
$templateCache.put('/templates//myTopics/popularItemsSummary.html','<div class="topic-summary row">\r\n    <div class="col-md-8">\r\n        <div class="custom-item-list">\r\n            <div class="icon-wrapper">\r\n                <h4><i class="glyphicon glyphicon-signal"></i></h4>\r\n            </div>\r\n            <div classs="label-wrapper">\r\n                <h4><span>Most Popular</span> <list-count></list-count></h4>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>');
$templateCache.put('/templates//myTopics/recentUpdatesSummary.html','<div class="topic-summary row">\r\n    <div class="col-md-8">\r\n        <div class="custom-item-list">\r\n            <div class="icon-wrapper">\r\n                <h4><i class="glyphicon glyphicon-time"></i></h4>\r\n            </div>\r\n            <div classs="label-wrapper">\r\n                <h4><span>Recent Updates</span> <list-count></list-count></h4>\r\n            </div>\r\n        </div>\r\n\r\n        <a ng-click="summary.markNowAsCreatedAfter()">Mark all read</a>\r\n    </div>\r\n</div>');
$templateCache.put('/templates//myTopics/recommendedItemsSummary.html','<div class="topic-summary row">\r\n    <div class="col-md-8">\r\n        <div class="custom-item-list">\r\n            <div class="icon-wrapper">\r\n                <h4><i class="glyphicon glyphicon-certificate"></i></h4>\r\n            </div>\r\n            <div classs="label-wrapper">\r\n                <h4><span>Recommended</span></h4>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>');
$templateCache.put('/templates//myTopics/savedItemsSummary.html','<div class="topic-summary row">\r\n    <div class="col-md-8">\r\n        <div class="custom-item-list">\r\n            <div class="icon-wrapper">\r\n                <h4><i class="glyphicon glyphicon-bookmark"></i></h4>\r\n            </div>\r\n            <div classs="label-wrapper">\r\n                <h4><span>Saved Items</span> <list-count></list-count></h4>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>');
$templateCache.put('/templates//myTopics/search.html','<div class="row" style="padding-top:10px;">\r\n    <div class="col-sm-8 col-sm-offset-2">\r\n        <form ng-submit="topicSearch.state.go(\'mytopics.explore\', { searchTerm: topicSearch.searchTerm, streamId: topicSearch.streamId, tags: topicSearch.tags , tag: topicSearch.tag, siteOnly: topicSearch.siteOnly, followedOnly: topicSearch.followedOnly }, { inherit: false })">\r\n            <div class="input-group input-group-lg">\r\n                <input type="text"\r\n                       class="form-control"\r\n                       placeholder="Search for content"\r\n                       ng-model="topicSearch.searchTerm"\r\n                       on-delayed-change="topicSearch.state.go(\'mytopics.explore\', { searchTerm: topicSearch.searchTerm, streamId: topicSearch.streamId, tags: topicSearch.tags, tag: topicSearch.tag, siteOnly: topicSearch.siteOnly, followedOnly: topicSearch.followedOnly }, { inherit: false })">\r\n                <span class="input-group-btn">\r\n                    <button class="btn btn-secondary" type="submit">\r\n                        <span class="fa fa-search"></span>\r\n                    </button>\r\n                </span>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>');
$templateCache.put('/templates//myTopics/topicSidebar.html','<div class="col-sm-4 col-md-3 topic-sidebar-column my-topic-sidebar" full-height style="background-color: #F4F4F5; overflow-y: auto;" additional-padding="70">\r\n    <div>\r\n        <div class="custom-item-lists">\r\n            <div class="custom-item-list" ui-sref-active="active">\r\n                <div class="icon-wrapper">\r\n                    <h4><i class="glyphicon glyphicon-time"></i></h4>\r\n                </div>\r\n                <div classs="label-wrapper">\r\n                    <h4><span><a ui-sref="mytopics.recent">Recent Updates</a></span></h4>\r\n                </div>\r\n            </div>\r\n            <div class="custom-item-list" ui-sref-active="active">\r\n                <div class="icon-wrapper">\r\n                    <h4><i class="glyphicon glyphicon-search"></i></h4>\r\n                </div>\r\n                <div classs="label-wrapper">\r\n                    <h4><span><a ui-sref="mytopics.explore">Explore</a></span></h4>\r\n                </div>\r\n            </div>\r\n            <div class="custom-item-list" ui-sref-active="active">\r\n                <div class="icon-wrapper">\r\n                    <h4><i class="glyphicon glyphicon-bookmark"></i> </h4>\r\n                </div>\r\n                <div classs="label-wrapper">\r\n                    <h4><span><a ui-sref="mytopics.saved">Saved Items</a></span></h4>\r\n                </div>\r\n            </div>\r\n            <div class="custom-item-list" ui-sref-active="active">\r\n                <div class="icon-wrapper">\r\n                    <h4><i class="glyphicon glyphicon-certificate"></i></h4>\r\n                </div>\r\n                <div classs="label-wrapper">\r\n                    <h4><span><a ui-sref="mytopics.recommended">Recommended</a></span></h4>\r\n                </div>\r\n            </div>\r\n            <div class="custom-item-list" ui-sref-active="active">\r\n                <div class="icon-wrapper">\r\n                    <h4><i class="glyphicon glyphicon-signal"></i></h4>\r\n                </div>\r\n                <div class="label-wrapper">\r\n                    <h4><span><a ui-sref="mytopics.waypopular">Most Popular</a></span></h4>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <uib-accordion close-others="false">\r\n            <span show-with-permission action="CREATE_STREAM">\r\n                <uib-accordion-group is-open="topicSidebar.openMap.managed">\r\n                    <uib-accordion-heading>\r\n                        <div class="custom-item-list">\r\n                            <div class="icon-wrapper" style="color:black; padding-left:0px;">\r\n                                <h4><i class="glyphicon glyphicon-briefcase"></i></h4>\r\n                            </div>\r\n                            <div classs="label-wrapper">\r\n                                <h4>Topics I Own <span ng-show="topicSidebar.managedStreams">({{topicSidebar.managedStreams.length}})</span> <span><a ui-sref="seedTopic"><i style="top: 4px;" class="glyphicon glyphicon-plus-sign"></i></a></span></h4>\r\n                            </div>\r\n                        </div>\r\n                    </uib-accordion-heading>\r\n                    <ul ng-repeat="stream in topicSidebar.managedStreams | orderBy: \'title\' track by stream.id">\r\n                        <li ng-class="{ \'selected-stream\': stream.id === topicSidebar.streamId }">\r\n                            <div class="flex">\r\n                                <div ng-if="stream.thumbnailImage.uri" ng-style="{ \'background-image\':\'url(\' + stream.thumbnailImage.uri + \')\' }" class="stream-image-small"></div>\r\n                                <div ng-if="!stream.thumbnailImage.uri" style="background-color: transparent;" class="stream-image-small"></div>\r\n                                <div style="flex:2; padding-left: 20px;"><a ui-sref="mytopics.topic({streamId: stream.id})" ui-sref-opts="{inherit: false}">{{stream.title}}</a></div>\r\n                            </div>\r\n                        </li>\r\n                    </ul>\r\n                </uib-accordion-group>\r\n            </span>\r\n            <uib-accordion-group is-open="topicSidebar.openMap.following">\r\n                <uib-accordion-heading>\r\n                    <div class="custom-item-list">\r\n                        <div class="icon-wrapper" style="color:black; padding-left:0px;">\r\n                            <h4 ng-show="topicSidebar.topicsLabel"><i class="glyphicon glyphicon-user"></i></h4>\r\n                        </div>\r\n                        <div classs="label-wrapper" style="padding-top: 5px;">\r\n                            <h4>{{topicSidebar.topicsLabel}}</h4>\r\n                        </div>\r\n                    </div>\r\n                </uib-accordion-heading>\r\n                <div ng-repeat="category in topicSidebar.taxonomy | orderBy: topicSidebar.orderLabel track by category.id" ng-show="topicSidebar.matchingStreams(category).length">\r\n                    <uib-accordion-group is-open="topicSidebar.openMap[category.id]">\r\n                        <uib-accordion-heading><span class="topic-category">{{::category.title}} <span ng-show="topicSidebar.matchingStreams(category).length">({{topicSidebar.matchingStreams(category).length}})</span></span></uib-accordion-heading>\r\n                        <span ng-repeat="stream in topicSidebar.matchingStreams(category) | orderBy: \'title\' track by stream.id">\r\n                            <ul>\r\n                                <li ng-class="{ \'selected-stream\': stream.id === topicSidebar.streamId }">\r\n                                    <div class="flex stream-listing">\r\n                                        <div ng-if="::stream.thumbnailImage.uri" ng-style="{ \'background-image\': \'url(\' + stream.thumbnailImage.uri + \')\' }" class="stream-image-small"></div>\r\n                                        <div ng-if="::!stream.thumbnailImage.uri" style="background-color: transparent;" class="stream-image-small"></div>\r\n                                        <div style="flex:2; padding-left: 20px;"><a ui-sref="mytopics.topic({streamId: stream.id})" ui-sref-opts="{inherit: false}">{{stream.title}}</a></div>\r\n                                    </div>\r\n\r\n                                </li>\r\n                            </ul>\r\n                        </span>\r\n                    </uib-accordion-group>\r\n                </div>\r\n                <div ng-show="topicSidebar.sharedStreamIds.length">\r\n                    <uib-accordion-group is-open="topicSidebar.openMap.shared">\r\n                        <uib-accordion-heading><span class="topic-category">Resources <span ng-show="topicSidebar.sharedStreamIds.length">({{topicSidebar.sharedStreamIds.length}})</span></span></uib-accordion-heading>\r\n                        <span ng-repeat="stream in topicSidebar.sharedStreams() | orderBy: \'title\' track by stream.id">\r\n                            <ul>\r\n                                <li ng-class="{ \'selected-stream\': stream.id === topicSidebar.streamId }">\r\n                                    <div class="flex stream-listing">\r\n                                        <div ng-if="::stream.thumbnailImage.uri" ng-style="{ \'background-image\': \'url(\' + stream.thumbnailImage.uri + \')\' }" class="stream-image-small"></div>\r\n                                        <div ng-if="::!stream.thumbnailImage.uri" style="background-color: transparent;" class="stream-image-small"></div>\r\n                                        <div style="flex:2; padding-left: 20px;"><a ui-sref="mytopics.topic({streamId: stream.id})" ui-sref-opts="{inherit: false}">{{stream.title}}</a></div>\r\n                                    </div>\r\n\r\n                                </li>\r\n                            </ul>\r\n                        </span>\r\n                    </uib-accordion-group>\r\n                </div>\r\n            </uib-accordion-group>\r\n        </uib-accordion>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//myTopics/topicSummary.html','<div class="row">\r\n    <topic-summary-section topic="topic.mainStream" user="user" hide-edit-link="uiState.current.data.hideEditLink"></topic-summary-section>\r\n</div>\r\n');
$templateCache.put('/templates//personalDigest/personalDigest.html','<section ng-controller="PersonalDigestCtrl as $ctrl">\n    <digest-editor user="$ctrl.user" preview-enabled="true"></digest-editor>    \n</section>\n');
$templateCache.put('/templates//preferences/preferencesBase.html','<div ng-controller="PreferenceCenterCtrl as $ctrl">\r\n    <md-toolbar>\r\n        <div class="md-toolbar-tools">\r\n            <div flex="50">\r\n                <h4 flex>Preference Center</h4>\r\n            </div>\r\n            <div ng-if="$ctrl.user && !$ctrl.noTouching" flex="auto" layout="row" layout-align="end center">\r\n                <md-button ng-click="$ctrl.changePassword()">Change Password</md-button>\r\n                <md-button ng-click="$ctrl.logOut()">Logout</md-button>\r\n            </div>\r\n        </div>\r\n    </md-toolbar>\r\n    <div layout="column" flex>\r\n        <div layout="row" flex>\r\n            <spinner flex-offset="45" ng-if="$ctrl.noTouching"></spinner>\r\n            <div flex-offset="10" flex="80" ng-if="!$ctrl.unSubscribed">\r\n\r\n                <md-card ng-if="!$ctrl.user && !$ctrl.noTouching">\r\n                    <md-card-header layout="column" layout-align="center center">\r\n                        <h4>Welcome to the Preference Center. </h4>\r\n                        <h5>Please log in or create an account to manage your briefing subscriptions or update your profile.</h5>\r\n                    </md-card-header>\r\n                    <md-card-actions layout="row" layout-align="center center">\r\n                        <md-button class="md-raised md-primary" ng-click="$ctrl.logIn()">Log In</md-button>\r\n                        <md-button ng-if="$ctrl.selfSignupConfiguration === \'true\'" class="md-raised md-primary" ng-click="$ctrl.createAccount()">Create Account</md-button>\r\n                    </md-card-actions>\r\n\r\n                </md-card>\r\n\r\n                <md-card flex ng-form="form" layout="column" layout-padding ng-if="$ctrl.user && !$ctrl.noTouching">\r\n                    <div layout="row">\r\n                        <name-control flex="40"\r\n                                      label="First Name"\r\n                                      attribute="firstName"\r\n                                      user="$ctrl.user"\r\n                                      on-change="$ctrl.saveUser(\'firstName\', $value)">\r\n                        </name-control>\r\n\r\n                        <name-control flex="40"\r\n                                      label="Last Name"\r\n                                      attribute="lastName"\r\n                                      user="$ctrl.user"\r\n                                      on-change="$ctrl.saveUser(\'lastName\', $value)"></name-control>\r\n                    </div>\r\n\r\n                    <div layout="row">\r\n                        <email-control flex="40" user="$ctrl.user" on-change="$ctrl.saveUser(\'emailAddress\', $value)"></email-control>\r\n                    </div>\r\n                </md-card>\r\n            </div>\r\n        </div>\r\n        <div layout="row" flex ng-if="!$ctrl.noTouching && $ctrl.unSubscribed" layout-padding layout-align="center center">\r\n            <md-card>\r\n                <h5>You have been unsubscribed from this briefing. If you want to subscribe again, please sign in <a ui-sref="{briefingId: $ctrl.briefingId, userId: $ctrl.userId}" ui-sref-opts="{inherit: false}">here</a>.</h5>\r\n            </md-card>\r\n        </div>\r\n        <div layout="row" flex ng-show="!$ctrl.noTouching && !$ctrl.unSubscribed">\r\n            <briefings-section flex-offset="10"\r\n                               flex="80"\r\n                               user="$ctrl.user"\r\n                               subscribe-to-briefing="$ctrl.subscribeToBriefing"\r\n                               briefing-subscribed="$ctrl.initialBriefingSubscribed()">\r\n            </briefings-section>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//sourceCreation/sourceCreationModal.html','<modal-header title="Add source: {{::modalCtrl.sourceTypeTitle}}" on-close="$dismiss()"></modal-header>\n<div class="modal-body">\n    <div class="row">\n        <div class="col-md-12">\n            <form ng-submit="modalCtrl.search()">\n                <div class="input-group input-group-lg">\n                    <input type="text" class="form-control"\n                           ng-model="modalCtrl.searchTerm"\n                           placeholder="Enter your search term"\n                           on-delayed-change="modalCtrl.search()"\n                    >\n                    <span class="input-group-btn">\n                        <button class="btn btn-default" type="submit">\n                            <span class="fa fa-search"></span>\n                        </button>\n                    </span>\n                </div>\n                <div ng-if="modalCtrl.streamType === \'BING_SEARCH\'" class="form-group clearfix">\n                    <label>Result Type: &nbsp;</label>\n                    <label>\n                        <input type="radio" ng-model="modalCtrl.searchType" value="NEWS">\n                        News\n                    </label>&nbsp;\n                    <label>\n                        <input type="radio" ng-model="modalCtrl.searchType" value="WEB">\n                        Web\n                    </label>\n                </div>\n                <rss-authentication ng-if="modalCtrl.streamType === \'RSS\'"\n                                    auth-settings="modalCtrl.authSettings"></rss-authentication>\n                <div class="pad-top-bottom" ng-if="modalCtrl.streamType === \'ATTENSA_SEARCH\'">\n                    <label>Type:</label>\n                    <topic-tag-facets type="select"\n                                      tag-settings="modalCtrl.tagSettings"\n                                      tag-selection-did-change="modalCtrl.tagsDidChange()">\n                    </topic-tag-facets>\n                </div>\n            </form>\n        </div>\n    </div>\n    <source-preview term="modalCtrl.searchTerm"\n                    search-settings-type="modalCtrl.searchType"\n                    stream-type="{{::modalCtrl.streamType}}"\n                    source-type-title="{{::modalCtrl.sourceTypeTitle}}"\n                    searching="modalCtrl.searching"\n                    auth-settings="modalCtrl.authSettings"\n                    add-new-source="modalCtrl.addSources(streamId)",\n                    tag-settings="modalCtrl.tagSettings">\n    </source-preview>\n    <div ng-if="!modalCtrl.searching && !modalCtrl.preventSearch">\n        <div class="row pad-top-bottom" ng-if="modalCtrl.recommendedStreams.length > 0">\n            <hr>\n            <div class="col-md-12">\n                <h5>We found some existing sources that are similar to your search. You can include any of these sources by selecting them below.</h5>\n            </div>\n        </div>\n        <div class="row">\n            <source-card ng-repeat="stream in modalCtrl.recommendedStreams"\n                         stream="stream"\n                         source-selection-did-change="modalCtrl.sourceSelectionsDidChange(isSelected, stream.id)">\n            </source-card>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//sourceFinder/sourceFinder.html','<modal-header title="Add existing topics and sources" on-close="sourceFinderCtrl.dismiss()"></modal-header>\n<div class="modal-body">\n    <div class="row">\n        <span growl reference="sourceFinderMessages"></span>\n        <div class="col-md-9">\n            <form ng-submit="sourceFinderCtrl.search()">\n                <div class="input-group input-group-lg">\n                    <input type="text" class="form-control"\n                           ng-model="sourceFinderCtrl.searchTerm"\n                           placeholder="Enter your search term"\n                           on-delayed-change="sourceFinderCtrl.search()"\n                    >\n                    <span class="input-group-btn">\n                        <button class="btn btn-default" type="submit">\n                            <span class="fa fa-search"></span>\n                        </button>\n                    </span>\n                </div>\n            </form>\n        </div>\n        <div class="col-md-3">\n            <label class="pull-left pad-left-right overflow-ellipsis" title="Topics only">\n                <input type="checkbox" ng-model="sourceFinderCtrl.topicsOnly"> search topics only\n            </label>\n        </div>\n    </div>\n    <div class="row pad-top-bottom">\n        <div class="col-md-12">\n            <button class="btn btn-primary"\n                    ng-click="sourceFinderCtrl.addSources(sourceFinderCtrl.selectedSources)"\n                    ng-disabled="!sourceFinderCtrl.selectedSources.length">\n                <span>Add topics and sources</span><span ng-show="sourceFinderCtrl.selectedSources.length > 0"> ({{sourceFinderCtrl.selectedSources.length}})</span>\n            </button>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12">\n            <uib-tabset>\n                <uib-tab heading="{{::sourceFinderCtrl.catalogTabLabel}}">\n                    <source-finder-catalog taxonomy="sourceFinderCtrl.taxonomy"\n                        source-selection-did-change="sourceFinderCtrl.sourceSelectionDidChange(isSelected, source)"\n                        ng-if="sourceFinderCtrl.taxonomy"\n                        existing-sources="::sourceFinderCtrl.existingSources"\n                        parent-stream-id="{{::sourceFinderCtrl.parentStreamId}}">\n                    </source-finder-catalog>\n                </uib-tab>\n                <uib-tab heading="{{::catalog.label}}" ng-repeat="catalog in sourceFinderCtrl.catalogs">\n                    <source-finder-catalog taxonomy="sourceFinderCtrl.catalogTaxonomies[$index]"\n                        source-selection-did-change="sourceFinderCtrl.sourceSelectionDidChange(isSelected, source)"\n                        catalog-id="{{catalog.catalogId}}"\n                        ng-if="sourceFinderCtrl.catalogTaxonomies[$index]"\n                        existing-sources="::sourceFinderCtrl.existingSources"\n                        parent-stream-id="{{::sourceFinderCtrl.parentStreamId}}">\n                    </source-finder-catalog>\n                </uib-tab>\n                <uib-tab\n                    ng-if="sourceFinderCtrl.showSearch"\n                    active="sourceFinderCtrl.showSearch"\n                >\n                    <uib-tab-heading>\n                        <i class="fa fa-search"></i> Search <a ng-click="sourceFinderCtrl.showSearch = false" class="fa fa-times"></a>\n                    </uib-tab-heading>\n                    <div class="tab-content" style="padding-top: 2em" ng-controller="SourceSearchCtrl as searchView" ng-if="sourceFinderCtrl.showSearch">\n                        <spinner ng-show="searchView.fetchingMatches"></spinner>\n                        <div class="row" ng-if="!searchView.fetchingMatches && searchView.matchingStreams.length > 0">\n                            <div class="col-md-12">\n                                <h5>Results based on title and description:</h5>\n                            </div>\n                            <div class="col-md-12">\n                                <div>\n                                    <source-card ng-repeat="stream in searchView.matchingStreams"\n                                                 existing-sources="sourceFinderCtrl.existingSources"\n                                                 parent-stream-id="{{::sourceFinderCtrl.parentStreamId}}"\n                                                 stream="stream"\n                                                 source-selection-did-change="sourceFinderCtrl.sourceSelectionDidChange(isSelected, stream)">\n                                    </source-card>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row" ng-if="searchView.matchingStreamsPaging.totalElements && !(searchView.matchingStreamsPaging.first && searchView.matchingStreamsPaging.last)">\n                            <uib-pagination ng-if="!searchView.fetchingMatches && searchView.matchingStreamsPaging.totalElements"\n                                            class="flex-center"\n                                            total-items="searchView.matchingStreamsPaging.totalElements"\n                                            items-per-page="20"\n                                            ng-change="searchView.fetchMatchingStreams()"\n                                            ng-model="searchView.matchingStreamsPaging.currentPage"\n                                            max-size="5"\n                                            boundary-link-numbers="true"\n                                            previous-text="&lsaquo;"\n                                            next-text="&rsaquo;">\n                            </uib-pagination>\n                        </div>\n                        <spinner ng-show="searchView.fetchingRecommended && !searchView.fetchingMatches"></spinner>\n                        <div class="row" ng-if="searchView.recommendedStreams.length > 0">\n                            <hr ng-if="searchView.matchingStreams.length > 0">\n                            <div class="col-md-12">\n                                <h5>Results based on article content:</h5>\n                            </div>\n                            <div class="col-md-12">\n                                <div>\n                                    <source-card ng-repeat="stream in searchView.recommendedStreams"\n                                                 existing-sources="sourceFinderCtrl.existingSources"\n                                                 parent-stream-id="{{::sourceFinderCtrl.parentStreamId}}"\n                                                 stream="stream"\n                                                 source-selection-did-change="sourceFinderCtrl.sourceSelectionDidChange(isSelected, stream)">\n                                    </source-card>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row" ng-if="searchView.recommendedStreams.length === 0 && searchView.matchingStreams.length === 0 && !fetchingMatches && !fetchingRecommended">\n                            <div class="col-md-12">\n                                <no-results></no-results>\n                            </div>\n                        </div>\n                    </div>\n\n                </uib-tab>\n            </uib-tabset>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//streamBuilder/bing.html','<div class="row" id="tabPaneClinicaltrailsContent" ng-controller="BingBuilderCtrl">\n    <div class="col-md-12">\n        <h3>{{action}} Bing Search Stream</h3>\n        <form role="form" name="form">\n            <div ng-show="!stream" class="form-group clearfix">\n                <label>Title</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       placeholder="Enter title"\n                       ng-model="title">\n            </div>\n            <div class="form-group clearfix">\n                <label>Bing Search</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       id="search-bing-input"\n                       placeholder="Enter search term"\n                       ng-model="bing.search"\n                       ng-change="bingChanged()"\n                       required\n                       enter-key="search()">\n            </div>\n            <div ng-if="!stream || !stream.id" class="form-group clearfix">\n                <label>Result Type: &nbsp;</label>\n                    <label>\n                        <input type="radio" ng-model="bing.type" ng-change="bingChanged()" value="NEWS">\n                        News\n                    </label>&nbsp;\n                    <label>\n                        <input type="radio" ng-model="bing.type" ng-change="bingChanged()" value="WEB">\n                        Web\n                    </label>\n            </div>\n            <div class="form-group" ng-show="showCategories">\n                <label>Categories</label>\n                <div class="panel panel-default">\n                    <div class="panel-heading">\n                        <h4 class="panel-title">\n                            <button class="btn btn-sm btn-default" ng-disabled="taxonomy == null" ng-click="editCategories()">Edit</button>\n                        </h4>\n                    </div>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length > 0">\n                        <li class="list-group-item">\n                            <h4><span title="{{categoryTitle(category)}}" style="max-width: 500px;" ng-repeat="category in taxonomicMemberships" class="label label-default label-tag overflow-ellipsis">{{categoryTitle(category)}}</span></h4>\n                        </li>\n                    </ul>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length === 0">\n                        <li class="list-group-item help-block">Click edit to categorize this stream.</li>\n                    </ul>\n                </div>\n            </div>\n            <div class="form-group clearfix">\n                <div class="navbar-right">\n                    <button id="search-bing" ng-disabled="form.$invalid" ng-class="bingPreview ? \'btn btn-default\' : \'btn btn-primary\'" ng-click="search()">{{searchBtn}}</button>\n                    <button ng-show="bingPreview" ng-disabled="form.$invalid || addBtn === \'Saving...\'" style="margin:0;" class="btn btn-primary add-bing-streamsource" ng-click="save()">{{addBtn}}</button>\n                    <button ng-show="streamId" class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n                </div>\n            </div>\n            <hr style="margin:0;">\n            <div class="form-group clearfix" id="search-bing-results" ng-show="bingPreview">\n                <div id="search-bing-preview">\n                    <div class="bing-preview">\n                        <div class="row">\n                            <div class="col-md-12">\n                                <h4>{{title}}<br/><small>{{description}}</small></h4>\n                            </div>\n                        </div>\n                        <div class="bing-preview-items">\n                            <h5>Article Preview:</h5>\n                            <div id="reading-table" class="position-relative">\n                                <div class="reading-item" ng-repeat="item in bingItems">\n                                    <div style="cursor:default;" class="rich-list-link rich-list-item-read">\n                                        <div class="rich-list-item-group">\n                                            <div class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{item.title}}">{{item.title}}</div>\n                                            <div ng-if="bing.type === \'NEWS\'"class="rich-list-item-seg align-right muted item-list-date" am-time-ago="item.publishedDate"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('/templates//streamBuilder/briefing.html','<div class="tab-pane" id="tabPaneStreamBriefing" ng-controller="StreamEditorBriefingCtrl">\n    <form name="form" role="form" autocomplete="off" class="form">\n        <briefing-enabled-switch briefing="briefing" toggle-briefing="toggleBriefing()"></briefing-enabled-switch>\n        <div class="form-group" ng-if="showBriefingCustomConfiguration">\n            <label>{{briefingCustomConfigurationLabel}}</label>\n            <textarea class="form-control" name="title" id="briefing-custom-configuratoni" ng-model="briefing.customConfiguration"></textarea>\n        </div>\n        <briefing-edit-details\n                briefing="briefing"\n                briefing-schedule="briefingSchedule"\n                form="form"\n                frequency-changed="frequencyChanged()"\n                selected-days="selectedDays"\n                selected-template="selectedTemplate">\n        </briefing-edit-details>\n        <div ng-show="briefing.enabled" class="row">\n            <div class="col-md-12">\n                <div class="pull-right">\n                    <button class="btn btn-default" ng-click="openBriefingHistoryModal()">View Send History</button>\n                    <button class="btn btn-default" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Send briefing to all subscribers." ng-disabled="!briefing.id || processing || briefingSchedule.defaultSchedule" ng-click="sendBriefingNow()">Send Now</button>\n                    <button class="btn btn-default" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Send briefing to just you." ng-disabled="!briefing.id || processing" ng-click="sendBriefingPreviewNow()">Send Preview</button>\n                    <button class="btn btn-default" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="View preview" ng-disabled="!briefing.id || processing" ng-click="viewBriefingPreview()">View Preview</button>\n                    <button class="btn btn-primary" ng-disabled="processing || form.$invalid" ng-click="saveBriefingSchedule()">Save</button>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n');
$templateCache.put('/templates//streamBuilder/clinicaltrials.html','<div class="row" id="tabPaneClinicaltrailsContent" ng-controller="ClinicaltrialsBuilderCtrl">\n    <div class="col-md-12">\n        <h3>{{action}} ClinicalTrials.gov Search Stream</h3>\n        <form role="form" name="form">\n            <div ng-show="!stream" class="form-group clearfix">\n                <label>Title</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       placeholder="Enter title"\n                       ng-model="title">\n            </div>\n            <div class="form-group clearfix">\n                <label>Add ClinicalTrials.gov Search</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       id="search-clinicaltrials-input"\n                       placeholder="Enter search term"\n                       ng-model="clinicaltrials.search"\n                       ng-change="clinicaltrialsChanged()"\n                       required\n                       enter-key="search()">\n            </div>\n            <div class="form-group" ng-show="showCategories">\n                <label>Categories</label>\n                <div class="panel panel-default">\n                    <div class="panel-heading">\n                        <h4 class="panel-title">\n                            <button class="btn btn-sm btn-default" ng-disabled="taxonomy == null" ng-click="editCategories()">Edit</button>\n                        </h4>\n                    </div>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length > 0">\n                        <li class="list-group-item">\n                            <h4><span title="{{categoryTitle(category)}}" style="max-width: 500px;" ng-repeat="category in taxonomicMemberships" class="label label-default label-tag overflow-ellipsis">{{categoryTitle(category)}}</span></h4>\n                        </li>\n                    </ul>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length === 0">\n                        <li class="list-group-item help-block">Click edit to categorize this stream.</li>\n                    </ul>\n                </div>\n            </div>\n            <div class="form-group clearfix">\n                <div class="navbar-right">\n                    <button id="search-clinicaltrials" ng-disabled="form.$invalid" ng-class="clinicaltrialsPreview ? \'btn btn-default\' : \'btn btn-primary\'" ng-click="search()">{{searchBtn}}</button>\n                    <button ng-show="clinicaltrialsPreview" ng-disabled="form.$invalid || addBtn === \'Saving...\'" style="margin:0;" class="btn btn-primary add-clinicaltrials-streamsource" ng-click="save()">{{addBtn}}</button>\n                    <button ng-show="streamId" class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n                </div>\n            </div>\n            <hr style="margin:0;">\n            <div class="form-group clearfix" id="search-clinicaltrials-results" ng-show="clinicaltrialsPreview">\n                <div id="search-clinicaltrials-preview">\n                    <div class="clinicaltrials-preview">\n                        <div class="row">\n                            <div class="col-md-12">\n                                <h4>{{title}}<br/><small>{{description}}</small></h4>\n                            </div>\n                        </div>\n                        <div class="clinicaltrials-preview-items">\n                            <h5>Article Preview:</h5>\n                            <div id="reading-table" class="position-relative">\n                                <div class="reading-item" ng-repeat="item in clinicaltrialsItems">\n                                    <div style="cursor:default;" class="rich-list-link rich-list-item-read">\n                                        <div class="rich-list-item-group">\n                                            <div class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{item.title}}">{{item.title}}</div>\n                                            <div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="item.publishedDate"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('/templates//streamBuilder/factiva.html','<div class="row" id="tabPaneFactivaContent" ng-controller="FactivaBuilderCtrl">\n    <div class="col-md-12">\n        <h3>{{action}} Factiva Select Stream</h3>\n        <form role="form" name="form">\n            <div ng-show="!stream" class="form-group clearfix">\n                <label>Title</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       placeholder="Enter title"\n                       ng-model="title"\n                       required>\n            </div>\n            <div class="form-group clearfix">\n                <label>Factiva Customer ID</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       id="customerId-factiva-input"\n                       placeholder="Enter Factiva customer id"\n                       ng-model="customerId"\n                       required>\n            </div>\n            <div class="form-group clearfix">\n                <label>Folder Name</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       id="folder-factiva-input"\n                       placeholder="Enter folder name"\n                       ng-model="folderName"\n                       required>\n            </div>\n            <div class="form-group clearfix">\n                <label>Password</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       id="password-factiva-input"\n                       placeholder="Enter password"\n                       ng-model="password"\n                       required>\n            </div>\n            <div class="form-group" ng-show="showCategories">\n                <label>Categories</label>\n                <div class="panel panel-default">\n                    <div class="panel-heading">\n                        <h4 class="panel-title">\n                            <button class="btn btn-sm btn-default" ng-disabled="taxonomy == null" ng-click="editCategories()">Edit</button>\n                        </h4>\n                    </div>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length > 0">\n                        <li class="list-group-item">\n                            <h4><span title="{{categoryTitle(category)}}" style="max-width: 500px;" ng-repeat="category in taxonomicMemberships" class="label label-default label-tag overflow-ellipsis">{{categoryTitle(category)}}</span></h4>\n                        </li>\n                    </ul>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length === 0">\n                        <li class="list-group-item help-block">Click edit to categorize this stream.</li>\n                    </ul>\n                </div>\n            </div>\n            <div class="form-group clearfix">\n                <div class="navbar-right">\n                    <button ng-disabled="form.$invalid || addBtn === \'Saving...\'" style="margin:0;" class="btn btn-primary add-factiva-streamsource" ng-click="save()">{{addBtn}}</button>\n                    <button ng-show="streamId" class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('/templates//streamBuilder/groups.html','<div class="tab-pane stream-people-tab-pane" id="tabPaneStreamPeople" ng-controller="StreamGroupsCtrl">\n    <div class="row">\n        <div class="col-md-12">\n            <div class="row">\n                <div class="col-md-4 col-md">\n                    <ul class="nav nav-pills" style="width: 100%;" ng-if="!(peopleCtrl.tenant.settings.limitProductSources === \'true\' && stream.type === \'PRODUCT_SOURCE\')">\n                        <li role="presentation" style="margin-top: 10px; padding-right: 8px;">\n                            <label>Everyone can:</label>\n                        </li>\n                        <li role="presentation" style="text-align: left;">\n                            <div class="checkbox">\n                                <label>\n                                    <input type="checkbox" ng-model="stream.openForReading" ng-change="updateStream()"> Read\n                                </label>\n                            </div>\n                        </li>\n                        <li ng-if="stream.type === \'COLLECTION\'" role="presentation" style="margin-left: 10px; text-align: left;">\n                            <div class="checkbox">\n                                <label>\n                                    <input type="checkbox" ng-model="stream.openForPosting" ng-change="updateStream()"> Publish\n                                </label>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n                <div class="col-md-6 col-md-offset-2" style="margin-top: -15px;">\n                    <ul class="nav nav-pills pad-top-bottom">\n                        <li role="presentation" ng-click="config.target = \'people\'"><a>People</a></li>\n                        <li role="presentation" class="active" ng-click="config.target = \'groups\'"><a>Groups</a></li>\n                    </ul>\n                </div>\n            </div>\n            <nav class="navbar navbar-default" role="navigation">\n                <div class="navbar-header">\n                    <button type="button" class="navbar-toggle" ng-click="navbarCollapsed = !navbarCollapsed">\n                        <span class="sr-only">Toggle navigation</span>\n                        <span class="icon-bar"></span>\n                        <span class="icon-bar"></span>\n                        <span class="icon-bar"></span>\n                    </button>\n                </div>\n                <!-- Collect the nav links, forms, and other content for toggling -->\n                <div>\n                    <ul class="nav navbar-nav">\n                        <li uib-dropdown>\n                            <a data-toggle="dropdown" uib-dropdown-toggle><i class="fa fa-ellipsis-v"></i>\n                            </a>\n                            <ul class="dropdown-menu" role="menu">\n                                <li role="presentation" class="dropdown-header">Stream</li>\n                                <li ng-class="{disabled: selectDisabled}"><a ng-click="groupsGroupAction(\'follow\')">Follow</a></li>\n                                <li ng-class="{disabled: selectDisabled}"><a ng-click="groupsGroupAction(\'unfollow\')">Unfollow</a></li>\n                                <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" class="divider"></li>\n                                <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" role="presentation" class="dropdown-header">Briefing</li>\n                                <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" ng-class="{disabled: selectDisabled}"><a ng-click="groupsGroupAction(\'subscribe\')">Subscribe</a></li>\n                                <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" ng-class="{disabled: selectDisabled}"><a ng-click="groupsGroupAction(\'unsubscribe\')">Unsubscribe</a></li>\n                            </ul>\n                        </li>\n                    </ul>\n                    <form class="navbar-form navbar-left" role="search">\n                        <div class="form-group has-feedback">\n                            <input ng-model="groupSearchTerm" ng-change="searchGroups()" ng-model-options="{debounce: 1000}" id="group-search-input" type="text" focus-me="streamGroupsSearch" class="form-control admin-table-search" placeholder="Search Groups">\n                            <a ng-click="clearSearch()" ng-show="groupSearchTerm" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n                        </div>\n                    </form>\n                    <ul class="nav navbar-nav">\n                        <li ng-if="!filter" uib-dropdown>\n                            <a class="dropdown-toggle" tooltip-placement="top" uib-tooltip="Filter" uib-dropdown-toggle>\n                                <i class="fa fa-filter"></i>\n                            </a>\n                            <ul class="dropdown-menu" role="menu">\n                                <li>\n                                    <a ng-click="filterByGroupSubscription(\'Follower\')">Follower</a>\n                                </li>\n                                <li>\n                                    <a ng-click="filterByGroupSubscription(\'Subscriber\')">Subscriber</a>\n                                </li>\n                            </ul>\n                        </li>\n                        <li ng-if="filter">\n                            <a type="button" class="btn btn-default" tooltip-placement="top" uib-tooltip="Remove filter" ng-click="removeFilter()">\n                               Filtered by: {{filter}} <i class="fa fa-times"></i>\n                            </a>\n                        </li>\n                    </ul>\n                </div>\n            </nav>\n            <div style="margin-top:8px;" class="row">\n                <div class="col-md-12">\n                    <div class="row">\n                        <div class="col-md-12 table-section-content stream-groups-table">\n                            <table class="table scrollable-table fixed-table" id="group-table">\n                                <thead>\n                                    <tr>\n                                        <th style="width: 8%;">Select</th>\n                                        <th style="width: 20%;" class="admin-table-header">\n                                            <sort-people-by label="\'Group\'" sort="sort" sort-key="\'nameLower\'" sort-by="sortByGroupProperties" initial-sort="true"></sort-people-by>\n                                        </th>\n                                        <th style="width: 36%;" class="admin-table-header">\n                                            <span style="font-weight: normal">Description</span>\n                                        </th>\n                                        <th style="width: 10%;">\n                                            <sort-people-by label="\'Members\'" sort="sort" sort-key="\'membersCount\'" sort-by="sortByGroupProperties">Members</sort-people-by>\n                                        </th>\n                                        <th style="width: 12%;">Stream</th>\n                                        <th style="width: 14%;"><span ng-if="!peopleCtrl.tenant.settings.noStreamBriefings">Briefing</span></th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr ng-repeat="group in groups" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                                        <td style="width: 8%;" class="text-center select-cell"><input type="checkbox" ng-model="group.selected" ng-change="selectionChange()"></td>\n                                        <td style="width: 20%;" class="overflow-ellipsis white-space-nowrap" title="{{group.name}}">{{group.name}}</td>\n                                        <td style="width: 36%;" class="overflow-ellipsis white-space-nowrap" title="{{group.description}}">{{group.description}}</td>\n                                        <td style="width: 10%;" class="overflow-ellipsis white-space-nowrap">{{group.membersCount}}</td>\n                                        <td style="width: 12%;" class="overflow-ellipsis white-space-nowrap">\n                                            <button type="button" class="btn btn-default btn-block follow-button" tabstop="0" ng-click="followGroup(group)" ng-class="{active: group.followed}" blur-me>\n                                                {{group.followed ? \'Unfollow\' : \'Follow\'}}\n                                            </button>\n                                        </td>\n                                        <td style="width: 14%;" class="overflow-ellipsis white-space-nowrap">\n                                            <button ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" type="button" class="btn btn-default btn-block" tabstop="0" ng-click="subscribeGroup(group)" ng-class="{active: group.subscribed}" blur-me>\n                                                {{group.subscribed ? \'Unsubscribe\' : \'Subscribe\'}}\n                                            </button>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        <div class="col-md-6" ng-show="groups.length">\n                            <uib-pagination total-items="totalElements"\n                                            ng-model="pagerPage"\n                                            items-per-page="rows"\n                                            ng-change="fetchPage()"\n                                            max-size="5"\n                                            boundary-link-numbers="true"\n                                            previous-text="&lsaquo;"\n                                            next-text="&rsaquo;"></uib-pagination>\n                        <div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//streamBuilder/people.html','<div class="tab-pane stream-people-tab-pane" id="tabPaneStreamPeople" ng-controller="StreamPeopleCtrl">\n    <div class="row">\n        <div class="col-md-12">\n            <div class="row">\n                <div class="col-md-4 col-md">\n                    <ul class="nav nav-pills" style="width: 100%;" ng-if="stream && peopleCtrl.tenant && !(peopleCtrl.tenant.settings.limitProductSources === \'true\' && stream.type === \'PRODUCT_SOURCE\')">\n                        <li role="presentation" style="margin-top: 10px; padding-right: 8px;">\n                            <label>Everyone can:</label>\n                        </li>\n                        <li role="presentation" style="text-align: left;">\n                            <div class="checkbox">\n                                <label>\n                                    <input type="checkbox" ng-disabled="stream.openForPosting" ng-model="stream.openForReading" ng-click="updateStream(); $event.stopPropagation();"> Read\n                                </label>\n                            </div>\n                        </li>\n                        <li ng-if="stream.type === \'COLLECTION\'" role="presentation" style="margin-left: 10px; text-align: left;">\n                            <div class="checkbox">\n                                <label>\n                                    <input type="checkbox" ng-model="stream.openForPosting" ng-click="updateStream(); $event.stopPropagation();"> Publish\n                                </label>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n                <div class="col-md-6 col-md-offset-2" style="margin-top: -15px;">\n                    <ul class="nav nav-pills pad-top-bottom">\n                        <li role="presentation" class="active" ng-click="config.target = \'people\'"><a>People</a></li>\n                        <li role="presentation" ng-click="config.target = \'groups\'"><a>Groups</a></li>\n                    </ul>\n                </div>\n            </div>\n            <nav class="navbar navbar-default" role="navigation">\n                <ul class="nav navbar-nav">\n                    <li uib-dropdown>\n                        <a data-toggle="dropdown" uib-dropdown-toggle><i class="fa fa-ellipsis-v"></i>\n                        </a>\n                        <ul class="dropdown-menu" role="menu" id="action-dropdown">\n                            <li role="presentation" class="dropdown-header">Stream</li>\n                            <li ng-class="{disabled: selectDisabled}"><a ng-click="usersGroupAction(follow)">Follow</a></li>\n                            <li ng-class="{disabled: selectDisabled}"><a ng-click="usersGroupAction(unfollow)">Unfollow</a></li>\n                            <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" class="divider"></li>\n                            <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" role="presentation" class="dropdown-header">Briefing</li>\n                            <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" ng-class="{disabled: selectDisabled}"><a ng-click="usersGroupAction(subscribe)">Subscribe</a></li>\n                            <li ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" ng-class="{disabled: selectDisabled}"><a ng-click="usersGroupAction(unsubscribe)">Unsubscribe</a></li>\n                            <li class="divider"></li>\n                            <li role="presentation" class="dropdown-header">Permissions</li>\n                            <li ng-class="{disabled: selectDisabled || searching || stream.openForReading}">\n                                <a ng-click="usersGroupAction(updateStreamRole, \'STREAM_SUBSCRIBER\', stream.openForReading)">Assign: Reader</a>\n                            </li>\n                            <li ng-if="stream.type === \'COLLECTION\'" ng-class="{disabled: selectDisabled || searching || stream.openForPosting}">\n                                <a ng-click="usersGroupAction(updateStreamRole, \'STREAM_PUBLISHER\' , stream.openForPosting)">Assign: Publisher</a>\n                            </li>\n                            <li ng-if="stream.type === \'COLLECTION\'" ng-class="{disabled: selectDisabled || searching}">\n                                <a ng-click="usersGroupAction(updateStreamRole, \'STREAM_ADMIN\', false)">Assign: Manager</a>\n                            </li>\n                            <li ng-class="{disabled: selectDisabled || searching || stream.openForReading || stream.openForPosting}"><a ng-click="usersGroupAction(removeAllStreamRoles, null, stream.openForPosting || stream.openForReading)">Clear All</a></li>\n                        </ul>\n                    </li>\n                </ul>\n                <form class="navbar-form navbar-left" role="search">\n                    <div class="form-group has-feedback">\n                        <input ng-model="search.searchTerm" ng-change="searchPeople()" ng-model-options="{debounce: 1000}" id="people-search-input" type="text" focus-me="streamPeopleSearch" class="form-control" placeholder="Search People">\n                        <a ng-click="clearSearch()" ng-show="search.searchTerm" id="clear-search" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n                    </div>\n                </form>\n                <ul class="nav navbar-nav">\n                    <li ng-if="!filter" uib-dropdown>\n                        <a class="dropdown-toggle" tooltip-placement="top" uib-tooltip="Filter" uib-dropdown-toggle>\n                            <i class="fa fa-filter"></i>\n                        </a>\n                        <ul class="dropdown-menu" role="menu">\n                            <li><a ng-click="filterByFollowingUsers()">Follower</a></li>\n                            <li><a ng-click="filterBySubscribingUsers()">Subscriber</a></li>\n                            <li ng-class="{disabled: searching || stream.openForReading}"><a ng-click="filterByRole(\'Reader\')">Reader</a></li>\n                            <li ng-class="{disabled: searching || stream.openForPosting}"><a ng-click="filterByRole(\'Publisher\')">Publisher</a></li>\n                            <li><a ng-click="filterByRole(\'Manager\')">Manager</a></li>\n                        </ul>\n                    </li>\n                    <li ng-if="filter">\n                        <a type="button" class="btn btn-default" tooltip-placement="top" uib-tooltip="Remove filter" ng-click="removeFilter()">\n                           Filtered by: {{filter}} <i class="fa fa-times"></i>\n                        </a>\n                    </li>\n                </ul>\n            </nav>\n            <div style="margin-top:8px;" class="row">\n                <div class="col-md-12">\n                    <div class="row">\n                        <div class="col-md-12 table-section-content">\n                            <table class="table scrollable-table" id="people-table">\n                                <thead>\n                                    <tr>\n                                        <th style="width:7.5%;">Select</th>\n                                        <th style="width:10%;" class="admin-table-header">\n                                            <sort-people-by label="\'First Name\'" sort="sort" sort-key="\'firstNameLower\'" sort-by="sortByUserProperty"></sort-people-by>\n                                        </th>\n                                        <th style="width:10%;" class="admin-table-header">\n                                            <sort-people-by label="\'Last Name\'" sort="sort" sort-key="\'lastNameLower\'" sort-by="sortByUserProperty"></sort-people-by>\n                                        </th>\n                                        <th style="width:20%;">\n                                            <sort-people-by label="\'Email Address\'" sort="sort" sort-key="\'emailAddress\'" sort-by="sortByUserProperty"></sort-people-by>\n                                        </th>\n                                        <th style="width:30%;">Permissions</th>\n                                        <th style="width:10%;">Stream</th>\n                                        <th style="width:10%;"><span ng-if="!peopleCtrl.tenant.settings.noStreamBriefings">Briefing</span></th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr ng-repeat="user in users" ng-class-odd="\'odd\'" ng-class-even="\'even\'">\n                                        <td style="width:7.5%;" class="text-center select-cell"><input type="checkbox" ng-model="user.selected" ng-change="change()"></td>\n                                        <td style="width:8%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.firstName}}">{{::user.firstName}}</td>\n                                        <td style="width:10%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.lastName}}">{{::user.lastName}}</td>\n                                        <td style="width:18%;" class="overflow-ellipsis white-space-nowrap" title="{{::user.emailAddress}}">{{::user.emailAddress}}</td>\n                                        <td style="width:30%;" class="white-space-nowrap">\n                                            <ul class="nav nav-pills">\n                                                <li>\n                                                    <span class="stream-people-roles checkbox">\n                                                        <label>\n                                                            <input type="checkbox" ng-model="user.reader" ng-click="updateStreamRole(user, \'STREAM_SUBSCRIBER\', user.reader); $event.stopPropagation();" ng-disabled="user.publisher && !stream.openForPosting || stream.openForReading || user.manager || isOverLimit(stream, user.reader)"> Read\n                                                        </label>\n                                                    </span>\n                                                </li>\n                                                <li ng-if="stream.type === \'COLLECTION\'">\n                                                    <span class="stream-people-roles checkbox">\n                                                        <label>\n                                                            <input type="checkbox" ng-model="user.publisher" ng-click="updateStreamRole(user, \'STREAM_PUBLISHER\', user.publisher); $event.stopPropagation();" ng-disabled="stream.openForPosting || user.manager"> Publish\n                                                        </label>\n                                                    </span>\n                                                </li>\n                                                <li ng-if="stream.type === \'COLLECTION\'">\n                                                    <span class="stream-people-roles checkbox">\n                                                        <label>\n                                                            <input type="checkbox" ng-model="user.manager" ng-click="updateStreamRole(user, \'STREAM_ADMIN\', user.manager); $event.stopPropagation();"> Manage\n                                                        </label>\n                                                    </span>\n                                                </li>\n                                            </ul>\n                                        </td>\n                                        <td style="width:12%;" class="white-space-nowrap">\n                                            <follow-button ng-if="!isOverLimit(stream, user.reader)" stream="stream" user="user" type="user"></follow-button>\n                                        </td>\n                                        <td style="width:12%;" class="white-space-nowrap">\n                                            <subscribe-button ng-if="!peopleCtrl.tenant.settings.noStreamBriefings" stream="stream" user="user" type="user"></subscribe-button>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        <div class="col-md-6" ng-show="users.length && !(isFirst && isLast)">\n                            <uib-pagination total-items="totalElements"\n                                            ng-model="pagerPage"\n                                            items-per-page="rows"\n                                            ng-change="fetchPage()"\n                                            max-size="5"\n                                            boundary-link-numbers="true"\n                                            previous-text="&lsaquo;"\n                                            next-text="&rsaquo;"></uib-pagination>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//streamBuilder/pubmed.html','<div class="row" id="tabPanePubmedContent" ng-controller="PubmedBuilderCtrl">\n    <div class="col-md-12">\n        <h3>{{action}} PubMed Search Stream</h3>\n        <form role="form" name="form">\n            <div ng-show="!stream" class="form-group clearfix">\n                <label>Title</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       placeholder="Enter title"\n                       ng-model="title">\n            </div>\n            <div class="form-group clearfix">\n                <label>Add PubMed Search</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       id="search-pubmed-input"\n                       placeholder="Enter search term"\n                       ng-model="pubmed.search"\n                       ng-change="pubmedChanged()"\n                       required\n                       enter-key="search()">\n            </div>\n            <div class="form-group" ng-show="showCategories">\n                <label>Categories</label>\n                <div class="panel panel-default">\n                    <div class="panel-heading">\n                        <h4 class="panel-title">\n                            <button class="btn btn-sm btn-default" ng-disabled="taxonomy == null" ng-click="editCategories()">Edit</button>\n                        </h4>\n                    </div>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length > 0">\n                        <li class="list-group-item">\n                            <h4><span title="{{categoryTitle(category)}}" style="max-width: 500px;" ng-repeat="category in taxonomicMemberships" class="label label-default label-tag overflow-ellipsis">{{categoryTitle(category)}}</span></h4>\n                        </li>\n                    </ul>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length === 0">\n                        <li class="list-group-item help-block">Click edit to categorize this stream.</li>\n                    </ul>\n                </div>\n            </div>\n            <div class="form-group clearfix">\n                <div class="navbar-right">\n                    <button id="search-pubmed" ng-disabled="form.$invalid" ng-class="pubmedPreview ? \'btn btn-default\' : \'btn btn-primary\'" ng-click="search()">{{searchBtn}}</button>\n                    <button ng-show="pubmedPreview" ng-disabled="form.$invalid || addBtn === \'Saving...\'" style="margin:0;" class="btn btn-primary add-pubmed-streamsource" ng-click="save()">{{addBtn}}</button>\n                    <button ng-show="streamId" class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n                </div>\n            </div>\n            <hr style="margin:0;">\n            <div class="form-group clearfix" id="search-pubmed-results" ng-show="pubmedPreview">\n                <div id="search-pubmed-preview">\n                    <div class="pubmed-preview">\n                        <div class="row">\n                            <div class="col-md-12">\n                                <h4>{{title}}<br/><small>{{description}}</small></h4>\n                            </div>\n                        </div>\n                        <div class="pubmed-preview-items">\n                            <h5>Article Preview:</h5>\n                            <div id="reading-table" class="position-relative">\n                                <div class="reading-item" ng-repeat="item in pubmedItems">\n                                    <div style="cursor:default;" class="rich-list-link rich-list-item-read">\n                                        <div class="rich-list-item-group">\n                                            <div class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{item.title}}">{{item.title}}</div>\n                                            <div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="item.publishedDate"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('/templates//streamBuilder/rss.html','<div class="row" id="tabPaneStreamContent" ng-controller="RssBuilderCtrl as $ctrl">\n    <div class="col-md-12">\n        <h3>{{$ctrl.action}} RSS Stream</h3>\n        <form role="form" name="form">\n            <div class="form-group clearfix">\n                <label for="content_search">Add RSS</label>\n                <input type="text" id="content_search" name="content_search" class="form-control" id="search-rss-input" placeholder="Enter URL or search term" ng-model="$ctrl.rss.input" ng-change="$ctrl.rssPreview.shown = false" required>\n                <p class="help-block">Enter the URL of a feed to add it directly.</p>\n            </div>\n            <div ng-if="!$ctrl.catalog">\n                <input type="checkbox" ng-model="$ctrl.rss.isAuthenticated" ng-change="$ctrl.toggleAuthenticated()"><label>&nbsp;Authenticated Feed</label>\n            </div>\n            <div class="form-group row" ng-show="$ctrl.rss.isAuthenticated">\n                <div class="col-md-8">\n                <input autocomplete="off" name="rssUsername" type="text" class="form-control" placeholder="Name" ng-model="$ctrl.rss.username" ng-required="$ctrl.rss.isAuthenticated" focus-me="$ctrl.focusOnUsername">\n                    <div ng-if="form.rssUsername.$touched">\n                        <div class="has-error" ng-messages="form.rssUsername.$error">\n                            <small class="help-block" ng-message="required">Username is required with a Password</small>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="form-group row" ng-show="$ctrl.rss.isAuthenticated">\n                <div class="col-md-8">\n                    <input autocomplete="off" name="rssPassword" type="password" class="form-control" placeholder="Password" ng-model="$ctrl.rss.password">\n                    <div ng-if="form.rssPassword.$touched">\n                        <div class="has-error" ng-messages="form.rssPassword.$error">\n                            <small class="help-block" ng-message="required">Password is required with a Username</small>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="form-group" ng-if="!$ctrl.streamId && $ctrl.rssPreview.shown && !$ctrl.catalog">\n                <label>Categories</label>\n                <div class="panel panel-default">\n                    <div class="panel-heading">\n                        <h4 class="panel-title">\n                            <button class="btn btn-sm btn-default" ng-disabled="!$ctrl.taxonomy" ng-click="$ctrl.editCategories()">Edit</button>\n                        </h4>\n                    </div>\n                    <ul class="list-group" ng-if="$ctrl.selectedCategories.length > 0">\n                        <li class="list-group-item">\n                        <h4><span title="{{$ctrl.categoryTitle(category)}}" style="max-width: 500px" ng-repeat="category in $ctrl.selectedCategories" class="label label-default label-tag overflow-ellipsis">{{$ctrl.categoryTitle(category)}}</span></h4>\n                        </li>\n                    </ul>\n                    <ul class="list-group" ng-if="$ctrl.selectedCategories.length === 0">\n                        <li class="list-group-item help-block">Click edit to categorize this stream.</li>\n                    </ul>\n                </div>\n            </div>\n            <div class="form-group clearfix">\n                <div class="navbar-right">\n                    <button id="search-rss" ng-disabled="form.$invalid" ng-class="$ctrl.rssPreview.shown ? \'btn btn-default\' : \'btn btn-primary\'" ng-click="$ctrl.searchRss()">{{$ctrl.searchBtn}}</button>\n                    <button ng-show="$ctrl.rssPreview.shown" ng-disabled="form.$invalid || $ctrl.addBtn === \'Saving...\'" style="margin:0;" class="btn btn-primary add-rss-streamsource" ng-click="$ctrl.saveRss()">{{$ctrl.addBtn}}</button>\n                    <button ng-show="$ctrl.streamId" class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n                </div>\n            </div>\n            <hr style="margin:0;">\n            <div class="form-group clearfix" id="search-rss-results" ng-show="$ctrl.rssPreview.shown">\n                <div id="search-rss-preview">\n                    <div class="rss-preview">\n                        <div class="row">\n                            <div class="col-md-12">\n                                <h4>{{$ctrl.title}}<br/><small>{{$ctrl.description}}</small></h4>\n                            </div>\n                        </div>\n                        <div class="rss-preview-items">\n                            <h5>Article Preview:</h5>\n                            <div id="reading-table" class="position-relative">\n                                <div class="reading-item" ng-repeat="item in $ctrl.rssItems">\n                                    <div style="cursor:default;" class="rich-list-link rich-list-item-read" ng-click="$ctrl.openReadingModal(\'{{item.id}}\')">\n                                        <div class="rich-list-item-group">\n                                            <div class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{item.title}}">{{item.title}}</div>\n                                            <div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="item.publishedDate"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="form-group clearfix" id="existing-result" ng-show="$ctrl.matched">\n                <div id="existing-result-message">\n                        <div class="rss-preview">\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <h4><small>This source already exists.</small></h4>\n                                </div>\n                            </div>\n                            <div class="rss-preview-items">\n                                <h5 ng-if="$ctrl.matched.tenantId">Edit existing Source: <a ui-sref="mytopics.editTopic.articles({streamId: $ctrl.matched.id})">{{$ctrl.matched.title}}</a></h5>\n                                <h5 ng-if="!$ctrl.matched.tenantId">Add it to one of your Topics <a ui-sref="streams">here</a></h5>\n                            </div>\n                        </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n');
$templateCache.put('/templates//streamBuilder/searchStream.html','<div class="row" id="tabPaneSearchContent" ng-controller="SearchBuilderCtrl">\n    <div class="col-md-12">\n        <h3>{{action}} Search Stream\n            <a>\n                <i bs-popover\n                   data-template="/templates/filterHelpPopover.html"\n                   data-placement="right"\n                   data-auto-close="true"\n                   class="pull-right fa fa-question-circle"></i>\n            </a>\n        </h3>\n        <div ng-show="!stream" class="form-group clearfix">\n            <label>Title</label>\n            <input type="text"\n                   name="content_search"\n                   class="form-control"\n                   placeholder="Enter stream title"\n                   ng-model="title"\n                   required>\n        </div>\n        <div class="form-group clearfix">\n            <label>Add Search</label>\n            <input type="text"\n                   name="content_search"\n                   class="form-control"\n                   id="search-input"\n                   placeholder="Enter search term"\n                   ng-model="searchTerm.search"\n                   ng-change="previewChanged()"\n                   required\n                   enter-key="search()">\n        </div>\n        <div class="form-group clearfix">\n            <label>Type:</label>\n            <topic-tag-facets ng-if="!config.fetching" type="select" tag-settings="topicTagSettings"></topic-tag-facets>\n        </div>\n        <div ng-if="entitiesTagSettings.tags.length > 0" class="form-group clearfix">\n            <label>Entities:</label>\n            <div class="btn-group btn-group-xs tag-buttons tag-btn-group user-tag-button-group ng-scope" ng-repeat="tag in entitiesTagSettings.tags">\n                <button type="button" class="btn btn-default tag-button user-tag-button default-cursor" data-toggle="tooltip" data-placement="top">\n                    {{::tag.tagText}}\n                </button>\n                <button type="button" class="btn btn-default delete-tag" ng-click="deleteTag(entitiesTagSettings, $index)">\n                    <span class="glyphicon glyphicon-remove"></span>\n                </button>\n            </div>\n        </div>\n        <div ng-if="socialTagsSettings.tags.length > 0" class="form-group clearfix">\n            <label>Subjects:</label>\n            <div class="btn-group btn-group-xs tag-buttons tag-btn-group user-tag-button-group ng-scope" ng-repeat="tag in socialTagsSettings.tags">\n                <button type="button" class="btn btn-default tag-button user-tag-button default-cursor" data-toggle="tooltip" data-placement="top">\n                    {{::tag.tagText}}\n                </button>\n                <button type="button" class="btn btn-default delete-tag" ng-click="deleteTag(socialTagsSettings, $index)">\n                    <span class="glyphicon glyphicon-remove"></span>\n                </button>\n            </div>\n        </div>\n        <div class="form-group" ng-show="showCategories">\n            <label>Categories</label>\n            <div class="panel panel-default">\n                <div class="panel-heading">\n                    <h4 class="panel-title">\n                        <button class="btn btn-sm btn-default" ng-disabled="taxonomy == null" ng-click="editCategories()">Edit</button>\n                    </h4>\n                </div>\n                <ul class="list-group" ng-if="taxonomicMemberships.length > 0">\n                    <li class="list-group-item">\n                        <h4><span title="{{categoryTitle(category)}}" style="max-width: 500px;" ng-repeat="category in taxonomicMemberships" class="label label-default label-tag overflow-ellipsis">{{categoryTitle(category)}}</span></h4>\n                    </li>\n                </ul>\n                <ul class="list-group" ng-if="taxonomicMemberships.length === 0">\n                    <li class="list-group-item help-block">Click edit to categorize this stream.</li>\n                </ul>\n            </div>\n        </div>\n        <div class="form-group clearfix">\n            <div class="navbar-right">\n                <button id="search" ng-disabled="form.$invalid" ng-class="preview ? \'btn btn-default\' : \'btn btn-primary\'" ng-click="search()">{{searchBtn}}</button>\n                <button ng-show="preview" ng-disabled="form.$invalid || addBtn === \'Saving...\'" style="margin:0;" class="btn btn-primary add-search-streamsource" ng-click="save()">{{addBtn}}</button>\n                <button ng-show="streamId" class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n            </div>\n        </div>\n        <hr style="margin:0;">\n        <div class="form-group clearfix" id="search-results" ng-show="preview">\n            <div id="search-preview">\n                <div class="preview">\n                    <div class="row">\n                        <div class="col-md-12">\n                            <h4>{{title}}<br/><small>{{description}}</small></h4>\n                        </div>\n                    </div>\n                    <div class="search-preview">\n                        <h5>Article Preview:</h5>\n                        <item-list items="items"></item-list>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//streamBuilder/streamModal.html','<div class="modal-body generic-modal-content">\n    <div class="page-header">\n        <a id="close-stream-builder-modal" ng-click="$dismiss()" class="pull-right modal-close-x muted fa fa-times" aria-hidden="true"></a>\n        <div class="stream-modal-growl-container">\n            <div class="stream-modal-growls">\n                <div growl inline="true" reference="streamBuilderMessages"></div>\n            </div>\n        </div>\n    </div>\n    <div class="content-stream-builder">\n        <div class="row">\n            <div class="col-md-12">\n                <div class="stream-creation-panel tab-content">\n                    <span ng-if="config.target === \'RSS\'"><ng-include src="\'/templates/streamBuilder/rss.html\'"></ng-include></span>\n                    <span ng-if="config.target === \'TWITTER_SEARCH\'"><ng-include src="\'/templates/streamBuilder/twitter.html\'"></ng-include></span>\n                    <span ng-if="config.target === \'BING_SEARCH\'"><ng-include src="\'/templates/streamBuilder/bing.html\'"></ng-include></span>\n                    <span ng-if="config.target === \'PUBMED_SEARCH\'"><ng-include src="\'/templates/streamBuilder/pubmed.html\'"></ng-include></span>\n                    <span ng-if="config.target === \'CLINICALTRIALS_SEARCH\'"><ng-include src="\'/templates/streamBuilder/clinicaltrials.html\'"></ng-include></span>\n                    <span ng-if="config.target === \'FACTIVA_SELECT_HTTP\'"><ng-include src="\'/templates/streamBuilder/factiva.html\'"></ng-include></span>\n                    <span ng-if="config.target === \'ATTENSA_SEARCH\'"><ng-include src="\'/templates/streamBuilder/searchStream.html\'"></ng-include></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//streamBuilder/twitter.html','<div class="row" id="tabPaneTwitterContent" ng-controller="TwitterBuilderCtrl">\n    <div class="col-md-12">\n        <h3>{{action}} Twitter Stream\n            <a>\n                <i bs-popover\n                   data-template="/templates/twitterHelpPopover.html"\n                   data-placement="right"\n                   data-auto-close="true"\n                   class="pull-right fa fa-question-circle"></i>\n            </a>\n        </h3>\n        <form role="form" name="form">\n            <div ng-show="!stream" class="form-group clearfix">\n                <label>Title</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       placeholder="Enter title"\n                       ng-model="title">\n            </div>\n            <div class="form-group clearfix">\n                <label>Add Twitter Search</label>\n                <input type="text"\n                       name="content_search"\n                       class="form-control"\n                       id="search-twitter-input"\n                       placeholder="Enter search term"\n                       ng-model="twitter.search"\n                       ng-change="twitterChanged()"\n                       required\n                       enter-key="search()">\n            </div>\n            <div class="form-group" ng-show="showCategories && !catalog">\n                <label>Categories</label>\n                <div class="panel panel-default">\n                    <div class="panel-heading">\n                        <h4 class="panel-title">\n                            <button class="btn btn-sm btn-default" ng-disabled="taxonomy == null" ng-click="editCategories()">Edit</button>\n                        </h4>\n                    </div>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length > 0">\n                        <li class="list-group-item">\n                            <h4><span title="{{categoryTitle(category)}}" style="max-width: 500px;" ng-repeat="category in taxonomicMemberships" class="label label-default label-tag overflow-ellipsis">{{categoryTitle(category)}}</span></h4>\n                        </li>\n                    </ul>\n                    <ul class="list-group" ng-if="taxonomicMemberships.length === 0">\n                        <li class="list-group-item help-block">Click edit to categorize this stream.</li>\n                    </ul>\n                </div>\n            </div>\n            <div class="form-group clearfix">\n                <div class="navbar-right">\n                    <button id="search-twitter" ng-disabled="form.$invalid" ng-class="twitterPreview ? \'btn btn-default\' : \'btn btn-primary\'" ng-click="search()">{{searchBtn}}</button>\n                    <button ng-show="twitterPreview" ng-disabled="form.$invalid || addBtn === \'Saving...\'" style="margin:0;" class="btn btn-primary add-twitter-streamsource" ng-click="save()">{{addBtn}}</button>\n                    <button ng-show="streamId" class="btn btn-default" ng-click="$dismiss()">Cancel</button>\n                </div>\n            </div>\n            <hr style="margin:0;">\n            <div class="form-group clearfix" id="search-twitter-results" ng-show="twitterPreview">\n                <div id="search-twitter-preview">\n                    <div class="twitter-preview">\n                        <div class="row">\n                            <div class="col-md-12">\n                                <h4>{{title}}<br/><small>{{description}}</small></h4>\n                            </div>\n                        </div>\n                        <div class="twitter-preview-items">\n                            <h5>Article Preview:</h5>\n                            <div id="reading-table" class="position-relative">\n                                <div class="reading-item" ng-repeat="item in twitterItems">\n                                    <div style="cursor:default;" class="rich-list-link rich-list-item-read">\n                                        <div class="rich-list-item-group">\n                                            <div class="rich-list-item-seg rich-list-link-inline-excerpt item-list-title" style="float: none; position: static;" title="{{item.text}}">{{item.text}}</div>\n                                            <div class="rich-list-item-seg align-right muted item-list-date" am-time-ago="item.created_at"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('/templates//streams/aggregationTableTightView.html','<div class="row hidden-sm hidden-xs streams-table-panel-header" scrolled>\n    <div class="col-md-1">\n        <span ng-if="!params.catalogId" ng-show="hasManageStreamPermission">\n            <input class="select-stream-checkbox hidden-sm hidden-xs" type="checkbox" ng-model="params.selectAll" ng-click="toggleSelectAll(params.selectAll)">\n        </span>\n        <span ng-if="params.catalogId" show-with-permission action="MANAGE_CATALOG">\n            <input class="select-stream-checkbox hidden-sm hidden-xs" type="checkbox" ng-model="params.selectAll" ng-click="toggleSelectAll(params.selectAll)">\n        </span>\n    </div>\n    <div class="col-md-1">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "status.aggregationDisabled", "admin_view": "true"}\' ng-click="toggleSort(\'settings.aggregationDisabled\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'settings.aggregationDisabled\'), \'fa-sort-asc\': isSort(\'settings.aggregationDisabled\', \'ASC\'), \'fa-sort-desc\': isSort(\'settings.aggregationDisabled\', \'DESC\') }"></i> Active\n        </a>\n    </div>\n    <div class="col-md-1">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "status.inError", "admin_view": "true"}\' ng-click="toggleSort(\'status.inError\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'status.inError\'), \'fa-sort-asc\': isSort(\'status.inError\', \'ASC\'), \'fa-sort-desc\': isSort(\'status.inError\', \'DESC\') }"></i> Last Status\n        </a>\n    </div>\n    <div class="col-md-3">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "titleLower", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'titleLower\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'titleLower\'), \'fa-sort-asc\': isSort(\'titleLower\', \'ASC\'), \'fa-sort-desc\': isSort(\'titleLower\', \'DESC\') }"></i> Title\n        </a>\n    </div>\n    <div class="col-md-1">\n        <strong>Type</strong>\n    </div>\n    <div class="col-md-2">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "status.lastSuccess", "admin_view": "true"}\' ng-click="toggleSort(\'status.lastSuccess\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'status.lastSuccess\'), \'fa-sort-asc\': isSort(\'status.lastSuccess\', \'ASC\'), \'fa-sort-desc\': isSort(\'status.lastSuccess\', \'DESC\') }"></i> Last Success\n        </a>\n    </div>\n    <div class="col-md-2">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "status.lastFailure", "admin_view": "true"}\' ng-click="toggleSort(\'status.lastFailure\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'status.lastFailure\'), \'fa-sort-asc\': isSort(\'status.lastFailure\', \'ASC\'), \'fa-sort-desc\': isSort(\'status.lastFailure\', \'DESC\') }"></i> Last Error\n        </a>\n    </div>\n    <div class="col-md-1">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "status.averageItemsPerDay", "admin_view": "true"}\' ng-click="toggleSort(\'status.averageItemsPerDay\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'status.averageItemsPerDay\'), \'fa-sort-asc\': isSort(\'status.averageItemsPerDay\', \'ASC\'), \'fa-sort-desc\': isSort(\'status.averageItemsPerDay\', \'DESC\') }"></i> Items Per Day\n        </a>\n    </div>\n</div>\n<spinner ng-show="showSpinner"></spinner>\n<div class="position-relative clearfix stream-table" ng-if="!showSpinner">\n    <div ng-repeat="stream in streams" class="clearfix">\n        <div class="row streams-table-row">\n            <div class="col-md-1 hidden-sm hidden-xs">\n                <span ng-if="!params.catalogId" ng-show="hasManageStreamPermission">\n                    <input class="select-stream-checkbox hidden-sm hidden-xs" type="checkbox" ng-model="stream.selected" ng-click="selectAllCheck(stream.selected)">\n                </span>\n                <span ng-if="params.catalogId" show-with-permission action="MANAGE_CATALOG">\n                    <input class="select-stream-checkbox hidden-sm hidden-xs" type="checkbox" ng-model="stream.selected" ng-click="selectAllCheck(stream.selected)">\n                </span>\n            </div>\n            <div class="col-md-1" style="padding-top: 3px">\n            <switch tooltip-placement="top" tooltip-popup-delay="500" tooltip-append-to-body="true" uib-tooltip="{{stream.settings.aggregationEnabled ? \'Disable aggregation\' : \'Enable aggregation\'}}" ng-model="stream.settings.aggregationEnabled" ng-change="saveAggregationStatus(stream)" class="small" on="On" off="Off"></switch>\n            </div>\n            <div class="col-md-1">\n                <span ng-class="stream.status.inError ? \'label-danger\' : \'label-success\'" class="label">{{stream.status.inError ? \'Error\' : \'OK\'}}</span>\n            </div>\n            <div class="col-md-3">\n                <h4 class="media-heading">\n                    <div class="ellipsis-color">\n                        <a class="overflow-ellipsis" ui-sref="editTopic.aggregation({streamId: stream.id})">\n                            <span class="overflow-ellipsis stream-title">\n                                <span title="{{::stream.title}}">{{::stream.title}}</span>\n                            </span>\n                        </a>\n                    </div>\n                </h4>\n                <p title="{{::stream.description}}" class="catalog-tile-description">{{::stream.description}}</p>\n            </div>\n            <div class="hidden-sm hidden-xs col-md-1">\n                <stream-type-indicator stream="::stream"></stream-type-indicator>\n            </div>\n            <div class="col-md-2">\n                <span am-time-ago="::stream.status.lastSuccess" title="{{::stream.status.lastSuccess | date: \'medium\'}}"></span>\n            </div>\n            <div class="col-md-2">\n                <span am-time-ago="::stream.status.lastFailure" title="{{::stream.status.lastFailure | date: \'medium\'}}"></span>\n            </div>\n            <div class="col-md-1">\n                {{::stream.status.averageItemsPerDay | number:1}}\n            </div>\n        </div>\n    </div>\n    <ng-include src="\'/templates/streams/streamsPager.html\'"></ng-include>\n    <ng-include src="\'/templates/streams/emptyStreamsWarning.html\'"></ng-include>\n</div>\n');
$templateCache.put('/templates//streams/briefingsTableTightView.html','<div class="row hidden-sm hidden-xs streams-table-panel-header" scrolled>\n    <div class="col-md-4">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "titleLower", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'titleLower\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'titleLower\'), \'fa-sort-asc\': isSort(\'titleLower\', \'ASC\'), \'fa-sort-desc\': isSort(\'titleLower\', \'DESC\') }"></i> Stream\n        </a>\n    </div>\n    <div class="col-md-2">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "briefingTemplateTitle", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'briefingTemplateTitle\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'briefingTemplateTitle\'), \'fa-sort-asc\': isSort(\'briefingTemplateTitle\', \'ASC\'), \'fa-sort-desc\': isSort(\'briefingTemplateTitle\', \'DESC\') }"></i> Template\n        </a>\n    </div>\n    <div class="col-md-1">\n        <strong>Schedule</strong>\n    </div>\n    <div class="col-md-2">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "briefingLastSentDate", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'briefingLastSentDate\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'briefingLastSentDate\'), \'fa-sort-asc\': isSort(\'briefingLastSentDate\', \'ASC\'), \'fa-sort-desc\': isSort(\'briefingLastSentDate\', \'DESC\') }"></i> Last Sent\n        </a>\n    </div>\n    <div class="col-md-2">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "briefingSchedule.nextScheduledDate", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'briefingSchedule.nextScheduledDate\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'briefingSchedule.nextScheduledDate\'), \'fa-sort-asc\': isSort(\'briefingSchedule.nextScheduledDate\', \'ASC\'), \'fa-sort-desc\': isSort(\'briefingSchedule.nextScheduledDate\', \'DESC\') }"></i> Next Scheduled\n        </a>\n    </div>\n    <div class="col-md-1">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "subscribersCount", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'subscribersCount\')" title="Subscribers">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'subscribersCount\'), \'fa-sort-asc\': isSort(\'subscribersCount\', \'ASC\'), \'fa-sort-desc\': isSort(\'subscribersCount\', \'DESC\') }"></i> <span class="glyphicon glyphicon-user"></span>\n        </a>\n    </div>\n</div>\n<spinner ng-show="showSpinner"></spinner>\n<div class="position-relative clearfix stream-table" ng-if="!showSpinner">\n    <div ng-repeat="stream in streams" class="clearfix">\n        <div class="row streams-table-row">\n            <div class="col-md-4 col-xs-4">\n                <h4 class="media-heading">\n                    <div class="ellipsis-color">\n                        <a class="overflow-ellipsis" ui-sref="editTopic.syndication({streamId: stream.id})">\n                            <span class="stream-title overflow-ellipsis">\n                                <span title="{{::stream.title}}">{{::stream.title}}</span>\n                            </span>\n                        </a>\n                    </div>\n                </h4>\n                <p title="{{::stream.description}}" class="catalog-tile-description">{{::stream.description}}</p>\n            </div>\n            <div class="hidden-sm hidden-xs col-md-2">\n                <span class="overflow-ellipsis" title="{{stream.briefingTemplateTitle}}"><a ng-click="openTemplateBrowser(stream)">{{stream.briefingTemplateTitle}}</a></span>\n            </div>\n            <div class="col-md-1 col-xs-4">\n                <span class="overflow-ellipsis" title="{{::filteredFrequencies(stream.briefingSchedule)}}">{{::filteredFrequencies(stream.briefingSchedule)}}</span>\n            </div>\n            <div class="hidden-sm hidden-xs col-md-2">\n                {{::stream.briefingLastSentDate | amDateFormat:\'MMM Do YYYY, h:mm a\'}}\n            </div>\n            <div class="hidden-sm hidden-xs col-md-2 col-xs-2">\n                <ng-switch on="stream.briefingSchedule.scheduleMode">\n                    <span ng-switch-when="MANUAL">\n                        Manual\n                    </span>\n                    <span ng-switch-when="RECURRING">\n                        {{::stream.briefingSchedule.nextScheduledDate | amDateFormat:\'MMM Do YYYY, h:mm a\'}}\n                    </span>\n                </ng-switch>\n            </div>\n            <div class="col-md-1 col-xs-1">\n                <a ng-click="openFollowersModal(stream, true)">\n                    <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Subscribers">\n                        <span id="subscribersCount-{{::stream.id}}">{{::stream.subscribersCount}}</span>\n                    </span>\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n<ng-include src="\'/templates/streams/streamsPager.html\'"></ng-include>');
$templateCache.put('/templates//streams/emptyStreamsWarning.html','<div ng-show="emptyStreams">\n    <div ng-if="streamFilter && !params.term" class="alert alert-warning alert-dismissible" role="alert">\n        No streams match your filter criteria. <a ng-click="removeFilter()">Clear filter</a>.\n    </div>\n    <div ng-if="!streamFilter && params.term" class="alert alert-warning alert-dismissible" role="alert">\n        No streams match your search criteria. <a ng-click="clearSearch()">Clear search</a>.\n    </div>\n    <div ng-if="streamFilter && params.term" class="alert alert-warning alert-dismissible" role="alert">\n        No streams match your filter and search criteria. <a ng-click="removeFilterAndSearch()">Show all</a>.\n    </div>\n    <div ng-if="!streamFilter && !params.term" style="padding-top: 40px;">\n        <empty-state-help ng-if="view !== \'aggregation-table\'"\n                          title="No topics yet?"\n                          sub-title="You gotta try this!"\n                          target-sref="seedTopic"\n                          link-text="Topic"></empty-state-help>\n        <h4 ng-if="view === \'aggregation-table\'">Nothing to aggregate</h4>\n    </div>\n</div>\n');
$templateCache.put('/templates//streams/streams.html','<div>\n    <div class="col-md-2 taxonomy-sidebar-column">\n        <ng-include ng-if="!params.searching" src="\'/templates/streams/streamsSidebar.html\'"></ng-include>\n        <ng-include ng-if="params.searching" src="\'/templates/streams/streamsSearchSidebar.html\'"></ng-include>\n    </div>\n    <div class="col-md-10 taxonomy-column">\n        <div class="row">\n            <alerts watch-for="streams-alerts" suppress-duplicates></alerts>\n            <ng-include src="\'/templates/streams/streamsHeader.html\'"></ng-include>\n        </div>\n        <div ng-if="view === \'stream-tile\'">\n            <ng-include src="\'/templates/streams/streamsTileView.html\'"></ng-include>\n        </div>\n        <div ng-if="view === \'stream-table\'">\n            <ng-include src="\'/templates/streams/streamsTableTightView.html\'"></ng-include>\n        </div>\n        <div ng-if="view === \'briefing-table\'">\n            <ng-include src="\'/templates/streams/briefingsTableTightView.html\'"></ng-include>\n        </div>\n        <div ng-if="view === \'aggregation-table\'">\n            <ng-include src="\'/templates/streams/aggregationTableTightView.html\'"></ng-include>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//streams/streamsHeader.html','<div ng-if="view !== \'stream-tile\'" class="row tight-left catalog-dark-header bg-darkgrey" style="margin-left: -1px;" show-with-permission action="MANAGE_STREAM">\n    <ul class="nav nav-tabs">\n        <span class="pull-left" style="padding-left: 20px;">\n            <a id="streams-tile-view-button" class="btn" style="color: white;" ng-click="setView(\'stream-tile\')" title="Tile View">\n                <i class="glyphicon glyphicon-th-list"></i>\n            </a>\n        </span>\n        <li class="catalog-header-tabs white-text" ng-class="{\'active\': view === \'stream-table\'}">\n            <a ng-click="selectViewTab(\'stream-table\')">Streams<span ng-show="view === \'stream-table\' && streamCount !== null"> ({{streamCount}})</span></a>\n        </li>\n        <li class="catalog-header-tabs white-text" ng-class="{\'active\': view === \'briefing-table\'}" ng-if="currentTaxonomy === \'tenant\' && !tenant.settings.noStreamBriefings">\n            <a ng-click="selectViewTab(\'briefing-table\')">Briefings<span ng-show="view === \'briefing-table\' && streamCount !== null"> ({{streamCount}})</span></a>\n        </li>\n        <li class="catalog-header-tabs white-text" ng-class="{\'active\': view === \'aggregation-table\'}" ng-if="currentTaxonomy === \'tenant\'">\n            <a ng-click="selectViewTab(\'aggregation-table\')">Aggregation<span ng-show="view === \'aggregation-table\' && streamCount !== null"> ({{streamCount}})</span></a>\n        </li>\n        <li class="catalog-header-tabs white-text" ng-class="{\'active\': view === \'aggregation-table\'}" ng-if="currentTaxonomy !== \'tenant\'" show-with-permission action="MANAGE_CATALOG">\n            <a ng-click="selectViewTab(\'aggregation-table\')">Aggregation<span ng-show="view === \'aggregation-table\' && streamCount !== null"> ({{streamCount}})</span></a>\n        </li>\n    </ul>\n</div>\n<div class="row catalog-header bg-lightgrey tight-left" scrolled="85">\n    <div class="pull-left">\n        <div style="padding:0px 10px;">\n            <span ng-if="view === \'stream-tile\'" style="padding-left: 10px;">\n                <a id="streams-table-view-button" class="btn" ng-click="setView(\'stream-table\')" title="List View">\n                    <i class="glyphicon glyphicon-list"></i>\n                </a>\n            </span>\n            <span ng-if="view === \'stream-table\'" class="pull-left" style="padding-left: 10px;" hide-with-permission action="MANAGE_STREAM">\n                <a class="btn" ng-click="setView(\'stream-tile\')" title="Tile View">\n                    <i class="glyphicon glyphicon-th-list"></i>\n                </a>\n            </span>\n            <label ng-if="view === \'stream-table\'" ng-show="streamCount || streamCount === 0" class="catalog-header-stream-count" hide-with-permission action="MANAGE_STREAM">{{streamCount}} Streams</label>\n            <a class="feedback-link" ng-if="view === \'stream-table\'" ng-show="feedbackLinkTitle" hide-with-permission action="MANAGE_STREAM" href="{{feedbackLinkUrl}}" target="_blank">{{feedbackLinkTitle}}</a>\n            <label ng-if="view === \'stream-tile\'" ng-show="streamCount || streamCount === 0" class="catalog-header-stream-count">{{streamCount}} Streams</label>\n            <button class="btn btn-subtle-link streams-scroll-top" scrollup="">\n                <span class="glyphicon glyphicon-chevron-up"></span>\n            </button>\n        </div>\n    </div>\n    <div class="pull-left hidden-sm hidden-xs" style="position:relative; padding-left: 16px;">\n        <button click-event eventname="new_topic_clicked" eventargs=\'{"admin_view": {{view === "stream-table"}}}\'\n                ui-sref="seedTopic" class="btn btn-primary" ng-if="!params.catalogId || params.catalogId === \'tenant\'"\n                show-with-permission action="CREATE_STREAM" id="create-topic-button">\n                    <span class="fa fa-plus"></span> Topic\n        </button>\n        <button click-event eventname="new_topic_clicked" eventargs=\'{"admin_view": {{view === "stream-table"}}}\'\n                ng-click="createEmptyCatalogTopic()" ng-if="currentTaxonomy !== \'tenant\'"\n                class="btn btn-primary" show-with-permission action="MANAGE_CATALOG">\n            <span class="fa fa-plus"></span> Topic\n        </button>\n        <button click-event eventname="new_source_clicked" eventargs=\'{"admin_view": {{view === "stream-table"}}}\'\n                ui-sref="streamCreate({category: params.categoryId})" ng-if="currentTaxonomy === \'tenant\'"\n                class="btn btn-primary" show-with-permission action="CREATE_STREAM" id="create-stream-button">\n                    <span class="fa fa-plus"></span> Source\n        </button>\n        <button click-event eventname="new_source_clicked" eventargs=\'{"admin_view": {{view === "stream-table"}}}\'\n                ui-sref="streamCreate({category: params.categoryId, catalog: params.catalogId})" ng-if="currentTaxonomy !== \'tenant\'"\n                class="btn btn-primary" show-with-permission action="MANAGE_CATALOG">\n            <span class="fa fa-plus"></span> Source\n        </button>\n        <span ng-if="view === \'stream-table\' && !params.catalogId" show-with-permission action="MANAGE_STREAM" uib-dropdown>\n            <button id="streams-bulk-menu-button" class="btn btn-default" ng-disabled="!params.selectedCount" data-toggle="dropdown" uib-dropdown-toggle>Bulk Actions <span class="fa fa-caret-down"></span></button>\n            <ul uib-dropdown-menu class="dropdown-menu" id="streams-bulk-action-dropdown">\n                <li><a ng-click="bulkAction(deleteStreams)">Delete</a></li>\n                <li><a ng-click="bulkAction(setStreamPublish, true)" show-with-permission action="PUBLISH_STREAM">Publish</a></li>\n                <li><a ng-click="bulkAction(setStreamPublish, false)" show-with-permission action="PUBLISH_STREAM">Unpublish</a></li>\n                <li><a id="streams-bulk-add-to-categories" ng-click="bulkAction(addCategoriesToStreams)">Add To Categories</a></li>\n                <li><a id="streams-bulk-add-tags" ng-click="bulkAction(addTagsToStreams)">Tag Streams</a></li>\n            </ul>\n        </span>\n        <a class="feedback-link" ng-if="view === \'stream-table\' || view === \'stream-tile\'" ng-show="feedbackLinkTitle" show-with-permission action="MANAGE_STREAM" href="{{feedbackLinkUrl}}" target="_blank">{{feedbackLinkTitle}}</a>\n        <span ng-if="view === \'aggregation-table\' && !params.catalogId" show-with-permission action="MANAGE_STREAM" uib-dropdown>\n            <button class="btn btn-default" ng-disabled="!params.selectedCount" data-toggle="dropdown" uib-dropdown-toggle>Bulk Actions <span class="fa fa-caret-down"></span></button>\n            <ul uib-dropdown-menu class="dropdown-menu" id="streams-bulk-action-dropdown">\n                <li><a ng-click="bulkAction(setDisableAggregation, false)">Enable Aggregation</a></li>\n                <li><a ng-click="bulkAction(setDisableAggregation, true)">Disable Aggregation</a></li>\n                <li><a ng-click="bulkAction(deleteStreams)">Delete</a></li>\n            </ul>\n        </span>\n        <span ng-if="params.catalogId" show-with-permission action="MANAGE_CATALOG" uib-dropdown>\n            <button class="btn btn-default" ng-disabled="!params.selectedCount" data-toggle="dropdown" uib-dropdown-toggle>Bulk Actions <span class="fa fa-caret-down"></span></button>\n            <ul uib-dropdown-menu class="dropdown-menu" id="streams-bulk-action-dropdown">\n                <li><a ng-click="bulkAction(deleteStreams)">Delete</a></li>\n            </ul>\n        </span>\n    </div>\n    <div class="pull-right" style="margin-right: 30px;position: relative;">\n        <input type="text" class="form-control pull-right" style="width:300px;" placeholder="Search" ng-model="params.term" size="40" enter-key="searchStreams()" ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }" ng-change="searchStreams()">\n        <ul class="nav pull-right catalog-stream-sort-filter" style="padding-right:5px;">\n            <li ng-if="view === \'stream-tile\' && !params.segmentation" class="dropdown" uib-dropdown>\n                <button id="streams-header-sort-menu-button" type="button" class="btn btn-default dropdown-toggle" uib-tooltip="Sort streams" tooltip-append-to-body="true" uib-dropdown-toggle><span class="glyphicon glyphicon-sort"></span> {{selectedSort.label || \'Title\'}} <span class="caret"></span></button>\n                <ul class="dropdown-menu" role="menu">\n                    <li click-event eventname="stream_sort_selected" eventargs=\'{"sort": "{{sort.sort}}", "admin_view": {{view === "stream-table"}}}\' ng-repeat="sort in ::sortOptions"><a ng-click="changeSort(sort)">{{::sort.label}}</a></li>\n                </ul>\n            </li>\n            <li ng-if="(view === \'stream-table\' || view === \'stream-tile\' || view === \'aggregation-table\') && !params.catalogId && !params.segmentation">\n                    <button class="btn btn-default"\n                            export-to-csv\n                            format-data="fetchForCSV()"\n                            filename="streams.csv"\n                            ng-disabled="fetchingForCSV"\n                            title="Download CSV file of all streams">\n                        <span class="fa fa-download"></span>\n                    </button>\n            </li>\n            <li ng-if="!streamFilter && (view === \'stream-table\' || view === \'stream-tile\') && !params.catalogId && !params.segmentation" uib-dropdown auto-close="outsideClick" dropdown-append-to-body>\n                <button class="btn btn-default dropdown-toggle" uib-dropdown-toggle title="Filter">\n                    <span class="glyphicon glyphicon-filter"></span> All <span class="caret"></span>\n                </button>\n                <ul uib-dropdown-menu class="dropdown-menu" role="menu">\n                    <li role="presentation" class="dropdown-header">Type</li>\n                    <li ng-repeat="filter in typeFilters">\n                        <a click-event eventname="stream_filter_selected" eventargs=\'{"filter": "{{filter.label}}", "admin_view": {{view === "stream-table"}}}\' ng-click="filterStreams(filter)"><i class="fa" ng-class="filter.icon"></i> {{filter.label}}</a>\n                    </li>\n                    <li class="divider"></li>\n                    <li show-with-permission action="MANAGE_STREAM">\n                        <a click-event eventname="stream_filter_selected" eventargs=\'{"filter": "Published", "admin_view": {{view === "stream-table"}}}\' ng-click="filterStreams(nonTypeFilters[0])"><i class="fa fa-book"></i> Published</a>\n                    </li>\n                    <li ng-if="!tenant.settings.noStreamBriefings">\n                        <a click-event eventname="stream_filter_selected" eventargs=\'{"filter": "Briefings", "admin_view": {{view === "stream-table"}}}\' ng-click="filterStreams(nonTypeFilters[1])"><i class="fa fa-envelope-o"></i> Briefings</a>\n                    </li>\n                    <li class="divider"></li>\n                    <li class="dropdown-input">\n                        <input type="text"\n                               class="form-control add-tag"\n                               uib-typeahead="tag.label for tag in tenantStreamTags | filter: {label:$viewValue}"\n                               typeahead-on-select="selectTag($item, $model, $label)"\n                               typeahead-select-on-blur="true"\n                               placeholder="Tag"\n                               maxlength="50"\n                               ng-model="newTag">\n                    </li>\n                </ul>\n            </li>\n            <li ng-if="streamFilter && (view === \'stream-table\' || view === \'stream-tile\') && !params.segmentation">\n                <button click-event eventname="stream_filter_cleared" eventargs=\'{"filter": "{{streamFilter.label}}", "admin_view": {{view === "stream-table"}}}\' type="button" class="btn btn-default streams-clear-filter-button" title="Remove filter" ng-click="removeFilter()">\n                    <span class="glyphicon glyphicon-filter"></span> {{streamFilter.label}} <i class="fa fa-times"></i>\n                </button>\n            </li>\n        </ul>\n        <a ng-click="clearSearch()" ng-show="params.term" id="streams-search-clear" class="glyphicon glyphicon-remove-sign form-control-feedback search-clear" aria-hidden="true"></a>\n    </div>\n</div>\n');
$templateCache.put('/templates//streams/streamsPager.html','<div ng-show="!showSpinner && totalPages && totalPages > 1" class="row" style="padding-top:10px;">\n    <div class="col-md-12">\n        <uib-pagination total-items="streamCount"\n                        boundary-link-numbers="true"\n                        ng-model="params.pagerPage"\n                        items-per-page="params.rows"\n                        ng-change="fetchPage()"\n                        max-size="5"\n                        previous-text="&lsaquo;"\n                        next-text="&rsaquo;">\n        </uib-pagination>\n    </div>\n</div>');
$templateCache.put('/templates//streams/streamsSearchSidebar.html','<div class="streams-search" full-height>\n    <div ng-controller="StreamsSearchCtrl">\n        <div class="reading-menu-category streams-search-top row">\n            <div class="col-md-2">\n                <a id="clear-stream-search-button" class="btn" ng-click="clearSearch()">\n                    <i class="glyphicon glyphicon-chevron-left"></i>\n                </a>\n            </div>\n        </div>\n        <div class="row row-pad-top">\n            <div class="col-md-offset-1 col-md-11">\n                <label>Search In:</label>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-offset-1 col-md-11">\n                <ul class="nav">\n                    <li class="dropdown" uib-dropdown auto-close="outsideClick" is-open="isOpen">\n                        <span>\n                            <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-click="start(isOpen)">\n                                <div class="search-segmentation-label pull-left" title="{{segmentationLabel()}}">{{segmentationLabel()}}</div>\n                                <span class="caret"></span>\n                            </button>\n                        </span>\n                        <div class="dropdown-menu search-within-menu">\n                            <div class="row">\n                                <div class="col-md-12 search-filter-title">\n                                    Search Within:\n                                </div>\n                            </div>\n                            <!-- All  the things -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline" ng-model="params.segmentKey" ng-change="selectSegment({segment: \'all\'})" ng-value="\'all\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <span class="search-menu-label-unexpandable">All Catalogs</span>\n                                </div>\n                            </div>\n                            <!-- /All  the things -->\n                            <!-- Recommended things -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline" ng-model="params.segmentKey" ng-change="selectSegment({segment: \'recommended\'})" ng-value="\'recommended\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <span class="search-menu-label-unexpandable">Recommended</span>\n                                </div>\n                            </div>\n                            <!-- /Recommended things -->\n                            <!-- Tenant -->\n                            <div class="row selection-row">\n                                <div class="col-md-1">\n                                    <input type="radio" class="radio inline"ng-model="params.segmentKey" ng-change="selectSegment({segment: \'taxonomy\'})" ng-value="\'taxonomy\'">\n                                </div>\n                                <div class="col-md-9">\n                                    <a ng-click="searchMenuState.categoriesExpanded = !searchMenuState.categoriesExpanded; $event.stopPropagation();">\n                                        <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.categoriesExpanded,\n                                                                           \'glyphicon-triangle-right\': !searchMenuState.categoriesExpanded}"></span>\n                                    </a>\n                                    <span class="search-menu-label">{{catalogNavigationLabel}}</span>\n                                </div>\n                            </div>\n                            <span ng-show="searchMenuState.categoriesExpanded">\n                                <span ng-repeat="category in taxonomy">\n                                    <div class="row selection-row">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline"ng-model="params.segmentKey" ng-change="selectSegment({segment: \'taxonomyCategory\', id: category.id })" ng-value="\'taxonomyCategory-\' + category.id">\n                                        </div>\n                                        <div class="col-md-offset-1 col-md-8">\n                                            <a ng-show="category.subcategories.length" ng-click="searchMenuState.categoryExpandedMap[category.id] = !searchMenuState.categoryExpandedMap[category.id]; $event.stopPropagation();">\n                                                <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.categoryExpandedMap[category.id],\n                                                                                   \'glyphicon-triangle-right\': !searchMenuState.categoryExpandedMap[category.id]}"></span>\n                                            </a>\n                                            <span ng-class="{\'search-menu-label\': category.subcategories.length, \'search-menu-label-unexpandable\': !category.subcategories.length}">{{category.title}}</span>\n                                        </div>\n                                    </div>\n                                    <div class="row selection-row" ng-repeat="subcategory in category.subcategories" ng-show="searchMenuState.categoryExpandedMap[category.id]">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline" ng-model="params.segmentKey" ng-change="selectSegment({segment: \'taxonomyCategory\', id: subcategory.id })" ng-value="\'taxonomyCategory-\' + subcategory.id">\n                                        </div>\n                                        <div class="col-md-offset-2 col-md-8">\n                                            <span class="search-menu-label">{{subcategory.title}}</span>\n                                        </div>\n                                    </div>\n                                </span>\n                            </span>\n                            <!-- /Tenant -->\n                            <!-- Catalog -->\n                            <span ng-repeat="catalog in tenantCatalogMap">\n                                <div class="row selection-row">\n                                    <div class="col-md-1">\n                                        <input type="radio" class="radio inline"ng-model="params.segmentKey" ng-change="selectSegment({segment: \'catalog\', id: catalog.catalogId })" ng-value="\'catalog-\' + catalog.catalogId">\n                                    </div>\n                                    <div class="col-md-9">\n                                        <a ng-click="searchMenuState.catalogExpandedMap[catalog.catalogId] = !searchMenuState.catalogExpandedMap[catalog.catalogId]; $event.stopPropagation();">\n                                            <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.catalogExpandedMap[catalog.catalogId],\n                                                                               \'glyphicon-triangle-right\': !searchMenuState.catalogExpandedMap[catalog.catalogId]}"></span>\n                                        </a>\n                                        <span class="search-menu-label">{{catalog.label}}</span>\n                                    </div>\n                                </div>\n                                <span ng-repeat="category in catalogTaxonomy[catalog.catalogId]" ng-show="searchMenuState.catalogExpandedMap[catalog.catalogId]">\n                                    <div class="row selection-row">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline"ng-model="params.segmentKey" ng-change="selectSegment({segment: \'catalogCategory\', catalogId: catalog.catalogId, id: category.id})" ng-value="\'catalogCategory-\' + catalog.catalogId + \'-\' + category.id">\n                                        </div>\n                                        <div class="col-md-offset-1 col-md-9">\n                                            <a ng-show="category.subcategories.length" ng-click="searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id] = !searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id]; $event.stopPropagation();">\n                                                <span class="glyphicon" ng-class="{\'glyphicon-triangle-bottom\': searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id],\n                                                                                   \'glyphicon-triangle-right\': !searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id]}"></span>\n                                            </a>\n                                            <span ng-class="{\'search-menu-label\': category.subcategories.length, \'search-menu-label-unexpandable\': !category.subcategories.length}">{{category.title}}</span>\n                                        </div>\n                                    </div>\n                                    <div class="row selection-row" ng-repeat="subcategory in category.subcategories" ng-show="searchMenuState.catalogCategoryExpandedMap[catalog.catalogId][category.id]">\n                                        <div class="col-md-1">\n                                            <input type="radio" class="radio inline"ng-model="params.segmentKey" ng-change="selectSegment({segment: \'catalogCategory\', catalogId: catalog.catalogId, id: subcategory.id})" ng-value="\'catalogCategory-\' + catalog.catalogId + \'-\' + subcategory.id">\n                                        </div>\n                                        <div class="col-md-offset-2 col-md-7">\n                                            <span class="search-menu-label">{{subcategory.title}}</span>\n                                        </div>\n                                    </div>\n                                </span>\n                            </span>\n                            <!-- /Catalog -->\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class="row row-pad-top">\n            <div class="col-md-offset-1 col-md-11">\n                <label>With the query:</label>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-offset-1 col-md-11">\n                <textarea class="search-control" ng-model="params.term" ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }" ng-change="search()">\n                </textarea>\n                <div class="has-error" ng-if="termRequired">\n                    <small class="help-block">Search Term is required for this type of search</small>\n                </div>\n            </div>\n        </div>\n        <div class="row row-pad-top">\n            <div class="col-md-offset-1 col-md-11">\n                <label>Tagged with:</label>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-offset-1 col-md-11">\n                <input type="text"\n                       class="form-control add-tag"\n                       id="tag"\n                       uib-typeahead="tag.label for tag in tagSet() | filter: {label:$viewValue}"\n                       typeahead-on-select="selectTag($item, $model, $label)"\n                       placeholder="Tags"\n                       maxlength="50"\n                       ng-model="newTag"\n                       ng-disabled="params.segmentation.segment === \'recommended\'">\n                <div ng-show="newTag && !params.segmentation.tagIds">\n                    <div class="has-error">\n                        <small id="no-tag-match" class="help-block">Tag does not exist</small>\n                    </div>\n                </div>\n                <div ng-show="params.segmentation.segment === \'recommended\'">\n                    <div>\n                        <small class="help-block">Tags are not supported for searches in recommended.</small>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//streams/streamsSidebar.html','<div class="catalog-sidebar" full-height scrolled="85">\n    <uib-accordion close-others="true">\n        <uib-accordion-group is-open="taxonomyOpenMap[\'tenant\']" is-disabled="taxonomyOpenMap[\'tenant\']">\n            <uib-accordion-heading>\n                <div class="row" ng-class="{\'active\': !params.categoryId && !params.catalogId, \'before-active\':category.id === params.categoryId}">\n                    <div class="col-xs-9">\n                        <a id="streams-select-all-taxonomy-button" click-event eventname="category_selected" eventargs=\'{"category": "all", "admin_view": {{adminView}}}\' ng-click="selectTenantCatalog()"><h4 class="text-primary"> {{catalogNavigationLabel}}</h4></a>\n                    </div>\n                </div>\n            </uib-accordion-heading>\n            <ul full-height class="streams-sidebar-section" additional-padding="{{145 + (45 * catalogCount)}}">\n                <li ng-repeat="category in taxonomy"\n                    ng-class="{\'active\': category.id === params.categoryId, \'last\':$last, \'before-active\':isBeforeSelected($index)}"\n                    class="category-row cursor-pointer"\n                    scrollup>\n                    <div class="row category-detail-row"\n                         click-event\n                         eventname="category_selected"\n                         eventargs=\'{"category": "{{category.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-1" style="margin-top: 9px;">\n                            <a ng-show="category.subcategories.length" ng-click="category.expanded = !category.expanded" class="category-toggle"><span class="glyphicon" ng-class="{ \'glyphicon-triangle-right\': !category.expanded, \'glyphicon-triangle-bottom\': category.expanded}"></span></a>\n                        </div>\n                        <div class="taxonomy-category-select-link col-md-10" ng-click="selectCategory(category)">\n                            <h5 class="overflow-ellipsis text-primary" title="{{::category.title}}">{{::category.title}}</h5>\n                        </div>\n                    </div>\n                    <div ng-show="category.expanded" class="subcategory row" ng-repeat="subcategory in category.subcategories"\n                         ng-class="{\'active\': subcategory.id === params.categoryId }"\n                         click-event\n                         eventname="category_selected"\n                         eventargs=\'{"category": "{{subcategory.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-offset-2 col-md-10" ng-click="selectCategory(subcategory)">\n                            <h5>{{subcategory.title}}</h5>\n                        </div>\n\n                    </div>\n                </li>\n            </ul>\n        </uib-accordion-group>\n        <uib-accordion-group ng-repeat="catalog in tenantCatalogMap" is-open="taxonomyOpenMap[catalog.catalogId]" is-disabled="taxonomyOpenMap[catalog.catalogId]">\n            <uib-accordion-heading>\n                <div class="row" ng-class="{\'active\': !params.categoryId && params.catalogId === catalog.catalogId, \'before-active\':category.id === params.categoryId}" ng-click="selectCatalog(catalog)">\n                    <div class="col-xs-12">\n                        <a><h4 class="text-primary"> {{catalog.label}}</h4></a>\n                    </div>\n                </div>\n            </uib-accordion-heading>\n            <ul full-height class="streams-sidebar-section" additional-padding="190">\n                <li ng-repeat="category in catalogTaxonomy[catalog.catalogId]"\n                    ng-class="{\'active\': category.id === params.categoryId, \'last\':$last, \'before-active\':isBeforeSelected($index)}"\n                    class="category-row cursor-pointer"\n                    scrollup>\n                    <div class="row category-detail-row" click-event eventname="category_selected" eventargs=\'{"category": "{{category.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-1" style="margin-top: 9px;">\n                            <a ng-show="category.subcategories.length" ng-click="category.expanded = !category.expanded" class="category-toggle"><span class="glyphicon" ng-class="{ \'glyphicon-triangle-right\': !category.expanded, \'glyphicon-triangle-bottom\': category.expanded}"></span></a>\n                        </div>\n                        <div class="col-md-10" ng-click="selectCatalogCategory(catalog, category)">\n                            <h5 class="overflow-ellipsis text-primary" title="{{::category.title}}">{{::category.title}}</h5>\n                        </div>\n                    </div>\n                    <div ng-show="category.expanded" class="subcategory row" ng-repeat="subcategory in category.subcategories"\n                         ng-class="{\'active\': subcategory.id === params.categoryId }"\n                         click-event\n                         eventname="category_selected"\n                         eventargs=\'{"category": "{{subcategory.title}}", "admin_view": {{adminView}}}\'>\n                        <div class="col-md-offset-2 col-md-10" ng-click="selectCatalogCategory(catalog, subcategory)">\n                            <h5>{{subcategory.title}}</h5>\n                        </div>\n\n                    </div>\n                </li>\n            </ul>\n        </uib-accordion-group>\n    </uib-accordion>\n</div>\n');
$templateCache.put('/templates//streams/streamsTableTightView.html','<div class="row hidden-sm hidden-xs streams-table-panel-header" scrolled>\n    <div class="col-md-1">\n        <span ng-if="!params.catalogId || params.searching" ng-show="hasManageStreamPermission">\n            <input id="streams-table-select-all" class="select-stream-checkbox hidden-sm hidden-xs" type="checkbox" ng-model="params.selectAll" ng-click="toggleSelectAll(params.selectAll)">\n        </span>\n        <span ng-if="params.catalogId" show-with-permission action="MANAGE_CATALOG">\n            <input class="select-stream-checkbox hidden-sm hidden-xs" type="checkbox" ng-model="params.selectAll" ng-click="toggleSelectAll(params.selectAll)">\n        </span>\n    </div>\n    <div class="col-md-3">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "titleLower", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'titleLower\')">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'titleLower\'), \'fa-sort-asc\': isSort(\'titleLower\', \'ASC\'), \'fa-sort-desc\': isSort(\'titleLower\', \'DESC\') }"></i> Title\n        </a>\n    </div>\n    <div class="col-md-1" ng-if="!params.catalogId || params.searching">\n        <strong title="Stream Type">Type</strong>\n    </div>\n    <div class="col-md-1" ng-if="!params.catalogId || params.searching">\n        <i title="Published" class="fa fa-book"></i>\n    </div>\n    <div class="col-md-1"  ng-hide="noFollowing">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "followersCount", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'followersCount\')" title="Followers">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'followersCount\'), \'fa-sort-asc\': isSort(\'followersCount\', \'ASC\'), \'fa-sort-desc\': isSort(\'followersCount\', \'DESC\') }"></i> <span class="glyphicon glyphicon-user"></span>\n        </a>\n    </div>\n    <div class="col-md-1">\n        <a click-event eventname="stream_sort_selected" eventargs=\'{"sort": "itemsCount", "admin_view": {{view === "stream-table"}}}\' ng-click="toggleSort(\'itemsCount\')" title="Items">\n            <i class="fa" ng-class="{\'fa-sort\': (params.sort !== \'itemsCount\'), \'fa-sort-asc\': isSort(\'itemsCount\', \'ASC\'), \'fa-sort-desc\': isSort(\'itemsCount\', \'DESC\') }"></i> <span class="fa fa-copy"></span>\n        </a>\n    </div>\n</div>\n<spinner ng-show="showSpinner"></spinner>\n<div class="position-relative clearfix stream-table" ng-if="!showSpinner">\n    <div ng-repeat="stream in streams track by stream.id" class="clearfix">\n        <div class="row streams-table-row">\n            <div class="col-md-1 hidden-sm hidden-xs no-padd-right">\n                <span ng-if="stream.tenantId && (stream.tenantId === tenant.id)" ng-show="hasManageStreamPermission">\n                    <input class="select-stream-checkbox hidden-sm hidden-xs no-margin-right" type="checkbox" ng-model="stream.selected" ng-click="selectAllCheck(stream.selected)">\n                </span>\n                <span ng-if="params.catalogId" show-with-permission action="MANAGE_CATALOG">\n                    <input class="select-stream-checkbox hidden-sm hidden-xs" type="checkbox" ng-model="stream.selected" ng-click="selectAllCheck(stream.selected)">\n                </span>\n                <div ng-if="thumbnailImageAttachmentId || stream.thumbnailImage.uri" class="pull-right">\n                    <ng-include src="\'/templates/streamImageThumbnail.html\'"></ng-include>\n                </div>\n            </div>\n            <div class="col-md-3 col-xs-4">\n                <h4 class="media-heading">\n                    <div class="ellipsis-color">\n                        <a class="overflow-ellipsis" ng-click="viewStreamDetails(stream, categoryDetail)">\n                            <span class="stream-title overflow-ellipsis">\n                                <span title="{{::stream.title}}">{{::stream.title}}</span>\n                            </span>\n                        </a>\n                    </div>\n                </h4>\n                <p title="{{::stream.description}}" class="catalog-tile-description">{{::stream.description}}</p>\n            </div>\n            <div class="hidden-sm hidden-xs col-md-1" ng-if="(stream.tenantId && (stream.tenantId === tenant.id)) || params.searching">\n                <span ng-if="stream.tenantId && (stream.tenantId === tenant.id)"><stream-type-indicator stream="::stream"></stream-type-indicator></span>\n            </div>\n            <div class="hidden-sm hidden-xs col-md-1" ng-if="(stream.tenantId && (stream.tenantId === tenant.id)) || params.searching">\n                <publish-toggle stream="stream" has-manage-stream-permission="::hasManageStreamPermission"></publish-toggle>\n            </div>\n            <div class="hidden-lg hidden-md col-xs-1" ng-if="(stream.tenantId && (stream.tenantId === tenant.id)) || params.searching">\n                <span ng-if="stream.tenantId && (stream.tenantId === tenant.id)">\n                    <stream-type-indicator stream="::stream"></stream-type-indicator>\n                    <publish-toggle stream="stream" has-manage-stream-permission="::hasManageStreamPermission"></publish-toggle>\n                </span>\n            </div>\n            <div class="col-md-1 col-xs-1" ng-hide="noFollowing">\n                <a ng-click="openFollowersModal(stream, false, params.catalogId)">\n                    <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Followers">\n                        <span id="followersCount-{{::stream.id}}">{{stream.followersCount}}</span>\n                    </span>\n                    <span ng-if="stream.type === \'PRODUCT_SOURCE\' && stream.streamSubscribersCount >= stream.maxStreamSubscribers" \n                          tooltip-placement="top" \n                          tooltip-append-to-body="true" \n                          uib-tooltip="This product has reached the maximum of {{stream.maxStreamSubscribers}} users.">\n                        <i style="color: red;" class="fa fa-exclamation-circle"></i>                    \n                    </span>\n                </a>\n            </div>\n            <div class="col-md-1 col-xs-1">\n                <span tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Articles">\n                    <span id="itemsCount">{{::stream.itemsCount}}</span>\n                </span>\n            </div>\n            <div class="col-xs-2 no-padding">\n                <span class="pull-left fixed-length-subscribe">\n                    <follow-button stream="stream" user="::user" type="stream" follow-style="primary">&nbsp;</follow-button>\n                </span>\n                <subscribe-button ng-if="::stream.briefingEnabled" stream="::stream" user="user" type="stream" subscribe-style="primary"></subscribe-button>\n            </div>\n            <div class="col-xs-1">\n                <a ng-show="stream.rssEnabled" target="_blank" href="/rss/{{::stream.id}}" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="RSS Feed">\n                    <i class="fa fa-rss"></i>\n                </a>\n                <span ng-show="!stream.rssEnabled" class="glyphicon glyphicon-none"></span>\n                <span ng-show="stream.briefingEnabled" class="fa fa-envelope-o" title="Briefings"></span>\n            </div>\n            <div class="hidden-xs hidden-sm col-xs-2" show-with-permission action="MANAGE_CATALOG">\n                <div class="btn-group" dropdown-append-to-body uib-dropdown>\n                    <a class="btn btn-default" ui-sref="editTopic.articles({streamId: stream.id, catalogId: params.catalogId, catalogCategories: stream.catalogCategories})">\n                        <span class="fa fa-edit"></span>\n                    </a>\n                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle>\n                        <span class="caret"></span>\n                    </button>\n                    <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-right" role="menu">\n                        <li>\n                            <a ng-click="deleteStream(stream, categoryDetail)">Delete</a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class="hidden-xs hidden-sm col-xs-1" ng-show="::hasManageStreamPermission" stream-id="::stream.id" style="padding-right: 0px;">\n                <span ng-if="stream.tenantId && (stream.tenantId === tenant.id)">\n                    <div class="btn-group" dropdown-append-to-body uib-dropdown>\n                        <a type="button" id="edit-{{::stream.id}}" class="btn btn-xs btn-default" ui-sref="editTopic.articles({streamId: stream.id})"><span class="fa fa-edit"></span></a>\n                        <button type="button" id="dropdown-{{::stream.id}}" class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle>\n                            <span class="caret"></span>\n                        </button>\n                        <ul class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu>\n                            <li>\n                                <a id="delete-{{::stream.id}}" ng-click="deleteStream(stream, categoryDetail)">Delete</a>\n                            </li>\n                            <li ng-if="!tenant.settings.noStreamBriefings">\n                                <a id="edit-briefing-link-{{::stream.id}}" stream-id="::stream.id" ui-sref="editTopic.syndication({streamId: stream.id})"">Edit Briefing</a>\n                            </li>\n                        </ul>\n                    </div>\n                </span>\n            </div>\n        </div>\n    </div>\n    <ng-include src="\'/templates/streams/streamsPager.html\'"></ng-include>\n    <ng-include src="\'/templates/streams/emptyStreamsWarning.html\'"></ng-include>\n</div>\n');
$templateCache.put('/templates//streams/streamsTileView.html','<spinner ng-show="showSpinner"></spinner>\n<div ng-if="!showSpinner">\n    <div class="catalog-tile clearfix" ng-repeat="stream in streams track by stream.id" ng-show="stream.title" id="tile">\n        <div class="media">\n            <div class="media-left" ng-if="thumbnailImageAttachmentId || stream.thumbnailImage.uri">\n                <ng-include src="\'/templates/streamImageThumbnail.html\'"></ng-include>\n            </div>\n            <div class="media-body tile-body">\n                <h4 class="media-heading">\n                    <div class="ellipsis-color">\n                        <a class="overflow-ellipsis" style="width: 270px" ng-click="viewStreamDetails(stream, categoryDetail)"><stream-type-indicator stream="stream"></stream-type-indicator> <span class="stream-tile-title" tooltip-placement="top" uib-tooltip="{{stream.title}}" tooltip-append-to-body="true">{{stream.title}}</span></a>\n                    </div>\n                </h4>\n                <p title="{{::stream.description}}" class="catalog-tile-description line-clamp">{{::stream.description}}</p>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-9">\n                <div class="pad-top-bottom">\n                    <div role="group" data-toggle="buttons" aria-label="...">\n                        <span id="tooltip-wrapper" ng-if="fromStream" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="{{tooltipManager(stream)}}">\n                                <button type="button" data-loading-text="Saving..." class="btn btn-primary catalog-stream-add-button" ng-class="{active: stream.streamIsSubscribed && fromStream}"  ng-click="toggleFollow(stream)" blur-me>\n                                    <span>{{stream.streamIsSubscribed ? \'Remove\' : \'Add\'}}</span>\n                                </button>\n                            </span>\n                        </span>\n                        <follow-button stream="stream" user="user" type="stream" follow-style="primary">&nbsp;</follow-button><subscribe-button ng-if="stream.briefingEnabled" stream="stream" user="user" type="stream" subscribe-style="primary"></subscribe-button>\n                        <span ng-show="hasManageStreamPermission" stream-id="::stream.id" style="padding-right: 0px;" ng-if="::stream.tenantId">\n                            <div class="btn-group" dropdown-append-to-body uib-dropdown>\n                                <button type="button" id="edit-{{::stream.id}}" class="btn btn-default" ui-sref="editTopic.articles({streamId: stream.id})""><span class="fa fa-edit"></span></button>\n                                <button type="button" id="dropdown-{{::stream.id}}" class="btn btn-default dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle>\n                                    <span class="caret"></span>\n                                </button>\n                                <ul class="dropdown-menu pull-right" role="menu" uib-dropdown-menu>\n                                    <li>\n                                        <a id="delete-{{::stream.id}}" ng-click="deleteStream(stream, categoryDetail)">Delete</a>\n                                    </li>\n                                    <li ng-if="!tenant.settings.noStreamBriefings">\n                                        <a id="edit-briefing-link-{{::stream.id}}" stream-id="::stream.id" ui-sref="editTopic.syndication({streamId: stream.id})">Edit Briefing</a>\n                                    </li>\n                                </ul>\n                            </div>\n                        </span>\n                        <a ng-if="!fromStream && stream.rssEnabled" class="text-primary btn rss-btn" tooltip-placement="top" uib-tooltip="RSS Feed" target="_blank" href="/rss/{{::stream.id}}">\n                            <i class="fa fa-rss"></i><br/>\n                            RSS\n                        </a>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-3" style="padding-left: 0;">\n                <div class="pad-top-bottom margin-top-bottom pull-right">\n                    <a ng-click="openFollowersModal(stream)" ng-hide="noFollowing">\n                        <span class="text-primary margin-left-right pull-right" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Followers">\n                            <span class="glyphicon glyphicon-user"></span>\n                            <span id="followersCount-{{::stream.id}}">{{stream.followersCount}}</span>\n                        </span>\n                    </a>\n                    <span class="muted-text margin-left-right pull-right" tooltip-placement="top" tooltip-append-to-body="true" uib-tooltip="Number of Items">\n                        <span class="fa fa-file"></span>\n                        <span id="itemsCount">{{::stream.itemsCount}}</span>\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <ng-include src="\'/templates/streams/streamsPager.html\'"></ng-include>\n    <ng-include src="\'/templates/streams/emptyStreamsWarning.html\'"></ng-include>\n</div>\n');
$templateCache.put('/templates//subscriptions/manageSubscriptions.html','<section class="row">\n    <div class="col-md-8 col-md-offset-2">\n        <personal-digest-stream-management></personal-digest-stream-management>\n    </div>\n</section>\n\n<section class="row">\n    <div class="col-md-8 col-md-offset-2">\n        <briefing-subscription-management></briefing-subscription-management>\n    </div>\n</section>');
$templateCache.put('/templates//topic/topic.html','<div class="topic-state" ng-if="topic.loaded">\n    <div ng-switch on="topic.indexVisible">\n        <div ng-switch-when="true" class="col-md-3 topic-sidebar-column" full-height>\n            <ng-include src="\'/templates/topic/topicSources.html\'"></ng-include>\n        </div>\n        <div ng-switch-when="false" class="col-md-1 topic-sidebar-column"></div>\n    </div>\n    <div ng-class="{\'col-md-9\': topic.indexVisible, \'col-md-10\': !topic.indexVisible}">\n        <div class="row">\n            <topic-summary-section topic="topic.mainStream" user="user"></topic-summary-section>\n        </div>\n        <div class="row">\n            <topic-control-bar topic="topic.mainStream" index-controls="true" index-visible="topic.indexVisible"></topic-control-bar>\n        </div>\n        <div class="row">\n            <div class="col-md-12 topic-item-list">\n                <span ng-controller="TopicItemListCtrl as topicItemList">\n                    <div class="position-relative" infinite-scroll="topicItemList.fetchPage()" infinite-scroll-disabled="topicItemList.isLastPage || topicItemList.ongoingRequest" infinite-scroll-immediate-check="false">\n                        <topic-item-list-contents\n                                current-topic-id="topicItemList.currentTopicId"\n                                items="topicItemList.items"\n                                item-search-params="topicItemList.itemSearchParams"\n                                searching="topicItemList.searching"\n                                topic="topic"\n                                fetchPage="topicItemList.fetchPage()">\n                        </topic-item-list-contents>\n                    </div>\n                </span>\n                <span ng-controller="TopicResultsCtrl as results">\n                    <no-results ng-show="!results.searching && results.totalElements === 0"></no-results>\n                </span>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//topic/topicSources.html','<span ng-controller="TopicSourcesCtrl as topicSources" class="topic-sources">\n    <div class="row">\n        <div class="col-md-12">\n            <h4 class="overflow-ellipsis topic-title"><a ng-click="topicSources.selectStream(topic.mainStream.streamConfiguration)">Index (All)</a></h4>\n        </div>\n    </div>\n    <span ui-tree data-drag-enabled="false" data-empty-placeholder-enabled="false">\n        <span ui-tree-nodes ng-model="topic.mainStream.streamConfiguration.subStreamConfigurations">\n            <div ng-repeat="streamConfig in topicSources.orderedConfigurations(topic.mainStream)" title="{{streamConfig.title}}" ui-tree-node>\n                <div ng-show="streamConfig.subStreamConfigurations" ng-class="{\'bg-info\': streamConfig.streamId === topic.currentStream.id}" class="row">\n                    <div class="topic-stream-expander col-md-1 col-sm-1">\n                        <a ng-show="streamConfig.subStreamConfigurations.length" class="glyphicon" ng-class="{\'glyphicon-chevron-down\': topicSources.expandedStreams[streamConfig.streamId], \'glyphicon-chevron-right\': !topicSources.expandedStreams[streamConfig.streamId] }" ng-click="topicSources.toggleExpansion(streamConfig)"></a>\n                    </div>\n                    <div class="col-md-8 no-padding col-sm-6">\n                        <h4 class="text-primary overflow-ellipsis">\n                            <a ng-click="topicSources.selectStream(streamConfig)">\n                                {{::streamConfig.title}}\n                            </a>\n                        </h4>\n                    </div>\n                    <div class="col-md-2 no-padding col-sm-3" style="padding-left: 3px;">\n                        <h4 class="overflow-ellipsis pull-left">\n                            <span ng-show="topicSources.idCountMap[streamConfig.streamId]">({{topicSources.idCountMap[streamConfig.streamId].count}})</span>\n                        </h4>\n                    </div>\n                </div>\n                <div ui-tree-nodes ng-model="streamConfig.subStreamConfigurations" ng-show="topicSources.expandedStreams[streamConfig.streamId]" class="clearfix">\n                    <div class=""\n                        ng-repeat="subStreamConfig in topicSources.configurationsAlpha(streamConfig.subStreamConfigurations)"\n                        title="{{::subStreamConfig.title}}"\n                        ui-tree-node>\n                        <div class="row" ng-class="{\'bg-info\': subStreamConfig.streamId === topic.currentStream.id}">\n                            <div class="col-md-offset-1 col-md-8 overflow-ellipsis no-padd-right">\n                                <a scrollup ng-click="topicSources.selectStream(subStreamConfig, streamConfig)" class="sidebar-nowrap-title text-primary cursor-pointer">\n                                    {{::subStreamConfig.title}}\n                                </a>\n                            </div>\n                            <div class="col-md-2 no-padding">\n                                <span ng-show="topicSources.idCountMap[subStreamConfig.streamId]">({{topicSources.idCountMap[subStreamConfig.streamId].count}})</span>\n                            </div>\n\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </span>\n    </span>\n</span>\n');
$templateCache.put('/templates//topicBuilder/seedContentSearch.html','<div ng-controller="TopicBuilderSeedContentSearch as contentSearchCtrl">\n    <div class="row">\n        <div class="col-md-6 col-md-offset-3">\n            <form ng-submit="contentSearchCtrl.search(contentSearchCtrl.searchTerm)"\n                  name="searchTopicForm"\n                  style="margin-bottom: 0.5em">\n                <h2>Create a new topic</h2>\n                <h5>Start your topic with a search phrase or rss url</h5>\n                <div class="input-group input-group-lg">\n                    <input type="text" class="form-control"\n                           placeholder="Enter keywords or an rss feed url"\n                           ng-model="contentSearchCtrl.searchTerm"\n                           ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }"\n                           required\n                    >\n                    <div class="input-group-btn" uib-dropdown>\n                        <button type="button" class="btn btn-default" ng-disabled="contentSearchCtrl.includedSources.length === 0 && contentSearchCtrl.includedNewSources.length === 0" uib-dropdown-toggle>\n                            <span>{{contentSearchCtrl.includedSources.length + contentSearchCtrl.includedNewSources.length}} sources </span><span class="caret"></span>\n                        </button>\n                        <ul class="dropdown-menu" uib-dropdown-menu>\n                            <li class="dropdown-header" ng-if="contentSearchCtrl.includedSources.length">Existing sources</li>\n                            <li ng-repeat="stream in contentSearchCtrl.includedSources track by stream.id">\n                                <a ng-click="contentSearchCtrl.toggleAddition(stream)"><i class="fa fa-close"></i> {{::stream.title}}</a>\n                            </li>\n                            <li class="dropdown-header" ng-if="contentSearchCtrl.includedNewSources.length">New sources</li>\n                            <li ng-repeat="newSource in contentSearchCtrl.includedNewSources">\n                                <a ng-click="contentSearchCtrl.toggleNewSourceAddition(newSource)"><i class="fa fa-close"></i> {{contentSearchCtrl.genTitle(newSource)}}</a>\n                            </li>\n                        </ul>\n                        <button class="btn btn-primary"\n                                ng-disabled="contentSearchCtrl.creatingStreams"\n                                ng-click="contentSearchCtrl.save()"\n                                type="button"\n                        >\n                            <span ng-hide="contentSearchCtrl.creatingStreams">Create topic</span>\n                            <span ng-show="contentSearchCtrl.creatingStreams"><i class="fa fa-spin fa-spinner"></i></span>\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n    <section class="row" ng-if="contentSearchCtrl.searchTerm">\n        <div class="col-md-6 col-md-offset-3">\n            <div class="panel panel-default">\n                <div class="panel-heading">\n                    <h3 class="panel-title">Create new sources:</h3>\n                </div>\n                <div class="panel-body">\n                    <spinner ng-show="contentSearchCtrl.newSourceFetching"></spinner>\n                    <new-source-list\n                            ng-hide="contentSearchCtrl.newSourceFetching"\n                            is-fetching="contentSearchCtrl.newSourceFetching"\n                            included-sources="contentSearchCtrl.includedNewSources"\n                            search-term="{{contentSearchCtrl.searchTerm}}"\n                            toggle-add-to-topic="contentSearchCtrl.toggleNewSourceAddition(source)"\n                    ></new-source-list>\n                </div>\n            </div>\n        </div>\n    </section>\n    <section class="row">\n        <div class="col-md-6 col-md-offset-3">\n            <div class="panel panel-default" ng-if="contentSearchCtrl.searchTerm">\n                <div class="panel-heading" title="recommended based on article content">\n                    <h3 class="panel-title">\n                        Recommended Topics and Sources\n                        <span class="pull-right">\n                            <input type="checkbox"\n                                   ng-model="contentSearchCtrl.restrictToSite"\n                                   ng-change="contentSearchCtrl.search(contentSearchCtrl.searchTerm)"\n                                   style="margin-right: 0.5em">Search site only\n                        </span>\n                    </h3>\n                </div>\n                <div class="panel-body">\n                    <spinner ng-show="contentSearchCtrl.fetchingRecommended"></spinner>\n                    <existing-source-list\n                            ng-hide="contentSearchCtrl.fetchingRecommended"\n                            included-sources="contentSearchCtrl.includedSources"\n                            search-term="contentSearchCtrl.searchTerm"\n                            sources="contentSearchCtrl.recommendedSources"\n                            toggle-add-to-topic="contentSearchCtrl.toggleAddition(source)"\n                    ></existing-source-list>\n                </div>\n            </div>\n        </div>\n    </section>\n</div>\n');
$templateCache.put('/templates//topicBuilder/topicBuilder.html','<div ng-controller="TopicBuilderCtrl as builderCtrl">\n    <div class="row" ng-if="builderCtrl.stream">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="topic-summary row">\n                <div class="col-md-12 flex">\n                    <topic-image stream="builderCtrl.stream" use-placeholder="true" allow-edit="true"\n                                 class="pull-left"></topic-image>\n                    <div style="flex:2">\n                        <edit-stream-title stream="builderCtrl.stream"\n                                           on-change="builderCtrl.saveStream(builderCtrl.stream)">\n                        </edit-stream-title>\n                        <edit-stream-description stream="builderCtrl.stream"\n                                                 on-change="builderCtrl.saveStream(builderCtrl.stream)">\n\n                        </edit-stream-description>\n                        <topic-categories ng-if="builderCtrl.taxonomy && builderCtrl.stream.tenantId"\n                                          allow-edit="true"\n                                          taxonomy="builderCtrl.taxonomy"\n                                          taxonomy-version="{{builderCtrl.taxonomyVersion}}"\n                                          stream="builderCtrl.stream">\n                        </topic-categories>\n                        <topic-catalog-categories ng-if="builderCtrl.taxonomy && !builderCtrl.stream.tenantId && builderCtrl.stateParams.catalogId"\n                                          allow-edit="true"\n                                          catalog-id="{{builderCtrl.stateParams.catalogId}}"\n                                          selected-categories="builderCtrl.stream.catalogCategories"\n                                          taxonomy="builderCtrl.taxonomy"\n                                          stream="builderCtrl.stream">\n                        </topic-catalog-categories>\n                        <topic-tags ng-if="builderCtrl.stream.tenantId"\n                                    allow-edit="true"\n                                    stream="builderCtrl.stream"\n                                    on-tag-change="builderCtrl.saveStream(builderCtrl.stream)">\n                        </topic-tags>\n                        <div ng-if="builderCtrl.stream.type === \'PRODUCT_SOURCE\' && builderCtrl.stream.maxStreamSubscribers && builderCtrl.stream.streamSubscribersCount >= builderCtrl.stream.maxStreamSubscribers"\n                            style="color: red;">\n                                This product has reached the maximum of {{builderCtrl.stream.maxStreamSubscribers}} users.\n                        </div>\n                        <div ng-if="builderCtrl.stream.type === \'PRODUCT_SOURCE\' && builderCtrl.stream.maxStreamSubscribers && builderCtrl.stream.streamSubscribersCount < builderCtrl.stream.maxStreamSubscribers"\n                             style="padding-top: 5px;">\n                            {{builderCtrl.stream.streamSubscribersCount}} registered users of {{builderCtrl.stream.maxStreamSubscribers}} allowed.    \n                        </div>\n                    </div>\n                    <div class="pull-right">\n                        <ul class="list-unstyled" id="topic-builder-action-list">\n                            <li ng-if="builderCtrl.stream.tenantId" show-with-permission action="PUBLISH_STREAM">\n                                <catalog-publish stream="builderCtrl.stream" on-change="builderCtrl.saveStream(builderCtrl.stream)"></catalog-publish>\n                            </li>\n                            <li>\n                                <follow-button stream="builderCtrl.stream" user="user" type="stream" follow-style="primary"></follow-button>\n                                <subscribe-button ng-if="builderCtrl.stream.briefingEnabled" stream="builderCtrl.stream" user="user" type="stream" subscribe-style="primary"></subscribe-button>\n                            </li>\n                            <li ng-if="builderCtrl.stream.type === \'COLLECTION\'"><strong><a ng-click="builderCtrl.postToTopic(builderCtrl.stream)">Post\n                                to topic</a></strong></li>\n                            <li><read-stream stream="builderCtrl.stream"></read-stream></li>\n                            <li show-with-permission action="CREATE_STREAM">\n                                <delete-stream stream="builderCtrl.stream"></delete-stream>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="col-md-10 col-md-offset-1">\n        <uib-tabset>\n            <uib-tab heading="Articles" ui-sref=".articles" active="builderCtrl.activeStates[\'editTopic.articles\']">\n                <div ui-view="articles"></div>\n            </uib-tab>\n            <uib-tab heading="Filters" ui-sref=".filters" active="builderCtrl.activeStates[\'editTopic.filters\']">\n                <div ui-view="filters"></div>\n            </uib-tab>\n            <uib-tab heading="Sources" ng-if="::builderCtrl.stream && builderCtrl.stream.type === \'COLLECTION\'"\n                     ui-sref=".sources" active="builderCtrl.activeStates[\'editTopic.sources\']">\n                <div ui-view="sources"></div>\n            </uib-tab>\n            <uib-tab heading="Briefing" ui-sref=".syndication" active="builderCtrl.activeStates[\'editTopic.syndication\']"\n                     ng-if="builderCtrl.stream.tenantId && builderCtrl.canSeePeopleTab && !builderCtrl.tenant.settings.noStreamBriefings && !builderCtrl.noFollowing">\n                <div ui-view="syndication"></div>\n            </uib-tab>\n            <uib-tab heading="Briefing" ui-sref=".usage" active="builderCtrl.activeStates[\'editTopic.usage\']"\n                     ng-if="builderCtrl.stream.tenantId && builderCtrl.canSeePeopleTab && builderCtrl.tenant.settings.noStreamBriefings && !builderCtrl.noFollowing">\n                <div ui-view="usage"></div>\n            </uib-tab>\n            <uib-tab heading="Topics" ui-sref=".topics" active="builderCtrl.activeStates[\'editTopic.topics\']">\n                <div ui-view="topics"></div>\n            </uib-tab>\n            <uib-tab heading="People" ui-sref=".people" active="builderCtrl.activeStates[\'editTopic.people\']"\n                     ng-if="builderCtrl.stream.tenantId && builderCtrl.canSeeSyndicationTab && !builderCtrl.noFollowing">\n                <div ui-view="people"></div>\n            </uib-tab>\n            <uib-tab heading="Activity" ui-sref=".activity" active="builderCtrl.activeStates[\'editTopic.activity\']">\n                <div ui-view="activity"></div>\n            </uib-tab>\n            <uib-tab heading="Settings" ui-sref=".settings" active="builderCtrl.activeStates[\'editTopic.settings\']">\n                <div ui-view="settings"></div>\n            </uib-tab>\n            <uib-tab heading="Aggregation" ng-if="::builderCtrl.stream && builderCtrl.stream.type !== \'COLLECTION\' && builderCtrl.stream.type !== \'PRODUCT_SOURCE\'"\n                     ui-sref=".aggregation" active="builderCtrl.activeStates[\'editTopic.aggregation\']">\n                <div ui-view="aggregation"></div>\n            </uib-tab>\n        </uib-tabset>\n    </div>\n</div>\n');
$templateCache.put('/templates//topicBuilder/topicBuilderActivity.html','<div class="row browse-section" ng-controller="TopicBuilderActivityCtrl as activityCtrl" ng-if="builderCtrl.stream">\n    <div class="col-sm-4">\n        <div class="form-group form-inline">\n            <label>Last&nbsp;\n                <select class="form-control" ng-model="activityCtrl.selectedDuration" ng-options="selectedDuration*1 as selectedDuration for selectedDuration in activityCtrl.durations">\n                </select>\n                <select class="form-control" ng-model="activityCtrl.selectedTimeUnitDays" ng-options="timeUnit.days as timeUnit.text for timeUnit in activityCtrl.timeUnits">\n                </select>\n                <button class="btn btn-primary" ng-click="activityCtrl.renderAnalytics(activityCtrl.stream.id, activityCtrl.selectedTimeUnitDays * activityCtrl.selectedDuration, activityCtrl.graphSelection)" ng-disabled="activityCtrl.fetchingData">\n                    <span ng-if="!activityCtrl.fetchingData">Go</span>\n                    <span ng-if="activityCtrl.fetchingData"><i class="fa fa-spinner fa-spin"></i></span>\n                </button>\n            </label>\n        </div>\n        <div top-items-list title="Most Read Articles" top-list-content="activityCtrl.topItems" stream-id="{{activityCtrl.stream.id}}"></div>\n    </div>\n    <div class="col-sm-8">\n        <div class="row">\n            <div class="col-sm-12">\n                <analytics-chart data="activityCtrl.graphData.data" labels="activityCtrl.graphData.labels" summary="activityCtrl.graphData.summaryText"></analytics-chart>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-sm-4 col-lg-3">\n                <div class="chart-wrapper">\n                    <div class="analytics-badge"><span class="analytics-badge-number">{{activityCtrl.totalViewsData.metric}}</span><br>total articles viewed</div>\n                    <div class="chart-notes"><a ng-click="activityCtrl.setGraphSelection(\'item_viewed\')">{{activityCtrl.graphSelection === \'item_viewed\' ? \'Graph displayed\' : \'Display graph\'}}</a><br>\n                        <a ng-click="activityCtrl.showDetailModal(activityCtrl.stream, \'item_viewed\', activityCtrl.selectedTimeUnitDays * activityCtrl.selectedDuration)">Show details</a></div>\n                </div>\n            </div>\n            <div class="col-sm-4 col-lg-3">\n                <div class="chart-wrapper">\n                    <div class="analytics-badge"><span class="analytics-badge-number">{{activityCtrl.clickThroughData.metric}}</span><br>click-throughs to source</div>\n                    <div class="chart-notes"><a ng-click="activityCtrl.setGraphSelection(\'item_link_clicked\')">{{activityCtrl.graphSelection === \'item_link_clicked\' ? \'Graph displayed\' : \'Display graph\'}}</a><br>\n                        <a ng-click="activityCtrl.showDetailModal(activityCtrl.stream, \'item_link_clicked\', activityCtrl.selectedTimeUnitDays * activityCtrl.selectedDuration)">Show details</a></div>\n                </div>\n            </div>\n            <div class="col-sm-4 col-lg-3">\n                <div class="chart-wrapper">\n                    <div class="analytics-badge"><span class="analytics-badge-number">{{activityCtrl.uniqueViewsData.metric}}</span><br>unique articles viewed</div>\n                    <div class="chart-notes">Unique articles viewed</div>\n                </div>\n            </div>\n            <!-- Add the extra clearfix for only the required viewport -->\n            <div class="clearfix visible-sm visible-md"></div>\n            <analytic-result label="briefings delivered"\n                             quantity="activityCtrl.deliveredBriefings.metric"\n                             is-selected="activityCtrl.graphSelection === \'briefing_email_delivered\'"\n                             on-select="activityCtrl.setGraphSelection(\'briefing_email_delivered\')"></analytic-result>\n            <div class="clearfix visible-lg"></div>\n            <analytic-result label="briefing opens"\n                             quantity="activityCtrl.openedBriefings.metric"\n                             is-selected="activityCtrl.graphSelection === \'briefing_email_opened\'"\n                             on-select="activityCtrl.setGraphSelection(\'briefing_email_opened\')"></analytic-result>\n            <analytic-result label="briefing clicks"\n                             quantity="activityCtrl.clickedBriefings.metric"\n                             is-selected="activityCtrl.graphSelection === \'briefing_email_clicked\'"\n                             on-select="activityCtrl.setGraphSelection(\'briefing_email_clicked\')"></analytic-result>\n            <analytic-result label="briefings dropped"\n                             quantity="activityCtrl.droppedBriefings.metric"\n                             is-selected="activityCtrl.graphSelection === \'briefing_email_dropped\'"\n                             on-select="activityCtrl.setGraphSelection(\'briefing_email_dropped\')"></analytic-result>\n            <analytic-result label="briefings spammed"\n                             quantity="activityCtrl.spammedBriefings.metric"\n                             is-selected="activityCtrl.graphSelection === \'briefing_email_spammed\'"\n                             on-select="activityCtrl.setGraphSelection(\'briefing_email_spammed\')"></analytic-result>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//topicBuilder/topicBuilderAggregation.html','<div class="row browse-section"\n     ng-if="::builderCtrl.stream"\n     ng-controller="TopicBuilderAggregationCtrl as aggregationCtrl">\n    <div class="col-md-12">\n        <div class="form-horizontal">\n            <div class="form-group">\n                <label class="col-sm-3 col-md-2 col-xl-1 control-label">Active</label>\n                <div class="col-sm-9 col-md-10 col-xl-11">\n                    <div class="form-control-static"><switch tooltip-placement="top" tooltip-popup-delay="500" tooltip-append-to-body="true" uib-tooltip="{{aggregationCtrl.aggregationEnabled ? \'Disable aggregation\' : \'Enable aggregation\'}}" ng-model="aggregationCtrl.aggregationEnabled" ng-change="aggregationCtrl.saveAggregationStatus(aggregationCtrl.aggregationEnabled)" class="small" on="On" off="Off"></switch></div>\n                </div>\n            </div>\n            <div class="form-group">\n                <label class="col-sm-3 col-md-2 col-xl-1 control-label">Last Status</label>\n                <div class="col-sm-9 col-md-10 col-xl-11">\n                    <div class="form-control-static"><span ng-class="aggregationCtrl.stream.status.inError ? \'label-danger\' : \'label-success\'" class="label" >{{::aggregationCtrl.stream.status.inError ? \'Error\' : \'OK\'}}</span></div>\n                </div>\n            </div>\n            <div class="form-group">\n                <label class="col-sm-3 col-md-2 col-xl-1 control-label">Last Success</label>\n                <div class="col-sm-9 col-md-10 col-xl-11">\n                    <div class="form-control-static" am-time-ago="::aggregationCtrl.stream.status.lastSuccess"></div>\n                </div>\n            </div>\n            <div class="form-group">\n                <label class="col-sm-3 col-md-2 col-xl-1 control-label">Last Error</label>\n                <div class="col-sm-9 col-md-10 col-xl-11">\n                    <div class="form-control-static" am-time-ago="::aggregationCtrl.stream.status.lastFailure"></div>\n                </div>\n            </div>\n            <div class="form-group">\n                <label class="col-sm-3 col-md-2 col-xl-1 control-label">Last Error Message</label>\n                <div class="col-sm-9 col-md-10 col-xl-11">\n                    <div class="form-control-static" style="word-wrap: break-word;">{{::aggregationCtrl.stream.status.lastErrorMessage}}<a ng-show="::aggregationCtrl.stream.status.lastErrorMessage" ng-click="showStackTrace = !showStackTrace">...</a></div>\n                    <div uib-collapse="!showStackTrace">\n                        <pre class="well" style="word-wrap: normal; overflow-x: scroll">{{::aggregationCtrl.stream.status.lastErrorStackTrace}}</pre>\n                    </div>\n                </div>\n            </div>\n            <div class="form-group">\n                <label class="col-sm-3 col-md-2 col-xl-1 control-label">Total Items</label>\n                <div class="col-sm-9 col-md-10 col-xl-11">\n                    <div class="form-control-static">{{::aggregationCtrl.stream.itemsCount}}</div>\n                </div>\n            </div>\n            <div class="form-group">\n                <label class="col-sm-3 col-md-2 col-xl-1 control-label">Average Items</label>\n                <div class="col-sm-9 col-md-10 col-xl-11">\n                    <div class="form-control-static" ng-if="::aggregationCtrl.stream.status.averageItemsPerHour > 1">{{::aggregationCtrl.stream.status.averageItemsPerHour | number:1}} per hour</div>\n                    <div class="form-control-static" ng-if="::aggregationCtrl.stream.status.averageItemsPerHour <= 1">{{::aggregationCtrl.stream.status.averageItemsPerDay | number:1}} per day</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//topicBuilder/topicBuilderArticles.html','<div class="topic-state" ng-controller="MyTopicsItemListCtrl as topicItemList">\r\n    <div class="col-sm-12 col-md-12">\r\n        <div class="row">\r\n            <topic-control-bar topic="topicItemList.topic" curate="true"></topic-control-bar>\r\n        </div>\r\n\r\n        <div ng-if="uiState.current.data.paneScroll === true" class="row mytopic-scroll-container" full-height style="overflow-y: auto;" additional-padding="{{ uiState.current.data.additionalPadding || 220 }}">\r\n            <div class="col-md-12 topic-item-list">\r\n                <div class="position-relative" infinite-scroll="topicItemList.fetchPage()" infinite-scroll-disabled="topicItemList.isLastPage || topicItemList.ongoingRequest" infinite-scroll-container="\'.mytopic-scroll-container\'" infinite-scroll-immediate-check="false">\r\n                    <topic-item-list-contents\r\n                            current-topic-id="topicItemList.currentTopicId"\r\n                            items="topicItemList.items"\r\n                            item-search-params="topicItemList.itemSearchParams"\r\n                            searching="topicItemList.searching"\r\n                            topic="topicItemList.topic"\r\n                            toggle-item-visibility="topicItemList.toggleItemVisibility(item)"\r\n                            fetchPage="topicItemList.fetchPage()">\r\n                    </topic-item-list-contents>\r\n                </div>\r\n                <no-results ng-if="!topicItemList.items.length && !topicItemList.ongoingRequest" message="{{topicItemList.topic.status.lastAttempted || topicItemList.topic.type === \'COLLECTION\' ?\r\n                \'There are no articles in this topic matching your current filter.\' :\r\n                \'Article aggregation is scheduled. Please refresh your browser shortly to see aggregated articles.\'}}"></no-results>\r\n            </div>\r\n        </div>\r\n        <div ng-if="uiState.current.data.paneScroll !== true" class="row">\r\n            <div class="col-md-12 topic-item-list">\r\n                <div class="position-relative" infinite-scroll="topicItemList.fetchPage()" infinite-scroll-disabled="topicItemList.isLastPage || topicItemList.ongoingRequest" infinite-scroll-immediate-check="false">\r\n                    <topic-item-list-contents\r\n                            current-topic-id="topicItemList.currentTopicId"\r\n                            items="topicItemList.items"\r\n                            item-search-params="topicItemList.itemSearchParams"\r\n                            searching="topicItemList.searching"\r\n                            topic="topicItemList.topic"\r\n                            toggle-item-visibility="topicItemList.toggleItemVisibility(item)"\r\n                            fetchPage="topicItemList.fetchPage()">\r\n                    </topic-item-list-contents>\r\n                </div>\r\n                <no-results ng-if="!topicItemList.items.length && !topicItemList.ongoingRequest" message="{{topicItemList.topic.status.lastAttempted || topicItemList.topic.type === \'COLLECTION\' ?\r\n                \'There are no articles in this topic matching your current filter.\' :\r\n                \'Article aggregation is scheduled. Please refresh your browser shortly to see aggregated articles.\'}}"></no-results>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('/templates//topicBuilder/topicBuilderFilters.html','<div ng-controller="TopicBuilderFiltersCtrl as filtersCtrl" class="topic-builder-articles" ng-if="::builderCtrl.stream.id">\n    <div class="row browse-section" ng-if="builderCtrl.stream.type === \'COLLECTION\' && !builderCtrl.stream.filter.version">\n        <div class="col-md-6">\n            <filter-prefill filter-terms="::filtersCtrl.previousSearchTerms" ng-if="::filtersCtrl.previousSearchTerms.length > 0"></filter-prefill>\n            <stream-filter-editor stream="builderCtrl.stream" on-filter-change="filtersCtrl.refreshItemList()"></stream-filter-editor>\n        </div>\n        <div class="col-md-6">\n            <div class="row">\n                <div class="col-md-12">\n                    <curate-item-list-header stream="builderCtrl.stream"\n                                             initial-page="0"\n                                             items-did-change="filtersCtrl.refreshItemList(params)"\n                                             item-counts="filtersCtrl.itemCounts"\n                                             selected-filter="selectedFilter"></curate-item-list-header>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <item-list items="filtersCtrl.items" stream="builderCtrl.stream"\n                               item-counts="filtersCtrl.itemCounts"></item-list>\n                    <uib-pagination ng-show="filtersCtrl.itemsMetadata.totalPages > 1" class="pad-top-bottom"\n                                    total-items="filtersCtrl.itemsMetadata.totalElements"\n                                    ng-model="filtersCtrl.currentPage"\n                                    items-per-page="20" ng-change="filtersCtrl.fetchPage()" max-size="5"\n                                    boundary-link-numbers="true" previous-text="&lsaquo;"\n                                    next-text="&rsaquo;"></uib-pagination>\n                </div>\n            </div>\n            <div class="col-md-12" ng-if="filtersCtrl.items && filtersCtrl.items.length === 0">\n                <no-results message="{{builderCtrl.stream.status.lastAttempted || builderCtrl.stream.type === \'COLLECTION\' ?\n                    \'There are no articles in this topic matching your current filter.\' :\n                    \'Article aggregation is scheduled. Please refresh your browser shortly to see aggregated articles.\'}}"\n                ></no-results>\n            </div>\n        </div>\n    </div>\n    <div class="row browse-section" ng-if="builderCtrl.stream.type === \'COLLECTION\' && builderCtrl.stream.filter.version">\n        <h4>This filter cannot be edited in this editor, please use the <a target="_blank" ng-href="/client/topics/{{builderCtrl.stream.id}}/content/filters">client editor</a>.</h4>\n    </div>\n    <div class="row browse-section" ng-if="builderCtrl.stream.type !== \'COLLECTION\'">\n        <div class="col-md-offset-4 col-md-6">\n            <h4>Sources cannot be filtered directly. Please add this source to a Topic if you need a filtered view.</h4>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//topicBuilder/topicBuilderPeople.html','<div class="row browse-section" ng-controller="TopicBuilderPeopleCtrl as peopleCtrl">\n    <div class="col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1">\n        <div class="stream-creation-panel">\n            <div class="tab-content editor">\n                <div ng-if="config.target === \'people\'">\n                    <ng-include src="\'/templates/streamBuilder/people.html\'"></ng-include>\n                </div>\n                <div ng-if="config.target === \'groups\'">\n                    <ng-include src="\'/templates/streamBuilder/groups.html\'"></ng-include>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('/templates//topicBuilder/topicBuilderSettings.html','<div class="tab-content browse-section" ng-if="::builderCtrl.stream">\n    <div class="form-horizontal">\n        <div class="form-group" ng-if="builderCtrl.stream.type !== \'COLLECTION\' && builderCtrl.stream.type !== \'PRODUCT_SOURCE\'">\n            <label class="col-sm-3 col-md-2 col-xl-1 control-label">Source</label>\n            <div class="col-sm-9 col-md-10 col-xl-11">\n                <edit-stream-source stream="builderCtrl.stream" \n                                    on-change="builderCtrl.saveStream(builderCtrl.stream)"></edit-stream-source>\n            </div>\n        </div>\n        <div class="form-group" ng-if="builderCtrl.stream.type !== \'COLLECTION\' && builderCtrl.stream.type !== \'PRODUCT_SOURCE\'">\n            <label class="col-sm-3 col-md-2 col-xl-1 control-label">Retention Days</label>\n            <div class="col-sm-9 col-md-10 col-xl-11">\n                <item-time-to-live stream="builderCtrl.stream"\n                                   on-set-limit="builderCtrl.saveStream(builderCtrl.stream)"></item-time-to-live>\n            </div>\n        </div>\n        <div class="form-group" ng-if="::builderCtrl.stream.type !== \'PRODUCT_SOURCE\'"">\n            <label class="col-sm-3 col-md-2 col-xl-1 control-label">Creator</label>\n            <div class="col-sm-9 col-md-10 col-xl-11">\n                <div class="form-control-static">\n                    {{builderCtrl.stream.creator.firstName}} {{builderCtrl.stream.creator.lastName}} (<a href="mailto:{{builderCtrl.stream.creator.emailAddress}}">{{builderCtrl.stream.creator.emailAddress}}</a>)\n                </div>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-2 col-xl-1 control-label">Created</label>\n            <div class="col-sm-9 col-md-10 col-xl-11">\n                <div class="form-control-static">{{builderCtrl.stream.created | date : shortDate }}</div>\n            </div>\n        </div>\n        <div class="form-group" ng-if="::builderCtrl.stream.type !== \'PRODUCT_SOURCE\'"">\n            <label class="col-sm-3 col-md-2 col-xl-1 control-label">Owner</label>\n            <div class="col-sm-9 col-md-10 col-xl-11">\n                <edit-stream-owner stream="builderCtrl.stream"\n                                   on-change="builderCtrl.saveStream(builderCtrl.stream)"></edit-stream-owner>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-2 col-xl-1 control-label">Enable RSS</label>\n            <div class="col-sm-9 col-md-10 col-xl-11">\n                <rss-publish stream="builderCtrl.stream" on-change="builderCtrl.saveStream(builderCtrl.stream)"></rss-publish>\n            </div>\n        </div>\n        <div class="form-group" ng-if="::builderCtrl.stream.type === \'COLLECTION\'">\n            <label class="col-sm-3 col-md-2 col-xl-1 control-label">Email Articles to Stream</label>\n            <div class="col-sm-9 col-md-10 col-xl-11">\n                <edit-stream-email-address stream="builderCtrl.stream"\n                                           on-change="builderCtrl.saveStream(builderCtrl.stream)"></edit-stream-email-address>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//topicBuilder/topicBuilderSyndication.html','<div class="row browse-section" ng-if="::builderCtrl.stream" ng-controller="TopicBuilderSyndicationCtrl as syndicationCtrl">\n    <div class="col-md-12">\n        <!--This growl container can go away after the stream builder modal.  The growl pinning to the id here can\n        be removed from that controller at that time -->\n        <div class="stream-modal-growl-container">\n            <div class="stream-modal-growls">\n                <div growl inline="true" reference="streamBuilderMessages"></div>\n            </div>\n        </div>\n        <div class="tab-content editor">\n            <div ng-controller="StreamEditorBriefingCtrl" class="panel panel-default">\n                <div class="panel-heading">\n                    <h3 class="panel-title">Email Briefing</h3>\n                </div>\n                <div class="panel-body">\n                    <ng-include src="\'/templates/streamBuilder/briefing.html\'"></ng-include>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//topicBuilder/topicBuilderTabs.html','<div ng-controller="TopicBuilderCtrl as builderCtrl">\r\n    <uib-tabset>\r\n        <uib-tab heading="Articles"\r\n                 ui-sref="mytopics.editTopic.articles"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.articles\'">\r\n            <div ui-view="articles"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Filters"\r\n                 ui-sref="mytopics.editTopic.filters"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.filters\'">\r\n            <div ui-view="filters"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Sources"\r\n                 ui-sref="mytopics.editTopic.sources"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.sources\'"\r\n                 ng-if="::builderCtrl.stream && builderCtrl.stream.type === \'COLLECTION\'">\r\n            <div ui-view="sources"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Briefing"\r\n                 ui-sref="mytopics.editTopic.syndication"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.syndication\'"\r\n                 ng-if="builderCtrl.stream.tenantId && builderCtrl.canSeePeopleTab && !builderCtrl.tenant.settings.noStreamBriefings && !builderCtrl.noFollowing">\r\n            <div ui-view="syndication"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Briefing"\r\n                 ui-sref="mytopics.editTopic.usage"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.usage\'"\r\n                 ng-if="builderCtrl.stream.tenantId && builderCtrl.canSeePeopleTab && builderCtrl.tenant.settings.noStreamBriefings && !builderCtrl.noFollowing">\r\n            <div ui-view="usage"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Topics"\r\n                 ui-sref="mytopics.editTopic.topics"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.topics\'">\r\n            <div ui-view="topics"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="People"\r\n                 ui-sref="mytopics.editTopic.people"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.people\'"\r\n                 ng-if="builderCtrl.stream.tenantId && builderCtrl.canSeeSyndicationTab && !builderCtrl.noFollowing">\r\n            <div ui-view="people"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Activity"\r\n                 ui-sref="mytopics.editTopic.activity"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.activity\'">\r\n            <div ui-view="activity"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Settings"\r\n                 ui-sref="mytopics.editTopic.settings"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.settings\'">\r\n            <div ui-view="settings"></div>\r\n        </uib-tab>\r\n        <uib-tab heading="Aggregation"\r\n                 ng-if="::builderCtrl.stream && builderCtrl.stream.type !== \'COLLECTION\' && builderCtrl.stream.type !== \'PRODUCT_SOURCE\'"\r\n                 ui-sref="mytopics.editTopic.aggregation"\r\n                 active="builderCtrl.state.current.name === \'mytopics.editTopic.aggregation\'">\r\n            <div ui-view="aggregation"></div>\r\n        </uib-tab>\r\n    </uib-tabset>\r\n</div>\r\n');
$templateCache.put('/templates//topicBuilder/topicBuilderTopics.html','<div class="tab-content browse-section" ng-if="::builderCtrl.stream" ng-controller="TopicBuilderRelatedTopicsCtrl as relatedTopicsCtrl">\n    <section class="row" ng-if="!relatedTopicsCtrl.fetching">\n        <div class="col-md-12">\n            <div class="panel panel-default">\n                <div class="panel-heading">\n                    <h3 class="panel-title">Referencing Topics</h3>\n                </div>\n                <div class="panel-body" ng-if="relatedTopicsCtrl.topics.length">\n                    <including-topics-list topics="relatedTopicsCtrl.topics"></including-topics-list>\n                </div>\n                <div class="panel-body" ng-if="!relatedTopicsCtrl.topics.length">\n                    This {{builderCtrl.stream.type === \'COLLECTION\' ? \'topic\' : \'source\'}} is not included in any topics.\n                </div>\n            </div>\n        </div>\n    </section>\n    <spinner ng-if="relatedTopicsCtrl.fetching"></spinner>\n</div>\n');
$templateCache.put('/templates//topicBuilder/topicBuilderUsage.html','<div class="row browse-section" ng-if="::builderCtrl.stream" ng-controller="TopicBuilderUsageCtrl as usageCtrl">\r\n    <section class="row" ng-if="!usageCtrl.ongoingRequest">\r\n        <div class="col-md-12">\r\n            <div class="panel panel-default">\r\n                <div class="panel-heading">\r\n                    <h3 class="panel-title">Referencing Briefings</h3>\r\n                </div>\r\n                <div class="panel-body" ng-if="usageCtrl.briefings.length">\r\n                    <briefing-card ng-repeat="briefing in usageCtrl.briefings track by briefing.id" briefing="briefing" user="user" template="usageCtrl.templateMap[briefing.templateId]"></briefing-card>\r\n                </div>\r\n                <div class="panel-body" ng-if="!usageCtrl.briefings.length">\r\n                    This {{builderCtrl.stream.type === \'COLLECTION\' ? \'topic\' : \'source\'}} is not included in any briefings.\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </section>\r\n    <spinner ng-show="usageCtrl.ongoingRequest"></spinner>\r\n</div>');
$templateCache.put('/templates//topics/browse.html','<div ng-controller="BrowseCtrl as browse">\n    <div class="row browse-section">\n        <div class="col-md-6 col-md-offset-3">\n            <form ng-submit="browse.state.go(\'^.search\', { searchTerm: browse.searchTerm })">\n                    <button class="btn btn-primary pull-left" style="margin-right: 30px;" type="button"\n                            ng-click="browse.state.go(\'seedTopic\', { searchTerm: browse.searchTerm || \'\' })"\n                            show-with-permission action="CREATE_STREAM">\n                        <span class="fa fa-plus"></span> Topic\n                    </button>\n                    <div class="input-group input-group-lg">\n                        <input type="text" class="form-control"\n                               placeholder="Search for content"\n                               ng-model="browse.searchTerm"\n                               on-delayed-change="browse.state.go(\'^.search\', { searchTerm: browse.searchTerm })">\n                        <span class="input-group-btn">\n                            <button class="btn btn-secondary" type="submit">\n                                <span class="fa fa-search"></span>\n                            </button>\n                        </span>\n                    </div>\n            </form>\n        </div>\n    </div>\n    <div class="row browse-section">\n        <div class="col-md-10 col-md-offset-1">\n            <uib-tabset>\n                <uib-tab heading="{{::browse.catalogTabLabel}}" ui-sref=".catalog" active="browse.state.current.name === \'browse.catalog\'">\n                    <div ui-view="catalog"></div>\n                </uib-tab>\n                <uib-tab\n                    heading="{{::catalog.label}}"\n                    ng-repeat="catalog in browse.catalogs"\n                    ui-sref=".marketplace({ catalogId: catalog.catalogId, categoryId: undefined, taxonomy: undefined })"\n                    active="browse.state.current.name === \'browse.marketplace\' && browse.stateParams.catalogId === catalog.catalogId">\n                    <div ui-view="marketplace"></div>\n                </uib-tab>\n                <uib-tab\n                        heading="Topics I own"\n                        ui-sref=".ownedStreams"\n                        active="browse.state.current.name === \'browse.ownedStreams\'"\n                        ng-if="browse.displayOwnedStreams">\n                    <div ui-view="ownedStreams"></div>\n                </uib-tab>\n                <uib-tab\n                    active="browse.state.current.name === \'browse.search\'"\n                    ng-if="browse.state.current.name === \'browse.search\'">\n                    <uib-tab-heading>\n                        <i class="fa fa-search"></i> Search <a class="fa fa-times" ui-sref="browse.catalog"></a>\n                    </uib-tab-heading>\n                    <div ui-view="searchResults"></div>\n                </uib-tab>\n                <uib-tab heading="{{::stream.title}}"\n                    ng-repeat="stream in browse.selectedStreams"\n                    ui-sref=".stream({ streamId: stream.id, stream: stream })"\n                    active="browse.state.current.name === \'browse.stream\' && browse.stateParams.streamId === stream.id">\n                    <uib-tab-heading>\n                        <span class="fa fa-files-o"></span> {{::stream.title}} <a class="fa fa-times" ng-click="browse.search(stream.id)"></a>\n                    </uib-tab-heading>\n                    <div ui-view="stream"></div>\n                </uib-tab>\n            </uib-tabset>\n         </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//topics/ownedStreams.html','<div class="tab-content" style="padding-top: 2em" ng-controller="TopicsOwnedStreamsCtrl as ownedStreamsView">\n    <spinner ng-show="ownedStreamsView.fetchingTopics"></spinner>\n    <div class="row" ng-if="ownedStreamsView.matchingTopics.length > 0">\n        <div class="col-md-12">\n            <h5>Topics I own:</h5>\n        </div>\n        <div class="col-md-12">\n            <div>\n                <stream-card ng-repeat="stream in ownedStreamsView.matchingTopics track by stream.id" stream="stream" user="user"></stream-card>\n            </div>\n        </div>\n    </div>\n    <spinner ng-show="ownedStreamsView.fetchingSources && !ownedStreamsView.fetchingTopics"></spinner>\n    <div class="row" ng-if="ownedStreamsView.matchingSources.length > 0">\n        <hr ng-if="ownedStreamsView.matchingTopics.length > 0">\n        <div class="col-md-12">\n            <h5>Sources I own:</h5>\n        </div>\n        <div class="col-md-12">\n            <div>\n                <stream-card ng-repeat="stream in ownedStreamsView.matchingSources track by stream.id" stream="stream" user="user"></stream-card>\n            </div>\n        </div>\n    </div>\n    <div class="row" ng-if="ownedStreamsView.matchingSources.length === 0 && ownedStreamsView.matchingTopics.length === 0 && !fetchingTopics && !fetchingSources">\n        <div class="col-md-12">\n            <h1 class="text-center"><i class="fa fa-search"></i></h1>\n            <p class="text-center"><strong>Sorry, it doesn\'t look like you own any topics.</strong></p>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//topics/searchResults.html','<div class="tab-content" style="padding-top: 2em" ng-controller="TopicsSearchCtrl as searchView">\n    <spinner ng-show="searchView.fetchingMatches"></spinner>\n    <div class="row" ng-if="searchView.matchingStreams.length > 0">\n        <div class="col-md-12">\n            <h5>Results based on title and description:</h5>\n        </div>\n        <div class="col-md-12">\n            <div>\n                <stream-card ng-repeat="stream in searchView.matchingStreams track by stream.id" stream="stream" user="user"></stream-card>\n            </div>\n        </div>\n    </div>\n    <spinner ng-show="searchView.fetchingRecommended && !searchView.fetchingMatches"></spinner>\n    <div class="row" ng-if="searchView.recommendedStreams.length > 0">\n        <hr ng-if="searchView.matchingStreams.length > 0">\n        <div class="col-md-12">\n                <h5>Results based on article content:</h5>\n        </div>\n        <div class="col-md-12">\n            <div>\n                <stream-card ng-repeat="stream in searchView.recommendedStreams track by stream.id" stream="stream" user="user"></stream-card>\n            </div>\n        </div>\n    </div>\n    <div class="row" ng-if="searchView.recommendedStreams.length === 0 && searchView.matchingStreams.length === 0 && !fetchingMatches && !fetchingRecommended">\n        <div class="col-md-12">\n            <no-results></no-results>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/templates//topics/topics.html','<div class="tab-content" style="padding-top: 2em" ng-controller="TopicsCtrl as topicsView">\n    <div class="row" style="margin-bottom: 20px;">\n        <div class="col-md-12">\n            <ol class="breadcrumb">\n                <li ng-repeat="category in topicsView.selectedCategoryStack" ng-switch on="$last">\n                    <span ng-switch-when="true">{{category.title}}</span>\n                    <a ng-switch-default ng-click="topicsView.clickCategory(category)">{{category.title}}</a>\n                </li>\n            </ol>\n            <div>\n                <category-card ng-repeat="category in topicsView.categories track by category.id" category="category" select-category="topicsView.clickCategory(category)" catalog-id="{{topicsView.stateParams.catalogId}}"></category-card>\n            </div>\n        </div>\n    </div>\n    <div class="row">\n        <spinner ng-show="topicsView.fetchingStreams && topicsView.categories.length === 0"></spinner>\n        <div class="col-md-12">\n            <div class="well well-sm" ng-if="topicsView.streams.length !== 0">\n                <span><strong>{{topicsView.streams.length}}</strong> Topics</span>\n            </div>\n            <div>\n                <stream-card ng-repeat="stream in topicsView.streams track by stream.id" stream="stream" user="user"></stream-card>\n            </div>\n        </div>\n    </div>\n</div>\n');}]);